import React from "react";
export const Wallicon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="107"
        height="62"
        style={props.style}
        className={props.className}
        viewBox="0 0 107 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_325_499)">
          <path
            opacity="0.5"
            d="M37.1494 24.8814L42.8481 35.3944L44.0263 32.2812L39.3856 23.708L37.1494 24.8814Z"
            fill="#0A0A0A"
          />
          <path
            d="M50.9508 17.5056L54.5095 15.6377L52.0088 21.2414L45.685 35.3944H42.8477L44.3384 31.5388L50.9508 17.5056Z"
            fill="#0A0A0A"
          />
          <path
            opacity="0.5"
            d="M61.6993 35.4662L63.5507 30.5091L54.5098 15.6377L52.0332 21.1935L61.6993 35.4662Z"
            fill="#0A0A0A"
          />
          <path
            d="M61.6992 35.4662H66.4361L69.1532 29.7907L74.3228 18.8946L80.2379 6.41792L83.3397 0L72.832 5.62766L61.6992 35.4662Z"
            fill="#0A0A0A"
          />
          <path
            d="M0.000130463 42.9138C-0.00679934 42.8806 -0.00654212 42.8462 0.000884895 42.8131C0.00831191 42.7799 0.0227387 42.7487 0.043207 42.7215C0.0636753 42.6943 0.0897167 42.6718 0.119601 42.6554C0.149485 42.639 0.182528 42.6292 0.216535 42.6265H4.71294C4.71294 42.6265 5.24193 42.4828 5.50642 43.9196L7.91092 52.1576C8.09518 52.88 8.31995 53.5915 8.58418 54.2889L10.0509 49.9783L11.3493 46.3623L12.3111 43.5604C12.3111 43.5604 12.5756 42.6744 13.1287 42.5546C13.8402 42.626 14.5571 42.626 15.2687 42.5546C15.6427 42.4915 16.0271 42.566 16.3501 42.7642C16.673 42.9625 16.9125 43.271 17.024 43.6323C17.024 43.6323 17.3606 45.0452 17.6732 46.027L19.6929 51.7026L20.5345 54.2889C20.5345 54.2889 20.799 54.4086 20.8471 53.8099L22.2417 48.8289L23.4199 44.5423L23.8046 43.0336C23.8757 42.8913 23.9922 42.7765 24.1357 42.7072C24.2793 42.6378 24.4419 42.6179 24.5981 42.6504H28.2529C28.2529 42.6504 28.6617 42.6504 28.5415 43.2251L27.9644 45.2367L27.0507 48.1823L25.055 54.6481L23.7565 58.9826L23.1073 61.09C23.1073 61.09 22.9871 61.545 22.6986 61.545C21.8948 61.5428 21.0918 61.5908 20.2941 61.6886C19.7164 61.7537 19.1333 61.6275 18.635 61.3294C18.3418 61.0683 18.1327 60.7267 18.0338 60.3476L17.601 58.7431C17.4379 58.1591 17.2453 57.5836 17.024 57.0189L15.1004 51.3433L14.4271 49.3318L11.8302 56.7555L10.4116 60.9223C10.3688 61.0546 10.2936 61.1742 10.1929 61.2703C10.0922 61.3665 9.96901 61.4361 9.83451 61.4731H9.30552C8.68889 61.4375 8.0707 61.4375 7.45406 61.4731H6.61249C6.32846 61.4596 6.0545 61.3641 5.82398 61.1982C5.59345 61.0324 5.41629 60.8034 5.31406 60.5392C5.04645 59.8987 4.88407 59.2195 4.83316 58.5276C4.70579 58.0149 4.54515 57.5109 4.35227 57.0189L3.39047 53.8339L2.18822 49.8347L0.216535 43.273L0.0963102 43.1294C0.0517159 43.0637 0.0191524 42.9908 0.000130463 42.9138Z"
            fill="#0A0A0A"
          />
          <path
            d="M42.4632 60.18V59.3418C42.4632 58.8149 42.2468 58.8149 42.2468 58.8149H41.8621C41.6718 58.8444 41.4773 58.8018 41.317 58.6954C41.1567 58.5889 41.0424 58.4265 40.9965 58.2402V53.7381C41.045 53.1324 41.045 52.5238 40.9965 51.9181C40.8682 51.3203 40.613 50.7567 40.2481 50.2652C39.8832 49.7737 39.4169 49.3656 38.8805 49.0683C37.6844 48.4713 36.3333 48.254 35.0093 48.4457C33.6199 48.631 32.2894 49.1218 31.114 49.8825C31.0223 49.9374 30.9528 50.0226 30.9176 50.1232C30.8824 50.2239 30.8839 50.3336 30.9217 50.4333L31.643 51.6307L32.0037 52.2773C32.2201 52.6365 32.6048 52.2773 32.6048 52.2773C33.3493 51.7166 34.2455 51.3913 35.1776 51.3433C35.8481 51.2689 36.523 51.4391 37.0772 51.8223C37.3451 52.062 37.5554 52.3587 37.6928 52.6903C37.8301 53.0219 37.8909 53.38 37.8707 53.7381C37.8707 54.1931 37.1974 54.1212 37.1974 54.1212H36.428H35.899C34.9405 54.1485 33.9848 54.2365 33.0376 54.3847C32.1318 54.5288 31.2924 54.9468 30.6331 55.582C30.2839 55.9909 30.0266 56.4695 29.8786 56.9856C29.7305 57.5018 29.6952 58.0435 29.7749 58.5744C29.8547 59.1053 30.0476 59.613 30.3408 60.0635C30.634 60.5139 31.0206 60.8966 31.4747 61.1858C32.5139 61.8562 33.7556 62.1442 34.9853 62C36.2561 61.8229 37.4231 61.2036 38.2794 60.2518C38.5345 60.7252 38.9288 61.1096 39.4095 61.3534C40.212 61.7536 41.1219 61.8879 42.0064 61.7365C42.1101 61.7295 42.2111 61.7001 42.3024 61.6505C42.3938 61.6009 42.4732 61.5322 42.5354 61.4492C42.5894 61.0253 42.565 60.5951 42.4632 60.18ZM37.8707 56.971C37.9324 57.2389 37.9324 57.5173 37.8707 57.7852C37.6735 58.2768 37.3184 58.6894 36.8608 58.9586C36.3045 59.3015 35.6635 59.4839 35.0093 59.4855C34.6287 59.5109 34.2481 59.4358 33.9061 59.2675C33.564 59.0993 33.2727 58.844 33.0617 58.5276C32.9438 58.3149 32.882 58.076 32.882 57.8331C32.882 57.5902 32.9438 57.3513 33.0617 57.1386C33.3996 56.88 33.7958 56.7074 34.2158 56.6357C34.9082 56.5126 35.6064 56.4247 36.3077 56.3723H37.2695C37.7264 56.3723 37.7023 56.5399 37.7023 56.5399L37.8707 56.971Z"
            fill="#0A0A0A"
          />
          <path
            d="M44.8438 52.2773V44.662C44.8438 44.662 44.8438 44.1831 45.4449 44.2549H47.8494C47.8494 44.2549 48.0898 44.2549 48.0898 44.5662V61.3294C48.0898 61.3993 48.062 61.4663 48.0123 61.5157C47.9627 61.5651 47.8955 61.5929 47.8253 61.5929H45.2044C45.1633 61.5961 45.122 61.5913 45.0828 61.5786C45.0437 61.5659 45.0074 61.5456 44.9761 61.5189C44.9448 61.4922 44.9191 61.4596 44.9006 61.423C44.882 61.3863 44.8708 61.3464 44.8678 61.3055L44.8438 52.2773Z"
            fill="#0A0A0A"
          />
          <path
            d="M51.3604 52.2773V44.662C51.3604 44.662 51.3604 44.1831 51.9615 44.2549H54.366C54.4039 44.2579 54.4409 44.2684 54.4747 44.2857C54.5086 44.303 54.5387 44.3268 54.5633 44.3557C54.5879 44.3847 54.6065 44.4182 54.618 44.4543C54.6295 44.4904 54.6338 44.5285 54.6305 44.5662V61.3294C54.6305 61.3993 54.6026 61.4663 54.553 61.5157C54.5034 61.5651 54.4361 61.5929 54.366 61.5929H51.721C51.68 61.5961 51.6386 61.5913 51.5994 61.5786C51.5603 61.5659 51.524 61.5456 51.4927 61.5189C51.4614 61.4922 51.4357 61.4596 51.4172 61.423C51.3986 61.3863 51.3874 61.3464 51.3844 61.3055L51.3604 52.2773Z"
            fill="#0A0A0A"
          />
          <path
            d="M57.9727 54.8397V49.0923C57.9838 49.0032 58.026 48.9208 58.0919 48.8596C58.1579 48.7983 58.2433 48.762 58.3333 48.7571H61.0264C61.0264 48.7571 61.2668 48.7571 61.2668 49.1402V61.4013C61.2668 61.4013 61.2668 61.6169 61.0985 61.6648H58.1891C58.1891 61.6648 57.9727 61.6648 57.9727 61.3774V54.8397Z"
            fill="#0A0A0A"
          />
          <path
            d="M59.6073 47.4398C60.6299 47.4398 61.4588 46.625 61.4588 45.6198C61.4588 44.6146 60.6299 43.7998 59.6073 43.7998C58.5848 43.7998 57.7559 44.6146 57.7559 45.6198C57.7559 46.625 58.5848 47.4398 59.6073 47.4398Z"
            fill="#0A0A0A"
          />
          <path
            d="M74.7794 52.7562L76.8954 51.2954C76.3368 50.5317 75.6444 49.8746 74.8515 49.3557C73.5165 48.5111 71.9153 48.187 70.3551 48.4457C68.9597 48.5764 67.6366 49.1244 66.5595 50.0176C65.4824 50.9108 64.7017 52.1076 64.3199 53.4507C64.0796 54.4099 64.0796 55.4131 64.3199 56.3723C64.5179 57.6032 65.069 58.7509 65.9068 59.677C66.9699 60.8255 68.3952 61.5775 69.9464 61.8084C70.6805 61.9676 71.4355 62.008 72.1825 61.9281C73.545 61.7824 74.8212 61.1932 75.8133 60.2518C76.1039 59.9905 76.377 59.7105 76.6309 59.4136C76.6309 59.4136 76.8713 59.246 76.6309 58.9586C76.331 58.6286 75.9823 58.3459 75.5969 58.1205L74.8996 57.5697C74.811 57.4889 74.6952 57.4441 74.575 57.4441C74.4549 57.4441 74.3391 57.4889 74.2504 57.5697C73.5697 58.3389 72.611 58.8085 71.5837 58.8758C70.5564 58.9431 69.5442 58.6027 68.7682 57.9289C68.6362 57.8215 68.5154 57.7011 68.4075 57.5697C67.7471 56.8068 67.4105 55.8181 67.4688 54.8126C67.5271 53.807 67.9759 52.8635 68.7201 52.1815C69.2162 51.7669 69.8037 51.4748 70.4346 51.3292C71.0656 51.1835 71.7222 51.1884 72.3509 51.3433C72.6294 51.4074 72.8968 51.5123 73.1443 51.6546C73.4077 51.8083 73.6571 51.9846 73.8897 52.1815L74.4187 52.7083C74.4679 52.7499 74.5281 52.7765 74.592 52.785C74.6559 52.7935 74.721 52.7835 74.7794 52.7562Z"
            fill="#0A0A0A"
          />
          <path
            d="M85.215 48.4217C83.8806 48.4734 82.591 48.915 81.5068 49.6914C80.4226 50.4679 79.5918 51.5449 79.1178 52.7883C78.6439 54.0317 78.5477 55.3864 78.8413 56.6839C79.135 57.9813 79.8054 59.164 80.7691 60.0846C81.7329 61.0053 82.9473 61.6232 84.2611 61.8613C85.5749 62.0994 86.93 61.9473 88.1576 61.4239C89.3852 60.9005 90.4311 60.0289 91.1649 58.9177C91.8986 57.8065 92.2879 56.5048 92.2842 55.1749C92.2717 54.2713 92.0798 53.3792 91.7196 52.5498C91.3594 51.7205 90.8379 50.9703 90.1852 50.3426C89.5326 49.7148 88.7617 49.2219 87.9169 48.8922C87.0721 48.5626 86.1702 48.4026 85.2631 48.4217H85.215ZM85.215 59.0304C84.4448 59.0445 83.6877 58.8308 83.0394 58.4163C82.3911 58.0019 81.8807 57.4053 81.5729 56.702C81.265 55.9987 81.1734 55.2203 81.3097 54.4651C81.446 53.71 81.8041 53.0121 82.3386 52.4596C82.8732 51.9072 83.5602 51.525 84.3128 51.3613C85.0655 51.1977 85.8499 51.26 86.567 51.5404C87.2841 51.8208 87.9016 52.3066 88.3414 52.9365C88.7813 53.5664 89.0238 54.312 89.0381 55.0791C89.051 56.0912 88.6613 57.0673 87.9539 57.7942C87.2466 58.5211 86.2793 58.9397 85.2631 58.9586L85.215 59.0304Z"
            fill="#0A0A0A"
          />
          <path
            d="M95.0732 54.1212V49.0922C95.0732 49.0922 95.0732 48.6612 95.4339 48.6612H97.9827C98.09 48.6538 98.1963 48.6865 98.2808 48.7529C98.3653 48.8193 98.4218 48.9147 98.4395 49.0204V49.7867C99.0314 49.233 99.7492 48.8304 100.531 48.6133C101.312 48.4005 102.13 48.361 102.928 48.4976C103.726 48.6341 104.484 48.9434 105.148 49.4036C105.793 49.9034 106.305 50.553 106.639 51.2954C106.815 51.7932 106.944 52.3063 107.024 52.828V61.4012C107.024 61.4012 107.024 61.5449 107.024 61.5689H104.018C104.018 61.5689 103.753 61.5689 103.778 61.0899V53.738C103.753 53.2047 103.568 52.691 103.246 52.2638C102.925 51.8367 102.481 51.5159 101.974 51.3433C101.426 51.1703 100.837 51.1719 100.29 51.3479C99.7423 51.5239 99.2637 51.8655 98.9204 52.3251C98.5126 52.9479 98.342 53.6954 98.4395 54.4325V61.1618C98.4497 61.2234 98.447 61.2865 98.4316 61.347C98.4163 61.4076 98.3886 61.4643 98.3502 61.5137C98.3119 61.5632 98.2637 61.6042 98.2088 61.6343C98.1538 61.6644 98.0932 61.6829 98.0308 61.6886H97.0449C96.5733 61.6407 96.0979 61.6407 95.6263 61.6886C95.6263 61.6886 95.0492 61.6886 95.1213 61.2336L95.0732 54.1212Z"
            fill="#0A0A0A"
          />
        </g>
        <defs>
          <clipPath id="clip0_325_499">
            <rect width="107" height="62" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const HomeIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 576 512"
        height="2em"
        width="2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Clock = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="40px"
        width="40px"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path d="M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"></path>
      </svg>
    </React.Fragment>
  );
};
export const ThemeChange = (props) => {
  return (
    <React.Fragment>
      <svg
        width="74"
        height="28"
        viewBox="0 0 74 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <rect width="74" height="28" rx="14" fill="#FFFFFF" />
        <circle cx="56.5" cy="13.5" r="8.5" fill={props.color} />
      </svg>
    </React.Fragment>
  );
};
export const Invoice = (props) => {
  return (
    <React.Fragment>
      <svg
        width="22"
        height="28"
        viewBox="0 0 22 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M11.0833 25.2H0V0H18.6667V17.7545H17.5V1.14545H1.16667V24.0545H11.0833V25.2Z"
          fill={props.color}
        />
        <path
          d="M14.9329 3.7334H5.59961V4.66673H14.9329V3.7334Z"
          fill={props.color}
        />
        <path
          d="M4.66771 3.7334H3.73438V4.66673H4.66771V3.7334Z"
          fill={props.color}
        />
        <path
          d="M14.9329 6.53369H5.59961V7.46702H14.9329V6.53369Z"
          fill={props.color}
        />
        <path
          d="M4.66771 6.53369H3.73438V7.46702H4.66771V6.53369Z"
          fill={props.color}
        />
        <path
          d="M14.9329 10.2666H5.59961V11.1999H14.9329V10.2666Z"
          fill={props.color}
        />
        <path
          d="M4.66771 10.2666H3.73438V11.1999H4.66771V10.2666Z"
          fill={props.color}
        />
        <path d="M14.9329 14H5.59961V14.9333H14.9329V14Z" fill={props.color} />
        <path d="M4.66771 14H3.73438V14.9333H4.66771V14Z" fill={props.color} />
        <path
          d="M11.1996 16.8003H5.59961V17.7336H11.1996V16.8003Z"
          fill={props.color}
        />
        <path
          d="M4.66771 16.8003H3.73438V17.7336H4.66771V16.8003Z"
          fill={props.color}
        />
        <line
          x1="18.3146"
          y1="21.4663"
          x2="18.3146"
          y2="27.9996"
          stroke={props.color}
          strokeWidth="1.16036"
        />
        <line
          x1="14.9336"
          y1="24.6195"
          x2="21.4669"
          y2="24.6195"
          stroke={props.color}
          strokeWidth="1.16036"
        />
      </svg>
    </React.Fragment>
  );
};
export const BellIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="26"
        height="28"
        viewBox="0 0 26 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M10.3918 1.74964C10.5994 1.2327 10.9553 0.789985 11.4141 0.47826C11.8728 0.166536 12.4135 0 12.9668 0C13.5201 0 14.0608 0.166536 14.5195 0.47826C14.9783 0.789985 15.3342 1.2327 15.5418 1.74964C17.5955 2.31894 19.4071 3.55203 20.6983 5.25954C21.9894 6.96705 22.6888 9.05456 22.6889 11.2015V17.7766L25.2333 21.6234C25.3728 21.8342 25.453 22.0792 25.4652 22.3324C25.4774 22.5855 25.4212 22.8372 25.3025 23.0607C25.1839 23.2841 25.0073 23.4709 24.7916 23.6012C24.5759 23.7314 24.3292 23.8002 24.0777 23.8001H17.7792C17.612 24.9663 17.0335 26.0328 16.1497 26.8041C15.2658 27.5755 14.1359 28 12.9668 28C11.7977 28 10.6678 27.5755 9.78393 26.8041C8.90011 26.0328 8.3216 24.9663 8.15438 23.8001H1.85587C1.60443 23.8002 1.35769 23.7314 1.14198 23.6012C0.926274 23.4709 0.749689 23.2841 0.631066 23.0607C0.512443 22.8372 0.456234 22.5855 0.468433 22.3324C0.480632 22.0792 0.560783 21.8342 0.700334 21.6234L3.24474 17.7766V11.2015C3.24474 6.68832 6.27246 2.88632 10.3918 1.74964ZM11.0029 23.8001C11.1464 24.2098 11.4124 24.5645 11.7642 24.8155C12.1161 25.0664 12.5365 25.2011 12.9675 25.2011C13.3985 25.2011 13.8189 25.0664 14.1708 24.8155C14.5226 24.5645 14.7886 24.2098 14.932 23.8001H11.0016H11.0029ZM12.9668 4.20219C11.125 4.20219 9.35873 4.93961 8.05642 6.25222C6.7541 7.56484 6.02247 9.34513 6.02247 11.2015V18.2007C6.02253 18.4772 5.94134 18.7476 5.78914 18.9776L4.45166 21.0004H21.4805L20.1431 18.9776C19.9914 18.7474 19.9107 18.4771 19.9111 18.2007V11.2015C19.9111 9.34513 19.1795 7.56484 17.8772 6.25222C16.5749 4.93961 14.8085 4.20219 12.9668 4.20219Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const FullScreen = (props) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M1.4668 7.25V2H6.7168M1.4668 2L7.30013 7.775L1.4668 2ZM1.4668 22.9417L7.30013 17.1667L1.4668 22.9417ZM22.4668 22.9417L16.6918 17.1667L22.4668 22.9417ZM22.4085 2L16.6335 7.775L22.4085 2ZM17.2168 2H22.4668V7.25L17.2168 2ZM22.4668 17.75V23H17.2168L22.4668 17.75ZM6.7168 23H1.4668V17.75L6.7168 23Z"
          stroke={props.color}
          strokeWidth="2.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const User = (props) => {
  return (
    <React.Fragment>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <g clipPath="url(#clip0_3205_4030)">
          <path
            d="M18.2831 13.7757C20.098 12.362 21.267 10.1714 21.267 7.71417C21.2667 3.46032 17.7679 0 13.4668 0C9.16568 0 5.66691 3.46032 5.66691 7.71417C5.66691 10.1712 6.83562 12.362 8.6508 13.7757C3.86046 15.6727 0.466797 20.3078 0.466797 25.7143C0.466797 26.4249 1.04883 27 1.76682 27C2.48481 27 3.06685 26.4249 3.06685 25.7143C3.06685 20.0429 7.73243 15.4286 13.4668 15.4286C19.2012 15.4286 23.8667 20.0429 23.8667 25.7143C23.8667 26.4249 24.4488 27 25.1668 27C25.8848 27 26.4668 26.4249 26.4668 25.7143C26.4668 20.3078 23.0731 15.6727 18.2831 13.7757ZM8.26669 7.71417C8.26669 4.87836 10.5995 2.57121 13.4668 2.57121C16.3341 2.57121 18.6669 4.87836 18.6669 7.71417C18.6669 10.55 16.3341 12.8571 13.4668 12.8571C10.5995 12.8571 8.26669 10.55 8.26669 7.71417Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_3205_4030">
            <rect
              width="27"
              height="28"
              fill="white"
              transform="translate(0.466797)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const DashBoard = (props) => {
  return (
    <React.Fragment>
      <svg
        width="2rem"
        height="2rem"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <g clipPath="url(#clip0_4421_11833)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.05078 4.22917C4.05078 3.61934 4.54513 3.125 5.15495 3.125H16.6958C17.3066 3.125 17.8008 3.61954 17.8008 4.22917V12.437C17.8009 12.582 17.7723 12.7257 17.7169 12.8597C17.6614 12.9937 17.5801 13.1155 17.4776 13.2181C17.375 13.3207 17.2533 13.402 17.1193 13.4576C16.9853 13.5131 16.8417 13.5417 16.6966 13.5417H13.4419C13.432 13.5414 13.4221 13.5414 13.4122 13.5417H8.4413C8.43137 13.5414 8.42147 13.5414 8.41161 13.5417H5.15495C4.8621 13.5417 4.58126 13.4253 4.37418 13.2183C4.16711 13.0112 4.05078 12.7303 4.05078 12.4375V4.22917ZM7.62643 14.7917H5.15495C4.53058 14.7917 3.93179 14.5436 3.4903 14.1021C3.04881 13.6607 2.80078 13.0619 2.80078 12.4375V4.22917C2.80078 2.92899 3.85477 1.875 5.15495 1.875H16.6958C17.9966 1.875 19.0508 2.92879 19.0508 4.22917V12.4364C19.0509 12.7455 18.9901 13.052 18.8719 13.3376C18.7537 13.6234 18.5803 13.883 18.3617 14.1017C18.143 14.3205 17.8835 14.494 17.5978 14.6124C17.3121 14.7307 17.0059 14.7917 16.6966 14.7917H14.2271L14.8662 17.3484C14.95 17.6833 14.7464 18.0226 14.4115 18.1063C14.0766 18.19 13.7373 17.9864 13.6536 17.6516L12.9386 14.7917H10.9258H8.9149L8.19993 17.6516C8.11621 17.9864 7.77687 18.19 7.442 18.1063C7.10713 18.0226 6.90353 17.6833 6.98725 17.3484L7.62643 14.7917Z"
            fill={props.color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3004 5.8334C10.3004 5.48823 10.0205 5.2084 9.67536 5.2084C9.33019 5.2084 9.05036 5.48823 9.05036 5.8334V10.8334C9.05036 11.1786 9.33019 11.4584 9.67536 11.4584C10.0205 11.4584 10.3004 11.1786 10.3004 10.8334V5.8334ZM7.80086 8.55845C7.80086 8.21327 7.52104 7.93345 7.17586 7.93345C6.83068 7.93345 6.55086 8.21327 6.55086 8.55845V10.8335C6.55086 11.1786 6.83068 11.4585 7.17586 11.4585C7.52104 11.4585 7.80086 11.1786 7.80086 10.8335V8.55845ZM12.1761 7.44169C12.5212 7.44169 12.8011 7.72151 12.8011 8.06669V10.8334C12.8011 11.1785 12.5212 11.4584 12.1761 11.4584C11.8309 11.4584 11.5511 11.1785 11.5511 10.8334V8.06669C11.5511 7.72151 11.8309 7.44169 12.1761 7.44169ZM15.3006 6.29167C15.3006 5.94649 15.0208 5.66667 14.6756 5.66667C14.3304 5.66667 14.0506 5.94649 14.0506 6.29167V10.8333C14.0506 11.1785 14.3304 11.4583 14.6756 11.4583C15.0208 11.4583 15.3006 11.1785 15.3006 10.8333V6.29167Z"
            fill={props.color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4421_11833">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0.925781)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const Dealers = (props) => {
  return (
    <React.Fragment>
      <svg
        width="2rem"
        height="2rem"
        viewBox="0 0 20 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M11.5883 5.80785C12.1867 5.32913 12.572 4.58737 12.572 3.75527C12.572 2.31482 11.4185 1.14307 10.0006 1.14307C8.58261 1.14307 7.42917 2.31482 7.42917 3.75527C7.42917 4.58728 7.81446 5.32913 8.41287 5.80785C6.83364 6.45023 5.71484 8.01978 5.71484 9.85055C5.71484 10.0912 5.90672 10.2859 6.14342 10.2859C6.38012 10.2859 6.57201 10.0912 6.57201 9.85055C6.57201 7.93009 8.11011 6.36757 10.0006 6.36757C11.891 6.36757 13.4291 7.93009 13.4291 9.85055C13.4291 10.0912 13.621 10.2859 13.8577 10.2859C14.0944 10.2859 14.2863 10.0912 14.2863 9.85055C14.2863 8.01978 13.1675 6.45023 11.5883 5.80785ZM8.28624 3.75527C8.28624 2.795 9.05529 2.01374 10.0006 2.01374C10.9458 2.01374 11.7149 2.795 11.7149 3.75527C11.7149 4.71555 10.9458 5.49681 10.0006 5.49681C9.05529 5.49681 8.28624 4.71555 8.28624 3.75527Z"
          fill={props.color}
        />
        <path
          d="M17.3455 4.66478C17.9342 4.18606 18.3134 3.4443 18.3134 2.61221C18.3133 1.17175 17.1784 0 15.7833 0C14.3882 0 13.2533 1.17175 13.2533 2.61221C13.2533 3.44421 13.6324 4.18606 14.2212 4.66478C13.3223 5.03642 12.575 5.71837 12.1047 6.5817C11.7621 7.21065 12.3698 6.29332 12.3698 7.06494C12.3698 7.30558 12.5586 7.50032 12.7915 7.50032C13.0243 7.50032 13.2131 7.30558 13.2131 7.06494C13.2131 6.4849 12.548 7.58006 12.792 7.09852C13.3557 5.98571 14.4851 5.22451 15.7833 5.22451C17.6433 5.22451 19.1566 6.78702 19.1566 8.70748C19.1566 8.94812 19.3454 9.14287 19.5783 9.14287C19.8112 9.14287 20 8.94812 20 8.70748C20 6.87671 18.8992 5.30716 17.3455 4.66478ZM14.0966 2.61221C14.0966 1.65193 14.8533 0.870675 15.7833 0.870675C16.7134 0.870675 17.47 1.65193 17.47 2.61221C17.47 3.57248 16.7134 4.35374 15.7833 4.35374C14.8533 4.35374 14.0966 3.57248 14.0966 2.61221Z"
          fill={props.color}
        />
        <path
          d="M2.65448 4.66478C2.0658 4.18606 1.68662 3.4443 1.68662 2.61221C1.68671 1.17175 2.82158 0 4.2167 0C5.61182 0 6.74669 1.17175 6.74669 2.61221C6.74669 3.44421 6.3676 4.18606 5.77882 4.66478C6.67774 5.03642 7.42504 5.71837 7.89528 6.5817C8.23786 7.21065 7.63022 6.29332 7.63022 7.06494C7.63022 7.30558 7.44143 7.50032 7.20855 7.50032C6.97566 7.50032 6.78687 7.30558 6.78687 7.06494C6.78687 6.4849 7.45199 7.58006 7.20804 7.09852C6.64427 5.98571 5.51493 5.22451 4.2167 5.22451C2.35669 5.22451 0.843352 6.78702 0.843352 8.70748C0.843352 8.94812 0.654562 9.14287 0.421673 9.14287C0.188784 9.14287 -6.67572e-06 8.94812 -6.67572e-06 8.70748C-6.67572e-06 6.87671 1.10077 5.30716 2.65448 4.66478ZM5.90342 2.61221C5.90342 1.65193 5.14675 0.870675 4.2167 0.870675C3.28665 0.870675 2.52998 1.65193 2.52998 2.61221C2.52998 3.57248 3.28665 4.35374 4.2167 4.35374C5.14675 4.35374 5.90342 3.57248 5.90342 2.61221Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const Order = (props) => {
  return (
    <React.Fragment>
      <svg
        width="2rem"
        height="2rem"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M16.2258 20C16.3114 20 16.3934 19.966 16.4539 19.9055C16.5144 19.845 16.5484 19.763 16.5484 19.6774V0.322581C16.5484 0.237027 16.5144 0.154977 16.4539 0.0944817C16.3934 0.0339861 16.3114 0 16.2258 0H3.32258C3.23703 0 3.15498 0.0339861 3.09448 0.0944817C3.03399 0.154977 3 0.237027 3 0.322581V19.6774C3 19.763 3.03399 19.845 3.09448 19.9055C3.15498 19.966 3.23703 20 3.32258 20H16.2258ZM3.64516 0.645161H15.9032V19.3548H3.64516V0.645161Z"
          fill={props.color}
        />
        <path
          d="M14.9342 1.29004H4.61164C4.52609 1.29004 4.44404 1.32403 4.38354 1.38452C4.32305 1.44502 4.28906 1.52707 4.28906 1.61262V15.161C4.28906 15.2466 4.32305 15.3286 4.38354 15.3891C4.44404 15.4496 4.52609 15.4836 4.61164 15.4836H14.9342C15.0198 15.4836 15.1018 15.4496 15.1623 15.3891C15.2228 15.3286 15.2568 15.2466 15.2568 15.161V1.61262C15.2568 1.52707 15.2228 1.44502 15.1623 1.38452C15.1018 1.32403 15.0198 1.29004 14.9342 1.29004ZM14.6116 14.8384H4.93422V1.9352H14.6116V14.8384Z"
          fill={props.color}
        />
        <path
          d="M9.7747 16.1289C9.5195 16.1289 9.27003 16.2046 9.05783 16.3464C8.84564 16.4881 8.68026 16.6897 8.5826 16.9254C8.48493 17.1612 8.45938 17.4207 8.50917 17.671C8.55896 17.9213 8.68185 18.1512 8.8623 18.3316C9.04276 18.5121 9.27267 18.635 9.52297 18.6848C9.77327 18.7345 10.0327 18.709 10.2685 18.6113C10.5043 18.5137 10.7058 18.3483 10.8476 18.1361C10.9893 17.9239 11.065 17.6744 11.065 17.4192C11.065 17.077 10.9291 16.7488 10.6871 16.5068C10.4451 16.2649 10.1169 16.1289 9.7747 16.1289ZM9.7747 18.0644C9.6471 18.0644 9.52236 18.0266 9.41627 17.9557C9.31017 17.8848 9.22748 17.784 9.17865 17.6661C9.12982 17.5482 9.11704 17.4185 9.14193 17.2934C9.16683 17.1682 9.22827 17.0533 9.3185 16.963C9.40873 16.8728 9.52368 16.8114 9.64883 16.7865C9.77398 16.7616 9.9037 16.7743 10.0216 16.8232C10.1395 16.872 10.2402 16.9547 10.3111 17.0608C10.382 17.1669 10.4199 17.2916 10.4199 17.4192C10.4199 17.5903 10.3519 17.7544 10.2309 17.8754C10.1099 17.9964 9.94581 18.0644 9.7747 18.0644Z"
          fill={props.color}
        />
        <path
          d="M13.645 3.54834H9.12891V4.1935H13.645V3.54834Z"
          fill={props.color}
        />
        <path
          d="M13.645 6.45166H9.12891V7.09682H13.645V6.45166Z"
          fill={props.color}
        />
        <path
          d="M13.645 12.2578H9.12891V12.903H13.645V12.2578Z"
          fill={props.color}
        />
        <path
          d="M6.54997 4.8385C6.62554 4.83854 6.69872 4.81205 6.75675 4.76366L8.69223 3.15076L8.27868 2.65527L6.56901 4.07947L6.13191 3.64269L5.67578 4.09882L6.32094 4.74398C6.35101 4.77406 6.38672 4.79789 6.42602 4.81411C6.46533 4.83033 6.50745 4.83862 6.54997 4.8385Z"
          fill={props.color}
        />
        <path
          d="M6.54997 7.74182C6.62554 7.74186 6.69872 7.71537 6.75675 7.66698L8.69223 6.05408L8.27868 5.55859L6.56901 6.98279L6.13191 6.54601L5.67578 7.00214L6.32094 7.6473C6.35101 7.67738 6.38672 7.70121 6.42602 7.71743C6.46533 7.73365 6.50745 7.74194 6.54997 7.74182Z"
          fill={props.color}
        />
        <path
          d="M6.54997 13.5485C6.62554 13.5485 6.69872 13.522 6.75675 13.4736L8.69223 11.8607L8.27868 11.3652L6.56901 12.7894L6.13191 12.3527L5.67578 12.8088L6.32094 13.4539C6.35101 13.484 6.38672 13.5078 6.42602 13.5241C6.46533 13.5403 6.50745 13.5486 6.54997 13.5485Z"
          fill={props.color}
        />
        <path
          d="M13.645 9.35498H9.12891V10.0001H13.645V9.35498Z"
          fill={props.color}
        />
        <path
          d="M6.54997 10.6451C6.62554 10.6452 6.69872 10.6187 6.75675 10.5703L8.69223 8.9574L8.27868 8.46191L6.56901 9.88611L6.13191 9.44933L5.67578 9.90546L6.32094 10.5506C6.35101 10.5807 6.38672 10.6045 6.42602 10.6207C6.46533 10.637 6.50745 10.6453 6.54997 10.6451Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const Complaints = (props) => {
  return (
    <React.Fragment>
      <svg
        width="2rem"
        height="2rem"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M16.1111 0H3.88889C2.85788 0.00125703 1.86945 0.413794 1.14041 1.14712C0.411372 1.88045 0.00124967 2.8747 0 3.91178V11.7353C0.00124967 12.7724 0.411372 13.7667 1.14041 14.5C1.86945 15.2333 2.85788 15.6459 3.88889 15.6471H6.96181L9.57356 18.7993C9.62567 18.8621 9.69087 18.9126 9.76455 18.9473C9.83823 18.982 9.91859 19 9.99995 19C10.0813 19 10.1617 18.982 10.2353 18.9473C10.309 18.9126 10.3742 18.8621 10.4263 18.7993L13.0382 15.6471H16.1111C17.1421 15.6459 18.1306 15.2333 18.8596 14.5C19.5886 13.7667 19.9988 12.7724 20 11.7353V3.91178C19.9988 2.8747 19.5886 1.88045 18.8596 1.14712C18.1306 0.413794 17.1421 0.00125703 16.1111 0ZM18.8889 11.7353C18.8881 12.4761 18.5952 13.1864 18.0744 13.7102C17.5537 14.2341 16.8476 14.5287 16.1111 14.5295H12.7778C12.6964 14.5294 12.616 14.5474 12.5423 14.5821C12.4686 14.6168 12.4034 14.6674 12.3513 14.7303L10 17.5681L7.64867 14.7303C7.59658 14.6674 7.53137 14.6168 7.45768 14.5821C7.38398 14.5474 7.3036 14.5294 7.22222 14.5295H3.88889C3.15241 14.5287 2.44632 14.2341 1.92556 13.7102C1.40479 13.1864 1.11188 12.4761 1.11111 11.7353V3.91178C1.11188 3.17097 1.40479 2.46072 1.92556 1.93689C2.44632 1.41306 3.15241 1.11843 3.88889 1.11765H16.1111C16.8476 1.11843 17.5537 1.41306 18.0744 1.93689C18.5952 2.46072 18.8881 3.17097 18.8889 3.91178V11.7353Z"
          fill={props.color}
        />
        <path
          d="M10 9.99951C9.80222 9.99951 9.60888 10.0582 9.44443 10.168C9.27998 10.2779 9.15181 10.4341 9.07612 10.6168C9.00043 10.7996 8.98063 11.0006 9.01922 11.1946C9.0578 11.3886 9.15304 11.5668 9.29289 11.7066C9.43275 11.8465 9.61093 11.9417 9.80491 11.9803C9.99889 12.0189 10.2 11.9991 10.3827 11.9234C10.5654 11.8477 10.7216 11.7195 10.8315 11.5551C10.9414 11.3906 11 11.1973 11 10.9995C10.9997 10.7344 10.8943 10.4802 10.7068 10.2927C10.5193 10.1052 10.2651 9.99978 10 9.99951Z"
          fill={props.color}
        />
        <path
          d="M10 2.99902C9.73486 2.99934 9.48066 3.12587 9.29319 3.35085C9.10571 3.57582 9.00026 3.88086 9 4.19902V7.79902C9 8.11728 9.10536 8.42251 9.29289 8.64755C9.48043 8.8726 9.73478 8.99902 10 8.99902C10.2652 8.99902 10.5196 8.8726 10.7071 8.64755C10.8946 8.42251 11 8.11728 11 7.79902V4.19902C10.9997 3.88086 10.8943 3.57582 10.7068 3.35085C10.5193 3.12587 10.2651 2.99934 10 2.99902Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const ProductIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 16 16"
        height="2rem"
        width="2rem"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Search = ({ mode, css }) => {
  return (
    <React.Fragment>
      <svg
        className={css}
        width="19"
        height="19"
        viewBox="0 0 19 19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9442 12.2826C15.094 10.7133 15.609 8.76779 15.3861 6.83512C15.1632 4.90245 14.219 3.12521 12.7422 1.85896C11.2654 0.592705 9.36504 -0.0691779 7.42128 0.00572919C5.47752 0.0806363 3.63371 0.886809 2.25874 2.26296C0.883763 3.63911 0.0790232 5.48376 0.00551755 7.42784C-0.0679881 9.37193 0.595161 11.2721 1.86229 12.7482C3.12942 14.2242 4.90709 15.1674 6.83964 15.3889C8.7722 15.6104 10.7171 15.094 12.2853 13.9429H12.2841C12.3197 13.9904 12.3577 14.0355 12.4005 14.0794L16.9722 18.6518C17.1948 18.8746 17.4969 18.9999 17.8119 19C18.1269 19.0001 18.429 18.8751 18.6518 18.6524C18.8746 18.4297 18.9999 18.1276 19 17.8126C19.0001 17.4975 18.8751 17.1953 18.6524 16.9725L14.0807 12.4001C14.0383 12.3572 13.9926 12.3175 13.9442 12.2814V12.2826ZM14.2505 7.71735C14.2505 8.57513 14.0816 9.42452 13.7534 10.217C13.4252 11.0095 12.9441 11.7296 12.3376 12.3361C11.7312 12.9427 11.0112 13.4238 10.2188 13.7521C9.42646 14.0803 8.57719 14.2493 7.71953 14.2493C6.86186 14.2493 6.0126 14.0803 5.22022 13.7521C4.42784 13.4238 3.70787 12.9427 3.10141 12.3361C2.49495 11.7296 2.01388 11.0095 1.68566 10.217C1.35745 9.42452 1.18852 8.57513 1.18852 7.71735C1.18852 5.98497 1.87661 4.32355 3.10141 3.09858C4.32621 1.87361 5.9874 1.18542 7.71953 1.18542C9.45166 1.18542 11.1128 1.87361 12.3376 3.09858C13.5624 4.32355 14.2505 5.98497 14.2505 7.71735Z"
          fill={mode ? "#fff" : "#000"}
        />
      </svg>
    </React.Fragment>
  );
};
export const WhatsApp = (props) => {
  return (
    <React.Fragment>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M4.01114 12.9963L4.25388 13.1173C5.26543 13.7223 6.39825 14.0046 7.53114 14.0046C11.0916 14.0046 14.0046 11.1006 14.0046 7.55115C14.0046 5.85713 13.3168 4.20341 12.1031 2.99336C10.8893 1.78331 9.27084 1.09766 7.53114 1.09766C3.97072 1.09766 1.05759 4.00172 1.09807 7.59151C1.09807 8.8015 1.46221 9.97124 2.06908 10.9795L2.2309 11.2216L1.5836 13.6013L4.01114 12.9963Z"
          fill="#00E676"
        />
        <path
          d="M12.8338 2.18919C11.4441 0.770295 9.52315 0 7.56129 0C3.39241 0 0.0408978 3.36485 0.081737 7.45943C0.081737 8.75674 0.449583 10.0135 1.0627 11.1486L0 15L3.96457 13.9865C5.0681 14.5946 6.29422 14.8784 7.52045 14.8784C11.6485 14.8784 15 11.5135 15 7.41898C15 5.43246 14.2234 3.56757 12.8338 2.18919ZM7.56129 13.6217C6.45775 13.6217 5.35421 13.3379 4.41415 12.7704L4.16894 12.6487L1.79839 13.2568L2.41145 10.946L2.24797 10.7028C0.449583 7.82441 1.30791 4.01351 4.25068 2.22969C7.19344 0.445939 10.9945 1.29731 12.7929 4.21622C14.5913 7.13514 13.7329 10.9054 10.7902 12.6892C9.8501 13.2973 8.70572 13.6217 7.56129 13.6217ZM11.158 9.12172L10.7084 8.91901C10.7084 8.91901 10.0545 8.63522 9.64579 8.4325C9.60489 8.4325 9.56405 8.39194 9.52315 8.39194C9.40052 8.39194 9.31878 8.4325 9.23704 8.47307C9.23704 8.47307 9.1962 8.51358 8.62399 9.16223C8.58309 9.2433 8.50135 9.28387 8.41961 9.28387H8.37872C8.33788 9.28387 8.25614 9.2433 8.21524 9.2028L8.01087 9.12172C7.56129 8.91901 7.1526 8.67572 6.8256 8.35143C6.74386 8.27035 6.62122 8.18928 6.53949 8.1082C6.25338 7.82441 5.96727 7.50006 5.76296 7.13519L5.72206 7.05412C5.68122 7.01355 5.68122 6.97304 5.64032 6.89197C5.64032 6.8109 5.64032 6.72982 5.68122 6.68925C5.68122 6.68925 5.84469 6.48654 5.96727 6.36496C6.04907 6.28382 6.0899 6.16224 6.17164 6.08117C6.25338 5.95953 6.29428 5.79738 6.25338 5.67574C6.21254 5.47302 5.72206 4.37843 5.59948 4.13521C5.51769 4.01356 5.43601 3.97306 5.31337 3.93249H4.86379C4.782 3.93249 4.70032 3.97306 4.61852 3.97306L4.57762 4.01356C4.49589 4.05413 4.41415 4.13521 4.33241 4.17571C4.25068 4.25685 4.20978 4.33786 4.12804 4.419C3.84193 4.78386 3.67846 5.2298 3.67846 5.67574C3.67846 6.00003 3.76019 6.32439 3.88283 6.60818L3.92373 6.72982C4.29157 7.50006 4.782 8.18928 5.43601 8.79737L5.59948 8.95951C5.72206 9.08116 5.84469 9.16223 5.92643 9.28381C6.78476 10.0136 7.76566 10.5406 8.8692 10.8244C8.99183 10.8649 9.15531 10.8649 9.27794 10.9055H9.68663C9.891 10.9055 10.1362 10.8244 10.2997 10.7433C10.4223 10.6623 10.5041 10.6623 10.5858 10.5812L10.6676 10.5C10.7493 10.419 10.8311 10.3785 10.9128 10.2974C10.9945 10.2163 11.0763 10.1352 11.1172 10.0541C11.1989 9.89196 11.2397 9.68924 11.2806 9.48659V9.2028C11.2806 9.2028 11.2397 9.16223 11.158 9.12172Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const Call = (props) => {
  return (
    <React.Fragment>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M13.2957 10.3082L11.2712 8.89374C11.0065 8.70911 10.697 8.61176 10.3761 8.61176C9.86586 8.61176 9.38688 8.862 9.09514 9.2807L8.62516 9.95422C7.83751 9.42596 6.9586 8.68835 6.12074 7.85065C5.28303 7.01294 4.54557 6.13403 4.01747 5.34637L4.69069 4.8764C5.03386 4.63745 5.26304 4.27948 5.33583 3.86871C5.40846 3.45825 5.31691 3.04352 5.07765 2.7002L3.66346 0.675659C3.36775 0.252686 2.89061 0 2.38691 0C2.21235 0 2.04115 0.0308228 1.87819 0.0909424C1.6931 0.159302 1.52067 0.243225 1.3516 0.349426L1.07206 0.546265C1.00218 0.600586 0.937176 0.660095 0.87492 0.722351C0.533886 1.06323 0.291882 1.49475 0.155316 2.005C-0.427418 4.18945 1.01622 7.49268 3.74754 10.224C6.04124 12.5177 8.79683 13.9426 10.9387 13.9429H10.9389C11.3057 13.9429 11.6514 13.9001 11.9667 13.8159C12.4769 13.6795 12.9085 13.4375 13.2496 13.0963C13.3116 13.0344 13.3708 12.9694 13.4343 12.8873L13.6313 12.6062C13.7276 12.4524 13.8113 12.28 13.8806 12.0935C14.1188 11.4496 13.8783 10.7153 13.2957 10.3082Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const Messanger = (props) => {
  return (
    <React.Fragment>
      <svg
        width="14"
        height="22"
        viewBox="0 0 14 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M11.0132 1H3.00264C1.89661 1 1 1.89543 1 3V19C1 20.1046 1.89661 21 3.00264 21H11.0132C12.1192 21 13.0158 20.1046 13.0158 19V3C13.0158 1.89543 12.1192 1 11.0132 1Z"
          stroke={props.color}
          strokeWidth="0.711462"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.92969 19.3398H7.00874"
          stroke={props.color}
          strokeWidth="1.99605"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.07596 9.77421C6.07596 9.85808 6.04181 9.9385 5.98103 9.9978C5.92024 10.0571 5.8378 10.0904 5.75185 10.0904C5.66589 10.0904 5.58345 10.0571 5.52266 9.9978C5.46188 9.9385 5.42773 9.85808 5.42773 9.77421C5.42773 9.69035 5.46188 9.60992 5.52266 9.55062C5.58345 9.49132 5.66589 9.45801 5.75185 9.45801C5.8378 9.45801 5.92024 9.49132 5.98103 9.55062C6.04181 9.60992 6.07596 9.69035 6.07596 9.77421ZM7.3724 9.77421C7.3724 9.85808 7.33825 9.9385 7.27747 9.9978C7.21669 10.0571 7.13425 10.0904 7.04829 10.0904C6.96233 10.0904 6.87989 10.0571 6.81911 9.9978C6.75832 9.9385 6.72418 9.85808 6.72418 9.77421C6.72418 9.69035 6.75832 9.60992 6.81911 9.55062C6.87989 9.49132 6.96233 9.45801 7.04829 9.45801C7.13425 9.45801 7.21669 9.49132 7.27747 9.55062C7.33825 9.60992 7.3724 9.69035 7.3724 9.77421ZM8.34473 10.0904C8.43069 10.0904 8.51313 10.0571 8.57391 9.9978C8.63469 9.9385 8.66884 9.85808 8.66884 9.77421C8.66884 9.69035 8.63469 9.60992 8.57391 9.55062C8.51313 9.49132 8.43069 9.45801 8.34473 9.45801C8.25877 9.45801 8.17633 9.49132 8.11555 9.55062C8.05477 9.60992 8.02062 9.69035 8.02062 9.77421C8.02062 9.85808 8.05477 9.9385 8.11555 9.9978C8.17633 10.0571 8.25877 10.0904 8.34473 10.0904Z"
          fill={props.color}
        />
        <path
          d="M5.1738 12.2639L5.18022 12.2626C5.76792 12.1473 6.12696 11.9951 6.29396 11.9116C6.53982 11.9764 6.79323 12.0091 7.04769 12.0088C8.46651 12.0088 9.61686 11.0132 9.61686 9.78515C9.61686 8.55707 8.46651 7.56152 7.04769 7.56152C5.62886 7.56152 4.47852 8.55707 4.47852 9.78515C4.47852 10.3442 4.71713 10.8557 5.11117 11.2464C5.08361 11.4974 5.02715 11.7444 4.94289 11.9827L4.94193 11.9862C4.91799 12.0545 4.89185 12.122 4.86357 12.1886C4.8382 12.2477 4.88733 12.3137 4.95124 12.3036C5.02564 12.2915 5.09983 12.2783 5.1738 12.2639ZM5.43071 11.2766C5.43521 11.2301 5.42928 11.1831 5.41335 11.1392C5.39742 11.0952 5.37188 11.0552 5.33855 11.0221C4.99813 10.6841 4.79966 10.2515 4.79966 9.78515C4.79966 8.77118 5.76439 7.87918 7.04769 7.87918C8.33099 7.87918 9.29571 8.77118 9.29571 9.78515C9.29571 10.7994 8.33099 11.6911 7.04769 11.6911C6.82131 11.6914 6.59587 11.6624 6.37713 11.6047C6.30069 11.5845 6.21938 11.5928 6.1488 11.6282C6.02451 11.6905 5.75058 11.8093 5.3029 11.9119C5.36535 11.7045 5.40814 11.4918 5.43071 11.2766Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const Ban = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="40px"
        width="40px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Checked = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="40px"
        width="40px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Facebook = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Instagram = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Youtube = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 576 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Pinterest = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 496 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Twitter = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
      </svg>
    </React.Fragment>
  );
};
export const PdfFile = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 384 512"
        color="#fff"
        height="25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Setting = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color ? props.color : "currentColor"}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Edit = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        className={props.className}
        fill={props.color}
        strokeWidth="0"
        viewBox="0 0 576 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"></path>
      </svg>
    </React.Fragment>
  );
};
export const View = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 496 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"></path>
      </svg>
    </React.Fragment>
  );
};
export const UpLoadFile = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        viewBox="0 0 24 24"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={props.className}
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="17 8 12 3 7 8"></polyline>
        <line x1="12" y1="3" x2="12" y2="15"></line>
      </svg>
    </React.Fragment>
  );
};
export const DeleteFile = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"></path>
      </svg>
    </React.Fragment>
  );
};
export const MarketingIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 460 512"
        height="2rem"
        width="2rem"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"></path>
      </svg>
    </React.Fragment>
  );
};
export const DownArrowCircle = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"></path>
      </svg>
    </React.Fragment>
  );
};
export const UpArrowCircle = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"></path>
      </svg>
    </React.Fragment>
  );
};
export const ThreeDots = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        style={{
          cursor: "pointer",
        }}
        stroke="currentColor"
        fill={mode ? "#fff" : "#646B88"}
        // className={props.css}
        strokeWidth="0"
        viewBox="0 0 192 512"
        height="20px"
        width="20px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Envelope = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"></path>
      </svg>
    </React.Fragment>
  );
};
export const CommentDetail = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 7h10v2H7zm0 4h7v2H7z"></path>
        <path d="M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"></path>
      </svg>
    </React.Fragment>
  );
};

export const Phone = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="2"
        viewBox="0 0 24 24"
        strokeLinecap="round"
        strokeLinejoin="round"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
      </svg>
    </React.Fragment>
  );
};
export const UpdateIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="40px"
        width="40px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="#1ffc33" d="M0 0h24v24H0z"></path>
        <path d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"></path>
      </svg>
    </React.Fragment>
  );
};

export const Eye = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        onClick={props.onClick}
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 576 512"
        className={props.className}
        height="25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path>
      </svg>
    </React.Fragment>
  );
};

export const EyeHide = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        onClick={props.onClick}
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 640 512"
        className={props.className}
        height="25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Spinner = (props) => {
  return (
    <React.Fragment>
      <div className="tw_center">
        <div
          className="spinner"
          style={{ height: props.size + "px", width: props.size + "px" }}
        />
      </div>
    </React.Fragment>
  );
};

export const Danger = (props) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#f93e3e"
      className={props.className}
      viewBox="0 0 85.04 122.88"
    >
      <path d="M42.89,88.34c3.66-2.03,10.09-5.03,19.25-8.95c0.46-0.23,1.65-0.75,3.55-1.54c3.28-3.34,5.96-5.84,8.13-7.52 c2.14-1.66,3.69-2.5,4.64-2.5c1.18,0,2.04,0.38,2.62,1.11c0.55,0.73,0.84,1.86,0.84,3.4c0,1.31-0.2,3.14-0.6,5.52 c2.42,3.08,3.63,5.35,3.63,6.83c0,1.25-0.35,2.21-1.01,2.85c-0.69,0.66-1.7,0.98-3.05,0.98c-0.66,0-1.7-0.35-3.06-1.07 c-1.38-0.7-3.14-1.74-5.28-3.11c-5.19,0.96-12.62,3.89-22.31,8.78c1.24,0.73,2.13,1.27,2.71,1.63c3.37,1.92,7.55,4.5,12.51,7.73 c0.6,0.41,2.02,1.25,4.21,2.56c10.24,1.19,15.37,3.8,15.37,7.81c0,2.61-2.77,4.39-8.27,5.29c-2.59,3.16-4.73,4.76-6.43,4.76 c-2.02,0-3.98-2.67-5.91-7.99c-0.17-0.58-0.46-1.39-0.92-2.47c-7.9-6.54-14.99-11.47-21.3-14.81c-7.7,4.39-14.85,9.59-21.45,15.66 c-0.89,6.42-2.8,9.62-5.74,9.62c-1.84,0-3.98-1.8-6.4-5.43c-5.74,0-8.62-1.6-8.62-4.76c0-2.32,1.07-4.01,3.2-5.09 c2.13-1.04,6.66-2.06,13.52-3.1c5.1-3.78,11.18-7.58,18.22-11.39c-9.46-4.76-17.15-7.7-23.12-8.78c-1.41,1.25-2.71,2.18-3.89,2.82 c-1.18,0.61-2.28,0.93-3.28,0.93c-1.47,0-2.57-0.32-3.32-0.93c-0.78-0.64-1.15-1.54-1.15-2.73c0-1.07,1.24-3.28,3.72-6.57 c-0.58-2.32-0.87-4.06-0.87-5.26c0-1.71,0.35-2.96,1.01-3.81C4.73,67.98,5.7,67.57,7,67.57c1.29,0,2.97,0.84,5.04,2.56 c2.11,1.69,4.61,4.27,7.52,7.73C26.06,80.18,33.81,83.69,42.89,88.34L42.89,88.34L42.89,88.34z M52.96,60.6l-1.7,4.35 c-2.13,0.73-5.05,1.11-8.71,1.11c-1.78,0-3.43-0.09-4.9-0.29c-1.47-0.2-2.74-0.47-3.8-0.81l-1.7-4.35L20.36,54.9l-1.09-7.15 c-0.17-1.36-1.39-4.03-3.64-8.01c-1.76-2.93-2.62-7.67-2.62-14.2c0-7.61,2.74-13.78,8.19-18.48C26.67,2.35,33.79,0,42.58,0 c8.76,0,15.88,2.35,21.36,7.06c5.45,4.7,8.19,10.87,8.19,18.48c0,6.54-1.82,12.9-5.42,19.14c-0.31,0.7-0.6,1.72-0.83,3.08 l-1.09,7.15L52.96,60.6L52.96,60.6L52.96,60.6z M58.53,62.57l-2.11,8.4l-5.16,4.53c-0.89,1.74-2.07,3.08-3.58,3.95 c-1.49,0.87-3.25,1.31-5.3,1.31c-4.07,0-7-1.74-8.88-5.26l-5.14-4.53l-2.12-8.4l3.05-0.78c0.35,0.87,0.58,1.51,0.75,1.98 c1.3,2.99,2.74,4.97,4.26,5.93c1.56,0.96,4.12,1.45,7.76,1.45c4.04,0,6.86-0.46,8.39-1.36c1.56-0.91,3-2.9,4.27-6.02 c0.17-0.47,0.43-1.1,0.78-1.98L58.53,62.57L58.53,62.57L58.53,62.57z M42.64,46.3c-1.01,1.69-2.05,3.2-3.13,4.5 c-1.36,1.54-2.03,2.73-2.03,3.57c0,0.9,0.26,1.6,0.81,2.07c0.52,0.43,1.29,0.66,2.34,0.66c0.6,0,1.29-0.23,2.01-0.66 c0.72,0.43,1.41,0.66,2.02,0.66c2.11,0,3.14-0.92,3.14-2.82c0-0.79-0.66-1.95-2.01-3.49C44.63,49.44,43.59,47.96,42.64,46.3 L42.64,46.3z M23.21,39.42c0,5.43,2.33,8.16,7,8.16c4.73,0,7.1-2.93,7.1-8.77c0-4.82-2.28-7.23-6.84-7.23 c-2.41,0-4.23,0.63-5.45,1.94C23.82,34.83,23.21,36.81,23.21,39.42L23.21,39.42L23.21,39.42z M48.23,39.42 c0,5.43,2.36,8.16,7.1,8.16c4.72,0,7.08-2.93,7.08-8.77c0-2.44-0.57-4.24-1.72-5.43c-1.15-1.19-2.88-1.8-5.19-1.8 C50.66,31.58,48.23,34.19,48.23,39.42L48.23,39.42L48.23,39.42z" />
    </svg>
  );
};

export const EyeIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="15"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9603 7.26818C19.1762 5.19385 17.8149 3.39997 16.0447 2.10824C14.2745 0.816515 12.1731 0.0835725 10 0C7.82695 0.0835725 5.72547 0.816515 3.9553 2.10824C2.18512 3.39997 0.823847 5.19385 0.0397175 7.26818C-0.0132392 7.41798 -0.0132392 7.58202 0.0397175 7.73182C0.823847 9.80615 2.18512 11.6 3.9553 12.8918C5.72547 14.1835 7.82695 14.9164 10 15C12.1731 14.9164 14.2745 14.1835 16.0447 12.8918C17.8149 11.6 19.1762 9.80615 19.9603 7.73182C20.0132 7.58202 20.0132 7.41798 19.9603 7.26818ZM10 13.6364C6.46657 13.6364 2.73313 10.9568 1.37976 7.5C2.73313 4.04318 6.46657 1.36364 10 1.36364C13.5334 1.36364 17.2669 4.04318 18.6202 7.5C17.2669 10.9568 13.5334 13.6364 10 13.6364Z"
          fill={props.color}
        />
        <path
          d="M10 3C9.20888 3 8.43552 3.2346 7.77772 3.67412C7.11992 4.11365 6.60723 4.73836 6.30448 5.46927C6.00173 6.20017 5.92252 7.00444 6.07686 7.78036C6.2312 8.55628 6.61216 9.26902 7.17157 9.82843C7.73098 10.3878 8.44372 10.7688 9.21964 10.9231C9.99556 11.0775 10.7998 10.9983 11.5307 10.6955C12.2616 10.3928 12.8864 9.88008 13.3259 9.22228C13.7654 8.56448 14 7.79112 14 7C14 5.93913 13.5786 4.92172 12.8284 4.17157C12.0783 3.42143 11.0609 3 10 3ZM10 9.66667C9.47258 9.66667 8.95701 9.51027 8.51848 9.21725C8.07995 8.92423 7.73816 8.50776 7.53632 8.02049C7.33449 7.53322 7.28168 6.99704 7.38457 6.47976C7.48747 5.96248 7.74144 5.48732 8.11438 5.11438C8.48732 4.74144 8.96248 4.48747 9.47976 4.38457C9.99704 4.28168 10.5332 4.33449 11.0205 4.53632C11.5078 4.73815 11.9242 5.07995 12.2173 5.51848C12.5103 5.95701 12.6667 6.47258 12.6667 7C12.6667 7.70724 12.3857 8.38552 11.8856 8.88562C11.3855 9.38571 10.7072 9.66667 10 9.66667Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const PoliceLightIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        version="1.1"
        viewBox="0 0 752 752"
        fill={props.color}
      >
        <g>
          <path d="m555.96 513.34h-28.414v-132.6c0-83.352-68.195-151.55-151.55-151.55s-151.55 68.195-151.55 151.55v132.6h-28.414c-5.2109 0-9.4727 4.2617-9.4727 9.4727v56.828c0 5.2109 4.2617 9.4727 9.4727 9.4727h359.92c5.2109 0 9.4727-4.2617 9.4727-9.4727v-56.828c0-5.2109-4.2617-9.4727-9.4727-9.4727zm-312.56-132.6c0-72.93 59.672-132.6 132.6-132.6s132.6 59.672 132.6 132.6v132.6h-265.2zm303.09 189.43h-340.98v-37.887h340.98z" />
          <path d="m376 219.72c5.2109 0 9.4727-4.2617 9.4727-9.4727v-37.883c0-5.2109-4.2617-9.4727-9.4727-9.4727s-9.4727 4.2617-9.4727 9.4727v37.887c0.003906 5.207 4.2656 9.4688 9.4727 9.4688z" />
          <path d="m214.98 394.95c0-5.2109-4.2617-9.4727-9.4727-9.4727h-37.887c-5.2109 0-9.4727 4.2617-9.4727 9.4727 0 5.2109 4.2617 9.4727 9.4727 9.4727h37.887c5.2109 0 9.4727-4.2656 9.4727-9.4727z" />
          <path d="m584.38 385.47h-37.887c-5.2109 0-9.4727 4.2617-9.4727 9.4727 0 5.2109 4.2617 9.4727 9.4727 9.4727h37.887c5.2109 0 9.4727-4.2617 9.4727-9.4727-0.003906-5.2109-4.2656-9.4727-9.4727-9.4727z" />
          <path d="m231.09 277.5c1.8945 1.8945 4.2617 2.8398 6.6289 2.8398 2.3672 0 4.7344-0.94531 6.6289-2.8398 3.7891-3.7891 3.7891-9.4727 0-13.262l-26.992-26.992c-3.7891-3.7891-9.4727-3.7891-13.262 0-3.7891 3.7891-3.7891 9.4727 0 13.262z" />
          <path d="m514.29 280.34c2.3672 0 4.7344-0.94531 6.6289-2.8398l26.992-26.992c3.7891-3.7891 3.7891-9.4727 0-13.262-3.7891-3.7891-9.4727-3.7891-13.262 0l-26.992 26.992c-3.7891 3.7891-3.7891 9.4727 0 13.262 1.4258 1.8906 4.2656 2.8398 6.6328 2.8398z" />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const ViewImageIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 7.5C10 8.16304 9.73661 8.79893 9.26777 9.26777C8.79893 9.73661 8.16304 10 7.5 10C6.83696 10 6.20107 9.73661 5.73223 9.26777C5.26339 8.79893 5 8.16304 5 7.5C5 6.83696 5.26339 6.20107 5.73223 5.73223C6.20107 5.26339 6.83696 5 7.5 5C8.16304 5 8.79893 5.26339 9.26777 5.73223C9.73661 6.20107 10 6.83696 10 7.5Z"
          fill="white"
        />
        <path
          d="M2.5 0C1.83696 0 1.20107 0.30102 0.732233 0.836838C0.263392 1.37266 0 2.09938 0 2.85714V17.1429C0 17.9006 0.263392 18.6273 0.732233 19.1632C1.20107 19.699 1.83696 20 2.5 20H17.5C18.163 20 18.7989 19.699 19.2678 19.1632C19.7366 18.6273 20 17.9006 20 17.1429V2.85714C20 2.09938 19.7366 1.37266 19.2678 0.836838C18.7989 0.30102 18.163 0 17.5 0H2.5ZM17.5 1.42857C17.8315 1.42857 18.1495 1.57908 18.3839 1.84699C18.6183 2.1149 18.75 2.47826 18.75 2.85714V12.1429L14.0288 9.36143C13.9115 9.29432 13.7788 9.27104 13.6494 9.29488C13.5199 9.31872 13.4003 9.38848 13.3075 9.49429L8.67 14.7943L5.345 12.2629C5.22495 12.1715 5.08095 12.1304 4.93742 12.1466C4.79389 12.1627 4.65967 12.2351 4.5575 12.3514L1.25 15.7143V2.85714C1.25 2.47826 1.3817 2.1149 1.61612 1.84699C1.85054 1.57908 2.16848 1.42857 2.5 1.42857H17.5Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const CrossCircleIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 25C19.8513 25 25 19.8513 25 13.5C25 7.14873 19.8513 2 13.5 2C7.14873 2 2 7.14873 2 13.5C2 19.8513 7.14873 25 13.5 25Z"
          stroke="#FF4F4F"
          strokeWidth="2.26488"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 10L10 17"
          stroke="#FF4F4F"
          strokeWidth="2.26488"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10L17 17"
          stroke="#FF4F4F"
          strokeWidth="2.26488"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const Print = () => {
  return (
    <React.Fragment>
      <svg
        width="25"
        height="25"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          fill="#4387FF"
        />
        <path
          d="M6.25 6.17857C6.25 5.86599 6.36853 5.56622 6.5795 5.3452C6.79048 5.12417 7.07663 5 7.375 5H12.625C12.9234 5 13.2095 5.12417 13.4205 5.3452C13.6315 5.56622 13.75 5.86599 13.75 6.17857V6.57143H14.125C14.6223 6.57143 15.0992 6.77838 15.4508 7.14675C15.8025 7.51513 16 8.01475 16 8.53571V12.4643C16 12.7769 15.8815 13.0766 15.6705 13.2977C15.4595 13.5187 15.1734 13.6429 14.875 13.6429H13.75V14.8214C13.75 15.134 13.6315 15.4338 13.4205 15.6548C13.2095 15.8758 12.9234 16 12.625 16H7.375C7.07663 16 6.79048 15.8758 6.5795 15.6548C6.36853 15.4338 6.25 15.134 6.25 14.8214V13.6429H5.125C4.82663 13.6429 4.54048 13.5187 4.3295 13.2977C4.11853 13.0766 4 12.7769 4 12.4643V8.53571C4 8.01475 4.19754 7.51513 4.54917 7.14675C4.90081 6.77838 5.37772 6.57143 5.875 6.57143H6.25V6.17857ZM7 6.57143H13V6.17857C13 6.07438 12.9605 5.97445 12.8902 5.90078C12.8198 5.8271 12.7245 5.78571 12.625 5.78571H7.375C7.27554 5.78571 7.18016 5.8271 7.10984 5.90078C7.03951 5.97445 7 6.07438 7 6.17857V6.57143ZM6.25 12.8571V11.6786C6.25 11.366 6.36853 11.0662 6.5795 10.8452C6.79048 10.6242 7.07663 10.5 7.375 10.5H12.625C12.9234 10.5 13.2095 10.6242 13.4205 10.8452C13.6315 11.0662 13.75 11.366 13.75 11.6786V12.8571H14.875C14.9745 12.8571 15.0698 12.8158 15.1402 12.7421C15.2105 12.6684 15.25 12.5685 15.25 12.4643V8.53571C15.25 8.22314 15.1315 7.92336 14.9205 7.70234C14.7095 7.48131 14.4234 7.35714 14.125 7.35714H5.875C5.57663 7.35714 5.29048 7.48131 5.0795 7.70234C4.86853 7.92336 4.75 8.22314 4.75 8.53571V12.4643C4.75 12.5685 4.78951 12.6684 4.85984 12.7421C4.93016 12.8158 5.02554 12.8571 5.125 12.8571H6.25ZM7.375 11.2857C7.27554 11.2857 7.18016 11.3271 7.10984 11.4008C7.03951 11.4745 7 11.5744 7 11.6786V14.8214C7 14.9256 7.03951 15.0255 7.10984 15.0992C7.18016 15.1729 7.27554 15.2143 7.375 15.2143H12.625C12.7245 15.2143 12.8198 15.1729 12.8902 15.0992C12.9605 15.0255 13 14.9256 13 14.8214V11.6786C13 11.5744 12.9605 11.4745 12.8902 11.4008C12.8198 11.3271 12.7245 11.2857 12.625 11.2857H7.375Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const Camera = () => {
  return (
    <React.Fragment>
      <svg
        width="27"
        height="22"
        viewBox="0 0 27 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.5 3H18.7676L17.2129 0.668001C17.0761 0.462388 16.8905 0.293803 16.6727 0.177256C16.455 0.060709 16.2118 -0.000183468 15.9648 4.15232e-07H11.0348C10.7878 -0.000183468 10.5446 0.060709 10.3269 0.177256C10.1091 0.293803 9.92354 0.462388 9.7867 0.668001L8.2324 3H2.5C1.83715 3.00061 1.20161 3.2642 0.732906 3.73291C0.264197 4.20161 0.000608986 4.83715 0 5.5V19.5C0.000608986 20.1629 0.264197 20.7984 0.732906 21.2671C1.20161 21.7358 1.83715 21.9994 2.5 22H24.5C25.1629 21.9994 25.7984 21.7358 26.2671 21.2671C26.7358 20.7984 26.9994 20.1629 27 19.5V5.5C26.9994 4.83715 26.7358 4.20161 26.2671 3.73291C25.7984 3.2642 25.1629 3.00061 24.5 3ZM26 19.5C25.9995 19.8977 25.8414 20.279 25.5602 20.5602C25.279 20.8414 24.8977 20.9995 24.5 21H2.5C2.10231 20.9995 1.72104 20.8414 1.43984 20.5602C1.15863 20.279 1.00045 19.8977 1 19.5V5.5C1.00045 5.10231 1.15863 4.72104 1.43984 4.43984C1.72104 4.15863 2.10231 4.00045 2.5 4H8.5C8.5813 3.99507 8.66057 3.97261 8.73237 3.93418C8.80418 3.89574 8.86682 3.84222 8.916 3.7773L10.6191 1.2227C10.6646 1.15405 10.7265 1.09776 10.7991 1.05889C10.8717 1.02003 10.9528 0.99979 11.0352 1H15.9652C16.0476 0.99979 16.1287 1.02003 16.2013 1.05889C16.2739 1.09776 16.3358 1.15405 16.3813 1.2227L18.084 3.7773C18.1327 3.84268 18.1953 3.89653 18.2672 3.93502C18.3391 3.9735 18.4186 3.99569 18.5 4H24.5C24.8977 4.00045 25.279 4.15863 25.5602 4.43984C25.8414 4.72104 25.9995 5.10231 26 5.5V19.5Z"
          fill="#3A3A3A"
        />
        <path
          d="M13.5 7C12.4122 7 11.3488 7.32257 10.4444 7.92692C9.5399 8.53126 8.83495 9.39025 8.41867 10.3952C8.00238 11.4002 7.89346 12.5061 8.10568 13.573C8.3179 14.6399 8.84173 15.6199 9.61091 16.3891C10.3801 17.1583 11.3601 17.6821 12.427 17.8943C13.4939 18.1065 14.5998 17.9976 15.6048 17.5813C16.6098 17.1651 17.4687 16.4601 18.0731 15.5556C18.6774 14.6512 19 13.5878 19 12.5C18.9982 11.0419 18.4181 9.64398 17.3871 8.61293C16.356 7.58187 14.9581 7.00183 13.5 7ZM13.5 17C12.61 17 11.74 16.7361 10.9999 16.2416C10.2599 15.7471 9.68314 15.0443 9.34254 14.2221C9.00195 13.3998 8.91283 12.495 9.08647 11.6221C9.2601 10.7492 9.68869 9.94736 10.318 9.31802C10.9474 8.68868 11.7492 8.2601 12.6221 8.08647C13.495 7.91283 14.3998 8.00195 15.2221 8.34254C16.0443 8.68314 16.7471 9.25991 17.2416 9.99993C17.7361 10.74 18 11.61 18 12.5C17.9987 13.6931 17.5241 14.8369 16.6805 15.6805C15.8369 16.5241 14.6931 16.9987 13.5 17Z"
          fill="#3A3A3A"
        />
      </svg>
    </React.Fragment>
  );
};
// export const Tick = () => {
//   return (
//     <React.Fragment>
//       <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <circle cx="10" cy="10" r="9.5625" stroke="#50F085" strokeWidth="0.875" />
//         <path d="M19.1164 0.226115C18.9191 0.111592 18.7021 0.0387619 18.4778 0.0117907C18.2535 -0.0151804 18.0263 0.00423597 17.8092 0.0689298C17.5921 0.133624 17.3894 0.242326 17.2126 0.38882C17.0358 0.535314 16.8884 0.716727 16.7789 0.922683L8.78138 12.2576L6.95514 10.3526C6.79659 10.1813 6.60692 10.0447 6.39722 9.95077C6.18752 9.8568 5.96198 9.80734 5.73375 9.80527C5.50553 9.80321 5.2792 9.84857 5.06796 9.93872C4.85672 10.0289 4.66481 10.162 4.50343 10.3304C4.34205 10.4987 4.21442 10.6989 4.12799 10.9192C4.04157 11.1396 3.99808 11.3757 4.00006 11.6138C4.00205 11.8518 4.04946 12.0871 4.13955 12.3058C4.22963 12.5246 4.36057 12.7224 4.52473 12.8878L7.96237 16.4738C8.28723 16.8135 8.72552 17 9.17757 17L9.41563 16.9821C9.67908 16.9436 9.93038 16.8419 10.1498 16.685C10.3691 16.528 10.5506 16.3201 10.6798 16.0775L19.7833 2.66455C19.8931 2.45876 19.9628 2.23245 19.9887 1.99853C20.0145 1.76462 19.996 1.52768 19.9341 1.30125C19.8721 1.07482 19.768 0.863325 19.6278 0.678853C19.4875 0.494381 19.3137 0.34054 19.1164 0.226115Z" fill="#50F085" />
//       </svg>
//     </React.Fragment>
//   )
// }
export const Whatsappweb = () => {
  return (
    <React.Fragment>
      <svg
        width="25"
        height="25"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.0024 34C12.4939 34 8.16997 32.2093 4.98154 29.0218C1.79311 25.8343 0.0012569 21.5109 0 17.0024V17.0024C0 14.7696 0.439764 12.5587 1.29421 10.4958C2.14866 8.43302 3.40108 6.5587 4.97989 4.97988C6.55871 3.40106 8.43302 2.14868 10.4958 1.29423C12.5587 0.439778 14.7696 0 17.0024 0V0C19.2349 -8.68065e-08 21.4456 0.439814 23.5082 1.29432C25.5707 2.14883 27.4448 3.40129 29.0232 4.98017C30.6016 6.55904 31.8536 8.43341 32.7075 10.4962C33.5614 12.559 34.0006 14.7698 34 17.0024V17.0024C34 21.5104 32.2092 25.8338 29.0215 29.0215C25.8339 32.2092 21.5104 34 17.0024 34V34Z"
          fill="#00E676"
        />
        <path
          d="M12.0631 24.5937L12.4017 24.7625C13.8123 25.6062 15.3922 26 16.9721 26C21.9374 26 26 21.95 26 17C26 14.6375 25.0407 12.3313 23.3481 10.6437C21.6553 8.95621 19.3983 8 16.9721 8C12.0068 8 7.94412 12.05 8.00058 17.0563C8.00058 18.7437 8.5084 20.3751 9.35474 21.7812L9.58042 22.1188L8.6777 25.4375L12.0631 24.5937Z"
          fill="#00E676"
        />
        <path
          d="M24.076 9.9539L24.0907 9.96891H24.0911C25.9252 11.7959 26.95 14.2635 26.95 16.892C26.95 22.3237 22.5037 26.7879 17.0273 26.7879C15.4 26.7879 13.7736 26.4113 12.3102 25.6049L12.2929 25.5953L12.2737 25.6002L7.07113 26.9302L8.46513 21.8782L8.47048 21.8588L8.46092 21.8411C7.64675 20.3338 7.15898 18.6661 7.15899 16.9459L7.15898 16.9454C7.10481 11.5143 11.5505 7.05 17.0817 7.05C19.6846 7.05 22.2329 8.07204 24.076 9.9539ZM17.0817 25.2122H17.1317V25.212C18.6498 25.2027 20.1653 24.7685 21.4135 23.9613C25.3609 21.568 26.5116 16.5101 24.0998 12.5954C21.687 8.67926 16.588 7.53812 12.6416 9.93017C8.69373 12.3233 7.54251 17.4358 9.95489 21.2968L9.95487 21.2969L9.9558 21.2982L10.1611 21.6038L9.34952 24.6629L9.32765 24.7454L9.41028 24.7242L12.553 23.918L12.8615 24.071C14.1229 24.8322 15.6027 25.2122 17.0817 25.2122ZM19.3325 18.3532L19.3463 18.3382C19.4518 18.2859 19.5504 18.2392 19.6975 18.2392C19.7108 18.2392 19.727 18.2461 19.7571 18.2611C19.7582 18.2617 19.7595 18.2623 19.7607 18.2629C19.7824 18.2737 19.8138 18.2893 19.848 18.2927C20.1202 18.4274 20.4704 18.5877 20.7534 18.7146C20.8966 18.7789 21.0227 18.8347 21.113 18.8744L21.2194 18.921L21.248 18.9335L21.2555 18.9368L21.2573 18.9376L21.2578 18.9378L21.258 18.9379L21.258 18.9379L21.8559 19.2075C21.9071 19.2329 21.9451 19.2581 21.9701 19.2767C21.9785 19.283 21.9854 19.2884 21.9909 19.2929V19.6438C21.9363 19.9141 21.883 20.1752 21.7782 20.383C21.7282 20.4823 21.6262 20.5842 21.5152 20.6944C21.4636 20.7456 21.4118 20.7841 21.3571 20.8248L21.3561 20.8255C21.3021 20.8657 21.2453 20.908 21.1882 20.9646L21.0792 21.0727C21.0314 21.1202 20.9837 21.1442 20.9239 21.1706C20.9166 21.1738 20.9091 21.1771 20.9014 21.1804C20.8467 21.2042 20.7824 21.2321 20.708 21.281C20.4938 21.3867 20.1763 21.4906 19.9155 21.4906H19.3785C19.2943 21.4638 19.1983 21.4502 19.1075 21.4374L19.1051 21.4371C19.0086 21.4234 18.918 21.4104 18.8413 21.3851L18.8413 21.385L18.838 21.3841C17.3767 21.0083 16.0773 20.3109 14.9395 19.3447C14.8822 19.2611 14.8119 19.1919 14.7378 19.1251C14.7139 19.1036 14.6898 19.0824 14.6656 19.0611C14.6116 19.0138 14.5568 18.9657 14.5012 18.9105L14.5012 18.9105L14.2832 18.6943L14.2832 18.6943L14.2821 18.6932C13.4157 17.8877 12.7658 16.9748 12.2781 15.9543L12.2245 15.795L12.2247 15.7949L12.223 15.7911C12.0616 15.4176 11.9546 14.9919 11.9546 14.5676C11.9546 13.9861 12.1675 13.4032 12.5415 12.9252C12.5974 12.8694 12.6395 12.8138 12.6795 12.7609L12.6802 12.76C12.7197 12.7077 12.7573 12.658 12.8063 12.6086C12.8622 12.5797 12.9171 12.5389 12.9679 12.5011L12.9699 12.4997C13.0253 12.4584 13.076 12.4209 13.1257 12.3962L13.133 12.3926L13.1387 12.3869L13.1792 12.3468C13.2325 12.344 13.2844 12.3311 13.3309 12.3196L13.3336 12.3189C13.3892 12.3051 13.4377 12.2933 13.4851 12.2933H14.0764C14.1534 12.3191 14.2142 12.344 14.2681 12.3796C14.3225 12.4156 14.3719 12.4639 14.4227 12.5389C14.5047 12.7021 14.7073 13.1443 14.8969 13.5808C14.9922 13.8002 15.0839 14.0175 15.1552 14.1968C15.2272 14.3779 15.2763 14.5153 15.2888 14.5775L15.2884 14.5776L15.2904 14.5836C15.3379 14.7247 15.292 14.9224 15.19 15.0764C15.133 15.1341 15.0904 15.2045 15.0514 15.269L15.0499 15.2715C15.0084 15.3401 14.9705 15.4021 14.9211 15.4511C14.8379 15.5337 14.7414 15.6431 14.6663 15.7312C14.6287 15.7753 14.5961 15.8144 14.573 15.8424L14.5459 15.8755L14.5386 15.8845L14.5377 15.8856C14.5003 15.924 14.485 15.9768 14.4778 16.0268C14.4704 16.0776 14.4704 16.1347 14.4704 16.1872V16.1893V16.2012L14.4758 16.2118C14.4954 16.2507 14.5071 16.2811 14.518 16.3093C14.5215 16.3185 14.525 16.3274 14.5286 16.3363C14.5424 16.3706 14.558 16.4029 14.5882 16.4349L14.6393 16.5361L14.6393 16.5361L14.6403 16.538C14.916 17.0304 15.3013 17.4667 15.6841 17.8464C15.7406 17.9024 15.8105 17.9579 15.8776 18.0112L15.879 18.0123C15.9477 18.0668 16.0134 18.119 16.0656 18.1707L16.0981 18.138L16.0656 18.1707C16.5074 18.6089 17.0582 18.9362 17.6606 19.2079L17.6606 19.2079L17.6627 19.2088L17.9262 19.3133C17.9578 19.3424 17.9999 19.3694 18.0404 19.3895C18.0828 19.4105 18.1323 19.4285 18.1716 19.4285H18.2262C18.3492 19.4285 18.475 19.3682 18.5402 19.2447C18.9191 18.8153 19.1222 18.5869 19.2307 18.4659C19.2851 18.4052 19.3156 18.3715 19.3325 18.3532Z"
          fill="white"
          stroke="#ADADAD"
          strokeWidth="0.1"
        />
      </svg>
    </React.Fragment>
  );
};
export const PhoneMob = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="none"
        strokwidth="2"
        viewBox="0 0 20 22"
        height="15px"
        width="15px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <desc></desc>
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"></path>
        <path d="M15 7a2 2 0 0 1 2 2"></path>
        <path d="M15 3a6 6 0 0 1 6 6"></path>
      </svg>
    </React.Fragment>
  );
};
export const Image = (props) => {
  return (
    <React.Fragment>
      <svg
        width="61"
        height="31"
        viewBox="0 0 61 31"
        fill={props.color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="61" height="31" fill="#B9B9B9" />
        <path
          d="M27.6734 13.142C27.6734 13.3315 27.5928 13.5131 27.4495 13.6471C27.3061 13.7811 27.1117 13.8563 26.9089 13.8563C26.7062 13.8563 26.5118 13.7811 26.3684 13.6471C26.2251 13.5131 26.1445 13.3315 26.1445 13.142C26.1445 12.9526 26.2251 12.7709 26.3684 12.6369C26.5118 12.503 26.7062 12.4277 26.9089 12.4277C27.1117 12.4277 27.3061 12.503 27.4495 12.6369C27.5928 12.7709 27.6734 12.9526 27.6734 13.142Z"
          fill="black"
          fillOpacity="0.5"
        />
        <path
          d="M25.951 11C25.5962 11 25.256 11.1505 25.0051 11.4184C24.7542 11.6863 24.6133 12.0497 24.6133 12.4286V19.5714C24.6133 19.9503 24.7542 20.3137 25.0051 20.5816C25.256 20.8495 25.5962 21 25.951 21H33.9773C34.3321 21 34.6724 20.8495 34.9232 20.5816C35.1741 20.3137 35.315 19.9503 35.315 19.5714V12.4286C35.315 12.0497 35.1741 11.6863 34.9232 11.4184C34.6724 11.1505 34.3321 11 33.9773 11H25.951ZM33.9773 11.7143C34.1547 11.7143 34.3248 11.7895 34.4503 11.9235C34.5757 12.0574 34.6462 12.2391 34.6462 12.4286V17.0714L32.1199 15.6807C32.0572 15.6472 31.9861 15.6355 31.9169 15.6474C31.8476 15.6594 31.7836 15.6942 31.734 15.7471L29.2525 18.3971L27.4733 17.1314C27.4091 17.0858 27.332 17.0652 27.2552 17.0733C27.1784 17.0814 27.1066 17.1175 27.0519 17.1757L25.2821 18.8571V12.4286C25.2821 12.2391 25.3526 12.0574 25.478 11.9235C25.6035 11.7895 25.7736 11.7143 25.951 11.7143H33.9773Z"
          fill="black"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};
export const Printmob = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="#fff"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.75 10C19.75 15.3848 15.3848 19.75 10 19.75C4.61522 19.75 0.25 15.3848 0.25 10C0.25 4.61522 4.61522 0.25 10 0.25C15.3848 0.25 19.75 4.61522 19.75 10Z"
          stroke="#1FFC33"
          strokeWidth="0.5"
        />
        <path
          d="M6.25 6.17857C6.25 5.86599 6.36853 5.56622 6.5795 5.3452C6.79048 5.12417 7.07663 5 7.375 5H12.625C12.9234 5 13.2095 5.12417 13.4205 5.3452C13.6315 5.56622 13.75 5.86599 13.75 6.17857V6.57143H14.125C14.6223 6.57143 15.0992 6.77838 15.4508 7.14675C15.8025 7.51513 16 8.01475 16 8.53571V12.4643C16 12.7769 15.8815 13.0766 15.6705 13.2977C15.4595 13.5187 15.1734 13.6429 14.875 13.6429H13.75V14.8214C13.75 15.134 13.6315 15.4338 13.4205 15.6548C13.2095 15.8758 12.9234 16 12.625 16H7.375C7.07663 16 6.79048 15.8758 6.5795 15.6548C6.36853 15.4338 6.25 15.134 6.25 14.8214V13.6429H5.125C4.82663 13.6429 4.54048 13.5187 4.3295 13.2977C4.11853 13.0766 4 12.7769 4 12.4643V8.53571C4 8.01475 4.19754 7.51513 4.54917 7.14675C4.90081 6.77838 5.37772 6.57143 5.875 6.57143H6.25V6.17857ZM7 6.57143H13V6.17857C13 6.07438 12.9605 5.97445 12.8902 5.90078C12.8198 5.8271 12.7245 5.78571 12.625 5.78571H7.375C7.27554 5.78571 7.18016 5.8271 7.10984 5.90078C7.03951 5.97445 7 6.07438 7 6.17857V6.57143ZM6.25 12.8571V11.6786C6.25 11.366 6.36853 11.0662 6.5795 10.8452C6.79048 10.6242 7.07663 10.5 7.375 10.5H12.625C12.9234 10.5 13.2095 10.6242 13.4205 10.8452C13.6315 11.0662 13.75 11.366 13.75 11.6786V12.8571H14.875C14.9745 12.8571 15.0698 12.8158 15.1402 12.7421C15.2105 12.6684 15.25 12.5685 15.25 12.4643V8.53571C15.25 8.22314 15.1315 7.92336 14.9205 7.70234C14.7095 7.48131 14.4234 7.35714 14.125 7.35714H5.875C5.57663 7.35714 5.29048 7.48131 5.0795 7.70234C4.86853 7.92336 4.75 8.22314 4.75 8.53571V12.4643C4.75 12.5685 4.78951 12.6684 4.85984 12.7421C4.93016 12.8158 5.02554 12.8571 5.125 12.8571H6.25ZM7.375 11.2857C7.27554 11.2857 7.18016 11.3271 7.10984 11.4008C7.03951 11.4745 7 11.5744 7 11.6786V14.8214C7 14.9256 7.03951 15.0255 7.10984 15.0992C7.18016 15.1729 7.27554 15.2143 7.375 15.2143H12.625C12.7245 15.2143 12.8198 15.1729 12.8902 15.0992C12.9605 15.0255 13 14.9256 13 14.8214V11.6786C13 11.5744 12.9605 11.4745 12.8902 11.4008C12.8198 11.3271 12.7245 11.2857 12.625 11.2857H7.375Z"
          fill="#000"
        />
      </svg>
    </React.Fragment>
  );
};
export const Printbtn = (props) => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.75 8.75H15.625M4.375 15.625H1.25V5.625H18.75V15.625H15.625H4.375ZM4.375 11.875V18.75H15.625V11.875H4.375ZM15.625 5.625V1.25H4.375V5.625H15.625Z"
          stroke="#1FFC33"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const Close = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        // onClick={props.onClick}
        width="25"
        height="25"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* <circle r="11" transform="matrix(-1 0 0 1 11 11)" fill={mode ? "#646B88" : "#000000"}/> */}
        <path
          d="M15.4001 15.3996L6.6001 6.59961M15.4001 6.59961L6.6001 15.3996"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const Notification = () => {
  return (
    <React.Fragment>
      <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.31181 8.53855C2.31181 12.6812 1.3544 13.9471 0.770604 14.3153C0.28022 14.6375 0 15.1899 0 15.7422C0 16.7089 0.793956 17.4684 1.75137 17.4684H5.83791V17.5144C6.04808 18.9413 7.28571 20 8.73352 20C10.1813 20 11.419 18.9413 11.6291 17.5374V17.4914H15.2486C16.206 17.4914 17 16.7089 17 15.7652C17 15.1899 16.7198 14.6605 16.2294 14.3383C15.6456 13.9471 14.6882 12.6812 14.6882 8.56157C14.6882 4.69505 12.3063 3.15305 10.5549 2.50863C10.5783 2.37054 10.6016 2.20944 10.6016 2.07135C10.6016 0.920598 9.66758 0 8.5 0C7.33242 0 6.39835 0.920598 6.39835 2.07135C6.39835 2.20944 6.4217 2.37054 6.44505 2.50863C4.69368 3.10702 2.31181 4.67204 2.31181 8.53855ZM8.73352 19.0794C7.93956 19.0794 7.23901 18.6191 6.93544 17.9287H10.5549C10.228 18.6191 9.52747 19.0794 8.73352 19.0794ZM8.5 0.897583C9.15385 0.897583 9.66758 1.40391 9.66758 2.04833C9.66758 2.11738 9.66758 2.16341 9.64423 2.23245C8.68681 2.02532 7.79945 2.14039 7.33242 2.23245C7.33242 2.16341 7.30907 2.11738 7.30907 2.04833C7.33242 1.40391 7.84615 0.897583 8.5 0.897583ZM7.26236 3.19908H7.28571C7.28571 3.19908 7.79945 3.03797 8.52335 3.03797C8.89698 3.03797 9.29395 3.084 9.73764 3.22209H9.76099C11.5824 3.72842 13.7775 5.06329 13.7775 8.56157C13.7775 10.748 14.0343 12.4281 14.5481 13.5788H6.16483C5.90797 13.5788 5.6978 13.786 5.6978 14.0391C5.6978 14.2923 5.90797 14.4994 6.16483 14.4994H15.0385H15.0618C15.2486 14.7526 15.4588 14.9367 15.6923 15.0978C15.9258 15.2589 16.0659 15.5121 16.0659 15.7652C16.0659 16.2025 15.6923 16.5708 15.2486 16.5708H1.75137C1.30769 16.5708 0.934066 16.2025 0.934066 15.7652C0.934066 15.4891 1.07418 15.2359 1.30769 15.0978C2.59203 14.2232 3.24588 12.0368 3.24588 8.56157C3.24588 5.04028 5.41758 3.70541 7.26236 3.19908Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const DeleteIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 2.2V0H16.5V2.2H22V4.4H19.8V20.9C19.8 21.1917 19.6841 21.4715 19.4778 21.6778C19.2715 21.8841 18.9917 22 18.7 22H3.3C3.00826 22 2.72847 21.8841 2.52218 21.6778C2.31589 21.4715 2.2 21.1917 2.2 20.9V4.4H0V2.2H5.5ZM4.4 4.4V19.8H17.6V4.4H4.4ZM7.7 7.7H9.9V16.5H7.7V7.7ZM12.1 7.7H14.3V16.5H12.1V7.7Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};
export const Logout = () => {
  return (
    <React.Fragment>
      <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.32432 18.6395H2.7027C1.95946 18.6395 1.35135 18.0272 1.35135 17.2789V2.72109C1.35135 1.97279 1.95946 1.36054 2.7027 1.36054H9.32432C9.69595 1.36054 10 1.05442 10 0.680272C10 0.306122 9.69595 0 9.32432 0H2.7027C1.21622 0 0 1.22449 0 2.72109V17.2789C0 18.7755 1.21622 20 2.7027 20H9.32432C9.69595 20 10 19.6939 10 19.3197C10 18.9456 9.69595 18.6395 9.32432 18.6395Z"
          fill="#3A3A3A"
        />
        <path
          d="M16.9669 10.3801C16.9669 10.3452 16.9669 10.3452 16.9339 10.3103C16.9339 10.2754 16.9339 10.2405 16.9008 10.2405C16.8678 10.2405 16.9008 10.2056 16.8678 10.1707C16.8678 10.1358 16.8678 10.1358 16.8347 10.1358V10.066L12.6033 5.21402C12.3388 4.93477 11.9091 4.93477 11.6446 5.17911C11.3802 5.45836 11.3802 5.87723 11.6116 6.15648L14.8182 9.78672H5.66116C5.29752 9.78672 5 10.1009 5 10.4848C5 10.8688 5.29752 11.183 5.66116 11.183H14.8182L11.6116 14.8132C11.3802 15.0924 11.3802 15.5113 11.6446 15.7906C11.7769 15.9302 11.9421 16 12.1074 16C12.3058 16 12.4711 15.8953 12.6033 15.7557L16.8017 10.9735V10.9037C16.8347 10.9037 16.8347 10.9037 16.8347 10.8688C16.9008 10.8339 16.9008 10.8339 16.9008 10.799C16.9339 10.799 16.9339 10.7641 16.9339 10.7292C16.9669 10.6943 16.9669 10.6943 16.9669 10.6594C16.9669 10.6245 17 10.5546 17 10.5197C17 10.4848 16.9669 10.415 16.9669 10.3801Z"
          fill="#3A3A3A"
        />
      </svg>
    </React.Fragment>
  );
};
export const OrderChecked = () => {
  return (
    <React.Fragment>
      <svg
        width="78"
        height="76"
        viewBox="0 0 78 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M71.2391 7.2359L33.9435 41.6601L20.3975 26.7163C19.0781 25.293 16.8791 25.2041 15.3837 26.4494C13.9763 27.7837 13.8884 30.0075 15.1198 31.5196L31.0408 49.132C31.7445 49.9326 32.7121 50.2884 33.6797 50.2884C34.5593 50.2884 35.3509 50.0215 36.0546 49.3989L75.989 12.484C77.3964 11.1498 77.4844 8.92598 76.2529 7.41381C74.9335 5.99059 72.7345 5.90163 71.2391 7.2359Z"
          fill="#1FFC33"
        />
        <path
          d="M37.7143 75.4286C58.5469 75.4286 75.4286 58.5469 75.4286 37.7143C75.4286 35.9184 75.3388 34.2122 75.0694 32.5061C74.8 30.5306 73.0041 29.1837 71.0286 29.4531C69.0531 29.7224 67.7061 31.5184 67.9755 33.4939C68.1551 34.9306 68.2449 36.3673 68.2449 37.7143C68.2449 54.5061 54.5061 68.2449 37.7143 68.2449C20.9224 68.2449 7.18367 54.5061 7.18367 37.7143C7.18367 20.9224 20.9224 7.18367 37.7143 7.18367C44.898 7.18367 51.902 9.69796 57.3796 14.3673C58.9061 15.6245 61.151 15.4449 62.4082 13.9184C63.6653 12.3918 63.4857 10.1469 61.9592 8.8898C55.2245 3.14286 46.6041 0 37.7143 0C16.8816 0 0 16.8816 0 37.7143C0 58.5469 16.8816 75.4286 37.7143 75.4286Z"
          fill="#1FFC33"
        />
      </svg>
    </React.Fragment>
  );
};

export const DemoImageIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="16"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.81105 3.57056C3.81105 3.81564 3.71369 4.05069 3.54039 4.22398C3.36709 4.39728 3.13205 4.49464 2.88697 4.49464C2.64189 4.49464 2.40684 4.39728 2.23355 4.22398C2.06025 4.05069 1.96289 3.81564 1.96289 3.57056C1.96289 3.32548 2.06025 3.09044 2.23355 2.91714C2.40684 2.74384 2.64189 2.64648 2.88697 2.64648C3.13205 2.64648 3.36709 2.74384 3.54039 2.91714C3.71369 3.09044 3.81105 3.32548 3.81105 3.57056Z"
          fill="black"
          fillOpacity="0.5"
        />
        <path
          d="M1.38584 0.798828C1.04886 0.798828 0.725672 0.937911 0.487387 1.18548C0.249102 1.43305 0.115234 1.76882 0.115234 2.11894V8.71949C0.115234 9.06961 0.249102 9.40538 0.487387 9.65295C0.725672 9.90052 1.04886 10.0396 1.38584 10.0396H9.00948C9.34647 10.0396 9.66965 9.90052 9.90794 9.65295C10.1462 9.40538 10.2801 9.06961 10.2801 8.71949V2.11894C10.2801 1.76882 10.1462 1.43305 9.90794 1.18548C9.66965 0.937911 9.34647 0.798828 9.00948 0.798828H1.38584V0.798828ZM9.00948 1.45888C9.17798 1.45888 9.33957 1.52842 9.45871 1.65221C9.57785 1.77599 9.64479 1.94388 9.64479 2.11894V6.4093L7.24525 5.12417C7.18567 5.09316 7.11821 5.08241 7.05243 5.09342C6.98664 5.10444 6.92586 5.13667 6.87867 5.18556L4.5217 7.63436L2.83179 6.46474C2.77078 6.42254 2.69759 6.40356 2.62464 6.41102C2.5517 6.41848 2.48348 6.45192 2.43155 6.50567L0.750538 8.05944V2.11894C0.750538 1.94388 0.817471 1.77599 0.936614 1.65221C1.05576 1.52842 1.21735 1.45888 1.38584 1.45888H9.00948Z"
          fill="black"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};

// export const Print = () => {
//   return (
//       <React.Fragment>
//           <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M3.375 1.60714C3.375 1.1809 3.55279 0.772119 3.86926 0.470721C4.18572 0.169324 4.61495 0 5.0625 0H12.9375C13.3851 0 13.8143 0.169324 14.1307 0.470721C14.4472 0.772119 14.625 1.1809 14.625 1.60714V2.14286H15.1875C15.9334 2.14286 16.6488 2.42506 17.1762 2.92739C17.7037 3.42972 18 4.11103 18 4.82143V10.1786C18 10.6048 17.8222 11.0136 17.5057 11.315C17.1893 11.6164 16.7601 11.7857 16.3125 11.7857H14.625V13.3929C14.625 13.8191 14.4472 14.2279 14.1307 14.5293C13.8143 14.8307 13.3851 15 12.9375 15H5.0625C4.61495 15 4.18572 14.8307 3.86926 14.5293C3.55279 14.2279 3.375 13.8191 3.375 13.3929V11.7857H1.6875C1.23995 11.7857 0.810725 11.6164 0.494257 11.315C0.17779 11.0136 0 10.6048 0 10.1786V4.82143C0 4.11103 0.296316 3.42972 0.823762 2.92739C1.35121 2.42506 2.06658 2.14286 2.8125 2.14286H3.375V1.60714ZM13.5 1.60714C13.5 1.46506 13.4407 1.3288 13.3352 1.22834C13.2298 1.12787 13.0867 1.07143 12.9375 1.07143H5.0625C4.91332 1.07143 4.77024 1.12787 4.66475 1.22834C4.55926 1.3288 4.5 1.46506 4.5 1.60714V2.14286H13.5V1.60714ZM4.5 9.10714V13.3929C4.5 13.5349 4.55926 13.6712 4.66475 13.7717C4.77024 13.8721 4.91332 13.9286 5.0625 13.9286H12.9375C13.0867 13.9286 13.2298 13.8721 13.3352 13.7717C13.4407 13.6712 13.5 13.5349 13.5 13.3929V9.10714C13.5 8.96506 13.4407 8.8288 13.3352 8.72834C13.2298 8.62787 13.0867 8.57143 12.9375 8.57143H5.0625C4.91332 8.57143 4.77024 8.62787 4.66475 8.72834C4.55926 8.8288 4.5 8.96506 4.5 9.10714Z" fill="black" />
//           </svg>
//       </React.Fragment>
//   )
// }
export const Download = () => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8462 15.75C13.8462 15.5469 13.7776 15.3711 13.6406 15.2227C13.5036 15.0742 13.3413 15 13.1538 15C12.9663 15 12.8041 15.0742 12.6671 15.2227C12.53 15.3711 12.4615 15.5469 12.4615 15.75C12.4615 15.9531 12.53 16.1289 12.6671 16.2773C12.8041 16.4258 12.9663 16.5 13.1538 16.5C13.3413 16.5 13.5036 16.4258 13.6406 16.2773C13.7776 16.1289 13.8462 15.9531 13.8462 15.75ZM16.6154 15.75C16.6154 15.5469 16.5469 15.3711 16.4099 15.2227C16.2728 15.0742 16.1106 15 15.9231 15C15.7356 15 15.5733 15.0742 15.4363 15.2227C15.2993 15.3711 15.2308 15.5469 15.2308 15.75C15.2308 15.9531 15.2993 16.1289 15.4363 16.2773C15.5733 16.4258 15.7356 16.5 15.9231 16.5C16.1106 16.5 16.2728 16.4258 16.4099 16.2773C16.5469 16.1289 16.6154 15.9531 16.6154 15.75ZM18 13.125V16.875C18 17.1875 17.899 17.4531 17.6971 17.6719C17.4952 17.8906 17.25 18 16.9615 18H1.03846C0.75 18 0.504808 17.8906 0.302885 17.6719C0.100962 17.4531 0 17.1875 0 16.875V13.125C0 12.8125 0.100962 12.5469 0.302885 12.3281C0.504808 12.1094 0.75 12 1.03846 12H6.06851L7.52885 13.5938C7.94712 14.0312 8.4375 14.25 9 14.25C9.5625 14.25 10.0529 14.0312 10.4712 13.5938L11.9423 12H16.9615C17.25 12 17.4952 12.1094 17.6971 12.3281C17.899 12.5469 18 12.8125 18 13.125ZM14.4844 6.45703C14.607 6.77734 14.5565 7.05078 14.3329 7.27734L9.48678 12.5273C9.35697 12.6758 9.19471 12.75 9 12.75C8.80529 12.75 8.64303 12.6758 8.51322 12.5273L3.66707 7.27734C3.44351 7.05078 3.39303 6.77734 3.51562 6.45703C3.63822 6.15234 3.85096 6 4.15385 6H6.92308V0.75C6.92308 0.546875 6.99159 0.371094 7.12861 0.222656C7.26562 0.0742188 7.42788 0 7.61539 0H10.3846C10.5721 0 10.7344 0.0742188 10.8714 0.222656C11.0084 0.371094 11.0769 0.546875 11.0769 0.75V6H13.8462C14.149 6 14.3618 6.15234 14.4844 6.45703Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const Email = () => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="15"
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2 0H1.8C0.81 0 0.00899999 0.84375 0.00899999 1.875L0 13.125C0 14.1562 0.81 15 1.8 15H16.2C17.19 15 18 14.1562 18 13.125V1.875C18 0.84375 17.19 0 16.2 0ZM16.2 3.75L9 8.4375L1.8 3.75V1.875L9 6.5625L16.2 1.875V3.75Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const Send = () => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.311392 0.220552C0.44572 0.103856 0.611625 0.0296026 0.78814 0.00717647C0.964655 -0.0152496 1.14386 0.0151582 1.30309 0.0945567L17.5015 8.19424C17.6513 8.26888 17.7772 8.3838 17.8653 8.52608C17.9534 8.66837 18 8.83238 18 8.99971C18 9.16704 17.9534 9.33106 17.8653 9.47334C17.7772 9.61563 17.6513 9.73054 17.5015 9.80518L1.30309 17.9049C1.14387 17.9845 0.964586 18.0152 0.787936 17.9929C0.611285 17.9707 0.445205 17.8965 0.310711 17.7799C0.176217 17.6632 0.0793545 17.5092 0.0323797 17.3375C-0.014595 17.1657 -0.00957043 16.9839 0.0468176 16.815L2.35239 9.89968H7.20022C7.43889 9.89968 7.66778 9.80486 7.83655 9.63608C8.00532 9.46731 8.10013 9.2384 8.10013 8.99971C8.10013 8.76103 8.00532 8.53212 7.83655 8.36334C7.66778 8.19457 7.43889 8.09975 7.20022 8.09975H2.35239L0.0459176 1.18441C-0.01018 1.01559 -0.0149871 0.833929 0.0321034 0.662375C0.0791939 0.490821 0.176069 0.337072 0.310492 0.220552H0.311392Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const InvoiceWhatsapp = () => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 0C4.02975 0 0 4.02975 0 9C0 10.6884 0.474256 12.2626 1.2832 13.6128L0.0805664 18L4.56152 16.8237C5.87202 17.5688 7.38487 18 9 18C13.9703 18 18 13.9703 18 9C18 4.02975 13.9703 0 9 0ZM5.91943 4.80176C6.06568 4.80176 6.21595 4.80087 6.3457 4.80762C6.5062 4.81137 6.68089 4.82312 6.84814 5.19287C7.04689 5.63237 7.47966 6.73493 7.53516 6.84668C7.59066 6.95843 7.62998 7.09008 7.55273 7.23633C7.47923 7.38633 7.44101 7.47711 7.33301 7.60986C7.22126 7.73886 7.09881 7.89908 6.99756 7.99658C6.88581 8.10833 6.77041 8.23086 6.89941 8.45361C7.02841 8.67636 7.47642 9.40659 8.13867 9.99609C8.98992 10.7566 9.70814 10.9903 9.93164 11.1021C10.1551 11.2138 10.2846 11.1964 10.4136 11.0464C10.5463 10.9001 10.9711 10.3983 11.1211 10.1748C11.2673 9.9513 11.4166 9.98998 11.6191 10.0635C11.8246 10.137 12.9205 10.6768 13.144 10.7886C13.3675 10.9003 13.5141 10.9556 13.5703 11.0464C13.6281 11.1401 13.6281 11.5864 13.4429 12.1069C13.2576 12.6267 12.3479 13.1293 11.9399 13.1646C11.5282 13.2028 11.1439 13.3496 9.26367 12.6094C6.99567 11.7161 5.56536 9.39316 5.45361 9.24316C5.34186 9.09691 4.54541 8.03543 4.54541 6.94043C4.54541 5.84168 5.12149 5.30358 5.32324 5.08008C5.52874 4.85658 5.76943 4.80176 5.91943 4.80176Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};

export const InventoryIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="21"
        height="30"
        viewBox="0 0 21 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.006 12.8598H18.1637H17.5304V8.51524C17.5304 8.10975 17.185 7.76219 16.782 7.76219H14.9397H13.0974H11.8596V3.30183C11.8596 2.78049 11.4279 2.34604 10.9097 2.34604H9.1538C9.03866 1.85366 8.60688 1.5061 8.08874 1.5061H7.05246V1.12957C7.05246 0.521341 6.5631 0 5.92982 0C5.29654 0 4.80719 0.492378 4.80719 1.12957V1.5061H3.77091C3.25277 1.5061 2.82098 1.85366 2.70584 2.34604H0.949923C0.431784 2.34604 0 2.78049 0 3.30183V17.378C0 17.8994 0.431784 18.3338 0.949923 18.3338H7.31153C7.34031 18.7104 7.65696 19 8.05995 19H13.558C13.7307 19 13.9034 18.9421 14.0186 18.8262C14.1337 18.9131 14.3064 19 14.4791 19H19.9772C20.3802 19 20.7256 18.6524 20.7256 18.2469V13.6128C20.7544 13.1784 20.409 12.8598 20.006 12.8598ZM16.6093 13.439H17.2425H17.8758V14.8872L17.4153 14.5396C17.3577 14.5107 17.3001 14.4817 17.2425 14.4817C17.185 14.4817 17.1274 14.5107 17.0698 14.5396L16.6093 14.8872V13.439V13.439ZM16.9547 8.48628V12.8308H16.3214H14.4791C14.4216 12.8308 14.3928 12.8308 14.3352 12.8308C14.3064 12.8308 14.3064 12.8308 14.3064 12.8308C14.2776 12.8308 14.2488 12.8598 14.2201 12.8598C14.1913 12.8598 14.1913 12.8598 14.1625 12.8887C14.1337 12.8887 14.1049 12.9177 14.0761 12.9177L14.0473 12.9466C14.0473 12.9466 14.0186 12.9466 14.0186 12.9756C14.0186 12.9756 13.9898 12.9756 13.9898 12.9466L13.961 12.9177C13.9322 12.8887 13.9034 12.8887 13.8746 12.8887C13.8458 12.8887 13.8458 12.8887 13.8171 12.8598C13.7883 12.8598 13.7595 12.8308 13.7307 12.8308H13.7019C13.6443 12.8308 13.6156 12.8308 13.558 12.8308H11.7157H11.0824V8.48628C11.0824 8.39939 11.1688 8.3125 11.2551 8.3125H11.5718H12.8096V10.3399C12.8096 10.4558 12.8671 10.5427 12.9823 10.6006C13.0686 10.6585 13.1838 10.6296 13.2701 10.5716L14.0186 9.99238L14.767 10.5716C14.8246 10.6006 14.8821 10.6296 14.9397 10.6296C14.9973 10.6296 15.0261 10.6296 15.0548 10.6006C15.1412 10.5427 15.2276 10.4558 15.2276 10.3399V8.3125H16.782C16.8971 8.3125 16.9547 8.39939 16.9547 8.48628ZM10.1901 13.439H10.8234H11.4566V14.8872L10.9961 14.5396C10.8809 14.4527 10.7658 14.4527 10.6507 14.5396L10.1901 14.8872V13.439ZM14.6806 8.3125V9.76067L14.2201 9.41311C14.1625 9.38415 14.1049 9.35518 14.0473 9.35518C13.9898 9.35518 13.9322 9.38415 13.8746 9.41311L13.4141 9.78963V8.34146H14.6806V8.3125ZM3.79969 2.08537H5.12383C5.29654 2.08537 5.41168 1.96951 5.41168 1.79573V1.12957C5.41168 0.839939 5.64197 0.579268 5.95861 0.579268C6.27525 0.579268 6.50553 0.810975 6.50553 1.12957V1.79573C6.50553 1.96951 6.62068 2.08537 6.79339 2.08537H8.11752C8.40538 2.08537 8.66445 2.31707 8.66445 2.63567C8.66445 2.9253 8.43417 3.18598 8.11752 3.18598H3.79969C3.51184 3.18598 3.25277 2.95427 3.25277 2.63567C3.25277 2.31707 3.51184 2.08537 3.79969 2.08537ZM0.604497 17.378V3.30183C0.604497 3.09908 0.77721 2.9253 0.978709 2.9253H2.70584C2.70584 2.95427 2.73463 2.98323 2.73463 3.04116C2.73463 3.07012 2.73463 3.07012 2.76341 3.09908C2.7922 3.15701 2.82098 3.21494 2.84977 3.27287C2.84977 3.27287 2.84977 3.30183 2.87855 3.30183C2.90734 3.35976 2.93613 3.38872 2.9937 3.41768C3.02248 3.44665 3.02248 3.44665 3.05127 3.47561C3.08005 3.50457 3.10884 3.53354 3.16641 3.5625C3.1952 3.59146 3.1952 3.59146 3.22398 3.59146C3.25277 3.62043 3.31034 3.62043 3.33912 3.64939C3.36791 3.64939 3.39669 3.67835 3.39669 3.67835C3.42548 3.70732 3.48305 3.70732 3.51184 3.70732C3.54062 3.70732 3.54062 3.70732 3.56941 3.73628C3.62698 3.73628 3.71334 3.76524 3.77091 3.76524H8.08874C8.14631 3.76524 8.23267 3.76524 8.29024 3.73628C8.31902 3.73628 8.31902 3.73628 8.34781 3.70732C8.40538 3.70732 8.43417 3.67835 8.49174 3.67835C8.52052 3.67835 8.54931 3.64939 8.54931 3.64939C8.57809 3.62043 8.63566 3.62043 8.66445 3.59146C8.69324 3.59146 8.69324 3.5625 8.72202 3.5625C8.75081 3.53354 8.77959 3.50457 8.83716 3.47561C8.86595 3.44665 8.86595 3.44665 8.89473 3.41768C8.92352 3.38872 8.98109 3.33079 9.00988 3.27287C9.00988 3.27287 9.00988 3.2439 9.03866 3.2439C9.06745 3.18597 9.09623 3.12805 9.12502 3.07012C9.12502 3.04116 9.12502 3.04116 9.1538 3.01219C9.1538 2.98323 9.18259 2.95427 9.18259 2.89634H10.9097C11.1112 2.89634 11.2839 3.07012 11.2839 3.27287V7.70427H11.2551C10.8522 7.70427 10.5067 8.05183 10.5067 8.45732V12.8018H9.87344H8.03117C7.9736 12.8018 7.91603 12.8018 7.85845 12.8308C7.82967 12.8308 7.82967 12.8308 7.80088 12.8598C7.7721 12.8598 7.71453 12.8887 7.68574 12.8887C7.65696 12.8887 7.65696 12.9177 7.62817 12.9177C7.59939 12.9466 7.5706 12.9466 7.54181 12.9756L7.51303 13.0046H3.62698C3.10884 13.0046 2.67706 13.439 2.67706 13.9604C2.67706 14.4817 3.10884 14.9162 3.62698 14.9162H7.31153V17.6966H0.978709C0.77721 17.7546 0.604497 17.5808 0.604497 17.378ZM7.31153 14.3948H3.62698C3.42548 14.3948 3.25277 14.221 3.25277 14.0183C3.25277 13.8155 3.42548 13.6418 3.62698 13.6418H7.31153V14.3948ZM13.5868 18.4207H8.05995C7.9736 18.4207 7.88724 18.3338 7.88724 18.2469V18.0442V14.6844V13.6128C7.88724 13.5838 7.88724 13.5549 7.91603 13.5259C7.91603 13.5259 7.91603 13.4969 7.94481 13.4969C7.94481 13.4969 7.9736 13.468 8.00238 13.468C8.03117 13.468 8.03117 13.468 8.05995 13.468H9.61437V15.4954C9.61437 15.6113 9.67194 15.6982 9.78709 15.7561C9.81587 15.7851 9.87344 15.7851 9.90223 15.7851C9.9598 15.7851 10.0174 15.7561 10.0749 15.7271L10.8234 15.1479L11.5718 15.7271C11.6581 15.7851 11.7733 15.814 11.8596 15.7561C11.946 15.6982 12.0324 15.6113 12.0324 15.4954V13.468H13.5868C13.6731 13.468 13.7595 13.5549 13.7595 13.6418V18.2759C13.7595 18.3338 13.6731 18.4207 13.5868 18.4207ZM20.1787 18.2469C20.1787 18.3338 20.0923 18.4207 20.006 18.4207H14.5079C14.4216 18.4207 14.3352 18.3338 14.3352 18.2469V13.6128C14.3352 13.5259 14.4216 13.439 14.5079 13.439H16.0623V15.4665C16.0623 15.5823 16.1199 15.6692 16.235 15.7271C16.2638 15.7561 16.3214 15.7561 16.3502 15.7561C16.4078 15.7561 16.4653 15.7271 16.5229 15.6982L17.2713 15.1189L18.0198 15.6982C18.1061 15.7561 18.2213 15.7851 18.3076 15.7271C18.394 15.6692 18.4803 15.5823 18.4803 15.4665V13.439H20.0347C20.1211 13.439 20.2075 13.5259 20.2075 13.6128V18.2469H20.1787Z"
          fill={props.color}
        />
        <path
          d="M3.5524 7.77248H8.2485C8.77353 7.77248 9.21106 7.31449 9.21106 6.7649C9.21106 6.21531 8.77353 5.75732 8.2485 5.75732H3.5524C3.02737 5.75732 2.58984 6.21531 2.58984 6.7649C2.58984 7.31449 3.02737 7.77248 3.5524 7.77248ZM3.5524 6.36798H8.2485C8.45268 6.36798 8.62769 6.55117 8.62769 6.7649C8.62769 6.97863 8.45268 7.16182 8.2485 7.16182H3.5524C3.34822 7.16182 3.17321 6.97863 3.17321 6.7649C3.17321 6.55117 3.34822 6.36798 3.5524 6.36798Z"
          fill={props.color}
        />
        <path
          d="M3.5524 11.5152H8.2485C8.77353 11.5152 9.21106 11.0572 9.21106 10.5076C9.21106 9.95799 8.77353 9.5 8.2485 9.5H3.5524C3.02737 9.5 2.58984 9.95799 2.58984 10.5076C2.58984 11.0572 3.02737 11.5152 3.5524 11.5152ZM3.5524 10.1107H8.2485C8.45268 10.1107 8.62769 10.2938 8.62769 10.5076C8.62769 10.7213 8.45268 10.9045 8.2485 10.9045H3.5524C3.34822 10.9045 3.17321 10.7213 3.17321 10.5076C3.17321 10.2938 3.34822 10.1107 3.5524 10.1107Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};

export const LargeEyeIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="24"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9603 7.26818C19.1762 5.19385 17.8149 3.39997 16.0447 2.10824C14.2745 0.816515 12.1731 0.0835725 10 0C7.82695 0.0835725 5.72547 0.816515 3.9553 2.10824C2.18512 3.39997 0.823847 5.19385 0.0397175 7.26818C-0.0132392 7.41798 -0.0132392 7.58202 0.0397175 7.73182C0.823847 9.80615 2.18512 11.6 3.9553 12.8918C5.72547 14.1835 7.82695 14.9164 10 15C12.1731 14.9164 14.2745 14.1835 16.0447 12.8918C17.8149 11.6 19.1762 9.80615 19.9603 7.73182C20.0132 7.58202 20.0132 7.41798 19.9603 7.26818ZM10 13.6364C6.46657 13.6364 2.73313 10.9568 1.37976 7.5C2.73313 4.04318 6.46657 1.36364 10 1.36364C13.5334 1.36364 17.2669 4.04318 18.6202 7.5C17.2669 10.9568 13.5334 13.6364 10 13.6364Z"
          fill={props.color}
        />
        <path
          d="M10 3C9.20888 3 8.43552 3.2346 7.77772 3.67412C7.11992 4.11365 6.60723 4.73836 6.30448 5.46927C6.00173 6.20017 5.92252 7.00444 6.07686 7.78036C6.2312 8.55628 6.61216 9.26902 7.17157 9.82843C7.73098 10.3878 8.44372 10.7688 9.21964 10.9231C9.99556 11.0775 10.7998 10.9983 11.5307 10.6955C12.2616 10.3928 12.8864 9.88008 13.3259 9.22228C13.7654 8.56448 14 7.79112 14 7C14 5.93913 13.5786 4.92172 12.8284 4.17157C12.0783 3.42143 11.0609 3 10 3ZM10 9.66667C9.47258 9.66667 8.95701 9.51027 8.51848 9.21725C8.07995 8.92423 7.73816 8.50776 7.53632 8.02049C7.33449 7.53322 7.28168 6.99704 7.38457 6.47976C7.48747 5.96248 7.74144 5.48732 8.11438 5.11438C8.48732 4.74144 8.96248 4.48747 9.47976 4.38457C9.99704 4.28168 10.5332 4.33449 11.0205 4.53632C11.5078 4.73815 11.9242 5.07995 12.2173 5.51848C12.5103 5.95701 12.6667 6.47258 12.6667 7C12.6667 7.70724 12.3857 8.38552 11.8856 8.88562C11.3855 9.38571 10.7072 9.66667 10 9.66667Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const AddDealerIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="19"
        height="15"
        viewBox="0 0 19 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 7.99632C13.2439 7.99632 15 6.24103 15 3.99816C15 1.75529 13.2439 0 11 0C8.7561 0 7 1.75529 7 3.99816C7 6.24103 8.7561 8.09383 11 7.99632ZM11 1.46274C12.3659 1.46274 13.5366 2.63293 13.5366 3.99816C13.5366 5.36338 12.3659 6.53358 11 6.53358C9.63415 6.53358 8.46341 5.36338 8.46341 3.99816C8.46341 2.63293 9.53658 1.46274 11 1.46274Z"
          fill="white"
        />
        <path
          d="M11.451 9C7.33333 9 4 12.2381 4 16.2381C4 16.619 4.29412 17 4.78431 17C5.17647 17 5.56863 16.7143 5.56863 16.2381C5.66667 13.0952 8.5098 10.619 11.7451 10.7143C14.8824 10.8095 17.3333 13.2857 17.4314 16.2381C17.4314 16.619 17.7255 17 18.2157 17C18.7059 17 19 16.7143 19 16.2381C18.8039 12.2381 15.5686 9 11.451 9Z"
          fill="white"
        />
        <path
          d="M5.14286 8.18182C5.57143 8.18182 6 7.90909 6 7.54545C6 7.18182 5.67857 6.81818 5.14286 6.81818H3.75V5.72727C3.75 5.36364 3.42857 5 2.89286 5C2.46429 5 2.03571 5.27273 2.03571 5.72727V6.81818H0.857143C0.428572 6.81818 0 7.09091 0 7.54545C0 8 0.321429 8.18182 0.857143 8.18182H2.14286V9.27273C2.14286 9.63636 2.46429 10 3 10C3.53571 10 3.85714 9.72727 3.85714 9.27273V8.18182H5.14286Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const PackingOrderIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="32"
        viewBox="0 0 24 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.2381 0H0.761905C0.342857 0 0 0.342857 0 0.761905V30.6667C0 30.9333 0.152381 31.2 0.380952 31.3524C0.609524 31.4667 0.914286 31.4667 1.14286 31.3143L6.05714 28.1524L11.3905 30.2476C11.581 30.3238 11.7714 30.3238 11.9619 30.2476L15.7333 28.6857L22.9333 31.9238C23.0476 31.9619 23.1238 32 23.2381 32C23.3905 32 23.5429 31.9619 23.6571 31.8857C23.8857 31.7333 24 31.5048 24 31.2381V0.761905C24 0.342857 23.6952 0 23.2381 0ZM22.4762 30.0571L16.0381 27.1619C15.9238 27.1238 15.8476 27.0857 15.7333 27.0857C15.619 27.0857 15.5429 27.0857 15.4286 27.1619L11.619 28.7238L6.20952 26.5905C5.98095 26.5143 5.71429 26.5143 5.52381 26.6667L1.48571 29.2952V1.52381H22.4762V30.0571V30.0571ZM5.10476 4.7619C5.10476 4.34286 5.44762 4 5.86667 4H18.1333C18.5524 4 18.8952 4.34286 18.8952 4.7619C18.8952 5.18095 18.5524 5.52381 18.1333 5.52381H5.86667C5.44762 5.52381 5.10476 5.18095 5.10476 4.7619ZM5.10476 10.1333C5.10476 9.71429 5.44762 9.37143 5.86667 9.37143H18.1333C18.5524 9.37143 18.8952 9.71429 18.8952 10.1333C18.8952 10.5524 18.5524 10.8952 18.1333 10.8952H5.86667C5.44762 10.8952 5.10476 10.5524 5.10476 10.1333ZM5.10476 15.5048C5.10476 15.0857 5.44762 14.7429 5.86667 14.7429H18.1333C18.5524 14.7429 18.8952 15.0857 18.8952 15.5048C18.8952 15.9238 18.5524 16.2667 18.1333 16.2667H5.86667C5.44762 16.2667 5.10476 15.9238 5.10476 15.5048ZM12.381 22.8571C12.381 23.2762 12.0381 23.619 11.619 23.619H5.90476C5.48571 23.619 5.14286 23.2762 5.14286 22.8571C5.14286 22.4381 5.48571 22.0952 5.90476 22.0952H11.619C12.0381 22.0952 12.381 22.4381 12.381 22.8571Z"
          fill="#3A3A3A"
        />
      </svg>
    </React.Fragment>
  );
};

export const DispatchIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="15"
        className={props.css}
        height="19"
        viewBox="0 0 15 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.4422 5.17203C9.3759 5.17203 9.30901 5.16508 9.24241 5.15089C7.99901 4.87777 6.68961 4.87707 5.34911 5.1488C4.93367 5.23058 4.50561 5.02671 4.32928 4.66388L3.91061 3.80627C3.87628 3.7359 3.87364 3.65524 3.90328 3.58293C3.9332 3.51061 3.99276 3.45304 4.06845 3.42342C6.25627 2.56733 8.4746 2.56705 10.663 3.42342C10.7437 3.45499 10.8059 3.5184 10.8335 3.59697C10.861 3.67568 10.8511 3.76163 10.8062 3.83283L10.227 4.75149C10.056 5.01683 9.75643 5.17203 9.4422 5.17203ZM7.32774 4.37574C8.02454 4.37574 8.70902 4.44903 9.37619 4.5956C9.50528 4.62328 9.64142 4.56751 9.71271 4.45681L10.1082 3.82949C8.2748 3.18896 6.42145 3.19327 4.58981 3.84117L4.87469 4.42511C4.93543 4.54971 5.08241 4.61897 5.225 4.59143C5.93472 4.44764 6.63739 4.37574 7.32774 4.37574Z"
          fill={props.color}
        />
        <path
          d="M5.99574 15.0175C5.94264 15.0175 5.88954 15.0042 5.8423 14.9775C5.75106 14.9262 5.69531 14.8331 5.69531 14.7327V11.5211C5.69531 11.3639 5.82969 11.2363 5.99574 11.2363H8.73103C8.89709 11.2363 9.03146 11.3639 9.03146 11.5211V14.7327C9.03146 14.8314 8.97748 14.9232 8.88887 14.9751C8.80027 15.0268 8.68966 15.0314 8.59636 14.9873L7.31424 14.3778L6.13921 14.983C6.09432 15.006 6.04503 15.0175 5.99574 15.0175ZM7.30867 13.7718C7.35473 13.7718 7.40079 13.7818 7.44334 13.8019L8.4306 14.2713V11.8059H6.29618V14.2539L7.1652 13.8063C7.2098 13.7833 7.25938 13.7718 7.30867 13.7718Z"
          fill={props.color}
        />
        <path
          d="M11.283 18.2252H3.44502C2.95828 18.2252 2.5625 17.8499 2.5625 17.3886V12.069C2.5625 11.6078 2.95828 11.2324 3.44502 11.2324H11.283C11.7697 11.2324 12.1655 11.6078 12.1655 12.069V17.3886C12.1655 17.8499 11.7697 18.2252 11.283 18.2252ZM3.44502 11.802C3.28982 11.802 3.16336 11.9218 3.16336 12.069V17.3886C3.16336 17.5358 3.28982 17.6556 3.44502 17.6556H11.283C11.4382 17.6556 11.5646 17.5358 11.5646 17.3886V12.069C11.5646 11.9218 11.4382 11.802 11.283 11.802H3.44502Z"
          fill={props.color}
        />
        <path
          d="M7.66807 11.8041H7.08012C6.98007 11.8041 6.88648 11.7569 6.83074 11.678L5.00027 9.09279C4.96682 9.04592 4.94922 8.99071 4.94922 8.93411V7.65388C4.94922 7.53859 5.02257 7.43457 5.13494 7.39063C5.24789 7.34682 5.37698 7.37116 5.46265 7.45307C5.99574 7.96121 6.67465 8.24101 7.3741 8.24101C8.07559 8.24101 8.75567 7.96121 9.28877 7.45307C9.37473 7.37116 9.50382 7.34682 9.61648 7.39063C9.72885 7.43457 9.8022 7.53859 9.8022 7.65388V8.93411C9.8022 8.99085 9.7843 9.04634 9.75086 9.09334L7.91746 11.6783C7.86171 11.757 7.76812 11.8041 7.66807 11.8041ZM7.24031 11.2345H7.50818L9.20134 8.84706V8.26159C8.65328 8.61885 8.02249 8.81062 7.3741 8.81062C6.72717 8.81062 6.09755 8.61885 5.55008 8.26173V8.84734L7.24031 11.2345Z"
          fill={props.color}
        />
        <path
          d="M5.24083 7.93922C5.16337 7.93922 5.08592 7.91099 5.02724 7.85467C4.49855 7.34791 4.11743 6.67706 3.94228 5.95128C3.4573 5.75631 3.13281 5.28641 3.13281 4.74906C3.13281 4.13661 3.55266 3.61637 4.15411 3.48384C4.31489 3.4488 4.47713 3.54364 4.51468 3.69675C4.55224 3.85 4.4519 4.00311 4.29024 4.03871C3.9678 4.10977 3.73368 4.40849 3.73368 4.74906C3.73368 5.09074 3.95607 5.38222 4.27469 5.45774C4.38853 5.48485 4.47566 5.57246 4.49708 5.68205C4.62969 6.35999 4.96973 6.9894 5.45442 7.45416C5.57119 7.56597 5.57001 7.74634 5.45207 7.85689C5.39339 7.91182 5.31711 7.93922 5.24083 7.93922Z"
          fill={props.color}
        />
        <path
          d="M9.49184 7.9364C9.41526 7.9364 9.33869 7.90886 9.28001 7.85352C9.16236 7.74268 9.16177 7.56231 9.27884 7.45078C9.76645 6.98602 10.0971 6.37302 10.2356 5.67839C10.257 5.56978 10.3433 5.48287 10.4559 5.45533C10.7754 5.37759 10.9987 5.08597 10.9987 4.74624C10.9987 4.40274 10.7619 4.10292 10.436 4.03353C10.274 3.99918 10.1722 3.84676 10.2086 3.69323C10.245 3.53984 10.406 3.44291 10.5674 3.47782C11.1656 3.60507 11.5996 4.13852 11.5996 4.74624C11.5996 5.28094 11.2751 5.75085 10.7901 5.94762C10.6117 6.68787 10.2385 7.34356 9.70484 7.8524C9.64616 7.90845 9.569 7.9364 9.49184 7.9364Z"
          fill={props.color}
        />
        <path
          d="M10.5484 3.97157C10.5096 3.97157 10.4706 3.96448 10.4336 3.95002C8.39781 3.15303 6.33321 3.15303 4.29796 3.95002C4.20496 3.98645 4.09934 3.9763 4.01631 3.92345C3.93298 3.87061 3.88281 3.78189 3.88281 3.68676V2.42308C3.88281 1.08694 5.02821 0 6.4359 0H8.29571C9.7034 0 10.8488 1.08694 10.8488 2.42308V3.68676C10.8488 3.78189 10.7986 3.87061 10.7153 3.92345C10.6651 3.9553 10.607 3.97157 10.5484 3.97157ZM7.36595 2.78131C8.32827 2.78131 9.2906 2.94457 10.2479 3.27138V2.42308C10.2479 1.40108 9.37216 0.569612 8.29571 0.569612H6.4359C5.35945 0.569612 4.48368 1.40108 4.48368 2.42308V3.27138C5.44101 2.94457 6.40334 2.78131 7.36595 2.78131Z"
          fill={props.color}
        />
        <path
          d="M0.300432 15.3654C0.134373 15.3654 0 15.2379 0 15.0806V13.2738C0 12.1152 0.67656 11.0661 1.76533 10.5357L5.1895 8.80684C5.3359 8.733 5.51781 8.7857 5.59585 8.92435C5.67389 9.06328 5.61844 9.23572 5.47174 9.3097L2.04376 11.0405C1.15215 11.4747 0.600865 12.3296 0.600865 13.2738V15.0806C0.600865 15.2379 0.466487 15.3654 0.300432 15.3654Z"
          fill={props.color}
        />
        <path
          d="M14.4283 15.3678C14.2622 15.3678 14.1279 15.2403 14.1279 15.083V13.2393C14.1279 12.3157 13.5951 11.4694 12.7372 11.0306L9.25932 9.31318C9.11204 9.24058 9.05512 9.06856 9.1317 8.92908C9.20768 8.78945 9.38929 8.73452 9.53687 8.80809L13.0185 10.5275C14.075 11.0676 14.7287 12.106 14.7287 13.2393V15.083C14.7287 15.2403 14.5943 15.3678 14.4283 15.3678Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const PackersIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="16"
        className={props.css + " mb-1"}
        height="24"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.153527 14.9415L7.81686 19.9409C7.83117 19.9436 7.84587 19.9436 7.86018 19.9409H7.88683C7.9191 19.9692 7.95812 19.9887 8.00012 19.9976C8.03002 20.0008 8.06018 20.0008 8.09008 19.9976H8.11673H8.16005L15.4902 14.9982C15.5492 14.9665 15.5973 14.9178 15.6282 14.8583C15.6591 14.7988 15.6714 14.7314 15.6635 14.6649V6.74254C15.6677 6.71717 15.6677 6.69126 15.6635 6.66588C15.6654 6.65823 15.6654 6.65021 15.6635 6.64255C15.6566 6.62278 15.6477 6.60379 15.6368 6.58589C15.6378 6.57704 15.6378 6.56809 15.6368 6.55923L15.6035 6.51924L15.5768 6.49591L15.5568 6.47591L11.1321 3.44295L11.5619 2.77636L12.145 3.05299C12.2655 3.11129 12.3976 3.14203 12.5315 3.14298C12.8301 3.11502 13.1058 2.97074 13.299 2.74129C13.4922 2.51183 13.5875 2.21559 13.5644 1.91647C13.5648 1.83273 13.5581 1.7491 13.5444 1.6665C13.5031 1.37217 13.3504 1.10493 13.1179 0.919923C13.0673 0.879741 13.0126 0.845103 12.9546 0.816602C12.8782 0.778827 12.7977 0.74976 12.7147 0.729946L10.9055 0.023366C10.8676 0.00734372 10.8267 -0.000601746 10.7856 3.55128e-05C10.5348 0.0103399 10.2938 0.0997078 10.0969 0.255354C9.89999 0.411 9.75736 0.62495 9.68938 0.866596L8.99968 1.96313L8.26334 1.46652C8.20858 1.42998 8.14424 1.41048 8.07842 1.41048C8.0126 1.41048 7.94825 1.42998 7.8935 1.46652L0.156859 6.46591L0.126872 6.48924L0.100217 6.50924L0.0668982 6.55257C0.0601675 6.56066 0.0545634 6.56963 0.0502387 6.57923C0.0380513 6.59638 0.0290245 6.61556 0.0235836 6.63589C0.0184291 6.63931 0.0140071 6.64373 0.010575 6.64888C0.00714283 6.65403 0.00476923 6.65981 0.00359233 6.66588C-0.00119744 6.69345 -0.00119744 6.72164 0.00359233 6.74921V14.6649C0.00387625 14.7198 0.0177113 14.7738 0.043868 14.822C0.0700248 14.8703 0.107693 14.9113 0.153527 14.9415ZM3.36546 9.22224L4.33504 9.88882V12.7418L3.33548 12.1452L3.36546 9.22224ZM0.669969 7.3758L2.70242 8.76896L2.6691 12.3319C2.66853 12.3903 2.68331 12.4478 2.71196 12.4987C2.74062 12.5496 2.78214 12.592 2.83236 12.6218L4.4983 13.6217C4.55006 13.6511 4.60874 13.666 4.66823 13.665C4.72547 13.6649 4.7817 13.6499 4.83149 13.6217C4.88296 13.5928 4.92582 13.5507 4.95567 13.4997C4.98553 13.4488 5.00132 13.3908 5.00142 13.3317V10.3321L7.66693 12.1619V19.0477L0.669969 14.4816V7.3758ZM8.33331 19.041V12.1685L11.2354 10.0888L14.9971 7.38913V14.4849L8.33331 19.041ZM14.7505 6.74587L8.00012 11.5919L5.208 9.66552L8.87307 6.91919C8.90551 6.89623 8.93275 6.86671 8.95304 6.83253L10.7722 3.99955L14.7505 6.74587ZM12.5348 2.4764C12.3616 2.4764 12.1683 2.23643 12.1683 1.91647C12.1683 1.59651 12.3349 1.3832 12.5348 1.3832H12.5948C12.6179 1.39116 12.6402 1.4012 12.6614 1.4132C12.6823 1.42345 12.7014 1.43695 12.7181 1.45319C12.7322 1.46568 12.7456 1.47903 12.758 1.49319C12.787 1.52782 12.8116 1.56588 12.8313 1.60651V1.6265C12.8487 1.66621 12.862 1.70751 12.8713 1.74982C12.8823 1.80244 12.8879 1.85605 12.888 1.9098C12.898 2.23643 12.7047 2.4764 12.5348 2.4764ZM10.2791 1.17989C10.3043 1.14483 10.3224 1.10521 10.3324 1.06324C10.3564 0.966302 10.4068 0.877912 10.4779 0.807894C10.5491 0.737876 10.6383 0.688973 10.7356 0.66662L11.7885 1.07657C11.6734 1.21773 11.5915 1.38286 11.5486 1.55984L8.41993 6.43591L4.62825 9.2789L3.5987 8.57565L7.19713 5.93597C7.22993 5.91106 7.25812 5.88061 7.28043 5.84599L10.2791 1.17989ZM8.07009 2.13977L8.62318 2.52306L6.75399 5.4327L3.00229 8.1757L0.93652 6.74921L8.07009 2.13977Z"
          fill={props.color}
        />
        <path
          d="M11.82 11.0326C11.767 11.0072 11.7083 10.9964 11.6497 11.0011C11.5912 11.0057 11.535 11.0258 11.4867 11.0593L9.15333 12.7274C9.10778 12.7566 9.07002 12.7965 9.04331 12.8436C9.0166 12.8906 9.00173 12.9435 9 12.9976V15.333C8.99987 15.3943 9.0166 15.4544 9.04835 15.5068C9.0801 15.5591 9.12565 15.6018 9.18 15.6299C9.22774 15.6535 9.28013 15.666 9.33333 15.6666C9.40303 15.6676 9.47106 15.6453 9.52667 15.6032L11.86 13.9351C11.9031 13.9044 11.9382 13.8639 11.9626 13.8169C11.9869 13.7699 11.9998 13.7178 12 13.6649V11.3295C12.0001 11.2682 11.9834 11.2081 11.9516 11.1558C11.9199 11.1034 11.8743 11.0608 11.82 11.0326ZM11.3333 13.4947L9.66667 14.6858V13.1678L11.3333 11.9767V13.4947Z"
          fill={props.color}
        />
        <path
          d="M5.03614 14.7782L4.66797 15.334L6.61283 16.6232L6.98101 16.0674L5.03614 14.7782Z"
          fill={props.color}
        />
        <path
          d="M5.03614 16.1122L4.66797 16.668L6.61283 17.9571L6.98101 17.4014L5.03614 16.1122Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};

export const PackingWhatsappIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4288_8427)">
          <path
            d="M6.19803 22.6762L6.62948 22.8913C8.42743 23.9667 10.4409 24.4685 12.4546 24.4685C18.7829 24.4685 23.9607 19.3068 23.9607 12.9979C23.9607 9.98694 22.7381 7.04758 20.5808 4.89681C18.4234 2.74605 15.5467 1.52734 12.4546 1.52734C6.12618 1.52734 0.948313 6.6891 1.02027 13.0697C1.02027 15.2203 1.66749 17.2995 2.74616 19.0917L3.03379 19.5219L1.88327 23.7517L6.19803 22.6762Z"
            fill="#00E676"
          />
          <path
            d="M22.2452 3.79459C19.8365 1.33518 16.5068 0 13.1062 0C5.88017 0 0.0708895 5.83241 0.141677 12.9297C0.141677 15.1784 0.779277 17.3568 1.84201 19.3243L0 26L6.87192 24.2432C8.78471 25.2974 10.91 25.7893 13.0354 25.7893C20.1907 25.7893 26 19.9567 26 12.8596C26 9.41626 24.6539 6.18378 22.2453 3.79459H22.2452ZM13.1062 23.6109C11.1934 23.6109 9.28064 23.1191 7.65119 22.1353L7.22616 21.9245L3.11721 22.9785L4.17984 18.9731L3.89649 18.5515C0.779277 13.5623 2.26704 6.95674 7.36784 3.8648C12.4686 0.772961 19.0572 2.24867 22.1744 7.30812C25.2915 12.3676 23.8037 18.9027 18.7031 21.9947C17.0735 23.0487 15.0899 23.6108 13.1062 23.6108V23.6109ZM19.3405 15.811L18.5613 15.4596C18.5613 15.4596 17.4279 14.9677 16.7194 14.6163C16.6485 14.6163 16.5777 14.546 16.5068 14.546C16.2942 14.546 16.1526 14.6163 16.0109 14.6867C16.0109 14.6867 15.9401 14.7569 14.9482 15.8812C14.8774 16.0217 14.7357 16.092 14.594 16.092H14.5231C14.4523 16.092 14.3106 16.0217 14.2398 15.9515L13.8855 15.811C13.1062 15.4596 12.3978 15.0379 11.831 14.4758C11.6894 14.3353 11.4768 14.1947 11.3351 14.0542C10.8392 13.5623 10.3433 13.0001 9.98913 12.3677L9.91824 12.2271C9.84745 12.1568 9.84745 12.0866 9.77656 11.9461C9.77656 11.8056 9.77656 11.665 9.84745 11.5947C9.84745 11.5947 10.1308 11.2433 10.3433 11.0326C10.485 10.892 10.5558 10.6812 10.6975 10.5407C10.8392 10.3298 10.9101 10.0488 10.8392 9.83794C10.7684 9.48657 9.91824 7.58928 9.70577 7.16769C9.56399 6.95685 9.42241 6.88663 9.20985 6.81632H8.43057C8.28879 6.81632 8.14722 6.88663 8.00544 6.88663L7.93455 6.95684C7.79287 7.02716 7.65119 7.16769 7.50952 7.2379C7.36784 7.37853 7.29695 7.51896 7.15527 7.65959C6.65935 8.29202 6.37599 9.06498 6.37599 9.83794C6.37599 10.4001 6.51767 10.9623 6.73024 11.4542L6.80113 11.665C7.43873 13.0001 8.28879 14.1947 9.42242 15.2488L9.70577 15.5298C9.91824 15.7407 10.1308 15.8812 10.2725 16.0919C11.7602 17.3569 13.4605 18.2704 15.3733 18.7623C15.5858 18.8325 15.8692 18.8325 16.0818 18.9028H16.7902C17.1444 18.9028 17.5694 18.7623 17.8529 18.6218C18.0654 18.4812 18.207 18.4812 18.3487 18.3407L18.4905 18.2001C18.6322 18.0596 18.7738 17.9893 18.9155 17.8488C19.0572 17.7083 19.1989 17.5677 19.2698 17.4271C19.4114 17.1461 19.4822 16.7947 19.5531 16.4434V15.9515C19.5531 15.9515 19.4822 15.8812 19.3405 15.811Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_4288_8427">
            <rect width="26" height="26" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const PickUpIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 480 480"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <g>
            <path
              style={{ fill: "#4E4E4F" }}
              d="M250,68.5c-50.3,0-91.2,40.9-91.2,91.2c0,5,0.4,10,1.2,14.9l0,0.1c5.3,44.6,27,81.6,51.4,110.1
			c11.2,13.1,23,24.5,34,33.9c2.7,2.3,6.5,2.3,9.2,0c11.1-9.4,23.1-20.7,34.5-33.9c24.4-28.2,46-65,50.9-109.2
			c0.2-1.4,0.3-2.8,0.4-4l0-0.1c0.5-3.9,0.8-7.9,0.8-11.8C341.2,109.4,300.3,68.5,250,68.5z M250,228.4c-38.2,0-69.3-31.1-69.3-69.2
			c0-38.2,31.1-69.2,69.3-69.2c38.2,0,69.2,31.1,69.2,69.2C319.2,197.3,288.2,228.4,250,228.4z"
            />
          </g>
          <g>
            <g>
              <path
                style={{ fill: "#4D4E4E" }}
                d="M250,155.1c-0.3,0-0.5-0.1-0.8-0.2l-42.8-18.2c-0.8-0.3-1.3-1.1-1.3-1.9c0-0.8,0.5-1.6,1.3-1.9l42.7-17.3
				c0.5-0.2,1.1-0.2,1.6,0l42.8,18.5c0.8,0.3,1.3,1.1,1.2,1.9c0,0.8-0.5,1.6-1.3,1.9l-42.8,17C250.5,155,250.3,155.1,250,155.1z
				 M212.6,134.9l37.4,15.9l37.4-14.8l-37.5-16.2L212.6,134.9z"
              />
            </g>
            <g>
              <path
                style={{ fill: "#4D4E4E" }}
                d="M250,202.7c-0.4,0-0.8-0.1-1.1-0.3c-0.6-0.4-0.9-1-0.9-1.7V153c0-0.8,0.5-1.6,1.3-1.9l42.8-17
				c0.6-0.3,1.3-0.2,1.9,0.2c0.6,0.4,0.9,1,0.9,1.7v46.7c0,0.8-0.5,1.6-1.3,1.9l-42.8,17.9C250.5,202.6,250.3,202.7,250,202.7z
				 M252.1,154.4v43.1l38.7-16.2v-42.3L252.1,154.4z"
              />
            </g>
            <g>
              <g>
                <polygon
                  style={{ fill: "#4D4E4E" }}
                  points="250,153 207.2,134.8 207.2,183.2 250,200.6 				"
                />
              </g>
              <g>
                <path
                  style={{ fill: "#4D4E4E" }}
                  d="M250,202.7c-0.3,0-0.5-0.1-0.8-0.2l-42.8-17.5c-0.8-0.3-1.3-1.1-1.3-1.9v-48.3c0-0.7,0.3-1.3,0.9-1.7
					c0.6-0.4,1.3-0.4,1.9-0.2l42.8,18.2c0.8,0.3,1.3,1.1,1.3,1.9v47.6c0,0.7-0.3,1.3-0.9,1.7C250.8,202.6,250.4,202.7,250,202.7z
					 M209.3,181.8l38.7,15.8v-43.2L209.3,138V181.8z"
                />
              </g>
            </g>
            <g>
              <polygon
                style={{ fill: "#4D4E4E" }}
                points="235.2,123.5 276.9,140.7 276.9,164.7 266.9,168.4 266.9,146.6 223.2,128.4 			"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                style={{ fill: "#4E4E4F" }}
                points="125.8,431.5 483.9,431.5 456.3,386.4 140.5,386.4 			"
              />
            </g>
            <g>
              <polygon
                style={{ fill: "#4E4E4F" }}
                points="16.1,431.5 94.9,431.5 113.2,386.4 43.7,386.4 			"
              />
            </g>
            <g>
              <polygon
                style={{ fill: "#4E4E4F" }}
                points="54,369.7 138.9,369.7 172.4,284.8 106,284.8 			"
              />
            </g>
            <g>
              <path
                style={{ fill: "#4E4E4F" }}
                d="M332.8,369.7H153.1l28.9-84.9h20.8c12.5,15.3,25.9,28.3,38.3,38.9c2.6,2.2,5.7,3.3,8.9,3.3
				c3.1, 0, 6.3-1.1, 8.8-3.2c12.6-10.6, 26.2-23.6, 38.9-38.9h16.4L332.8, 369.7z"
              />
            </g>
            <g>
              <polygon
                style={{ fill: "#4E4E4F" }}
                points="347.1,369.7 446,369.7 394,284.8 323,284.8 			"
              />
            </g>
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const CourierAirIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 480 480"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <path
            className="st0"
            d="M172.5,239.5l-48,22.8v-59.9l48.3,33.6C174,236.9,173.9,238.8,172.5,239.5z"
          />
          <path
            className="st0"
            d="M341.6,76.8v59.8c0,2.2-1.3,4.2-3.4,5c-2,0.8-4.3,0.3-5.8-1.3l-14.4-15l-16.7,17.4c-1,1-2.4,1.6-3.8,1.6
		c-1.4,0-2.8-0.6-3.8-1.6L277,125.3l-14.4,15c-1.5,1.6-3.8,2.1-5.8,1.3c-2-0.8-3.3-2.8-3.3-5V76.8H124.4v106l13.9-5.3
		c1.7-0.7,3.6-0.7,5.3-0.1l92,31.5c2.7,0.9,5.6,0.8,8.2-0.3l68.4-28.3c13.2-5.4,27.5-7.5,41.7-6l33.6,3.5c11.7,1.2,14.6,17,4.1,22.3
		l-95.1,48c-1.9,1-3.4,2.5-4.3,4.5l-60.9,132.7c-1.6,3.5-4.6,6.2-8.3,7.5l-20.9,7.1c-1.9,0.6-3.9-1-3.5-3L218.5,285
		c0.4-2.2-1.7-4-3.8-3.2L124.4,314v109.1H473V76.8H341.6z M361.3,387.7h-10.7v-53.9h10.7V387.7z M378.3,387.7h-10.7v-53.9h10.7
		V387.7z M395.3,387.7h-10.7v-53.9h10.7V387.7z M412.3,387.7h-10.7v-53.9h10.7V387.7z M429.3,387.7h-10.7v-53.9h10.7V387.7z
		 M277,115.4c1.8,0,3.5,0.7,4.7,2l15.8,16.5l15.8-16.5c1.2-1.3,2.9-2,4.7-2c0,0,0,0,0,0c1.8,0,3.5,0.7,4.7,2l10,10.4v-51h-70.3v51
		l9.9-10.4C273.5,116.2,275.3,115.4,277,115.4z"
          />
          <g>
            <path
              className="st0"
              d="M345,173.9c3,0,6,0.2,8.9,0.5l33.6,3.5c11.7,1.2,14.6,17,4.1,22.3l-95.1,48c-1.9,1-3.4,2.5-4.3,4.5
			l-60.9,132.7c-1.6,3.5-4.6,6.2-8.3,7.5l-20.9,7.1c-0.3,0.1-0.6,0.1-0.9,0.1c-1.6,0-2.9-1.5-2.6-3.2L218.5,285
			c0.3-1.8-1.1-3.4-2.8-3.4c-0.3,0-0.6,0.1-1,0.2l-104.8,37.5c-2.2,0.8-4.4,1.1-6.6,1.1c-4.9,0-9.7-1.8-13.4-5.3l-61.2-57.6
			c-3-2.8-2-7.8,1.9-9.2l16.4-6c1.8-0.7,3.7-1,5.6-1c3.5,0,7,1.1,9.9,3.3L97.6,271c1.2,0.9,2.6,1.4,4,1.4c1,0,2-0.2,2.9-0.6
			l67.9-32.2c1.4-0.7,1.6-2.6,0.3-3.5l-63.9-44.5c-1-0.7-0.8-2.3,0.3-2.8l29.2-11.2c0.9-0.3,1.8-0.5,2.8-0.5c0.9,0,1.7,0.1,2.5,0.4
			l92,31.5c1.2,0.4,2.5,0.6,3.7,0.6c1.5,0,3-0.3,4.4-0.9l68.4-28.2C322.7,176.1,333.8,173.9,345,173.9 M345,168.9
			c-12,0-23.6,2.3-34.7,6.9L242,204c-0.8,0.3-1.6,0.5-2.5,0.5c-0.7,0-1.4-0.1-2.1-0.4l-92-31.5c-1.3-0.5-2.7-0.7-4.1-0.7
			c-1.6,0-3.1,0.3-4.6,0.9l-29.2,11.2c-2.3,0.9-3.9,2.9-4.2,5.3c-0.3,2.4,0.8,4.8,2.8,6.2l59.7,41.6l-63.3,30
			c-0.2,0.1-0.5,0.2-0.7,0.2c-0.3,0-0.6-0.1-1-0.3l-35.1-26.5c-3.7-2.8-8.3-4.3-12.9-4.3c-2.5,0-5,0.4-7.4,1.3l-16.4,6
			c-3.5,1.3-6,4.2-6.7,7.8c-0.7,3.6,0.4,7.3,3.1,9.8l61.2,57.6c4.6,4.3,10.6,6.7,16.8,6.7c2.8,0,5.6-0.5,8.3-1.4l101.3-36.3
			L193.6,396c-0.4,2.2,0.2,4.5,1.7,6.3c1.5,1.8,3.6,2.8,5.9,2.8c0.8,0,1.7-0.1,2.5-0.4l20.9-7.1c5-1.7,9-5.4,11.2-10.1l60.9-132.7
			c0.4-0.9,1.1-1.6,2-2.1l95.1-48c6.8-3.4,10.4-10.5,9-18.1c-1.4-7.5-7.2-12.9-14.8-13.7l-33.6-3.5
			C351.3,169.1,348.2,168.9,345,168.9L345,168.9z"
            />
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const CurrierSurfaceIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 500 500"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <g>
            <path
              className="st0"
              d="M58.5,301.6c-3.8,9.3-5.5,17.9-4.4,27c0.3,2.4-1.1,2.9-3,2.7c-8.5-0.9-16.3-4-24.4-6.2
			c-1.3-0.4-1.4-1.6-1.5-2.9c-0.2-6-0.4-11.9-0.7-17.9c-0.1-2,0.5-2.7,2.4-2.7C37.2,301.6,47.5,301.6,58.5,301.6z"
            />
            <path
              className="st0"
              d="M364.1,344.5c0,3.9-1.6,4.2-4.7,4.2c-10.3-0.1-20.6,0-30.9,0c-9.8,0-19.6,0.1-29.4-0.1c-1.6,0-5,1.5-4.6-1.4
			c0.4-2.5,0.8-6.7,5.1-6.8c3-0.1,6,0,9,0c17,0,33.9,0.1,50.9-0.1C362.7,340.2,364.1,340.8,364.1,344.5z"
            />
            <path
              className="st0"
              d="M411.3,283.9c-21.5,0-39.4,17.6-39.6,39.5c-0.2,22.9,21.1,41.3,39.5,39.2c22.2,0,39.7-17.3,39.5-39.3
			C450.6,301.8,432.8,283.9,411.3,283.9z M410.5,345.3c-12.1-0.4-21.2-10.3-20.8-22.6c0.3-11.8,10.2-21.4,21.9-21.1
			c11.7,0.3,21.6,10.6,21.4,22.4C432.7,335.6,422,345.7,410.5,345.3z"
            />
            <path
              className="st0"
              d="M468.7,281.6c-3.1-0.8-5.1-2.1-5.7-5.7c-1.3-7.4-1.5-7.4-8.8-7.4c-10.1,0-10.1,0-10.1-10.2
			c0-8.5,0-8.5,8.4-9.5c1-0.1,2.5,0.3,2.4-1.6c-0.1-2.8-5.1-9.6-8-10.7c-6.4-2.3-12.8-4.7-19.2-6.8c-2.4-0.8-4-2-5.4-4
			c-11.9-17-24-33.9-35.9-50.8c-1.7-2.5-3.6-4.1-6.8-4.4c-25.7-2.4-53.5-3.5-79.3-4.1c-4-0.1-5.4,0.6-5.4,5c0,10.1,0,20.3-0.3,30.4
			c-1,31.3-0.2,62.8-1.4,94.3c-0.2,4.5-1.5,5.5-5.7,5.4c-43.8-0.2-89.6-0.1-133.4-0.1h-5.9c5.4,16.3,6,28.2-0.4,44h5.9
			c40.6,0,81.3-0.2,121.9,0.2c7.1,0.1,11.1-1.6,12.6-8.6c1-4.8,4.1-6.1,9.1-6c20.2,0.3,40.3,0.1,60.5,0.2c3.5,0,4.6-0.8,4.1-4.5
			c-0.7-5.3-0.2-10.6,1.3-15.8c5.2-17.4,16-29.9,33.7-35c19.3-5.5,36.6-1.2,50.6,13.6c9.1,9.6,13.5,21.1,13.4,34.8
			c2.2-1.1,3.8-2.3,5.7-2.8c6.2-1.6,7.2-6.3,7.5-11.7c0.3-6.3,0.6-12.6,1.3-18.9C475.9,283.6,476.1,283.6,468.7,281.6z M339,245
			c-2.3,1.9-5.3,1.9-8,2.3c-4.4,0.6-8.9,0.7-13.3,1.1c-2.8,0.3-4.3-0.7-3.5-3.5c0.6-2.4-1.8-6.6,3.6-6.5c3.3,0.1,6.6,0,9.9,0v0.3
			c3.3,0.2,6.6,0.4,9.9,0.8c1.2,0.1,2.9-0.6,3.4,1.2C341.3,242.5,340.3,243.9,339,245z M404.6,237.2c-9.3,0-18.4-0.1-27.6,0
			c-3.1,0-3.9-2.4-5-4.2c-1.6-2.9-3.6-3.8-6.8-3.9c-15.3-0.4-30.6-1-45.9-1.3c-3.3-0.1-4.6-0.8-4.5-4.4c0.5-12.8,0.7-25.6,0.9-38.4
			c0-2.4,0.5-3.6,3.3-3.5c16.8,0.4,33.6,0.5,50.3,2.2c1.4,0.1,2.6,0.2,3.4,1.5c11,17,22.2,33.8,31.8,51.6
			C404.8,236.8,404.6,237,404.6,237.2z"
            />
            <path
              className="st0"
              d="M468.7,281.6c-3.1-0.8-5.1-2.1-5.7-5.7c-1.3-7.4-1.5-7.4-8.8-7.4c-10.1,0-10.1,0-10.1-10.2
			c0-8.5,0-8.5,8.4-9.5c1-0.1,2.5,0.3,2.4-1.6c-0.1-2.8-5.1-9.6-8-10.7c-6.4-2.3-12.8-4.7-19.2-6.8c-2.4-0.8-4-2-5.4-4
			c-11.9-17-24-33.9-35.9-50.8c-1.7-2.5-3.6-4.1-6.8-4.4c-25.7-2.4-53.5-3.5-79.3-4.1c-4-0.1-5.4,0.6-5.4,5c0,10.1,0,20.3-0.3,30.4
			c-1,31.3-0.2,62.8-1.4,94.3c-0.2,4.5-1.5,5.5-5.7,5.4c-43.8-0.2-89.6-0.1-133.4-0.1h-5.9c5.4,16.3,6,28.2-0.4,44h5.9
			c40.6,0,81.3-0.2,121.9,0.2c7.1,0.1,11.1-1.6,12.6-8.6c1-4.8,4.1-6.1,9.1-6c20.2,0.3,40.3,0.1,60.5,0.2c3.5,0,4.6-0.8,4.1-4.5
			c-0.7-5.3-0.2-10.6,1.3-15.8c5.2-17.4,16-29.9,33.7-35c19.3-5.5,36.6-1.2,50.6,13.6c9.1,9.6,13.5,21.1,13.4,34.8
			c2.2-1.1,3.8-2.3,5.7-2.8c6.2-1.6,7.2-6.3,7.5-11.7c0.3-6.3,0.6-12.6,1.3-18.9C475.9,283.6,476.1,283.6,468.7,281.6z M339,245
			c-2.3,1.9-5.3,1.9-8,2.3c-4.4,0.6-8.9,0.7-13.3,1.1c-2.8,0.3-4.3-0.7-3.5-3.5c0.6-2.4-1.8-6.6,3.6-6.5c3.3,0.1,6.6,0,9.9,0v0.3
			c3.3,0.2,6.6,0.4,9.9,0.8c1.2,0.1,2.9-0.6,3.4,1.2C341.3,242.5,340.3,243.9,339,245z M404.6,237.2c-9.3,0-18.4-0.1-27.6,0
			c-3.1,0-3.9-2.4-5-4.2c-1.6-2.9-3.6-3.8-6.8-3.9c-15.3-0.4-30.6-1-45.9-1.3c-3.3-0.1-4.6-0.8-4.5-4.4c0.5-12.8,0.7-25.6,0.9-38.4
			c0-2.4,0.5-3.6,3.3-3.5c16.8,0.4,33.6,0.5,50.3,2.2c1.4,0.1,2.6,0.2,3.4,1.5c11,17,22.2,33.8,31.8,51.6
			C404.8,236.8,404.6,237,404.6,237.2z"
            />
            <path
              className="st0"
              d="M411.3,283.9c-21.5,0-39.4,17.6-39.6,39.5c-0.2,22.9,21.1,41.3,39.5,39.2c22.2,0,39.7-17.3,39.5-39.3
			C450.6,301.8,432.8,283.9,411.3,283.9z M410.5,345.3c-12.1-0.4-21.2-10.3-20.8-22.6c0.3-11.8,10.2-21.4,21.9-21.1
			c11.7,0.3,21.6,10.6,21.4,22.4C432.7,335.6,422,345.7,410.5,345.3z"
            />
            <path
              className="st0"
              d="M54,328.6c0.3,2.4-1.1,2.9-3,2.7c-8.5-0.9-16.3-4-24.4-6.2c-1.3-0.4-1.4-1.6-1.5-2.9
			c-0.2-6-0.4-11.9-0.7-17.9c-0.1-2,0.5-2.7,2.4-2.7c10.3,0,20.6,0,31.6,0C54.7,310.8,52.9,319.5,54,328.6z"
            />
            <path
              className="st0"
              d="M364.1,344.5c0,3.9-1.6,4.2-4.7,4.2c-10.3-0.1-20.6,0-30.9,0c-9.8,0-19.6,0.1-29.4-0.1c-1.6,0-5,1.5-4.6-1.4
			c0.4-2.5,0.8-6.7,5.1-6.8c3-0.1,6,0,9,0c17,0,33.9,0.1,50.9-0.1C362.7,340.2,364.1,340.8,364.1,344.5z"
            />
          </g>
          <path
            className="st0"
            d="M124.8,290.9c-0.4-0.3-0.8-0.5-1.2-0.8c-0.4-0.2-0.7-0.5-1.1-0.7c-0.4-0.3-0.9-0.5-1.4-0.8
		c-0.4-0.2-0.8-0.4-1.3-0.7c-0.3-0.2-0.6-0.3-0.9-0.4c-0.2-0.1-0.5-0.2-0.7-0.3c-0.8-0.4-1.7-0.7-2.5-1c-0.4-0.1-0.8-0.3-1.2-0.4
		c-0.5-0.2-1-0.3-1.6-0.5c-0.4-0.1-0.8-0.2-1.3-0.3c-0.5-0.1-1.1-0.2-1.6-0.3c-0.3,0-0.5-0.1-0.8-0.1c-0.2,0-0.3,0-0.5-0.1
		c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.8-0.1-1.2-0.2c-0.4,0-0.9-0.1-1.3-0.1c-0.1,0-0.2,0-0.3,0c-0.4,0-0.9,0-1.3-0.1h0c-0.5,0-1,0-1.5,0
		c-0.5,0-1,0-1.5,0h0c-0.5,0-0.9,0-1.3,0.1c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8,0.1-1.2,0.1c-0.6,0.1-1.2,0.1-1.8,0.2
		c-0.4,0.1-0.8,0.1-1.2,0.2c-0.3,0.1-0.6,0.1-0.9,0.2c-0.4,0.1-0.9,0.2-1.3,0.3c-2,0.5-4,1.2-5.8,2c-0.2,0.1-0.5,0.2-0.7,0.3
		c-1,0.5-2,1-3,1.5c-0.3,0.2-0.6,0.3-0.9,0.5c-0.3,0.2-0.6,0.3-0.8,0.5c-0.4,0.2-0.8,0.5-1.2,0.8C70,298,63.2,310,63,323.7
		c-0.3,20.7,18.7,40.9,39.3,38.8c21,2.4,40.2-18.4,39.8-38.8C141.9,310,135.2,298,124.8,290.9z M102.9,345.5
		C91,345.7,81,335.6,81,323.7c0-11.9,10.1-22,21.8-21.9c11.7,0.1,21.4,10.1,21.5,21.8C124.3,335.4,114.5,345.4,102.9,345.5z"
          />
          <polygon
            className="st0"
            points="181.8,195.5 163.2,202.9 163.2,202.9 112.6,181.4 130.6,174.1 	"
          />
          <polygon
            className="st0"
            points="198.6,188.8 146.8,167.6 163,161 213.6,182.9 	"
          />
          <polygon
            className="st0"
            points="199.5,194.4 218.1,187.1 218.1,244.2 165.9,266 165.9,207.8 185.9,199.8 185.9,226.6 199.5,221.7 	"
          />
          <path
            className="st0"
            d="M272.3,137.3h-227c-6.2,0-11.2,5-11.2,11.2v131.2c0,6.2,5,11.2,11.2,11.2h20.2c0.7-0.8,1.4-1.5,2.1-2.3
		c9.3-9.4,21.7-14.5,35-14.5c14.9,0,28.1,6.4,37.1,16.8h137.9c3.2,0,5.8-2.6,5.8-5.8V148.5C283.5,142.3,278.5,137.3,272.3,137.3z
		 M223.7,246.1c0,1.1-0.7,2.1-1.7,2.6l-57.8,24.2c-0.1,0-0.2,0.1-0.3,0.1h0c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.3,0-0.4,0s-0.3,0-0.4,0
		c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1l-0.2-0.1l-57.6-23.5c-1-0.4-1.7-1.4-1.7-2.6v-65.3c0-0.1,0-0.2,0-0.4
		c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.3
		c0.2-0.3,0.5-0.5,0.7-0.7c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0l57.7-23.3c0.7-0.3,1.5-0.3,2.1,0
		l57.9,25c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.2,0.2
		c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0.1,0.2
		c0,0.2,0,0.3,0,0.5V246.1z"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const TransportIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 500 500"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <rect
            x="5.7"
            y="171.7"
            className="st0"
            width="366.7"
            height="103.4"
          />
          <rect
            x="377.8"
            y="205.7"
            className="st0"
            width="14.5"
            height="69.4"
          />
          <rect
            x="377.8"
            y="282.2"
            className="st0"
            width="14.5"
            height="24.5"
          />
          <path
            className="st0"
            d="M254.8,282.2h30.5c-7.4,5-12.2,13.3-12.2,22.9c0,0.5,0,1.1,0,1.6h-18.3V282.2z"
          />
          <path
            className="st0"
            d="M372.4,282.2v24.5h-44.3c0-0.5,0-1.1,0-1.6c0-9.5-4.8-17.9-12.2-22.9H372.4z"
          />
          <path
            className="st0"
            d="M5.7,282.2h26c-7.4,5-12.2,13.3-12.2,22.9c0,0.5,0,1.1,0,1.6H5.7V282.2z"
          />
          <path
            className="st0"
            d="M88.4,282.2v24.5H74.5c0-0.5,0.1-1.1,0.1-1.6c0-9.5-4.9-17.9-12.2-22.9H88.4z"
          />
          <path
            className="st0"
            d="M488.8,289.2v-29.5c0-1-0.2-2-0.6-2.9L460,196c-1.6-3.5-5.1-5.7-9-5.7h-53.7v116.5h3.8c0-0.5,0-1.1,0-1.6
		c0-15.2,12.4-27.6,27.5-27.6s27.5,12.4,27.5,27.6c0,0.5,0,1.1,0,1.6h38.2v-17.5H488.8z M440.8,233.2h-30.5v-36.5H449
		c2.6,0,5,1.5,6.1,3.9l25.7,53.6h-18L440.8,233.2z M486.3,283.9c0,1.2-1,2.3-2.2,2.3h-6.4c-1.2,0-2.3-1-2.3-2.3v-16.1
		c0-1.2,1-2.2,2.3-2.2h6.4c1.2,0,2.2,1,2.2,2.2V283.9z"
          />
          <g>
            <path
              className="st0"
              d="M429.4,328.3c-12.4,0-22.5-10.1-22.5-22.5s10.1-22.5,22.5-22.5s22.5,10.1,22.5,22.5S441.8,328.3,429.4,328.3z
			 M429.4,294.2c-6.4,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5s11.5-5.2,11.5-11.5S435.7,294.2,429.4,294.2z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M299.8,328.3c-12.4,0-22.5-10.1-22.5-22.5s10.1-22.5,22.5-22.5s22.5,10.1,22.5,22.5S312.2,328.3,299.8,328.3z
			 M299.8,294.2c-6.4,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5s11.5-5.2,11.5-11.5S306.2,294.2,299.8,294.2z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M47.1,328.3c-12.4,0-22.5-10.1-22.5-22.5s10.1-22.5,22.5-22.5s22.5,10.1,22.5,22.5S59.5,328.3,47.1,328.3z
			 M47.1,294.2c-6.4,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5s11.5-5.2,11.5-11.5S53.4,294.2,47.1,294.2z"
            />
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const RapidoIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 500 500"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <path
            className="st0"
            d="M69.9,138.3l-0.6,17.9l3.8-3.7c0.5-0.5,1.1-0.7,1.8-0.7c0.6,0,1.3,0.3,1.7,0.8l5.6,6.3l6-5.9
		c0.5-0.5,1.1-0.7,1.8-0.7c0,0,0,0,0,0c0.6,0,1.3,0.3,1.7,0.8l3.5,3.9l0.6-17.9C87.1,138.9,78.5,138.6,69.9,138.3z M411.3,328
		c2.2-4.9,5.1-7.9,10.9-7.6c15.6,0.9,29.5,6,41.6,16c4,3.3,8.8,3.2,11.6,0c2.9-3.4,2.6-8.1-1.3-11.6c-11.9-10.5-25.9-17.3-41.6-18.8
		c-9.4-0.9-14.4-2.6-17.4-13.1c-6.2-21.6-18.4-40.5-32.1-58.2c-1.1-1.4-3.4-3.1-4.8-2.8c-9.1,1.9-18.1,4.3-27.1,6.5
		c-2.9,0.7-3.8,2.6-3.5,5.6c1.2,12.4,2.3,24.9,3.1,37.4c0.2,3-0.4,6.3-1.5,9.1c-3.2,8-6.7,15.9-10.2,23.8
		c-6.8,15.5-13.6,31-20.6,46.5c-0.7,1.5-2.8,3.4-4.1,3.4c-8.5-0.5-16.9-1.4-25.3-2.3c-0.7-0.1-1.3-0.7-1.8-1
		c2.2-4.4,5.2-8.2,6.2-12.6c4.1-18.5,7.9-37.1,11.4-55.8c1.6-8.8,2.8-17.7,3.3-26.6c0.4-6.6-5.9-13.2-12.4-14.4
		c-5.4-1-10.8-1.8-16.2-2.9c-10.6-2.2-21.1-4.5-31.7-6.8c-2.8-0.6-4.4-2.2-3.6-5.4c1.9-7.9,3.7-15.8,5.5-23.8c1.3-5.8,2.4-6.3,7-2.9
		c5.7,4.2,11.7,6.4,19,6.1c10.6-0.5,21.3-0.2,32,0c1.6,0,4.2,1.5,4.6,2.9c1.7,6.2,4.8,8,10.9,5.3c3.5-1.5,6.9-3.2,10.4-4.8
		c6.5-3,6.7-2.9,9.3,3.5c0.9,2.1,1.7,4.3,2.4,6.6c0.9,3.1,2.7,4.2,6,3.4c11.7-3.1,23.5-6,35.2-9.1c1.5-0.4,2.9-1.1,5.4-2.1
		c-12.1-9.5-15.8-22.2-17.3-36.8c-6.2,3.6-11.3,6.7-17.3,10.2c-2.6-6.9-5.1-13.1-7.2-19.5c-0.8-2.3-0.9-5.1-0.5-7.6
		c1.1-6.3,0.7-12.3-2.9-17.7c-3.4-5.1-9.6-5.3-13.3-0.4c-5,6.7-5.1,19.1,0.5,25.2c1.6,1.8,5.1,3.3,7.2,2.8c4.4-1.1,6.2-0.1,7,4.2
		c0.3,1.6,1.2,3.1,1.9,4.6c1.9,4.6,1.2,5.5-3.6,5.5c-22.7-0.1-45.3-0.1-68-0.2c-9.9-0.1-15.8-7.4-22.8-12.8
		c-0.6-0.5-0.4-1.9-0.8-2.8c-2-5.5-3.4-11.2-6-16.3c-8.1-15.4-27.5-22.5-43.8-16.6c-16.6,6-25.5,18.6-29.5,35.1
		c-5.2,21.6-10.2,43.4-14.7,65.2c-1.1,5.3-6.2,12.1,4,15.7c-1.9,0.7-2.6,1.3-3.3,1.3c-5.8-0.3-11.7-0.3-17.4-1.2
		c-0.2,0-0.4-0.1-0.6-0.3c-1.4-0.9-2.8-3.5-2.9-5.1c0-10,0.5-20,0.9-30c0.9-26,1.8-52,2.9-77.9c0.1-3.5-0.8-5-4.6-5.2
		c-13.6-0.4-27.1-0.9-40.7-1.4l-0.7,21.1c0,0.8-0.5,1.5-1.3,1.8c-0.8,0.3-1.6,0.1-2.1-0.5l-5.1-5.7l-6.4,6.2
		c-0.4,0.4-0.9,0.6-1.4,0.5c-0.5,0-1-0.2-1.4-0.7l-5.9-6.6l-5.5,5.4c-0.6,0.6-1.4,0.7-2.1,0.4c-0.7-0.3-1.2-1.1-1.2-1.9l0.7-21.2
		c-12.1-0.4-24.2-0.9-36.3-1.4c-3.8-0.2-5,1-5.2,4.6c-0.4,10.3-1.2,20.6-1.5,30.9c0,0.1,0,0.3,0,0.4c-0.2,4.4-0.3,8.8-0.5,13.3
		c-0.2,5.1-0.4,10.2-0.5,15.4v0c-0.2,6.6-0.4,13.1-0.7,19.7c-0.3,9.9-0.7,19.8-1,29.6c-0.2,4.1,1.3,5.7,5.5,5.7
		c11.5,0.1,23,0.5,34.5,0.8c1.4,0,2.8,0.4,4.2,0.6c0.2,0.5,0.4,0.9,0.5,1.4c-2.1,1.7-4,3.5-5.8,5.4c-7.2,7.8-11.7,17.3-14.8,27.5
		c-2.8,9.4-5,18.9-6.7,28.6c-1,5.2,1.5,9.9,6.8,11.5c6.8,2.2,13.8,3.4,20.7,5c1.4,0.3,2.6,1,3.9,1.5c-0.7,1.2-1.2,2.6-2.1,3.7
		c-10.5,12.9-17,27.4-18,44c-0.3,5,2.6,8.3,7,8.6c4.2,0.3,7.1-2.2,7.9-7.1c2.2-12.8,5.9-24.9,14.5-35c3-3.5,6.4-6.5,9.6-9.8
		c0.5,0.4,0.9,0.8,1.4,1.1c-12.5,14.4-20.2,30.5-17.7,50.1c2.5,19.7,12.6,34.5,29.5,44.5c13.7,8.2,29,10.2,43.9,5.7
		c29.1-8.6,43.6-29.5,44.6-60.2c1.3,0.9,1.9,1.1,2,1.4c2.6,10,9.6,12.4,18.9,11.2c1.3-0.2,2.7,0.2,4,0.2c44.3,1,88.6,2,132.9,3.1
		c4.2,0.1,7.5-0.3,9.5-4.5c0.6-1.2,2.3-2,4.4-3.6c2.2,18.1,9.9,32.2,23.7,42.6c14.1,10.6,30.1,13.7,47.3,10.4
		c22.6-4.3,43.4-22.3,45.7-47C483.1,350.7,457.4,329.1,411.3,328z M124.2,234l3.9,0.1l-0.7,19.8l-4-0.1L124.2,234z M118,233.8
		l3.9,0.1l-0.7,19.9l-3.9-0.1L118,233.8z M111.7,233.6l3.9,0.1l-0.7,19.8l-4-0.1L111.7,233.6z M105.5,233.4l3.9,0.1l-0.7,19.9
		l-4-0.1L105.5,233.4z M99.2,233.1l3.9,0.1l-0.7,19.8l-4-0.1L99.2,233.1z M131.6,417.9c-17,0.5-31.3-13.6-31.3-30.2
		c0-17,14.4-31.4,31.3-30.7c15.7,0.7,29.4,13.3,29.4,30.5C161.1,404.8,147.3,417.5,131.6,417.9z M271.5,286.1c0,0.1,0,0.3,0,0.4
		c0,0.1,0,0.3,0,0.4c0,0.5-0.1,1-0.2,1.5c0,0.2,0,0.3-0.1,0.5c0,0,0,0,0,0c0,0.4-0.1,0.7-0.2,1.1c0,0.3-0.1,0.5-0.1,0.8
		c-0.1,0.6-0.2,1.2-0.3,1.8c-0.1,0.7-0.3,1.5-0.4,2.2c-0.3,1.8-0.7,3.7-1.1,5.6c-0.5,2.8-1.1,5.6-1.6,8.3c-0.5,2.8-1.1,5.6-1.7,8.3
		c-0.8,3.7-1.5,7.4-2.3,11.1c-0.8,3.7-1.7,7.4-2.5,11c-1.7,6.9-0.6,12.7,3.5,18.3c-0.2,0.5-0.4,0.9-0.6,1.4
		c-2.4-0.2-4.8-0.3-7.1-0.4c-0.8-0.1-1.6-0.1-2.4-0.2c-6.6-0.6-13.3-1.1-19.8-2.1c-0.4-0.1-0.8-0.2-1.2-0.3c-0.2,0-0.3-0.1-0.4-0.2
		c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.3-0.1-0.5-0.3-0.8-0.5c-0.1-0.1-0.2-0.2-0.4-0.3
		c-0.1-0.1-0.2-0.2-0.3-0.2c-0.5-0.4-0.9-0.8-1.1-1.3c-0.1-0.1-0.1-0.2-0.2-0.3c-10.2-22.3-5.1-51.1,11.2-69.4
		c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.4-0.4,0.6-0.6c0,0,0.1-0.1,0.1-0.1c1-0.9,2-1.7,3.1-2.3c0.4-0.2,0.9-0.5,1.3-0.7
		c0.3-0.1,0.5-0.2,0.8-0.3c0.2-0.1,0.4-0.2,0.6-0.2c0.2-0.1,0.4-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3-0.1
		c0.2,0,0.3-0.1,0.5-0.1c0.4-0.1,0.9-0.1,1.3-0.2c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c0.2,0,0.5,0,0.7,0c0.3,0,0.5,0,0.8,0
		c0.5,0,0.9,0,1.4,0.1c0.2,0,0.5,0,0.7,0.1c0.7,0.1,1.5,0.2,2.3,0.3c0.3,0,0.5,0.1,0.8,0.1c2.3,0.4,4.2,0.8,5.8,1.1
		c0.5,0.1,0.9,0.2,1.3,0.3c0.5,0.1,0.9,0.2,1.3,0.3c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.6,0.2,0.9,0.3c0.5,0.2,1,0.5,1.4,0.8
		c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.1,0.1
		c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.2,0.2,0.4,0.3,0.6c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.2,0,0.3
		c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4,0,0.5c0,0.2,0,0.4,0,0.5C271.5,285.8,271.5,286,271.5,286.1z M451.4,388c0,0.4,0,0.8-0.1,1.3
		c0,0.2,0,0.5-0.1,0.7c-0.1,0.7-0.2,1.5-0.3,2.2c-0.1,0.4-0.1,0.8-0.2,1.1c-0.1,0.3-0.2,0.7-0.2,1c0,0.1-0.1,0.2-0.1,0.4
		c0,0.1-0.1,0.2-0.1,0.4c-0.3,1-0.6,2.1-1,3c-0.1,0.3-0.2,0.6-0.3,0.8c0,0,0,0.1,0,0.1c-0.1,0.3-0.3,0.6-0.4,0.9s-0.3,0.6-0.4,0.9
		c-0.1,0.3-0.3,0.6-0.5,0.9c-0.2,0.3-0.3,0.6-0.5,0.9c-0.2,0.3-0.3,0.6-0.5,0.9c-0.3,0.4-0.5,0.8-0.8,1.2c-0.3,0.4-0.5,0.7-0.8,1.1
		c0,0,0,0-0.1,0.1c-0.2,0.3-0.5,0.6-0.8,0.9c0,0.1-0.1,0.1-0.2,0.2c-0.2,0.3-0.5,0.6-0.8,0.9c-1.2,1.3-2.5,2.5-3.9,3.6
		c-0.4,0.3-0.8,0.6-1.2,0.9c-0.3,0.2-0.6,0.4-0.9,0.6c-0.3,0.2-0.6,0.4-1,0.6c-0.3,0.2-0.7,0.4-1,0.6c-0.3,0.2-0.6,0.3-0.9,0.5
		c-0.4,0.2-0.9,0.4-1.3,0.6c-0.3,0.1-0.6,0.3-0.9,0.4c-0.3,0.2-0.7,0.3-1.1,0.4c0,0,0,0,0,0c-0.3,0.1-0.7,0.2-1,0.4
		c-0.2,0.1-0.5,0.2-0.8,0.2c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.7,0.2c-0.3,0.1-0.7,0.2-1,0.2c-0.4,0.1-0.9,0.2-1.3,0.2
		c-0.3,0-0.6,0.1-0.9,0.1c-0.6,0.1-1.2,0.1-1.8,0.2c-0.3,0-0.6,0-1,0c-0.3,0-0.6,0-0.9,0c-0.2,0-0.5,0-0.8,0c-0.4,0-0.8,0-1.2-0.1
		c-0.2,0-0.5,0-0.7-0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.5-0.1-1-0.2-1.5-0.3c-0.4-0.1-0.7-0.2-1.1-0.2
		c-0.3-0.1-0.6-0.2-0.9-0.2c-0.1,0-0.1,0-0.2-0.1c-0.5-0.1-0.9-0.3-1.4-0.5c-0.4-0.1-0.8-0.3-1.1-0.4c-0.1,0-0.2-0.1-0.3-0.1
		c-0.4-0.2-0.8-0.3-1.1-0.5c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.1-0.6-0.3-0.9-0.4c-0.4-0.2-0.9-0.4-1.3-0.7c-0.4-0.2-0.7-0.4-1.1-0.6
		c-0.4-0.2-0.8-0.5-1.2-0.8c-0.4-0.3-0.8-0.6-1.2-0.8c-0.4-0.3-0.8-0.6-1.2-0.9c-0.2-0.1-0.4-0.3-0.6-0.5c-0.3-0.2-0.6-0.5-0.8-0.7
		c-0.2-0.2-0.4-0.4-0.6-0.6c-0.6-0.6-1.2-1.2-1.7-1.8c-0.3-0.3-0.6-0.7-0.9-1c-0.1-0.1-0.2-0.2-0.3-0.3c-1.1-1.3-2-2.7-2.8-4.2
		c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.2-0.2-0.5-0.4-0.7s-0.2-0.5-0.4-0.7c-0.1-0.3-0.3-0.6-0.4-1c-0.3-0.6-0.5-1.3-0.8-2
		c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.4-0.2-0.7-0.3-1c-0.1-0.3-0.1-0.6-0.2-0.9c0-0.1-0.1-0.3-0.1-0.4
		c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.1,0-0.1,0-0.2c0-0.3-0.1-0.7-0.1-1c-0.1-0.5-0.1-0.9-0.1-1.4c0-0.2,0-0.4,0-0.6c0-0.4,0-0.8,0-1.2
		v-0.1c0-0.3,0-0.6,0-0.9c0-0.3,0-0.7,0.1-1c0-0.3,0-0.6,0.1-0.9c0-0.1,0-0.2,0-0.3c0-0.2,0.1-0.5,0.1-0.7c0-0.3,0.1-0.6,0.2-0.9
		c0.1-0.3,0.1-0.6,0.2-0.9c0-0.1,0-0.1,0-0.2c0.1-0.5,0.2-1,0.4-1.4c0-0.1,0-0.1,0.1-0.2c0.1-0.3,0.2-0.7,0.3-1
		c0.1-0.4,0.3-0.8,0.4-1.2c0.2-0.4,0.3-0.8,0.5-1.1c0.1-0.3,0.2-0.5,0.3-0.8c0.2-0.4,0.4-0.8,0.5-1.1c0.2-0.4,0.4-0.8,0.6-1.1
		c0.1-0.2,0.3-0.5,0.4-0.7c0.3-0.5,0.6-1,0.9-1.4c0.2-0.4,0.5-0.8,0.8-1.1c0.4-0.6,0.9-1.2,1.3-1.7c0.3-0.4,0.6-0.8,1-1.1
		c0.2-0.2,0.3-0.4,0.5-0.5c0.2-0.2,0.3-0.3,0.5-0.5c0.2-0.2,0.4-0.4,0.7-0.6c0.3-0.3,0.6-0.6,0.9-0.9c0.3-0.3,0.7-0.6,1-0.9
		c0.2-0.1,0.3-0.2,0.5-0.4c0.8-0.7,1.7-1.3,2.6-1.8c0.2-0.1,0.4-0.3,0.6-0.4c0.4-0.3,0.9-0.5,1.3-0.8c0.2-0.1,0.5-0.2,0.7-0.4
		c0.2-0.1,0.3-0.2,0.5-0.2c0.2-0.1,0.4-0.2,0.7-0.3c0.4-0.2,0.7-0.3,1.1-0.5c0.3-0.1,0.6-0.2,0.9-0.4c0.5-0.2,0.9-0.3,1.4-0.5
		c0.5-0.2,0.9-0.3,1.4-0.4c0.5-0.1,1-0.2,1.4-0.3c0.2-0.1,0.5-0.1,0.7-0.1c0.2,0,0.5-0.1,0.7-0.1c0.2,0,0.4-0.1,0.6-0.1
		c0.1,0,0.1,0,0.2,0c0.2,0,0.5,0,0.8-0.1c0.2,0,0.4,0,0.7,0c0.6-0.1,1.3-0.1,1.9-0.1c1.1,0,2.1,0.1,3.1,0.2c0.5,0,1,0.1,1.5,0.2
		c0.5,0.1,1,0.2,1.5,0.3c0.5,0.1,1,0.2,1.5,0.3c0,0,0.1,0,0.1,0c0.5,0.1,0.9,0.3,1.4,0.4c0.5,0.1,0.9,0.3,1.4,0.5c0,0,0,0,0,0
		c0.4,0.1,0.8,0.3,1.1,0.4c0,0,0.1,0,0.1,0.1c0.1,0,0.3,0.1,0.4,0.2c0.4,0.2,0.8,0.3,1.1,0.5c0.5,0.2,0.9,0.4,1.3,0.7
		c0.4,0.2,0.9,0.5,1.3,0.7c0.4,0.2,0.8,0.5,1.2,0.8c0.7,0.5,1.4,1,2.1,1.6c0.2,0.1,0.4,0.3,0.6,0.5c0.2,0.2,0.4,0.3,0.6,0.5
		c0.2,0.1,0.3,0.3,0.5,0.4c0.3,0.2,0.5,0.5,0.8,0.7c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.2,0.5,0.5,0.8,0.8c0.7,0.7,1.3,1.5,1.9,2.2
		c0.2,0.3,0.5,0.6,0.7,1c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.3,0.4,0.4,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3l0,0
		c0,0,0,0,0,0.1c0.2,0.3,0.4,0.6,0.5,0.9c0.5,0.8,0.9,1.7,1.3,2.6c0.2,0.5,0.4,0.9,0.6,1.4c0.3,0.9,0.6,1.8,0.9,2.8
		c0.1,0.4,0.2,0.7,0.3,1.1c0,0.1,0,0.1,0,0.2c0,0.2,0.1,0.3,0.1,0.5l0,0c0,0,0,0,0,0c0.1,0.4,0.2,0.8,0.2,1.2
		c0.1,0.4,0.1,0.9,0.2,1.4v0c0.1,0.4,0.1,0.9,0.1,1.3c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.4,0,0.8,0,1.2
		C451.4,387.6,451.4,387.8,451.4,388z"
          />
          <path
            className="st0"
            d="M233.6,104.7c-2.5-3.6-3.6-7.5-2.9-10.8c1.7-8.5,36.5-3.8,46.8-2.2c-1.1-3.9-2.5-7.8-4.3-11.5
		c-9.6-19.6-26.2-28.2-44.5-27.1c-29.5,1.9-48.6,28.7-41.8,57.6c1.1,4.8,3.8,7.5,8.7,9.2c10,3.4,19.8,7.5,29.8,11.3
		c9.9,3.8,19.7,7.7,29.7,11.3c8,2.8,14.7,0,18.1-7.8c1.4-3.2,2.2-6.7,3.3-10.5C247.9,119.7,237.3,110.1,233.6,104.7z M253.2,105.6
		c0.2-5.6,5.3-10.2,11.6-10c3.5,0.1,7,0.7,10.5,0.5c0.7,0,2-1.3,2.5-2.3c-18.4-2.9-43.9-4.6-45,0.5c-0.6,2.8,0.3,6.1,2.6,9.3
		c3.6,5.1,13.8,14.4,41.7,18.8c0.1-0.4,0.2-0.8,0.3-1.1c-4.9-1.3-8.8-2-12.5-3.2C257.9,115.8,253,111.5,253.2,105.6z M239.8,100
		c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C243.3,98.5,241.7,100,239.8,100z"
          />
          <path
            className="st0"
            d="M244.4,279.5c-1,0.6-2.1,1.4-3.1,2.3C242.3,280.8,243.4,280,244.4,279.5z"
          />
          <path
            className="st0"
            d="M245.7,278.8c-0.4,0.2-0.9,0.4-1.3,0.7C244.8,279.2,245.3,279,245.7,278.8z"
          />
          <path
            className="st0"
            d="M254.2,358.5c0.8,0.1,1.6,0.1,2.4,0.2C255.8,358.6,255,358.5,254.2,358.5c-6.6-0.6-13.3-1-19.8-2.1
		c-0.4-0.1-0.8-0.2-1.2-0.3c0.4,0.1,0.8,0.2,1.2,0.3C241,357.4,247.6,357.9,254.2,358.5z"
          />
          <path
            className="st0"
            d="M270.1,295c0.2-0.8,0.3-1.5,0.4-2.2C270.4,293.5,270.3,294.2,270.1,295c-0.3,1.8-0.7,3.7-1.1,5.6
		C269.4,298.7,269.8,296.9,270.1,295z"
          />
          <path
            className="st0"
            d="M445.4,369.5c-0.6-0.8-1.2-1.5-1.9-2.2C444.2,368,444.8,368.7,445.4,369.5z"
          />
          <path
            className="st0"
            d="M447.7,373.1c0.5,0.8,0.9,1.7,1.3,2.6C448.6,374.9,448.2,374,447.7,373.1z"
          />
          <path
            className="st0"
            d="M450.4,379.9c-0.2-1-0.5-1.9-0.9-2.8C449.9,378,450.2,379,450.4,379.9z"
          />
          <path
            className="st0"
            d="M451,392.2c0.1-0.7,0.2-1.4,0.3-2.2C451.2,390.7,451.1,391.4,451,392.2z"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const BusIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 500 500"
        style={{ enableBackground: "new 0 0 500 500", opacity: "0.3" }}
      >
        <image
          width="1000"
          height="1000"
          transform="matrix(1 0 0 1 -7192 -7192)"
        ></image>
        <g>
          <path
            className="st0"
            d="M5,300.1c0,6.3,3,9.5,9.3,9.9c23.7,1.5,47.4,3,71.1,4.5c6.9,0.4,13.9,0.8,20.8,1.4c2.2,0.2,2.8-0.5,2.8-2.7
		c-0.1-4-0.3-8,0.2-11.9c1.6-12.7,11.6-22.5,24.4-24.3c7.3-1,14.2,0.2,20.6,3.9c8.7,5.1,13.4,12.6,13.8,22.8
		c0.1,3.2,0.1,6.5,0.1,9.8c0,1.9,0.6,2.7,2.7,2.7c58.1,0,116.2,0,174.3,0c2.2,0,3-0.6,2.9-2.9c-0.1-4.4-0.4-8.9,0.3-13.2
		c2.1-12,11.6-20.9,23.7-22.9c9.4-1.5,17.9,0.7,25.3,6.8c6.2,5,9.3,11.6,9.5,19.6c0.1,3.3,0.1,6.7,0,10c0,1.9,0.7,2.7,2.7,2.7
		c17.5-0.1,35,0,52.6-0.1c4.3,0,8.2-2.4,9.1-6.3c3.5-14.2,6.2-28.7,2.8-43.1c-5-20.7-10.9-41.1-16.5-61.7c-0.2-0.6-0.3-1.2-0.6-2.3
		c1.2-0.1,2.1-0.2,2.9-0.2c5.6,0,11.2,0,16.8,0c1.1,0,2.2,0.1,3.2,0.5c4.3,1.8,7.4,4.3,6.4,9.7c-0.3,1.7-0.2,3.4,0,5.1
		c0,0.1,0.1,0.3,0.1,0.4c0.5,1.2,2,1.5,3,0.8c0.6-0.4,1-0.8,1.1-1.2c0.4-2.7,0.2-5.4,0.2-8.1c-0.2-9.1,1.3-6.5-6.4-11.3
		c-3.3-2.1-6.7-3.1-10.7-2.9c-5.7,0.2-11.4,0-17.1,0.1c-1.7,0-2.8-0.4-3.5-2c-4-10.1-14.3-16.3-25.2-16c-29.2,0.6-58.5,0.2-87.7,0.2
		c-2.4,0-4.1-0.5-5.2-2.8c-2.7-5.4-7.2-7.2-13.1-7.2c-46.5,0.1-93,0.1-139.6,0c-5.5,0-9.8,1.7-12.3,6.7c-1.3,2.6-3.2,3.3-6.1,3.3
		c-41.6-0.1-83.3-0.1-124.9-0.1c-7,0-13.9,0-20.9,0c-5.7,0-8.4,2.1-10,7.6c-2.5,9-3.2,18.3-3.2,27.6C5,241.9,5,271,5,300.1z
		 M419.6,189.1c0.1-2.8,1.5-4.4,4.1-4.4c13.8,0,19.6,3.6,25.2,14.1c3.7,6.9,6.2,14.3,7.5,22c1.7,10,2.9,20.1,4.3,30.6
		c-1.9,0.1-2.8,0.3-3.7,0.3c-10.6,0-21.1,0-31.7,0c-4.5,0-5.7-1.3-5.7-5.9c0-15.2,0-30.3,0-45.5
		C419.6,196.5,419.5,192.8,419.6,189.1z M336.7,187.8c0-2.7,0.9-3.3,3.5-3.3c22,0.1,44.1,0.1,66.1,0c2.4,0,3.3,0.6,3.3,3.2
		c-0.1,12.2-0.1,24.4,0,36.6c0,2.7-0.9,3.3-3.4,3.3c-11-0.1-22-0.1-33-0.1s-22-0.1-33,0.1c-2.7,0-3.3-0.9-3.3-3.4
		C336.8,212,336.8,199.9,336.7,187.8z M258.4,224.7c0.1-12.4,0.1-24.9,0-37.3c0-2.1,0.7-2.8,2.8-2.8c22.3,0,44.6,0,66.9-0.1
		c2.1,0,3,0.6,3,2.9c-0.1,12.4-0.1,24.7,0,37.1c0,2.4-0.7,3.1-3.1,3c-11-0.1-22-0.1-33-0.1c-11.2,0-22.4,0-33.6,0
		C259.2,227.5,258.4,227,258.4,224.7z M179.9,224.6c0.1-12.5,0.1-24.9,0-37.4c0-2.2,0.8-2.8,2.9-2.8c22.3,0,44.6,0,66.9,0
		c2.2,0,3,0.7,3,2.9c-0.1,12.4-0.1,24.7,0,37.1c0,2.5-0.9,3-3.2,3c-11.1-0.1-22.2,0-33.3,0c0,0,0,0,0,0c-11.1,0-22.2,0-33.3,0
		C180.7,227.5,179.9,226.9,179.9,224.6z M101.4,187.5c0-2.2,0.7-3,2.9-3c22.3,0.1,44.6,0.1,66.9,0c2.2,0,3,0.7,3,2.9
		c-0.1,12.4-0.1,24.7,0,37.1c0,2.5-0.9,3-3.2,2.9c-2.7,0-5.5,0-8.2,0c-5.5,0-11,0-16.6,0c-2.9,0-5.7,0-8.5,0c-0.6,0-1.2,0-1.8,0
		c-10.5,0-21,0-31.5,0c-2.2,0-3-0.5-3-2.9C101.5,212.2,101.5,199.9,101.4,187.5z M23.2,187.7c0-2.6,0.9-3.2,3.3-3.2
		c22,0.1,44.1,0.1,66.1,0c2.4,0,3.3,0.6,3.3,3.2c-0.1,12.2-0.1,24.4,0,36.6c0,2.7-0.9,3.3-3.4,3.3c-10.9-0.1-21.9,0-32.8,0v0
		c-11.1,0-22.2-0.1-33.3,0c-2.3,0-3.1-0.5-3.1-3C23.3,212.2,23.3,199.9,23.2,187.7z"
          />
          <path
            className="st0"
            d="M114.2,307.8c-0.1,13.3,10.8,24.4,24.2,24.5c13.5,0.1,24.2-10.6,24.3-24.2c0.1-13.7-10.4-24.4-24-24.4
		C125.1,283.7,114.4,294.3,114.2,307.8z M124.8,308.1c-0.1-7.5,6.2-13.8,13.8-13.8c7.5,0,13.6,6,13.6,13.5c0,7.6-6.1,13.8-13.7,13.8
		C131.1,321.6,124.9,315.5,124.8,308.1z"
          />
          <path
            className="st0"
            d="M353.1,308.2c0,13.1,10.9,24.1,24,24.1c13.9,0,24.7-10.6,24.6-24.4c0-13.5-10.8-24.2-24.3-24.1
		C363.8,283.7,353.1,294.5,353.1,308.2z M363.8,308c0-7.5,6.1-13.6,13.5-13.7c7.7,0,13.8,6,13.8,13.6c0,7.5-6.1,13.7-13.5,13.7
		C370.1,321.7,363.8,315.5,363.8,308z"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const MessageIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9601 40C13.8344 40 13.7086 40 13.5828 39.8742C13.2055 39.7484 12.954 39.3711 12.954 38.9937V30.8176H5.03068C2.2638 30.8176 0 28.5535 0 25.7862V5.03145C0 2.26415 2.2638 0 5.03068 0H35.9693C38.7362 0 41 2.26415 41 5.03145V25.6604C41 28.4277 38.7362 30.6918 35.9693 30.6918H24.5245L14.589 39.6226C14.4632 39.8742 14.2117 40 13.9601 40ZM5.03068 2.01258C3.39571 2.01258 2.01227 3.39623 2.01227 5.03145V25.6604C2.01227 27.2956 3.39571 28.6792 5.03068 28.6792H13.9601C14.4632 28.6792 14.9663 29.1824 14.9663 29.6855V36.6038L23.5184 28.9308C23.6442 28.805 23.8957 28.6792 24.1472 28.6792H35.9693C37.6043 28.6792 38.9877 27.2956 38.9877 25.6604V5.03145C38.9877 3.39623 37.6043 2.01258 35.9693 2.01258H5.03068Z"
          fill="white"
        />
        <path
          d="M30.1302 9H10.9941C10.497 9 10 8.5 10 8C10 7.5 10.497 7 10.9941 7H30.0059C30.503 7 31 7.5 31 8C31 8.5 30.6272 9 30.1302 9Z"
          fill="white"
        />
        <path
          d="M30.1302 16H10.9941C10.497 16 10 15.5 10 15C10 14.5 10.497 14 10.9941 14H30.0059C30.503 14 31 14.5 31 15C31 15.5 30.6272 16 30.1302 16Z"
          fill="white"
        />
        <path
          d="M24.0164 23H10.9836C10.4918 23 10 22.5 10 22C10 21.5 10.4918 21 10.9836 21H24.0164C24.5082 21 25 21.5 25 22C25 22.5 24.5082 23 24.0164 23Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const CopyIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="2em"
        width="2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"></path>
      </svg>
    </React.Fragment>
  );
};

export const WhatsappIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8514_9736)">
          <path
            d="M10.0372 34.8897L10.701 35.2206C13.4671 36.875 16.5648 37.647 19.6627 37.647C29.3986 37.647 37.3644 29.7059 37.3644 20C37.3644 15.3677 35.4835 10.8456 32.1646 7.53671C28.8454 4.22783 24.4199 2.35291 19.6627 2.35291C9.92669 2.35291 1.96075 10.2941 2.07145 20.1103C2.07145 23.419 3.06718 26.6177 4.72666 29.3749L5.16917 30.0368L3.39914 36.5442L10.0372 34.8897Z"
            fill="#00E676"
          />
          <path
            d="M34.7234 5.83783C31.0176 2.05412 25.8951 0 20.6634 0C9.54642 0 0.609061 8.97294 0.717965 19.8918C0.717965 23.3513 1.69889 26.7028 3.33386 29.7297L0.5 40L11.0722 37.2973C14.0149 38.919 17.2846 39.6758 20.5545 39.6758C31.5626 39.6758 40.5 30.7027 40.5 19.784C40.5 14.4865 38.4291 9.51351 34.7235 5.83783H34.7234ZM20.6634 36.3245C17.7207 36.3245 14.7779 35.5678 12.2711 34.0543L11.6172 33.7299L5.29571 35.3515L6.93052 29.1894L6.49459 28.5407C1.69889 20.8651 3.98776 10.7027 11.8351 5.94585C19.6825 1.18917 29.8188 3.45949 34.6145 11.2433C39.41 19.027 37.1211 29.0811 29.2739 33.838C26.7669 35.4595 23.7153 36.3243 20.6634 36.3243V36.3245ZM30.2547 24.3246L29.0558 23.784C29.0558 23.784 27.3121 23.0272 26.2221 22.4867C26.113 22.4867 26.0041 22.3785 25.8951 22.3785C25.568 22.3785 25.3501 22.4867 25.1321 22.5948C25.1321 22.5948 25.0232 22.7029 23.4973 24.4326C23.3882 24.6488 23.1703 24.757 22.9523 24.757H22.8432C22.7343 24.757 22.5164 24.6488 22.4073 24.5408L21.8623 24.3246C20.6634 23.784 19.5736 23.1353 18.7016 22.2705C18.4836 22.0543 18.1566 21.8381 17.9386 21.6219C17.1757 20.8651 16.4127 20.0002 15.8679 19.0272L15.7588 18.811C15.6499 18.7028 15.6499 18.5948 15.5409 18.3786C15.5409 18.1624 15.5409 17.9462 15.6499 17.838C15.6499 17.838 16.0859 17.2974 16.4127 16.9732C16.6308 16.7569 16.7397 16.4326 16.9577 16.2164C17.1757 15.8921 17.2847 15.4597 17.1757 15.1353C17.0668 14.5947 15.7588 11.6758 15.432 11.0272C15.2138 10.7028 14.996 10.5948 14.669 10.4866H13.4701C13.252 10.4866 13.0342 10.5948 12.8161 10.5948L12.707 10.7028C12.489 10.811 12.2711 11.0272 12.0531 11.1352C11.8351 11.3516 11.7261 11.5676 11.5081 11.784C10.7452 12.757 10.3092 13.9461 10.3092 15.1353C10.3092 16.0001 10.5272 16.865 10.8542 17.6218L10.9633 17.9462C11.9442 20.0002 13.252 21.8381 14.996 23.4596L15.432 23.892C15.7588 24.2164 16.0859 24.4326 16.3038 24.7568C18.5927 26.7029 21.2084 28.1083 24.1512 28.8651C24.4782 28.9731 24.9141 28.9731 25.2412 29.0813H26.331C26.876 29.0813 27.5299 28.8651 27.966 28.6489C28.2928 28.4327 28.5108 28.4327 28.7288 28.2165L28.9469 28.0001C29.1649 27.7839 29.3828 27.6759 29.6008 27.4597C29.8188 27.2435 30.0367 27.0273 30.1458 26.811C30.3638 26.3786 30.4727 25.838 30.5817 25.2976V24.5408C30.5817 24.5408 30.4727 24.4326 30.2547 24.3246Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_8514_9736">
            <rect
              width="40"
              height="40"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const FolderIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="#FFFFFF"
        strokeWidth="0"
        viewBox="0 0 1024 1024"
        height="4em"
        width="4em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z"></path>
      </svg>
    </React.Fragment>
  );
};

export const DownloadIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1.5em"
        width="1.5em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="2"
          d="M1,17 L1,23 L23,23 L23,17 M12,2 L12,19 M5,12 L12,19 L19,12"
        ></path>
      </svg>
    </React.Fragment>
  );
};

export const ReloadIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        version="1.1"
        viewBox="0 0 17 17"
        height="1.8em"
        width="1.8em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g></g>
        <path d="M6 8h-6v-6h1v4.109c1.013-3.193 4.036-5.484 7.5-5.484 3.506 0 6.621 2.36 7.574 5.739l-0.963 0.271c-0.832-2.95-3.551-5.011-6.611-5.011-3.226 0.001-6.016 2.276-6.708 5.376h4.208v1zM11 9v1h4.208c-0.693 3.101-3.479 5.375-6.708 5.375-3.062 0-5.78-2.061-6.611-5.011l-0.963 0.271c0.952 3.379 4.067 5.739 7.574 5.739 3.459 0 6.475-2.28 7.5-5.482v4.108h1v-6h-6z"></path>
      </svg>
    </React.Fragment>
  );
};
export const ReciptsIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="19"
        height="24"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css + " mb-1"}
      >
        <g clipPath="url(#clip0_12418_7631)">
          <path
            d="M13.1008 5.50039C12.7008 5.50039 12.3008 5.20039 12.3008 4.70039C12.3008 4.30039 12.7008 3.90039 13.0008 3.90039C13.4008 3.90039 13.8008 4.30039 13.8008 4.70039C13.8008 5.20039 13.5008 5.50039 13.1008 5.50039Z"
            fill={props.color}
          />
          <path
            d="M15.4011 5.5C15.0011 5.5 14.6011 5.1 14.7011 4.7C14.7011 4.4 15.0011 4 15.4011 4C15.8011 4 16.2011 4.4 16.2011 4.8C16.2011 5.2 15.8011 5.5 15.4011 5.5Z"
            fill={props.color}
          />
          <path
            d="M5.30078 4.8C5.30078 4.4 5.70078 4 6.10078 4C6.50078 4 6.90078 4.4 6.90078 4.8C6.90078 5.2 6.60078 5.6 6.20078 5.6C5.70078 5.5 5.30078 5.2 5.30078 4.8Z"
            fill={props.color}
          />
          <path
            d="M9.20117 4.8C9.20117 5.2 8.80117 5.5 8.40117 5.5C8.00117 5.5 7.70117 5.2 7.70117 4.8C7.70117 4.4 8.00117 4 8.40117 4C8.80117 4 9.20117 4.4 9.20117 4.8Z"
            fill={props.color}
          />
          <path
            d="M10 4.8C10 4.4 10.4 4 10.8 4C11.2 4 11.6 4.4 11.6 4.8C11.6 5.2 11.2 5.6 10.8 5.6C10.3 5.5 10 5.2 10 4.8Z"
            fill={props.color}
          />
          <path
            d="M15.9004 10.2992H14.1004C14.4004 10.4992 14.6004 10.8992 14.7004 11.3992H15.9004V11.8992H14.7004C14.6004 12.9992 13.7004 13.6992 12.3004 13.6992C13.1004 14.5992 14.0004 15.6992 15.0004 16.7992H14.0004C13.2004 15.7992 12.4004 14.8992 11.4004 13.7992V13.0992H12.0004C13.2004 13.0992 13.8004 12.5992 13.9004 11.8992H11.5004V11.3992H13.9004C13.7004 10.7992 13.2004 10.4992 12.2004 10.4992H11.4004V9.69922H15.9004V10.2992Z"
            fill={props.color}
          />
          <path
            d="M16.1008 6.90039H5.30078V8.00039H16.1008V6.90039Z"
            fill={props.color}
          />
          <path
            d="M10.0008 11.2988H5.30078V12.2988H10.0008V11.2988Z"
            fill={props.color}
          />
          <path
            d="M10.0008 13.9004H5.30078V14.9004H10.0008V13.9004Z"
            fill={props.color}
          />
          <path
            d="M18.1004 18.7992H3.40039V3.69922H1.50039C1.30039 3.69922 1.20039 3.59922 1.10039 3.49922C1.00039 3.39922 0.900391 3.29922 0.900391 3.09922C0.900391 2.49922 1.10039 1.89922 1.40039 1.39922C1.70039 0.899219 2.20039 0.499219 2.70039 0.299219C2.90039 0.199219 3.20039 0.199219 3.90039 0.199219H15.4004C16.9004 0.199219 18.1004 1.39922 18.1004 2.89922V18.7992ZM4.40039 17.7992H17.1004V2.89922C17.1004 1.99922 16.3004 1.19922 15.4004 1.19922H3.90039C3.40039 1.19922 3.10039 1.19922 3.00039 1.19922C2.70039 1.39922 2.50039 1.59922 2.30039 1.89922C2.10039 2.09922 2.10039 2.39922 2.00039 2.69922H4.40039V17.7992Z"
            fill={props.color}
          />
          <path
            d="M18.2008 18.8996H3.30078V3.79961H1.50078C1.30078 3.79961 1.10078 3.69961 1.00078 3.59961C0.900781 3.49961 0.800781 3.29961 0.800781 3.09961C0.800781 2.39961 1.00078 1.79961 1.30078 1.29961C1.60078 0.699609 2.10078 0.399609 2.60078 0.199609C2.80078 0.0996094 3.10078 0.0996094 3.90078 0.0996094H15.4008C16.9008 0.0996094 18.2008 1.39961 18.2008 2.89961V18.8996ZM3.50078 18.6996H18.0008V2.89961C18.0008 1.49961 16.8008 0.299609 15.4008 0.299609H3.90078C3.20078 0.299609 2.90078 0.299609 2.70078 0.399609C2.20078 0.599609 1.80078 0.899609 1.50078 1.39961C1.20078 1.89961 1.00078 2.49961 1.00078 3.09961C1.00078 3.19961 1.00078 3.29961 1.10078 3.39961C1.20078 3.49961 1.30078 3.49961 1.40078 3.49961H3.40078V18.6996H3.50078ZM17.2008 17.8996H4.30078V2.79961H1.90078V2.69961C2.00078 2.39961 2.10078 2.09961 2.20078 1.79961C2.40078 1.49961 2.70078 1.29961 3.00078 1.19961C3.10078 1.19961 3.20078 1.19961 3.90078 1.19961H15.4008C16.4008 1.19961 17.2008 1.99961 17.2008 2.99961V17.8996ZM4.50078 17.6996H17.0008V2.89961C17.0008 1.99961 16.3008 1.29961 15.4008 1.29961H3.90078C3.20078 1.29961 3.10078 1.29961 3.00078 1.29961C2.80078 1.39961 2.50078 1.59961 2.40078 1.89961C2.30078 2.09961 2.20078 2.29961 2.10078 2.59961H4.50078V17.6996Z"
            fill={props.color}
          />
          <path
            d="M4.40078 3.199H3.90078H3.40078C3.40078 3.199 3.40078 2.799 3.40078 2.299C3.30078 1.499 3.10078 1.399 3.10078 1.299C3.10078 1.299 3.10078 1.299 3.00078 1.299L2.80078 0.298996C3.20078 0.198996 3.50078 0.298996 3.80078 0.498996C4.20078 0.798996 4.40078 1.399 4.50078 2.199C4.40078 2.699 4.40078 3.199 4.40078 3.199Z"
            fill={props.color}
          />
          <path
            d="M4.50156 3.29939H4.40156L3.30156 3.19939V3.09939C3.30156 3.09939 3.30156 2.69939 3.30156 2.19939C3.20156 1.59939 3.00156 1.39939 3.00156 1.39939H2.90156L2.60156 0.199387H2.70156C3.10156 0.0993867 3.50156 0.199387 3.80156 0.399387C4.20156 0.699387 4.40156 1.29939 4.50156 2.09939C4.50156 2.59939 4.50156 2.99939 4.50156 3.09939V3.29939ZM3.50156 2.99939L4.30156 3.09939C4.30156 2.89939 4.30156 2.59939 4.30156 2.19939C4.20156 1.39939 4.00156 0.899387 3.70156 0.599387C3.40156 0.399387 3.10156 0.299387 2.80156 0.399387L3.00156 1.19939H3.10156C3.20156 1.29939 3.40156 1.49939 3.40156 2.19939C3.50156 2.59939 3.50156 2.89939 3.50156 2.99939Z"
            fill={props.color}
          />
        </g>
        <defs>
          <clipPath id="clip0_12418_7631">
            <rect width="19" height="19" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const CarIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8304 5.82194L14.2282 2.10319C14.1871 2.0076 14.1186 1.92614 14.0314 1.86891C13.9441 1.81167 13.8419 1.78119 13.7374 1.78125H12.1352V0.71875C12.1352 0.577854 12.0789 0.442728 11.9788 0.3431C11.8786 0.243471 11.7428 0.1875 11.6011 0.1875H7.86271V1.25H11.0671V7.92037C10.8237 8.06094 10.6108 8.24804 10.4404 8.47088C10.2701 8.69372 10.1459 8.9479 10.0748 9.21875H6.71875C6.60258 8.76281 6.33689 8.35842 5.96371 8.06956C5.59054 7.78071 5.13119 7.62387 4.65835 7.62387C4.1855 7.62387 3.72616 7.78071 3.35298 8.06956C2.97981 8.35842 2.71412 8.76281 2.59794 9.21875H1.98804V4.4375H0.919922V9.75C0.919922 9.8909 0.976189 10.026 1.07634 10.1257C1.1765 10.2253 1.31234 10.2812 1.45398 10.2812H2.59794C2.71412 10.7372 2.97981 11.1416 3.35298 11.4304C3.72616 11.7193 4.1855 11.8761 4.65835 11.8761C5.13119 11.8761 5.59054 11.7193 5.96371 11.4304C6.33689 11.1416 6.60258 10.7372 6.71875 10.2812H10.0748C10.191 10.7372 10.4567 11.1416 10.8298 11.4304C11.203 11.7193 11.6624 11.8761 12.1352 11.8761C12.608 11.8761 13.0674 11.7193 13.4406 11.4304C13.8137 11.1416 14.0794 10.7372 14.1956 10.2812H15.3396C15.4812 10.2812 15.617 10.2253 15.7172 10.1257C15.8174 10.026 15.8736 9.8909 15.8736 9.75V6.03125C15.8737 5.95928 15.8589 5.88806 15.8304 5.82194ZM4.65835 10.8125C4.44709 10.8125 4.24058 10.7502 4.06493 10.6334C3.88928 10.5167 3.75238 10.3507 3.67153 10.1566C3.59069 9.96245 3.56954 9.74882 3.61075 9.54272C3.65196 9.33661 3.75369 9.14729 3.90307 8.9987C4.05245 8.85011 4.24277 8.74891 4.44997 8.70792C4.65716 8.66692 4.87193 8.68796 5.0671 8.76838C5.26227 8.8488 5.42909 8.98498 5.54646 9.15971C5.66383 9.33443 5.72647 9.53986 5.72647 9.75C5.72605 10.0317 5.61338 10.3017 5.41316 10.5008C5.21294 10.7 4.9415 10.8121 4.65835 10.8125ZM12.1352 2.84375H13.3849L14.5299 5.5H12.1352V2.84375ZM12.1352 10.8125C11.9239 10.8125 11.7174 10.7502 11.5418 10.6334C11.3661 10.5167 11.2292 10.3507 11.1484 10.1566C11.0675 9.96245 11.0464 9.74882 11.0876 9.54272C11.1288 9.33661 11.2305 9.14729 11.3799 8.9987C11.5293 8.85011 11.7196 8.74891 11.9268 8.70792C12.134 8.66692 12.3488 8.68796 12.544 8.76838C12.7391 8.8488 12.9059 8.98498 13.0233 9.15971C13.1407 9.33443 13.2033 9.53986 13.2033 9.75C13.203 10.0317 13.0904 10.3018 12.8902 10.501C12.6899 10.7002 12.4184 10.8122 12.1352 10.8125ZM14.8055 9.21875H14.1956C14.078 8.7637 13.8118 8.36034 13.439 8.07192C13.0661 7.78349 12.6075 7.62631 12.1352 7.625V6.5625H14.8055V9.21875Z"
          fill="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const CartIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.25258 5.33333C7.06753 5.33333 6.91231 5.26933 6.78691 5.14133C6.66151 5.01333 6.59903 4.85511 6.59947 4.66667V3.33333H5.29324C5.1082 3.33333 4.95297 3.26933 4.82758 3.14133C4.70218 3.01333 4.6397 2.85511 4.64013 2.66667C4.64013 2.47778 4.70283 2.31934 4.82823 2.19134C4.95363 2.06334 5.10863 1.99956 5.29324 2H6.59947V0.666669C6.59947 0.47778 6.66216 0.319336 6.78756 0.191336C6.91296 0.0633356 7.06796 -0.000442138 7.25258 2.30681e-06C7.43762 2.30681e-06 7.59285 0.0640023 7.71824 0.192002C7.84364 0.320002 7.90612 0.478224 7.90569 0.666669V2H9.21191C9.39696 2 9.55218 2.064 9.67758 2.192C9.80297 2.32 9.86545 2.47822 9.86502 2.66667C9.86502 2.85556 9.80232 3.014 9.67692 3.142C9.55152 3.27 9.39652 3.33378 9.21191 3.33333H7.90569V4.66667C7.90569 4.85556 7.84299 5.014 7.71759 5.142C7.59219 5.27 7.43719 5.33378 7.25258 5.33333ZM3.98702 14C3.62781 14 3.3202 13.8693 3.06418 13.608C2.80816 13.3467 2.68037 13.0329 2.6808 12.6667C2.6808 12.3 2.80881 11.986 3.06483 11.7247C3.32085 11.4633 3.62825 11.3329 3.98702 11.3333C4.34623 11.3333 4.65385 11.464 4.90987 11.7253C5.16589 11.9867 5.29368 12.3004 5.29324 12.6667C5.29324 13.0333 5.16523 13.3473 4.90922 13.6087C4.6532 13.87 4.3458 14.0004 3.98702 14ZM10.5181 14C10.1589 14 9.8513 13.8693 9.59528 13.608C9.33926 13.3467 9.21147 13.0329 9.21191 12.6667C9.21191 12.3 9.33992 11.986 9.59594 11.7247C9.85196 11.4633 10.1594 11.3329 10.5181 11.3333C10.8773 11.3333 11.185 11.464 11.441 11.7253C11.697 11.9867 11.8248 12.3004 11.8243 12.6667C11.8243 13.0333 11.6963 13.3473 11.4403 13.6087C11.1843 13.87 10.8769 14.0004 10.5181 14ZM3.98702 10.6667C3.48631 10.6667 3.10794 10.4471 2.85192 10.008C2.5959 9.56889 2.59329 9.13289 2.84408 8.7L3.72578 7.06667L1.37458 2H0.721472C0.536424 2 0.381201 1.936 0.255804 1.808C0.130407 1.68 0.0679262 1.52178 0.0683616 1.33334C0.0683616 1.14445 0.13106 0.986002 0.256457 0.858002C0.381855 0.730002 0.536859 0.666224 0.721472 0.666669H1.7991C1.91884 0.666669 2.03314 0.700002 2.14199 0.766669C2.25084 0.833336 2.33248 0.92778 2.3869 1.05L4.98302 6.66667H9.57112L11.9223 2.33334C11.9767 2.23334 12.0529 2.15267 12.1509 2.09134C12.2489 2.03 12.3577 1.99956 12.4775 2C12.7278 2 12.9157 2.10845 13.0411 2.32534C13.1665 2.54222 13.1691 2.76156 13.0489 2.98333L10.7141 7.3C10.5943 7.52222 10.4337 7.69445 10.2321 7.81667C10.0305 7.93889 9.81016 8 9.57112 8H4.70545L3.98702 9.33333H11.1712C11.3563 9.33333 11.5115 9.39733 11.6369 9.52533C11.7623 9.65333 11.8248 9.81156 11.8243 10C11.8243 10.1889 11.7617 10.3473 11.6363 10.4753C11.5109 10.6033 11.3559 10.6671 11.1712 10.6667H3.98702Z"
          fill="#7A7A7A"
        />
        <path
          d="M7.25258 5.33333C7.06753 5.33333 6.91231 5.26933 6.78691 5.14133C6.66151 5.01333 6.59903 4.85511 6.59947 4.66667V3.33333H5.29324C5.1082 3.33333 4.95297 3.26933 4.82758 3.14133C4.70218 3.01333 4.6397 2.85511 4.64013 2.66667C4.64013 2.47778 4.70283 2.31934 4.82823 2.19134C4.95363 2.06334 5.10863 1.99956 5.29324 2H6.59947V0.666669C6.59947 0.47778 6.66216 0.319336 6.78756 0.191336C6.91296 0.0633356 7.06796 -0.000442138 7.25258 2.30681e-06C7.43762 2.30681e-06 7.59285 0.0640023 7.71824 0.192002C7.84364 0.320002 7.90612 0.478224 7.90569 0.666669V2H9.21191C9.39696 2 9.55218 2.064 9.67758 2.192C9.80297 2.32 9.86545 2.47822 9.86502 2.66667C9.86502 2.85556 9.80232 3.014 9.67692 3.142C9.55152 3.27 9.39652 3.33378 9.21191 3.33333H7.90569V4.66667C7.90569 4.85556 7.84299 5.014 7.71759 5.142C7.59219 5.27 7.43719 5.33378 7.25258 5.33333ZM3.98702 14C3.62781 14 3.3202 13.8693 3.06418 13.608C2.80816 13.3467 2.68037 13.0329 2.6808 12.6667C2.6808 12.3 2.80881 11.986 3.06483 11.7247C3.32085 11.4633 3.62825 11.3329 3.98702 11.3333C4.34623 11.3333 4.65385 11.464 4.90987 11.7253C5.16589 11.9867 5.29368 12.3004 5.29324 12.6667C5.29324 13.0333 5.16523 13.3473 4.90922 13.6087C4.6532 13.87 4.3458 14.0004 3.98702 14ZM10.5181 14C10.1589 14 9.8513 13.8693 9.59528 13.608C9.33926 13.3467 9.21147 13.0329 9.21191 12.6667C9.21191 12.3 9.33992 11.986 9.59594 11.7247C9.85196 11.4633 10.1594 11.3329 10.5181 11.3333C10.8773 11.3333 11.185 11.464 11.441 11.7253C11.697 11.9867 11.8248 12.3004 11.8243 12.6667C11.8243 13.0333 11.6963 13.3473 11.4403 13.6087C11.1843 13.87 10.8769 14.0004 10.5181 14ZM3.98702 10.6667C3.48631 10.6667 3.10794 10.4471 2.85192 10.008C2.5959 9.56889 2.59329 9.13289 2.84408 8.7L3.72578 7.06667L1.37458 2H0.721472C0.536424 2 0.381201 1.936 0.255804 1.808C0.130407 1.68 0.0679262 1.52178 0.0683616 1.33334C0.0683616 1.14445 0.13106 0.986002 0.256457 0.858002C0.381855 0.730002 0.536859 0.666224 0.721472 0.666669H1.7991C1.91884 0.666669 2.03314 0.700002 2.14199 0.766669C2.25084 0.833336 2.33248 0.92778 2.3869 1.05L4.98302 6.66667H9.57112L11.9223 2.33334C11.9767 2.23334 12.0529 2.15267 12.1509 2.09134C12.2489 2.03 12.3577 1.99956 12.4775 2C12.7278 2 12.9157 2.10845 13.0411 2.32534C13.1665 2.54222 13.1691 2.76156 13.0489 2.98333L10.7141 7.3C10.5943 7.52222 10.4337 7.69445 10.2321 7.81667C10.0305 7.93889 9.81016 8 9.57112 8H4.70545L3.98702 9.33333H11.1712C11.3563 9.33333 11.5115 9.39733 11.6369 9.52533C11.7623 9.65333 11.8248 9.81156 11.8243 10C11.8243 10.1889 11.7617 10.3473 11.6363 10.4753C11.5109 10.6033 11.3559 10.6671 11.1712 10.6667H3.98702Z"
          stroke="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const SettingIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="15"
        height="13"
        viewBox="0 0 15 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8182 13L10.6161 12.025C10.4813 11.9708 10.3549 11.9141 10.2368 11.8547C10.1191 11.7949 9.99855 11.7217 9.87505 11.635L8.89826 11.9275L8.22461 10.8225L8.99931 10.1725C8.97685 10.0208 8.96562 9.88 8.96562 9.75C8.96562 9.62 8.97685 9.47917 8.99931 9.3275L8.22461 8.6775L8.89826 7.5725L9.87505 7.865C9.99855 7.77833 10.1191 7.7051 10.2368 7.6453C10.3549 7.58593 10.4813 7.52917 10.6161 7.475L10.8182 6.5H12.1655L12.3675 7.475C12.5023 7.52917 12.6287 7.58875 12.7468 7.65375C12.8645 7.71875 12.9851 7.8 13.1086 7.8975L14.0854 7.5725L14.759 8.71L13.9843 9.36C14.0068 9.49 14.018 9.62542 14.018 9.76625C14.018 9.90708 14.0068 10.0425 13.9843 10.1725L14.759 10.8225L14.0854 11.9275L13.1086 11.635C12.9851 11.7217 12.8645 11.7949 12.7468 11.8547C12.6287 11.9141 12.5023 11.9708 12.3675 12.025L12.1655 13H10.8182ZM11.4918 11.05C11.8623 11.05 12.1796 10.9228 12.4437 10.6684C12.7073 10.4136 12.8391 10.1075 12.8391 9.75C12.8391 9.3925 12.7073 9.08635 12.4437 8.83155C12.1796 8.57718 11.8623 8.45 11.4918 8.45C11.1213 8.45 10.8042 8.57718 10.5406 8.83155C10.2765 9.08635 10.1445 9.3925 10.1445 9.75C10.1445 10.1075 10.2765 10.4136 10.5406 10.6684C10.8042 10.9228 11.1213 11.05 11.4918 11.05Z"
          fill="#7A7A7A"
        />
        <circle cx="7.0957" cy="3.25" r="2.75" stroke="#7A7A7A" />
        <path
          d="M7.09686 7.58203C4.86359 7.67602 2.22186 8.66536 1.68019 9.20703C1.13853 9.7487 1.68019 11.9154 1.68019 11.9154C1.68019 11.9154 5.31165 11.9154 7.63853 11.9154"
          stroke="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const IndustryIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="11"
        viewBox="0 0 16 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.3384 9.49878H14.8358V1.61753L15.4434 1.48753C15.5093 1.47522 15.5721 1.44991 15.6281 1.41309C15.684 1.37626 15.732 1.32867 15.7692 1.27311C15.8063 1.21755 15.8319 1.15515 15.8445 1.08959C15.857 1.02403 15.8563 0.95663 15.8422 0.891372C15.8282 0.826113 15.8011 0.764314 15.7627 0.709616C15.7242 0.654918 15.6752 0.608428 15.6184 0.572888C15.5616 0.537348 15.4982 0.513476 15.432 0.502679C15.3658 0.491883 15.2981 0.494381 15.2329 0.510026L1.15881 3.51003C1.03756 3.53605 0.930269 3.60575 0.85757 3.70573C0.784871 3.8057 0.7519 3.92888 0.764998 4.05158C0.778097 4.17427 0.83634 4.28782 0.928525 4.37037C1.02071 4.45293 1.14033 4.49866 1.26436 4.49878C1.30006 4.49871 1.33564 4.49494 1.37055 4.48753L1.76701 4.40315V9.49878H1.26436C1.13105 9.49878 1.0032 9.55145 0.90894 9.64522C0.814676 9.73899 0.761719 9.86617 0.761719 9.99878C0.761719 10.1314 0.814676 10.2586 0.90894 10.3523C1.0032 10.4461 1.13105 10.4988 1.26436 10.4988H15.3384C15.4717 10.4988 15.5996 10.4461 15.6939 10.3523C15.7881 10.2586 15.8411 10.1314 15.8411 9.99878C15.8411 9.86617 15.7881 9.73899 15.6939 9.64522C15.5996 9.55145 15.4717 9.49878 15.3384 9.49878ZM2.7723 4.18628L13.8305 1.8319V9.49878H12.3226V5.99878C12.3226 5.86617 12.2696 5.73899 12.1753 5.64522C12.0811 5.55145 11.9532 5.49878 11.8199 5.49878H4.78288C4.64957 5.49878 4.52172 5.55145 4.42746 5.64522C4.33319 5.73899 4.28024 5.86617 4.28024 5.99878V9.49878H2.7723V4.18628ZM11.3173 7.49878H5.28553V6.49878H11.3173V7.49878ZM5.28553 8.49878H11.3173V9.49878H5.28553V8.49878Z"
          fill="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const ArrowIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.58678 7.98103L6.58678 7.98102C6.64497 7.91174 6.72839 7.86839 6.81853 7.86006C6.90866 7.85173 6.99864 7.87904 7.06868 7.93632C7.13878 7.99363 7.18323 8.07636 7.19179 8.16647C7.20034 8.2566 7.17223 8.34619 7.11399 8.41553L4.12215 11.9778L4.12187 11.9781C4.0566 12.0551 3.9601 12.1 3.85855 12.1H3.85853C3.8084 12.1 3.75884 12.0891 3.71337 12.068C3.66793 12.047 3.62763 12.0162 3.5954 11.9779L6.58678 7.98103ZM6.58678 7.98103L4.19476 10.8295V1.55875C4.19476 1.46828 4.15833 1.3818 4.09392 1.31824C4.02955 1.25473 3.94253 1.21928 3.85208 1.21928C3.76162 1.21928 3.6746 1.25473 3.61023 1.31824C3.54582 1.3818 3.50939 1.46828 3.50939 1.55875V10.817L1.11728 7.9806C1.11728 7.98059 1.11727 7.98059 1.11727 7.98058C1.11726 7.98057 1.11725 7.98056 1.11724 7.98055C1.08839 7.94631 1.05307 7.91809 1.01332 7.89744C0.973554 7.87677 0.930111 7.86407 0.885467 7.86C0.840825 7.85594 0.795797 7.86059 0.752935 7.8737C0.710072 7.88681 0.670169 7.90815 0.635525 7.93656C0.600878 7.96497 0.572159 7.9999 0.551072 8.03941C0.529984 8.07893 0.516959 8.12221 0.51279 8.16679C0.50862 8.21137 0.513394 8.25632 0.526819 8.29904C0.540243 8.34176 0.562039 8.38137 0.590896 8.41563L0.590941 8.41568L3.59531 11.9778L6.58678 7.98103ZM12.5872 4.98595L12.6505 5.0633C12.7205 5.00596 12.7649 4.92326 12.7733 4.83321C12.7818 4.74315 12.7536 4.65366 12.6954 4.58442L12.6953 4.58432L9.24166 1.08653L9.16508 1.02221L9.16492 1.0224L6.17292 4.58447L6.17243 4.58506C6.11505 4.65445 6.08761 4.74367 6.09647 4.83326C6.10532 4.92284 6.14968 5.005 6.21939 5.062C6.28905 5.11895 6.37845 5.14625 6.46811 5.13829C6.55778 5.13033 6.64095 5.0877 6.69933 5.01922L6.69981 5.01865L9.09182 2.17048V11.4413C9.09182 11.5317 9.12826 11.6182 9.19267 11.6818C9.25703 11.7453 9.34405 11.7807 9.43451 11.7807C9.52497 11.7807 9.61199 11.7453 9.67635 11.6818C9.74076 11.6182 9.7772 11.5317 9.7772 11.4413V2.18269L12.1689 5.0186C12.169 5.0187 12.1691 5.0188 12.1692 5.0189C12.1978 5.05328 12.233 5.08166 12.2727 5.10244C12.3125 5.12329 12.356 5.13611 12.4007 5.14021C12.4455 5.14431 12.4906 5.13962 12.5335 5.12638C12.5765 5.11314 12.6164 5.09161 12.651 5.06296L12.5872 4.98595ZM12.5872 4.98595C12.6367 4.94539 12.6678 4.88708 12.6738 4.82385C12.6797 4.76062 12.66 4.69765 12.6189 4.64879L9.61475 1.08653C9.59198 1.05953 9.56349 1.03779 9.53129 1.02284L12.5872 4.98595Z"
          fill="#7A7A7A"
          stroke="#7A7A7A"
          strokeWidth="0.2"
        />
      </svg>
    </React.Fragment>
  );
};
export const UpArrowIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="2em"
        width="2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11 8.414V18h2V8.414l4.293 4.293 1.414-1.414L12 4.586l-6.707 6.707 1.414 1.414z"></path>
      </svg>
    </React.Fragment>
  );
};
export const DateIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.875 1.5H9.625V0.875C9.625 0.70924 9.55915 0.550268 9.44194 0.433058C9.32473 0.315848 9.16576 0.25 9 0.25C8.83424 0.25 8.67527 0.315848 8.55806 0.433058C8.44085 0.550268 8.375 0.70924 8.375 0.875V1.5H4.625V0.875C4.625 0.70924 4.55915 0.550268 4.44194 0.433058C4.32473 0.315848 4.16576 0.25 4 0.25C3.83424 0.25 3.67527 0.315848 3.55806 0.433058C3.44085 0.550268 3.375 0.70924 3.375 0.875V1.5H2.125C1.62772 1.5 1.15081 1.69754 0.799175 2.04917C0.447544 2.40081 0.25 2.87772 0.25 3.375V10.875C0.25 11.3723 0.447544 11.8492 0.799175 12.2008C1.15081 12.5525 1.62772 12.75 2.125 12.75H10.875C11.3723 12.75 11.8492 12.5525 12.2008 12.2008C12.5525 11.8492 12.75 11.3723 12.75 10.875V3.375C12.75 2.87772 12.5525 2.40081 12.2008 2.04917C11.8492 1.69754 11.3723 1.5 10.875 1.5ZM11.5 10.875C11.5 11.0408 11.4342 11.1997 11.3169 11.3169C11.1997 11.4342 11.0408 11.5 10.875 11.5H2.125C1.95924 11.5 1.80027 11.4342 1.68306 11.3169C1.56585 11.1997 1.5 11.0408 1.5 10.875V6.5H11.5V10.875ZM11.5 5.25H1.5V3.375C1.5 3.20924 1.56585 3.05027 1.68306 2.93306C1.80027 2.81585 1.95924 2.75 2.125 2.75H3.375V3.375C3.375 3.54076 3.44085 3.69973 3.55806 3.81694C3.67527 3.93415 3.83424 4 4 4C4.16576 4 4.32473 3.93415 4.44194 3.81694C4.55915 3.69973 4.625 3.54076 4.625 3.375V2.75H8.375V3.375C8.375 3.54076 8.44085 3.69973 8.55806 3.81694C8.67527 3.93415 8.83424 4 9 4C9.16576 4 9.32473 3.93415 9.44194 3.81694C9.55915 3.69973 9.625 3.54076 9.625 3.375V2.75H10.875C11.0408 2.75 11.1997 2.81585 11.3169 2.93306C11.4342 3.05027 11.5 3.20924 11.5 3.375V5.25Z"
          fill="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const EyeTwo = () => {
  return (
    <React.Fragment>
      <svg
        width="26"
        height="21"
        viewBox="0 0 26 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.9445 10.0675C24.9251 7.31799 23.1554 4.94021 20.8542 3.22805C18.553 1.51588 15.8211 0.544368 12.9961 0.433594C10.1711 0.544368 7.43921 1.51588 5.13798 3.22805C2.83675 4.94021 1.06709 7.31799 0.0477265 10.0675C-0.0211172 10.2661 -0.0211172 10.4835 0.0477265 10.682C1.06709 13.4315 2.83675 15.8093 5.13798 17.5215C7.43921 19.2337 10.1711 20.2052 12.9961 20.3159C15.8211 20.2052 18.553 19.2337 20.8542 17.5215C23.1554 15.8093 24.9251 13.4315 25.9445 10.682C26.0133 10.4835 26.0133 10.2661 25.9445 10.0675ZM12.9961 18.5085C8.40263 18.5085 3.54916 14.9567 1.78978 10.3748C3.54916 5.79279 8.40263 2.24108 12.9961 2.24108C17.5896 2.24108 22.443 5.79279 24.2024 10.3748C22.443 14.9567 17.5896 18.5085 12.9961 18.5085Z"
          fill="#7A7A7A"
        />
        <path
          d="M12.9994 5.02344C11.9407 5.02344 10.9058 5.33738 10.0255 5.92557C9.14521 6.51376 8.45911 7.34977 8.05396 8.3279C7.6488 9.30602 7.5428 10.3823 7.74934 11.4207C7.95589 12.4591 8.4657 13.4129 9.21433 14.1615C9.96295 14.9101 10.9168 15.4199 11.9551 15.6265C12.9935 15.833 14.0698 15.727 15.0479 15.3219C16.026 14.9167 16.862 14.2306 17.4502 13.3503C18.0384 12.47 18.3524 11.4351 18.3524 10.3764C18.3524 8.95669 17.7884 7.59515 16.7845 6.59128C15.7807 5.58741 14.4191 5.02344 12.9994 5.02344ZM12.9994 13.945C12.2936 13.945 11.6037 13.7357 11.0168 13.3436C10.4299 12.9515 9.97255 12.3941 9.70245 11.742C9.43234 11.09 9.36167 10.3724 9.49937 9.68017C9.63707 8.98793 9.97695 8.35206 10.476 7.85298C10.9751 7.3539 11.611 7.01402 12.3032 6.87632C12.9955 6.73862 13.713 6.8093 14.3651 7.0794C15.0172 7.3495 15.5745 7.8069 15.9666 8.39376C16.3588 8.98061 16.5681 9.67057 16.5681 10.3764C16.5681 11.3228 16.1921 12.2305 15.5228 12.8998C14.8536 13.569 13.9459 13.945 12.9994 13.945Z"
          fill="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const Copy = () => {
  return (
    <React.Fragment>
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.75065 9.5H1.58398V30.0833C1.58398 31.825 3.00898 33.25 4.75065 33.25H31.6673V30.0833H4.75065V9.5Z"
          fill="black"
        />
        <path
          d="M33.2493 6.0026H22.166L18.9993 2.83594H11.0827C9.34102 2.83594 7.93185 4.26094 7.93185 6.0026L7.91602 23.4193C7.91602 25.1609 9.34102 26.5859 11.0827 26.5859H33.2493C34.991 26.5859 36.416 25.1609 36.416 23.4193V9.16927C36.416 7.4276 34.991 6.0026 33.2493 6.0026Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const Type = () => {
  return (
    <React.Fragment>
      <svg
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5363 6.42188L13.7488 7.48438C13.8905 7.5434 14.0234 7.60526 14.1476 7.66996C14.2713 7.73512 14.3981 7.81493 14.528 7.90938L15.5551 7.59062L16.2634 8.79479L15.4488 9.50313C15.4724 9.64479 15.4842 9.79826 15.4842 9.96354C15.4842 10.1288 15.4724 10.2823 15.4488 10.424L16.2634 11.1323L15.5551 12.3365L14.528 12.0177C14.3981 12.1122 14.2713 12.192 14.1476 12.2571C14.0234 12.3218 13.8905 12.3837 13.7488 12.4427L13.5363 13.5052H12.1197L11.9072 12.4427C11.7655 12.3837 11.6328 12.3218 11.5091 12.2571C11.3849 12.192 11.2579 12.1122 11.128 12.0177L10.1009 12.3365L9.39258 11.1323L10.2072 10.424C10.1836 10.2823 10.1717 10.1288 10.1717 9.96354C10.1717 9.79826 10.1836 9.64479 10.2072 9.50313L9.39258 8.79479L10.1009 7.59062L11.128 7.90938C11.2579 7.81493 11.3849 7.73512 11.5091 7.66996C11.6328 7.60526 11.7655 7.5434 11.9072 7.48438L12.1197 6.42188H13.5363ZM12.828 8.54688C12.4384 8.54688 12.1048 8.68547 11.8271 8.96267C11.5499 9.24033 11.4113 9.57396 11.4113 9.96354C11.4113 10.3531 11.5499 10.6867 11.8271 10.9644C12.1048 11.2416 12.4384 11.3802 12.828 11.3802C13.2176 11.3802 13.5512 11.2416 13.8289 10.9644C14.1061 10.6867 14.2447 10.3531 14.2447 9.96354C14.2447 9.57396 14.1061 9.24033 13.8289 8.96267C13.5512 8.68547 13.2176 8.54688 12.828 8.54688Z"
          fill="#7A7A7A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7478 3.79451C14.212 1.49428 11.3124 0.41059 8.43158 0.458555C5.5557 0.506438 2.75692 1.68082 0.410156 3.79249L1.41349 4.90753C3.5239 3.00855 5.98418 1.99951 8.45655 1.95835C10.924 1.91726 13.4618 2.8389 15.7399 4.90551L16.7478 3.79451ZM4.4772 8.03296C5.70992 6.911 7.00973 6.34664 8.23048 6.32099C8.56623 6.31394 8.9039 6.34742 9.24068 6.42535C9.68006 5.98427 10.2075 5.63101 10.7945 5.39421C9.96553 4.99349 9.09132 4.80258 8.19898 4.82132C6.52768 4.85643 4.89522 5.62424 3.46755 6.92364L4.4772 8.03296ZM7.9205 9.14008C7.8982 9.32464 7.88672 9.51254 7.88672 9.70312C7.88672 10.0378 7.92211 10.3642 7.98936 10.6787C7.80683 10.7513 7.64927 10.8584 7.54696 10.971L6.43699 9.962C6.80106 9.56148 7.33901 9.25832 7.9205 9.14008Z"
          fill="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const BlackPrint = () => {
  return (
    <React.Fragment>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.1694 4.23863H3.39488V1.79501C3.39488 1.56423 3.47308 1.37064 3.62947 1.21424C3.78586 1.05785 3.97918 0.979929 4.20942 0.980472H12.3548C12.5856 0.980472 12.7792 1.05867 12.9356 1.21506C13.092 1.37145 13.1699 1.56477 13.1694 1.79501V4.23863ZM13.1694 8.7186C13.4001 8.7186 13.5937 8.64041 13.7501 8.48401C13.9065 8.32762 13.9844 8.1343 13.9839 7.90406C13.9839 7.67328 13.9057 7.47969 13.7493 7.32329C13.5929 7.1669 13.3996 7.08898 13.1694 7.08952C12.9386 7.08952 12.745 7.16772 12.5886 7.32411C12.4322 7.4805 12.3543 7.67382 12.3548 7.90406C12.3548 8.13485 12.433 8.32844 12.5894 8.48483C12.7458 8.64122 12.9391 8.71914 13.1694 8.7186ZM5.02396 14.0131H11.5403V10.755H5.02396V14.0131ZM5.02396 15.6422C4.57596 15.6422 4.19232 15.4825 3.87302 15.1632C3.55372 14.8439 3.39434 14.4606 3.39488 14.0131V12.384H0.951262C0.720475 12.384 0.526886 12.3058 0.370494 12.1494C0.214103 11.9931 0.136179 11.7997 0.136722 11.5695V7.49679C0.136722 6.80443 0.374296 6.22394 0.849444 5.75531C1.32459 5.28667 1.90156 5.05263 2.58034 5.05317H13.9839C14.6763 5.05317 15.2568 5.28749 15.7254 5.75612C16.194 6.22475 16.4281 6.80498 16.4275 7.49679V11.5695C16.4275 11.8003 16.3493 11.9939 16.1929 12.1503C16.0365 12.3066 15.8432 12.3846 15.613 12.384H13.1694V14.0131C13.1694 14.4611 13.0097 14.8448 12.6904 15.1641C12.3711 15.4834 11.9877 15.6427 11.5403 15.6422H5.02396Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const Loadmore = (props) => {
  return (
    <React.Fragment>
      <svg
        className={props.className}
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.9606 4.3582L26.9777 5.90859C24.2742 2.45273 20.0695 0.234375 15.3481 0.234375C7.19533 0.234375 0.596497 6.82617 0.58595 14.9824C0.575403 23.1457 7.18829 29.7656 15.3481 29.7656C21.7219 29.7656 27.1535 25.7227 29.2207 20.059C29.2735 19.9113 29.1961 19.7461 29.0485 19.6969L27.0551 19.0113C26.9856 18.9875 26.9095 18.9918 26.8432 19.0234C26.7768 19.0549 26.7254 19.1111 26.7 19.1801C26.6367 19.3559 26.5664 19.5316 26.4926 19.7039C25.8844 21.1453 25.0125 22.4391 23.9016 23.55C22.7996 24.654 21.4949 25.535 20.059 26.1445C18.5719 26.7738 16.9863 27.0938 15.3551 27.0938C13.7203 27.0938 12.1383 26.7738 10.6512 26.1445C9.21391 25.5376 7.90872 24.6563 6.80861 23.55C5.70365 22.4482 4.82362 21.1419 4.21759 19.7039C3.58829 18.2133 3.26837 16.6313 3.26837 14.9965C3.26837 13.3617 3.58829 11.7797 4.21759 10.2891C4.82579 8.84766 5.69767 7.55391 6.80861 6.44297C7.91954 5.33203 9.21329 4.46016 10.6512 3.84844C12.1383 3.21914 13.7238 2.89922 15.3551 2.89922C16.9899 2.89922 18.5719 3.21914 20.059 3.84844C21.4963 4.45539 22.8015 5.33667 23.9016 6.44297C24.2496 6.79102 24.5766 7.16016 24.8789 7.54688L22.7625 9.19922C22.7206 9.23161 22.6888 9.27517 22.6705 9.32487C22.6523 9.37458 22.6485 9.42842 22.6595 9.48021C22.6705 9.53199 22.6959 9.57961 22.7328 9.61759C22.7697 9.65558 22.8165 9.68238 22.868 9.69492L29.0414 11.2066C29.2172 11.2488 29.3895 11.1152 29.3895 10.9359L29.4176 4.57617C29.4141 4.34414 29.1434 4.21406 28.9606 4.3582Z"
          fill="black"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};

export const DownloadIcongrey = (props) => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8462 15.75C13.8462 15.5469 13.7776 15.3711 13.6406 15.2227C13.5036 15.0742 13.3413 15 13.1538 15C12.9663 15 12.8041 15.0742 12.6671 15.2227C12.53 15.3711 12.4615 15.5469 12.4615 15.75C12.4615 15.9531 12.53 16.1289 12.6671 16.2773C12.8041 16.4258 12.9663 16.5 13.1538 16.5C13.3413 16.5 13.5036 16.4258 13.6406 16.2773C13.7776 16.1289 13.8462 15.9531 13.8462 15.75ZM16.6154 15.75C16.6154 15.5469 16.5469 15.3711 16.4099 15.2227C16.2728 15.0742 16.1106 15 15.9231 15C15.7356 15 15.5733 15.0742 15.4363 15.2227C15.2993 15.3711 15.2308 15.5469 15.2308 15.75C15.2308 15.9531 15.2993 16.1289 15.4363 16.2773C15.5733 16.4258 15.7356 16.5 15.9231 16.5C16.1106 16.5 16.2728 16.4258 16.4099 16.2773C16.5469 16.1289 16.6154 15.9531 16.6154 15.75ZM18 13.125V16.875C18 17.1875 17.899 17.4531 17.6971 17.6719C17.4952 17.8906 17.25 18 16.9615 18H1.03846C0.75 18 0.504808 17.8906 0.302885 17.6719C0.100962 17.4531 0 17.1875 0 16.875V13.125C0 12.8125 0.100962 12.5469 0.302885 12.3281C0.504808 12.1094 0.75 12 1.03846 12H6.06851L7.52885 13.5938C7.94712 14.0312 8.4375 14.25 9 14.25C9.5625 14.25 10.0529 14.0312 10.4712 13.5938L11.9423 12H16.9615C17.25 12 17.4952 12.1094 17.6971 12.3281C17.899 12.5469 18 12.8125 18 13.125ZM14.4844 6.45703C14.607 6.77734 14.5565 7.05078 14.3329 7.27734L9.48678 12.5273C9.35697 12.6758 9.19471 12.75 9 12.75C8.80529 12.75 8.64303 12.6758 8.51322 12.5273L3.66707 7.27734C3.44351 7.05078 3.39303 6.77734 3.51562 6.45703C3.63822 6.15234 3.85096 6 4.15385 6H6.92308V0.75C6.92308 0.546875 6.99159 0.371094 7.12861 0.222656C7.26562 0.0742188 7.42788 0 7.61539 0H10.3846C10.5721 0 10.7344 0.0742188 10.8714 0.222656C11.0084 0.371094 11.0769 0.546875 11.0769 0.75V6H13.8462C14.149 6 14.3618 6.15234 14.4844 6.45703Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};

export const OrdersIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        className={props.className}
        width="24"
        height="30"
        viewBox="0 0 24 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.2381 0.5H0.761905C0.342857 0.5 0 0.842857 0 1.2619V31.1667C0 31.4333 0.152381 31.7 0.380952 31.8524C0.609524 31.9667 0.914286 31.9667 1.14286 31.8143L6.05714 28.6524L11.3905 30.7476C11.581 30.8238 11.7714 30.8238 11.9619 30.7476L15.7333 29.1857L22.9333 32.4238C23.0476 32.4619 23.1238 32.5 23.2381 32.5C23.3905 32.5 23.5429 32.4619 23.6571 32.3857C23.8857 32.2333 24 32.0048 24 31.7381V1.2619C24 0.842857 23.6952 0.5 23.2381 0.5ZM22.4762 30.5571L16.0381 27.6619C15.9238 27.6238 15.8476 27.5857 15.7333 27.5857C15.619 27.5857 15.5429 27.5857 15.4286 27.6619L11.619 29.2238L6.20952 27.0905C5.98095 27.0143 5.71429 27.0143 5.52381 27.1667L1.48571 29.7952V2.02381H22.4762V30.5571V30.5571ZM5.10476 5.2619C5.10476 4.84286 5.44762 4.5 5.86667 4.5H18.1333C18.5524 4.5 18.8952 4.84286 18.8952 5.2619C18.8952 5.68095 18.5524 6.02381 18.1333 6.02381H5.86667C5.44762 6.02381 5.10476 5.68095 5.10476 5.2619ZM5.10476 10.6333C5.10476 10.2143 5.44762 9.87143 5.86667 9.87143H18.1333C18.5524 9.87143 18.8952 10.2143 18.8952 10.6333C18.8952 11.0524 18.5524 11.3952 18.1333 11.3952H5.86667C5.44762 11.3952 5.10476 11.0524 5.10476 10.6333ZM5.10476 16.0048C5.10476 15.5857 5.44762 15.2429 5.86667 15.2429H18.1333C18.5524 15.2429 18.8952 15.5857 18.8952 16.0048C18.8952 16.4238 18.5524 16.7667 18.1333 16.7667H5.86667C5.44762 16.7667 5.10476 16.4238 5.10476 16.0048ZM12.381 23.3571C12.381 23.7762 12.0381 24.119 11.619 24.119H5.90476C5.48571 24.119 5.14286 23.7762 5.14286 23.3571C5.14286 22.9381 5.48571 22.5952 5.90476 22.5952H11.619C12.0381 22.5952 12.381 22.9381 12.381 23.3571Z"
          fill="#3A3A3A"
        />
      </svg>
    </React.Fragment>
  );
};

export const NoImageIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.625 2.24044L19.6529 1.3125L1.375 18.7596L2.34713 19.6875L3.72213 18.375H17.875C18.2395 18.3745 18.5889 18.236 18.8467 17.99C19.1044 17.744 19.2495 17.4104 19.25 17.0625V3.55294L20.625 2.24044ZM17.875 17.0625H5.09713L10.4548 11.9483L12.0904 13.5096C12.3482 13.7556 12.6979 13.8938 13.0625 13.8938C13.4271 13.8938 13.7768 13.7556 14.0346 13.5096L15.125 12.4688L17.875 15.0918V17.0625ZM17.875 13.2352L16.0971 11.5382C15.8393 11.2921 15.4896 11.1539 15.125 11.1539C14.7604 11.1539 14.4107 11.2921 14.1529 11.5382L13.0625 12.579L11.4283 11.0191L17.875 4.86544V13.2352ZM4.125 14.4375V12.4688L7.5625 9.18947L8.50644 10.0912L9.47994 9.16191L8.53462 8.25956C8.27677 8.01351 7.9271 7.87528 7.5625 7.87528C7.1979 7.87528 6.84823 8.01351 6.59038 8.25956L4.125 10.6129V3.9375H15.125V2.625H4.125C3.76044 2.62535 3.41091 2.76374 3.15313 3.00981C2.89535 3.25587 2.75036 3.58951 2.75 3.9375V14.4375H4.125Z"
          fill="#656565"
        />
      </svg>
    </React.Fragment>
  );
};

export const BurgerIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="none"
        strokeWidth="0"
        viewBox="0 0 15 15"
        height="2.8em"
        width="2.8em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z"
          fill="currentColor"
        ></path>
      </svg>
    </React.Fragment>
  );
};
export const CreateOrderIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="21"
        viewBox="0 0 15 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.66156 17.1002H0.140625V0H12.8075V12.0479H12.0158V0.777283H0.932302V16.3229H7.66156V17.1002Z"
          fill="black"
        />
        <path
          d="M10.2748 2.53516H3.94141V3.1685H10.2748V2.53516Z"
          fill="black"
        />
        <path
          d="M3.30912 2.53516H2.67578V3.1685H3.30912V2.53516Z"
          fill="black"
        />
        <path
          d="M10.2748 4.43359H3.94141V5.06694H10.2748V4.43359Z"
          fill="black"
        />
        <path
          d="M3.30912 4.43359H2.67578V5.06694H3.30912V4.43359Z"
          fill="black"
        />
        <path
          d="M10.2748 6.96484H3.94141V7.59819H10.2748V6.96484Z"
          fill="black"
        />
        <path
          d="M3.30912 6.96484H2.67578V7.59819H3.30912V6.96484Z"
          fill="black"
        />
        <path d="M10.2748 9.5H3.94141V10.1333H10.2748V9.5Z" fill="black" />
        <path d="M3.30912 9.5H2.67578V10.1333H3.30912V9.5Z" fill="black" />
        <path
          d="M7.74145 11.4023H3.94141V12.0357H7.74145V11.4023Z"
          fill="black"
        />
        <path
          d="M3.30912 11.4023H2.67578V12.0357H3.30912V11.4023Z"
          fill="black"
        />
        <line
          x1="12.756"
          y1="14.5664"
          x2="12.756"
          y2="18.9998"
          stroke="black"
          strokeWidth="1.16036"
        />
        <line
          x1="10.2734"
          y1="16.5214"
          x2="14.7068"
          y2="16.5214"
          stroke="black"
          strokeWidth="1.16036"
        />
      </svg>
    </React.Fragment>
  );
};

export const CircleAddIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 11.2773C8.2125 11.2773 8.39075 11.2053 8.53475 11.0613C8.67825 10.9178 8.75 10.7398 8.75 10.5273V8.27734H11.0187C11.2312 8.27734 11.4062 8.20534 11.5438 8.06134C11.6813 7.91784 11.75 7.73984 11.75 7.52734C11.75 7.31484 11.678 7.13659 11.534 6.99259C11.3905 6.84909 11.2125 6.77734 11 6.77734H8.75V4.50859C8.75 4.29609 8.67825 4.12109 8.53475 3.98359C8.39075 3.84609 8.2125 3.77734 8 3.77734C7.7875 3.77734 7.6095 3.84909 7.466 3.99259C7.322 4.13659 7.25 4.31484 7.25 4.52734V6.77734H4.98125C4.76875 6.77734 4.59375 6.84909 4.45625 6.99259C4.31875 7.13659 4.25 7.31484 4.25 7.52734C4.25 7.73984 4.32175 7.91784 4.46525 8.06134C4.60925 8.20534 4.7875 8.27734 5 8.27734H7.25V10.5461C7.25 10.7586 7.322 10.9336 7.466 11.0711C7.6095 11.2086 7.7875 11.2773 8 11.2773ZM8 15.0273C6.9625 15.0273 5.9875 14.8303 5.075 14.4363C4.1625 14.0428 3.36875 13.5086 2.69375 12.8336C2.01875 12.1586 1.4845 11.3648 1.091 10.4523C0.697 9.53984 0.5 8.56484 0.5 7.52734C0.5 6.48984 0.697 5.51484 1.091 4.60234C1.4845 3.68984 2.01875 2.89609 2.69375 2.22109C3.36875 1.54609 4.1625 1.01159 5.075 0.617594C5.9875 0.224094 6.9625 0.0273438 8 0.0273438C9.0375 0.0273438 10.0125 0.224094 10.925 0.617594C11.8375 1.01159 12.6313 1.54609 13.3063 2.22109C13.9813 2.89609 14.5155 3.68984 14.909 4.60234C15.303 5.51484 15.5 6.48984 15.5 7.52734C15.5 8.56484 15.303 9.53984 14.909 10.4523C14.5155 11.3648 13.9813 12.1586 13.3063 12.8336C12.6313 13.5086 11.8375 14.0428 10.925 14.4363C10.0125 14.8303 9.0375 15.0273 8 15.0273ZM8 13.5273C9.6625 13.5273 11.0782 12.9431 12.2472 11.7746C13.4158 10.6056 14 9.18984 14 7.52734C14 5.86484 13.4158 4.44909 12.2472 3.28009C11.0782 2.11159 9.6625 1.52734 8 1.52734C6.3375 1.52734 4.922 2.11159 3.7535 3.28009C2.5845 4.44909 2 5.86484 2 7.52734C2 9.18984 2.5845 10.6056 3.7535 11.7746C4.922 12.9431 6.3375 13.5273 8 13.5273Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const CrossCircelIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.275 11.2523C4.4125 11.3898 4.5875 11.4586 4.8 11.4586C5.0125 11.4586 5.1875 11.3898 5.325 11.2523L7.5 9.07734L9.69375 11.2711C9.83125 11.4086 10.0033 11.4741 10.2098 11.4676C10.4157 11.4616 10.5875 11.3898 10.725 11.2523C10.8625 11.1148 10.9313 10.9398 10.9313 10.7273C10.9313 10.5148 10.8625 10.3398 10.725 10.2023L8.55 8.02734L10.7438 5.83359C10.8813 5.69609 10.9467 5.52409 10.9403 5.31759C10.9342 5.11159 10.8625 4.93984 10.725 4.80234C10.5875 4.66484 10.4125 4.59609 10.2 4.59609C9.9875 4.59609 9.8125 4.66484 9.675 4.80234L7.5 6.97734L5.30625 4.78359C5.16875 4.64609 4.997 4.58034 4.791 4.58634C4.5845 4.59284 4.4125 4.66484 4.275 4.80234C4.1375 4.93984 4.06875 5.11484 4.06875 5.32734C4.06875 5.53984 4.1375 5.71484 4.275 5.85234L6.45 8.02734L4.25625 10.2211C4.11875 10.3586 4.05325 10.5303 4.05975 10.7363C4.06575 10.9428 4.1375 11.1148 4.275 11.2523ZM7.5 15.5273C6.4625 15.5273 5.4875 15.3303 4.575 14.9363C3.6625 14.5428 2.86875 14.0086 2.19375 13.3336C1.51875 12.6586 0.9845 11.8648 0.591 10.9523C0.197 10.0398 0 9.06484 0 8.02734C0 6.98984 0.197 6.01484 0.591 5.10234C0.9845 4.18984 1.51875 3.39609 2.19375 2.72109C2.86875 2.04609 3.6625 1.51159 4.575 1.11759C5.4875 0.724094 6.4625 0.527344 7.5 0.527344C8.5375 0.527344 9.5125 0.724094 10.425 1.11759C11.3375 1.51159 12.1313 2.04609 12.8063 2.72109C13.4813 3.39609 14.0155 4.18984 14.409 5.10234C14.803 6.01484 15 6.98984 15 8.02734C15 9.06484 14.803 10.0398 14.409 10.9523C14.0155 11.8648 13.4813 12.6586 12.8063 13.3336C12.1313 14.0086 11.3375 14.5428 10.425 14.9363C9.5125 15.3303 8.5375 15.5273 7.5 15.5273ZM7.5 14.0273C9.1625 14.0273 10.5782 13.4431 11.7472 12.2746C12.9158 11.1056 13.5 9.68984 13.5 8.02734C13.5 6.36484 12.9158 4.94909 11.7472 3.78009C10.5782 2.61159 9.1625 2.02734 7.5 2.02734C5.8375 2.02734 4.422 2.61159 3.2535 3.78009C2.0845 4.94909 1.5 6.36484 1.5 8.02734C1.5 9.68984 2.0845 11.1056 3.2535 12.2746C4.422 13.4431 5.8375 14.0273 7.5 14.0273Z"
          fill="#E13537"
        />
      </svg>
    </React.Fragment>
  );
};
export const HelpCircle = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        fill="#fff"
        viewBox="0 0 20 20"
        aria-hidden="true"
      >
        <g id="Layer_4">
          <path d="M11,12.3V13c0,0-1.8,0-2,0v-0.6c0-0.6,0.1-1.4,0.8-2.1c0.7-0.7,1.6-1.2,1.6-2.1c0-0.9-0.7-1.4-1.4-1.4 c-1.3,0-1.4,1.4-1.5,1.7H6.6C6.6,7.1,7.2,5,10,5c2.4,0,3.4,1.6,3.4,3C13.4,10.4,11,10.8,11,12.3z"></path>
          <circle cx="10" cy="15" r="1"></circle>
          <path d="M10,2c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S5.6,2,10,2 M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0 L10,0z"></path>
        </g>
      </svg>
    </React.Fragment>
  );
};
export const Hyphen = (props) => {
  return (
    <React.Fragment>
      <svg
        role="button"
        onClick={props.onClick}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        data-testid="Icon--dash"
        data-garden-id="buttons.icon"
        data-garden-version="8.13.0"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
          d="M3 8h10"
        ></path>
      </svg>
    </React.Fragment>
  );
};

export const EmailIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2 0H1.8C0.81 0 0.00899999 0.84375 0.00899999 1.875L0 13.125C0 14.1562 0.81 15 1.8 15H16.2C17.19 15 18 14.1562 18 13.125V1.875C18 0.84375 17.19 0 16.2 0ZM16.2 3.75L9 8.4375L1.8 3.75V1.875L9 6.5625L16.2 1.875V3.75Z"
          fill="#FFFFFF"
        />
      </svg>
    </React.Fragment>
  );
};

export const WhatsAppIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="28"
        height="28"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
        style={props.styles}
      >
        <path
          d="M4.01114 12.9963L4.25388 13.1173C5.26543 13.7223 6.39825 14.0046 7.53114 14.0046C11.0916 14.0046 14.0046 11.1006 14.0046 7.55115C14.0046 5.85713 13.3168 4.20341 12.1031 2.99336C10.8893 1.78331 9.27084 1.09766 7.53114 1.09766C3.97072 1.09766 1.05759 4.00172 1.09807 7.59151C1.09807 8.8015 1.46221 9.97124 2.06908 10.9795L2.2309 11.2216L1.5836 13.6013L4.01114 12.9963Z"
          fill="#00E676"
        />
        <path
          d="M12.8338 2.18919C11.4441 0.770295 9.52315 0 7.56129 0C3.39241 0 0.0408978 3.36485 0.081737 7.45943C0.081737 8.75674 0.449583 10.0135 1.0627 11.1486L0 15L3.96457 13.9865C5.0681 14.5946 6.29422 14.8784 7.52045 14.8784C11.6485 14.8784 15 11.5135 15 7.41898C15 5.43246 14.2234 3.56757 12.8338 2.18919ZM7.56129 13.6217C6.45775 13.6217 5.35421 13.3379 4.41415 12.7704L4.16894 12.6487L1.79839 13.2568L2.41145 10.946L2.24797 10.7028C0.449583 7.82441 1.30791 4.01351 4.25068 2.22969C7.19344 0.445939 10.9945 1.29731 12.7929 4.21622C14.5913 7.13514 13.7329 10.9054 10.7902 12.6892C9.8501 13.2973 8.70572 13.6217 7.56129 13.6217ZM11.158 9.12172L10.7084 8.91901C10.7084 8.91901 10.0545 8.63522 9.64579 8.4325C9.60489 8.4325 9.56405 8.39194 9.52315 8.39194C9.40052 8.39194 9.31878 8.4325 9.23704 8.47307C9.23704 8.47307 9.1962 8.51358 8.62399 9.16223C8.58309 9.2433 8.50135 9.28387 8.41961 9.28387H8.37872C8.33788 9.28387 8.25614 9.2433 8.21524 9.2028L8.01087 9.12172C7.56129 8.91901 7.1526 8.67572 6.8256 8.35143C6.74386 8.27035 6.62122 8.18928 6.53949 8.1082C6.25338 7.82441 5.96727 7.50006 5.76296 7.13519L5.72206 7.05412C5.68122 7.01355 5.68122 6.97304 5.64032 6.89197C5.64032 6.8109 5.64032 6.72982 5.68122 6.68925C5.68122 6.68925 5.84469 6.48654 5.96727 6.36496C6.04907 6.28382 6.0899 6.16224 6.17164 6.08117C6.25338 5.95953 6.29428 5.79738 6.25338 5.67574C6.21254 5.47302 5.72206 4.37843 5.59948 4.13521C5.51769 4.01356 5.43601 3.97306 5.31337 3.93249H4.86379C4.782 3.93249 4.70032 3.97306 4.61852 3.97306L4.57762 4.01356C4.49589 4.05413 4.41415 4.13521 4.33241 4.17571C4.25068 4.25685 4.20978 4.33786 4.12804 4.419C3.84193 4.78386 3.67846 5.2298 3.67846 5.67574C3.67846 6.00003 3.76019 6.32439 3.88283 6.60818L3.92373 6.72982C4.29157 7.50006 4.782 8.18928 5.43601 8.79737L5.59948 8.95951C5.72206 9.08116 5.84469 9.16223 5.92643 9.28381C6.78476 10.0136 7.76566 10.5406 8.8692 10.8244C8.99183 10.8649 9.15531 10.8649 9.27794 10.9055H9.68663C9.891 10.9055 10.1362 10.8244 10.2997 10.7433C10.4223 10.6623 10.5041 10.6623 10.5858 10.5812L10.6676 10.5C10.7493 10.419 10.8311 10.3785 10.9128 10.2974C10.9945 10.2163 11.0763 10.1352 11.1172 10.0541C11.1989 9.89196 11.2397 9.68924 11.2806 9.48659V9.2028C11.2806 9.2028 11.2397 9.16223 11.158 9.12172Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const EmailColorIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="30"
        height="30"
      >
        <path
          fill="#CFD8DC"
          d="M40,10H8c-2.209,0-4,1.791-4,4v20c0,2.209,1.791,4,4,4h32c2.209,0,4-1.791,4-4V14C44,11.791,42.209,10,40,10z"
        />
        <path
          fill="#78909C"
          d="M44,14.025c0-0.465-0.095-0.904-0.24-1.32L24,27.025L4.241,12.705C4.095,13.121,4,13.561,4,14.025V15l20,14.495L44,15V14.025z"
        />
      </svg>
    </React.Fragment>
  );
};

export const MessageColorIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 36 36"
        width="30"
        height="30"
      >
        <g data-name="Слой 2">
          <path
            fill="#1565c0"
            d="M14,30H30l6,6V14a4,4,0,0,0-4-4H14a4,4,0,0,0-4,4V26a4,4,0,0,0,4,4"
          />
          <path
            fill="#2196f3"
            d="M23,20H6L0,26V4A4,4,0,0,1,4,0H23a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4"
          />
          <rect width="19" height="2" x="4" y="4" fill="#e3f2fd" />
          <rect width="19" height="2" x="4" y="9" fill="#e3f2fd" />
          <rect width="10" height="2" x="4" y="14" fill="#e3f2fd" />
        </g>
      </svg>
    </React.Fragment>
  );
};
export const CopyColorIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="30"
        height="30"
      >
        <path fill="#42A5F5" d="M31 36L6 36 6 3 23 3 31 11z" />
        <path fill="#E1F5FE" d="M29.5 12L22 12 22 4.5z" />
        <path
          fill="#1565C0"
          d="M11 16H27V18H11zM11 20H23V22H11zM11 24H27V26H11zM11 28H23V30H11z"
        />
        <path fill="#90CAF9" d="M42 44L17 44 17 11 34 11 42 19z" />
        <path fill="#E1F5FE" d="M40.5 20L33 20 33 12.5z" />
        <g>
          <path
            fill="#1976D2"
            d="M22 24H37V26H22zM22 28H33V30H22zM22 32H37V34H22zM22 36H33V38H22z"
          />
        </g>
      </svg>{" "}
    </React.Fragment>
  );
};
export const WarehouseIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        className={props.css}
        stroke="currentColor"
        fill={props.color}
        strokeWidth="0"
        viewBox="0 0 576 512"
        height="3em"
        width="2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"></path>
      </svg>
    </React.Fragment>
  );
};
export const CloseWhiteIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 1024 1024"
        fillRule="evenodd"
        height="1.5em"
        width="1.5em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64Zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372Zm128.013 198.826c.023.007.042.018.083.059l45.02 45.019c.04.04.05.06.058.083a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082L557.254 512l127.861 127.862a.268.268 0 0 1 .05.06l.009.023a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082l-45.019 45.02c-.04.04-.06.05-.083.058a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059L512 557.254 384.14 685.115c-.042.041-.06.052-.084.059a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059l-45.02-45.019c-.04-.04-.05-.06-.058-.083a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082L466.745 512l-127.86-127.86a.268.268 0 0 1-.05-.061l-.009-.023a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082l45.019-45.02c.04-.04.06-.05.083-.058a.118.118 0 0 1 .07 0c.022.007.041.018.082.059L512 466.745l127.862-127.86c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"></path>
      </svg>
    </React.Fragment>
  );
};
export const RupeesIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 320 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"></path>
      </svg>
    </React.Fragment>
  );
};
export const SearchIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 10.5231C0 13.314 1.10868 15.9906 3.08215 17.9641C5.05561 19.9375 7.7322 21.0462 10.5231 21.0462C12.8601 21.0491 15.1302 20.2662 16.9685 18.8232L22.7431 24.6109C22.8653 24.7342 23.0108 24.8321 23.1711 24.8988C23.3314 24.9656 23.5033 25 23.677 25C23.8506 25 24.0226 24.9656 24.1829 24.8988C24.3431 24.8321 24.4886 24.7342 24.6109 24.6109C24.7342 24.4886 24.8321 24.3431 24.8988 24.1829C24.9656 24.0226 25 23.8506 25 23.677C25 23.5033 24.9656 23.3314 24.8988 23.1711C24.8321 23.0108 24.7342 22.8653 24.6109 22.7431L18.8232 16.9685C20.2662 15.1302 21.0491 12.8601 21.0462 10.5231C21.0462 7.7322 19.9375 5.05561 17.9641 3.08215C15.9906 1.10868 13.314 0 10.5231 0C7.7322 0 5.05561 1.10868 3.08215 3.08215C1.10868 5.05561 0 7.7322 0 10.5231ZM10.5231 2.63078C12.0841 2.63078 13.61 3.09365 14.9078 3.96087C16.2057 4.82809 17.2173 6.06071 17.8147 7.50284C18.412 8.94498 18.5683 10.5319 18.2638 12.0628C17.9593 13.5938 17.2076 15.0001 16.1038 16.1038C15.0001 17.2076 13.5938 17.9593 12.0628 18.2638C10.5319 18.5683 8.94498 18.412 7.50284 17.8147C6.06071 17.2173 4.82809 16.2057 3.96087 14.9078C3.09365 13.61 2.63078 12.0841 2.63078 10.5231C2.63078 8.42993 3.46229 6.42248 4.94239 4.94239C6.42248 3.46229 8.42993 2.63078 10.5231 2.63078Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const PreviousIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M46.7998 3.59961L51.8398 8.99961L25.1998 35.9996L51.8398 62.9996L46.7998 68.3996L14.3998 35.9996L46.7998 3.59961Z"
          fill="#F5F5F5"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};
export const NextIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.2002 3.59961L20.1602 8.99961L46.8002 35.9996L20.1602 62.9996L25.2002 68.3996L57.6002 35.9996L25.2002 3.59961Z"
          fill="#F5F5F5"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};
export const DropDownBlueIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="22"
        height="10"
        viewBox="0 0 27 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M26 1L13.5 13L1 1" stroke="#74B9FF" strokeWidth="2" />
      </svg>
    </React.Fragment>
  );
};
export const DropDownIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1.8em"
        width="1.8em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 15.0006L7.75732 10.758L9.17154 9.34375L12 12.1722L14.8284 9.34375L16.2426 10.758L12 15.0006Z"></path>
      </svg>
    </React.Fragment>
  );
};
export const DropUpIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1.8em"
        width="1.8em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 11.8284L9.17154 14.6569L7.75732 13.2426L12 9L16.2426 13.2426L14.8284 14.6569L12 11.8284Z"></path>
      </svg>{" "}
    </React.Fragment>
  );
};
export const CheckIcon = ({ selected }) => {
  return (
    <React.Fragment>
      <svg
        width="15"
        height="11"
        viewBox="0 0 15 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.20685 4.48445C1.39438 4.29698 1.64868 4.19167 1.91385 4.19167C2.17901 4.19167 2.43332 4.29698 2.62085 4.48445L6.15685 8.02045L13.2268 0.949453C13.3197 0.856542 13.4299 0.782829 13.5513 0.732521C13.6726 0.682214 13.8026 0.656296 13.934 0.65625C14.0653 0.656204 14.1954 0.682029 14.3168 0.732251C14.4382 0.782473 14.5484 0.856108 14.6413 0.948953C14.7343 1.0418 14.808 1.15203 14.8583 1.27337C14.9086 1.3947 14.9345 1.52475 14.9346 1.6561C14.9346 1.78745 14.9088 1.91752 14.8586 2.03889C14.8083 2.16026 14.7347 2.27054 14.6418 2.36345L6.15685 10.8485L1.20685 5.89845C1.01938 5.71093 0.914062 5.45662 0.914062 5.19145C0.914063 4.92629 1.01938 4.67198 1.20685 4.48445Z"
          fill={selected ? "green" : "#000"}
        />
      </svg>
    </React.Fragment>
  );
};
export const CheckGreenIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="16"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 8.46667L7.66667 15L21 1"
          stroke="#4164E3"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const DoubleCheckIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="#0dcaf0"
        strokeWidth="0"
        viewBox="0 0 256 256"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M152.41,88.56l-89.6,88a12,12,0,0,1-16.82,0L7.59,138.85a12,12,0,0,1,16.82-17.13l30,29.46,81.19-79.74a12,12,0,0,1,16.82,17.12Zm96.15-17a12,12,0,0,0-17-.15L150.4,151.18l-7.88-7.74a12,12,0,0,0-16.82,17.12l16.29,16a12,12,0,0,0,16.82,0l89.6-88A12,12,0,0,0,248.56,71.59Z"></path>
      </svg>
    </React.Fragment>
  );
};
export const LocationIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.0013 9.58464C9.44877 9.58464 8.91886 9.36514 8.52816 8.97444C8.13746 8.58374 7.91797 8.05384 7.91797 7.5013C7.91797 6.94877 8.13746 6.41886 8.52816 6.02816C8.91886 5.63746 9.44877 5.41797 10.0013 5.41797C10.5538 5.41797 11.0837 5.63746 11.4744 6.02816C11.8651 6.41886 12.0846 6.94877 12.0846 7.5013C12.0846 7.77489 12.0307 8.0458 11.9261 8.29856C11.8214 8.55132 11.6679 8.78099 11.4744 8.97444C11.281 9.1679 11.0513 9.32135 10.7986 9.42605C10.5458 9.53075 10.2749 9.58464 10.0013 9.58464ZM10.0013 1.66797C8.45421 1.66797 6.97047 2.28255 5.87651 3.37651C4.78255 4.47047 4.16797 5.95421 4.16797 7.5013C4.16797 11.8763 10.0013 18.3346 10.0013 18.3346C10.0013 18.3346 15.8346 11.8763 15.8346 7.5013C15.8346 5.95421 15.2201 4.47047 14.1261 3.37651C13.0321 2.28255 11.5484 1.66797 10.0013 1.66797Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const GSTIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 15 15"
        fill="none"
      >
        <circle cx="7.5" cy="7.5" r="7.5" fill="black" />
        <path
          d="M1.301 7.69C1.273 6.367 2.4 5.282 3.737 5.303C4.542 5.303 5.207 5.653 5.648 6.269L5.109 6.71C4.766 6.227 4.304 5.982 3.73 5.982C2.757 5.982 2.071 6.71 2.071 7.683C2.071 8.67 2.778 9.412 3.772 9.412C4.381 9.412 4.864 9.153 5.151 8.712V8.215H3.73V7.557H5.893V8.859C5.48 9.594 4.668 10.077 3.737 10.077C2.386 10.098 1.28 9.013 1.301 7.69ZM6.47466 9.076L6.99966 8.677C7.30766 9.125 7.67866 9.412 8.21066 9.412C8.68666 9.412 9.00866 9.16 9.00866 8.768C9.00866 8.439 8.81266 8.299 8.32966 8.075L7.81866 7.837C7.14666 7.529 6.74066 7.172 6.74066 6.556C6.74066 5.8 7.39866 5.303 8.19666 5.303C8.84766 5.303 9.40066 5.632 9.68766 6.129L9.16966 6.528C8.92466 6.164 8.58866 5.968 8.19666 5.968C7.80466 5.968 7.49666 6.164 7.49666 6.528C7.52466 6.892 7.68566 6.955 8.14066 7.186L8.65866 7.424C9.40766 7.767 9.76466 8.131 9.76466 8.74C9.76466 9.545 9.10666 10.077 8.21766 10.077C7.46166 10.077 6.83166 9.699 6.47466 9.076ZM11.7988 10V6.045H10.2448V5.38H14.1018V6.045H12.5408V10H11.7988Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const ImageIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 165 145"
        fill="none"
      >
        <path
          d="M144.375 15.7812C147.211 15.7812 149.531 18.1016 149.531 20.9375V123.998L147.92 121.903L104.092 65.1846C102.642 63.2832 100.354 62.1875 97.9688 62.1875C95.584 62.1875 93.3281 63.2832 91.8457 65.1846L65.0977 99.7959L55.2686 86.0352C53.8184 84.0049 51.498 82.8125 48.9844 82.8125C46.4707 82.8125 44.1504 84.0049 42.7002 86.0674L16.9189 122.161L15.4688 124.159V20.9375C15.4688 18.1016 17.7891 15.7812 20.625 15.7812H144.375ZM20.625 0.3125C9.24902 0.3125 0 9.56152 0 20.9375V124.062C0 135.438 9.24902 144.688 20.625 144.688H144.375C155.751 144.688 165 135.438 165 124.062V20.9375C165 9.56152 155.751 0.3125 144.375 0.3125H20.625ZM46.4062 62.1875C48.4376 62.1875 50.4491 61.7874 52.3259 61.01C54.2026 60.2326 55.9079 59.0932 57.3443 57.6568C58.7807 56.2204 59.9201 54.5151 60.6975 52.6384C61.4749 50.7616 61.875 48.7501 61.875 46.7188C61.875 44.6874 61.4749 42.6759 60.6975 40.7991C59.9201 38.9224 58.7807 37.2171 57.3443 35.7807C55.9079 34.3443 54.2026 33.2049 52.3259 32.4275C50.4491 31.6501 48.4376 31.25 46.4062 31.25C44.3749 31.25 42.3634 31.6501 40.4866 32.4275C38.6099 33.2049 36.9046 34.3443 35.4682 35.7807C34.0318 37.2171 32.8924 38.9224 32.115 40.7991C31.3376 42.6759 30.9375 44.6874 30.9375 46.7188C30.9375 48.7501 31.3376 50.7616 32.115 52.6384C32.8924 54.5151 34.0318 56.2204 35.4682 57.6568C36.9046 59.0932 38.6099 60.2326 40.4866 61.01C42.3634 61.7874 44.3749 62.1875 46.4062 62.1875Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const VideoIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 144 144"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72 144C81.4552 144 90.8178 142.138 99.5532 138.519C108.289 134.901 116.226 129.598 122.912 122.912C129.598 116.226 134.901 108.289 138.519 99.5532C142.138 90.8178 144 81.4552 144 72C144 62.5448 142.138 53.1822 138.519 44.4468C134.901 35.7113 129.598 27.7741 122.912 21.0883C116.226 14.4025 108.289 9.09901 99.5532 5.48067C90.8178 1.86233 81.4552 -1.40893e-07 72 0C52.9044 2.84546e-07 34.5909 7.58569 21.0883 21.0883C7.58569 34.5909 0 52.9044 0 72C0 91.0956 7.58569 109.409 21.0883 122.912C34.5909 136.414 52.9044 144 72 144ZM62.264 39.92L107.416 65.008C108.663 65.701 109.701 66.7147 110.424 67.9441C111.147 69.1734 111.529 70.5738 111.529 72C111.529 73.4262 111.147 74.8266 110.424 76.0559C109.701 77.2853 108.663 78.299 107.416 78.992L62.264 104.08C60.802 104.893 59.153 105.309 57.4805 105.288C55.8079 105.268 54.1699 104.81 52.7285 103.961C51.2872 103.113 50.0927 101.902 49.2633 100.449C48.4339 98.9967 47.9984 97.3527 48 95.68V48.32C47.9984 46.6473 48.4339 45.0033 49.2633 43.5507C50.0927 42.0981 51.2872 40.8875 52.7285 40.0387C54.1699 39.1899 55.8079 38.7325 57.4805 38.7116C59.153 38.6908 60.802 39.1074 62.264 39.92Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const DocumentIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 125 144"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.503906 14.59C0.503906 10.7764 2.01123 7.11904 4.6943 4.42245C7.37736 1.72587 11.0164 0.210938 14.8108 0.210938L93.0885 0.210938L124.497 31.7777V129.622C124.497 133.436 122.99 137.093 120.307 139.79C117.623 142.486 113.984 144.001 110.19 144.001H14.8108C11.0164 144.001 7.37736 142.486 4.6943 139.79C2.01123 137.093 0.503906 133.436 0.503906 129.622V14.59ZM29.1177 38.5262L76.8073 38.555V48.141L29.1177 48.1123V38.5262ZM95.8831 67.2651H29.1177V76.8511H95.8831V67.2651ZM95.8831 96.0807L29.1177 96.004V105.59L95.8831 105.657V96.0807Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const LiveLocationIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 100 143"
        fill="none"
      >
        <path
          d="M49.875 67.6875C45.1508 67.6875 40.6202 65.8108 37.2797 62.4703C33.9392 59.1298 32.0625 54.5992 32.0625 49.875C32.0625 45.1508 33.9392 40.6202 37.2797 37.2797C40.6202 33.9392 45.1508 32.0625 49.875 32.0625C54.5992 32.0625 59.1298 33.9392 62.4703 37.2797C65.8108 40.6202 67.6875 45.1508 67.6875 49.875C67.6875 52.2142 67.2268 54.5304 66.3316 56.6916C65.4364 58.8527 64.1244 60.8163 62.4703 62.4703C60.8163 64.1244 58.8527 65.4364 56.6916 66.3316C54.5304 67.2268 52.2142 67.6875 49.875 67.6875ZM49.875 0C36.6473 0 23.9614 5.25467 14.608 14.608C5.25467 23.9614 0 36.6473 0 49.875C0 87.2812 49.875 142.5 49.875 142.5C49.875 142.5 99.75 87.2812 99.75 49.875C99.75 36.6473 94.4953 23.9614 85.1419 14.608C75.7886 5.25467 63.1027 0 49.875 0Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const GotoWebsiteIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"></path>
      </svg>
    </React.Fragment>
  );
};
export const BoldIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 4.75c0-.69.56-1.25 1.25-1.25h5a4.752 4.752 0 0 1 3.888 7.479A5 5 0 0 1 14 20.5H7.25c-.69 0-1.25-.56-1.25-1.25ZM8.5 13v5H14a2.5 2.5 0 1 0 0-5Zm0-2.5h3.751A2.25 2.25 0 0 0 12.25 6H8.5Z"></path>
      </svg>
    </React.Fragment>
  );
};
export const ItalicIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        version="1.1"
        viewBox="0 0 16 16"
        height="18px"
        width="18px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 1v1h-2l-5 12h2v1h-7v-1h2l5-12h-2v-1z"></path>
      </svg>
    </React.Fragment>
  );
};
export const EmojisIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
        <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"></path>
      </svg>
    </React.Fragment>
  );
};
export const SendMessageIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 40 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.3438 17.9409H38.4565M7.3438 17.9409L2.39405 32.7901C2.3207 32.9876 2.30558 33.2019 2.35049 33.4077C2.3954 33.6135 2.49844 33.8021 2.64738 33.951C2.79632 34.0999 2.98489 34.203 3.19068 34.2479C3.39647 34.2928 3.61082 34.2777 3.80827 34.2043L38.4565 17.9409M7.3438 17.9409L2.39405 3.09163C2.3207 2.89419 2.30558 2.67983 2.35049 2.47404C2.3954 2.26825 2.49844 2.07968 2.64738 1.93074C2.79632 1.78181 2.98489 1.67876 3.19068 1.63385C3.39647 1.58895 3.61082 1.60407 3.80827 1.67742L38.4565 17.9409"
          stroke="#D9D9D9"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const WhatsAppHeader = (props) => {
  return (
    <React.Fragment>
      <svg
        width="32"
        height="32"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M4.01114 12.9963L4.25388 13.1173C5.26543 13.7223 6.39825 14.0046 7.53114 14.0046C11.0916 14.0046 14.0046 11.1006 14.0046 7.55115C14.0046 5.85713 13.3168 4.20341 12.1031 2.99336C10.8893 1.78331 9.27084 1.09766 7.53114 1.09766C3.97072 1.09766 1.05759 4.00172 1.09807 7.59151C1.09807 8.8015 1.46221 9.97124 2.06908 10.9795L2.2309 11.2216L1.5836 13.6013L4.01114 12.9963Z"
          fill="#00E676"
        />
        <path
          d="M12.8338 2.18919C11.4441 0.770295 9.52315 0 7.56129 0C3.39241 0 0.0408978 3.36485 0.081737 7.45943C0.081737 8.75674 0.449583 10.0135 1.0627 11.1486L0 15L3.96457 13.9865C5.0681 14.5946 6.29422 14.8784 7.52045 14.8784C11.6485 14.8784 15 11.5135 15 7.41898C15 5.43246 14.2234 3.56757 12.8338 2.18919ZM7.56129 13.6217C6.45775 13.6217 5.35421 13.3379 4.41415 12.7704L4.16894 12.6487L1.79839 13.2568L2.41145 10.946L2.24797 10.7028C0.449583 7.82441 1.30791 4.01351 4.25068 2.22969C7.19344 0.445939 10.9945 1.29731 12.7929 4.21622C14.5913 7.13514 13.7329 10.9054 10.7902 12.6892C9.8501 13.2973 8.70572 13.6217 7.56129 13.6217ZM11.158 9.12172L10.7084 8.91901C10.7084 8.91901 10.0545 8.63522 9.64579 8.4325C9.60489 8.4325 9.56405 8.39194 9.52315 8.39194C9.40052 8.39194 9.31878 8.4325 9.23704 8.47307C9.23704 8.47307 9.1962 8.51358 8.62399 9.16223C8.58309 9.2433 8.50135 9.28387 8.41961 9.28387H8.37872C8.33788 9.28387 8.25614 9.2433 8.21524 9.2028L8.01087 9.12172C7.56129 8.91901 7.1526 8.67572 6.8256 8.35143C6.74386 8.27035 6.62122 8.18928 6.53949 8.1082C6.25338 7.82441 5.96727 7.50006 5.76296 7.13519L5.72206 7.05412C5.68122 7.01355 5.68122 6.97304 5.64032 6.89197C5.64032 6.8109 5.64032 6.72982 5.68122 6.68925C5.68122 6.68925 5.84469 6.48654 5.96727 6.36496C6.04907 6.28382 6.0899 6.16224 6.17164 6.08117C6.25338 5.95953 6.29428 5.79738 6.25338 5.67574C6.21254 5.47302 5.72206 4.37843 5.59948 4.13521C5.51769 4.01356 5.43601 3.97306 5.31337 3.93249H4.86379C4.782 3.93249 4.70032 3.97306 4.61852 3.97306L4.57762 4.01356C4.49589 4.05413 4.41415 4.13521 4.33241 4.17571C4.25068 4.25685 4.20978 4.33786 4.12804 4.419C3.84193 4.78386 3.67846 5.2298 3.67846 5.67574C3.67846 6.00003 3.76019 6.32439 3.88283 6.60818L3.92373 6.72982C4.29157 7.50006 4.782 8.18928 5.43601 8.79737L5.59948 8.95951C5.72206 9.08116 5.84469 9.16223 5.92643 9.28381C6.78476 10.0136 7.76566 10.5406 8.8692 10.8244C8.99183 10.8649 9.15531 10.8649 9.27794 10.9055H9.68663C9.891 10.9055 10.1362 10.8244 10.2997 10.7433C10.4223 10.6623 10.5041 10.6623 10.5858 10.5812L10.6676 10.5C10.7493 10.419 10.8311 10.3785 10.9128 10.2974C10.9945 10.2163 11.0763 10.1352 11.1172 10.0541C11.1989 9.89196 11.2397 9.68924 11.2806 9.48659V9.2028C11.2806 9.2028 11.2397 9.16223 11.158 9.12172Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
// export const Doubletick = ({ mode }) => {
//   return (
//     <React.Fragment>
//       <svg
//         width="18"
//         height="18"
//         viewBox="0 0 21 12"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M8.5 8L11.5 10.5L20 2"
//           stroke={mode ? "#F4F4F4" : "#000"}
//           strokeWidth="1.4"
//           strokeLinecap="round"
//         />
//         <path
//           d="M1 5L5.5 9.5L14 1"
//           stroke={mode ? "#F4F4F4" : "#000"}
//           strokeWidth="1.4"
//           strokeLinecap="round"
//         />
//       </svg>
//     </React.Fragment>
//   );
// };

export const Doubletick = ({ mode, icon }) => {
  // Determine stroke color based on the icon status (delivered, read, or default)

  const getStrokeColor = () => {
    if (icon === "DoubleWithColor") {
      return "#34B7F1"; // Blue color for 'read'
    }
    if (icon === "Double") {
      return mode ? "#F4F4F4" : "#000"; // Gray or black for 'delivered'
    }
    return mode ? "#F4F4F4" : "#000"; // Default color if neither delivered nor read
  };

  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 21 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 8L11.5 10.5L20 2"
          stroke={getStrokeColor()}
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        {(icon === "Double" || icon === "DoubleWithColor") && (
          <path
            d="M1 5L5.5 9.5L14 1"
            stroke={getStrokeColor()}
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        )}
      </svg>
    </React.Fragment>
  );
};

export const DoubletickActive = (props) => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 21 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 8L11.5 10.5L20 2"
          stroke="#1baafa"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        <path
          d="M1 5L5.5 9.5L14 1"
          stroke="#1baafa"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const WhatsappLocationIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 100 143"
        fill="none"
      >
        <path
          d="M49.875 67.6875C45.1508 67.6875 40.6202 65.8108 37.2797 62.4703C33.9392 59.1298 32.0625 54.5992 32.0625 49.875C32.0625 45.1508 33.9392 40.6202 37.2797 37.2797C40.6202 33.9392 45.1508 32.0625 49.875 32.0625C54.5992 32.0625 59.1298 33.9392 62.4703 37.2797C65.8108 40.6202 67.6875 45.1508 67.6875 49.875C67.6875 52.2142 67.2268 54.5304 66.3316 56.6916C65.4364 58.8527 64.1244 60.8163 62.4703 62.4703C60.8163 64.1244 58.8527 65.4364 56.6916 66.3316C54.5304 67.2268 52.2142 67.6875 49.875 67.6875ZM49.875 0C36.6473 0 23.9614 5.25467 14.608 14.608C5.25467 23.9614 0 36.6473 0 49.875C0 87.2812 49.875 142.5 49.875 142.5C49.875 142.5 99.75 87.2812 99.75 49.875C99.75 36.6473 94.4953 23.9614 85.1419 14.608C75.7886 5.25467 63.1027 0 49.875 0Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const AddFile = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        stroke={mode ? "#fff" : "#000"}
        fill={mode ? "#fff" : "#000"}
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="1.6em"
        width="1.6em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
      </svg>
    </React.Fragment>
  );
};

export const WhatsappEmojisIcon = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        stroke={mode ? "#fff" : "#000"}
        fill={mode ? "#fff" : "#000"}
        strokeWidth="0"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
        <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"></path>
      </svg>
    </React.Fragment>
  );
};
export const DownloadFileIcon = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        stroke={mode ? "#fff" : "#000"}
        fill={mode ? "#fff" : "#000"}
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="2em"
        width="2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="none" d="M0 0h24v24H0z"></path>
        <path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm-1 8V6h2v4h3l-4 4-4-4h3zm6 7H7v-2h10v2z"></path>
      </svg>
    </React.Fragment>
  );
};

export const WhatsappEmojisWhiteIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="#000"
        fill="#000"
        strokeWidth="0"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
        <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"></path>
      </svg>
    </React.Fragment>
  );
};

export const AddFileDark = () => {
  return (
    <React.Fragment>
      <svg
        stroke="#000"
        fill="#000"
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="1.6em"
        width="1.6em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
      </svg>
    </React.Fragment>
  );
};

export const BackArrowIcon = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        stroke={mode ? "#fff" : "#646b88"}
        fill={mode ? "#fff" : "#000"}
        strokeWidth="2"
        viewBox="0 0 512 512"
        height="1.5em"
        width="1.5em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="none"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="48"
          d="M244 400 100 256l144-144M120 256h292"
        ></path>
      </svg>{" "}
    </React.Fragment>
  );
};

export const SpinnerWhite = (props) => {
  return (
    <React.Fragment>
      <div className="tw_center">
        <div
          className={props.css}
          style={{ height: props.size + "px", width: props.size + "px" }}
        />
      </div>
    </React.Fragment>
  );
};

export const CrossRedIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="#dc3545"
        fill="#dc3545"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1.4em"
        width="1.4em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="none" strokeWidth="2" d="M7,7 L17,17 M7,17 L17,7"></path>
      </svg>
    </React.Fragment>
  );
};

export const ErickshawIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 500 500"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <path
            d="M104.6,328.5c0.5,0.6,1.5,1.1,1.5,1.7c0.1,1.7-0.2,3.3-0.4,5c-1.7-0.2-3.3-0.2-4.9-0.7c-1-0.3-1.8-1.2-3.5-2.3
		c4.4,31.1-15.5,48.7-34.8,51.4c-22.7,3.2-42.1-11.1-46.8-31.9c-3.4-14.8,0.4-27.9,10.9-38.7c10.5-10.8,23.6-14,38.4-12.3
		c-4.5-2.5-10.1-2.5-17.6-0.8c-6.2,1.4-12.4,2.6-18.6,3.7c-1.4,0.3-3-0.1-5-0.8c6.3-0.8,6-5.2,5.7-9.4c0.7,0,1.1-0.1,1.2,0
		c2.8,5,6.5,3.4,10.7,1.8c8.1-3.3,11.8-3.4,26.3-2.3c0.8-7.8,6.7-14.5,4.8-23.3c0.5-0.1,1.5-0.3,2-0.4c0.7-2.3,1.4-4.3,2-6.5
		c2,0.6,3.5,1.1,5.2,1.7c3.3-8.7,6.5-17.2,9.7-25.7c-0.3-0.3-0.5-0.5-0.8-0.8c-0.9,0.9-2,1.6-2.6,2.6c-2.4,4-3.9,8.6-8.5,11.1
		c-3.8,2-7.7,2.2-11.5,0.9c-1.4-0.5-2.9-2.2-3.2-3.6c-2-7.4-1.6-14.7,1.5-21.7c2.1-4.8,6.1-3,8.9-2.6c1.4-4.1,2.5-8.1,4.2-11.8
		c1.2-2.7,3.4-3.5,5.9-1c1.6,1.6,3.4,3,5.2,4.3c2.9,2.1,5.8,4.2,4,8.5c0.6,0.1,1.1,0.2,1.1,0.1c3.5-7.5,10.8-13.4,9.6-23
		c-0.3-2.3,1.1-4.7,1.7-7.1c0.9-3.7,2.4-7.3,2.6-11c0.4-5.8,0.8-8,4.4-10.7c5.7,5,8.5,11.5,9.3,18.9c0.1,0.8-1.5,1.9-2.5,2.6
		c-0.3,0.2-1.2-0.3-1.8-0.5c-8.2-3.3-12.2-0.4-12.2,8.6c0,1.7,0,3.4,0.4,5.4c2.2-4,5.2-1.4,7.7-1.4c3,0,5.1,1.4,5.9,4.7
		c0.3,1.4,2.7,2.1,3.5,3.5c0.8,1.3,0.8,3.1,1.2,4.7c-1.5,0.1-3.2,0.6-4.4,0.1c-2.1-1-3.8-2-6.5-1.3c-3.5,0.9-5.1-1.9-6.7-5.3
		c-2,3.2-4.1,6.3-6.1,9.4c2.3,2,4.1,3.6,6,5.3c-1.5,1.1-2.4,1.7-3.3,2.4c1,0.8,2,1.7,3.4,2.9c0,0.8,0,2.4,0,4.2
		c-1.9,0.2-3.7,0.3-5.1,0.5c1.3,1,3.8,1.8,4.1,3.1c0.8,4.1,1.9,8.8,0.7,12.5c-1.5,4.4-4.2,8.6-8.4,11.9c-2.7,2.1-4.4,4.3-8.2,4.4
		c-1.3,0-3.2,2.3-3.8,3.9c-1.1,2.9-1.4,6.1-2.1,9.5c0.9,0.4,2.1,1.1,3.3,1.2c1.8,0.1,3.7,0.1,3.5-2.8c-0.2-2.7-0.1-5.4,3.7-5.8
		c0.7-0.1,1.3-1.2,1.8-1.9c1.5-2.2,3-4.4,4.2-6.7c2.6-5.3,7-9,10.9-13.2c1-1.1,2.9-2.3,0.7-4.3c-0.2-0.2,1.6-2.7,2.8-4.5
		c0.6,2.9,1,4.9,1.4,6.7c5.2-5.2,10.4-10.3,15.5-15.4c0.5,0.4,1.1,0.8,1.6,1.3c-5.7,9.9-11.2,20-20,29.1c6.2-0.4,7.6,2.7,8.6,6.9
		c2,8.5,4.4,16.9,6.4,25.3c0.4,1.5,0.5,3.9-0.3,4.8c-3,3.4-1.2,6.2,0.7,8.8c3.5,4.7,7.1,9.3,11,13.5c3.7,4,4,9,5,13.9
		c0.2,1.1,1.4,2.9,2.1,2.9c11.4,0.2,22.7,0.1,34.3,0.1c0-18.1,0-35.6,0-52c-1.7-2-2.9-3.4-4-4.7c-0.4-0.4-1-0.8-1.5-1.1
		c-1.2-0.6-3.6-1.2-3.6-1.7c0.1-2.8-1.7-6.1,1.8-8.6c-4-3-2.1-6.2-0.3-9.6c2-3.6,3.4-7.5,5.6-10.9c0.9-1.4,3.3-2.2,5.2-2.6
		c13.2-2.2,25.8,0.4,37.8,5.8c1.2,0.5,2.4,0.9,4.6,1.7c0-7.3,2.1-14.9-0.4-20.4c-5.3-11.5-0.3-22,0-33c0-2.1,0.5-4.2,0.5-6.3
		c0.1-26.8,0.1-53.5,0.3-80.3c0-3.7,0.4-7.3,0.7-11.6c-2,0-3.5,0-5,0c-48,0-96,0-143.9,0c-1.8,0-3.6-0.4-5.4-0.6
		c0-0.5-0.1-1-0.1-1.4c0.8-0.3,1.7-1,2.5-0.9c17.8,1.3,34.5-4.8,51.6-7.6c21.3-3.5,42.7-6.6,64.3-6.6c90-0.2,180-0.1,270-0.1
		c9.1,0,15.7,3.9,19.8,12c0.7,1.3,1.7,2.5,3.1,4.5c-6.8,1.5-13.3,0.2-20.2,0.9c0,3.2,0,6.3,0,9.4c0.2,24.4,0.4,48.7,0.6,73.1
		c0,1.8-0.9,4.1,2.4,4.4c0.5,0.1,0.7,2.6,1.1,4.6c0.6-0.5,1.5-0.9,1.6-1.4c0.6-2.6,0.8-5.2,1.4-7.8c0.8-3.6,3.5-5.6,6.8-5.1
		c4.1,0.6,6.3,3.2,5.8,7.1c-2.7,20.3-3.4,40.9-8.9,60.8c-0.7,2.4-0.9,4.9-1.2,7.4c-0.9,6.5-2,7.5-8.3,7.6c0,5,0,9.9,0,14.9
		c0.5-0.1,1-0.3,1.5-0.4c0.7,1.5,2.1,3,2,4.5c-0.1,3.9,1.3,6.3,4.5,8.4c1.7,1.1,3.2,3.7,3.5,5.7c0.5,4.2,0.5,8.5,0,12.7
		c-0.2,1.7-1.7,4.2-3.2,4.7c-4,1.5-5.2,4.1-4.6,7.9c0.2,1,0.7,2.7,1.3,2.8c1.2,0.3,2.7-0.2,4-0.6c1-0.3,2.3-1.3,2.7-1
		c0.8,0.6,1.3,1.9,1.4,2.9c0.2,3.4,0.1,6.9,0.1,10.3c0,2.7-1.3,3.5-4,2.7c-0.1-1.3-0.2-2.6-0.3-4.3c-5.9,0.4-11.8,0.7-18,1.1
		c-0.9-3.9-1.8-7.7-2.8-11.7c-1.9,0.1-3.4,0.2-5.4,0.3c0.6,3.2,1.3,6.1,1.7,9c3,19.1-8.5,37.7-27,43.8c-18.4,6.1-39.1-1.9-47.7-19.1
		c-2.2-4.3-4.2-5.7-9.1-5.4c-27.8,1.4-55.6,2.3-83.4,3.4c-2.8,0.1-5.6,0.4-8.5,0.1c7.3-2.2,0-7.1,3-10.3c-10.1,0-19.3,0-28.5,0
		c-1,3.3-6.8,7.3-11.1,7.7c-6.8,0.7-13.6,0.3-20.3,2.9c-4.8,1.9-9.4-0.8-12.4-4.3c-4.6-5.3-10-5.5-16.3-5.6
		c-20.7-0.5-41.3-1.5-61.9-2.5c-3.8-0.2-7.6-1-11.4-1.5c-3-0.5-3.1-2.2-3.2-5c-0.3-4.7-1.9-9.3-3.5-13.7c-0.3-0.9-3.3-0.8-5-1.1
		C104.9,327.8,104.7,328.2,104.6,328.5z M352.3,108.1c-18.3,0-36,0-53.7,0c-1.1,11.2-0.5,13.8,4.7,22.8c1.2,2,0.6,3.4-1.8,3.5
		c-3.4,0.1-6.9,0.1-10.3,0c-2.5-0.1-3-1.8-1.5-3.5c1.9-2.1,2.5-4.6,3.6-7.1c2.4-5.4,0.6-10.5,1.2-15.7c-13.6,0-26.7,0-40,0
		c-0.4,7.4-0.7,14.5,4.5,20.4c0.6,0.6,0.9,2.1,0.5,2.8c-0.3,0.7-1.6,1.2-2.5,1.2c-3,0.1-6.1,0.1-9.1,0c-0.9,0-2.2-0.6-2.5-1.3
		c-0.3-0.8,0-2.2,0.6-2.9c5.1-6,5.1-13,4.5-20.2c-6.9,0-13.5,0-19.8,0c0,28.9,0,57.4,0,86.9c4.5-2.5,6.4,0.5,8.4,2.7
		c1.4,1.5,3.2,3.4,3.4,5.3c0.7,6.4,1.2,13,0.8,19.4c-0.3,4.2-1.5,8.8-3.8,12.2c-2,2.9-2.4,5.2-1.7,8.2c5.8,0.8,6.8,0.6,12-2.2
		c0.6-0.3,1.3-0.4,1.9-0.4c10.6-0.3,21.2-0.7,31.8-0.9c4.3-0.1,6.2,3,4,6.6c-1.8,3-2,5.5-0.7,8.8c0.8,2.1,0.4,4.7,0.5,7.1
		c0.1,4.1,0,8.1,0,12.1c9.6,1,10.3,2,8.3,11.8c-2.7,0.2-5.4,0.4-8.2,0.6c0.5,1.3,1,1.8,1.6,2c9.2,3.9,12.6,8.9,12.6,18.9
		c0,11.4,0,22.8,0,34.2c0,1.4,0.1,2.8,0.2,4.4c12.6,0,24.8,0,37,0c2.6,0,5.7,0.8,6.4-3.2c0.1-0.6,1.4-1.5,2.1-1.5
		c2.7-0.1,3.3-2.1,4.2-4.1c5.9-14,11.7-28.1,17.7-42c1.3-2.9,3.8-5.3,5.5-8c1-1.5,2.2-3.2,2.4-4.9c0.7-8.1,5.8-13.2,13.9-13.3
		c0.9,0,1.9-0.1,2.8,0c3.4,0.6,5.2-0.7,6.5-4c2-5.1,4.5-10.1,7.2-15c1.3-2.4,1.4-4-0.4-6.2c-3.2-3.9-2-7.4,2.8-9.1
		c1.3-0.5,2.8-0.7,4.3-0.7c6.2,0.2,12.4,0.5,18.6,0.9c4.7,0.4,10,0,14.1,1.9c5.4,2.5,10.5,1.3,16.2,1.8c0-3.2,0.2-5.9-0.1-8.7
		c-0.1-0.8-1.1-2.1-1.9-2.3c-3.4-0.6-4.6-3.1-4.2-5.8c1.3-7,3.1-13.8,4.7-20.7c0.5-2,1.3-4,1.4-6c0.1-25.1,0.1-50.1,0.2-75.2
		c0-3.8,0.4-7.6,0.6-11.6c-16.4,0-32.2,0-47.9,0c-1.2,8.9-0.2,13.1,4.5,20.4c1.4,2.2,0.7,3.9-1.9,4c-3.2,0.1-6.4,0-9.5,0
		c-3,0-3.3-2.3-2-3.7c2-2.2,2.2-4.9,3.5-7.1c2.7-4.6,0.8-9.1,1.4-13.7c-19,0-37.4,0-56.2,0c0,5.4-0.7,10.6,0.2,15.6
		c0.9,4.6,3.6,8.9,5.8,14c-4.6,0-8.1,0.1-11.7,0c-1.1,0-2.1-0.6-3.2-0.9c0.4-1.3,0.8-2.6,1.3-3.9c1.3-3,3.5-5.9,3.9-9
		C352.8,118.8,352.3,113.5,352.3,108.1z M411.6,373.7c16.5,0,29.9-13.3,30-29.6c0-16.1-13.3-29.6-29.5-29.9
		c-16.2-0.2-30.1,13.4-30.1,29.6C381.9,360.2,395.2,373.6,411.6,373.7z M238,244.7c0,10.5-0.1,20.5,0.1,30.5
		c0.1,2.9,2.5,1.9,4.2,1.4c1.6-0.4,3.2-1.5,4.8-1.6c12-0.4,24.1-0.6,36.1-0.9c0.7,0,1.5-0.3,2.4-0.4c0-5.7,0.2-11.3-0.1-16.8
		c-0.4-7.1-5.9-12.1-13.1-12.2c-2.8,0-5.6,0-8.3-0.1C255.4,244.7,246.7,244.7,238,244.7z M85.3,338.1c-0.2,0-0.5-0.2-0.7-0.1
		c-4.1,1.4-8.2,2.9-12.4,4.2c-2.3,0.7-3.6,1.9-4.4,4.3c-1.9,5.8-7.3,8.8-13.4,8.1c-5.2-0.7-9.7-5.5-10.4-11.1
		c-0.6-5.1,3.1-10.7,8.3-12.7c1-0.4,2.4-1,2.7-1.8c1.9-5.1,3.6-10.3,5.3-15.5c-11.3-2.5-24.3,4.1-30,14.8c-6.4,12-4.1,26.3,5.8,35.6
		c9.7,9.2,24.2,10.7,35.6,3.8C82,361.4,88.1,348.2,85.3,338.1z M226.1,263.7c-10.8-5.8-28.4-9.9-39.3-8.3c-2.9,0.4-5.8,3.1-8,5.3
		c-1.8,1.8-2.6,4.6-3.8,6.9c-2.4,4.5-0.1,7.8,5.1,8.3c14,1.2,28.1-3,42.3,0.5C223.6,272.2,224.8,267.9,226.1,263.7z M457,240.9
		c-12.5,0-23.9-0.2-35.4,0.1c-2.3,0.1-4.9,1.5-6.7,3c-5.3,4.5-7.2,11.1-10.2,17c0.8,0.4,1,0.6,1.2,0.6c12.5,0,24.9,0.1,37.4,0
		c1.5,0,3.6-1.1,4.3-2.3C450.8,253.5,453.7,247.5,457,240.9z M374.1,355.9c-1.5-2.5-2.3-5.5-3.6-5.7c-5.8-0.8-11.8-1.2-17.7-1.1
		c-4.6,0-9.2,1.3-13.8,1.4c-17.5,0.2-35,0.1-52.5,0.1c-1.4,0-2.9,0-4.4,0c-0.1,2,0.1,3.7-0.5,5.1c-1.7,3.9,0.1,4.2,3.4,4.1
		c16.9-0.7,33.9-1.3,50.8-2C348.3,357.2,360.6,356.5,374.1,355.9z M401.7,268.4c20.5,0,40.8,0,60.5,0c0.3-4.8,0.6-9.2,0.7-13.6
		c0.1-4.6,0-9.1,0-13.5c-3.8-1.3-5.3,0.2-6.5,3.1c-1.9,4.6-4.2,9.1-6.4,13.6c-1.7,3.6-4.5,5.2-8.6,5.1c-11.3-0.2-22.5,0.2-33.8-0.2
		C403.4,262.8,402.3,264.9,401.7,268.4z M204.7,319.6c1.7,6.2,6.5,9.5,11.5,8.6c5.3-1,8.9-5.5,8.6-10.7c-0.3-5.3-4.4-9.5-9.7-9.8
		c-5-0.3-9.2,3.1-9.9,7.9c6.4,0.7,6.4,0.7,6,4.1C209.1,319.6,207.1,319.6,204.7,319.6z M69.9,340.9c4.5-1.5,9.9-3.3,15.4-5.1
		c-2.8-10.3-8.8-17.3-18.8-21.3c-1.8,5.6-3.5,10.9-4.9,15.1C64.5,333.7,67,337.1,69.9,340.9z M53.8,331.8c-6.5,2.2-9.6,7.5-8.2,13.3
		c1.3,5.5,6.7,8.9,12.8,8c4.7-0.7,8.3-4.5,8.1-8.6c-5.3,0.3-10,5.9-16.2,1.4C51.4,341.4,52.5,336.8,53.8,331.8z M98.6,293.5
		c-5.1,3.6-3.5,7.8-1.9,11.9c3.9,10.2,4.5,10.9,9.7,11.2C103.7,308.9,101.2,301.3,98.6,293.5z M126.1,303.7c0.4,0,0.9,0,1.3-0.1
		c0.1-1.1,0.6-2.3,0.4-3.2c-2.4-9.6-4.8-19.1-7.5-28.6c-0.4-1.3-2-2.3-3.1-3.4c-0.4,0.3-0.8,0.6-1.2,0.9
		C119.3,280.7,122.7,292.2,126.1,303.7z M92,309.1c0.3-0.3,0.6-0.6,0.9-0.9c-1.7-11.7-3.3-11.1-14.9-10.4
		C83,301.9,87.5,305.5,92,309.1z M290.3,132.9c4.2,0,8.1,0,12.2,0c-1.6-3.1-3-5.9-4.6-8.9c-0.9,0-2.2,0-2.8,0
		C293.4,127.3,291.9,130,290.3,132.9z M347.9,136.2c4.2,0,8.1,0,12.2,0c-1.6-3-3.1-5.8-4.7-8.8c-0.7,0-2.1,0-2.5,0
		C351,130.6,349.5,133.2,347.9,136.2z M60.3,344.7c2.4-1.4,6.3-2.5,6.5-4.2c0.5-3.7-2.3-6.5-6-8.1C59.4,336.2,57.1,339.8,60.3,344.7
		z M406.8,130.8c5,0,9,0,12.9,0c-1.6-3-3.1-5.7-4.7-8.6c-0.7,0-2.1,0-3.3,0c-0.4,1.7-0.6,3.3-1.3,4.6
		C409.8,128.1,408.5,129,406.8,130.8z M69.9,226c-5.6,5.7-6.6,19.1-2.3,23.3C68.3,241.8,69.1,234.4,69.9,226z M258.6,131
		c-1.8-3.2-3.3-5.9-5.1-8.9c-0.7,0-2,0.1-2.5,0.1c-1.6,3.2-3,5.9-4.5,8.8C250.6,131,254.5,131,258.6,131z M470.6,201.7
		c-4.2,2.1-6.3,19.1-3.9,27.2C468.1,219.7,469.3,210.9,470.6,201.7z M216.6,356c0-1.6,0-2.9,0-4.2c-4.4,0-8.4,0-12.8,0
		C207.2,356.6,211.4,357.1,216.6,356z M238.4,278.6c-0.8,8.5,0.2,9.8,5.2,8.6c-0.4-2.9-0.9-5.7-1.3-8.6
		C241.1,278.6,239.8,278.6,238.4,278.6z M470.3,332.4c0.1,1.7,0.2,2.9,0.3,4.3c1.9,0,3.4,0,4.9,0c0-1.6,0-3,0-4.3
		C473.7,332.4,472.3,332.4,470.3,332.4z M472.7,317c4.2-1.2,4.7-2.2,3.6-6.8c-1.2,0.1-2.4,0.2-3.6,0.3
		C472.7,312.9,472.7,314.9,472.7,317z M89.7,316.7c1.5,2.7,3,5.2,4.4,7.9c1.2,2.4,2.2,4.8,3.3,7.3c0.3-0.2,0.6-0.4,1-0.5
		C93.8,319.3,92.5,317,89.7,316.7z M472.7,304.1c1.4,0,2.6,0,5.3,0c-1.7-2.9-2.9-5-4.1-7.1c-0.4,0.2-0.8,0.4-1.2,0.6
		C472.7,299.6,472.7,301.8,472.7,304.1z M451.7,322.1c-2,0.5-3.6,0.9-5.2,1.3c1.1,5,4.2,2.1,6.9,2.4
		C452.8,324.5,452.4,323.4,451.7,322.1z M219.5,356.5c0.4,0.2,0.7,0.4,1.1,0.6c1.2-1.6,2.3-3.2,4-5.6c-2.5,0.2-3.8,0.2-5.2,0.3
		C219.5,353.6,219.5,355.1,219.5,356.5z M101.6,321.5c2.2,1.6,4.4,3.1,6.6,4.7C108.1,322.6,107.2,322,101.6,321.5z"
          />
          <path
            d="M411.5,357.2c-7.5-0.1-13.1-5.8-13-13.5c0.1-7.4,6.1-13.2,13.5-13c7.2,0.2,12.9,6.1,12.8,13.3
		C424.8,351.6,419.1,357.3,411.5,357.2z M418.6,337.5c-1.6,2.8-2.9,5.3-4.5,7.5c-0.6,0.8-2.3,1.2-3.3,1c-1.8-0.5-2.4-1.8-1.2-3.6
		c1.5-2.3,2.7-4.8,4.1-7.3c-5.3-0.9-9.1,1.1-10.8,5.4c-1.6,4.2-0.1,9.2,3.6,11.6c3.9,2.5,8.8,2,12-1.3
		C421.8,347.2,422,342.4,418.6,337.5z"
          />
          <path
            d="M388.4,332.8c1.2-1.7,2.2-3.1,3.2-4.7c0.8-1.3,1.4-2.8,2-4c1.6-0.7,3.1-1.3,4.7-2.1c1.5-0.7,3-1.5,4.6-2.4
		C403.2,327.8,397,333.4,388.4,332.8z"
          />
          <path d="M393.9,362.5c-2.5-2.8-4.7-5.3-6.7-7.5c-0.4-3.2-0.8-6.6-1.2-10C393.7,347.1,397.1,354.6,393.9,362.5z" />
          <path
            d="M423.9,366.6c-3.5,1.5-6.6,2.7-9.8,4.1c-1.1-0.3-2.6-0.7-4.1-1c-1.7-0.3-3.4-0.5-5.1-0.8
		C408.2,362.4,417.1,361.2,423.9,366.6z"
          />
          <path d="M415.2,318.6c3.6,0.9,6.7,1.6,10,2.4c1.9,2.1,4.3,4.6,6.7,7.2C424.6,330.8,417.4,326.9,415.2,318.6z" />
          <path d="M437.2,339.4c0.2,3.7,0.3,6.9,0.5,10.4c-1.3,2.3-2.9,5.3-4.6,8.4C428.1,352.3,429.8,343.8,437.2,339.4z" />
          <path d="M32,333.5c7.9,3.8,9,16.7,1.9,21.9C30.4,348.3,29.7,341.2,32,333.5z" />
          <path d="M36.9,325.3c5.8-6,12.4-8.4,20.3-8.9c0.2,4.4-2.5,6.7-5.6,8.5C47.1,327.3,42.4,328.9,36.9,325.3z" />
          <path d="M82.2,345c-1.5,8-5.1,14-11.4,19c-2.6-4.2-1.7-8,0.2-11.4C73.3,348.5,76.1,344.8,82.2,345z" />
          <path d="M40.5,362.4c3.9-4,8.5-3.6,13.1-2.3c3.8,1.1,7.3,2.8,8.1,7.4C53.9,369.1,45.6,367.1,40.5,362.4z" />
          <path d="M81.3,335.2c-9,1.4-16.6-7.4-14.6-16.6C73.9,322.2,78.5,327.7,81.3,335.2z" />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const AllInventoryViewIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="29"
        height="27"
        viewBox="0 0 29 27"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 11.1875H8V12.1134H5.707L8.854 15.0264L8.146 15.6819L5 12.7681V14.8912H4V11.1875ZM15.293 12.1134H13V11.1875H17V14.8912H16V12.7681L12.854 15.6819L12.146 15.0264L15.293 12.1134ZM8.853 19.3856L5.708 22.2986H8V23.2245H4V19.5208H5V21.644L8.146 18.7301L8.853 19.3856ZM12.853 18.7301L16 21.644V19.5208H17V23.2245H13V22.2986H15.293L12.146 19.3856L12.853 18.7301Z"
          fill={props.color}
        />
        <rect
          x="1"
          y="8.40625"
          width="19"
          height="17.5926"
          rx="1"
          stroke={props.color}
          strokeWidth="2"
        />
        <path
          d="M5 4.70312H21C22.6569 4.70312 24 6.04627 24 7.70313V22.2957"
          stroke={props.color}
          strokeWidth="1.5"
        />
        <path
          d="M10 1H24C26.2091 1 28 2.79086 28 5V17.6667"
          stroke={props.color}
          strokeWidth="1.5"
        />
      </svg>
    </React.Fragment>
  );
};
export const QuickReplyIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 16 16"
        height="1.5em"
        width="1.5em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.921 11.9 1.353 8.62a.72.72 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"></path>
      </svg>
    </React.Fragment>
  );
};
export const WalliconLogo = () => {
  return (
    <React.Fragment>
      <svg
        width="200"
        height="124"
        viewBox="0 0 200 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_1926_44010)">
          <path
            d="M31.0027 93.9373C30.6267 95.0646 30.326 96.0039 30.0252 96.9433C28.0328 103.031 26.0403 109.118 24.0102 115.205C23.7846 115.844 23.7846 115.844 23.1455 115.844C21.5666 115.844 19.9876 115.844 18.4087 115.844C17.732 115.844 17.732 115.844 17.544 115.168C15.4764 107.878 13.4087 100.588 11.341 93.2985C10.5891 90.6682 9.83727 88.0379 9.08539 85.4452C9.0478 85.2949 8.97261 85.1446 9.0478 84.9943C9.19817 84.8815 9.34855 84.9191 9.49892 84.9191C11.2658 84.9191 13.0328 84.9191 14.7997 84.9191C15.4012 84.9191 15.4012 84.9191 15.5516 85.5579C17.1305 91.6452 18.6719 97.77 20.2132 103.857C20.4764 104.909 20.7395 105.962 21.0403 107.089C21.341 106.826 21.341 106.488 21.4538 106.187C23.7094 99.3858 25.9275 92.5846 28.1455 85.7833C28.1831 85.633 28.2583 85.4827 28.2959 85.3324C28.3711 85.0694 28.5215 84.9567 28.7846 84.9567C30.326 84.9567 31.8298 84.9567 33.3711 84.9567C33.7846 84.9567 33.8598 85.1821 33.935 85.4827C34.4989 87.2488 35.1004 89.0149 35.6643 90.7809C37.3561 95.9664 39.0478 101.152 40.7771 106.337C40.8523 106.563 40.8523 106.863 41.1531 107.051C41.8673 104.271 42.5816 101.528 43.2583 98.8221C44.3861 94.4258 45.514 90.0294 46.6042 85.633C46.7546 84.9943 46.7922 84.9943 47.4313 84.9943C49.2358 84.9943 51.0403 84.9943 52.8448 84.9943C52.9576 85.2573 52.8448 85.4452 52.8072 85.633C49.9876 95.5155 47.1681 105.435 44.3485 115.318C44.1606 115.994 44.1606 115.994 43.4463 115.994C41.9049 115.994 40.326 115.994 38.7846 115.994C38.1079 115.994 38.1079 115.994 37.8824 115.318C35.7019 108.329 33.4839 101.528 31.2658 94.6888C31.1907 94.5009 31.1155 94.313 31.0027 93.9373Z"
            fill="white"
          />
          <path
            d="M160.586 95.2905C155.886 91.3826 148.743 91.3826 144.082 95.3281C141.262 97.6953 139.796 100.701 139.721 104.384C139.683 106.225 140.134 107.991 140.962 109.607C144.646 116.897 154.646 118.7 160.849 113.252C166.375 108.367 166.262 100.025 160.586 95.2905ZM152.428 111.298C148.706 111.373 145.548 108.329 145.51 104.497C145.473 100.514 148.518 97.6202 152.165 97.5075C155.962 97.3947 159.119 100.438 159.157 104.309C159.195 108.329 156.112 111.223 152.428 111.298Z"
            fill="white"
          />
          <path
            d="M76.4535 115.356C76.4535 114.153 76.4535 112.951 76.4535 111.711C76.4535 110.584 76.5662 110.734 75.476 110.771C74.3858 110.809 73.9723 110.358 73.9347 109.268C73.9347 109.081 73.9347 108.893 73.9347 108.705C73.9347 105.999 73.9347 103.294 73.9347 100.588C73.9347 100.062 73.9347 99.5363 73.8595 99.0102C73.258 95.8163 71.3031 93.8248 68.258 92.923C65.3632 92.0587 62.4685 92.3593 59.649 93.2987C58.1828 93.7872 56.8294 94.5387 55.5512 95.4781C56.3783 96.8684 57.1678 98.2212 57.9948 99.5739C58.3332 99.3484 58.5963 99.1981 58.8971 99.0478C60.7392 97.9957 62.6941 97.4321 64.8369 97.6199C65.9647 97.7327 66.9422 98.0709 67.6565 99.0102C68.2204 99.7242 68.3332 100.588 68.3332 101.49C68.3332 102.054 68.3332 102.054 67.8068 102.091C65.7016 102.242 63.5963 102.392 61.5287 102.542C60.0625 102.655 58.5963 102.956 57.2805 103.632C55.8144 104.384 54.7241 105.511 54.273 107.089C53.258 110.508 54.5738 113.853 57.8444 115.431C59.9873 116.483 62.2429 116.558 64.5362 115.994C66.3031 115.544 67.8069 114.604 69.085 113.101C69.8745 114.604 71.0399 115.393 72.5813 115.656C73.7843 115.882 74.9873 115.731 76.1903 115.769C76.4911 115.807 76.4535 115.581 76.4535 115.356ZM66.5662 110.884C65.852 111.373 65.0625 111.711 64.1978 111.861C63.8219 111.936 63.4084 111.936 63.0324 111.974C62.1677 111.936 61.3407 111.824 60.6264 111.373C59.649 110.771 59.273 109.832 59.5362 108.742C59.6865 108.028 60.1377 107.615 60.7768 107.314C61.4159 107.014 62.0926 106.939 62.7693 106.901C64.4234 106.751 66.1151 106.601 67.8068 106.45C68.3708 106.413 68.3332 106.413 68.3708 106.976C68.4459 108.517 67.9572 109.907 66.5662 110.884Z"
            fill="white"
          />
          <path
            d="M175.626 94.6518C175.927 94.6518 176.002 94.4639 176.152 94.3511C179.573 91.4954 184.912 91.6081 188.182 94.6142C189.912 96.2299 190.927 98.259 190.964 100.589C191.04 105.511 191.002 110.434 191.002 115.318C191.002 115.694 190.889 115.807 190.513 115.807C188.934 115.807 187.355 115.807 185.776 115.807C185.213 115.807 185.175 115.807 185.175 115.206C185.175 111.072 185.175 106.939 185.175 102.843C185.175 102.242 185.175 101.641 185.025 101.04C184.423 98.4469 182.092 97.1693 179.536 97.5827C177.13 97.9584 175.664 99.7245 175.626 102.204C175.588 104.797 175.626 107.352 175.626 109.945C175.626 111.749 175.626 113.515 175.626 115.318C175.626 115.732 175.551 115.844 175.1 115.844C173.558 115.807 171.979 115.844 170.438 115.844C169.686 115.844 169.799 115.844 169.799 115.131C169.799 108.592 169.799 102.054 169.799 95.516C169.799 94.8021 169.799 94.0881 169.799 93.3742C169.799 93.0736 169.874 92.9609 170.213 92.9609C171.904 92.9609 173.596 92.9609 175.25 92.9609C175.588 92.9609 175.626 93.1487 175.626 93.4118C175.626 93.7875 175.626 94.2009 175.626 94.6518Z"
            fill="white"
          />
          <path
            d="M137.207 97.432C135.967 98.3338 134.764 99.2356 133.561 100.1C133.147 100.4 133.11 100.4 132.771 99.9871C131.643 98.672 130.252 97.8829 128.561 97.5447C124.801 96.8684 121.155 99.5362 120.628 103.331C120.14 106.788 122.358 110.433 126.079 111.11C128.636 111.56 130.816 110.847 132.583 108.968C132.696 108.855 132.809 108.742 132.884 108.592C133.072 108.329 133.222 108.367 133.448 108.517C134.688 109.456 135.967 110.358 137.245 111.297C135.591 113.439 133.636 115.017 131.042 115.807C126.23 117.272 120.703 115.694 117.508 111.861C112.282 105.586 114.801 96.1544 122.546 93.2235C125.929 91.9459 129.35 91.9459 132.658 93.4865C134.425 94.3508 136.042 95.7787 137.207 97.432Z"
            fill="white"
          />
          <path
            d="M86.7162 100.363C86.7162 105.21 86.7162 110.02 86.7162 114.867C86.7162 115.055 86.7162 115.243 86.7162 115.431C86.7538 115.731 86.6411 115.844 86.3403 115.844C84.6486 115.844 82.9568 115.844 81.3027 115.844C80.9644 115.844 80.8892 115.694 80.9268 115.431C80.9268 115.28 80.9268 115.13 80.9268 114.942C80.9268 105.21 80.9268 95.5155 80.9268 85.7834C80.9268 84.7689 80.7764 84.844 81.829 84.844C83.22 84.844 84.611 84.844 86.002 84.844C86.829 84.844 86.7162 84.8064 86.7162 85.558C86.7162 88.2258 86.7162 90.9313 86.7162 93.5992C86.7162 95.8161 86.7162 98.0707 86.7162 100.363Z"
            fill="white"
          />
          <path
            d="M98.2212 100.25C98.2212 105.135 98.2212 110.02 98.2212 114.905C98.2212 115.055 98.2212 115.205 98.2212 115.393C98.2588 115.769 98.0708 115.807 97.7701 115.807C96.1535 115.807 94.4994 115.807 92.8829 115.807C92.5069 115.807 92.3566 115.694 92.3941 115.318C92.3941 115.205 92.3941 115.055 92.3941 114.942C92.3941 105.21 92.3941 95.4406 92.3941 85.7084C92.3941 84.769 92.2438 84.8442 93.2964 84.8442C94.725 84.8442 96.1535 84.8442 97.5445 84.8442C98.2964 84.8442 98.2212 84.8442 98.2212 85.5206C98.2212 90.443 98.2212 95.3278 98.2212 100.25Z"
            fill="white"
          />
          <path
            d="M109.765 104.345C109.765 107.915 109.765 111.485 109.765 115.055C109.765 115.844 109.877 115.806 109.088 115.806C107.547 115.806 106.043 115.806 104.501 115.806C103.975 115.806 103.938 115.806 103.938 115.242C103.938 107.99 103.938 100.738 103.938 93.486C103.938 92.96 103.938 92.96 104.501 92.96C106.043 92.96 107.622 92.96 109.163 92.96C109.727 92.96 109.765 92.96 109.765 93.5612C109.765 97.1309 109.765 100.738 109.765 104.345Z"
            fill="white"
          />
          <path
            d="M110.099 87.2491C110.099 89.1279 108.746 90.5182 106.903 90.5182C105.099 90.5182 103.633 89.0904 103.633 87.2867C103.633 85.4831 105.061 84.0928 106.903 84.0928C108.746 84.0928 110.099 85.4079 110.099 87.2491Z"
            fill="white"
          />
          <path
            opacity="0.5"
            d="M59.0156 52.0794L69.1284 70.7545L71.2337 65.2309L63.0006 50.0127L59.0156 52.0794Z"
            fill="white"
          />
          <path
            d="M83.5235 39.0039L89.8393 35.6973L85.4032 45.6548L74.1626 70.793H69.125L71.7566 63.9542L83.5235 39.0039Z"
            fill="white"
          />
          <path
            opacity="0.5"
            d="M102.626 70.8667L105.896 62.074L89.8438 35.6582L85.4453 45.5406L102.626 70.8667Z"
            fill="white"
          />
          <path
            d="M102.625 70.8676H111.046L115.858 60.7973L125.069 41.4458L130.933 29.0458L141.084 7.89062L122.399 17.8858L102.625 70.8676Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_1926_44010"
            x="5.81562"
            y="7.89062"
            width="188.396"
            height="114.932"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3.2" />
            <feGaussianBlur stdDeviation="1.6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1926_44010"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1926_44010"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const HomeImg = () => {
  return (
    <React.Fragment>
      <svg
        width="500"
        height="412"
        viewBox="0 0 500 412"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.6">
          <path
            d="M281.765 178.514L165.381 248.855L163.635 205.896L0 302.281L4.77174 305.201H131.048L235.095 364.712C236.608 365.685 241.729 365.685 243.242 364.712L281.765 178.514Z"
            fill="#4A5477"
          />
          <path
            d="M172.015 411.809H161.889L150.367 404.751L163.402 396.962L172.015 411.809Z"
            fill="#4A5477"
          />
          <path
            d="M445.983 295.588H432.483L417.004 286.217L434.345 275.751L445.983 295.588Z"
            fill="#4A5477"
          />
          <path
            d="M73.4366 246.057H59.9361L44.457 236.686L61.7982 226.22L73.4366 246.057Z"
            fill="#4A5477"
          />
          <path
            d="M434.696 229.384H425.502L415.027 222.933L426.782 215.875L434.696 229.384Z"
            fill="#4A5477"
          />
          <path
            d="M437.37 238.753H432.133L427.012 235.589L433.646 231.573L437.37 238.753Z"
            fill="#4A5477"
          />
          <path
            d="M461.928 342.562H456.691L451.57 339.52L458.204 335.504L461.928 342.562Z"
            fill="#4A5477"
          />
          <path
            d="M490.444 289.016C490.444 289.016 464.607 286.095 458.671 295.101C453.201 303.376 467.866 304.958 477.642 304.228C477.991 304.228 477.875 296.926 477.875 296.926L495.798 295.952C496.263 295.952 490.444 289.016 490.444 289.016Z"
            fill="#4A5477"
          />
          <path
            d="M17.8086 340.859L53.3056 362.278H84.2637L57.6118 316.763L17.8086 340.859Z"
            fill="#4A5477"
          />
          <path
            d="M286.188 370.796H271.524L254.648 360.695L273.503 349.256L286.188 370.796Z"
            fill="#4A5477"
          />
          <path
            d="M275.599 390.998H268.267L261.051 386.617L270.478 380.897L275.599 390.998Z"
            fill="#4A5477"
          />
          <path
            d="M142.451 378.22C132.908 386.861 157.698 386.618 167.59 385.887C167.939 385.887 167.823 378.342 167.823 378.342L186.212 377.369C186.794 377.369 180.742 370.31 180.742 370.31C180.742 370.31 151.529 369.945 142.451 378.22Z"
            fill="#4A5477"
          />
          <path
            d="M378.245 383.088C375.103 382.236 352.292 380.897 344.959 388.078C337.045 395.745 364.512 398.544 364.512 398.544C364.745 397.692 364.628 395.745 364.628 393.919C364.628 392.459 366.374 389.416 367.771 389.538L378.362 390.025C378.362 389.903 381.388 383.818 378.245 383.088Z"
            fill="#4A5477"
          />
        </g>
        <path
          d="M172.018 400.368L162.242 394.405L172.018 388.563L181.795 394.405L172.018 400.368Z"
          fill="url(#paint0_linear_1926_44029)"
        />
        <path
          d="M172.018 411.808L162.242 405.845V394.405L172.018 400.368V411.808Z"
          fill="#276E91"
        />
        <path
          d="M181.792 405.844L172.016 411.807V400.368L181.792 394.404V405.844Z"
          fill="#2D86A5"
        />
        <path
          d="M445.979 280.254L432.828 272.344L445.979 264.434L459.131 272.344L445.979 280.254Z"
          fill="url(#paint1_linear_1926_44029)"
        />
        <path
          d="M445.979 295.588L432.828 287.678V272.344L445.979 280.254V295.588Z"
          fill="#276E91"
        />
        <path
          d="M459.132 287.678L445.98 295.588V280.254L459.132 272.344V287.678Z"
          fill="#2D86A5"
        />
        <path
          d="M73.4443 230.723L60.293 222.813L73.4443 214.902L86.5957 222.813L73.4443 230.723Z"
          fill="url(#paint2_linear_1926_44029)"
        />
        <path
          d="M73.4443 246.057L60.293 238.146V222.812L73.4443 230.723V246.057Z"
          fill="#276E91"
        />
        <path
          d="M86.5967 238.146L73.4453 246.057V230.723L86.5967 222.812V238.146Z"
          fill="#2D86A5"
        />
        <path
          d="M434.696 218.917L425.734 213.562L434.696 208.086L443.657 213.562L434.696 218.917Z"
          fill="url(#paint3_linear_1926_44029)"
        />
        <path
          d="M434.696 229.383L425.734 223.907V213.562L434.696 218.917V229.383Z"
          fill="#276E91"
        />
        <path
          d="M443.657 223.907L434.695 229.383V218.917L443.657 213.562V223.907Z"
          fill="#2D86A5"
        />
        <path
          d="M437.375 232.789L432.254 229.747L437.375 226.704L442.379 229.747L437.375 232.789Z"
          fill="url(#paint4_linear_1926_44029)"
        />
        <path
          d="M437.375 238.752L432.254 235.588V229.746L437.375 232.789V238.752Z"
          fill="#276E91"
        />
        <path
          d="M442.376 235.588L437.371 238.752V232.789L442.376 229.746V235.588Z"
          fill="#2D86A5"
        />
        <path
          d="M461.92 337.085L457.148 334.164L461.92 331.243L466.576 334.164L461.92 337.085Z"
          fill="url(#paint5_linear_1926_44029)"
        />
        <path
          d="M461.92 342.561L457.148 339.762V334.164L461.92 337.085V342.561Z"
          fill="#276E91"
        />
        <path
          d="M466.577 339.762L461.922 342.561V337.085L466.577 334.164V339.762Z"
          fill="#2D86A5"
        />
        <path
          d="M481.591 304.96C481.358 303.864 480.776 302.891 480.195 301.917L475.656 301.309C472.513 301.795 469.604 302.404 466.578 302.891C465.181 303.134 464.366 303.012 464.25 303.986C464.25 304.108 464.25 305.203 464.25 305.325C464.25 306.177 464.948 307.028 466.461 307.15C471 307.637 475.19 307.637 479.613 307.759C480.776 307.759 481.591 307.393 481.708 306.42C481.591 306.42 481.591 304.96 481.591 304.96Z"
          fill="#276E91"
        />
        <path
          d="M499.51 293.885C499.277 293.155 498.812 292.546 498.23 292.059C495.786 289.869 494.739 289.139 493.807 288.408C491.014 286.218 488.221 286.218 487.988 288.287C487.988 288.287 487.988 289.382 487.988 289.504C487.988 289.869 488.105 290.112 488.221 290.477C488.803 291.938 494.506 297.536 495.437 298.266C495.67 298.509 496.019 298.631 496.368 298.631C497.532 298.875 501.256 298.875 499.51 293.885Z"
          fill="#276E91"
        />
        <path
          d="M481.472 304.229C481.239 303.134 480.89 301.795 480.191 300.822L475.652 300.578C472.51 301.065 469.601 300.822 466.458 301.308C463.781 301.673 462.967 305.689 466.342 306.055C470.881 306.541 475.071 306.541 479.493 306.663C481.122 306.785 481.937 306.176 481.472 304.229Z"
          fill="white"
        />
        <path
          d="M499.511 292.667C499.278 291.937 498.813 291.329 498.231 290.842C495.787 288.651 494.739 287.921 493.808 287.191C490.549 284.514 487.174 286.583 488.222 289.26C488.804 290.72 494.506 296.318 495.438 297.049C495.67 297.292 496.019 297.414 496.369 297.414C497.532 297.535 501.257 297.535 499.511 292.667Z"
          fill="white"
        />
        <path
          d="M487.872 245.327C483.915 241.919 480.424 243.502 478.096 247.761C476.932 249.83 476.118 254.333 475.768 255.793C474.605 261.148 474.372 266.868 474.372 272.344C474.372 275.143 474.488 277.942 474.488 280.863C474.605 285.852 473.906 296.319 473.906 301.308C473.906 303.62 480.424 304.229 481.122 301.917C481.588 294.615 483.566 287.313 483.45 282.567C483.45 280.985 483.101 279.402 483.101 277.82C483.101 275.265 484.032 272.952 484.846 270.519C486.476 265.894 487.872 261.269 488.92 256.523C489.851 252.872 491.247 248.126 487.872 245.327Z"
          fill="#2035A4"
        />
        <path
          d="M497.415 273.926C497.066 273.317 496.95 272.709 496.833 272.222C496.251 270.64 496.018 269.058 496.135 267.476C496.6 262.121 498.579 253.359 493.807 244.597C487.406 241.311 485.428 245.814 485.777 254.697C486.359 261.269 487.057 267.963 489.617 273.926C489.967 274.778 490.316 275.63 490.548 276.481C490.665 277.09 490.781 277.82 490.898 278.429C491.13 280.741 492.411 286.826 493.924 293.154C494.505 295.345 499.976 294.858 499.976 292.789C500.092 291.815 499.51 285.852 499.394 285C499.044 279.524 498.695 276.603 497.415 273.926Z"
          fill="#2035A4"
        />
        <path
          d="M489.155 221.839C489.039 221.961 487.06 224.395 486.827 224.395C486.595 224.395 481.357 221.352 479.146 219.283C479.03 219.892 479.146 222.447 478.797 222.934C481.008 225.368 486.595 231.088 488.573 230.601C489.155 230.479 492.065 228.167 492.647 227.802C492.763 227.68 492.879 227.68 492.879 227.559C492.879 227.315 489.155 221.961 489.155 221.839Z"
          fill="#FCBE9F"
        />
        <path
          d="M479.964 220.256C479.033 217.214 477.753 216.727 474.843 215.875C474.377 217.214 472.399 219.161 472.748 220.986C473.097 222.69 477.52 221.595 478.916 222.69C478.916 222.69 479.149 222.934 479.498 223.299C479.964 223.299 480.429 221.595 479.964 220.256Z"
          fill="#FCBE9F"
        />
        <path
          d="M472.279 210.4L457.615 219.284C457.149 219.527 456.917 220.379 457.266 220.988L463.318 233.279C463.667 233.888 464.249 234.131 464.714 234.009L464.947 233.888L472.512 210.278L472.279 210.4Z"
          fill="white"
        />
        <path
          d="M479.73 223.544L473.562 210.887C473.329 210.4 472.864 210.157 472.514 210.4L457.966 219.162C457.501 219.406 457.268 220.258 457.617 220.866L463.669 233.158C464.018 233.766 464.717 234.131 465.182 233.766L479.497 225.126C479.847 225.004 479.963 224.152 479.73 223.544Z"
          fill="#3046B2"
        />
        <path
          d="M461.692 234.008C462.507 234.738 463.787 232.669 463.438 231.696C463.322 231.453 461.459 228.897 460.296 226.95L458.783 223.907C458.317 225.246 457.386 227.436 457.619 229.14C457.852 230.722 459.365 232.426 461.692 234.008Z"
          fill="#FCBE9F"
        />
        <path
          d="M471.347 232.548C471.231 232.67 469.253 235.104 469.02 235.104C468.787 235.104 463.899 232.061 463.201 231.696C462.502 231.209 460.989 233.156 461.688 234.13C463.317 236.077 468.438 242.04 470.882 241.432C471.464 241.31 474.373 238.998 474.955 238.633C475.072 238.511 475.188 238.511 475.188 238.389C475.072 238.024 471.347 232.67 471.347 232.548Z"
          fill="#FCBE9F"
        />
        <path
          d="M480.779 223.178C479.033 224.03 476.822 224.517 476.356 226.464C476.007 227.681 476.473 228.898 476.938 230.115C479.033 236.686 479.149 240.702 477.869 247.883C477.171 251.29 495.094 252.385 494.629 245.205C493.697 234.618 496.374 232.427 498.004 226.707C498.353 225.612 498.469 224.517 498.586 223.421C498.818 217.823 495.56 214.902 491.253 217.458C487.529 219.527 484.852 221.231 480.779 223.178Z"
          fill="white"
        />
        <path
          d="M475.772 225.977C474.725 226.951 471.117 231.94 470.302 233.157C469.022 234.861 473.677 240.094 475.307 238.999C477.751 237.417 481.475 233.887 482.057 229.628C482.406 226.829 479.962 222.083 475.772 225.977Z"
          fill="white"
        />
        <path
          d="M460.408 229.262C461.106 229.992 461.455 230.844 461.921 231.696C461.921 231.574 461.921 231.452 462.037 231.331C462.27 229.992 461.804 229.627 462.153 227.801C462.27 227.193 463.201 224.759 461.921 224.759C461.455 224.759 461.222 225.489 461.106 225.854C460.99 226.341 460.873 226.828 460.757 227.314C460.641 227.923 460.408 228.41 460.059 228.897C460.291 229.14 460.291 229.14 460.408 229.262Z"
          fill="#FCBE9F"
        />
        <path
          d="M478.797 219.405V219.284C478.565 219.162 478.448 219.162 478.215 219.04C477.75 218.797 477.401 218.432 476.935 218.31C476.586 218.188 475.888 217.823 475.539 218.188C474.724 219.162 477.052 220.136 477.517 220.379C478.914 221.109 479.03 221.718 479.728 222.326C479.496 221.353 479.147 220.379 478.797 219.405Z"
          fill="#FCBE9F"
        />
        <path
          d="M485.312 208.816L485.08 209.06L480.773 207.112L481.006 206.504L485.312 208.816Z"
          fill="#2035A4"
        />
        <path
          d="M482.171 205.044C481.59 205.896 481.357 206.748 481.124 207.721C481.008 208.086 481.008 208.33 480.775 208.573C480.542 208.816 479.378 209.668 479.262 210.033C479.145 210.277 479.727 211.007 479.727 211.007C479.727 211.007 478.68 214.901 478.913 215.632C479.145 216.483 479.844 216.483 480.542 216.97C481.24 217.457 481.59 218.431 481.59 219.283C481.59 220.134 482.055 222.082 481.939 222.933C481.939 223.055 481.939 223.177 481.939 223.299C482.288 224.029 487.991 223.542 489.969 221.351C490.435 220.865 490.435 220.499 490.318 219.891C489.969 218.917 489.62 218.066 489.62 217.092C489.62 216.118 491.017 217.335 491.715 216.605C492.646 215.51 493.577 214.415 494.159 213.076C494.857 211.494 494.974 209.79 494.624 208.086C494.275 206.383 493.344 204.922 491.948 204.07C490.551 203.097 488.805 202.853 487.176 202.853C485.197 202.61 483.219 203.34 482.171 205.044Z"
          fill="#FCBE9F"
        />
        <path
          d="M495.091 208.087C495.091 207.965 495.091 207.965 495.091 208.087C495.091 206.748 494.625 205.531 493.694 204.923C493.112 204.436 492.414 204.314 491.832 203.949C490.552 203.34 489.504 202.245 488.108 201.88C484.5 200.907 482.405 202.489 481.939 204.923C481.474 206.87 484.034 207.843 483.918 210.399C483.918 211.373 483.452 212.224 483.22 213.076C483.22 213.32 483.22 213.563 483.336 213.685C483.452 213.807 483.685 213.685 483.802 213.563C484.034 213.32 484.151 212.955 484.5 212.711C484.965 212.346 485.547 212.59 485.78 213.076C486.362 214.172 485.664 215.267 484.849 216.119C484.616 216.362 484.616 216.727 484.849 216.971C485.664 217.944 487.06 218.431 488.573 218.309C489.504 218.309 490.435 217.823 491.134 217.092C492.065 216.119 493.112 214.902 493.927 213.076C494.625 211.494 495.091 209.669 495.091 208.087Z"
          fill="#455FDC"
        />
        <path
          d="M485.317 211.981L485.084 212.225L480.895 210.277L481.011 209.669L485.317 211.981Z"
          fill="#2035A4"
        />
        <path
          d="M481.008 209.912C481.008 209.791 481.125 209.669 481.125 209.547C481.125 209.426 481.125 209.304 481.125 209.304V208.209C481.125 208.209 481.125 208.209 481.008 208.33V208.209C481.008 208.087 481.008 207.965 481.008 207.965C481.008 207.844 481.008 207.844 481.008 207.965C481.008 207.965 481.008 207.965 481.008 207.844C481.008 207.722 481.008 207.6 481.008 207.6V206.505H480.892L480.426 207.965C480.31 208.209 480.31 208.452 480.194 208.695C480.194 208.817 480.194 208.939 480.077 208.939C480.077 209.061 480.077 209.182 480.077 209.182V209.304L480.194 209.182C480.194 209.182 480.194 209.061 480.194 208.939C480.194 208.817 480.194 208.817 480.31 208.695C480.31 208.452 480.426 208.209 480.543 208.087C480.543 207.965 480.659 207.844 480.659 207.722C480.659 207.6 480.776 207.478 480.776 207.357V207.235C480.776 207.357 480.776 207.844 480.776 207.844C480.776 207.844 480.776 207.965 480.776 208.087C480.776 208.209 480.776 208.33 480.659 208.452C480.543 208.695 480.543 208.939 480.426 209.182C480.543 209.061 480.543 209.061 480.543 209.061C480.543 208.939 480.659 208.939 480.659 208.817V208.695C480.659 208.817 480.659 208.939 480.659 209.061L480.31 210.034C480.194 210.278 480.194 210.521 480.077 210.764C480.077 210.886 480.077 211.008 479.961 211.008C479.961 211.129 479.961 211.251 479.961 211.251V211.981L480.077 212.103C480.077 212.103 480.194 211.86 480.31 211.616L481.008 209.912ZM480.543 210.399C480.543 210.399 480.543 210.278 480.543 210.156C480.543 210.034 480.659 209.912 480.659 209.912L481.008 208.817V209.791L480.659 211.008C480.659 211.129 480.543 211.129 480.543 211.251V210.399Z"
          fill="#2035A4"
        />
        <path
          d="M484.037 212.711C483.571 212.346 482.408 212.346 481.942 213.077C481.709 213.563 481.477 214.05 481.477 214.659L482.64 216.241C484.386 215.876 484.968 213.563 484.037 212.711Z"
          fill="#FCBE9F"
        />
        <path
          d="M258.946 23.8357C258.248 23.714 257.55 23.8357 256.851 24.2008L84.3706 128.374C82.3921 129.591 81.2283 132.634 81.9266 135.311L117.656 287.434C118.006 289.138 119.053 290.233 120.217 290.476L121.381 290.72C120.217 290.476 119.169 289.381 118.82 287.677L83.0904 135.555C82.5085 132.877 83.5559 129.835 85.5345 128.618L258.015 24.5659C258.713 24.0791 259.528 23.9574 260.11 24.2008L258.946 23.8357Z"
          fill="url(#paint6_linear_1926_44029)"
        />
        <path
          d="M298.518 179.366L262.788 27.2436C262.206 24.5663 259.995 23.471 258.016 24.688L85.6519 128.74C83.6734 129.957 82.5095 132.999 83.2078 135.677L118.938 287.799C119.52 290.477 121.731 291.572 123.709 290.355L296.074 186.303C298.052 185.086 299.1 181.922 298.518 179.366Z"
          fill="url(#paint7_linear_1926_44029)"
        />
        <path
          d="M298.518 179.366L262.788 27.2436C262.206 24.5663 259.995 23.471 258.016 24.688L85.6519 128.74C83.6734 129.957 82.5095 132.999 83.2078 135.677L118.938 287.799C119.52 290.477 121.731 291.572 123.709 290.355L296.074 186.303C298.052 185.086 299.1 181.922 298.518 179.366Z"
          fill="#2035A4"
        />
        <path
          d="M122.082 288.408V293.154C122.082 294.006 122.548 294.736 123.595 295.345L238 364.469C239.979 365.686 243.237 365.686 245.216 364.469L416.533 260.417C417.464 259.809 418.046 259.079 418.046 258.227V256.645L122.082 288.408Z"
          fill="url(#paint8_linear_1926_44029)"
        />
        <path
          d="M416.418 254.332L302.013 182.044C300.034 180.827 296.775 180.827 294.797 182.044L123.48 286.096C121.501 287.313 121.501 289.26 123.48 290.477L237.885 362.765C239.864 363.982 243.122 363.982 245.101 362.765L416.418 258.713C418.513 257.496 418.396 255.549 416.418 254.332Z"
          fill="#FFF7F5"
        />
        <path
          d="M282.227 205.531C282.227 205.409 282.227 205.287 282.227 205.287C282.227 205.166 282.227 205.044 282.227 205.044C282.11 204.679 282.343 204.314 282.809 204.07L290.723 199.324C291.537 198.837 292.701 198.837 293.516 199.324L300.15 203.34C300.615 203.584 300.732 203.949 300.732 204.314C300.732 204.435 300.732 204.557 300.732 204.557C300.732 204.679 300.732 204.8 300.732 204.8C300.848 205.166 300.615 205.531 300.15 205.774L292.236 210.52C291.421 211.007 290.257 211.007 289.442 210.52L282.809 206.504C282.227 206.261 282.11 205.896 282.227 205.531ZM295.494 198.837L302.128 202.853C302.943 203.34 304.107 203.34 304.921 202.853L312.836 198.107C313.301 197.864 313.418 197.499 313.418 197.134C313.418 197.012 313.418 196.89 313.418 196.89C313.418 196.768 313.418 196.647 313.418 196.647C313.534 196.282 313.301 195.917 312.836 195.673L306.202 191.657C305.387 191.17 304.223 191.17 303.409 191.657L295.494 196.403C295.029 196.647 294.913 197.012 294.913 197.377C294.913 197.499 294.913 197.62 294.913 197.62C294.913 197.742 294.913 197.864 294.913 197.864C294.796 198.107 295.029 198.472 295.494 198.837ZM270.006 214.171L276.64 218.187C277.455 218.674 278.619 218.674 279.433 218.187L287.348 213.441C287.813 213.198 287.929 212.833 287.929 212.467C287.929 212.346 287.929 212.224 287.929 212.224C287.929 212.102 287.929 211.981 287.929 211.981C288.046 211.616 287.813 211.25 287.348 211.007L280.714 206.991C279.899 206.504 278.735 206.504 277.92 206.991L270.006 211.737C269.541 211.981 269.424 212.346 269.424 212.711C269.424 212.833 269.424 212.954 269.424 212.954C269.424 213.076 269.424 213.198 269.424 213.198C269.424 213.563 269.541 213.928 270.006 214.171ZM174.223 300.09L180.856 304.106C181.671 304.593 182.835 304.593 183.65 304.106L191.564 299.36C192.029 299.117 192.146 298.752 192.146 298.386C192.146 298.265 192.146 298.143 192.146 298.143C192.146 298.021 192.146 297.9 192.146 297.9C192.262 297.534 192.029 297.169 191.564 296.926L184.93 292.91C184.115 292.423 182.951 292.423 182.137 292.91L174.223 297.535C173.757 297.778 173.641 298.143 173.641 298.508C173.641 298.63 173.641 298.751 173.641 298.751C173.641 298.873 173.641 298.995 173.641 298.995C173.641 299.482 173.757 299.847 174.223 300.09ZM202.038 255.184L208.672 259.2C209.487 259.686 210.651 259.686 211.465 259.2L219.379 254.453C219.845 254.21 219.961 253.845 219.961 253.48C219.961 253.358 219.961 253.236 219.961 253.236C219.961 253.115 219.961 252.993 219.961 252.993C220.078 252.628 219.845 252.263 219.379 252.019L212.746 248.003C211.931 247.517 210.767 247.517 209.952 248.003L202.038 252.75C201.573 252.993 201.456 253.358 201.456 253.723C201.456 253.845 201.456 253.967 201.456 253.967C201.456 254.088 201.456 254.21 201.456 254.21C201.456 254.453 201.573 254.818 202.038 255.184ZM227.526 239.728L234.16 243.744C234.975 244.231 236.139 244.231 236.953 243.744L244.867 238.998C245.333 238.754 245.449 238.389 245.449 238.024C245.449 237.902 245.449 237.781 245.449 237.781C245.449 237.659 245.449 237.537 245.449 237.537C245.566 237.172 245.333 236.807 244.867 236.564L238.234 232.548C237.419 232.061 236.255 232.061 235.44 232.548L227.526 237.294C227.061 237.537 226.944 237.902 226.944 238.267C226.944 238.389 226.944 238.511 226.944 238.511C226.944 238.633 226.944 238.754 226.944 238.754C226.828 239.119 227.061 239.484 227.526 239.728ZM252.898 224.394L259.532 228.41C260.347 228.897 261.51 228.897 262.325 228.41L274.313 221.23C274.778 220.986 274.894 220.621 274.894 220.256C274.894 220.134 274.894 220.013 274.894 220.013C274.894 219.891 274.894 219.769 274.894 219.769C275.011 219.404 274.778 219.039 274.313 218.796L267.679 214.78C266.864 214.293 265.7 214.293 264.885 214.78L252.898 221.96C252.432 222.203 252.316 222.568 252.316 222.934C252.316 223.055 252.316 223.177 252.316 223.177C252.316 223.299 252.316 223.42 252.316 223.42C252.316 223.785 252.549 224.15 252.898 224.394ZM240.212 232.061L246.846 236.077C247.661 236.564 248.825 236.564 249.639 236.077L257.553 231.331C258.019 231.087 258.135 230.722 258.135 230.357C258.135 230.235 258.135 230.114 258.135 230.114C258.135 229.992 258.135 229.87 258.135 229.87C258.252 229.505 258.019 229.14 257.553 228.897L250.919 224.881C250.105 224.394 248.941 224.394 248.126 224.881L240.212 229.627C239.747 229.87 239.63 230.235 239.63 230.601C239.63 230.722 239.63 230.844 239.63 230.844C239.63 230.966 239.63 231.087 239.63 231.087C239.63 231.452 239.747 231.817 240.212 232.061ZM214.724 247.395L221.358 251.411C222.173 251.898 223.336 251.898 224.151 251.411L232.065 246.665C232.531 246.421 232.647 246.056 232.647 245.691C232.647 245.569 232.647 245.448 232.647 245.448C232.647 245.326 232.647 245.204 232.647 245.204C232.764 244.839 232.531 244.474 232.065 244.231L225.431 240.215C224.617 239.728 223.453 239.728 222.638 240.215L214.724 244.961C214.259 245.204 214.142 245.569 214.142 245.934C214.142 246.056 214.142 246.178 214.142 246.178C214.142 246.3 214.142 246.421 214.142 246.421C214.142 246.786 214.259 247.151 214.724 247.395ZM268.843 229.018L275.476 233.034C276.291 233.521 277.455 233.521 278.27 233.034L286.184 228.288C286.649 228.045 286.766 227.68 286.766 227.315C286.766 227.193 286.766 227.071 286.766 227.071C286.766 226.95 286.766 226.828 286.766 226.828C286.882 226.463 286.649 226.098 286.184 225.854L279.55 221.838C278.735 221.351 277.571 221.351 276.757 221.838L268.843 226.584C268.377 226.828 268.261 227.193 268.261 227.558C268.261 227.68 268.261 227.801 268.261 227.801C268.261 227.923 268.261 228.045 268.261 228.045C268.261 228.288 268.493 228.653 268.843 229.018ZM167.123 290.476L173.757 294.492C174.572 294.979 175.736 294.979 176.55 294.492L184.464 289.746C184.93 289.502 185.046 289.137 185.046 288.772C185.046 288.651 185.046 288.529 185.046 288.529C185.046 288.407 185.046 288.285 185.046 288.285C185.163 287.92 184.93 287.555 184.464 287.312L177.83 283.296C177.016 282.809 175.852 282.809 175.037 283.296L167.123 288.042C166.658 288.285 166.541 288.651 166.541 289.016C166.541 289.137 166.541 289.259 166.541 289.259C166.541 289.381 166.541 289.502 166.541 289.502C166.541 289.868 166.658 290.233 167.123 290.476ZM256.157 236.685L262.791 240.701C263.605 241.188 264.769 241.188 265.584 240.701L273.498 235.955C273.963 235.712 274.08 235.347 274.08 234.982C274.08 234.86 274.08 234.738 274.08 234.738C274.08 234.617 274.08 234.495 274.08 234.495C274.196 234.13 273.963 233.765 273.498 233.521L266.864 229.505C266.049 229.018 264.886 229.018 264.071 229.505L256.157 234.251C255.691 234.495 255.575 234.86 255.575 235.225C255.575 235.347 255.575 235.468 255.575 235.468C255.575 235.59 255.575 235.712 255.575 235.712C255.575 236.077 255.691 236.442 256.157 236.685ZM243.471 244.352L250.105 248.368C250.919 248.855 252.083 248.855 252.898 248.368L260.812 243.622C261.278 243.379 261.394 243.014 261.394 242.649C261.394 242.527 261.394 242.405 261.394 242.405C261.394 242.284 261.394 242.162 261.394 242.162C261.51 241.797 261.278 241.432 260.812 241.188L254.178 237.172C253.364 236.685 252.2 236.685 251.385 237.172L243.471 241.918C243.005 242.162 242.889 242.527 242.889 242.892C242.889 243.014 242.889 243.135 242.889 243.135C242.889 243.257 242.889 243.379 242.889 243.379C242.889 243.744 243.005 244.109 243.471 244.352ZM230.669 252.019L237.303 256.035C238.117 256.522 239.281 256.522 240.096 256.035L248.01 251.289C248.475 251.046 248.592 250.681 248.592 250.316C248.592 250.194 248.592 250.072 248.592 250.072C248.592 249.951 248.592 249.829 248.592 249.829C248.708 249.464 248.475 249.099 248.01 248.855L241.376 244.839C240.561 244.352 239.397 244.352 238.583 244.839L230.669 249.585C230.203 249.829 230.087 250.194 230.087 250.559C230.087 250.681 230.087 250.802 230.087 250.802C230.087 250.924 230.087 251.046 230.087 251.046C230.087 251.411 230.32 251.776 230.669 252.019ZM179.809 282.809L186.443 286.825C187.258 287.312 188.421 287.312 189.236 286.825L197.15 282.079C197.616 281.835 197.732 281.47 197.732 281.105C197.732 280.984 197.732 280.862 197.732 280.862C197.732 280.74 197.732 280.618 197.732 280.618C197.848 280.253 197.616 279.888 197.15 279.645L190.516 275.629C189.702 275.142 188.538 275.142 187.723 275.629L179.809 280.375C179.343 280.618 179.227 280.984 179.227 281.349C179.227 281.47 179.227 281.592 179.227 281.592C179.227 281.714 179.227 281.835 179.227 281.835C179.227 282.079 179.343 282.444 179.809 282.809ZM192.495 275.142L199.129 279.158C199.943 279.645 201.107 279.645 201.922 279.158L209.836 274.412C210.302 274.168 210.418 273.803 210.418 273.438C210.418 273.317 210.418 273.195 210.418 273.195C210.418 273.073 210.418 272.951 210.418 272.951C210.534 272.586 210.302 272.221 209.836 271.978C200.06 266.015 203.435 266.136 192.495 272.708C192.029 272.951 191.913 273.317 191.913 273.682C191.913 273.803 191.913 273.925 191.913 273.925C191.913 274.047 191.913 274.168 191.913 274.168C191.913 274.412 192.146 274.777 192.495 275.142ZM205.297 267.353L211.931 271.369C212.746 271.856 213.909 271.856 214.724 271.369L222.638 266.623C223.104 266.38 223.22 266.015 223.22 265.65C223.22 265.528 223.22 265.406 223.22 265.406C223.22 265.284 223.22 265.163 223.22 265.163C223.337 264.798 223.104 264.433 222.638 264.189L216.004 260.173C215.19 259.686 214.026 259.686 213.211 260.173L205.297 264.919C204.831 265.163 204.715 265.528 204.715 265.893C204.715 266.015 204.715 266.136 204.715 266.136C204.715 266.258 204.715 266.38 204.715 266.38C204.715 266.745 204.831 267.11 205.297 267.353ZM217.983 259.686C224.5 263.702 225.664 264.798 227.41 263.824L235.324 259.078C235.79 258.834 235.906 258.469 235.906 258.104C235.906 257.983 235.906 257.861 235.906 257.861C235.906 257.739 235.906 257.618 235.906 257.618C236.022 257.252 235.79 256.887 235.324 256.644L228.69 252.628C227.875 252.141 226.712 252.141 225.897 252.628L217.983 257.374C217.517 257.618 217.401 257.983 217.401 258.348C217.401 258.469 217.401 258.591 217.401 258.591C217.401 258.713 217.401 258.834 217.401 258.834C217.401 259.078 217.517 259.443 217.983 259.686ZM195.288 310.678C195.288 310.556 195.288 310.435 195.288 310.435C195.288 310.313 195.288 310.191 195.288 310.191C195.404 309.826 195.172 309.461 194.706 309.218L188.072 305.201C187.258 304.715 186.094 304.715 185.279 305.201L173.292 312.382C172.826 312.625 172.71 312.99 172.71 313.355C172.71 313.477 172.71 313.599 172.71 313.599C172.71 313.72 172.71 313.842 172.71 313.842C172.593 314.207 172.826 314.572 173.292 314.816L179.925 318.832C180.74 319.318 181.904 319.318 182.719 318.832L194.706 311.651C195.172 311.408 195.404 311.043 195.288 310.678ZM179.343 306.053C179.343 305.932 179.343 305.81 179.343 305.81C179.343 305.688 179.343 305.567 179.343 305.567C179.46 305.201 179.227 304.836 178.762 304.593L172.128 300.577C171.313 300.09 170.149 300.09 169.334 300.577L161.42 305.323C160.955 305.567 160.838 305.932 160.838 306.297C160.838 306.418 160.838 306.54 160.838 306.54C160.838 306.662 160.838 306.784 160.838 306.784C160.722 307.149 160.955 307.514 161.42 307.757L168.054 311.773C168.869 312.26 170.033 312.26 170.847 311.773L178.762 307.027C179.227 306.784 179.46 306.418 179.343 306.053ZM189.352 262.851C198.896 268.692 195.637 268.814 206.694 262.12C207.159 261.877 207.276 261.512 207.276 261.147C207.276 261.025 207.276 260.903 207.276 260.903C207.276 260.782 207.276 260.66 207.276 260.66C207.392 260.295 207.159 259.93 206.694 259.686L200.06 255.67C199.245 255.184 198.081 255.184 197.267 255.67L189.352 260.417C188.887 260.66 188.771 261.025 188.771 261.39C188.771 261.512 188.771 261.634 188.771 261.634C188.771 261.755 188.771 261.877 188.771 261.877C188.654 262.12 188.887 262.485 189.352 262.851ZM322.612 233.886C322.612 233.765 322.612 233.643 322.612 233.643C322.612 233.521 322.612 233.4 322.612 233.4C322.728 233.034 322.495 232.669 322.03 232.426L315.396 228.41C314.581 227.923 313.417 227.923 312.603 228.41L304.689 233.156C304.223 233.4 304.107 233.765 304.107 234.13C304.107 234.251 304.107 234.373 304.107 234.373C304.107 234.495 304.107 234.617 304.107 234.617C303.99 234.982 304.223 235.347 304.689 235.59L311.323 239.606C312.137 240.093 313.301 240.093 314.116 239.606L322.03 234.86C322.612 234.617 322.728 234.251 322.612 233.886ZM172.128 296.439C172.128 296.318 172.128 296.196 172.128 296.196C172.128 296.074 172.128 295.952 172.128 295.952C172.244 295.587 172.011 295.222 171.546 294.979L164.912 290.963C164.097 290.476 162.933 290.476 162.119 290.963L150.131 298.143C149.666 298.386 149.549 298.751 149.549 299.117C149.549 299.238 149.549 299.36 149.549 299.36C149.549 299.482 149.549 299.603 149.549 299.603C149.433 299.968 149.666 300.334 150.131 300.577L156.765 304.593C157.58 305.08 158.744 305.08 159.558 304.593L171.546 297.413C172.128 297.169 172.244 296.804 172.128 296.439ZM176.55 270.517L183.184 274.534C183.999 275.02 185.163 275.02 185.977 274.534L193.891 269.787C194.357 269.544 194.473 269.179 194.473 268.814C194.473 268.692 194.473 268.57 194.473 268.57C194.473 268.449 194.473 268.327 194.473 268.327C194.59 267.962 194.357 267.597 193.891 267.353L187.258 263.337C186.443 262.851 185.279 262.851 184.464 263.337L176.55 268.084C176.085 268.327 175.968 268.692 175.968 269.057C175.968 269.179 175.968 269.301 175.968 269.301C175.968 269.422 175.968 269.544 175.968 269.544C175.968 269.909 176.085 270.274 176.55 270.517ZM163.864 278.185L170.498 282.201C171.313 282.687 172.477 282.687 173.292 282.201L181.206 277.454C181.671 277.211 181.788 276.846 181.788 276.481C181.788 276.359 181.788 276.237 181.788 276.237C181.788 276.116 181.788 275.994 181.788 275.994C181.904 275.629 181.671 275.264 181.206 275.02L174.572 271.004C173.757 270.518 172.593 270.518 171.779 271.004L163.864 275.751C163.399 275.994 163.283 276.359 163.283 276.724C163.283 276.846 163.283 276.968 163.283 276.968C163.283 277.089 163.283 277.211 163.283 277.211C163.283 277.576 163.399 277.941 163.864 278.185ZM156.183 291.936C156.183 291.815 156.183 291.693 156.183 291.693C156.183 291.571 156.183 291.45 156.183 291.45C156.299 291.085 156.067 290.719 155.601 290.476L148.967 286.46C148.153 285.973 146.989 285.973 146.174 286.46L138.26 291.206C137.794 291.45 137.678 291.815 137.678 292.18C137.678 292.301 137.678 292.423 137.678 292.423C137.678 292.545 137.678 292.667 137.678 292.667C137.562 293.032 137.794 293.397 138.26 293.64L144.894 297.656C145.709 298.143 146.872 298.143 147.687 297.656L155.601 292.91C156.183 292.667 156.299 292.301 156.183 291.936ZM151.179 285.851L157.812 289.868C158.627 290.354 159.791 290.354 160.606 289.868L168.52 285.121C168.985 284.878 169.102 284.513 169.102 284.148C169.102 284.026 169.102 283.904 169.102 283.904C169.102 283.783 169.102 283.661 169.102 283.661C169.218 283.296 168.985 282.931 168.52 282.687L161.886 278.671C161.071 278.184 159.907 278.184 159.093 278.671L151.179 283.418C150.713 283.661 150.597 284.026 150.597 284.391C150.597 284.513 150.597 284.634 150.597 284.634C150.597 284.756 150.597 284.878 150.597 284.878C150.48 285.243 150.713 285.608 151.179 285.851ZM359.738 225.124C359.855 224.759 359.622 224.394 359.156 224.15L352.522 220.134C351.708 219.648 350.544 219.648 349.729 220.134L341.815 224.881C341.35 225.124 341.233 225.489 341.233 225.854C341.233 225.976 341.233 226.098 341.233 226.098C341.233 226.219 341.233 226.341 341.233 226.341C341.117 226.706 341.35 227.071 341.815 227.315L348.449 231.331C349.264 231.817 350.428 231.817 351.242 231.331L359.156 226.584C359.622 226.341 359.738 225.976 359.738 225.611C359.738 225.489 359.738 225.367 359.738 225.367C359.738 225.367 359.738 225.246 359.738 225.124ZM309.344 239.971L302.71 235.955C301.896 235.468 300.732 235.468 299.917 235.955L292.003 240.701C291.537 240.945 291.421 241.31 291.421 241.675C291.421 241.797 291.421 241.918 291.421 241.918C291.421 242.04 291.421 242.162 291.421 242.162C291.305 242.527 291.537 242.892 292.003 243.135L298.637 247.151C299.451 247.638 300.615 247.638 301.43 247.151L309.344 242.405C309.81 242.162 309.926 241.797 309.926 241.432C309.926 241.31 309.926 241.188 309.926 241.188C309.926 241.067 309.926 240.945 309.926 240.945C309.926 240.58 309.693 240.215 309.344 239.971ZM334.832 224.637L328.198 220.621C327.384 220.134 326.22 220.134 325.405 220.621L317.491 225.367C317.025 225.611 316.909 225.976 316.909 226.341C316.909 226.463 316.909 226.584 316.909 226.584C316.909 226.706 316.909 226.828 316.909 226.828C316.793 227.193 317.025 227.558 317.491 227.801L324.125 231.817C324.939 232.304 326.103 232.304 326.918 231.817L334.832 227.071C335.298 226.828 335.414 226.463 335.414 226.098C335.414 225.976 335.414 225.854 335.414 225.854C335.414 225.733 335.414 225.611 335.414 225.611C335.414 225.367 335.298 225.002 334.832 224.637ZM283.856 255.305L277.222 251.289C276.407 250.802 275.244 250.802 274.429 251.289L266.515 256.035C266.049 256.279 265.933 256.644 265.933 257.009C265.933 257.131 265.933 257.252 265.933 257.252C265.933 257.374 265.933 257.496 265.933 257.496C265.817 257.861 266.049 258.226 266.515 258.469L273.149 262.485C273.963 262.972 275.127 262.972 275.942 262.485L283.856 257.739C284.322 257.496 284.438 257.131 284.438 256.766C284.438 256.644 284.438 256.522 284.438 256.522C284.438 256.4 284.438 256.279 284.438 256.279C284.438 256.035 284.322 255.67 283.856 255.305ZM329.711 218.674C329.711 218.796 329.711 218.917 329.711 218.917C329.711 219.039 329.711 219.161 329.711 219.161C329.595 219.526 329.828 219.891 330.293 220.134L336.927 224.15C337.742 224.637 338.906 224.637 339.72 224.15L347.634 219.404C348.1 219.161 348.216 218.796 348.216 218.431C348.216 218.309 348.216 218.187 348.216 218.187C348.216 218.066 348.216 217.944 348.216 217.944C348.333 217.579 348.1 217.214 347.634 216.97L341 212.954C340.186 212.467 339.022 212.467 338.207 212.954L330.293 217.7C329.828 217.944 329.711 218.309 329.711 218.674ZM232.996 286.095L226.362 282.079C225.548 281.592 224.384 281.592 223.569 282.079L215.655 286.825C215.19 287.068 215.073 287.434 215.073 287.799C215.073 287.92 215.073 288.042 215.073 288.042C215.073 288.164 215.073 288.285 215.073 288.285C214.957 288.651 215.19 289.016 215.655 289.259L222.289 293.275C223.104 293.762 224.268 293.762 225.082 293.275L232.996 288.529C233.462 288.285 233.578 287.92 233.578 287.555C233.578 287.434 233.578 287.312 233.578 287.312C233.578 287.19 233.578 287.068 233.578 287.068C233.578 286.703 233.346 286.338 232.996 286.095ZM258.368 270.761L251.734 266.745C250.919 266.258 249.756 266.258 248.941 266.745L241.027 271.491C240.561 271.734 240.445 272.1 240.445 272.465C240.445 272.586 240.445 272.708 240.445 272.708C240.445 272.83 240.445 272.951 240.445 272.951C240.329 273.317 240.561 273.682 241.027 273.925L247.661 277.941C248.475 278.428 249.639 278.428 250.454 277.941L258.368 273.195C258.834 272.951 258.95 272.586 258.95 272.221C258.95 272.1 258.95 271.978 258.95 271.978C258.95 271.856 258.95 271.734 258.95 271.734C258.95 271.369 258.834 271.004 258.368 270.761ZM245.682 278.428L239.048 274.412C238.234 273.925 237.07 273.925 236.255 274.412L228.341 279.158C227.875 279.401 227.759 279.767 227.759 280.132C227.759 280.253 227.759 280.375 227.759 280.375C227.759 280.497 227.759 280.618 227.759 280.618C227.643 280.984 227.875 281.349 228.341 281.592L234.975 285.608C235.79 286.095 236.953 286.095 237.768 285.608L245.682 280.862C246.148 280.618 246.264 280.253 246.264 279.888C246.264 279.767 246.264 279.645 246.264 279.645C246.264 279.523 246.264 279.401 246.264 279.401C246.264 279.036 246.148 278.671 245.682 278.428ZM220.194 293.762L213.56 289.746C212.746 289.259 211.582 289.259 210.767 289.746L202.853 294.492C202.387 294.735 202.271 295.101 202.271 295.466C202.271 295.587 202.271 295.709 202.271 295.709C202.271 295.831 202.271 295.952 202.271 295.952C202.155 296.318 202.387 296.683 202.853 296.926L209.487 300.942C210.302 301.429 211.465 301.429 212.28 300.942L220.194 296.196C220.66 295.952 220.776 295.587 220.776 295.222C220.776 295.101 220.776 294.979 220.776 294.979C220.776 294.857 220.776 294.735 220.776 294.735C220.776 294.37 220.66 294.005 220.194 293.762ZM207.508 301.429L200.874 297.413C200.06 296.926 198.896 296.926 198.081 297.413L190.167 302.159C189.702 302.402 189.585 302.768 189.585 303.133C189.585 303.254 189.585 303.376 189.585 303.376C189.585 303.498 189.585 303.619 189.585 303.619C189.469 303.985 189.702 304.35 190.167 304.593L196.801 308.609C197.616 309.096 198.78 309.096 199.594 308.609L207.508 303.863C207.974 303.619 208.09 303.254 208.09 302.889C208.09 302.768 208.09 302.646 208.09 302.646C208.09 302.524 208.09 302.402 208.09 302.402C208.09 302.037 207.974 301.672 207.508 301.429ZM271.17 263.094L264.536 259.078C263.722 258.591 262.558 258.591 261.743 259.078L253.829 263.824C253.363 264.067 253.247 264.433 253.247 264.798C253.247 264.919 253.247 265.041 253.247 265.041C253.247 265.163 253.247 265.284 253.247 265.284C253.131 265.65 253.363 266.015 253.829 266.258L260.463 270.274C261.278 270.761 262.441 270.761 263.256 270.274L271.17 265.528C271.636 265.285 271.752 264.919 271.752 264.554C271.752 264.433 271.752 264.311 271.752 264.311C271.752 264.189 271.752 264.067 271.752 264.067C271.752 263.702 271.519 263.337 271.17 263.094ZM296.542 247.638L289.908 243.622C289.093 243.135 287.929 243.135 287.115 243.622L279.201 248.368C278.735 248.612 278.619 248.977 278.619 249.342C278.619 249.464 278.619 249.585 278.619 249.585C278.619 249.707 278.619 249.829 278.619 249.829C278.502 250.194 278.735 250.559 279.201 250.802L285.835 254.818C286.649 255.305 287.813 255.305 288.628 254.818L296.542 250.072C297.007 249.829 297.124 249.464 297.124 249.099C297.124 248.977 297.124 248.855 297.124 248.855C297.124 248.734 297.124 248.612 297.124 248.612C297.124 248.247 297.007 247.882 296.542 247.638ZM227.294 303.376L220.66 299.36C219.845 298.873 218.681 298.873 217.866 299.36L209.952 304.106C209.487 304.35 209.37 304.715 209.37 305.08C209.37 305.202 209.37 305.323 209.37 305.323C209.37 305.445 209.37 305.567 209.37 305.567C209.254 305.932 209.487 306.297 209.952 306.54L216.586 310.556C217.401 311.043 218.565 311.043 219.379 310.556L227.294 305.81C227.759 305.567 227.875 305.201 227.875 304.836C227.875 304.715 227.875 304.593 227.875 304.593C227.875 304.471 227.875 304.35 227.875 304.35C227.992 303.985 227.759 303.619 227.294 303.376ZM240.096 295.709L233.462 291.693C232.647 291.206 231.483 291.206 230.669 291.693L222.755 296.439C222.289 296.683 222.173 297.048 222.173 297.413C222.173 297.535 222.173 297.656 222.173 297.656C222.173 297.778 222.173 297.9 222.173 297.9C222.056 298.265 222.289 298.63 222.755 298.873L229.388 302.889C230.203 303.376 231.367 303.376 232.182 302.889L240.096 298.143C240.561 297.9 240.678 297.535 240.678 297.169C240.678 297.048 240.678 296.926 240.678 296.926C240.678 296.804 240.678 296.683 240.678 296.683C240.678 296.318 240.561 295.952 240.096 295.709ZM214.608 311.043L207.974 307.027C207.159 306.54 205.995 306.54 205.181 307.027L197.267 311.773C196.801 312.017 196.685 312.382 196.685 312.747C196.685 312.868 196.685 312.99 196.685 312.99C196.685 313.112 196.685 313.234 196.685 313.234C196.568 313.599 196.801 313.964 197.267 314.207L203.9 318.223C204.715 318.71 205.879 318.71 206.694 318.223L214.608 313.477C215.073 313.234 215.19 312.868 215.19 312.503C215.19 312.382 215.19 312.26 215.19 312.26C215.19 312.138 215.19 312.017 215.19 312.017C215.19 311.651 215.073 311.286 214.608 311.043ZM201.922 318.71L195.288 314.694C194.473 314.207 193.31 314.207 192.495 314.694L184.581 319.44C184.115 319.684 183.999 320.049 183.999 320.414C183.999 320.535 183.999 320.657 183.999 320.657C183.999 320.779 183.999 320.901 183.999 320.901C183.882 321.266 184.115 321.631 184.581 321.874L191.215 325.89C192.029 326.377 193.193 326.377 194.008 325.89L201.922 321.144C202.387 320.901 202.504 320.535 202.504 320.17C202.504 320.049 202.504 319.927 202.504 319.927C202.504 319.805 202.504 319.684 202.504 319.684C202.504 319.318 202.387 318.953 201.922 318.71ZM297.473 232.913L290.839 228.897C290.024 228.41 288.861 228.41 288.046 228.897L276.058 236.077C275.593 236.32 275.476 236.685 275.476 237.05C275.476 237.172 275.476 237.294 275.476 237.294C275.476 237.416 275.476 237.537 275.476 237.537C275.36 237.902 275.593 238.267 276.058 238.511L282.692 242.527C283.507 243.014 284.671 243.014 285.485 242.527L297.473 235.347C297.938 235.103 298.055 234.738 298.055 234.373C298.055 234.251 298.055 234.13 298.055 234.13C298.055 234.008 298.055 233.886 298.055 233.886C298.055 233.521 297.938 233.156 297.473 232.913ZM320.401 247.151L313.767 243.135C312.952 242.649 311.788 242.649 310.973 243.135L298.986 250.316C298.52 250.559 298.404 250.924 298.404 251.289C298.404 251.411 298.404 251.533 298.404 251.533C298.404 251.654 298.404 251.776 298.404 251.776C298.288 252.141 298.52 252.506 298.986 252.75L305.62 256.766C306.434 257.252 307.598 257.252 308.413 256.766L320.401 249.585C320.866 249.342 320.982 248.977 320.982 248.612C320.982 248.49 320.982 248.368 320.982 248.368C320.982 248.247 320.982 248.125 320.982 248.125C321.099 247.76 320.866 247.395 320.401 247.151ZM346.47 231.817L339.837 227.801C339.022 227.315 337.858 227.315 337.043 227.801L329.129 232.548C328.664 232.791 328.547 233.156 328.547 233.521C328.547 233.643 328.547 233.765 328.547 233.765C328.547 233.886 328.547 234.008 328.547 234.008C328.431 234.373 328.664 234.738 329.129 234.982L335.763 238.998C336.578 239.484 337.742 239.484 338.556 238.998L346.47 234.251C346.936 234.008 347.052 233.643 347.052 233.278C347.052 233.156 347.052 233.034 347.052 233.034C347.052 232.913 347.052 232.791 347.052 232.791C347.052 232.426 346.936 232.061 346.47 231.817ZM333.785 239.484L327.151 235.468C326.336 234.982 325.172 234.982 324.358 235.468L316.443 240.215C315.978 240.458 315.862 240.823 315.862 241.188C315.862 241.31 315.862 241.432 315.862 241.432C315.862 241.553 315.862 241.675 315.862 241.675C315.745 242.04 315.978 242.405 316.443 242.649L323.077 246.665C323.892 247.151 325.056 247.151 325.871 246.665L333.785 241.918C334.25 241.675 334.367 241.31 334.367 240.945C334.367 240.823 334.367 240.701 334.367 240.701C334.367 240.58 334.367 240.458 334.367 240.458C334.367 240.093 334.25 239.728 333.785 239.484ZM303.874 257.252L297.24 253.236C296.425 252.75 295.262 252.75 294.447 253.236L235.557 288.772C235.091 289.016 234.975 289.381 234.975 289.746C234.975 289.868 234.975 289.989 234.975 289.989C234.975 290.111 234.975 290.233 234.975 290.233C234.858 290.598 235.091 290.963 235.557 291.206L242.191 295.222C243.005 295.709 244.169 295.709 244.984 295.222L303.874 259.686C304.34 259.443 304.456 259.078 304.456 258.713C304.456 258.591 304.456 258.469 304.456 258.469C304.456 258.348 304.456 258.226 304.456 258.226C304.456 257.861 304.34 257.496 303.874 257.252ZM255.109 258.469L248.475 254.453C247.661 253.967 246.497 253.967 245.682 254.453L237.768 259.2C237.303 259.443 237.186 259.808 237.186 260.173C237.186 260.295 237.186 260.417 237.186 260.417C237.186 260.538 237.186 260.66 237.186 260.66C237.07 261.025 237.303 261.39 237.768 261.634L244.402 265.65C245.217 266.136 246.38 266.136 247.195 265.65L255.109 260.903C255.575 260.66 255.691 260.295 255.691 259.93C255.691 259.808 255.691 259.686 255.691 259.686C255.691 259.565 255.691 259.443 255.691 259.443C255.808 259.078 255.575 258.713 255.109 258.469ZM242.423 266.136L235.79 262.12C234.975 261.634 233.811 261.634 232.996 262.12L225.082 266.867C224.617 267.11 224.5 267.475 224.5 267.84C224.5 267.962 224.5 268.084 224.5 268.084C224.5 268.205 224.5 268.327 224.5 268.327C224.384 268.692 224.617 269.057 225.082 269.301L231.716 273.317C232.531 273.803 233.695 273.803 234.509 273.317L242.423 268.57C242.889 268.327 243.005 267.962 243.005 267.597C243.005 267.475 243.005 267.353 243.005 267.353C243.005 267.232 243.005 267.11 243.005 267.11C243.005 266.745 242.889 266.38 242.423 266.136ZM267.911 250.802L261.278 246.786C260.463 246.3 259.299 246.3 258.484 246.786L250.57 251.533C250.105 251.776 249.988 252.141 249.988 252.506C249.988 252.628 249.988 252.75 249.988 252.75C249.988 252.871 249.988 252.993 249.988 252.993C249.872 253.358 250.105 253.723 250.57 253.967L257.204 257.983C258.019 258.469 259.183 258.469 259.997 257.983L267.911 253.236C268.377 252.993 268.493 252.628 268.493 252.263C268.493 252.141 268.493 252.019 268.493 252.019C268.493 251.898 268.493 251.776 268.493 251.776C268.493 251.411 268.377 251.046 267.911 250.802ZM306.551 204.314C306.551 204.435 306.551 204.557 306.551 204.557C306.551 204.679 306.551 204.8 306.551 204.8C306.434 205.166 306.667 205.531 307.133 205.774L313.767 209.79C314.581 210.277 315.745 210.277 316.56 209.79L324.474 205.044C324.939 204.8 325.056 204.435 325.056 204.07C325.056 203.949 325.056 203.827 325.056 203.827C325.056 203.705 325.056 203.584 325.056 203.584C325.172 203.218 324.939 202.853 324.474 202.61L317.84 198.594C317.025 198.107 315.862 198.107 315.047 198.594L307.133 203.34C306.667 203.705 306.434 204.07 306.551 204.314ZM280.597 243.014L273.963 238.998C273.149 238.511 271.985 238.511 271.17 238.998L263.256 243.744C262.791 243.987 262.674 244.352 262.674 244.717C262.674 244.839 262.674 244.961 262.674 244.961C262.674 245.083 262.674 245.204 262.674 245.204C262.558 245.569 262.791 245.934 263.256 246.178L269.89 250.194C270.705 250.681 271.869 250.681 272.683 250.194L280.597 245.448C281.063 245.204 281.179 244.839 281.179 244.474C281.179 244.352 281.179 244.231 281.179 244.231C281.179 244.109 281.179 243.987 281.179 243.987C281.179 243.744 281.063 243.379 280.597 243.014ZM229.738 273.803L223.104 269.787C222.289 269.301 221.125 269.301 220.311 269.787L212.396 274.534C211.931 274.777 211.815 275.142 211.815 275.507C211.815 275.629 211.815 275.751 211.815 275.751C211.815 275.872 211.815 275.994 211.815 275.994C211.698 276.359 211.931 276.724 212.396 276.968L219.03 280.984C219.845 281.47 221.009 281.47 221.824 280.984L229.738 276.237C230.203 275.994 230.32 275.629 230.32 275.264C230.32 275.142 230.32 275.02 230.32 275.02C230.32 274.899 230.32 274.777 230.32 274.777C230.32 274.412 230.203 274.047 229.738 273.803ZM204.25 289.137L197.616 285.121C196.801 284.634 195.637 284.634 194.822 285.121L186.908 289.868C186.443 290.111 186.326 290.476 186.326 290.841C186.326 290.963 186.326 291.085 186.326 291.085C186.326 291.206 186.326 291.328 186.326 291.328C186.21 291.693 186.443 292.058 186.908 292.301L193.542 296.318C194.357 296.804 195.521 296.804 196.335 296.318L204.25 291.571C204.715 291.328 204.831 290.963 204.831 290.598C204.831 290.476 204.831 290.354 204.831 290.354C204.831 290.233 204.831 290.111 204.831 290.111C204.831 289.868 204.715 289.502 204.25 289.137ZM216.935 281.47L210.302 277.454C209.487 276.968 208.323 276.968 207.508 277.454L199.594 282.201C199.129 282.444 199.012 282.809 199.012 283.174C199.012 283.296 199.012 283.418 199.012 283.418C199.012 283.539 199.012 283.661 199.012 283.661C198.896 284.026 199.129 284.391 199.594 284.634L206.228 288.651C207.043 289.137 208.207 289.137 209.021 288.651L216.935 283.904C217.401 283.661 217.517 283.296 217.517 282.931C217.517 282.809 217.517 282.687 217.517 282.687C217.517 282.566 217.517 282.444 217.517 282.444C217.634 282.079 217.401 281.714 216.935 281.47Z"
          fill="#CEC6D4"
        />
        <path
          d="M313.766 211.859L305.038 206.504C304.107 205.896 302.594 205.896 301.546 206.504L281.528 218.553C280.946 218.918 280.83 219.283 280.83 219.77C280.83 219.891 280.83 220.013 280.83 220.013C280.83 220.135 280.83 220.256 280.83 220.256C280.713 220.743 280.946 221.108 281.528 221.473L298.986 232.183C299.917 232.791 301.43 232.791 302.477 232.183L335.647 212.224C336.229 211.859 336.345 211.494 336.345 211.007C336.345 210.886 336.345 210.764 336.345 210.764C336.345 210.642 336.345 210.521 336.345 210.521C336.461 210.034 336.229 209.669 335.647 209.304L329.129 205.287C328.547 204.922 327.5 204.922 326.801 205.287L315.629 211.859C315.163 212.224 314.348 212.224 313.766 211.859Z"
          fill="#D5D0D5"
        />
        <path
          d="M335.648 208.938L329.13 204.922C328.549 204.557 327.501 204.557 326.803 204.922L315.63 211.494C315.048 211.859 314.233 211.859 313.651 211.494L304.923 206.139C303.992 205.531 302.479 205.531 301.431 206.139L281.413 218.187C280.482 218.796 280.482 219.648 281.413 220.256L298.871 230.966C299.802 231.574 301.315 231.574 302.362 230.966L335.532 211.007C336.579 210.399 336.579 209.547 335.648 208.938Z"
          fill="#FFF7F5"
        />
        <path
          opacity="0.7"
          d="M360.199 281.714L296.653 320.536C295.373 321.266 293.394 321.266 292.231 320.536L256.152 297.657C254.871 296.927 254.871 295.588 256.152 294.858L319.697 256.036C320.977 255.306 322.956 255.306 324.12 256.036L360.199 278.915C361.479 279.767 361.479 280.984 360.199 281.714Z"
          fill="#EFE8EE"
        />
        <path
          d="M256.037 295.588L319.582 256.766C320.863 256.036 322.841 256.036 324.005 256.766L360.084 279.645C360.55 279.889 360.782 280.254 360.899 280.741C361.131 280.132 360.782 279.524 360.084 279.037L324.005 256.158C322.725 255.427 320.746 255.306 319.582 256.158L256.037 294.979C255.222 295.466 254.99 296.075 255.222 296.683C255.339 296.196 255.571 295.831 256.037 295.588Z"
          fill="#C0B7C8"
        />
        <path
          d="M155.714 291.693L147.8 296.44C146.985 296.926 145.821 296.926 145.007 296.44L138.373 292.424C137.558 291.937 137.558 291.207 138.373 290.72L146.287 285.974C147.102 285.487 148.265 285.487 149.08 285.974L155.714 289.99C156.412 290.476 156.412 291.207 155.714 291.693ZM168.4 282.323L161.766 278.307C160.951 277.82 159.787 277.82 158.973 278.307L151.059 283.053C150.244 283.54 150.244 284.27 151.059 284.757L157.692 288.773C158.507 289.259 159.671 289.259 160.486 288.773L168.4 284.026C169.214 283.54 169.214 282.809 168.4 282.323ZM181.086 274.656L174.452 270.64C173.637 270.153 172.473 270.153 171.658 270.64L163.744 275.386C162.93 275.873 162.93 276.603 163.744 277.09L170.378 281.106C171.193 281.592 172.357 281.592 173.171 281.106L181.086 276.359C181.9 275.873 181.9 275.021 181.086 274.656ZM193.888 266.867L187.254 262.851C186.439 262.364 185.275 262.364 184.461 262.851L176.547 267.597C175.732 268.084 175.732 268.814 176.547 269.301L183.18 273.317C183.995 273.804 185.159 273.804 185.974 273.317L193.888 268.571C194.586 268.084 194.586 267.354 193.888 266.867ZM206.574 259.2L199.94 255.184C199.125 254.697 197.961 254.697 197.147 255.184L189.232 259.93C188.418 260.417 188.418 261.147 189.232 261.634L195.866 265.65C196.681 266.137 197.845 266.137 198.66 265.65L206.574 260.904C207.388 260.417 207.388 259.687 206.574 259.2ZM219.259 251.533L212.626 247.517C211.811 247.03 210.647 247.03 209.832 247.517L201.918 252.263C201.104 252.75 201.104 253.48 201.918 253.967L208.552 257.983C209.367 258.47 210.531 258.47 211.345 257.983L219.259 253.237C220.074 252.75 220.074 252.02 219.259 251.533ZM232.062 243.866L225.428 239.85C224.613 239.363 223.449 239.363 222.635 239.85L214.72 244.596C213.906 245.083 213.906 245.813 214.72 246.3L221.354 250.316C222.169 250.803 223.333 250.803 224.148 250.316L232.062 245.57C232.76 245.083 232.76 244.353 232.062 243.866ZM244.747 236.199L238.114 232.183C237.299 231.696 236.135 231.696 235.32 232.183L227.406 236.929C226.592 237.416 226.592 238.146 227.406 238.633L234.04 242.649C234.855 243.136 236.019 243.136 236.833 242.649L244.747 237.903C245.562 237.416 245.562 236.686 244.747 236.199ZM257.433 228.532L250.799 224.516C249.985 224.029 248.821 224.029 248.006 224.516L240.092 229.262C239.277 229.749 239.277 230.479 240.092 230.966L246.726 234.982C247.541 235.469 248.704 235.469 249.519 234.982L257.433 230.236C258.248 229.749 258.248 229.019 257.433 228.532ZM274.309 218.309L267.675 214.293C266.86 213.807 265.697 213.807 264.882 214.293L252.894 221.474C252.08 221.96 252.08 222.691 252.894 223.177L259.528 227.193C260.343 227.68 261.507 227.68 262.321 227.193L274.309 220.013C275.124 219.526 275.124 218.796 274.309 218.309ZM322.143 231.94L315.509 227.924C314.694 227.437 313.53 227.437 312.716 227.924L304.801 232.67C303.987 233.157 303.987 233.887 304.801 234.374L311.435 238.39C312.25 238.876 313.414 238.876 314.229 238.39L322.143 233.643C322.841 233.157 322.841 232.426 322.143 231.94ZM334.828 224.273L328.195 220.257C327.38 219.77 326.216 219.77 325.401 220.257L317.487 225.003C316.673 225.49 316.673 226.22 317.487 226.707L324.121 230.723C324.936 231.209 326.1 231.209 326.914 230.723L334.828 225.976C335.643 225.49 335.643 224.759 334.828 224.273ZM347.514 216.606L340.88 212.59C340.066 212.103 338.902 212.103 338.087 212.59L330.173 217.336C329.358 217.823 329.358 218.553 330.173 219.04L336.807 223.056C337.622 223.542 338.786 223.542 339.6 223.056L347.514 218.309C348.329 217.823 348.329 217.092 347.514 216.606ZM333.781 239.12L327.147 235.104C326.332 234.617 325.169 234.617 324.354 235.104L316.44 239.85C315.625 240.337 315.625 241.067 316.44 241.554L323.074 245.57C323.888 246.057 325.052 246.057 325.867 245.57L333.781 240.824C334.479 240.337 334.479 239.607 333.781 239.12ZM346.467 231.453L339.833 227.437C339.018 226.95 337.854 226.95 337.04 227.437L329.126 232.183C328.311 232.67 328.311 233.4 329.126 233.887L335.76 237.903C336.574 238.39 337.738 238.39 338.553 237.903L346.467 233.157C347.282 232.67 347.282 231.94 346.467 231.453ZM359.153 223.786L352.519 219.77C351.704 219.283 350.54 219.283 349.726 219.77L341.811 224.516C340.997 225.003 340.997 225.733 341.811 226.22L348.445 230.236C349.26 230.723 350.424 230.723 351.239 230.236L359.153 225.49C359.967 225.003 359.967 224.273 359.153 223.786ZM171.658 294.614L165.025 290.598C164.21 290.111 163.046 290.111 162.231 290.598L150.244 297.778C149.429 298.265 149.429 298.995 150.244 299.482L156.878 303.498C157.692 303.985 158.856 303.985 159.671 303.498L171.658 296.318C172.357 295.831 172.357 294.979 171.658 294.614ZM184.344 286.826L177.71 282.809C176.896 282.323 175.732 282.323 174.917 282.809L167.003 287.556C166.188 288.042 166.188 288.773 167.003 289.259L173.637 293.276C174.452 293.762 175.616 293.762 176.43 293.276L184.344 288.529C185.159 288.164 185.159 287.312 184.344 286.826ZM197.147 279.159L190.513 275.143C189.698 274.656 188.534 274.656 187.719 275.143L179.805 279.889C178.991 280.376 178.991 281.106 179.805 281.592L186.439 285.609C187.254 286.095 188.418 286.095 189.232 285.609L197.147 280.862C197.845 280.376 197.845 279.645 197.147 279.159ZM209.832 271.492L203.198 267.475C202.384 266.989 201.22 266.989 200.405 267.475L192.491 272.222C191.676 272.709 191.676 273.439 192.491 273.926L199.125 277.942C199.94 278.428 201.104 278.428 201.918 277.942L209.832 273.195C210.531 272.709 210.531 271.978 209.832 271.492ZM222.518 263.825L215.884 259.809C215.07 259.322 213.906 259.322 213.091 259.809L205.177 264.555C204.362 265.042 204.362 265.772 205.177 266.259L211.811 270.275C212.626 270.761 213.789 270.761 214.604 270.275L222.518 265.528C223.333 265.042 223.333 264.311 222.518 263.825ZM235.32 256.158L228.687 252.142C227.872 251.655 226.708 251.655 225.893 252.142L217.979 256.888C217.165 257.375 217.165 258.105 217.979 258.592L224.613 262.608C225.428 263.094 226.592 263.094 227.406 262.608L235.32 257.861C236.019 257.375 236.019 256.644 235.32 256.158ZM248.006 248.491L241.372 244.475C240.558 243.988 239.394 243.988 238.579 244.475L230.665 249.221C229.85 249.708 229.85 250.438 230.665 250.925L237.299 254.941C238.114 255.427 239.277 255.427 240.092 254.941L248.006 250.194C248.704 249.708 248.704 248.977 248.006 248.491ZM260.692 240.824L254.058 236.808C253.243 236.321 252.08 236.321 251.265 236.808L243.351 241.554C242.536 242.041 242.536 242.771 243.351 243.258L249.985 247.274C250.799 247.76 251.963 247.76 252.778 247.274L260.692 242.527C261.507 242.041 261.507 241.189 260.692 240.824ZM273.494 233.035L266.86 229.019C266.046 228.532 264.882 228.532 264.067 229.019L256.153 233.765C255.338 234.252 255.338 234.982 256.153 235.469L262.787 239.485C263.602 239.972 264.765 239.972 265.58 239.485L273.494 234.739C274.193 234.374 274.193 233.522 273.494 233.035ZM286.18 225.368L279.546 221.352C278.732 220.865 277.568 220.865 276.753 221.352L268.839 226.098C268.024 226.585 268.024 227.315 268.839 227.802L275.473 231.818C276.287 232.305 277.451 232.305 278.266 231.818L286.18 227.072C286.878 226.585 286.878 225.855 286.18 225.368ZM178.758 304.228L172.124 300.212C171.309 299.726 170.145 299.726 169.331 300.212L161.417 304.959C160.602 305.445 160.602 306.176 161.417 306.662L168.051 310.678C168.865 311.165 170.029 311.165 170.844 310.678L178.758 305.932C179.573 305.445 179.573 304.593 178.758 304.228ZM191.56 296.44L184.926 292.424C184.112 291.937 182.948 291.937 182.133 292.424L174.219 297.17C173.404 297.657 173.404 298.387 174.219 298.874L180.853 302.89C181.667 303.376 182.831 303.376 183.646 302.89L191.56 298.143C192.258 297.778 192.258 296.926 191.56 296.44ZM204.246 288.773L197.612 284.757C196.797 284.27 195.634 284.27 194.819 284.757L186.905 289.503C186.09 289.99 186.09 290.72 186.905 291.207L193.539 295.223C194.353 295.709 195.517 295.709 196.332 295.223L204.246 290.476C205.061 289.99 205.061 289.259 204.246 288.773ZM216.932 281.106L210.298 277.09C209.483 276.603 208.319 276.603 207.505 277.09L199.591 281.836C198.776 282.323 198.776 283.053 199.591 283.54L206.224 287.556C207.039 288.042 208.203 288.042 209.018 287.556L216.932 282.809C217.746 282.323 217.746 281.592 216.932 281.106ZM201.918 318.345L195.284 314.329C194.47 313.842 193.306 313.842 192.491 314.329L184.577 319.076C183.762 319.562 183.762 320.293 184.577 320.779L191.211 324.795C192.026 325.282 193.189 325.282 194.004 324.795L201.918 320.049C202.617 319.562 202.617 318.832 201.918 318.345ZM214.604 310.678L207.97 306.662C207.156 306.176 205.992 306.176 205.177 306.662L197.263 311.409C196.448 311.895 196.448 312.626 197.263 313.112L203.897 317.128C204.711 317.615 205.875 317.615 206.69 317.128L214.604 312.382C215.419 311.895 215.419 311.165 214.604 310.678ZM227.29 303.011L220.656 298.995C219.841 298.509 218.678 298.509 217.863 298.995L209.949 303.742C209.134 304.228 209.134 304.959 209.949 305.445L216.583 309.461C217.397 309.948 218.561 309.948 219.376 309.461L227.29 304.715C228.105 304.228 228.105 303.498 227.29 303.011ZM240.092 295.344L233.458 291.328C232.644 290.842 231.48 290.842 230.665 291.328L222.751 296.075C221.936 296.561 221.936 297.292 222.751 297.778L229.385 301.794C230.199 302.281 231.363 302.281 232.178 301.794L240.092 297.048C240.79 296.561 240.79 295.831 240.092 295.344ZM320.397 246.787L313.763 242.771C312.948 242.284 311.784 242.284 310.97 242.771L298.982 249.951C298.168 250.438 298.168 251.168 298.982 251.655L305.616 255.671C306.431 256.158 307.595 256.158 308.409 255.671L320.397 248.491C321.212 248.004 321.212 247.274 320.397 246.787ZM229.734 273.439L223.1 269.423C222.285 268.936 221.122 268.936 220.307 269.423L212.393 274.169C211.578 274.656 211.578 275.386 212.393 275.873L219.027 279.889C219.841 280.376 221.005 280.376 221.82 279.889L229.734 275.143C230.432 274.656 230.432 273.926 229.734 273.439ZM242.42 265.772L235.786 261.756C234.971 261.269 233.807 261.269 232.993 261.756L225.079 266.502C224.264 266.989 224.264 267.719 225.079 268.206L231.712 272.222C232.527 272.709 233.691 272.709 234.506 272.222L242.42 267.475C243.234 266.989 243.234 266.259 242.42 265.772ZM255.106 258.105L248.472 254.089C247.657 253.602 246.493 253.602 245.679 254.089L237.764 258.835C236.95 259.322 236.95 260.052 237.764 260.539L244.398 264.555C245.213 265.042 246.377 265.042 247.192 264.555L255.106 259.809C255.92 259.322 255.92 258.592 255.106 258.105ZM267.908 250.438L261.274 246.422C260.459 245.935 259.295 245.935 258.481 246.422L250.567 251.168C249.752 251.655 249.752 252.385 250.567 252.872L257.201 256.888C258.015 257.375 259.179 257.375 259.994 256.888L267.908 252.142C268.606 251.655 268.606 250.803 267.908 250.438ZM280.594 242.649L273.96 238.633C273.145 238.146 271.981 238.146 271.167 238.633L263.252 243.379C262.438 243.866 262.438 244.596 263.252 245.083L269.886 249.099C270.701 249.586 271.865 249.586 272.68 249.099L280.594 244.353C281.408 243.988 281.408 243.136 280.594 242.649ZM297.469 232.548L290.835 228.532C290.021 228.045 288.857 228.045 288.042 228.532L276.055 235.712C275.24 236.199 275.24 236.929 276.055 237.416L282.689 241.432C283.503 241.919 284.667 241.919 285.482 241.432L297.469 234.252C298.168 233.765 298.168 233.035 297.469 232.548ZM194.819 308.731L188.185 304.715C187.37 304.228 186.206 304.228 185.392 304.715L173.404 311.895C172.59 312.382 172.59 313.112 173.404 313.599L180.038 317.615C180.853 318.102 182.017 318.102 182.831 317.615L194.819 310.435C195.517 309.948 195.517 309.218 194.819 308.731ZM207.505 301.064L200.871 297.048C200.056 296.561 198.892 296.561 198.078 297.048L190.163 301.794C189.349 302.281 189.349 303.011 190.163 303.498L196.797 307.514C197.612 308.001 198.776 308.001 199.591 307.514L207.505 302.768C208.203 302.281 208.203 301.551 207.505 301.064ZM220.19 293.397L213.557 289.381C212.742 288.894 211.578 288.894 210.763 289.381L202.849 294.127C202.035 294.614 202.035 295.344 202.849 295.831L209.483 299.847C210.298 300.334 211.462 300.334 212.276 299.847L220.19 295.101C221.005 294.614 221.005 293.884 220.19 293.397ZM232.993 285.73L226.359 281.714C225.544 281.227 224.38 281.227 223.566 281.714L215.652 286.46C214.837 286.947 214.837 287.677 215.652 288.164L222.285 292.18C223.1 292.667 224.264 292.667 225.079 292.18L232.993 287.434C233.691 286.947 233.691 286.217 232.993 285.73ZM245.679 278.063L239.045 274.047C238.23 273.56 237.066 273.56 236.251 274.047L228.337 278.793C227.523 279.28 227.523 280.01 228.337 280.497L234.971 284.513C235.786 285 236.95 285 237.764 284.513L245.679 279.767C246.377 279.28 246.377 278.55 245.679 278.063ZM303.87 256.888L297.237 252.872C296.422 252.385 295.258 252.385 294.443 252.872L235.553 288.408C234.738 288.894 234.738 289.625 235.553 290.111L242.187 294.127C243.002 294.614 244.166 294.614 244.98 294.127L303.87 258.592C304.685 258.105 304.685 257.375 303.87 256.888ZM258.364 270.396L251.73 266.38C250.916 265.893 249.752 265.893 248.937 266.38L241.023 271.126C240.208 271.613 240.208 272.343 241.023 272.83L247.657 276.846C248.472 277.333 249.636 277.333 250.45 276.846L258.364 272.1C259.179 271.613 259.179 270.883 258.364 270.396ZM271.167 262.608L264.533 258.592C263.718 258.105 262.554 258.105 261.739 258.592L253.825 263.338C253.011 263.825 253.011 264.555 253.825 265.042L260.459 269.058C261.274 269.544 262.438 269.544 263.252 269.058L271.167 264.311C271.865 263.946 271.865 263.094 271.167 262.608ZM283.852 254.941L277.219 250.925C276.404 250.438 275.24 250.438 274.425 250.925L266.511 255.671C265.697 256.158 265.697 256.888 266.511 257.375L273.145 261.391C273.96 261.877 275.124 261.877 275.938 261.391L283.852 256.644C284.667 256.158 284.667 255.427 283.852 254.941ZM296.538 247.274L289.904 243.258C289.09 242.771 287.926 242.771 287.111 243.258L279.197 248.004C278.382 248.491 278.382 249.221 279.197 249.708L285.831 253.724C286.646 254.21 287.809 254.21 288.624 253.724L296.538 248.977C297.353 248.491 297.353 247.76 296.538 247.274ZM309.34 239.607L302.707 235.591C301.892 235.104 300.728 235.104 299.913 235.591L291.999 240.337C291.185 240.824 291.185 241.554 291.999 242.041L298.633 246.057C299.448 246.543 300.612 246.543 301.426 246.057L309.34 241.31C310.039 240.824 310.039 240.093 309.34 239.607ZM287.228 210.521L280.594 206.505C279.779 206.018 278.615 206.018 277.8 206.505L269.886 211.251C269.072 211.738 269.072 212.468 269.886 212.955L276.52 216.971C277.335 217.458 278.499 217.458 279.313 216.971L287.228 212.225C288.042 211.859 288.042 211.008 287.228 210.521ZM300.03 202.854L293.396 198.838C292.581 198.351 291.417 198.351 290.603 198.838L282.689 203.584C281.874 204.071 281.874 204.801 282.689 205.288L289.322 209.304C290.137 209.791 291.301 209.791 292.116 209.304L300.03 204.558C300.728 204.071 300.728 203.341 300.03 202.854ZM312.716 195.187L306.082 191.171C305.267 190.684 304.103 190.684 303.288 191.171L295.374 195.917C294.56 196.404 294.56 197.134 295.374 197.621L302.008 201.637C302.823 202.124 303.987 202.124 304.801 201.637L312.716 196.891C313.53 196.404 313.53 195.674 312.716 195.187ZM324.354 202.367L317.72 198.351C316.905 197.864 315.742 197.864 314.927 198.351L307.013 203.097C306.198 203.584 306.198 204.314 307.013 204.801L313.647 208.817C314.461 209.304 315.625 209.304 316.44 208.817L324.354 204.071C325.052 203.584 325.052 202.854 324.354 202.367Z"
          fill="#FFF7F5"
        />
        <path
          opacity="0.7"
          d="M289.905 195.186L133.486 289.624L128.016 286.338L284.435 191.9L289.905 195.186Z"
          fill="#EFE8EE"
        />
        <path
          d="M284.435 192.631L289.323 195.551L289.905 195.186L284.435 191.9L128.016 286.338L128.598 286.703L284.435 192.631Z"
          fill="#CEC6D4"
        />
        <path
          opacity="0.3"
          d="M300.263 185.816C298.052 184.477 294.444 184.477 292.233 185.816C290.021 187.154 290.021 189.345 292.233 190.683C294.444 192.022 298.052 192.022 300.263 190.683C302.474 189.345 302.474 187.154 300.263 185.816Z"
          fill="url(#paint9_linear_1926_44029)"
        />
        <path
          d="M349.496 298.874L314.93 319.806L314.465 320.658L315.396 320.779L350.078 299.847L350.66 298.752L349.496 298.874Z"
          fill="#EFE8EE"
        />
        <path
          d="M300.031 190.44C298.052 191.657 294.677 191.657 292.699 190.44C290.72 189.223 290.72 187.276 292.699 186.059C294.677 184.842 298.052 184.842 300.031 186.059C302.009 187.276 302.009 189.223 300.031 190.44Z"
          fill="#FFF7F5"
        />
        <path
          d="M129.877 298.386L136.395 302.28C137.209 302.767 137.791 302.523 137.791 301.672C137.791 300.82 137.209 299.846 136.395 299.359L129.877 295.465C129.062 294.978 128.48 295.222 128.48 296.073C128.48 296.925 129.179 298.021 129.877 298.386Z"
          fill="#8B8396"
        />
        <mask
          id="mask0_1926_44029"
          Style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="128"
          y="295"
          width="10"
          height="8"
        >
          <path
            d="M129.877 298.386L136.395 302.28C137.209 302.767 137.791 302.523 137.791 301.672C137.791 300.82 137.209 299.846 136.395 299.359L129.877 295.465C129.062 294.978 128.48 295.222 128.48 296.073C128.48 296.925 129.179 298.021 129.877 298.386Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1926_44029)">
          <path
            opacity="0.7"
            d="M135.697 301.428L136.628 302.036L139.887 300.089L138.956 299.48L135.697 301.428ZM133.719 300.211L134.65 300.819L137.909 298.872L136.978 298.263L133.719 300.211ZM131.74 299.115L132.671 299.724L135.93 297.777L134.999 297.168L131.74 299.115ZM129.762 297.898L130.693 298.507L133.952 296.56L133.02 295.951L129.762 297.898Z"
            fill="#ADA4B8"
          />
        </g>
        <path
          d="M166.772 320.536L156.996 314.573V312.747L166.772 318.71V320.536Z"
          fill="#8B8396"
        />
        <path
          d="M119.637 127.4V276.115C119.637 279.158 121.964 280.132 124.99 278.428L315.976 163.058C318.886 161.232 321.33 157.46 321.33 154.417V5.70215L119.637 127.4Z"
          fill="#3F91FF"
        />
        <path
          d="M321.333 9.47449V3.14618C321.333 0.103726 319.005 -0.869862 315.979 0.833913L124.877 116.204C121.968 118.029 119.523 121.802 119.523 124.844V131.173L321.333 9.47449Z"
          fill="#455FDC"
        />
        <path
          d="M208.907 106.591L206.113 108.173V106.956L208.907 105.374V106.591Z"
          fill="white"
        />
        <path
          d="M214.609 103.062L210.652 105.496V104.279L214.609 101.845V103.062Z"
          fill="white"
        />
        <path
          d="M227.409 95.3947L216.469 101.966V100.749L227.409 94.1777V95.3947Z"
          fill="white"
        />
        <path
          d="M233.579 91.6223L229.156 94.2996V93.0826L233.579 90.4053V91.6223Z"
          fill="white"
        />
        <path
          d="M235.328 89.3102V90.6489L242.428 86.2678V85.0508L235.328 89.3102Z"
          fill="white"
        />
        <path
          d="M248.125 82.8596L244.168 85.2935V84.0765L248.125 81.6426V82.8596Z"
          fill="white"
        />
        <path
          d="M253.25 79.8176L249.875 81.7647V80.5477L253.25 78.6006V79.8176Z"
          fill="white"
        />
        <path
          d="M212.282 107.808L206.23 111.58V110.242L212.282 106.591V107.808Z"
          fill="white"
        />
        <path
          d="M218.101 104.4L214.027 106.712V105.495L218.101 103.062V104.4Z"
          fill="white"
        />
        <path
          d="M224.736 100.385L219.848 103.305V102.088L224.736 99.0459V100.385Z"
          fill="white"
        />
        <path
          d="M229.506 97.4641L226.48 99.2895V98.0725L229.506 96.2471V97.4641Z"
          fill="white"
        />
        <path
          d="M231.254 95.151V96.368L239.983 91.135V89.918L231.254 95.151Z"
          fill="white"
        />
        <path
          d="M245.222 87.9719L241.73 90.0407V88.8237L245.222 86.7549V87.9719Z"
          fill="white"
        />
        <path
          d="M256.276 81.2785L246.965 86.8766V85.6596L256.276 80.0615V81.2785Z"
          fill="white"
        />
        <path
          d="M208.907 113.163L206.23 114.867V113.65L208.907 111.946V113.163Z"
          fill="white"
        />
        <path
          d="M214.726 109.755L210.652 112.189V110.972L214.726 108.538V109.755Z"
          fill="white"
        />
        <path
          d="M220.542 106.225L216.469 108.659V107.442L220.542 104.887V106.225Z"
          fill="white"
        />
        <path
          d="M233.579 98.3156L222.406 105.131V103.914L233.579 97.0986V98.3156Z"
          fill="white"
        />
        <path
          d="M235.328 96.0036V97.2206L242.428 92.9611V91.7441L235.328 96.0036Z"
          fill="white"
        />
        <path
          d="M248.125 89.5539L244.168 91.9879V90.6492L248.125 88.3369V89.5539Z"
          fill="white"
        />
        <path
          d="M253.25 86.3898L249.875 88.4587V87.2417L253.25 85.1729V86.3898Z"
          fill="white"
        />
        <path
          d="M212.282 114.501L206.23 118.152V116.935L212.282 113.284V114.501Z"
          fill="white"
        />
        <path
          d="M218.098 110.972L214.141 113.406V112.189L218.098 109.755V110.972Z"
          fill="white"
        />
        <path
          d="M224.736 106.956L219.848 109.999V108.782L224.736 105.739V106.956Z"
          fill="white"
        />
        <path
          d="M229.506 104.157L226.48 105.983V104.766L229.506 102.94V104.157Z"
          fill="white"
        />
        <path
          d="M231.254 101.845V103.062L239.983 97.8289V96.4902L231.254 101.845Z"
          fill="white"
        />
        <path
          d="M245.219 94.6639L241.844 96.7327V95.5158L245.219 93.3252V94.6639Z"
          fill="white"
        />
        <path
          d="M257.203 87.3635L247.078 93.5701V92.3531L257.203 86.1465V87.3635Z"
          fill="white"
        />
        <path
          d="M208.907 119.857L206.23 121.56V120.343L208.907 118.64V119.857Z"
          fill="white"
        />
        <path
          d="M214.726 116.448L210.652 118.761V117.544L214.726 115.231V116.448Z"
          fill="white"
        />
        <path
          d="M228.34 108.173L216.469 115.353V114.136L228.34 106.956V108.173Z"
          fill="white"
        />
        <path
          d="M233.58 105.009L227.645 108.538V107.321L233.58 103.792V105.009Z"
          fill="white"
        />
        <path
          d="M235.328 102.697V103.914L242.428 99.6545V98.4375L235.328 102.697Z"
          fill="white"
        />
        <path
          d="M248.125 96.2473L244.168 98.5595V97.3425L248.125 95.0303V96.2473Z"
          fill="white"
        />
        <path
          d="M253.25 93.0832L249.875 95.1521V93.9351L253.25 91.8662V93.0832Z"
          fill="white"
        />
        <path
          d="M212.282 121.195L206.23 124.845V123.628L212.282 119.978V121.195Z"
          fill="white"
        />
        <path
          d="M218.098 117.665L214.141 120.099V118.882L218.098 116.448V117.665Z"
          fill="white"
        />
        <path
          d="M221.943 115.354L219.848 116.571V115.354L221.943 114.137V115.354Z"
          fill="white"
        />
        <path
          d="M229.507 110.73L223.688 114.259V113.042L229.507 109.513V110.73Z"
          fill="white"
        />
        <path
          d="M231.367 108.538V109.755L240.096 104.401L239.98 103.184L231.367 108.538Z"
          fill="white"
        />
        <path
          d="M245.335 101.236L241.844 103.426V102.209L245.219 100.019L245.335 101.236Z"
          fill="white"
        />
        <path
          d="M258.135 93.5695L247.078 100.263V99.0459L258.135 92.3525V93.5695Z"
          fill="white"
        />
        <path
          d="M261.161 75.0711L254.992 78.722V77.5051L261.161 73.7324V75.0711Z"
          fill="white"
        />
        <path
          d="M266.863 71.5422L262.906 73.9761V72.7592L266.863 70.3252V71.5422Z"
          fill="white"
        />
        <path
          d="M279.899 63.7531L268.609 70.4465V69.2295L279.782 62.5361L279.899 63.7531Z"
          fill="white"
        />
        <path
          d="M288.158 58.6418L281.641 62.6578V61.4408L288.158 57.4248V58.6418Z"
          fill="white"
        />
        <path
          d="M289.906 56.3297V57.6683L296.075 53.8957V52.6787L289.906 56.3297Z"
          fill="white"
        />
        <path
          d="M301.895 50.4881L297.938 52.8004V51.5834L301.895 49.1494V50.4881Z"
          fill="white"
        />
        <path
          d="M264.537 76.2873L258.02 80.1816V78.9647L264.537 75.0703V76.2873Z"
          fill="white"
        />
        <path
          d="M270.238 72.759L266.281 75.1929V73.976L270.238 71.542V72.759Z"
          fill="white"
        />
        <path
          d="M276.99 68.7424L272.102 71.7848V70.5678L276.99 67.5254V68.7424Z"
          fill="white"
        />
        <path
          d="M284.088 64.4826L278.734 67.7685V66.5515L284.088 63.2656V64.4826Z"
          fill="white"
        />
        <path
          d="M285.953 62.1706V63.3876L291.307 60.1017V58.8848L285.953 62.1706Z"
          fill="white"
        />
        <path
          d="M298.987 55.4777L293.168 59.007V57.79L298.987 54.2607V55.4777Z"
          fill="white"
        />
        <path
          d="M261.161 81.6428L254.992 85.4154V84.1984L261.161 80.4258V81.6428Z"
          fill="white"
        />
        <path
          d="M266.863 78.2355L262.906 80.6695V79.3308L266.863 77.0186V78.2355Z"
          fill="white"
        />
        <path
          d="M275.011 73.2453L268.727 77.1396V75.9227L275.011 72.0283V73.2453Z"
          fill="white"
        />
        <path
          d="M288.164 65.3351L276.875 72.1503V70.9333L288.164 64.1182V65.3351Z"
          fill="white"
        />
        <path
          d="M289.906 63.023V64.24L296.191 60.5891V59.3721L289.906 63.023Z"
          fill="white"
        />
        <path
          d="M301.895 57.0598L297.938 59.4937V58.2767L301.895 55.8428V57.0598Z"
          fill="white"
        />
        <path
          d="M264.536 82.9816L258.949 86.3892V85.1722L264.536 81.7646V82.9816Z"
          fill="white"
        />
        <path
          d="M270.355 79.4523L266.281 81.8863V80.6693L270.355 78.2354V79.4523Z"
          fill="white"
        />
        <path
          d="M278.503 74.5842L272.102 78.4785V77.1398L278.503 73.3672V74.5842Z"
          fill="white"
        />
        <path
          d="M284.203 71.176L280.246 73.4882V72.2713L284.203 69.959V71.176Z"
          fill="white"
        />
        <path
          d="M285.953 68.864V70.081L291.423 66.7951V65.5781L285.953 68.864Z"
          fill="white"
        />
        <path
          d="M298.987 62.1711L293.168 65.7003V64.4834L298.987 60.9541V62.1711Z"
          fill="white"
        />
        <path
          d="M261.161 88.3361L254.992 92.1088V90.8918L261.161 87.1191V88.3361Z"
          fill="white"
        />
        <path
          d="M266.863 84.9285L262.906 87.2408V86.0238L266.863 83.5898V84.9285Z"
          fill="white"
        />
        <path
          d="M276.99 78.8439L268.727 83.8335V82.6166L276.99 77.627V78.8439Z"
          fill="white"
        />
        <path
          d="M264.534 89.674L259.879 92.4731V91.2561L264.534 88.457V89.674Z"
          fill="white"
        />
        <path
          d="M270.355 86.1457L266.281 88.5797V87.3627L270.355 84.9287V86.1457Z"
          fill="white"
        />
        <path
          d="M274.778 83.4689L272.102 85.051V83.834L274.778 82.252V83.4689Z"
          fill="white"
        />
        <path
          d="M209.02 138.597L206.227 140.301V139.084L209.02 137.38V138.597Z"
          fill="white"
        />
        <path
          d="M214.723 135.19L210.766 137.624V136.407L214.723 133.973V135.19Z"
          fill="white"
        />
        <path
          d="M227.525 127.522L216.469 134.094V132.877L227.525 126.184V127.522Z"
          fill="white"
        />
        <path
          d="M233.576 123.749L229.27 126.427V125.21L233.576 122.532V123.749Z"
          fill="white"
        />
        <path
          d="M235.441 121.438V122.655L242.424 118.396V117.179L235.441 121.438Z"
          fill="white"
        />
        <path
          d="M248.125 114.987L244.284 117.421L244.168 116.083L248.125 113.771V114.987Z"
          fill="white"
        />
        <path
          d="M253.363 111.945L249.988 113.892V112.675L253.247 110.606L253.363 111.945Z"
          fill="white"
        />
        <path
          d="M212.395 139.935L206.227 143.586V142.369L212.395 138.718V139.935Z"
          fill="white"
        />
        <path
          d="M218.098 136.406L214.141 138.84V137.623L218.098 135.189V136.406Z"
          fill="white"
        />
        <path
          d="M224.733 132.391L219.961 135.433V134.216L224.733 131.174V132.391Z"
          fill="white"
        />
        <path
          d="M229.62 129.591L226.594 131.416V130.199L229.62 128.374V129.591Z"
          fill="white"
        />
        <path
          d="M231.367 127.28V128.497L240.096 123.264V122.047L231.367 127.28Z"
          fill="white"
        />
        <path
          d="M245.335 120.099L241.844 122.168V120.951L245.335 118.882V120.099Z"
          fill="white"
        />
        <path
          d="M256.389 113.405L247.078 119.004V117.787L256.389 112.188V113.405Z"
          fill="white"
        />
        <path
          d="M261.161 107.078L255.109 110.851V109.634L261.161 105.861V107.078Z"
          fill="white"
        />
        <path
          d="M266.981 103.671L263.023 106.105V104.766L266.981 102.454V103.671Z"
          fill="white"
        />
        <path
          d="M279.899 95.8826L268.727 102.576V101.359L279.899 94.5439V95.8826Z"
          fill="white"
        />
        <path
          d="M288.278 90.7707L281.645 94.7867V93.5697L288.278 89.5537V90.7707Z"
          fill="white"
        />
        <path
          d="M290.023 88.4586V89.6755L296.192 86.0246V84.8076L290.023 88.4586Z"
          fill="white"
        />
        <path
          d="M301.898 82.4953L297.941 84.9293V83.7123L301.898 81.2783V82.4953Z"
          fill="white"
        />
        <path
          d="M264.654 108.417L258.137 112.312V111.095L264.654 107.2V108.417Z"
          fill="white"
        />
        <path
          d="M270.355 104.888L266.398 107.322V106.105L270.355 103.671V104.888Z"
          fill="white"
        />
        <path
          d="M276.99 100.871L272.102 103.914V102.575L276.99 99.6543V100.871Z"
          fill="white"
        />
        <path
          d="M284.204 96.6115L278.851 99.8974L278.734 98.5587L284.204 95.3945V96.6115Z"
          fill="white"
        />
        <path
          d="M285.949 94.3005V95.5175L291.419 92.2316V91.0146L285.949 94.3005Z"
          fill="white"
        />
        <path
          d="M299.1 87.6066L293.164 91.1359V89.9189L299.1 86.3896V87.6066Z"
          fill="white"
        />
        <path
          d="M209.02 156.363L206.227 158.067V156.85L209.02 155.146V156.363Z"
          fill="white"
        />
        <path
          d="M214.723 152.834L210.766 155.268V154.051L214.723 151.617V152.834Z"
          fill="white"
        />
        <path
          d="M227.522 145.167L216.582 151.861V150.644L227.522 143.95V145.167Z"
          fill="white"
        />
        <path
          d="M233.692 141.516L229.27 144.071V142.854L233.692 140.299V141.516Z"
          fill="white"
        />
        <path
          d="M235.441 139.205V140.422L242.541 136.162V134.945L235.441 139.205Z"
          fill="white"
        />
        <path
          d="M248.238 132.754L244.281 135.066V133.849L248.238 131.537V132.754Z"
          fill="white"
        />
        <path
          d="M253.363 129.59L249.988 131.659V130.442L253.363 128.373V129.59Z"
          fill="white"
        />
        <path
          d="M212.396 157.701L206.344 161.352V160.135L212.396 156.484V157.701Z"
          fill="white"
        />
        <path
          d="M218.214 154.173L214.141 156.607V155.39L218.214 152.956V154.173Z"
          fill="white"
        />
        <path
          d="M224.849 150.157L219.961 153.078V151.861L224.849 148.94V150.157Z"
          fill="white"
        />
        <path
          d="M229.62 147.237L226.594 149.062V147.845L229.62 146.02V147.237Z"
          fill="white"
        />
        <path
          d="M231.367 144.923V146.14L240.096 140.907V139.69L231.367 144.923Z"
          fill="white"
        />
        <path
          d="M245.335 137.744L241.844 139.813V138.596L245.335 136.527V137.744Z"
          fill="white"
        />
        <path
          d="M256.389 131.051L247.078 136.649V135.432L256.389 129.834V131.051Z"
          fill="white"
        />
        <path
          d="M209.021 163.057L206.344 164.639V163.422L209.021 161.84V163.057Z"
          fill="white"
        />
        <path
          d="M214.839 159.528L210.766 161.961V160.745L214.839 158.311V159.528Z"
          fill="white"
        />
        <path
          d="M220.655 155.999L216.582 158.555V157.216L220.655 154.782V155.999Z"
          fill="white"
        />
        <path
          d="M233.692 148.21L222.52 154.904V153.687L233.692 146.993V148.21Z"
          fill="white"
        />
        <path
          d="M235.441 145.898V147.115L242.541 142.856V141.639L235.441 145.898Z"
          fill="white"
        />
        <path
          d="M248.238 139.326L244.281 141.76V140.543L248.238 138.109V139.326Z"
          fill="white"
        />
        <path
          d="M253.363 136.283L249.988 138.352V137.135L253.363 135.066V136.283Z"
          fill="white"
        />
        <path
          d="M212.396 164.274L206.344 168.046V166.829L212.396 163.057V164.274Z"
          fill="white"
        />
        <path
          d="M218.211 160.866L214.254 163.3V162.083L218.211 159.649V160.866Z"
          fill="white"
        />
        <path
          d="M224.849 156.851L219.961 159.772V158.555L224.849 155.634V156.851Z"
          fill="white"
        />
        <path
          d="M229.62 153.93L226.594 155.755V154.538L229.62 152.713V153.93Z"
          fill="white"
        />
        <path
          d="M231.367 151.617V152.834L240.096 147.601V146.384L231.367 151.617Z"
          fill="white"
        />
        <path
          d="M245.332 144.438L241.957 146.507V145.29L245.332 143.221V144.438Z"
          fill="white"
        />
        <path
          d="M257.317 137.257L247.191 143.342V142.125L257.317 136.04V137.257Z"
          fill="white"
        />
        <path
          d="M209.021 169.75L206.344 171.332V170.115L209.021 168.533V169.75Z"
          fill="white"
        />
        <path
          d="M214.839 166.221L210.766 168.655V167.438L214.839 165.004V166.221Z"
          fill="white"
        />
        <path
          d="M228.453 158.068L216.582 165.126V163.909L228.453 156.851V158.068Z"
          fill="white"
        />
        <path
          d="M233.693 154.781L227.758 158.432V157.215L233.693 153.564V154.781Z"
          fill="white"
        />
        <path
          d="M235.441 152.591V153.808L242.541 149.549V148.332L235.441 152.591Z"
          fill="white"
        />
        <path
          d="M248.238 146.02L244.281 148.454V147.237L248.238 144.803V146.02Z"
          fill="white"
        />
        <path
          d="M253.363 142.977L249.988 144.924V143.707L253.363 141.76V142.977Z"
          fill="white"
        />
        <path
          d="M212.396 170.967L206.344 174.74V173.523L212.396 169.75V170.967Z"
          fill="white"
        />
        <path
          d="M218.211 167.56L214.254 169.994V168.655L218.211 166.343V167.56Z"
          fill="white"
        />
        <path
          d="M222.056 165.248L219.961 166.465V165.248L222.056 163.909V165.248Z"
          fill="white"
        />
        <path
          d="M229.62 160.623L223.801 164.152V162.935L229.62 159.406V160.623Z"
          fill="white"
        />
        <path
          d="M231.48 158.31V159.527L240.093 154.294V153.077L231.48 158.31Z"
          fill="white"
        />
        <path
          d="M245.449 151.131L241.957 153.2V151.983L245.332 149.914L245.449 151.131Z"
          fill="white"
        />
        <path
          d="M258.248 143.342L247.191 150.035V148.818L258.248 142.125V143.342Z"
          fill="white"
        />
        <path
          d="M261.278 124.845L255.109 128.496V127.279L261.278 123.628V124.845Z"
          fill="white"
        />
        <path
          d="M266.981 121.316L263.023 123.75V122.533L266.981 120.099V121.316Z"
          fill="white"
        />
        <path
          d="M279.899 113.528L268.727 120.343V119.004L279.899 112.311V113.528Z"
          fill="white"
        />
        <path
          d="M288.275 108.537L281.758 112.432V111.215L288.275 107.32V108.537Z"
          fill="white"
        />
        <path
          d="M290.023 106.225V107.442L296.192 103.669V102.452L290.023 106.225Z"
          fill="white"
        />
        <path
          d="M302.012 100.262L298.055 102.696V101.357L301.895 99.0449L302.012 100.262Z"
          fill="white"
        />
        <path
          d="M264.654 126.183L258.137 130.078V128.861L264.654 124.845V126.183Z"
          fill="white"
        />
        <path
          d="M270.355 122.654L266.398 125.088V123.871L270.355 121.438V122.654Z"
          fill="white"
        />
        <path
          d="M277.107 118.638L272.219 121.559V120.342L277.107 117.421V118.638Z"
          fill="white"
        />
        <path
          d="M284.205 114.257L278.852 117.543V116.326L284.205 113.04V114.257Z"
          fill="white"
        />
        <path
          d="M286.07 111.945V113.162L291.424 109.876V108.659L286.07 111.945Z"
          fill="white"
        />
        <path
          d="M299.104 105.373L293.285 108.902V107.685L299.104 104.034V105.373Z"
          fill="white"
        />
        <path
          d="M261.278 131.538L255.109 135.189V133.972L261.278 130.321V131.538Z"
          fill="white"
        />
        <path
          d="M266.981 128.009L263.023 130.443V129.226L266.981 126.792V128.009Z"
          fill="white"
        />
        <path
          d="M275.128 123.141L268.844 126.913V125.696L275.128 121.924V123.141Z"
          fill="white"
        />
        <path
          d="M288.281 115.231L276.992 122.046V120.829L288.281 114.014V115.231Z"
          fill="white"
        />
        <path
          d="M290.023 112.918V114.135L296.308 110.362V109.146L290.023 112.918Z"
          fill="white"
        />
        <path
          d="M302.012 106.955L298.055 109.268V108.051L302.012 105.738V106.955Z"
          fill="white"
        />
        <path
          d="M264.653 132.755L259.066 136.163V134.946L264.653 131.538V132.755Z"
          fill="white"
        />
        <path
          d="M270.472 129.348L266.398 131.782V130.443L270.472 128.131V129.348Z"
          fill="white"
        />
        <path
          d="M278.62 124.358L272.219 128.252V127.035L278.62 123.141V124.358Z"
          fill="white"
        />
        <path
          d="M284.32 120.95L280.363 123.263V122.046L284.32 119.733V120.95Z"
          fill="white"
        />
        <path
          d="M286.07 118.638V119.855L291.54 116.57V115.353L286.07 118.638Z"
          fill="white"
        />
        <path
          d="M299.104 111.945L293.285 115.595V114.257L299.104 110.728V111.945Z"
          fill="white"
        />
        <path
          d="M261.278 138.232L255.109 141.883V140.666L261.278 137.015V138.232Z"
          fill="white"
        />
        <path
          d="M266.981 134.702L263.023 137.136V135.919L266.981 133.485V134.702Z"
          fill="white"
        />
        <path
          d="M277.107 128.617L268.844 133.607V132.39L277.107 127.4V128.617Z"
          fill="white"
        />
        <path
          d="M288.279 121.803L278.852 127.523V126.306L288.279 120.586V121.803Z"
          fill="white"
        />
        <path
          d="M290.145 119.612V120.828L296.313 117.056V115.839L290.145 119.612Z"
          fill="white"
        />
        <path
          d="M302.012 113.649L298.055 115.961V114.744L302.012 112.432V113.649Z"
          fill="white"
        />
        <path
          d="M264.651 139.449L259.996 142.37V141.031L264.651 138.232V139.449Z"
          fill="white"
        />
        <path
          d="M270.472 136.041L266.398 138.353V137.136L270.472 134.824V136.041Z"
          fill="white"
        />
        <path
          d="M274.896 133.241L272.219 134.945V133.728L274.896 132.024V133.241Z"
          fill="white"
        />
        <path
          d="M284.323 127.644L276.758 132.147V130.93L284.323 126.427V127.644Z"
          fill="white"
        />
        <path
          d="M286.07 125.332V126.549L291.54 123.263V122.046L286.07 125.332Z"
          fill="white"
        />
        <path
          d="M299.104 118.638L293.285 122.167V120.95L299.104 117.421V118.638Z"
          fill="white"
        />
        <path
          d="M209.133 191.048L206.34 192.752V191.535L209.133 189.831V191.048Z"
          fill="white"
        />
        <path
          d="M214.836 187.641L210.879 189.953V188.736L214.836 186.424V187.641Z"
          fill="white"
        />
        <path
          d="M227.638 179.852L216.582 186.545V185.328L227.638 178.635V179.852Z"
          fill="white"
        />
        <path
          d="M233.689 176.2L229.383 178.878V177.539L233.689 174.983V176.2Z"
          fill="white"
        />
        <path
          d="M235.555 173.889V175.106L242.538 170.847V169.63L235.555 173.889Z"
          fill="white"
        />
        <path
          d="M248.235 167.439L244.395 169.751V168.534L248.235 166.222V167.439Z"
          fill="white"
        />
        <path
          d="M253.477 164.275L250.102 166.343V165.126L253.477 163.058V164.275Z"
          fill="white"
        />
        <path
          d="M212.508 192.386L206.34 196.037V194.82L212.508 191.169V192.386Z"
          fill="white"
        />
        <path
          d="M218.211 188.858L214.254 191.292V190.075L218.211 187.641V188.858Z"
          fill="white"
        />
        <path
          d="M224.962 184.842L220.074 187.763V186.546L224.962 183.625V184.842Z"
          fill="white"
        />
        <path
          d="M229.733 181.921L226.707 183.747V182.53L229.733 180.704V181.921Z"
          fill="white"
        />
        <path
          d="M231.48 179.73V180.947L240.209 175.592V174.375L231.48 179.73Z"
          fill="white"
        />
        <path
          d="M245.445 172.429L241.953 174.619V173.281L245.445 171.212V172.429Z"
          fill="white"
        />
        <path
          d="M256.502 165.857L247.191 171.455V170.117L256.502 164.519V165.857Z"
          fill="white"
        />
        <path
          d="M209.133 197.741L206.34 199.445V198.228L209.133 196.524V197.741Z"
          fill="white"
        />
        <path
          d="M214.836 194.334L210.879 196.646V195.429L214.836 192.995V194.334Z"
          fill="white"
        />
        <path
          d="M220.772 190.684L216.582 193.239V192.022L220.772 189.467V190.684Z"
          fill="white"
        />
        <path
          d="M233.805 182.894L222.516 189.587V188.37L233.688 181.677L233.805 182.894Z"
          fill="white"
        />
        <path
          d="M212.508 199.08L206.34 202.731V201.514L212.508 197.863V199.08Z"
          fill="white"
        />
        <path
          d="M218.327 195.551L214.254 197.985V196.768L218.211 194.334L218.327 195.551Z"
          fill="white"
        />
        <path
          d="M224.962 191.535L220.074 194.456V193.239L224.962 190.318V191.535Z"
          fill="white"
        />
        <path
          d="M229.733 188.614L226.707 190.44V189.223L229.733 187.397V188.614Z"
          fill="white"
        />
        <path
          d="M231.48 186.301V187.518L240.209 182.285V181.068L231.48 186.301Z"
          fill="white"
        />
        <path
          d="M261.275 159.529L255.223 163.302V161.963L261.275 158.312V159.529Z"
          fill="white"
        />
        <path
          d="M267.094 156.122L263.137 158.434V157.217L267.094 154.783V156.122Z"
          fill="white"
        />
        <path
          d="M280.013 148.212L268.84 155.027V153.81L280.013 146.995V148.212Z"
          fill="white"
        />
        <path
          d="M288.392 143.222L281.758 147.238V145.899L288.392 142.005V143.222Z"
          fill="white"
        />
        <path
          d="M290.137 140.909V142.126L296.305 138.475V137.137L290.137 140.909Z"
          fill="white"
        />
        <path
          d="M302.012 134.946L298.055 137.38V136.163L302.012 133.729V134.946Z"
          fill="white"
        />
        <path
          d="M264.767 160.868L258.25 164.763V163.546L264.767 159.651V160.868Z"
          fill="white"
        />
        <path
          d="M270.469 157.339L266.512 159.773V158.556L270.469 156.122V157.339Z"
          fill="white"
        />
        <path
          d="M277.103 153.322L272.215 156.243V155.026L277.103 152.105V153.322Z"
          fill="white"
        />
        <path
          d="M284.319 148.942L278.965 152.227V151.01L284.319 147.725V148.942Z"
          fill="white"
        />
        <path
          d="M286.062 146.752V147.969L291.533 144.683V143.466L286.062 146.752Z"
          fill="white"
        />
        <path
          d="M299.213 140.058L293.277 143.587V142.37L299.213 138.841V140.058Z"
          fill="white"
        />
        <path
          d="M261.275 166.223L255.223 169.874V168.657L261.275 165.006V166.223Z"
          fill="white"
        />
        <path
          d="M267.094 162.694L263.137 165.128V163.911L267.094 161.477V162.694Z"
          fill="white"
        />
        <path
          d="M275.241 157.825L268.84 161.72V160.503L275.241 156.608V157.825Z"
          fill="white"
        />
        <path
          d="M264.766 167.561L259.18 170.847V169.63L264.766 166.223V167.561Z"
          fill="white"
        />
        <path
          d="M270.469 164.032L266.512 166.466V165.249L270.469 162.815V164.032Z"
          fill="white"
        />
        <path
          d="M278.617 159.042L272.332 162.937V161.72L278.617 157.825V159.042Z"
          fill="white"
        />
        <path
          d="M209.017 178.026L206.34 179.729V178.512L209.017 176.809V178.026Z"
          fill="white"
        />
        <path
          d="M214.836 174.618L210.879 176.93V175.713L214.836 173.279V174.618Z"
          fill="white"
        />
        <path
          d="M227.522 166.829L216.582 173.523V172.306L227.522 165.612V166.829Z"
          fill="white"
        />
        <path
          d="M233.689 163.178L229.383 165.734V164.517L233.689 161.961V163.178Z"
          fill="white"
        />
        <path
          d="M235.438 160.867V162.084L242.537 157.824V156.607L235.438 160.867Z"
          fill="white"
        />
        <path
          d="M248.238 154.416L244.281 156.728V155.511L248.238 153.199V154.416Z"
          fill="white"
        />
        <path
          d="M253.359 151.252L249.984 153.321V152.104L253.359 150.035V151.252Z"
          fill="white"
        />
        <path
          d="M212.508 179.363L206.34 183.014V181.797L212.508 178.146V179.363Z"
          fill="white"
        />
        <path
          d="M218.211 175.835L214.254 178.269V177.052L218.211 174.618V175.835Z"
          fill="white"
        />
        <path
          d="M224.845 171.82L219.957 174.74V173.523L224.845 170.603V171.82Z"
          fill="white"
        />
        <path
          d="M229.616 168.899L226.706 170.724L226.59 169.507L229.616 167.682V168.899Z"
          fill="white"
        />
        <path
          d="M231.48 166.586V167.803L240.209 162.57V161.353L231.48 166.586Z"
          fill="white"
        />
        <path
          d="M245.445 159.406L241.953 161.475V160.258L245.445 158.189V159.406Z"
          fill="white"
        />
        <path
          d="M256.502 152.713L247.191 158.311V157.094L256.502 151.496V152.713Z"
          fill="white"
        />
        <path
          d="M261.274 146.507L255.105 150.158V148.941L261.274 145.29V146.507Z"
          fill="white"
        />
        <path
          d="M267.093 142.978L263.02 145.412V144.195L267.093 141.761V142.978Z"
          fill="white"
        />
        <path
          d="M280.013 135.19L268.84 142.005V140.788L280.013 133.973V135.19Z"
          fill="white"
        />
        <path
          d="M288.388 130.199L281.754 134.094V132.877L288.271 128.982L288.388 130.199Z"
          fill="white"
        />
        <path
          d="M290.141 127.887V129.104L296.309 125.331V124.114L290.141 127.887Z"
          fill="white"
        />
        <path
          d="M302.008 121.924L298.051 124.358V123.019L302.008 120.707V121.924Z"
          fill="white"
        />
        <path
          d="M264.647 147.846L258.246 151.74V150.523L264.647 146.507V147.846Z"
          fill="white"
        />
        <path
          d="M270.469 144.317L266.512 146.751V145.534L270.469 143.1V144.317Z"
          fill="white"
        />
        <path
          d="M277.103 140.3L272.215 143.221V142.004L277.103 139.083V140.3Z"
          fill="white"
        />
        <path
          d="M284.318 135.919L278.848 139.205V137.988L284.318 134.702V135.919Z"
          fill="white"
        />
        <path
          d="M286.066 133.607V134.946L291.536 131.66V130.321L286.066 133.607Z"
          fill="white"
        />
        <path
          d="M299.1 127.035L293.281 130.565V129.348L299.1 125.818V127.035Z"
          fill="white"
        />
        <path
          d="M149.662 142.247L140.934 147.602V146.263L149.662 141.03V142.247Z"
          fill="white"
        />
        <path
          d="M157.109 137.745L151.523 141.153L151.406 139.936L157.109 136.528V137.745Z"
          fill="white"
        />
        <path
          d="M158.855 135.433V136.65L164.442 133.364V132.147L158.855 135.433Z"
          fill="white"
        />
        <path
          d="M170.145 129.834L166.188 132.268V131.051L170.145 128.617V129.834Z"
          fill="white"
        />
        <path
          d="M180.507 123.628L171.895 128.861V127.522L180.507 122.411V123.628Z"
          fill="white"
        />
        <path
          d="M145.939 147.847L141.051 150.768V149.551L145.939 146.63V147.847Z"
          fill="white"
        />
        <path
          d="M153.154 143.465L147.684 146.751V145.534L153.154 142.248V143.465Z"
          fill="white"
        />
        <path
          d="M154.898 141.274V142.491L159.67 139.57V138.354L154.898 141.274Z"
          fill="white"
        />
        <path
          d="M167.354 134.945L161.418 138.475V137.258L167.354 133.729V134.945Z"
          fill="white"
        />
        <path
          d="M180.503 127.035L169.098 133.85V132.633L180.503 125.818V127.035Z"
          fill="white"
        />
        <path
          d="M142.214 153.444L140.934 154.174V152.957L142.214 152.227V153.444Z"
          fill="white"
        />
        <path
          d="M157.109 144.438L144.074 152.348V151.131L157.109 143.221V144.438Z"
          fill="white"
        />
        <path
          d="M158.973 142.126V143.343L164.443 140.057V138.719L158.973 142.126Z"
          fill="white"
        />
        <path
          d="M170.145 136.528L166.304 138.961L166.188 137.745L170.145 135.311V136.528Z"
          fill="white"
        />
        <path
          d="M180.504 130.321L172.008 135.433V134.216L180.504 129.104V130.321Z"
          fill="white"
        />
        <path
          d="M145.939 154.54L141.051 157.461V156.244L145.939 153.323V154.54Z"
          fill="white"
        />
        <path
          d="M153.154 150.158L147.684 153.444V152.227L153.154 148.941V150.158Z"
          fill="white"
        />
        <path
          d="M154.898 147.846V149.185L159.67 146.264V145.047L154.898 147.846Z"
          fill="white"
        />
        <path
          d="M167.354 141.639L161.534 145.168L161.418 143.951L167.354 140.422V141.639Z"
          fill="white"
        />
        <path
          d="M180.503 133.729L169.098 140.544V139.327L180.503 132.391V133.729Z"
          fill="white"
        />
        <path
          d="M150.361 155.149L140.934 160.868V159.651L150.361 153.932V155.149Z"
          fill="white"
        />
        <path
          d="M157.111 151.131L152.223 154.052V152.835L157.111 149.914V151.131Z"
          fill="white"
        />
        <path
          d="M158.973 148.82V150.037L164.443 146.629V145.412L158.973 148.82Z"
          fill="white"
        />
        <path
          d="M143.495 162.693L141.051 164.153V162.936L143.495 161.476V162.693Z"
          fill="white"
        />
        <path
          d="M153.152 156.852L145.238 161.598V160.381L153.152 155.635V156.852Z"
          fill="white"
        />
        <path
          d="M154.898 154.539V155.756L161.183 151.984V150.767L154.898 154.539Z"
          fill="white"
        />
        <path
          d="M153.852 135.31L140.934 143.221V139.326L153.852 131.416V135.31Z"
          fill="white"
        />
        <path
          d="M166.188 127.888L157.227 133.364V129.47L166.188 123.993V127.888Z"
          fill="white"
        />
        <path
          d="M214.719 94.664L206.34 99.7753V103.67L214.719 98.5583L226.591 91.3781V87.6055L214.719 94.664Z"
          fill="white"
        />
        <path
          d="M147.921 210.155L141.055 214.293V210.398L147.921 206.261V210.155Z"
          fill="white"
        />
        <path
          d="M164.564 200.054L151.18 208.087V204.192L164.564 196.16V200.054Z"
          fill="white"
        />
        <path
          d="M214.841 144.682L206.461 149.794V153.688L214.841 148.577L221.009 144.926V141.031L214.841 144.682Z"
          fill="white"
        />
        <path
          d="M149.779 162.084L140.934 167.439V166.222L149.779 160.867V162.084Z"
          fill="white"
        />
        <path
          d="M157.23 157.581L151.527 160.989V159.772L157.23 156.364V157.581Z"
          fill="white"
        />
        <path
          d="M158.973 155.269V156.608L164.559 153.2V151.983L158.973 155.269Z"
          fill="white"
        />
        <path
          d="M170.262 149.792L166.305 152.104V150.887L170.262 148.575V149.792Z"
          fill="white"
        />
        <path
          d="M180.504 143.586L172.008 148.697V147.48L180.504 142.369V143.586Z"
          fill="white"
        />
        <path
          d="M145.939 167.682L141.051 170.724V169.507L145.939 166.465V167.682Z"
          fill="white"
        />
        <path
          d="M153.154 163.423L147.684 166.709V165.492L153.154 162.206V163.423Z"
          fill="white"
        />
        <path
          d="M154.898 161.11V162.327L159.787 159.406V158.189L154.898 161.11Z"
          fill="white"
        />
        <path
          d="M149.779 169.265L140.934 174.498V173.281L149.779 167.927V169.265Z"
          fill="white"
        />
        <path
          d="M157.23 164.762L151.527 168.169V166.952L157.23 163.545V164.762Z"
          fill="white"
        />
        <path
          d="M158.973 162.451V163.668L164.559 160.26V159.043L158.973 162.451Z"
          fill="white"
        />
        <path
          d="M170.262 156.852L166.305 159.286V157.947L170.262 155.635V156.852Z"
          fill="white"
        />
        <path
          d="M180.504 150.646L172.008 155.757V154.54L180.504 149.429V150.646Z"
          fill="white"
        />
        <path
          d="M145.939 174.864L141.051 177.785V176.568L145.939 173.647V174.864Z"
          fill="white"
        />
        <path
          d="M153.151 170.483L147.797 173.768V172.551L153.151 169.266V170.483Z"
          fill="white"
        />
        <path
          d="M154.898 168.17V169.387L159.787 166.466V165.249L154.898 168.17Z"
          fill="white"
        />
        <path
          d="M167.35 161.964L161.531 165.493V164.276L167.35 160.625V161.964Z"
          fill="white"
        />
        <path
          d="M180.504 153.932L169.215 160.869V159.652L180.504 152.715V153.932Z"
          fill="white"
        />
        <path
          d="M142.33 180.341L140.934 181.193V179.976L142.33 179.124V180.341Z"
          fill="white"
        />
        <path
          d="M157.226 171.334L144.074 179.366V178.028L157.226 170.117V171.334Z"
          fill="white"
        />
        <path
          d="M158.973 169.144V170.361L164.559 166.953V165.736L158.973 169.144Z"
          fill="white"
        />
        <path
          d="M170.262 163.545L166.305 165.857V164.64L170.262 162.328V163.545Z"
          fill="white"
        />
        <path
          d="M180.504 157.339L172.008 162.45V161.233L180.504 156.122V157.339Z"
          fill="white"
        />
        <path
          d="M145.936 181.558L141.164 184.479V183.262L145.936 180.341V181.558Z"
          fill="white"
        />
        <path
          d="M153.151 177.176L147.797 180.462V179.245L153.151 175.959V177.176Z"
          fill="white"
        />
        <path
          d="M154.898 174.864V176.081L159.787 173.16V171.943L154.898 174.864Z"
          fill="white"
        />
        <path
          d="M167.35 168.535L161.531 172.065V170.848L167.35 167.318V168.535Z"
          fill="white"
        />
        <path
          d="M180.504 160.625L169.215 167.562V166.345L180.504 159.408V160.625Z"
          fill="white"
        />
        <path
          d="M150.478 182.166L141.051 187.886V186.669L150.478 180.949V182.166Z"
          fill="white"
        />
        <path
          d="M157.227 178.028L152.223 181.07V179.853L157.227 176.811V178.028Z"
          fill="white"
        />
        <path
          d="M158.973 175.716V177.054L164.559 173.647V172.43L158.973 175.716Z"
          fill="white"
        />
        <path
          d="M143.608 189.711L141.164 191.171V189.954L143.608 188.372V189.711Z"
          fill="white"
        />
        <path
          d="M153.153 183.869L145.355 188.616V187.399L153.153 182.652V183.869Z"
          fill="white"
        />
        <path
          d="M155.02 181.557V182.774L159.791 179.854V178.637L155.02 181.557Z"
          fill="white"
        />
        <path
          d="M143.613 233.643L141.285 235.103V233.886L143.613 232.426V233.643Z"
          fill="white"
        />
        <path
          d="M149.783 194.456L141.055 199.689V198.472L149.783 193.117V194.456Z"
          fill="white"
        />
        <path
          d="M157.235 189.953L151.648 193.36V192.143L157.235 188.614V189.953Z"
          fill="white"
        />
        <path
          d="M158.977 187.641V188.858L164.563 185.45V184.233L158.977 187.641Z"
          fill="white"
        />
        <path
          d="M170.266 182.042L166.309 184.354V183.137L170.266 180.825V182.042Z"
          fill="white"
        />
        <path
          d="M180.628 175.836L172.132 180.947L172.016 179.73L180.628 174.619V175.836Z"
          fill="white"
        />
        <path
          d="M146.06 200.055L141.172 202.976V201.759L146.06 198.838V200.055Z"
          fill="white"
        />
        <path
          d="M153.275 195.673L147.805 198.959V197.742L153.275 194.456V195.673Z"
          fill="white"
        />
        <path
          d="M155.02 193.36V194.577L159.791 191.656V190.439L155.02 193.36Z"
          fill="white"
        />
        <path
          d="M151.533 307.393L331.578 198.716C328.32 182.165 315.634 158.799 301.668 160.26C271.292 163.545 154.442 217.701 151.416 268.936C150.951 276.481 151.067 294.979 151.416 302.525C151.416 304.107 151.416 305.689 151.533 307.393Z"
          fill="#455FDC"
        />
        <path
          d="M273.503 211.251L270.71 194.943L214.962 168.778C214.962 168.778 215.777 186.059 214.264 197.134C213.565 202.124 214.496 207.235 217.057 211.494C224.505 223.908 243.127 237.173 265.589 225.49C265.589 225.49 275.249 220.865 273.503 211.251Z"
          fill="#FFB586"
        />
        <path
          d="M289.101 161.476C288.286 153.444 288.984 148.82 286.657 143.952C286.075 142.857 285.493 141.761 285.376 140.544C285.376 138.354 287.471 136.528 286.657 131.782C286.307 129.835 285.493 127.888 284.445 126.184C283.398 124.602 282.001 122.168 281.303 120.586C277.928 112.31 275.135 103.792 268.734 98.0717C253.138 84.0765 238.707 80.9123 227.417 81.2774C203.209 82.1293 190.058 105.617 190.524 121.316C191.222 151.497 216.826 173.89 216.826 173.89C221.947 183.26 230.56 195.795 247.319 202.367C277.811 214.415 287.006 203.219 289.915 201.15C294.222 197.864 290.148 188.372 289.799 186.303C289.566 184.599 290.846 178.758 290.032 171.334C290.032 171.334 291.196 170.36 291.545 169.874C292.127 168.535 293.64 166.71 289.101 161.476Z"
          fill="#FFC799"
        />
        <path
          d="M291.426 169.265C289.796 170.969 286.77 169.996 284.792 169.996C283.977 170.117 283.046 170.361 282.115 170.848C280.486 171.699 278.973 172.551 277.925 172.673C277.111 172.795 276.529 172.065 276.529 171.334C275.947 172.795 277.111 174.133 280.835 172.43C282.93 171.456 283.861 171.334 286.77 171.821C287.352 171.943 287.818 171.943 288.283 171.943C289.564 171.943 290.727 171.091 291.542 169.874C291.775 169.509 291.891 169.265 291.891 168.9C291.775 169.022 291.542 169.144 291.426 169.265Z"
          fill="#F0A986"
        />
        <path
          d="M273.388 116.692C257.559 127.645 229.511 128.74 224.041 142.248C221.48 148.455 223.924 155.513 225.437 162.085C225.903 164.276 225.787 167.318 223.692 167.805C222.644 168.048 221.597 167.318 220.782 166.588C218.454 164.397 216.825 161.477 214.846 158.921C212.868 156.365 210.075 154.053 206.932 154.053C204.256 153.931 204.023 162.694 201.462 161.72C196.807 153.445 174.694 121.438 194.13 103.427C193.665 95.0294 208.795 69.3511 241.033 77.2615C263.495 82.8596 277.926 100.384 277.926 108.295C278.043 112.311 276.646 114.501 273.388 116.692Z"
          fill="#2035A4"
        />
        <path
          opacity="0.4"
          d="M287.82 162.936C288.285 163.302 289.449 164.884 289.565 164.275C289.565 164.275 289.565 164.275 289.565 164.153C289.333 163.788 288.983 163.423 288.751 163.058C288.052 156.486 288.983 152.714 287.936 148.211C283.397 148.576 281.186 151.74 280.255 152.592C278.974 153.809 281.884 158.312 287.82 162.936Z"
          fill="#FFE0BA"
        />
        <path
          d="M225.788 183.138C224.624 168.778 212.753 146.629 200.184 155.27C197.158 157.338 196.692 162.085 197.856 165.736C199.02 169.387 201.231 172.794 204.373 174.741C218.456 183.625 225.788 183.138 225.788 183.138Z"
          fill="#FFC799"
        />
        <path
          opacity="0.4"
          d="M256.396 151.62C250.228 153.81 243.594 156.853 243.594 156.853C254.65 146.63 265.939 146.63 270.246 146.63C270.246 146.752 261.4 149.916 256.396 151.62Z"
          fill="#FFE0BA"
        />
        <path
          opacity="0.4"
          d="M251.159 167.44C247.551 169.144 246.852 172.429 250.228 174.863C253.021 176.932 266.289 182.044 269.198 179.731C272.922 176.811 271.642 164.397 271.526 163.302C271.409 162.085 270.827 157.582 266.87 160.746C260.353 165.979 255.581 165.371 251.159 167.44Z"
          fill="#FFE0BA"
        />
        <path
          opacity="0.4"
          d="M285.027 166.345C288.053 170.239 290.497 170.361 291.893 169.144C292.359 168.048 293.523 166.223 289.216 161.477C286.656 158.678 278.393 149.185 279.091 144.926C279.44 142.492 280.953 140.18 283.979 137.867C285.492 136.772 286.307 135.677 286.889 134.581C286.889 134.095 286.889 133.608 286.889 133.121C286.772 133.364 286.656 133.486 286.54 133.73C285.143 136.285 279.557 138.963 277.694 142.979C277.229 143.952 276.996 144.926 276.88 146.021C276.414 151.741 279.44 157.582 282.35 162.329C283.048 163.667 283.979 165.128 285.027 166.345Z"
          fill="#FFE0BA"
        />
        <path
          opacity="0.6"
          d="M291.429 164.519C290.847 163.788 290.149 163.058 289.218 162.085C285.493 158.312 282.235 153.931 279.674 149.063C279.558 148.698 279.441 148.576 279.441 148.576C279.907 153.931 287.472 165.005 289.334 165.979C290.963 166.831 292.127 165.614 291.429 164.519Z"
          fill="#FFF3C4"
        />
        <path
          d="M280.838 182.53C282.002 181.556 284.097 181.07 285.028 180.583C285.61 180.339 285.959 180.096 286.192 179.853C287.123 179.244 288.287 179.122 289.334 179.488C289.567 179.609 289.8 179.731 290.032 179.609C289.334 181.922 287.356 183.26 286.541 185.086C285.028 188.372 284.795 187.033 282.933 188.25C280.023 190.197 280.256 191.414 275.601 191.049C275.019 191.049 271.527 190.197 271.527 190.197C274.902 187.52 277.463 185.086 280.838 182.53Z"
          fill="#F0A986"
        />
        <path
          d="M289.916 180.096C288.519 184.112 287.006 188.128 283.166 190.44C279.325 192.752 275.019 190.44 271.527 190.318C274.902 188.006 280.14 184.599 284.097 182.53C287.705 180.704 289.916 180.096 289.916 180.096Z"
          fill="#7C4040"
        />
        <path
          d="M282.118 189.223C280.489 189.953 275.135 190.683 271.527 190.318C271.993 190.562 274.204 191.657 278.045 192.266C281.071 192.752 284.33 191.9 286.657 189.71C288.519 187.884 290.032 184.842 290.032 180.096C287.821 184.964 287.937 186.546 282.118 189.223Z"
          fill="#F0A986"
        />
        <path
          d="M204.375 159.163C202.862 159.528 201.582 160.989 201.116 162.571C200.651 164.153 201.116 165.978 202.047 167.317C203.211 169.021 204.608 169.021 205.19 168.534C205.422 168.291 205.422 167.926 205.655 167.804C209.147 163.91 213.802 174.619 216.246 175.471C217.294 175.836 216.712 171.09 214.966 167.317C213.918 165.005 209.496 157.946 204.375 159.163Z"
          fill="#F0A986"
        />
        <path
          opacity="0.4"
          d="M277.927 201.15C276.763 205.653 287.121 202.732 289.565 200.055C290.845 198.594 291.311 195.917 290.729 194.335C288.634 188.98 278.509 199.081 277.927 201.15Z"
          fill="#FFE0BA"
        />
        <path
          opacity="0.5"
          d="M285.843 187.154C284.912 187.884 283.748 188.615 281.886 189.467C281.536 189.588 280.955 189.832 280.256 189.953C280.14 190.075 280.023 190.197 280.023 190.318C280.838 191.292 287.821 187.154 285.843 187.154Z"
          fill="#FFE0BA"
        />
        <path
          d="M284.094 182.53C281.068 184.112 277.111 186.546 273.969 188.736C285.258 185.207 288.168 182.895 288.633 180.461C287.586 180.948 286.073 181.556 284.094 182.53Z"
          fill="white"
        />
        <path
          d="M196.923 155.634C193.082 166.222 201.345 185.693 214.264 186.91C229.859 187.032 227.997 173.037 224.04 162.936C214.729 139.205 200.531 145.776 196.923 155.634Z"
          fill="#10173F"
        />
        <path
          d="M257.093 81.8854C233.933 68.8637 179.465 93.2033 201.927 151.253C202.858 155.148 212.751 155.878 211.587 153.2C198.668 123.75 208.212 101.6 225.088 91.2561C235.911 84.6844 252.903 81.5203 262.447 86.9967C262.447 86.3882 261.05 84.1976 257.093 81.8854Z"
          fill="#10173F"
        />
        <path
          d="M216.361 165.492C212.753 157.825 206.003 153.566 201.348 155.999C196.692 158.433 195.761 166.587 199.369 174.254C202.977 181.921 209.727 186.181 214.383 183.747C219.038 181.313 219.969 173.159 216.361 165.492Z"
          fill="url(#paint10_linear_1926_44029)"
        />
        <path
          d="M255.699 201.027C233.237 201.027 219.737 183.99 219.504 183.746L221.017 182.529C221.133 182.773 237.311 203.096 263.497 198.35L263.846 200.297C261.053 200.784 258.26 201.027 255.699 201.027Z"
          fill="#10173F"
        />
        <path
          d="M273.04 197.134C273.506 199.203 271.527 201.272 268.734 202.002C265.941 202.61 263.264 201.515 262.798 199.568C262.333 197.499 264.311 195.43 267.105 194.7C269.898 193.97 272.575 195.065 273.04 197.134Z"
          fill="#10173F"
        />
        <path
          d="M146.297 310.679C145.715 310.679 145.25 310.557 144.901 310.314C143.969 309.827 143.504 308.731 143.504 307.393V141.762C143.504 138.962 145.599 135.433 148.392 133.729L356.486 8.01524C357.999 7.16335 359.396 6.91995 360.443 7.52844C361.374 8.01523 361.84 9.11052 361.84 10.4492V176.08C361.84 178.879 359.745 182.409 356.952 184.113L148.858 309.948C148.043 310.435 147.112 310.679 146.297 310.679ZM359.047 8.50203C358.465 8.50203 357.766 8.74543 357.068 9.11052L148.858 134.825C146.53 136.285 144.551 139.328 144.551 141.762V307.393C144.551 308.001 144.668 308.853 145.366 309.34C146.064 309.705 147.112 309.583 148.276 308.853L356.486 183.139C358.814 181.679 360.792 178.636 360.792 176.202V10.5709C360.792 9.9624 360.676 9.11052 359.978 8.62373C359.628 8.50203 359.396 8.50203 359.047 8.50203Z"
          fill="#99E2FF"
        />
        <path
          d="M331.461 98.679V212.832C331.461 215.022 333.207 215.874 335.418 214.536L398.265 176.566C400.476 175.227 402.222 172.428 402.222 170.116V55.9629L331.461 98.679Z"
          fill="#99E2FF"
        />
        <path
          d="M402.339 58.7622V54.016C402.339 51.8254 400.593 50.9735 398.382 52.3122L335.418 90.282C333.207 91.6207 331.461 94.4198 331.461 96.732V101.478L402.339 58.7622Z"
          fill="#455FDC"
        />
        <path
          d="M342.868 146.263L341.355 147.237V147.967L342.868 146.994V146.263ZM356.601 137.866L354.157 139.327V140.057L356.601 138.596V137.866ZM362.537 135.067L364.748 133.728V132.998L362.537 134.337V135.067ZM351.713 142.978L349.036 144.681V145.411L351.713 143.708V142.978ZM360.209 137.866L355.321 140.787V141.517L360.209 138.596V137.866ZM361.257 137.988L363.235 136.771V136.041L361.257 137.258V137.988ZM368.705 131.416L372.197 129.347V128.617L368.705 130.686V131.416ZM376.27 126.792L382.555 123.019V122.289L376.27 126.061V126.792ZM373.942 129.591L370.334 131.781V132.511L373.942 130.321V129.591ZM384.999 122.897L381.973 124.723V125.453L384.999 123.628V122.897ZM389.072 120.463L386.046 122.289V123.019L389.072 121.194V120.463ZM393.262 117.908L390.003 119.855V120.585L393.262 118.638V117.908ZM342.868 154.661L341.355 155.634V156.364L342.868 155.391V154.661ZM343.799 154.782L346.01 153.444V152.713L343.799 154.052V154.782ZM347.058 152.835L353.226 149.062V148.332L347.058 152.105V152.835ZM361.606 143.343L357.649 145.777V146.507L361.606 144.073V143.343ZM347.989 153.687L345.777 155.026V155.756L347.989 154.417V153.687ZM352.644 151.618L354.39 150.645V149.914L352.644 150.888V151.618ZM355.321 149.914L360.209 146.994V146.263L355.321 149.184V149.914ZM364.166 144.681L369.403 141.517V140.787L364.166 143.951V144.681ZM343.799 159.042L346.01 157.703V156.973L343.799 158.311V159.042ZM356.601 150.523L350.316 154.295V155.026L356.601 151.253V150.523ZM361.606 147.48L357.649 149.914V150.645L361.606 148.211V147.48ZM364.748 145.655L362.537 146.994V147.724L364.748 146.385V145.655ZM367.658 144.681V143.951L365.795 145.046V145.777L367.658 144.681ZM363.235 148.697L361.257 149.914V150.645L363.235 149.428V148.697ZM361.257 154.782L363.235 153.565V152.835L361.257 154.052V154.782ZM368.705 139.813L372.197 137.744V137.014L368.705 139.083V139.813ZM373.128 137.136L375.339 135.797V135.067L373.128 136.406V137.136ZM376.27 135.189L382.555 131.416V130.686L376.27 134.459V135.189ZM377.201 136.041L374.99 137.379V138.11L377.201 136.771V136.041ZM381.973 133.972L384.999 132.146V131.416L381.973 133.242V133.972ZM393.262 126.305L390.003 128.252V128.982L393.262 127.035V126.305ZM392.68 129.469L394.891 128.13V127.4L392.68 128.739V129.469ZM382.788 136.771V137.501L384.999 136.162V135.432L382.788 136.771ZM389.072 133.12L386.046 134.945V135.676L389.072 133.85V133.12ZM393.262 130.443L390.003 132.39V133.12L393.262 131.173V130.443ZM368.705 148.211L372.197 146.142V145.411L368.705 147.48V148.211ZM375.339 143.464L373.128 144.803V145.533L375.339 144.195V143.464ZM388.258 136.406L391.749 134.337V133.607L388.258 135.676V136.406ZM392.68 133.728L394.891 132.39V131.66L392.68 132.998V133.728ZM377.201 144.438L374.99 145.777V146.507L377.201 145.168V144.438ZM384.999 139.692L380.809 142.247V142.978L384.999 140.422V139.692ZM342.868 179.852L341.355 180.826V181.556L342.868 180.582V179.852ZM347.058 178.027L353.226 174.254V173.524L347.058 177.296V178.027ZM356.601 171.455L354.157 172.915V173.645L356.601 172.185V171.455ZM361.606 168.534L357.649 170.968V171.698L361.606 169.264V168.534ZM347.989 178.878L345.777 180.217V180.947L347.989 179.609V178.878ZM351.713 176.566L349.036 178.27V179L351.713 177.296V176.566ZM364.166 169.873L369.403 166.709V165.978L364.166 169.143V169.873ZM343.799 184.233L346.01 182.895V182.164L343.799 183.503V184.233ZM347.058 182.286L349.385 180.947V180.217L347.058 181.556V182.286ZM351.713 180.826L349.036 182.529V183.26L351.713 181.556V180.826ZM360.209 175.593L355.321 178.513V179.244L360.209 176.323V175.593ZM368.705 165.005L372.197 162.936V162.206L368.705 164.275V165.005ZM376.27 160.38L382.555 156.608V155.878L376.27 159.65V160.38ZM388.258 153.2L391.749 151.131V150.401L388.258 152.47V153.2ZM392.68 150.523L394.891 149.184V148.454L392.68 149.793V150.523ZM384.999 156.486L381.973 158.311V159.042L384.999 157.216V156.486ZM389.072 154.052L386.046 155.878V156.608L389.072 154.782V154.052ZM343.799 171.577L346.01 170.238V169.508L343.799 170.846V171.577ZM356.601 163.058L354.157 164.518V165.248L356.601 163.788V163.058ZM352.644 168.412L354.39 167.439V166.709L352.644 167.682V168.412ZM355.321 166.709L360.209 163.788V163.058L355.321 165.978V166.709ZM361.257 163.179L363.235 161.962V161.232L361.257 162.449V163.179ZM368.705 156.608L372.197 154.539V153.809L368.705 155.878V156.608ZM373.128 153.93L375.339 152.592V151.861L373.128 153.2V153.93ZM342.868 192.387L341.355 193.361V194.091L342.868 193.117V192.387ZM347.058 190.683L353.226 186.911V186.18L347.058 189.953V190.683ZM344.73 193.361L341.355 195.429V196.16L344.73 194.091V193.361ZM351.713 189.223L349.036 190.927V191.657L351.713 189.953V189.223ZM361.257 184.233L363.235 183.016V182.286L361.257 183.503V184.233ZM343.799 196.768L346.01 195.429V194.699L343.799 196.038V196.768ZM347.058 194.821L349.385 193.482V192.752L347.058 194.091V194.821ZM356.601 188.249L350.316 192.022V192.752L356.601 188.979V188.249ZM364.748 183.381L362.537 184.72V185.45L364.748 184.112V183.381ZM367.658 182.408V181.678L365.795 182.773V183.503L367.658 182.408ZM351.713 193.361L349.036 195.064V195.795L351.713 194.091V193.361ZM363.235 186.424L361.257 187.641V188.371L363.235 187.154V186.424ZM342.868 200.784L341.355 201.758V202.488L342.868 201.514V200.784ZM347.058 199.08L353.342 195.308L356.601 193.361V192.63L353.692 194.456L347.058 198.472V199.08ZM373.942 175.714L370.334 177.905V178.635L373.942 176.445V175.714ZM380.925 171.577L378.249 173.28V174.011L380.925 172.307V171.577ZM373.128 179.122L375.339 177.783V177.053L373.128 178.392V179.122ZM376.27 177.175L379.878 174.984V174.254L376.27 176.445V177.175ZM383.602 147.602L387.326 145.411V144.681L383.602 146.872V147.602ZM388.258 144.803L391.749 142.734V142.004L388.258 144.073V144.803ZM392.68 142.126L394.891 140.787V140.057L392.68 141.395V142.126ZM377.201 152.835L374.99 154.174V154.904L377.201 153.565V152.835ZM378.249 152.227V152.957L380.925 151.253V150.523L378.249 152.227ZM392.68 116.934L394.891 115.595V114.865L392.68 116.204V116.934ZM344.73 155.634L341.355 157.703V158.433L344.73 156.364V155.634ZM347.989 162.084L345.777 163.423V164.153L347.989 162.814V162.084ZM376.27 139.448L379.878 137.258V136.528L376.27 138.718V139.448ZM380.925 136.649L387.326 132.755V132.025L380.925 135.919V136.649ZM350.316 180.217L356.601 176.445V175.714L350.316 179.487V180.217ZM344.73 184.963L341.355 187.032V187.762L344.73 185.694V184.963ZM347.989 183.016L345.777 184.355V185.085L347.989 183.746V183.016ZM374.99 163.301L377.201 161.962V161.232L374.99 162.571V163.301ZM365.795 158.311L367.658 157.216V156.486L365.795 157.581V158.311ZM365.795 179.365L367.658 178.27V177.54L365.795 178.635V179.365ZM347.989 191.413L345.777 192.752V193.482L347.989 192.144V191.413ZM369.403 178.513L364.166 181.678V182.408L369.403 179.244V178.513ZM377.201 173.767L374.99 175.106V175.836L377.201 174.497V173.767ZM343.799 146.385L346.01 145.046V144.316L343.799 145.655V146.385ZM365.795 132.39V133.12L367.658 132.025V131.294L365.795 132.39ZM344.73 147.237L341.355 149.306V150.036L344.73 147.967V147.237ZM352.644 143.221L354.39 142.247V141.517L352.644 142.491V143.221ZM364.166 136.284L369.403 133.12V132.39L364.166 135.554V136.284ZM373.128 128.739L375.339 127.4V126.67L373.128 128.009V128.739ZM354.39 154.782V153.93L352.644 154.904V155.634L354.39 154.782ZM343.799 163.179L346.01 161.841V161.111L343.799 162.449V163.179ZM361.606 151.74L357.649 154.174V154.904L361.606 152.47V151.74ZM344.73 164.031L341.355 166.1V166.83L344.73 164.761V164.031ZM354.39 158.19L351.131 160.137V160.867L354.39 158.92V158.19ZM383.602 130.808L387.326 128.617V127.887L383.602 130.078V130.808ZM388.258 128.009L391.749 125.94V125.21L388.258 127.278V128.009ZM368.705 144.073L372.197 142.004V141.274L368.705 143.343V144.073ZM389.072 137.258L386.046 139.083V139.813L389.072 137.988V137.258ZM393.262 134.702L390.003 136.649V137.379L393.262 135.432V134.702ZM355.321 175.106L360.209 172.185V171.455L355.321 174.376V175.106ZM383.602 155.999L387.326 153.809V153.078L383.602 155.269V155.999ZM370.334 166.1L373.942 163.91V163.179L370.334 165.37V166.1ZM362.537 160.259L364.748 158.92V158.19L362.537 159.528V160.259ZM344.73 172.428L341.355 174.497V175.228L344.73 173.159V172.428ZM347.989 170.481L345.777 171.82V172.55L347.989 171.211V170.481ZM351.713 168.169L349.036 169.873V170.603L351.713 168.899V168.169ZM343.799 192.63L346.01 191.292V190.44L343.799 191.778V192.63ZM352.644 189.345L354.39 188.371V187.641L352.644 188.614V189.345ZM355.321 187.762L360.209 184.842V184.112L355.321 187.032V187.762ZM354.39 192.509V191.778L352.644 192.752V193.482L354.39 192.509ZM343.799 201.028L346.01 199.689V198.959L343.799 200.297V201.028ZM373.942 154.782L370.334 156.973V157.703L373.942 155.512V154.782ZM383.602 122.411L387.326 120.22V119.49L383.602 121.68V122.411ZM388.258 119.611L391.749 117.543V116.812L388.258 118.881V119.611ZM351.713 151.375L349.036 153.078V153.809L351.713 152.105V151.375ZM363.235 144.438L361.257 145.655V146.385L363.235 145.168V144.438ZM342.868 158.798L341.355 159.772V160.502L342.868 159.528V158.798ZM367.658 148.089L365.795 149.184V149.914L367.658 148.819V148.089ZM392.68 125.331L394.891 123.993V123.262L392.68 124.601V125.331ZM388.258 132.268L391.749 130.199V129.469L388.258 131.538V132.268ZM380.925 140.057L376.27 142.856V143.586L380.925 140.787V140.057ZM381.973 140.178L387.326 137.014V136.284L381.973 139.448V140.178ZM379.762 143.586V142.856L378.249 143.829V144.56L379.762 143.586ZM343.799 179.974L346.01 178.635V177.905L343.799 179.244V179.974ZM365.795 166.709L367.658 165.613V164.883L365.795 165.978V166.709ZM344.73 180.826L341.355 182.895V183.625L344.73 181.556V180.826ZM361.257 171.577L363.235 170.36V169.629L361.257 170.846V171.577ZM342.868 183.99L341.355 184.963V185.694L342.868 184.72V183.99ZM393.262 151.496L390.003 153.444V154.174L393.262 152.227V151.496ZM342.868 171.455L341.355 172.428V173.159L342.868 172.185V171.455ZM369.403 157.46L364.166 160.624V161.354L369.403 158.19V157.46ZM342.868 196.646L341.355 197.62V198.35L342.868 197.377V196.646ZM344.73 197.62L341.355 199.689V200.419L344.73 198.35V197.62ZM347.989 195.673L345.777 197.012V197.742L347.989 196.403V195.673ZM360.209 188.249L355.321 191.17V191.9L360.209 188.979V188.249ZM373.128 174.984L375.339 173.645V172.915L373.128 174.254V174.984ZM376.27 173.037L382.555 169.264V168.534L376.27 172.307V173.037ZM347.058 144.438L353.226 140.665V139.935L347.058 143.708V144.438ZM347.989 145.29L345.777 146.628V147.359L347.989 146.02V145.29ZM377.201 127.644L374.99 128.982V129.712L377.201 128.374V127.644ZM365.795 140.787V141.517L367.658 140.422V139.692L365.795 140.787ZM364.748 149.793L362.537 151.131V151.861L364.748 150.523V149.793ZM355.321 158.311L360.209 155.391V154.661L355.321 157.581V158.311ZM364.166 153.078L370.334 149.306V148.576L364.166 152.348V153.078ZM380.925 133.728L378.249 135.432V136.162L380.925 134.459V133.728ZM373.128 141.395L375.339 140.057V139.327L373.128 140.665V141.395ZM373.942 146.385L371.265 147.967V148.697L373.942 147.115V146.385ZM354.39 179.122L352.644 180.095V180.826L354.39 179.852V179.122ZM378.249 161.354L380.925 159.65V158.92L378.249 160.624V161.354ZM347.058 169.629L353.226 165.857V165.127L347.058 168.899V169.629ZM361.606 181.069L357.649 183.503V184.233L361.606 181.799V181.069ZM364.748 179.122L362.537 180.461V181.191L364.748 179.852V179.122ZM361.606 185.328L357.649 187.762V188.493L361.606 186.059V185.328ZM361.606 189.466L357.649 191.9V192.63L361.606 190.196V189.466ZM368.705 181.799L372.197 179.73V179L368.705 181.069V181.799ZM357.649 138.11L361.606 135.676V134.945L357.649 137.379V138.11ZM378.249 127.035V127.765L380.925 126.061V125.331L378.249 127.035ZM356.601 146.263L354.157 147.724V148.454L356.601 146.994V146.263ZM362.537 143.464L364.748 142.126V141.395L362.537 142.734V143.464ZM347.058 157.095L349.385 155.634V154.904L347.058 156.243V157.095ZM360.209 150.401L355.321 153.322V154.052L360.209 151.131V150.401ZM342.868 163.058L341.355 164.031V164.761L342.868 163.788V163.058ZM347.058 161.232L353.342 157.46L356.601 155.512V154.782L353.342 156.729L347.058 160.502V161.232ZM350.084 160.745L348.92 161.476V162.206L350.084 161.476V160.745ZM373.942 137.988L370.334 140.178V140.909L373.942 138.718V137.988ZM389.072 128.861L386.046 130.686V131.416L389.072 129.591V128.861ZM364.748 166.587L362.537 167.926V168.656L364.748 167.317V166.587ZM352.644 176.81L354.39 175.836V175.106L352.644 176.079V176.81ZM373.128 162.328L375.339 160.989V160.259L373.128 161.597V162.328ZM357.649 163.301L361.606 160.867V160.137L357.649 162.571V163.301ZM356.601 184.112L354.157 185.572V186.302L356.601 184.842V184.112ZM368.705 177.662L372.197 175.593V174.862L368.705 176.931V177.662ZM376.27 151.983L382.555 148.211V147.48L376.27 151.253V151.983ZM384.999 148.089L381.973 149.914V150.645L384.999 148.819V148.089ZM389.072 145.655L386.046 147.48V148.211L389.072 146.385V145.655ZM393.262 143.099L390.003 145.046V145.777L393.262 143.829V143.099ZM338.445 147.602L339.958 146.628V145.898L338.445 146.872V147.602ZM338.445 149.671L339.958 148.697V147.967L338.445 148.941V149.671ZM338.445 151.861L339.958 150.888V150.158L338.445 151.131V151.861ZM338.445 153.93L339.958 152.957V152.227L338.445 153.2V153.93ZM338.445 155.999L339.958 155.026V154.295L338.445 155.269V155.999ZM338.445 158.068L339.958 157.095V156.364L338.445 157.338V158.068ZM338.445 160.259L339.958 159.285V158.555L338.445 159.528V160.259ZM338.445 162.328L339.958 161.354V160.624L338.445 161.597V162.328ZM338.445 164.396L339.958 163.423V162.693L338.445 163.666V164.396ZM338.445 166.465L339.958 165.492V164.761L338.445 165.735V166.465ZM338.445 168.656L339.958 167.682V166.952L338.445 167.926V168.656ZM338.445 170.725L339.958 169.751V169.021L338.445 169.995V170.725ZM338.445 172.794L339.958 171.82V171.09L338.445 172.063V172.794ZM338.445 174.862L339.958 173.889V173.159L338.445 174.132V174.862ZM338.445 176.931L339.958 175.958V175.228L338.445 176.201V176.931ZM338.445 179.122L339.958 178.148V177.418L338.445 178.392V179.122ZM338.445 181.191L339.958 180.217V179.487L338.445 180.461V181.191ZM338.445 183.26L339.958 182.286V181.556L338.445 182.529V183.26ZM338.445 185.328L339.958 184.355V183.625L338.445 184.598V185.328ZM338.445 187.519L339.958 186.545V185.815L338.445 186.789V187.519ZM338.445 189.588L339.958 188.614V187.884L338.445 188.858V189.588ZM338.445 191.657L339.958 190.683V189.953L338.445 190.927V191.657ZM338.445 193.726L339.958 192.752V192.022L338.445 192.995V193.726ZM338.445 195.916L339.958 194.943V194.212L338.445 195.186V195.916ZM338.445 197.985L339.958 197.012V196.281L338.445 197.255V197.985ZM338.445 200.054L339.958 199.08V198.35L338.445 199.324V200.054ZM338.445 202.123L339.958 201.149V200.419L338.445 201.393V202.123ZM338.445 204.313L339.958 203.34V202.61L338.445 203.583V204.313Z"
          fill="#FFFCF8"
        />
        <path
          d="M340.078 104.034L342.522 102.573V103.182L341.707 103.669V106.346L340.893 106.833V104.155L340.078 104.642V104.034Z"
          fill="white"
        />
        <path
          d="M344.846 101.721L343.682 102.451V103.181L344.729 102.573V103.181L343.682 103.79V104.52L344.846 103.79V104.398L342.867 105.615V102.329L344.846 101.112V101.721Z"
          fill="white"
        />
        <path
          d="M346.825 99.8951C347.639 99.4083 348.105 99.53 348.338 100.138L347.523 100.625C347.407 100.382 347.174 100.382 346.825 100.625C346.359 100.869 346.01 101.477 346.01 102.086C346.01 102.694 346.359 102.816 346.825 102.572C347.174 102.451 347.407 102.086 347.523 101.721L348.338 101.234C348.105 102.086 347.639 102.816 346.825 103.303C345.894 103.911 345.195 103.546 345.195 102.572C345.195 101.477 345.894 100.382 346.825 99.8951Z"
          fill="white"
        />
        <path
          d="M350.783 99.4076L349.619 100.138V101.476L348.805 101.963V98.6774L349.619 98.1906V99.5293L350.783 98.7991V97.4604L351.598 96.9736V100.259L350.783 100.746V99.4076Z"
          fill="white"
        />
        <path
          d="M354.976 95.0273V98.3132L354.161 98.8L352.881 97.583V99.6519L352.066 100.139V96.7311L352.881 96.2443L354.161 97.583V95.5141L354.976 95.0273Z"
          fill="white"
        />
        <path
          d="M355.555 94.6616L356.369 94.1748V97.4607L355.555 97.9475V94.6616Z"
          fill="white"
        />
        <path
          d="M358.348 92.9576C359.163 92.4708 359.628 92.5925 359.861 93.201L359.046 93.6878C358.93 93.4444 358.697 93.4444 358.348 93.6878C357.883 93.9312 357.533 94.5397 357.533 95.1482C357.533 95.7567 357.883 95.8784 358.348 95.635C358.697 95.5133 358.93 95.1482 359.046 94.7831L359.861 94.2963C359.628 95.1482 359.163 95.8784 358.348 96.3651C357.417 96.9736 356.719 96.6086 356.719 95.635C356.719 94.5397 357.417 93.4444 358.348 92.9576Z"
          fill="white"
        />
        <path
          d="M362.305 93.3232L361.141 94.0534L360.908 94.7836L360.094 95.2704L361.258 91.2544L362.189 90.7676L363.352 93.4449L362.538 93.9317L362.305 93.3232ZM361.723 91.7411L361.374 93.2015L362.189 92.7147L361.723 91.7411Z"
          fill="white"
        />
        <path
          d="M364.401 89.3076V91.985L365.449 91.3765V91.985L363.703 93.0803V89.7944L364.401 89.3076Z"
          fill="white"
        />
        <path
          d="M343.217 116.933C341.355 118.028 339.842 118.028 339.842 116.203L342.053 114.864C342.17 115.472 342.519 115.594 343.101 115.229C343.683 114.864 344.148 114.255 344.148 113.769C344.148 112.065 339.726 115.594 339.842 112.308C339.842 110.604 341.239 108.779 342.984 107.684C344.847 106.588 346.127 106.71 346.243 108.414L343.916 109.752C343.916 109.144 343.45 109.022 342.868 109.387C342.403 109.631 341.937 110.239 341.937 110.726C341.937 112.308 346.243 109.022 346.243 112.065C346.476 113.769 345.312 115.716 343.217 116.933Z"
          fill="white"
        />
        <path
          d="M347.757 105.007L349.852 103.669V109.145C349.852 110.24 350.317 110.484 351.365 109.875C352.412 109.267 352.878 108.293 352.878 107.198V101.721L354.973 100.383V105.859C354.973 108.415 353.227 110.605 351.249 111.822C349.27 113.039 347.641 112.796 347.641 110.24V105.007H347.757Z"
          fill="white"
        />
        <path
          d="M359.977 103.425L358.696 104.277V107.563L356.602 108.901V99.7739L360.093 97.7051C362.188 96.3664 363.352 96.9749 363.352 98.6787C363.235 100.139 362.188 102.086 359.977 103.425ZM359.86 101.721C360.675 101.234 361.024 100.504 361.024 99.8956C361.024 99.2871 360.675 98.922 359.86 99.5305L358.696 100.261V102.573L359.86 101.721Z"
          fill="white"
        />
        <path
          d="M367.774 98.7999L366.493 99.6518V102.938L364.398 104.276V95.1489L367.89 93.0801C369.985 91.7414 371.149 92.3499 371.149 94.0537C371.032 95.3923 369.985 97.4612 367.774 98.7999ZM367.657 97.0961C368.472 96.6093 368.821 95.8791 368.821 95.2706C368.821 94.5404 368.472 94.297 367.657 94.9055L366.493 95.6357V97.948L367.657 97.0961Z"
          fill="white"
        />
        <path
          d="M376.269 96.9745C373.825 98.4349 371.73 97.7047 371.73 95.0273C371.73 92.2283 373.709 89.1858 376.269 87.6037C378.713 86.1433 380.692 86.8735 380.692 89.5509C380.692 92.2283 378.713 95.5141 376.269 96.9745ZM376.269 95.0273C377.666 94.1754 378.597 92.5933 378.597 91.0113C378.597 89.4292 377.666 88.9424 376.269 89.7943C374.873 90.6462 373.942 92.2283 373.942 93.8103C373.942 95.3924 374.756 95.8792 376.269 95.0273Z"
          fill="white"
        />
        <path
          d="M385.463 82.25C387.558 80.9113 388.722 81.6415 388.722 83.2235C388.722 84.3188 388.14 85.7792 386.744 86.9962L388.722 89.4301L386.278 90.8905L384.416 88.5783L383.95 88.9434V92.3509L381.855 93.6896V84.5622L385.463 82.25ZM385.347 84.1971L384.067 85.049V87.3613L385.347 86.5094C386.162 86.0226 386.511 85.4141 386.511 84.6839C386.511 83.832 386.162 83.7103 385.347 84.1971Z"
          fill="white"
        />
        <path
          d="M389.539 79.6934L396.289 75.5557V77.3811L393.962 78.8415V86.2651L391.867 87.6038V80.1802L389.539 81.6406V79.6934Z"
          fill="white"
        />
        <path
          d="M394.428 100.504C394.428 104.764 391.053 110.24 386.98 112.796C382.906 115.23 379.531 113.769 379.531 109.51C379.531 105.251 382.906 99.7741 386.98 97.2185C391.17 94.6628 394.428 96.1232 394.428 100.504Z"
          fill="#455FDC"
        />
        <path
          d="M387.562 109.753C387.562 109.632 387.678 109.51 387.795 109.388C388.959 107.928 389.89 105.494 389.89 103.303C389.89 101.113 389.075 99.6524 387.795 99.6524C387.678 99.6524 387.562 99.6524 387.562 99.5307C387.213 99.0439 386.747 98.9222 386.165 99.1656C385.7 99.2873 385.351 100.018 385.467 100.383L386.282 102.695C386.398 103.06 386.98 102.938 387.213 102.451C387.562 101.965 388.028 101.721 388.26 101.965C388.493 102.451 388.609 103.182 388.609 104.034C388.609 104.885 388.493 105.737 388.144 106.589C388.028 107.076 387.446 107.563 387.213 107.441C386.864 107.319 386.282 107.806 386.165 108.293L385.351 111.579C385.234 112.066 385.583 112.309 386.049 111.944C386.747 111.214 387.213 110.484 387.562 109.753Z"
          fill="white"
        />
        <path
          d="M351.019 118.88C355.092 116.446 358.467 117.906 358.467 122.166C358.467 126.425 355.092 131.902 351.019 134.457C346.945 136.891 343.57 135.431 343.57 131.171C343.57 126.912 346.945 121.314 351.019 118.88Z"
          fill="#CC4444"
        />
        <path
          d="M355.907 123.625C355.791 123.625 355.675 123.625 355.675 123.504C354.976 122.652 353.114 122.895 351.019 124.234C348.924 125.573 347.062 127.52 346.364 129.224C346.248 129.345 346.248 129.467 346.131 129.589C345.549 130.319 345.084 131.049 344.967 131.779C344.851 132.266 345.316 132.388 345.782 132.023L348.459 129.589C348.924 129.224 349.041 128.615 348.692 128.372C348.342 128.25 348.459 127.642 348.808 127.155C349.39 126.546 350.205 125.938 351.019 125.451C351.834 124.964 352.649 124.599 353.231 124.599C353.58 124.477 353.696 124.964 353.463 125.451C353.114 125.938 353.231 126.425 353.696 126.303L356.373 125.573C356.838 125.451 357.188 124.842 357.071 124.356C356.955 123.869 356.489 123.625 355.907 123.625Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M369.52 125.697C367.308 127.035 365.562 129.834 365.562 132.147V136.893H365.679V196.281L398.383 176.566C400.594 175.228 402.34 172.429 402.34 170.116V105.981L369.52 125.697Z"
          fill="#437B9B"
        />
        <path
          d="M373.828 138.961V208.816C373.828 211.007 375.574 211.859 377.785 210.52L425.852 181.556C428.063 180.217 429.809 177.418 429.809 175.106V105.251L373.828 138.961Z"
          fill="#455FDC"
        />
        <path
          d="M429.808 108.049V103.303C429.808 101.113 428.062 100.261 425.851 101.599L377.668 130.685C375.457 132.024 373.711 134.823 373.711 137.135V141.881L429.808 108.049Z"
          fill="#99E2FF"
        />
        <path
          d="M419.449 108.779V109.266C419.449 109.388 419.449 109.509 419.332 109.509L417.237 111.335L419.332 110.605C419.449 110.605 419.449 110.605 419.449 110.726V111.213C419.449 111.335 419.449 111.335 419.332 111.457L416.772 112.187C416.655 112.187 416.539 112.187 416.539 112.065V111.7C416.539 111.578 416.655 111.457 416.772 111.335L419.332 108.901C419.449 108.657 419.449 108.657 419.449 108.779Z"
          fill="white"
        />
        <path
          d="M420.847 111.578L420.265 111.943C420.148 112.065 420.148 111.943 420.148 111.822C420.265 111.335 420.498 110.483 420.963 109.266C421.312 108.049 421.545 107.075 421.778 106.589C421.778 106.467 421.894 106.345 422.011 106.345L422.593 105.98C422.709 105.858 422.709 105.98 422.709 106.102L420.963 111.335C420.963 111.457 420.963 111.457 420.847 111.578Z"
          fill="white"
        />
        <path
          d="M423.289 106.954V106.467C423.289 106.345 423.289 106.345 423.405 106.223L425.966 105.493C426.082 105.493 426.199 105.493 426.199 105.615V105.98C426.199 106.102 426.082 106.223 425.966 106.345L423.405 108.779C423.289 108.901 423.289 108.901 423.289 108.779V108.292C423.289 108.171 423.289 108.049 423.405 108.049L425.5 106.223L423.405 106.954C423.289 107.075 423.289 107.075 423.289 106.954Z"
          fill="white"
        />
        <path
          d="M383.134 145.046V144.559L381.737 145.411C381.621 145.411 381.621 145.532 381.621 145.654V147.966C381.621 148.088 381.621 148.088 381.737 147.966L384.531 146.263C384.647 146.263 384.647 146.141 384.647 146.019V144.194C384.647 144.072 384.647 144.072 384.531 144.194L383.134 145.046Z"
          fill="#99E2FF"
        />
        <path
          d="M391.862 141.517L386.625 144.682V143.221L391.862 140.179V141.517Z"
          fill="#99E2FF"
        />
        <path
          d="M397.216 138.231L393.492 140.422V139.083L397.216 136.893V138.231Z"
          fill="#99E2FF"
        />
        <path
          d="M383.134 151.01V150.523L381.737 151.375C381.621 151.375 381.621 151.496 381.621 151.618V153.93C381.621 154.052 381.621 154.052 381.737 153.93L384.531 152.227C384.647 152.227 384.647 152.105 384.647 151.983V150.158C384.647 150.036 384.647 150.036 384.531 150.158L383.134 151.01Z"
          fill="#99E2FF"
        />
        <path
          d="M394.074 146.02L386.625 150.523V149.184L394.074 144.682V146.02Z"
          fill="#99E2FF"
        />
        <path
          d="M403.618 132.634V132.147L402.222 132.999C402.105 132.999 402.105 133.12 402.105 133.242V135.554C402.105 135.676 402.105 135.676 402.222 135.554L405.015 133.851C405.131 133.851 405.131 133.729 405.131 133.607V131.782C405.131 131.66 405.131 131.66 405.015 131.782L403.618 132.634Z"
          fill="#99E2FF"
        />
        <path
          d="M408.739 131.295L407.109 132.268V130.93L408.739 129.956V131.295Z"
          fill="#99E2FF"
        />
        <path
          d="M414.558 127.765L410.484 130.199V128.861L414.558 126.427V127.765Z"
          fill="#99E2FF"
        />
        <path
          d="M403.622 138.596V138.11L402.226 138.962C402.109 138.962 402.109 139.083 402.109 139.205V141.517C402.109 141.639 402.109 141.639 402.226 141.517L405.019 139.813C405.135 139.813 405.135 139.692 405.135 139.57V137.745C405.135 137.623 405.135 137.623 405.019 137.745L403.622 138.596Z"
          fill="#99E2FF"
        />
        <path
          d="M412.351 135.067L407.113 138.231V136.893L412.351 133.729V135.067Z"
          fill="#99E2FF"
        />
        <path
          d="M416.192 132.634L413.98 134.094V132.634L416.192 131.295V132.634Z"
          fill="#99E2FF"
        />
        <path
          d="M383.134 156.973V156.487L381.737 157.339C381.621 157.339 381.621 157.46 381.621 157.582V159.894C381.621 160.016 381.621 160.016 381.737 159.894L384.531 158.19C384.647 158.19 384.647 158.069 384.647 157.947V156.122C384.647 156 384.647 156 384.531 156.122L383.134 156.973Z"
          fill="#99E2FF"
        />
        <path
          d="M389.767 154.54L386.625 156.487V155.148L389.767 153.201V154.54Z"
          fill="#99E2FF"
        />
        <path
          d="M394.774 151.619L391.516 153.566V152.227L394.774 150.28V151.619Z"
          fill="#99E2FF"
        />
        <path
          d="M403.622 144.56V144.074L402.226 144.925C402.109 144.925 402.109 145.047 402.109 145.169V147.481C402.109 147.603 402.109 147.603 402.226 147.481L405.019 145.777C405.135 145.777 405.135 145.656 405.135 145.534V143.708C405.135 143.587 405.135 143.587 405.019 143.708L403.622 144.56Z"
          fill="#99E2FF"
        />
        <path
          d="M410.256 142.248L407.113 144.195V142.856L410.256 140.909V142.248Z"
          fill="#99E2FF"
        />
        <path
          d="M415.142 139.206L411.883 141.275V139.936L415.142 137.867V139.206Z"
          fill="#99E2FF"
        />
        <path
          d="M383.954 161.598L381.859 162.815C381.742 162.815 381.742 162.936 381.742 163.058V166.466C381.742 166.587 381.859 166.587 381.859 166.587L384.419 165.127C384.535 165.127 384.535 165.005 384.535 164.884V161.963C384.419 161.719 384.186 161.719 383.954 161.598Z"
          fill="white"
        />
        <path
          d="M391.866 159.407L386.629 162.571V161.233L391.866 158.068V159.407Z"
          fill="white"
        />
        <path
          d="M396.41 156.608L393.5 158.434V156.973L396.41 155.27V156.608Z"
          fill="white"
        />
        <path
          d="M383.954 167.439L381.859 168.656C381.742 168.656 381.742 168.778 381.742 168.9V172.307C381.742 172.429 381.859 172.429 381.859 172.429L384.419 170.969C384.535 170.969 384.535 170.847 384.535 170.725V167.805C384.419 167.561 384.186 167.439 383.954 167.439Z"
          fill="white"
        />
        <path
          d="M390.586 165.857L386.629 168.291V166.953L390.586 164.519V165.857Z"
          fill="white"
        />
        <path
          d="M383.954 173.159L381.859 174.376C381.742 174.376 381.742 174.498 381.742 174.62V178.027C381.742 178.149 381.859 178.149 381.859 178.149L384.419 176.688C384.535 176.688 384.535 176.567 384.535 176.445V173.403C384.419 173.403 384.186 173.281 383.954 173.159Z"
          fill="white"
        />
        <path
          d="M392.448 170.603L386.629 174.133V172.794L392.448 169.265V170.603Z"
          fill="white"
        />
        <path
          d="M396.41 168.291L394.082 169.63V168.291L396.41 166.952V168.291Z"
          fill="white"
        />
        <path
          d="M383.954 179.001L381.859 180.218C381.742 180.218 381.742 180.34 381.742 180.461V183.869C381.742 183.991 381.859 183.991 381.859 183.991L384.419 182.53C384.535 182.53 384.535 182.409 384.535 182.287V179.366C384.419 179.123 384.186 179.123 383.954 179.001Z"
          fill="white"
        />
        <path
          d="M388.957 178.513L386.629 179.974V178.513L388.957 177.175V178.513Z"
          fill="white"
        />
        <path
          d="M394.78 174.984L390.59 177.54V176.201L394.78 173.646V174.984Z"
          fill="white"
        />
        <path
          d="M383.954 184.477L381.859 185.694C381.742 185.694 381.742 185.815 381.742 185.937V189.344C381.742 189.466 381.859 189.466 381.859 189.466L384.419 188.006C384.535 188.006 384.535 187.884 384.535 187.762V184.842C384.419 184.72 384.186 184.598 383.954 184.477Z"
          fill="white"
        />
        <path
          d="M391.866 182.287L386.629 185.451V184.112L391.866 180.948V182.287Z"
          fill="white"
        />
        <path
          d="M396.41 179.609L393.5 181.313V179.974L396.41 178.271V179.609Z"
          fill="white"
        />
        <path
          d="M383.954 190.319L381.859 191.536C381.742 191.536 381.742 191.658 381.742 191.78V195.187C381.742 195.309 381.859 195.309 381.859 195.309L384.419 193.849C384.535 193.849 384.535 193.727 384.535 193.605V190.684C384.419 190.441 384.186 190.441 383.954 190.319Z"
          fill="white"
        />
        <path
          d="M390.586 188.858L386.629 191.292V189.832L390.586 187.52V188.858Z"
          fill="white"
        />
        <path
          d="M404.321 149.306L402.226 150.523C402.109 150.523 402.109 150.644 402.109 150.766V154.174C402.109 154.295 402.226 154.295 402.226 154.295L404.786 152.835C404.903 152.835 404.903 152.713 404.903 152.592V149.671C404.67 149.549 404.553 149.427 404.321 149.306Z"
          fill="white"
        />
        <path
          d="M414.445 145.776L406.996 150.279V148.94L414.445 144.438V145.776Z"
          fill="white"
        />
        <path
          d="M404.321 155.146L402.226 156.363C402.109 156.363 402.109 156.485 402.109 156.607V160.014C402.109 160.136 402.226 160.136 402.226 160.136L404.786 158.676C404.903 158.676 404.903 158.554 404.903 158.432V155.512C404.67 155.268 404.553 155.268 404.321 155.146Z"
          fill="white"
        />
        <path
          d="M415.608 150.888L406.996 156.121V154.782L415.608 149.549V150.888Z"
          fill="white"
        />
        <path
          d="M404.321 160.988L402.226 162.205C402.109 162.205 402.109 162.327 402.109 162.449V165.856C402.109 165.978 402.226 165.978 402.226 165.978L404.786 164.518C404.903 164.518 404.903 164.396 404.903 164.274V161.232C404.67 161.11 404.553 160.988 404.321 160.988Z"
          fill="white"
        />
        <path
          d="M410.72 159.65L406.996 161.841V160.502L410.72 158.312V159.65Z"
          fill="white"
        />
        <path
          d="M404.321 166.708L402.226 167.925C402.109 167.925 402.109 168.047 402.109 168.168V171.576C402.109 171.698 402.226 171.698 402.226 171.698L404.786 170.237C404.903 170.237 404.903 170.116 404.903 169.994V167.073C404.67 166.951 404.553 166.83 404.321 166.708Z"
          fill="white"
        />
        <path
          d="M409.906 165.977L406.996 167.681V166.342L409.906 164.639V165.977Z"
          fill="white"
        />
        <path
          d="M415.031 162.814L411.539 164.883V163.544L415.031 161.476V162.814Z"
          fill="white"
        />
        <path
          d="M84.1424 321.024L48.7617 299.726L84.1424 278.308L119.639 299.726L84.1424 321.024Z"
          fill="url(#paint11_linear_1926_44029)"
        />
        <path
          d="M84.1424 362.4L48.7617 340.981V299.726L84.1424 321.023V362.4Z"
          fill="#276E91"
        />
        <path
          d="M119.638 340.981L84.1406 362.4V321.023L119.638 299.726V340.981Z"
          fill="#2D86A5"
        />
        <path
          d="M286.186 354.124L271.871 345.605L286.186 336.965L300.385 345.605L286.186 354.124Z"
          fill="url(#paint12_linear_1926_44029)"
        />
        <path
          d="M286.186 370.796L271.871 362.155V345.604L286.186 354.123V370.796Z"
          fill="#276E91"
        />
        <path
          d="M300.386 362.155L286.188 370.796V354.123L300.386 345.604V362.155Z"
          fill="#2D86A5"
        />
        <path
          d="M275.588 382.723L268.488 378.463L275.588 374.082L282.687 378.463L275.588 382.723Z"
          fill="url(#paint13_linear_1926_44029)"
        />
        <path
          d="M275.588 390.998L268.488 386.738V378.463L275.588 382.722V390.998Z"
          fill="#276E91"
        />
        <path
          d="M282.689 386.738L275.59 390.998V382.722L282.689 378.463V386.738Z"
          fill="#2D86A5"
        />
        <path
          d="M373.009 220.62C373.358 221.472 373.707 222.324 374.056 223.176C374.987 225.732 375.104 228.287 375.22 230.965C375.22 231.086 375.22 231.208 375.336 231.33C375.336 231.33 375.453 231.451 375.569 231.451C377.897 231.938 379.875 228.409 380.806 226.584C381.854 224.636 383.018 221.837 382.669 219.525C382.203 216.483 380.69 212.71 377.315 212.588C373.241 212.467 371.845 217.213 373.009 220.62Z"
          fill="#2035A4"
        />
        <path
          d="M421.421 296.803C420.955 295.83 415.136 290.231 414.903 288.649L411.644 289.014C412.11 289.38 411.644 290.231 411.412 290.718C411.062 291.327 411.063 291.692 411.063 292.422C411.063 293.882 412.575 294.978 413.507 296.195C415.136 298.264 416.882 299.967 417.696 300.211C418.86 300.819 421.072 300.698 421.653 299.115C421.886 298.507 421.77 297.655 421.421 296.803Z"
          fill="#276E91"
        />
        <path
          d="M410.364 295.222C410.131 294.857 409.898 294.492 410.015 294.005L406.174 293.397C405.592 293.275 405.127 293.64 404.778 294.127C404.312 295.1 403.614 296.196 404.778 297.291C405.127 297.656 410.015 302.402 411.644 303.011C414.437 303.984 417.696 302.646 416.416 300.212C415.95 298.995 410.597 295.466 410.364 295.222Z"
          fill="#276E91"
        />
        <path
          d="M421.073 295.709C420.608 294.735 415.254 288.772 415.021 287.312L411.762 287.677C412.228 288.042 412.112 288.894 411.879 289.502C411.53 290.111 411.297 290.719 411.297 291.328C411.297 292.788 412.693 293.64 413.625 294.857C415.254 296.926 417 298.629 417.814 298.873C418.978 299.481 420.724 299.603 421.306 298.021C421.539 297.291 421.422 296.439 421.073 295.709Z"
          fill="white"
        />
        <path
          d="M409.547 292.18L406.405 291.571C406.172 291.936 403.262 294.614 404.892 296.074C405.241 296.439 410.129 301.185 411.758 301.794C414.552 302.768 417.578 301.672 416.297 299.117C415.133 296.926 410.362 295.101 409.547 292.18Z"
          fill="white"
        />
        <path
          d="M415.72 287.919C414.44 284.755 411.298 275.019 410.134 270.517C410.018 269.908 409.785 269.178 409.668 267.839C409.552 266.622 409.087 265.405 408.272 264.553C401.405 257.251 390.116 253.479 387.323 249.098L383.715 262.241C388.952 266.257 402.802 268.813 403.384 269.178C403.151 273.194 403.616 277.453 405.944 280.617C407.574 282.808 411.065 288.163 411.181 288.771C411.763 290.11 416.419 289.623 415.72 287.919Z"
          fill="#2035A4"
        />
        <path
          d="M400.359 272.708C400.01 271.491 399.312 270.396 398.381 269.665C394.656 266.623 385.811 260.051 385.695 259.443C385.462 258.469 385.928 257.496 386.393 256.644C386.975 255.548 387.324 254.453 387.79 253.358C388.023 252.749 388.139 252.141 388.023 251.532C387.79 250.194 386.393 248.977 387.092 247.76L374.289 250.802C371.496 253.358 371.729 260.538 374.755 264.189C376.384 266.136 379.41 267.84 381.505 269.179C384.88 271.248 389.186 273.56 392.794 275.264C396.169 282.444 399.545 283.296 405.48 293.275C406.295 295.1 410.485 293.153 409.786 291.936C399.312 275.264 401.523 276.481 400.359 272.708Z"
          fill="#2035A4"
        />
        <path
          d="M398.843 253.965C398.261 251.531 393.49 241.065 392.791 239.483C392.791 239.483 391.278 226.583 389.649 223.906C389.067 222.932 387.903 222.446 386.856 222.689C385.11 223.297 385.226 224.393 385.459 225.975C385.692 227.557 387.438 240.579 388.136 242.039C389.765 245.081 395.119 255.304 395.235 255.547C395.934 257.13 399.309 255.548 398.843 253.965Z"
          fill="#455FDC"
        />
        <path
          d="M375.682 229.139C373.703 230.721 373.819 232.547 374.518 234.859C375.216 237.293 376.38 239.727 376.263 242.404C376.147 245.203 374.401 247.516 373.47 250.071C373.354 250.558 373.121 251.045 373.121 251.532C373.121 252.992 374.634 253.966 375.914 254.331C379.639 255.548 383.945 254.574 386.854 251.897C387.436 251.41 387.902 250.923 388.018 250.193C388.6 248.124 386.156 246.177 386.738 244.23C387.087 242.769 388.833 242.161 389.88 241.066C390.811 240.092 391.393 238.753 391.277 237.415C391.044 234.737 388.6 232.669 388.251 229.991C388.018 228.652 388.367 227.192 388.484 225.853C388.484 224.515 388.135 223.054 386.505 223.176C384.876 223.298 382.665 225.245 381.152 225.975C379.289 226.705 377.427 227.679 375.682 229.139Z"
          fill="#455FDC"
        />
        <path
          d="M385.808 225.123C385.458 224.88 384.993 224.758 384.644 224.637C384.295 224.515 382.316 222.568 382.083 222.811C381.152 224.15 381.734 225.123 380.338 226.705C378.01 229.383 384.993 234.737 386.622 229.504C386.855 228.774 387.088 228.166 387.204 227.436C387.321 226.584 386.506 225.61 385.808 225.123Z"
          fill="#F1A782"
        />
        <path
          d="M380.221 214.293C380.686 214.779 380.453 215.753 379.755 216.483C379.057 217.092 378.126 217.213 377.66 216.605C377.195 216.118 377.427 215.144 378.126 214.414C378.824 213.806 379.755 213.806 380.221 214.293Z"
          fill="#1A2C87"
        />
        <path
          d="M389.301 226.584C389.417 225.854 389.417 225.124 389.184 224.515C388.719 222.933 390.115 220.377 388.719 218.43C387.206 216.24 385.925 216.605 384.762 217.092C382.667 217.822 377.546 219.769 378.36 221.838C380.223 226.828 382.667 228.288 384.063 229.018C385.111 229.505 387.555 231.087 388.602 229.748C388.951 229.261 388.951 228.653 389.184 228.044C389.184 227.558 389.184 227.071 389.301 226.584Z"
          fill="#FABC9D"
        />
        <path
          d="M388.021 216.24C383.599 210.763 376.267 214.414 376.732 220.134C377.198 225.367 380.689 226.828 381.62 227.193C381.387 226.706 380.573 225.367 380.573 224.759C380.573 224.272 381.038 224.029 381.504 224.272C381.853 224.394 382.086 224.637 382.318 224.88C382.551 225.124 383.25 226.462 383.25 225.367C383.25 224.637 383.017 223.907 383.599 223.42C383.831 223.177 384.181 223.055 384.53 222.933C385.461 222.568 386.276 221.716 386.974 220.864C387.556 220.134 388.952 220.134 389.302 219.404C389.651 218.674 388.487 216.848 388.021 216.24Z"
          fill="#2035A4"
        />
        <path
          d="M388.599 258.955C386.271 256.643 377.775 247.881 377.775 247.881C377.775 243.013 379.521 230.234 374.633 230.234C373.12 230.234 371.956 231.938 371.607 233.52C371.374 234.616 371.258 248.611 372.655 250.315C374.749 252.749 381.616 258.833 386.155 261.024C387.552 261.876 389.53 260.172 388.599 258.955Z"
          fill="#455FDC"
        />
        <path
          d="M380.105 225.002C380.105 226.219 380.92 226.705 381.968 227.192L382.782 225.975C381.502 223.298 380.105 223.906 380.105 225.002Z"
          fill="#FABC9D"
        />
        <path
          d="M384.535 264.31V264.675C384.535 264.797 384.535 264.797 384.652 264.918L394.195 270.638C394.311 270.76 394.661 270.76 394.777 270.638L408.277 262.363C408.394 262.363 408.394 262.241 408.394 262.241V261.876L384.535 264.31Z"
          fill="#ADA4B8"
        />
        <path
          d="M408.393 261.754L398.849 256.035C398.733 255.913 398.384 255.913 398.267 256.035L384.767 264.31C384.651 264.432 384.651 264.554 384.767 264.675L394.31 270.395C394.427 270.517 394.776 270.517 394.892 270.395L408.393 262.12C408.509 261.998 408.509 261.754 408.393 261.754Z"
          fill="white"
        />
        <path
          d="M391.164 266.744L390.582 267.109C390.466 267.109 390.466 267.109 390.35 267.109L389.884 266.744C389.768 266.744 389.768 266.622 389.884 266.622L390.466 266.257C390.582 266.257 390.582 266.257 390.699 266.257L391.164 266.622C391.281 266.622 391.281 266.622 391.164 266.744ZM392.095 266.014L391.63 265.648C391.514 265.648 391.514 265.648 391.397 265.648L390.815 266.014C390.699 266.014 390.699 266.135 390.815 266.135L391.281 266.5C391.397 266.5 391.397 266.5 391.514 266.5L392.095 266.135C392.212 266.135 392.212 266.014 392.095 266.014ZM393.143 265.405L392.677 265.04C392.561 265.04 392.561 265.04 392.445 265.04L391.863 265.405C391.746 265.405 391.746 265.527 391.863 265.527L392.328 265.892C392.445 265.892 392.445 265.892 392.561 265.892L393.143 265.527V265.405ZM394.074 264.797L393.608 264.431C393.492 264.431 393.492 264.431 393.376 264.431L392.794 264.797C392.677 264.797 392.677 264.918 392.794 264.918L393.259 265.283C393.376 265.283 393.376 265.283 393.492 265.283L394.074 264.918C394.19 264.918 394.19 264.797 394.074 264.797ZM395.005 264.188L394.54 263.823C394.423 263.823 394.423 263.823 394.307 263.823L393.725 264.188C393.608 264.188 393.608 264.31 393.725 264.31L394.19 264.675C394.307 264.675 394.307 264.675 394.423 264.675L395.005 264.31C395.121 264.31 395.121 264.31 395.005 264.188ZM396.053 263.58L395.587 263.215C395.471 263.215 395.471 263.215 395.354 263.215L394.772 263.58C394.656 263.58 394.656 263.701 394.772 263.701L395.238 264.066C395.354 264.066 395.354 264.066 395.471 264.066L396.053 263.701C396.053 263.701 396.053 263.701 396.053 263.58ZM396.984 263.093L396.518 262.728C396.402 262.728 396.402 262.728 396.285 262.728L395.703 263.093C395.587 263.093 395.587 263.215 395.703 263.215L396.169 263.58C396.285 263.58 396.285 263.58 396.402 263.58L396.984 263.215C397.1 263.093 397.1 263.093 396.984 263.093ZM397.915 262.484L397.449 262.119C397.333 262.119 397.333 262.119 397.216 262.119L396.634 262.484C396.518 262.484 396.518 262.606 396.634 262.606L397.1 262.971C397.216 262.971 397.216 262.971 397.333 262.971L397.915 262.606C398.031 262.606 398.031 262.484 397.915 262.484ZM398.962 261.876L398.497 261.511C398.38 261.511 398.38 261.511 398.264 261.511L397.682 261.876C397.566 261.876 397.566 261.998 397.682 261.998L398.147 262.363C398.264 262.363 398.264 262.363 398.38 262.363L398.962 261.998V261.876ZM400.242 261.146L399.777 260.781C399.66 260.781 399.66 260.781 399.544 260.781L398.613 261.389C398.497 261.389 398.497 261.511 398.613 261.511L399.079 261.876C399.195 261.876 399.195 261.876 399.311 261.876L400.242 261.267C400.242 261.146 400.242 261.146 400.242 261.146ZM403.85 262.119L403.385 261.754C403.268 261.754 403.268 261.754 403.152 261.754L402.57 262.119C402.454 262.119 402.454 262.241 402.57 262.241L403.036 262.606C403.152 262.606 403.152 262.606 403.268 262.606L403.85 262.241C403.967 262.241 403.967 262.119 403.85 262.119ZM404.898 261.511L404.432 261.146C404.316 261.146 404.316 261.146 404.199 261.146L403.617 261.511C403.501 261.511 403.501 261.632 403.617 261.632L404.083 261.998C404.199 261.998 404.199 261.998 404.316 261.998L404.898 261.632V261.511ZM405.829 260.902L405.363 260.537C405.247 260.537 405.247 260.537 405.13 260.537L404.549 260.902C404.432 260.902 404.432 261.024 404.549 261.024L405.014 261.389C405.13 261.389 405.13 261.389 405.247 261.389L405.829 261.024C405.829 261.024 405.829 261.024 405.829 260.902ZM404.781 262.606L404.316 262.241C404.199 262.241 404.199 262.241 404.083 262.241L403.501 262.606C403.385 262.606 403.385 262.728 403.501 262.728L403.967 263.093C404.083 263.093 404.083 263.093 404.199 263.093L404.781 262.728C404.781 262.728 404.781 262.728 404.781 262.606ZM405.712 262.119L405.247 261.754C405.13 261.754 405.13 261.754 405.014 261.754L404.432 262.119C404.316 262.119 404.316 262.241 404.432 262.241L404.898 262.606C405.014 262.606 405.014 262.606 405.13 262.606L405.712 262.241C405.829 262.119 405.829 262.119 405.712 262.119ZM406.76 261.511L406.294 261.146C406.178 261.146 406.178 261.146 406.062 261.146L405.48 261.511C405.363 261.511 405.363 261.632 405.48 261.632L405.945 261.998C406.062 261.998 406.061 261.998 406.178 261.998L406.76 261.632V261.511ZM392.445 266.865L391.979 266.5C391.863 266.5 391.863 266.5 391.746 266.5L390.699 267.109C390.582 267.109 390.582 267.231 390.699 267.231L391.164 267.596C391.281 267.596 391.281 267.596 391.397 267.596L392.328 266.987C392.445 266.987 392.445 266.987 392.445 266.865ZM393.376 266.379L392.91 266.014C392.794 266.014 392.794 266.014 392.677 266.014L392.095 266.379C391.979 266.379 391.979 266.5 392.095 266.5L392.561 266.865C392.677 266.865 392.677 266.865 392.794 266.865L393.376 266.5C393.376 266.379 393.376 266.379 393.376 266.379ZM394.307 265.77L393.841 265.405C393.725 265.405 393.725 265.405 393.608 265.405L393.027 265.77C392.91 265.77 392.91 265.892 393.027 265.892L393.492 266.257C393.608 266.257 393.608 266.257 393.725 266.257L394.307 265.892C394.423 265.892 394.423 265.77 394.307 265.77ZM395.354 265.162L394.889 264.797C394.772 264.797 394.772 264.797 394.656 264.797L394.074 265.162C393.958 265.162 393.958 265.283 394.074 265.283L394.54 265.648C394.656 265.648 394.656 265.648 394.772 265.648L395.354 265.283V265.162ZM396.285 264.553L395.82 264.188C395.703 264.188 395.703 264.188 395.587 264.188L395.005 264.553C394.889 264.553 394.889 264.675 395.005 264.675L395.471 265.04C395.587 265.04 395.587 265.04 395.703 265.04L396.285 264.675V264.553ZM397.216 263.945L396.751 263.58C396.634 263.58 396.634 263.58 396.518 263.58L395.936 263.945C395.82 263.945 395.82 264.066 395.936 264.066L396.402 264.431C396.518 264.431 396.518 264.431 396.634 264.431L397.216 264.066C397.333 264.066 397.333 264.066 397.216 263.945ZM398.264 263.336L397.798 262.971C397.682 262.971 397.682 262.971 397.565 262.971L396.984 263.336C396.867 263.336 396.867 263.458 396.984 263.458L397.449 263.823C397.565 263.823 397.566 263.823 397.682 263.823L398.264 263.458C398.264 263.458 398.264 263.458 398.264 263.336ZM399.195 262.849L398.729 262.484C398.613 262.484 398.613 262.484 398.497 262.484L397.915 262.849C397.798 262.849 397.798 262.971 397.915 262.971L398.38 263.336C398.497 263.336 398.497 263.336 398.613 263.336L399.195 262.971C399.195 262.849 399.195 262.849 399.195 262.849ZM400.126 262.241L399.66 261.876C399.544 261.876 399.544 261.876 399.428 261.876L398.846 262.241C398.729 262.241 398.729 262.363 398.846 262.363L399.311 262.728C399.428 262.728 399.428 262.728 399.544 262.728L400.126 262.363C400.242 262.363 400.242 262.241 400.126 262.241ZM401.173 261.632L400.708 261.267C400.591 261.267 400.591 261.267 400.475 261.267L399.893 261.632C399.777 261.632 399.777 261.754 399.893 261.754L400.359 262.119C400.475 262.119 400.475 262.119 400.591 262.119L401.173 261.754V261.632ZM392.91 267.596L392.445 267.231C392.328 267.231 392.328 267.231 392.212 267.231L391.63 267.596C391.514 267.596 391.514 267.717 391.63 267.717L392.095 268.082C392.212 268.082 392.212 268.082 392.328 268.082L392.91 267.717C393.027 267.717 393.027 267.717 392.91 267.596ZM393.958 267.109L393.492 266.744C393.376 266.744 393.376 266.744 393.259 266.744L392.677 267.109C392.561 267.109 392.561 267.231 392.677 267.231L393.143 267.596C393.259 267.596 393.259 267.596 393.376 267.596L393.958 267.231C393.958 267.109 393.958 267.109 393.958 267.109ZM394.889 266.5L394.423 266.135C394.307 266.135 394.307 266.135 394.19 266.135L393.608 266.5C393.492 266.5 393.492 266.622 393.608 266.622L394.074 266.987C394.19 266.987 394.19 266.987 394.307 266.987L394.889 266.622C394.889 266.5 394.889 266.5 394.889 266.5ZM395.82 265.892L395.354 265.527C395.238 265.527 395.238 265.527 395.121 265.527L394.54 265.892C394.423 265.892 394.423 266.014 394.54 266.014L395.005 266.379C395.121 266.379 395.121 266.379 395.238 266.379L395.82 266.014C395.936 266.014 395.936 265.892 395.82 265.892ZM394.656 268.691L394.19 268.326C394.074 268.326 394.074 268.326 393.958 268.326L393.376 268.691C393.259 268.691 393.259 268.813 393.376 268.813L393.841 269.178C393.958 269.178 393.958 269.178 394.074 269.178L394.656 268.813C394.772 268.813 394.772 268.691 394.656 268.691ZM395.703 268.082L395.238 267.717C395.121 267.717 395.121 267.717 395.005 267.717L394.423 268.082C394.307 268.082 394.307 268.204 394.423 268.204L394.889 268.569C395.005 268.569 395.005 268.569 395.121 268.569L395.703 268.204C395.703 268.204 395.703 268.204 395.703 268.082ZM396.634 267.474L396.169 267.109C396.053 267.109 396.053 267.109 395.936 267.109L395.354 267.474C395.238 267.474 395.238 267.596 395.354 267.596L395.82 267.961C395.936 267.961 395.936 267.961 396.053 267.961L396.634 267.596C396.751 267.596 396.751 267.596 396.634 267.474ZM397.565 266.987L397.1 266.622C396.984 266.622 396.984 266.622 396.867 266.622L396.285 266.987C396.169 266.987 396.169 267.109 396.285 267.109L396.751 267.474C396.867 267.474 396.867 267.474 396.984 267.474L397.565 267.109C397.682 266.987 397.682 266.987 397.565 266.987ZM403.734 263.215L403.268 262.849C403.152 262.849 403.152 262.849 403.036 262.849L402.104 263.458C401.988 263.458 401.988 263.58 402.104 263.58L402.57 263.945C402.686 263.945 402.686 263.945 402.803 263.945L403.734 263.336C403.85 263.336 403.85 263.215 403.734 263.215ZM396.867 265.283L396.402 264.918C396.285 264.918 396.285 264.918 396.169 264.918L395.587 265.283C395.471 265.283 395.471 265.405 395.587 265.405L396.053 265.77C396.169 265.77 396.169 265.77 396.285 265.77L396.867 265.405V265.283ZM397.798 264.675L397.333 264.31C397.216 264.31 397.216 264.31 397.1 264.31L396.518 264.675C396.402 264.675 396.402 264.797 396.518 264.797L396.984 265.162C397.1 265.162 397.1 265.162 397.216 265.162L397.798 264.797C397.798 264.797 397.798 264.797 397.798 264.675ZM398.729 264.066L398.264 263.701C398.147 263.701 398.147 263.701 398.031 263.701L397.449 264.066C397.333 264.066 397.333 264.188 397.449 264.188L397.915 264.553C398.031 264.553 398.031 264.553 398.147 264.553L398.729 264.188C398.846 264.188 398.846 264.188 398.729 264.066ZM399.777 263.58L399.311 263.215C399.195 263.215 399.195 263.215 399.079 263.215L398.497 263.58C398.38 263.58 398.38 263.701 398.497 263.701L398.962 264.066C399.078 264.066 399.078 264.066 399.195 264.066L399.777 263.701C399.777 263.58 399.777 263.58 399.777 263.58ZM400.708 262.971L400.242 262.606C400.126 262.606 400.126 262.606 400.01 262.606L399.428 262.971C399.311 262.971 399.311 263.093 399.428 263.093L399.893 263.458C400.01 263.458 400.01 263.458 400.126 263.458L400.708 263.093V262.971ZM401.988 262.119L401.523 261.754C401.406 261.754 401.406 261.754 401.29 261.754L400.359 262.363C400.242 262.363 400.242 262.484 400.359 262.484L400.824 262.849C400.941 262.849 400.941 262.849 401.057 262.849L401.988 262.241C402.104 262.241 402.104 262.241 401.988 262.119ZM394.19 267.961L393.725 267.596C393.608 267.596 393.608 267.596 393.492 267.596L392.561 268.204C392.445 268.204 392.445 268.326 392.561 268.326L393.027 268.691C393.143 268.691 393.143 268.691 393.259 268.691L394.19 268.082V267.961ZM395.121 267.352L394.656 266.987C394.54 266.987 394.54 266.987 394.423 266.987L393.841 267.352C393.725 267.352 393.725 267.474 393.841 267.474L394.307 267.839C394.423 267.839 394.423 267.839 394.54 267.839L395.121 267.474C395.238 267.474 395.238 267.474 395.121 267.352ZM396.053 266.865L395.587 266.5C395.471 266.5 395.471 266.5 395.354 266.5L394.772 266.865C394.656 266.865 394.656 266.987 394.772 266.987L395.238 267.352C395.354 267.352 395.354 267.352 395.471 267.352L396.053 266.987C396.169 266.865 396.169 266.865 396.053 266.865ZM397.1 266.257L396.518 265.892C396.402 265.892 396.402 265.892 396.285 265.892L395.703 266.257C395.587 266.257 395.587 266.379 395.703 266.379L396.169 266.744C396.285 266.744 396.285 266.744 396.402 266.744L396.984 266.379C397.1 266.257 397.1 266.257 397.1 266.257ZM398.031 265.648L397.565 265.283C397.449 265.283 397.449 265.283 397.333 265.283L396.751 265.648C396.634 265.648 396.634 265.77 396.751 265.77L397.216 266.135C397.333 266.135 397.333 266.135 397.449 266.135L398.031 265.77C398.147 265.77 398.147 265.648 398.031 265.648ZM398.962 265.04L398.497 264.675C398.38 264.675 398.38 264.675 398.264 264.675L397.682 265.04C397.566 265.04 397.566 265.162 397.682 265.162L398.147 265.527C398.264 265.527 398.264 265.527 398.38 265.527L398.962 265.162C399.078 265.162 399.078 265.04 398.962 265.04ZM400.01 264.431L399.544 264.066C399.428 264.066 399.428 264.066 399.311 264.066L398.729 264.431C398.613 264.431 398.613 264.553 398.729 264.553L399.195 264.918C399.311 264.918 399.311 264.918 399.428 264.918L400.01 264.553C400.01 264.553 400.01 264.553 400.01 264.431ZM400.941 263.823L400.475 263.458C400.359 263.458 400.359 263.458 400.242 263.458L399.66 263.823C399.544 263.823 399.544 263.945 399.66 263.945L400.126 264.31C400.242 264.31 400.242 264.31 400.359 264.31L400.941 263.945C401.057 263.945 401.057 263.945 400.941 263.823ZM401.872 263.336L401.406 262.971C401.29 262.971 401.29 262.971 401.173 262.971L400.591 263.336C400.475 263.336 400.475 263.458 400.591 263.458L401.057 263.823C401.173 263.823 401.173 263.823 401.29 263.823L401.872 263.458C401.988 263.336 401.988 263.336 401.872 263.336ZM402.919 262.728L402.454 262.363C402.337 262.363 402.337 262.363 402.221 262.363L401.639 262.728C401.523 262.728 401.523 262.849 401.639 262.849L402.104 263.215C402.221 263.215 402.221 263.215 402.337 263.215L402.919 262.849V262.728ZM401.173 260.537L400.708 260.172C400.591 260.172 400.591 260.172 400.475 260.172L399.893 260.537C399.777 260.537 399.777 260.659 399.893 260.659L400.359 261.024C400.475 261.024 400.475 261.024 400.591 261.024L401.173 260.659C401.29 260.659 401.29 260.537 401.173 260.537ZM402.221 259.929L401.755 259.564C401.639 259.564 401.639 259.564 401.523 259.564L400.941 259.929C400.824 259.929 400.824 260.05 400.941 260.05L401.406 260.415C401.523 260.415 401.523 260.415 401.639 260.415L402.221 260.05V259.929ZM403.152 259.32L402.686 258.955C402.57 258.955 402.57 258.955 402.454 258.955L401.872 259.32C401.755 259.32 401.755 259.442 401.872 259.442L402.337 259.807C402.454 259.807 402.454 259.807 402.57 259.807L403.152 259.442C403.268 259.442 403.268 259.32 403.152 259.32ZM404.083 259.929L403.617 259.564C403.501 259.564 403.501 259.564 403.385 259.564L402.803 259.929C402.686 259.929 402.686 260.05 402.803 260.05L403.268 260.415C403.385 260.415 403.385 260.415 403.501 260.415L404.083 260.05C404.083 259.929 404.083 259.929 404.083 259.929Z"
          fill="#DFD7E2"
        />
        <path
          d="M394.307 265.285C394.307 265.285 394.423 265.285 394.423 265.163C394.656 264.92 394.889 264.555 395.005 264.19C395.354 262.851 394.307 261.391 393.609 260.296C393.376 259.93 393.143 259.444 392.678 259.322C392.328 259.2 391.979 259.079 391.63 259.079C390.699 258.835 389.652 259.2 388.604 258.957C387.789 258.835 385.927 260.417 386.509 261.026C388.139 262.608 390.233 262.73 390.583 262.973C391.165 263.338 391.63 264.312 391.979 264.92C392.096 265.285 392.212 265.65 392.561 265.894C392.794 266.137 393.259 266.259 393.492 266.015C393.609 265.894 393.725 265.772 393.841 265.65C393.958 265.529 394.074 265.529 394.19 265.529C394.074 265.407 394.19 265.407 394.307 265.285Z"
          fill="#FABC9D"
        />
        <path
          d="M400.128 257.009C399.43 255.792 398.964 254.94 398.615 254.332C398.033 253.237 395.705 253.967 395.938 255.062C396.055 255.549 396.636 257.861 396.753 258.348C396.986 259.2 397.102 262.242 397.917 262.486C398.615 262.729 401.525 261.877 401.408 260.66C401.292 260.66 400.943 258.47 400.128 257.009Z"
          fill="#FABC9D"
        />
        <path
          d="M394.773 270.64L398.031 261.026L397.915 260.904L394.773 270.64C394.656 270.64 394.656 270.762 394.656 270.762L394.773 270.884C394.773 270.884 394.656 270.762 394.773 270.64Z"
          fill="#ADA4B8"
        />
        <path
          d="M412.229 252.142C412.229 252.142 411.996 252.142 411.88 252.263L398.612 260.295C398.263 260.417 398.03 260.782 397.914 261.147L398.03 261.269C398.147 261.026 398.496 260.66 398.729 260.417L411.996 252.385C412.113 252.142 412.346 252.142 412.229 252.142Z"
          fill="white"
        />
        <path
          d="M411.998 252.264L398.73 260.296C398.381 260.417 398.148 260.782 398.032 261.148L394.773 270.762C394.657 271.005 394.89 271.127 395.122 270.883L408.39 262.851C408.739 262.73 408.972 262.364 409.088 261.999L412.347 252.385C412.463 252.142 412.231 252.142 411.998 252.264Z"
          fill="#DFD7E2"
        />
        <path
          d="M187.371 375.176C187.371 374.933 187.254 374.689 186.905 374.324C185.276 372.986 181.319 370.308 180.62 368.726C180.155 367.509 177.478 367.509 176.081 368.361C175.383 368.726 175.267 369.943 175.383 371.16C175.499 372.62 175.383 372.986 176.431 373.594C180.737 376.393 181.319 376.758 182.133 377.123C184.228 378.219 188.069 377.854 187.371 375.176Z"
          fill="#276E91"
        />
        <path
          d="M165.607 374.324C165.491 374.202 164.792 374.08 164.559 373.959C163.745 373.594 162.232 374.08 161.301 374.202C160.719 374.202 159.904 385.277 161.534 386.494C163.047 387.711 166.538 387.954 167.236 385.763C167.585 385.033 165.956 377.001 165.607 374.324Z"
          fill="#276E91"
        />
        <path
          d="M187.371 373.838C187.371 373.595 187.254 373.351 186.905 372.986C185.276 371.648 181.319 368.97 180.62 367.388C180.155 366.171 177.478 366.171 176.081 367.023C175.383 367.388 175.267 368.605 175.383 369.822C175.499 371.283 175.383 371.648 176.431 372.256C180.737 375.055 181.319 375.42 182.133 375.785C184.228 376.881 188.069 376.637 187.371 373.838Z"
          fill="white"
        />
        <path
          d="M165.607 373.109C165.491 372.987 164.792 372.865 164.559 372.744C163.745 372.379 162.232 372.865 161.301 372.987C160.719 372.987 159.904 384.062 161.534 385.279C163.047 386.496 166.538 386.739 167.236 384.549C167.585 383.697 165.956 375.786 165.607 373.109Z"
          fill="white"
        />
        <path
          d="M180.155 322.117C178.991 321.508 169.098 322.847 167.12 322.847C166.421 322.847 164.559 322.847 163.861 323.82C162.814 325.159 161.184 331.001 161.301 336.355C161.301 338.546 161.417 341.223 161.766 347.43C161.766 347.795 161.766 348.038 161.766 348.403C161.766 350.716 161.533 353.028 160.951 355.218C160.602 356.801 160.137 359.235 160.137 361.912C160.137 364.224 160.602 373.717 160.602 373.717C160.835 376.272 166.538 375.907 166.654 373.717C166.654 373.717 168.167 361.668 168.749 358.383C169.098 356.679 169.447 355.097 169.564 354.61C170.029 352.906 172.706 338.424 172.706 338.424L174.452 346.821C174.685 347.917 174.685 349.134 174.568 350.229C174.568 350.351 174.568 350.472 174.568 350.594C174.336 353.271 174.452 356.07 174.801 358.748C174.917 359.6 175.034 360.33 175.034 361.425C175.034 362.764 175.267 366.658 175.383 367.388C175.383 369.701 181.668 369.457 181.668 367.51C181.784 362.155 181.784 358.018 181.9 354.975C182.017 352.906 182.133 348.038 182.25 346.821C182.832 337.085 181.551 322.968 180.155 322.117Z"
          fill="white"
        />
        <path
          d="M193.659 327.957C193.659 327.957 192.611 326.983 192.146 326.01C191.68 325.036 195.986 326.01 195.637 324.671C195.404 323.576 191.564 324.306 190.516 323.576C190.051 323.211 185.628 311.162 185.628 310.797C185.279 308.972 184.581 304.104 184.581 304.104C184.581 304.104 183.999 302.765 183.3 303.252C181.555 304.591 179.693 305.929 177.598 306.538C178.761 309.58 179.925 312.379 180.507 313.84C180.856 314.692 186.792 324.549 187.025 325.401C187.141 326.01 187.607 327.713 187.839 328.322C188.189 329.417 189.702 330.391 190.749 330.634C191.68 330.878 194.241 329.539 195.637 328.444L193.659 327.957Z"
          fill="#FBBD9E"
        />
        <path
          d="M177.133 309.337C177.831 311.528 186.095 308.85 186.327 307.025C186.095 303.252 181.905 289.135 177.133 290.474C177.133 290.474 170.848 291.082 177.133 309.337Z"
          fill="#1A2C87"
        />
        <path
          d="M162 299.602C158.857 303.739 162.698 309.946 163.629 313.597C164.676 317.491 163.745 320.412 163.163 324.915C162.465 331.121 181.668 331.487 181.086 324.915C181.086 324.915 181.086 324.915 181.086 324.793C180.505 318.221 180.621 311.65 181.552 305.2C181.785 303.983 181.901 302.644 182.134 301.184C182.25 300.575 182.25 299.845 182.25 299.115C182.25 298.141 182.134 297.533 182.018 296.681C181.785 295.464 179.69 292.543 178.526 292.178C174.802 290.839 163.163 298.02 162 299.602Z"
          fill="#1A2C87"
        />
        <path
          d="M176.899 301.428C176.55 302.036 175.968 302.401 175.386 302.645C174.106 303.01 172.826 302.888 171.778 302.158C170.265 301.184 169.102 299.481 169.334 297.047C169.334 296.803 169.451 296.56 169.684 296.317C170.498 295.465 171.429 294.004 172.011 291.205C172.128 290.353 173.175 289.867 173.873 290.475C176.201 292.422 178.063 296.073 178.063 297.777C177.83 298.385 177.598 300.211 176.899 301.428Z"
          fill="#F2A883"
        />
        <path
          d="M198.778 327.227L198.545 326.618L185.859 329.052L186.092 329.661C186.092 329.782 186.209 329.782 186.325 329.782L194.006 330.634C194.355 330.634 194.937 330.513 195.17 330.269L198.429 327.592C198.778 327.47 198.778 327.348 198.778 327.227Z"
          fill="white"
        />
        <path
          d="M198.311 326.983L195.052 329.661C194.703 329.904 194.238 330.148 193.888 330.026L186.207 329.174C185.858 329.174 185.858 328.931 186.207 328.687L189.466 326.01C189.815 325.766 190.281 325.523 190.63 325.645L198.311 326.497C198.66 326.497 198.66 326.74 198.311 326.983Z"
          fill="#2035A4"
        />
        <path
          d="M191.331 330.393C190.866 330.393 190.4 330.028 190.168 329.663C190.051 329.419 189.818 329.176 189.702 328.932C190.051 329.054 190.75 329.054 191.099 329.054C191.564 329.054 192.612 328.324 191.797 328.081C191.099 327.837 189.353 327.229 188.305 326.742C188.073 326.62 187.607 326.377 187.374 326.377C187.142 326.255 186.792 326.255 186.56 326.377C185.978 326.498 185.629 326.62 185.163 326.498C181.788 324.795 174.572 319.927 172.826 318.831C172.594 318.71 172.361 318.345 172.245 317.98C171.895 316.154 171.663 314.207 171.43 312.26C171.313 311.408 170.382 311.043 169.8 311.53C168.055 312.868 166.193 314.207 164.098 314.815C165.261 317.858 166.425 320.657 167.007 322.117C167.356 322.969 167.938 323.578 168.637 324.064C171.546 325.89 179.577 328.202 183.301 329.541C184.581 330.149 186.676 332.583 187.724 332.583C189.237 332.583 192.612 331.975 193.659 330.636L191.331 330.393Z"
          fill="#FBBD9E"
        />
        <path
          d="M163.399 317.614C164.097 319.804 172.36 317.127 172.593 315.301C172.36 311.529 168.17 297.412 163.399 298.75C163.399 298.629 157.114 299.237 163.399 317.614Z"
          fill="#1A2C87"
        />
        <path
          d="M180.51 286.946C179.346 284.999 177.833 284.025 175.622 283.903C175.04 283.903 173.992 284.39 173.527 284.634C171.432 285.485 171.083 289.015 170.966 291.084C170.85 293.639 170.966 296.56 172.596 298.507C175.738 302.401 179.346 302.888 179.695 300.454C179.695 300.211 179.695 299.967 179.928 299.846C180.044 299.846 180.044 299.846 180.161 299.724C180.51 299.602 180.626 299.116 180.626 298.751C180.626 298.385 180.626 298.02 180.51 297.777C180.51 297.534 180.394 297.29 180.394 297.047C180.51 296.438 180.859 296.073 181.208 295.586C181.907 294.369 181.79 292.544 181.674 291.327C181.674 289.745 181.325 288.284 180.51 286.946Z"
          fill="#FBBD9E"
        />
        <path
          d="M180.972 285.728C178.761 283.173 175.618 282.929 173.407 284.268C167.821 285.607 167.937 292.3 171.196 296.681C170.847 295.586 172.36 294.856 172.476 295.221C173.058 296.316 173.174 297.046 173.756 297.168C174.222 297.168 173.873 296.194 175.269 295.586C175.502 295.464 179.575 295.464 181.438 293.76C181.554 293.639 181.67 293.517 181.787 293.274C182.252 292.422 183.649 288.892 180.972 285.728Z"
          fill="#2035A4"
        />
        <path
          d="M172.128 294.612C171.197 293.517 169.568 294.977 172.128 298.02C172.361 298.385 172.71 298.628 173.059 298.385C173.99 298.02 172.71 295.342 172.128 294.612Z"
          fill="#FBBD9E"
        />
        <path
          d="M382.089 388.564C382.089 387.712 381.624 386.982 380.926 386.495C380.693 386.373 380.46 386.13 380.227 385.886C378.831 384.548 376.27 382.6 375.921 382.479C373.361 381.384 370.684 383.331 371.382 384.548C372.313 385.886 377.434 391.119 377.9 391.363C379.413 392.215 382.206 391.484 382.089 390.146C382.089 389.781 382.089 389.172 382.089 388.564Z"
          fill="#276E91"
        />
        <path
          d="M368.123 396.596C367.891 396.109 363.934 395.501 363.934 395.501C363.235 395.379 361.49 395.136 360.558 395.136C357.998 395.014 355.321 395.014 354.506 395.744C353.925 396.231 353.808 396.961 354.157 397.691C354.739 398.908 356.136 400.247 365.912 401.951C366.96 402.194 367.891 401.951 368.473 401.586C368.938 401.342 369.404 400.855 369.171 400.003C368.705 398.908 368.24 396.961 368.123 396.596Z"
          fill="#276E91"
        />
        <path
          d="M382.089 387.105C382.089 386.253 381.624 385.523 380.926 385.036C380.693 384.914 380.46 384.671 380.227 384.427C378.831 383.089 376.27 381.142 375.921 381.02C373.361 379.925 370.684 381.872 371.382 383.089C372.313 384.427 377.434 389.66 377.9 389.904C379.413 390.756 382.206 390.025 382.089 388.687C382.089 388.2 382.089 387.713 382.089 387.105Z"
          fill="white"
        />
        <path
          d="M368.123 395.137C367.891 394.65 363.934 394.042 363.934 394.042C363.235 393.92 361.49 393.677 360.558 393.677C357.998 393.555 355.321 393.555 354.506 394.285C353.925 394.772 353.808 395.502 354.157 396.232C354.739 397.449 356.136 398.788 365.912 400.492C366.96 400.735 367.891 400.492 368.473 400.127C368.938 399.883 369.404 399.396 369.171 398.544C368.705 397.449 368.24 395.502 368.123 395.137Z"
          fill="white"
        />
        <path
          d="M362.07 341.711C361.837 343.901 361.139 366.659 361.255 367.876C361.488 370.431 361.488 375.908 361.488 379.802C361.488 384.792 361.837 395.014 361.837 395.014C361.953 397.448 367.54 397.935 368.122 395.745L370.1 380.411C370.682 377.003 369.984 374.204 369.984 370.797C370.333 366.294 373.359 352.907 375.221 345.24C375.454 344.145 374.988 343.049 374.407 342.076C371.846 337.938 363.35 336.964 362.07 341.711Z"
          fill="#2035A4"
        />
        <path
          d="M382.087 363.251C381.272 358.383 382.669 353.028 382.552 348.16C382.436 345.361 382.32 340.737 381.272 337.573C381.156 337.329 381.039 337.329 380.807 337.451C377.199 339.277 374.056 339.033 372.427 342.076L370.914 345.605C371.496 349.986 372.194 354.854 373.358 359.722C373.824 361.912 374.056 364.103 374.638 366.902C374.871 368.119 375.104 369.458 375.22 370.675C375.569 373.23 375.569 374.569 375.569 374.691C375.686 377.246 376.384 379.437 376.5 385.157C376.733 387.347 381.971 387.956 381.971 386.009C381.971 384.305 382.32 382.114 382.552 381.019C383.484 376.394 383.949 373.352 383.251 368.727C382.902 366.415 382.436 365.442 382.087 363.251Z"
          fill="#2035A4"
        />
        <path
          d="M343.101 317.25C342.984 317.128 342.868 317.006 342.868 316.885C342.752 316.154 342.519 313.842 344.148 311.408C345.661 309.096 347.407 312.99 347.407 312.99L345.428 319.075L343.101 317.25Z"
          fill="#FCBE9F"
        />
        <path
          d="M345.776 317.858L340.073 303.985C339.957 303.741 340.073 303.498 340.19 303.376L347.871 298.387H347.987H347.638H347.522L339.84 303.376C339.724 303.498 339.608 303.741 339.724 303.985L345.427 317.858C345.543 318.102 345.66 318.102 345.776 318.102H346.125C346.009 318.102 345.892 318.102 345.776 317.858Z"
          fill="white"
        />
        <path
          d="M354.155 312.382L348.452 298.508C348.336 298.265 348.103 298.143 347.987 298.265L340.305 303.254C340.189 303.376 340.072 303.619 340.189 303.863L345.892 317.736C346.008 317.98 346.241 318.101 346.357 317.98L354.038 312.99C354.155 312.99 354.155 312.625 354.155 312.382Z"
          fill="#2035A4"
        />
        <path
          d="M368.123 317.979C366.144 317.006 362.653 315.058 361.838 314.328L359.627 311.529C359.161 310.921 358.579 310.556 357.881 310.434C354.738 309.947 355.088 310.069 353.924 310.556C353.342 310.677 352.876 311.042 352.76 311.286C352.527 311.651 351.945 311.773 351.596 312.016C351.247 312.259 351.131 312.746 351.363 313.111C351.596 313.355 351.945 313.355 352.294 313.233C355.088 312.868 357.299 313.841 357.299 314.207C357.299 314.45 356.601 314.693 354.971 314.815C354.622 314.815 354.273 314.693 354.04 314.937C353.807 315.058 353.575 315.545 353.807 315.789C353.924 315.91 353.924 315.91 354.04 315.91C354.855 316.275 355.786 316.154 356.601 316.275C357.299 316.275 357.997 316.519 358.579 316.884C359.161 317.249 359.743 317.614 360.325 318.101C361.605 319.074 367.191 323.699 367.657 323.942C367.541 321.874 368.123 320.048 368.123 317.979Z"
          fill="#FCBE9F"
        />
        <path
          d="M359.859 315.546C357.532 317.858 352.644 324.916 352.644 324.916C352.644 324.916 347.29 318.953 345.544 316.641C345.661 315.059 345.544 314.329 346.475 312.99C347.057 312.138 346.359 311.773 345.777 312.138C344.264 313.112 343.449 313.842 342.867 315.546C342.751 316.032 342.635 317.249 343.449 318.953C344.613 321.752 350.665 331.975 352.993 331.975C355.902 331.975 362.187 324.43 363.002 323.456C364.049 322.239 360.441 314.937 359.859 315.546Z"
          fill="#FCBE9F"
        />
        <path
          d="M360.91 313.476C358 314.571 357.884 317.492 358.582 319.561C358.815 320.291 359.048 320.048 359.397 320.656C361.608 325.767 362.539 331.487 362.306 337.085C362.19 339.154 362.074 340.98 361.957 341.953C361.259 348.16 383.139 347.186 381.51 338.546C380.695 334.651 380.113 328.566 381.277 325.159C382.324 321.63 383.256 318.1 383.954 314.571C385.234 308.121 377.32 309.46 375.574 309.582C373.712 309.582 364.751 311.894 360.91 313.476Z"
          fill="white"
        />
        <path
          d="M359.507 314.207C358.227 315.424 355.201 319.683 353.804 321.63C352.64 323.213 357.994 329.054 360.089 327.715C360.904 327.229 364.512 322.239 365.093 321.63C368.469 317.736 362.649 311.164 359.507 314.207Z"
          fill="white"
        />
        <path
          d="M370.447 313.719C373.24 313.232 375.451 311.894 375.218 310.677C375.218 310.312 374.636 309.947 374.171 309.703C371.61 310.19 365.558 311.772 365.209 312.015C364.977 312.259 364.977 312.502 364.977 312.624C365.209 313.719 367.537 314.206 370.447 313.719Z"
          fill="#FBBD9E"
        />
        <path
          d="M363.93 299.36C363.93 299.603 362.65 301.064 362.534 301.307C362.301 301.672 362.883 302.402 362.883 302.524C362.883 303.011 362.766 303.376 362.65 303.863C362.417 304.715 362.301 305.688 362.65 306.418C363.116 307.27 364.396 307.392 364.978 308.244C365.21 308.487 365.327 308.852 365.443 309.217L366.025 311.895C366.723 314.207 374.754 312.017 374.172 310.313C373.706 309.217 373.59 307.757 373.823 307.514C374.288 306.905 374.987 305.932 375.569 304.593C376.965 301.307 376.034 297.413 373.125 295.466C372.077 294.735 370.797 294.37 369.284 294.249C368.004 294.127 366.025 294.492 364.861 296.439C364.396 297.169 364.163 298.143 363.93 299.36Z"
          fill="#FBBD9E"
        />
        <path
          d="M366.375 300.577C366.724 300.82 366.84 301.429 366.607 301.794C366.375 302.402 366.025 303.011 366.142 303.254C366.142 303.376 366.375 303.498 366.491 303.498C366.607 303.498 366.724 303.376 366.84 303.254C367.888 302.037 369.517 303.498 367.888 305.445C366.142 307.514 367.189 308.852 368.935 309.461C371.146 310.191 373.94 308.852 375.103 306.662C375.918 305.201 376.5 303.498 376.733 301.794C377.198 296.926 373.59 293.153 368.586 293.031C364.512 292.91 364.28 296.317 364.396 297.534C364.512 298.751 365.676 299.847 366.375 300.577Z"
          fill="#2035A4"
        />
        <path
          d="M97.5355 331.124C97.7683 331.854 102.54 336.6 102.889 336.965C105.799 339.399 109.29 337.087 107.312 334.409C106.73 333.679 101.958 327.959 101.609 327.594C101.376 327.351 101.027 326.986 100.678 326.864C99.8632 326.499 99.0485 326.864 98.2338 327.229C96.8372 327.959 97.4191 330.637 97.5355 331.124Z"
          fill="white"
        />
        <path
          d="M108.012 335.627C107.546 337.087 105.218 337.696 103.123 335.992C102.774 335.627 98.0026 330.881 97.7698 330.15C97.6534 329.907 97.537 329.299 97.537 328.568C97.3043 329.542 97.6534 330.759 97.6534 331.124C97.8862 331.854 102.658 336.6 103.007 336.966C105.451 339.034 108.361 337.696 108.012 335.627Z"
          fill="#276E91"
        />
        <path
          d="M101.492 331.002C102.423 331.245 103.122 330.88 102.889 330.028C102.773 329.541 102.074 328.69 101.842 328.081L101.609 326.499C101.26 326.256 98.4664 326.012 98.1173 326.134C98.1173 326.134 98.0009 327.108 98.0009 328.203C97.8845 328.811 98.9319 330.393 101.492 331.002Z"
          fill="#FBBD9E"
        />
        <path
          d="M97.0599 341.712C97.409 342.442 102.646 346.58 102.995 346.945C106.138 349.014 109.397 346.336 107.185 343.902C106.603 343.172 101.133 338.061 100.784 337.818C100.435 337.574 100.086 337.331 99.7367 337.209C98.8056 336.966 98.1073 337.452 97.2927 337.818C96.0124 338.669 96.8271 341.225 97.0599 341.712Z"
          fill="white"
        />
        <path
          d="M107.887 344.999C107.538 346.459 105.326 347.433 102.999 345.972C102.533 345.729 97.2957 341.469 97.063 340.739C96.9466 340.496 96.7138 339.887 96.7138 339.157C96.5975 340.131 97.063 341.348 97.1794 341.591C97.5285 342.321 102.766 346.459 103.115 346.824C105.675 348.65 108.352 346.946 107.887 344.999Z"
          fill="#276E91"
        />
        <path
          d="M101.948 340.738C102.297 340.616 102.53 340.13 102.297 339.764C101.831 339.034 100.784 338.182 100.551 337.574C100.435 337.209 100.435 336.844 100.318 336.6C100.086 335.262 98.9217 335.505 97.9906 335.992C97.4087 336.357 97.0595 336.844 96.9432 337.574C96.8268 338.182 97.0595 339.156 97.6415 339.643C99.0381 340.616 100.784 341.103 101.948 340.738Z"
          fill="#FBBD9E"
        />
        <path
          d="M86.8242 262C86.8242 262.608 86.9406 263.339 86.9406 263.947C87.5225 268.45 90.083 278.551 90.083 278.551L96.3677 292.546C96.9496 293.52 99.6264 292.424 99.1609 290.964C98.2298 287.8 94.8547 275.265 94.8547 275.265C94.8547 275.265 93.3417 261.635 93.1089 260.661C92.6434 259.323 91.5959 256.767 89.3847 257.132C87.2898 257.497 86.9406 260.174 86.8242 262Z"
          fill="white"
        />
        <path
          d="M93.6828 271.25C92.2862 267.721 87.98 265.287 89.6093 257.498C87.1653 256.768 74.2467 264.557 73.1992 267.356C73.1992 267.356 77.1563 276.483 78.0873 282.325C78.5529 285.245 77.7382 288.166 76.9235 290.965C76.8071 295.711 91.2387 293.521 91.1223 287.679C91.0059 285.124 91.1223 281.229 91.1223 279.526C91.1223 278.43 92.4025 276.605 92.8681 275.753C94.0319 273.928 94.2647 272.589 93.6828 271.25Z"
          fill="#2035A4"
        />
        <path
          d="M74.9456 300.093C75.5275 303.987 77.0405 305.204 79.9501 307.76C91.9376 318.47 92.9851 317.496 92.7523 318.956C92.1704 322.242 92.2868 325.528 93.4506 328.692C94.8472 332.221 96.0111 333.56 96.593 337.089C97.0585 338.671 101.365 337.941 101.016 336.603C99.619 330.396 99.619 326.867 99.619 320.173C99.619 318.104 99.619 315.792 98.9207 313.967C97.8732 311.411 91.7049 306.178 90.1919 303.744C90.1919 303.744 98.5715 307.517 103.227 312.506C100.783 318.47 100.084 319.565 97.7568 326.867C97.5241 328.814 101.365 329.909 102.063 328.449C103.576 324.798 108.115 317.861 111.025 314.088C112.305 312.385 111.025 309.707 109.744 308.003C109.279 307.395 108.697 306.665 108.231 306.178C104.74 302.162 95.4291 292.913 93.567 291.087C92.6359 289.505 91.7049 287.68 91.3557 286.463C91.7049 290.844 81.3467 293.886 77.5061 289.505C75.4111 293.278 74.4801 297.051 74.9456 300.093Z"
          fill="#2035A4"
        />
        <path
          d="M72.1562 270.884C72.1562 271.493 72.2726 272.223 72.2726 272.831C72.7382 275.752 73.902 280.985 74.7167 284.271C75.1822 286.218 76.3461 288.044 77.859 289.261L88.3336 297.414C89.2647 298.023 91.1268 295.832 90.5449 295.102C87.6353 292.425 80.1867 284.271 80.1867 284.271C80.1867 284.271 78.6737 270.641 78.441 269.667C77.9754 268.328 76.928 265.773 74.7167 266.138C72.6218 266.381 72.2726 269.18 72.1562 270.884Z"
          fill="white"
        />
        <path
          d="M80.7688 243.502C78.3247 243.259 75.6479 245.449 75.4151 248.126C75.2987 249.952 76.3462 251.169 77.3937 251.777C78.9066 252.751 79.2558 251.777 80.4196 251.412C81.3507 251.047 84.9586 247.518 84.7258 246.788C84.7258 246.788 84.0275 243.745 80.7688 243.502Z"
          fill="#2035A4"
        />
        <path
          d="M79.7184 263.338C80.0675 265.894 86.1195 268.45 86.3523 264.677C86.3523 263.46 86.4686 262.365 86.7014 261.148C87.2833 258.957 86.9342 256.767 84.0246 256.28C80.3003 255.671 81.3478 257.862 81.2314 259.444C80.8822 262 79.602 262.73 79.7184 263.338Z"
          fill="#F3A984"
        />
        <path
          d="M77.9724 249.344C77.5068 250.074 77.3904 251.048 77.5068 251.899C77.856 255.915 82.8605 262.244 86.4684 263.826C89.4943 265.164 89.7271 260.54 89.9599 256.524C89.9599 255.672 89.9599 254.333 89.9599 253.238C89.8435 250.804 88.6797 248.492 86.7011 247.275C85.1881 246.301 83.326 245.936 81.5803 246.788C80.8819 247.031 78.3215 248.614 77.9724 249.344Z"
          fill="#FBBD9E"
        />
        <path
          d="M77.1598 251.047C76.3451 255.185 80.5349 258.714 80.5349 258.714C82.1643 259.444 81.1168 254.576 83.2117 254.698C88.449 254.941 89.1473 252.629 89.3801 252.142C89.4964 251.899 89.7292 252.264 89.7292 252.264C89.3801 244.84 78.5564 243.137 77.1598 251.047Z"
          fill="#2035A4"
        />
        <path
          d="M79.0214 257.498C79.3706 258.35 81.3491 260.053 81.8147 259.932C82.3966 259.81 81.8147 258.106 81.6983 257.62C81.1164 255.551 78.3231 255.794 79.0214 257.498Z"
          fill="#FBBD9E"
        />
        <path
          d="M94.9609 308.489L110.324 298.996V299.361L94.9609 308.854V308.489Z"
          fill="url(#paint14_linear_1926_44029)"
        />
        <path
          d="M84.0234 301.674L99.5025 292.182L110.326 298.753L94.9635 308.246L84.0234 301.674Z"
          fill="#ECE7E2"
        />
        <path
          opacity="0.2"
          d="M98.8012 297.9L93.7967 300.942C93.6804 301.064 93.4476 301.064 93.4476 300.942L90.1889 298.995C90.0725 298.874 90.0725 298.874 90.1889 298.752L95.1933 295.709C95.3097 295.588 95.5425 295.588 95.5425 295.709L98.8012 297.657C98.9176 297.657 98.9176 297.778 98.8012 297.9Z"
          fill="#C9C6C1"
        />
        <path
          d="M95.0787 295.709C95.1951 295.588 95.4279 295.588 95.4279 295.709L98.6866 297.657C98.6866 297.657 98.803 297.657 98.803 297.778C98.803 297.778 98.803 297.657 98.6866 297.657L95.4279 295.709C95.3115 295.588 95.0787 295.588 95.0787 295.709Z"
          fill="#C9C6C1"
        />
        <path
          d="M91.3581 304.228L90.6598 304.594C90.5434 304.594 90.5434 304.594 90.427 304.594L89.8451 304.228C89.7287 304.228 89.7287 304.107 89.8451 304.107L90.5434 303.742C90.6598 303.742 90.6598 303.742 90.7762 303.742L91.3581 304.107V304.228ZM92.4055 303.498L91.8236 303.133C91.7072 303.133 91.7072 303.133 91.5909 303.133L90.8926 303.498C90.7762 303.498 90.7762 303.62 90.8926 303.62L91.4745 303.985C91.5909 303.985 91.5909 303.985 91.7072 303.985L92.4055 303.62C92.4055 303.498 92.4055 303.498 92.4055 303.498ZM93.453 302.768L92.8711 302.403C92.7547 302.403 92.7547 302.403 92.6383 302.403L91.94 302.768C91.8236 302.768 91.8236 302.89 91.94 302.89L92.5219 303.255C92.6383 303.255 92.6383 303.255 92.7547 303.255L93.453 302.89C93.5694 302.89 93.5694 302.89 93.453 302.768ZM94.5004 302.16L93.9185 301.795C93.8021 301.795 93.8022 301.795 93.6858 301.795L92.9875 302.16C92.8711 302.16 92.8711 302.281 92.9875 302.281L93.5694 302.646C93.6858 302.646 93.6858 302.646 93.8021 302.646L94.5004 302.281C94.6168 302.281 94.6168 302.16 94.5004 302.16ZM95.6643 301.429L95.0824 301.186C94.966 301.186 94.966 301.186 94.8496 301.186L94.1513 301.551C94.0349 301.551 94.0349 301.673 94.1513 301.673L94.7332 302.038C94.8496 302.038 94.8496 302.038 94.966 302.038L95.6643 301.673C95.6643 301.551 95.6643 301.551 95.6643 301.429ZM96.7117 300.821L96.1298 300.456C96.0134 300.456 96.0134 300.456 95.897 300.456L95.1987 300.821C95.0824 300.821 95.0824 300.943 95.1987 300.943L95.7807 301.308C95.8971 301.308 95.8971 301.308 96.0134 301.308L96.7117 300.943V300.821ZM97.7592 300.212L97.1773 299.847C97.0609 299.847 97.0609 299.847 96.9445 299.847L96.2462 300.212C96.1298 300.212 96.1298 300.334 96.2462 300.334L96.8281 300.699C96.9445 300.699 96.9445 300.699 97.0609 300.699L97.7592 300.334C97.8756 300.212 97.8756 300.212 97.7592 300.212ZM98.8066 299.482L98.2247 299.117C98.1083 299.117 98.1083 299.117 97.992 299.117L97.2937 299.482C97.1773 299.482 97.1773 299.604 97.2937 299.604L97.8756 299.969C97.992 299.969 97.992 299.969 98.1083 299.969L98.8066 299.604C98.923 299.604 98.923 299.482 98.8066 299.482ZM99.9705 298.874L99.3886 298.509C99.2722 298.509 99.2722 298.509 99.1558 298.509L98.4575 298.874C98.3411 298.874 98.3411 298.995 98.4575 298.995L99.0394 299.361C99.1558 299.361 99.1558 299.361 99.2722 299.361L99.9705 298.995V298.874ZM101.367 298.022L100.785 297.657C100.669 297.657 100.669 297.657 100.552 297.657L99.505 298.265C99.3886 298.265 99.3886 298.387 99.505 298.387L100.087 298.752C100.203 298.752 100.203 298.752 100.32 298.752L101.367 298.144C101.367 298.022 101.367 298.022 101.367 298.022ZM105.441 299.117L104.859 298.752C104.742 298.752 104.742 298.752 104.626 298.752L103.928 299.117C103.811 299.117 103.811 299.239 103.928 299.239L104.509 299.604C104.626 299.604 104.626 299.604 104.742 299.604L105.441 299.239V299.117ZM106.488 298.387L105.906 298.022C105.79 298.022 105.79 298.022 105.673 298.022L104.975 298.387C104.859 298.387 104.859 298.509 104.975 298.509L105.557 298.874C105.673 298.874 105.673 298.874 105.79 298.874L106.488 298.509C106.604 298.509 106.604 298.509 106.488 298.387ZM107.535 297.778L106.954 297.413C106.837 297.413 106.837 297.413 106.721 297.413L106.022 297.778C105.906 297.778 105.906 297.9 106.022 297.9L106.604 298.265C106.721 298.265 106.721 298.265 106.837 298.265L107.535 297.9C107.652 297.9 107.652 297.778 107.535 297.778ZM106.372 299.726L105.79 299.361C105.673 299.361 105.673 299.361 105.557 299.361L104.859 299.726C104.742 299.726 104.742 299.847 104.859 299.847L105.441 300.212C105.557 300.212 105.557 300.212 105.673 300.212L106.372 299.847C106.488 299.726 106.488 299.726 106.372 299.726ZM107.535 298.995L106.954 298.63C106.837 298.63 106.837 298.63 106.721 298.63L106.022 298.995C105.906 298.995 105.906 299.117 106.022 299.117L106.604 299.482C106.721 299.482 106.721 299.482 106.837 299.482L107.535 299.117V298.995ZM108.583 298.387L108.001 298.022C107.885 298.022 107.885 298.022 107.768 298.022L107.07 298.387C106.954 298.387 106.954 298.509 107.07 298.509L107.652 298.874C107.768 298.874 107.768 298.874 107.885 298.874L108.583 298.509V298.387ZM92.6383 304.472L92.0564 304.107C91.94 304.107 91.94 304.107 91.8236 304.107L90.7762 304.715C90.6598 304.715 90.6598 304.837 90.7762 304.837L91.3581 305.202C91.4745 305.202 91.4745 305.202 91.5909 305.202L92.6383 304.594C92.7547 304.594 92.7547 304.472 92.6383 304.472ZM93.6858 303.863L93.1038 303.498C92.9875 303.498 92.9875 303.498 92.8711 303.498L92.1728 303.863C92.0564 303.863 92.0564 303.985 92.1728 303.985L92.7547 304.35C92.8711 304.35 92.8711 304.35 92.9875 304.35L93.6858 303.985C93.8022 303.985 93.8022 303.863 93.6858 303.863ZM94.8496 303.133L94.2677 302.768C94.1513 302.768 94.1513 302.768 94.0349 302.768L93.3366 303.133C93.2202 303.133 93.2202 303.255 93.3366 303.255L93.9185 303.62C94.0349 303.62 94.0349 303.62 94.1513 303.62L94.8496 303.255C94.8496 303.255 94.8496 303.255 94.8496 303.133ZM95.897 302.525L95.3151 302.16C95.1987 302.16 95.1988 302.16 95.0824 302.16L94.3841 302.525C94.2677 302.525 94.2677 302.646 94.3841 302.646L94.966 303.011C95.0824 303.011 95.0824 303.011 95.1987 303.011L95.897 302.646C96.0134 302.646 96.0134 302.525 95.897 302.525ZM96.9445 301.795L96.3626 301.429C96.2462 301.429 96.2462 301.429 96.1298 301.429L95.4315 301.795C95.3151 301.795 95.3151 301.916 95.4315 301.916L96.0134 302.281C96.1298 302.281 96.1298 302.281 96.2462 302.281L96.9445 301.916C97.0609 301.916 97.0609 301.916 96.9445 301.795ZM98.1083 301.186L97.5264 300.821C97.41 300.821 97.41 300.821 97.2937 300.821L96.5954 301.186C96.479 301.186 96.479 301.308 96.5954 301.308L97.1773 301.673C97.2937 301.673 97.2937 301.673 97.41 301.673L98.1083 301.308V301.186ZM99.1558 300.578L98.5739 300.212C98.4575 300.212 98.4575 300.212 98.3411 300.212L97.6428 300.578C97.5264 300.578 97.5264 300.699 97.6428 300.699L98.2247 301.064C98.3411 301.064 98.3411 301.064 98.4575 301.064L99.1558 300.699C99.1558 300.578 99.1558 300.578 99.1558 300.578ZM100.203 299.847L99.6213 299.482C99.505 299.482 99.5049 299.482 99.3886 299.482L98.6903 299.847C98.5739 299.847 98.5739 299.969 98.6903 299.969L99.2722 300.334C99.3886 300.334 99.3886 300.334 99.505 300.334L100.203 299.969C100.32 299.969 100.32 299.969 100.203 299.847ZM101.251 299.239L100.669 298.874C100.552 298.874 100.552 298.874 100.436 298.874L99.7377 299.239C99.6213 299.239 99.6213 299.361 99.7377 299.361L100.32 299.726C100.436 299.726 100.436 299.726 100.552 299.726L101.251 299.361C101.367 299.361 101.367 299.239 101.251 299.239ZM102.415 298.509L101.833 298.144C101.716 298.144 101.716 298.144 101.6 298.144L100.902 298.509C100.785 298.509 100.785 298.63 100.902 298.63L101.483 298.995C101.6 298.995 101.6 298.995 101.716 298.995L102.415 298.63C102.415 298.63 102.415 298.63 102.415 298.509ZM93.3366 305.324L92.7547 304.959C92.6383 304.959 92.6383 304.959 92.5219 304.959L91.8236 305.324C91.7072 305.324 91.7072 305.445 91.8236 305.445L92.4055 305.811C92.5219 305.811 92.5219 305.811 92.6383 305.811L93.3366 305.445V305.324ZM94.3841 304.594L93.8021 304.228C93.6858 304.228 93.6858 304.228 93.5694 304.228L92.8711 304.594C92.7547 304.594 92.7547 304.715 92.8711 304.715L93.453 305.08C93.5694 305.08 93.5694 305.08 93.6858 305.08L94.3841 304.715C94.3841 304.715 94.3841 304.715 94.3841 304.594ZM95.4315 303.985L94.8496 303.62C94.7332 303.62 94.7332 303.62 94.6168 303.62L93.9185 303.985C93.8021 303.985 93.8021 304.107 93.9185 304.107L94.5004 304.472C94.6168 304.472 94.6168 304.472 94.7332 304.472L95.4315 304.107C95.5479 304.107 95.5479 303.985 95.4315 303.985ZM96.479 303.255L95.897 302.89C95.7807 302.89 95.7807 302.89 95.6643 302.89L94.966 303.255C94.8496 303.255 94.8496 303.377 94.966 303.377L95.5479 303.742C95.6643 303.742 95.6643 303.742 95.7807 303.742L96.479 303.377C96.5954 303.377 96.5954 303.377 96.479 303.255ZM95.1987 306.419L94.6168 306.054C94.5004 306.054 94.5005 306.054 94.3841 306.054L93.6858 306.419C93.5694 306.419 93.5694 306.541 93.6858 306.541L94.2677 306.906C94.3841 306.906 94.3841 306.906 94.5004 306.906L95.1987 306.541C95.3151 306.541 95.3151 306.541 95.1987 306.419ZM96.3626 305.811L95.7807 305.445C95.6643 305.445 95.6643 305.445 95.5479 305.445L94.8496 305.811C94.7332 305.811 94.7332 305.932 94.8496 305.932L95.4315 306.297C95.5479 306.297 95.5479 306.297 95.6643 306.297L96.3626 305.932V305.811ZM97.41 305.08L96.8281 304.715C96.7117 304.715 96.7117 304.715 96.5954 304.715L95.897 305.08C95.7807 305.08 95.7807 305.202 95.897 305.202L96.479 305.567C96.5954 305.567 96.5954 305.567 96.7117 305.567L97.41 305.202C97.41 305.202 97.41 305.202 97.41 305.08ZM98.4575 304.472L97.8756 304.107C97.7592 304.107 97.7592 304.107 97.6428 304.107L96.9445 304.472C96.8281 304.472 96.8281 304.594 96.9445 304.594L97.5264 304.959C97.6428 304.959 97.6428 304.959 97.7592 304.959L98.4575 304.594C98.5739 304.594 98.5739 304.472 98.4575 304.472ZM105.324 300.334L104.742 299.969C104.626 299.969 104.626 299.969 104.509 299.969L103.462 300.578C103.346 300.578 103.346 300.699 103.462 300.699L104.044 301.064C104.16 301.064 104.16 301.064 104.277 301.064L105.324 300.456V300.334ZM97.6428 302.646L97.0609 302.281C96.9445 302.281 96.9445 302.281 96.8281 302.281L96.1298 302.646C96.0134 302.646 96.0134 302.768 96.1298 302.768L96.7117 303.133C96.8281 303.133 96.8281 303.133 96.9445 303.133L97.6428 302.768V302.646ZM98.6903 302.038L98.1083 301.673C97.992 301.673 97.992 301.673 97.8756 301.673L97.1773 302.038C97.0609 302.038 97.0609 302.16 97.1773 302.16L97.7592 302.525C97.8756 302.525 97.8756 302.525 97.992 302.525L98.6903 302.16C98.6903 302.038 98.6903 302.038 98.6903 302.038ZM99.7377 301.308L99.1558 300.943C99.0394 300.943 99.0394 300.943 98.923 300.943L98.2247 301.308C98.1083 301.308 98.1083 301.429 98.2247 301.429L98.8066 301.795C98.923 301.795 98.923 301.795 99.0394 301.795L99.7377 301.429C99.8541 301.429 99.8541 301.429 99.7377 301.308ZM100.785 300.699L100.203 300.334C100.087 300.334 100.087 300.334 99.9705 300.334L99.2722 300.699C99.1558 300.699 99.1558 300.821 99.2722 300.821L99.8541 301.186C99.9705 301.186 99.9705 301.186 100.087 301.186L100.785 300.821C100.902 300.821 100.902 300.699 100.785 300.699ZM101.949 299.969L101.367 299.604C101.251 299.604 101.251 299.604 101.134 299.604L100.436 299.969C100.32 299.969 100.32 300.091 100.436 300.091L101.018 300.456C101.134 300.456 101.134 300.456 101.251 300.456L101.949 300.091C101.949 300.091 101.949 300.091 101.949 299.969ZM103.346 299.117L102.764 298.752C102.647 298.752 102.647 298.752 102.531 298.752L101.483 299.361C101.367 299.361 101.367 299.482 101.483 299.482L102.065 299.847C102.182 299.847 102.182 299.847 102.298 299.847L103.346 299.239C103.346 299.239 103.346 299.239 103.346 299.117ZM94.6168 305.689L94.0349 305.324C93.9185 305.324 93.9185 305.324 93.8021 305.324L92.7547 305.932C92.6383 305.932 92.6383 306.054 92.7547 306.054L93.3366 306.419C93.453 306.419 93.453 306.419 93.5694 306.419L94.6168 305.811C94.7332 305.811 94.7332 305.689 94.6168 305.689ZM95.6643 304.959L95.0824 304.594C94.966 304.594 94.966 304.594 94.8496 304.594L94.1513 304.959C94.0349 304.959 94.0349 305.08 94.1513 305.08L94.7332 305.445C94.8496 305.445 94.8496 305.445 94.966 305.445L95.6643 305.08C95.7807 305.08 95.7807 305.08 95.6643 304.959ZM96.8281 304.35L96.2462 303.985C96.1298 303.985 96.1298 303.985 96.0134 303.985L95.3151 304.35C95.1987 304.35 95.1987 304.472 95.3151 304.472L95.897 304.837C96.0134 304.837 96.0134 304.837 96.1298 304.837L96.8281 304.472V304.35ZM97.8756 303.62L97.2937 303.255C97.1773 303.255 97.1773 303.255 97.0609 303.255L96.3626 303.62C96.2462 303.62 96.2462 303.742 96.3626 303.742L96.9445 304.107C97.0609 304.107 97.0609 304.107 97.1773 304.107L97.8756 303.742C97.8756 303.742 97.8756 303.742 97.8756 303.62ZM98.923 303.011L98.3411 302.646C98.2247 302.646 98.2247 302.646 98.1083 302.646L97.41 303.011C97.2937 303.011 97.2937 303.133 97.41 303.133L97.992 303.498C98.1083 303.498 98.1083 303.498 98.2247 303.498L98.923 303.133C99.0394 303.133 99.0394 303.011 98.923 303.011ZM103.928 301.186L103.346 300.821C103.229 300.821 103.229 300.821 103.113 300.821L98.1083 303.863C97.992 303.863 97.992 303.985 98.1083 303.985L98.6903 304.35C98.8066 304.35 98.8067 304.35 98.923 304.35L103.928 301.308V301.186ZM99.9705 302.403L99.3886 302.038C99.2722 302.038 99.2722 302.038 99.1558 302.038L98.5739 302.403C98.4575 302.403 98.4575 302.525 98.5739 302.525L99.1558 302.89C99.2722 302.89 99.2722 302.89 99.3886 302.89L100.087 302.525C100.087 302.525 100.087 302.403 99.9705 302.403ZM101.134 301.673L100.552 301.308C100.436 301.308 100.436 301.308 100.32 301.308L99.6213 301.673C99.505 301.673 99.505 301.795 99.6213 301.795L100.203 302.16C100.32 302.16 100.32 302.16 100.436 302.16L101.134 301.795C101.134 301.795 101.134 301.794 101.134 301.673ZM102.182 301.064L101.6 300.699C101.483 300.699 101.483 300.699 101.367 300.699L100.669 301.064C100.552 301.064 100.552 301.186 100.669 301.186L101.251 301.551C101.367 301.551 101.367 301.551 101.483 301.551L102.182 301.186C102.298 301.186 102.298 301.064 102.182 301.064ZM103.229 300.334L102.647 299.969C102.531 299.969 102.531 299.969 102.415 299.969L101.716 300.334C101.6 300.334 101.6 300.456 101.716 300.456L102.298 300.821C102.415 300.821 102.415 300.821 102.531 300.821L103.229 300.456C103.346 300.456 103.346 300.456 103.229 300.334ZM104.277 299.726L103.695 299.361C103.578 299.361 103.578 299.361 103.462 299.361L102.764 299.726C102.647 299.726 102.647 299.847 102.764 299.847L103.346 300.212C103.462 300.212 103.462 300.212 103.578 300.212L104.277 299.847C104.393 299.847 104.393 299.726 104.277 299.726ZM102.415 297.292L101.833 296.927C101.716 296.927 101.716 296.927 101.6 296.927L100.902 297.292C100.785 297.292 100.785 297.413 100.902 297.413L101.483 297.778C101.6 297.778 101.6 297.778 101.716 297.778L102.415 297.413C102.531 297.413 102.531 297.292 102.415 297.292ZM103.578 296.683L102.996 296.318C102.88 296.318 102.88 296.318 102.764 296.318L102.065 296.683C101.949 296.683 101.949 296.805 102.065 296.805L102.647 297.17C102.764 297.17 102.764 297.17 102.88 297.17L103.578 296.805V296.683ZM104.626 295.953L104.044 295.588C103.928 295.588 103.928 295.588 103.811 295.588L103.113 295.953C102.996 295.953 102.996 296.075 103.113 296.075L103.695 296.44C103.811 296.44 103.811 296.44 103.928 296.44L104.626 296.075C104.626 296.075 104.626 296.075 104.626 295.953ZM105.557 296.561L104.975 296.196C104.859 296.196 104.859 296.196 104.742 296.196L104.044 296.561C103.928 296.561 103.928 296.683 104.044 296.683L104.626 297.048C104.742 297.048 104.742 297.048 104.859 297.048L105.557 296.683C105.673 296.683 105.673 296.561 105.557 296.561ZM106.604 297.17L106.022 296.805C106.022 296.805 105.906 296.805 105.79 296.805L104.859 297.413H104.742L104.044 296.927C103.928 296.927 103.811 296.927 103.695 296.927L101.949 297.9C101.833 297.9 101.833 298.022 101.949 298.022L103.462 298.874C103.578 298.874 103.695 298.874 103.811 298.874L106.604 297.17Z"
          fill="#FBFFFB"
        />
        <path
          d="M99.7374 299.604L115.1 290.111L110.561 299.117L95.082 308.609L99.7374 299.604Z"
          fill="url(#paint15_linear_1926_44029)"
        />
        <path
          d="M99.5039 299.361L114.867 289.868L115.099 290.112L99.7367 299.604L99.5039 299.361Z"
          fill="#ECE7E2"
        />
        <path
          d="M99.5025 299.36L99.7352 299.604L95.0799 308.609L94.9635 308.488V308.853L84.0234 302.281V301.673L94.9635 308.244L99.5025 299.36Z"
          fill="#C9C6C1"
        />
        <path
          d="M93.2226 296.927C93.6881 297.414 95.0847 300.578 94.7355 301.43C94.5028 301.916 92.9898 302.403 92.4079 302.282C92.2915 302.282 92.1751 302.16 92.0587 302.16C91.9423 302.038 91.9423 301.916 91.9423 301.795C91.5932 300.943 90.7785 299.848 90.7785 299.848C90.7785 299.848 89.731 298.631 88.8 297.414L88.6836 297.292C88.6836 297.17 88.6836 297.17 88.6836 297.048C88.9164 296.44 89.3819 295.831 89.9638 295.466C90.0802 295.466 90.1966 295.345 90.4293 295.345C91.244 295.345 92.6406 296.318 93.2226 296.927Z"
          fill="#FBBD9E"
        />
        <path
          d="M97.8797 297.656C98.1125 298.387 99.3927 298.508 99.5091 298.387C99.9746 298.265 100.789 297.9 100.789 297.413C100.789 295.466 100.789 294.37 100.324 293.032C100.207 292.667 99.6255 291.693 99.1599 291.206C98.578 290.598 96.5995 291.571 96.7159 292.18C96.7159 292.302 97.065 293.519 97.2978 294.492C97.4142 295.709 97.5306 296.561 97.8797 297.656Z"
          fill="#FBBD9E"
        />
        <path
          d="M156.423 34.3013C160.263 31.989 163.289 33.8145 163.289 38.439L163.406 65.6994C163.406 70.2022 160.38 75.8004 156.539 78.1126L155.957 78.4777V92.3513L148.625 82.9805L99.6276 112.553C95.7869 114.865 92.7609 113.04 92.7609 108.415L92.6445 81.1551C92.6445 76.6522 95.6705 71.0541 99.5112 68.7419L156.423 34.3013Z"
          fill="#99E2FF"
        />
        <path
          d="M86.7104 175.837C82.8697 178.149 79.8438 183.747 79.8438 188.25L79.9601 215.51C79.9601 220.013 83.1025 221.96 86.8268 219.648L148.743 182.287L156.075 191.658V177.784L156.657 177.419C160.498 175.107 163.524 169.63 163.524 165.006L163.407 137.745C163.407 133.242 160.265 131.295 156.541 133.608L86.7104 175.837Z"
          fill="#99E2FF"
        />
        <path
          d="M128.258 100.748C132.098 98.4353 135.124 100.261 135.124 104.885L135.241 132.146C135.241 136.649 132.215 142.247 128.374 144.559L57.1471 187.518L49.8149 205.773V192.021L49.233 192.386C45.3924 194.699 42.3664 192.873 42.3664 188.249L42.25 160.988C42.25 156.364 45.276 150.887 49.1166 148.575L128.258 100.748Z"
          fill="white"
        />
        <path
          d="M95.3167 193.36C95.0839 193.969 94.7347 194.699 94.1528 195.307C93.6873 195.916 92.989 196.524 92.1743 196.889L90.5449 197.863V202.122L88.5664 203.218V192.143L92.1743 190.074C92.8726 189.588 93.5709 189.466 94.0364 189.466C94.502 189.466 94.9675 189.588 95.2003 189.953C95.433 190.318 95.5494 190.805 95.5494 191.413C95.6658 192.143 95.5494 192.752 95.3167 193.36ZM93.3381 194.09C93.5709 193.604 93.6873 193.238 93.6873 192.752C93.6873 191.656 93.1054 191.413 92.0579 192.021L90.5449 192.873V196.038L92.0579 195.186C92.6398 194.942 93.1054 194.577 93.3381 194.09Z"
          fill="#2035A4"
        />
        <path
          d="M98.9269 186.301V192.995C98.9269 193.725 99.0433 194.212 99.3925 194.455C99.7416 194.699 100.207 194.577 100.789 194.212C101.371 193.847 101.837 193.36 102.186 192.751C102.535 192.143 102.651 191.535 102.651 190.804V184.111L104.513 183.016V189.709C104.513 190.683 104.397 191.535 104.048 192.386C103.699 193.238 103.233 193.968 102.651 194.699C102.069 195.307 101.371 195.916 100.673 196.281C99.9744 196.646 99.2761 196.889 98.6942 196.889C98.1123 196.889 97.6467 196.646 97.2976 196.281C96.9484 195.794 96.832 195.185 96.832 194.212V187.518L98.9269 186.301Z"
          fill="#2035A4"
        />
        <path
          d="M111.258 189.954L109.163 186.911L108.232 187.398V191.536L106.37 192.631L106.254 181.8L109.745 179.853C110.444 179.488 111.026 179.244 111.608 179.244C112.073 179.244 112.539 179.366 112.771 179.731C113.004 180.096 113.121 180.583 113.121 181.191C113.121 181.921 113.004 182.652 112.655 183.382C112.306 184.112 111.84 184.842 111.142 185.451L113.353 188.493L111.258 189.954ZM108.349 185.816L109.862 184.964C110.327 184.721 110.793 184.355 111.026 183.869C111.258 183.504 111.375 183.017 111.375 182.53C111.375 182.043 111.258 181.678 111.026 181.556C110.793 181.435 110.444 181.556 109.862 181.8L108.349 182.652V185.816Z"
          fill="#2035A4"
        />
        <path
          d="M115.1 179.486C115.449 178.391 116.031 177.417 116.729 176.565C117.428 175.714 118.242 174.983 119.057 174.497C120.104 173.888 120.919 173.766 121.734 173.888C122.432 174.01 123.014 174.618 123.363 175.47L121.268 176.687C121.035 176.322 120.803 176.079 120.337 176.079C119.988 176.079 119.522 176.2 119.057 176.444C118.475 176.687 118.126 177.174 117.66 177.661C117.311 178.148 116.962 178.756 116.729 179.486C116.496 180.095 116.38 180.825 116.38 181.555C116.38 182.285 116.496 182.772 116.729 183.259C116.962 183.624 117.311 183.867 117.66 183.989C118.126 183.989 118.591 183.867 119.057 183.624C119.522 183.381 119.988 183.015 120.337 182.529C120.686 182.042 121.035 181.555 121.152 180.825L123.247 179.608C123.014 180.825 122.432 182.042 121.734 183.015C121.035 184.111 120.104 184.841 119.057 185.449C118.242 185.936 117.428 186.18 116.729 186.18C116.031 186.18 115.449 185.815 115.1 185.206C114.634 184.598 114.518 183.746 114.518 182.772C114.402 181.677 114.634 180.582 115.1 179.486Z"
          fill="#2035A4"
        />
        <path
          d="M131.978 167.316L132.094 177.661L130.348 178.634V174.253L126.624 176.444V180.947L124.878 182.042L124.762 171.576L126.507 170.602V174.862L130.232 172.671V168.412L131.978 167.316Z"
          fill="#2035A4"
        />
        <path
          d="M139.077 171.576L135.702 173.524L135.12 175.836L133.258 176.931L136.284 164.761L138.262 163.666L141.405 172.185L139.659 173.28L139.077 171.576ZM138.495 170.238L137.215 166.708L136.051 171.698L138.495 170.238Z"
          fill="#2035A4"
        />
        <path
          d="M143.852 170.482C143.386 170.482 143.037 170.36 142.688 170.117C142.455 169.873 142.223 169.387 142.223 168.778L144.085 167.683C144.085 168.048 144.201 168.291 144.434 168.413C144.667 168.535 145.016 168.413 145.365 168.291C145.714 168.048 146.063 167.805 146.296 167.439C146.529 167.074 146.645 166.709 146.645 166.344C146.645 166.101 146.529 165.857 146.412 165.736C146.296 165.614 146.063 165.614 145.831 165.614C145.598 165.614 145.249 165.736 144.899 165.736C144.318 165.857 143.852 165.979 143.619 165.979C143.27 165.979 142.921 165.857 142.688 165.614C142.455 165.371 142.339 164.884 142.339 164.275C142.339 163.667 142.455 163.058 142.688 162.45C142.921 161.841 143.27 161.355 143.736 160.868C144.201 160.381 144.667 160.016 145.249 159.651C146.063 159.164 146.762 159.042 147.344 159.164C147.925 159.407 148.158 159.894 148.275 160.746L146.412 161.841C146.412 161.476 146.296 161.233 146.063 161.233C145.831 161.111 145.481 161.233 145.132 161.355C144.783 161.598 144.55 161.841 144.318 162.085C144.085 162.45 144.085 162.815 144.085 163.18C144.085 163.423 144.201 163.667 144.318 163.789C144.434 163.91 144.667 163.91 144.899 163.91C145.132 163.91 145.481 163.789 145.831 163.789C146.412 163.667 146.762 163.667 147.111 163.545C147.46 163.545 147.809 163.667 148.042 163.91C148.275 164.154 148.391 164.64 148.391 165.249C148.391 165.736 148.275 166.344 148.042 166.953C147.809 167.561 147.46 168.17 146.994 168.656C146.529 169.143 146.063 169.63 145.365 169.995C144.899 170.239 144.318 170.482 143.852 170.482Z"
          fill="#2035A4"
        />
        <path
          d="M151.297 157.825V160.38L154.09 158.798V160.38L151.297 161.962V164.64L154.439 162.814V164.396L149.667 167.195L149.551 157.094L154.323 154.417V155.999L151.297 157.825Z"
          fill="#2035A4"
        />
        <path
          d="M63.4282 169.872C62.4972 169.872 61.6825 169.386 61.1006 168.655C60.5186 167.925 60.1695 166.83 60.0531 165.491C59.9367 164.153 60.1695 162.814 60.635 161.354C61.1005 159.893 61.7988 158.676 62.6135 157.459C63.5446 156.242 64.4757 155.39 65.6395 154.66C66.8033 153.93 67.8508 153.687 68.7819 153.687C69.7129 153.687 70.5276 154.173 71.1095 154.904C71.6915 155.634 72.0406 156.729 72.157 158.068C72.2734 159.406 72.0406 160.867 71.5751 162.205C71.1096 163.544 70.4112 164.883 69.5966 166.1C68.7819 167.317 67.7344 168.169 66.687 168.899C65.4067 169.629 64.3593 169.994 63.4282 169.872ZM68.0836 164.883C68.5491 164.153 69.0146 163.422 69.2474 162.449C69.4802 161.597 69.5966 160.623 69.5966 159.771C69.5966 158.798 69.3638 158.068 69.0146 157.581C68.6655 157.094 68.2 156.729 67.618 156.729C67.0361 156.729 66.4542 156.851 65.7559 157.337C65.0576 157.824 64.4757 158.311 63.8938 159.041C63.4282 159.771 62.9627 160.502 62.7299 161.475C62.4971 162.327 62.3808 163.301 62.4972 164.153C62.6135 165.126 62.7299 165.856 63.0791 166.343C63.4282 166.83 63.8938 167.073 64.4757 167.195C65.0576 167.195 65.6395 167.073 66.3378 166.587C67.0361 166.1 67.618 165.491 68.0836 164.883Z"
          fill="#2035A4"
        />
        <path
          d="M80.0698 160.502L77.2766 156.729L76.1127 157.459L76.3455 162.814L74.0178 164.275L73.2031 150.279L77.6257 147.602C78.5568 146.993 79.3715 146.75 79.9534 146.75C80.6517 146.75 81.1172 146.993 81.4664 147.48C81.8155 147.967 82.0483 148.575 82.0483 149.427C82.0483 150.401 81.9319 151.375 81.4664 152.348C81.0008 153.322 80.4189 154.295 79.4878 155.147L82.5138 159.042L80.0698 160.502ZM76.1127 155.147L78.0912 153.93C78.6732 153.565 79.2551 153.078 79.4878 152.47C79.837 151.861 79.9534 151.253 79.837 150.644C79.837 150.036 79.6042 149.549 79.2551 149.427C78.9059 149.306 78.4404 149.427 77.7421 149.792L75.7636 151.009L76.1127 155.147Z"
          fill="#2035A4"
        />
        <path
          d="M91.7095 139.812C92.6405 139.812 93.4552 140.178 93.9208 141.029C94.5027 141.76 94.7354 142.855 94.7354 144.315C94.7354 145.776 94.5027 147.114 94.0371 148.453C93.5716 149.792 92.8733 151.13 91.9422 152.226C91.0112 153.321 89.9637 154.295 88.7999 155.025L84.7264 157.58L84.1445 143.463L88.3343 140.908C89.6146 140.178 90.7784 139.812 91.7095 139.812ZM91.4767 149.792C92.175 148.575 92.4078 147.236 92.4078 145.776C92.4078 144.315 91.9422 143.342 91.2439 142.855C90.5456 142.368 89.6146 142.612 88.3343 143.342L86.705 144.315L87.0541 153.686L88.6835 152.713C89.9637 151.982 90.8948 151.009 91.4767 149.792Z"
          fill="#2035A4"
        />
        <path
          d="M98.8112 136.892L98.9276 140.543L102.885 138.109V140.421L98.9276 142.855L99.044 146.628L103.467 143.95V146.263L96.7163 150.4L96.3672 136.162L103.234 131.902V134.336L98.8112 136.892Z"
          fill="#2035A4"
        />
        <path
          d="M111.614 141.151L109.053 137.135L107.889 137.865V143.463L105.562 144.924L105.445 130.563L109.868 127.886C110.799 127.278 111.614 127.034 112.196 127.034C112.894 127.034 113.359 127.278 113.592 127.764C113.941 128.251 114.058 128.86 114.058 129.712C114.058 130.685 113.825 131.659 113.359 132.754C112.894 133.849 112.196 134.701 111.381 135.553L114.174 139.691L111.614 141.151ZM107.889 135.675L109.868 134.458C110.566 134.093 111.032 133.606 111.264 132.997C111.614 132.389 111.73 131.78 111.73 131.172C111.73 130.563 111.614 130.077 111.264 129.955C110.915 129.833 110.45 129.833 109.868 130.32L107.889 131.537V135.675Z"
          fill="#2035A4"
        />
        <path
          d="M118.126 136.771C117.428 136.771 116.962 136.649 116.613 136.284C116.264 135.919 116.031 135.189 116.031 134.337L118.592 132.755C118.592 133.363 118.824 133.728 119.057 133.85C119.406 133.972 119.756 133.972 120.337 133.607C120.919 133.242 121.269 132.877 121.618 132.39C121.967 131.903 122.083 131.416 122.083 130.808C122.083 130.321 121.967 130.078 121.734 129.956C121.501 129.834 121.269 129.712 120.919 129.834C120.57 129.834 120.221 129.956 119.639 130.077C118.824 130.321 118.243 130.321 117.777 130.443C117.311 130.443 116.846 130.321 116.497 129.956C116.148 129.591 116.031 128.982 116.031 128.009C116.031 127.157 116.264 126.305 116.613 125.453C116.962 124.601 117.428 123.749 118.126 123.019C118.708 122.289 119.523 121.68 120.337 121.194C121.618 120.463 122.549 120.22 123.363 120.463C124.062 120.707 124.527 121.559 124.644 122.776L122.083 124.358C122.083 123.871 121.85 123.506 121.618 123.384C121.269 123.262 120.919 123.384 120.337 123.628C119.872 123.871 119.523 124.236 119.174 124.723C118.941 125.21 118.708 125.696 118.708 126.305C118.708 126.67 118.824 126.913 119.057 127.035C119.29 127.157 119.523 127.157 119.872 127.157C120.221 127.157 120.57 127.035 121.152 126.913C121.967 126.67 122.549 126.67 123.014 126.548C123.48 126.548 123.945 126.67 124.295 127.035C124.644 127.4 124.76 128.009 124.76 128.861C124.76 129.591 124.527 130.443 124.295 131.294C123.945 132.146 123.48 132.998 122.898 133.728C122.316 134.459 121.501 135.189 120.687 135.676C119.523 136.406 118.824 136.649 118.126 136.771Z"
          fill="#2035A4"
        />
        <path
          d="M114.637 87.8499C113.939 87.8499 113.357 87.7282 113.008 87.3631C112.659 86.998 112.426 86.3895 112.426 85.5376L115.103 84.0772C115.103 84.6857 115.335 84.9291 115.685 85.1725C116.034 85.2942 116.499 85.2942 117.081 84.9291C117.663 84.564 118.129 84.1989 118.478 83.7121C118.827 83.2253 118.943 82.7385 118.943 82.2518C118.943 81.8867 118.827 81.5215 118.594 81.3999C118.361 81.2782 118.129 81.1565 117.779 81.2782C117.43 81.2782 116.965 81.3999 116.383 81.5216C115.568 81.6433 114.87 81.7649 114.404 81.7649C113.939 81.7649 113.473 81.6433 113.124 81.2782C112.775 80.9131 112.542 80.3046 112.542 79.4527C112.542 78.6008 112.775 77.7489 113.124 77.0187C113.473 76.1668 114.055 75.4366 114.637 74.7065C115.335 73.9763 116.034 73.4895 116.848 73.0027C118.129 72.2725 119.176 72.1508 119.991 72.3942C120.805 72.6376 121.271 73.3678 121.271 74.5848L118.594 76.0451C118.594 75.5583 118.361 75.315 118.012 75.1933C117.663 75.0716 117.198 75.1933 116.732 75.4366C116.266 75.68 115.917 76.0451 115.568 76.5319C115.335 77.0187 115.103 77.5055 115.103 77.9923C115.103 78.3574 115.219 78.6008 115.452 78.7225C115.685 78.8442 115.917 78.8442 116.266 78.8442C116.616 78.8442 117.081 78.7225 117.663 78.6008C118.478 78.4791 119.06 78.3574 119.642 78.3574C120.107 78.3574 120.573 78.4791 120.922 78.8442C121.271 79.2093 121.504 79.8178 121.504 80.6697C121.504 81.3999 121.387 82.2517 121.038 82.9819C120.689 83.8338 120.223 84.564 119.525 85.2942C118.827 86.0244 118.129 86.6329 117.198 87.1197C116.15 87.6065 115.335 87.8499 114.637 87.8499Z"
          fill="#2035A4"
        />
        <path
          d="M125.807 70.3244V73.7319L129.881 71.5413V73.7319L125.807 76.0442V79.6951L130.346 77.1395V79.33L123.363 83.2244V69.3508L130.346 65.5781V67.7687L125.807 70.3244Z"
          fill="#2035A4"
        />
        <path
          d="M135.007 74.5848L138.964 72.3942V74.5848L132.679 78.114L132.562 64.3621L135.007 63.0234V74.5848Z"
          fill="#2035A4"
        />
        <path
          d="M142.803 70.3244L146.644 68.1338V70.3244L140.476 73.8536L140.359 60.2234L142.687 58.8848L142.803 70.3244Z"
          fill="#2035A4"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1926_44029"
            x1="162.195"
            y1="394.443"
            x2="181.813"
            y2="394.443"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1926_44029"
            x1="432.85"
            y1="272.389"
            x2="459.103"
            y2="272.389"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1926_44029"
            x1="60.3137"
            y1="222.818"
            x2="86.5673"
            y2="222.818"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1926_44029"
            x1="425.758"
            y1="213.526"
            x2="443.625"
            y2="213.526"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_1926_44029"
            x1="432.28"
            y1="229.721"
            x2="442.423"
            y2="229.721"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_1926_44029"
            x1="457.11"
            y1="334.167"
            x2="466.628"
            y2="334.167"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_1926_44029"
            x1="137.077"
            y1="161.417"
            x2="140.859"
            y2="152.925"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ADA4B8" />
            <stop offset="1" stopColor="#FFF7F5" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_1926_44029"
            x1="152.593"
            y1="88.1897"
            x2="234.321"
            y2="223.566"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFF7F5" />
            <stop offset="1" stopColor="#F1E9EC" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_1926_44029"
            x1="237.645"
            y1="310.9"
            x2="246.006"
            y2="310.9"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ADA4B8" />
            <stop offset="1" stopColor="#DFD7E2" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_1926_44029"
            x1="299.008"
            y1="184.936"
            x2="292.244"
            y2="192.609"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ADA4B8" />
            <stop offset="1" stopColor="#DFD7E2" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_1926_44029"
            x1="197.514"
            y1="159.07"
            x2="225.217"
            y2="185.563"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D7CEDB" />
            <stop offset="1" stopColor="#EEE6F2" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_1926_44029"
            x1="48.7261"
            y1="299.683"
            x2="119.62"
            y2="299.683"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_1926_44029"
            x1="271.875"
            y1="345.558"
            x2="300.418"
            y2="345.558"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_1926_44029"
            x1="268.482"
            y1="378.433"
            x2="282.71"
            y2="378.433"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_1926_44029"
            x1="110.654"
            y1="303.365"
            x2="94.6672"
            y2="304.401"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B6B2AE" />
            <stop offset="1" stopColor="#BCB8B4" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_1926_44029"
            x1="115.688"
            y1="298.611"
            x2="94.5317"
            y2="299.982"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B6B2AE" />
            <stop offset="1" stopColor="#BCB8B4" />
          </linearGradient>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const LogInImg = () => {
  return (
    <React.Fragment>
      <svg
        width="200"
        height="150"
        viewBox="0 0 200 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1926_44801)">
          <path
            d="M167.633 137.232H180.966V137.332H167.633V137.232Z"
            fill="#EEEEEE"
          />
          <path
            d="M129.691 138.315H133.191V138.415H129.691V138.315Z"
            fill="#EEEEEE"
          />
          <path
            d="M159.504 133.522H167.229V133.622H159.504V133.522Z"
            fill="#EEEEEE"
          />
          <path
            d="M20.9805 134.293H38.3674V134.193H20.9805V134.293Z"
            fill="#EEEEEE"
          />
          <path
            d="M41.9531 134.293H44.5025V134.193H41.9531V134.293Z"
            fill="#EEEEEE"
          />
          <path
            d="M52.7852 135.979H90.493V135.879H52.7852V135.979Z"
            fill="#EEEEEE"
          />
          <path
            d="M18.1024 0.0978622C16.8909 0.0978622 15.9053 1.07576 15.9053 2.27815V110.706C15.9053 111.909 16.8909 112.886 18.1024 112.886H95.8316C97.0428 112.886 98.0283 111.909 98.0283 110.706V2.27815C98.0283 1.07576 97.0428 0.0978622 95.8316 0.0978622H18.1024ZM95.8316 112.986H18.1024C16.8354 112.986 15.8047 111.964 15.8047 110.706V2.27815C15.8047 1.02103 16.8354 -0.0019989 18.1024 -0.0019989H95.8316C97.098 -0.0019989 98.1289 1.02103 98.1289 2.27815V110.706C98.1289 111.964 97.098 112.986 95.8316 112.986Z"
            fill="#EEEEEE"
          />
          <path
            d="M105.168 0.0978622C103.957 0.0978622 102.972 1.07576 102.972 2.27815V110.706C102.972 111.909 103.957 112.886 105.168 112.886H182.898C184.109 112.886 185.095 111.909 185.095 110.706V2.27815C185.095 1.07576 184.109 0.0978622 182.898 0.0978622H105.168ZM182.898 112.986H105.168C103.902 112.986 102.871 111.964 102.871 110.706V2.27815C102.871 1.02103 103.902 -0.0019989 105.168 -0.0019989H182.898C184.164 -0.0019989 185.195 1.02103 185.195 2.27815V110.706C185.195 111.964 184.164 112.986 182.898 112.986Z"
            fill="#EEEEEE"
          />
          <path
            d="M-0.136719 130.902H201.131V130.802H-0.136719V130.902Z"
            fill="#EEEEEE"
          />
          <path
            d="M140.781 128.482H179.093V77.8918H140.781V128.482Z"
            fill="#F8F8F9"
          />
          <path
            d="M133.469 128.482H140.777V77.8918H133.469V128.482Z"
            fill="#E9E9E8"
          />
          <path
            d="M143.266 93.9316H176.408V81.646H143.266V93.9316Z"
            fill="#FCFDFD"
          />
          <path
            d="M164.159 81.6461L164.014 83.284C163.966 83.824 163.51 84.2383 162.964 84.2383H156.71C156.164 84.2383 155.708 83.824 155.661 83.284L155.516 81.6461H164.159Z"
            fill="#EEEEEE"
          />
          <path
            d="M143.266 107.56H176.408V95.2735H143.266V107.56Z"
            fill="#FCFDFD"
          />
          <path
            d="M164.159 95.2742L164.014 96.9121C163.966 97.4525 163.51 97.8672 162.964 97.8672H156.71C156.164 97.8672 155.708 97.4525 155.661 96.9121L155.516 95.2742H164.159Z"
            fill="#EEEEEE"
          />
          <path
            d="M143.266 121.188H176.408V108.902H143.266V121.188Z"
            fill="#FCFDFD"
          />
          <path
            d="M164.159 108.902L164.014 110.539C163.966 111.08 163.51 111.494 162.964 111.494H156.71C156.164 111.494 155.708 111.08 155.661 110.539L155.516 108.902H164.159Z"
            fill="#EEEEEE"
          />
          <path
            d="M143.266 131.008H176.005L176.408 128.478H143.266V131.008Z"
            fill="#E9E9E8"
          />
          <path
            d="M136.422 131.008H143.265V128.478H136.02L136.422 131.008Z"
            fill="#E3E3E2"
          />
          <path
            d="M158.655 77.9453H171.737L170.286 61.4812H157.203L158.655 77.9453Z"
            fill="#FCFDFD"
          />
          <path
            d="M158.654 77.9463H158.03L156.578 61.4822H157.202L158.654 77.9463Z"
            fill="#EEEEEE"
          />
          <path
            d="M159.843 76.2676H170.258L169.102 63.1606H158.688L159.843 76.2676Z"
            fill="#F4F4F4"
          />
          <path
            d="M160.602 75.1885H169.302L168.337 64.2395H159.637L160.602 75.1885Z"
            fill="#E9E9E8"
          />
          <path
            d="M154.984 77.9453L155.883 67.7545H142.859L141.961 77.9453H154.984Z"
            fill="#F4F4F4"
          />
          <path
            d="M154.98 77.9453L155.879 67.7545H156.58L155.682 77.9453H154.98Z"
            fill="#E3E3E2"
          />
          <path
            d="M153.743 76.9072L154.458 68.794H144.09L143.375 76.9072H153.743Z"
            fill="#EEEEEE"
          />
          <path
            d="M152.95 76.2402L153.547 69.4629H144.886L144.289 76.2402H152.95Z"
            fill="#F8F8F9"
          />
          <path
            d="M124.908 124.158C124.908 126.859 124.481 128.605 123.762 129.726C123.221 130.569 122.249 131.043 121.242 131.043H117.302C116.295 131.043 115.324 130.569 114.783 129.726C114.064 128.605 113.637 126.859 113.637 124.158C113.637 120.241 115.358 117.106 115.919 114.601C116.122 113.7 115.448 110.936 115.448 110.936H123.096C123.096 110.936 122.422 113.7 122.625 114.601C123.187 117.106 124.908 120.241 124.908 124.158Z"
            fill="#EEEEEE"
          />
          <path
            d="M137.934 108.307C137.934 104.907 132.562 106.318 131.208 101.042C130.695 99.0429 135.065 94.5181 135.065 94.5181H121.44C121.44 94.5181 125.81 99.0429 125.297 101.042C123.943 106.318 118.57 104.907 118.57 108.307C118.57 112.052 126.149 119.853 126.514 128.633C126.547 129.418 125.089 131.044 125.089 131.044H131.416C131.416 131.044 129.958 129.418 129.991 128.633C130.356 119.853 137.934 112.052 137.934 108.307Z"
            fill="#F8F8F9"
          />
          <path
            d="M133.815 117.143C134.607 115.491 132.969 109.871 132.969 109.871H138.873C138.873 109.871 137.236 115.491 138.028 117.143C138.587 118.31 139.859 119.055 139.859 120.436V128.734C139.859 130.883 138.087 131.043 135.922 131.043C133.756 131.043 131.984 130.883 131.984 128.734V120.436C131.984 119.055 133.256 118.311 133.815 117.143Z"
            fill="#F4F4F4"
          />
          <path
            d="M69.0408 61.9493C67.4512 61.2663 65.7714 61.5962 65.2968 62.6852C64.8214 63.7737 65.7283 65.215 67.3179 65.8981C68.9071 66.5808 70.5873 66.2512 71.0623 65.1623C71.5373 64.0737 70.6304 62.632 69.0408 61.9493ZM66.3406 68.1371C62.9488 66.6795 61.0134 63.6035 62.0274 61.2802C63.041 58.9565 66.6256 58.2527 70.0177 59.7099C73.4099 61.1676 75.3453 64.2439 74.3313 66.5676C73.3177 68.8905 69.7331 69.5948 66.3406 68.1371Z"
            fill="#E9E9E8"
          />
          <path
            d="M70.3305 62.0781L68.7188 61.3855L78.4585 39.0412C78.6513 38.5998 79.1682 38.3965 79.6134 38.5874C80.0586 38.7788 80.2631 39.2917 80.0707 39.7335L70.3305 62.0781Z"
            fill="#E9E9E8"
          />
          <path
            d="M80.8197 41.8926L77.7266 40.552L78.4242 38.9525L81.5172 40.2931L80.8197 41.8926Z"
            fill="#E9E9E8"
          />
          <path
            d="M79.2929 43.6816L77.0781 42.7269L77.7761 41.1274L79.9905 42.0822L79.2929 43.6816Z"
            fill="#E9E9E8"
          />
          <path
            d="M78.6668 46.8516L76.1836 45.7842L76.8816 44.1847L79.3648 45.2521L78.6668 46.8516Z"
            fill="#E9E9E8"
          />
          <path
            d="M70.9612 59.6922L70.0756 59.3115C69.6344 59.1222 69.4316 58.6133 69.6228 58.1755L69.6288 58.1619C69.8196 57.7241 70.3324 57.5227 70.7736 57.7125L71.6588 58.0928C72.1004 58.2825 72.3032 58.791 72.112 59.2289L72.106 59.2428C71.9148 59.6807 71.4024 59.882 70.9612 59.6922Z"
            fill="#E9E9E8"
          />
          <path
            d="M135.247 59.2934C136.507 60.1259 138.231 59.7608 139.091 58.4797C139.951 57.1986 139.626 55.4793 138.367 54.6464C137.108 53.8139 135.383 54.1783 134.523 55.4593C133.663 56.7404 133.988 58.4605 135.247 59.2934ZM140.136 52.0115C142.824 53.7884 143.517 57.4583 141.681 60.1926C139.846 62.9266 136.165 63.7052 133.478 61.9283C130.79 60.1515 130.097 56.4812 131.933 53.7468C133.768 51.0129 137.448 50.2343 140.136 52.0115Z"
            fill="#E9E9E8"
          />
          <path
            d="M134.597 58.5839L136.263 59.6857L124.342 77.7895C124.036 78.2461 123.414 78.37 122.954 78.0656C122.494 77.7612 122.369 77.1452 122.676 76.6886L134.597 58.5839Z"
            fill="#E9E9E8"
          />
          <path
            d="M122.753 72.7421L126.259 75.079L124.509 77.6855L120.996 75.3447C120.492 75.0083 120.356 74.3308 120.693 73.8291L121.22 73.0437C121.559 72.5392 122.246 72.4042 122.753 72.7421Z"
            fill="#E9E9E8"
          />
          <path
            d="M91.4564 17.4167L89.6056 22.1735C89.4389 22.6018 88.9535 22.8155 88.5215 22.6501C88.0896 22.4847 87.8747 22.0026 88.0413 21.5739L89.8918 16.8171C90.4895 15.2815 89.7167 13.5478 88.1685 12.955L86.4537 12.2979C84.906 11.7051 83.1602 12.4729 82.5624 14.0092L81.8068 15.9518L80.2422 15.3522L80.9982 13.41C81.9288 11.0172 84.6479 9.82198 87.0579 10.7456L88.7727 11.4023C91.1827 12.3259 92.3871 15.0239 91.4564 17.4167Z"
            fill="#F4F4F4"
          />
          <path
            d="M84.0752 25.3263L81.1134 24.1918L82.6796 21.479C82.4824 21.0855 82.4458 20.6134 82.6185 20.17C82.9449 19.3303 83.8961 18.91 84.7422 19.2344C85.5888 19.5588 86.0106 20.5047 85.6842 21.3448C85.5119 21.7878 85.1649 22.1134 84.7503 22.2723L84.0752 25.3263ZM91.1667 18.1646C91.0431 18.0068 90.8761 17.8782 90.6748 17.8011L81.336 14.2231C81.1279 14.1436 80.9089 14.1272 80.7056 14.1675C80.3325 14.2402 80.002 14.4963 79.8546 14.8742L76.2491 24.1423C76.0213 24.7287 76.3143 25.3854 76.9053 25.6119L86.2445 29.1899C86.8354 29.416 87.4972 29.1252 87.7254 28.5388L91.3309 19.2708C91.4807 18.8861 91.4062 18.4694 91.1667 18.1646Z"
            fill="#E9E9E8"
          />
          <path
            d="M27.7031 125.632H102.224V85.8325H27.7031V125.632Z"
            fill="#E9E9E8"
          />
          <path
            d="M96.25 130.795H100.934V127.283H96.25V130.795Z"
            fill="#E9E9E8"
          />
          <path
            d="M22.0117 130.797H26.6953V82.8723H22.0117V130.797Z"
            fill="#E9E9E8"
          />
          <path
            d="M29.1384 123.772V106.334H63.7864V123.772H29.1384ZM100.932 123.772H66.2842V87.2091H100.932V123.772ZM29.1384 87.2091H63.7864V103.855H29.1384V87.2091ZM26.6406 82.8713V130.796H29.1384V128.11H100.932V130.796H103.43V82.8713H102.181H100.932H29.1384H27.8896H26.6406Z"
            fill="#F4F4F4"
          />
          <path
            d="M66.2812 123.771H98.5873V88.9986H66.2812V123.771Z"
            fill="#F8F8F9"
          />
          <path
            d="M67.7461 105.344C67.7461 106.167 68.4183 106.834 69.2471 106.834C70.076 106.834 70.7482 106.167 70.7482 105.344C70.7482 104.522 70.076 103.855 69.2471 103.855C68.4183 103.855 67.7461 104.522 67.7461 105.344Z"
            fill="#FCFDFD"
          />
          <path
            d="M69.2471 106.833C69.8526 106.833 70.371 106.475 70.6081 105.963C70.6959 106.152 70.7482 106.361 70.7482 106.583C70.7482 107.405 70.076 108.072 69.2471 108.072C68.4183 108.072 67.7461 107.405 67.7461 106.583C67.7461 106.361 67.7984 106.152 67.8862 105.963C68.1233 106.475 68.6417 106.833 69.2471 106.833Z"
            fill="#E3E3E2"
          />
          <path
            d="M86.062 123.771H78.3547L74.6719 88.9986H82.3792L86.062 123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M76.377 123.771H74.843L71.1602 88.9986H72.6942L76.377 123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M55.9805 103.839H59.0338V88.9651H55.9805V103.839Z"
            fill="#FCFDFD"
          />
          <path
            d="M43.3203 103.839H46.3731V88.9651H43.3203V103.839Z"
            fill="#F8F8F9"
          />
          <path
            d="M52.9219 103.838H55.9747V90.0099H52.9219V103.838Z"
            fill="#F8F8F9"
          />
          <path
            d="M46.375 103.839H49.4278V90.0109H46.375V103.839Z"
            fill="#FCFDFD"
          />
          <path
            d="M49.4258 103.839H51.3992V88.9651H49.4258V103.839Z"
            fill="#EEEEEE"
          />
          <path
            d="M51.3984 103.839H52.9248V90.0109H51.3984V103.839Z"
            fill="#FCFDFD"
          />
          <path
            d="M40.2656 103.839H43.3185V88.9651H40.2656V103.839Z"
            fill="#EEEEEE"
          />
          <path
            d="M37.2148 103.839H40.268V90.0109H37.2148V103.839Z"
            fill="#E9E9E8"
          />
          <path
            d="M30.6602 103.839H33.7131V90.0109H30.6602V103.839Z"
            fill="#E9E9E8"
          />
          <path
            d="M33.7148 103.839H35.6876V88.9651H33.7148V103.839Z"
            fill="#FCFDFD"
          />
          <path
            d="M35.6875 103.839H37.2141V90.0109H35.6875V103.839Z"
            fill="#EEEEEE"
          />
          <path
            d="M29.1328 103.838H30.6595V89.3167H29.1328V103.838Z"
            fill="#EEEEEE"
          />
          <path
            d="M32.1858 123.771H29.1328V108.898H32.1858V123.771Z"
            fill="#EEEEEE"
          />
          <path
            d="M41.793 123.771H44.8458V108.898H41.793V123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M32.1875 123.771H35.2405V109.943H32.1875V123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M38.7383 123.771H41.7914V109.943H38.7383V123.771Z"
            fill="#EEEEEE"
          />
          <path
            d="M36.7656 123.772H38.7387V108.899H36.7656V123.772Z"
            fill="#FCFDFD"
          />
          <path
            d="M35.2422 123.771H36.7687V109.943H35.2422V123.771Z"
            fill="#F8F8F9"
          />
          <path
            d="M44.8477 123.772H47.9005V108.899H44.8477V123.772Z"
            fill="#EEEEEE"
          />
          <path
            d="M47.8984 123.771H50.9517V109.943H47.8984V123.771Z"
            fill="#F8F8F9"
          />
          <path
            d="M54.4492 123.771H57.5024V109.943H54.4492V123.771Z"
            fill="#E9E9E8"
          />
          <path
            d="M52.4766 123.771H54.4495V108.898H52.4766V123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M59.0312 123.771H61.004V108.898H59.0312V123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M50.9531 123.771H52.4795V109.943H50.9531V123.771Z"
            fill="#EEEEEE"
          />
          <path
            d="M57.5039 123.771H59.0304V109.251H57.5039V123.771Z"
            fill="#EEEEEE"
          />
          <path
            d="M32.5433 57.2552C32.5433 57.2552 32.0308 57.4889 31.7965 57.9623C31.5622 58.4352 32.2891 59.3085 32.2891 59.3085C32.2891 59.3085 32.8989 59.7299 33.5051 59.4567C34.1111 59.1834 34.1111 59.1834 34.1111 59.1834C34.1111 59.1834 33.0747 57.3982 32.5716 57.3806L32.5433 57.2552Z"
            fill="#E9E9E8"
          />
          <path
            d="M35.1393 57.2413C35.2132 58.0882 34.6846 59.1559 33.9229 59.2214C33.1613 59.2869 32.4551 58.3254 32.381 57.479C32.3071 56.6321 32.9221 56.5498 33.6838 56.4843C34.4453 56.4188 35.0655 56.3948 35.1393 57.2413Z"
            fill="#E9E9E8"
          />
          <path
            d="M32.9031 56.9921C32.9031 56.9921 33.485 57.4523 34.6843 57.1838C34.6843 57.1838 32.7928 58.4358 32.9031 56.9921Z"
            fill="#E9E9E8"
          />
          <path
            d="M33.418 56.8237C33.418 56.8237 34.0894 56.7076 34.0993 56.9863C34.0993 56.9863 34.6686 56.9547 34.5899 56.7176C34.5113 56.4805 33.418 56.8237 33.418 56.8237Z"
            fill="#E9E9E8"
          />
          <path
            d="M33.3948 57.6875C33.114 57.6875 32.8988 57.5453 32.8984 57.1095C32.8984 57.0723 32.8999 57.0332 32.9032 56.992C32.9032 56.992 33.2519 57.2677 33.9656 57.2677C34.174 57.2677 34.4135 57.2445 34.6844 57.1838C34.6844 57.1838 33.9233 57.6875 33.3948 57.6875Z"
            fill="#EDEDEC"
          />
          <path
            d="M34.0993 56.9863C34.0939 56.8341 33.8917 56.7997 33.709 56.7997C33.5568 56.7997 33.418 56.8237 33.418 56.8237C33.418 56.8237 34.0221 56.6339 34.3644 56.6339C34.4826 56.6339 34.5697 56.6567 34.5899 56.7176C34.5949 56.7328 34.5973 56.7472 34.5973 56.7608C34.5976 56.9587 34.0993 56.9863 34.0993 56.9863Z"
            fill="#EDEDEC"
          />
          <path
            d="M32.6406 59.4904C32.883 59.8803 33.3773 60.0804 33.8355 60.0265C34.2937 59.9718 34.7064 59.6877 34.9709 59.3122C35.2354 58.9367 35.3615 58.4782 35.3904 58.0208C35.3982 57.9025 35.4074 57.6061 35.2503 57.5606C35.1062 57.5186 35.0173 57.7188 34.9505 57.8122C34.7585 58.0803 34.555 58.3315 34.3103 58.5556C34.0732 58.7726 33.811 58.9623 33.5304 59.1201C33.4517 59.1644 32.6833 59.5591 32.6406 59.4904Z"
            fill="#E9E9E8"
          />
          <path
            d="M35.9067 57.7988C36.051 58.1419 35.9982 58.5594 35.7735 58.8566C35.6258 59.0523 35.4162 59.1913 35.2055 59.3176C35.059 59.4051 34.8701 59.4885 34.7264 59.3963C34.5714 59.2968 34.5852 59.0707 34.6207 58.8909C34.6756 58.6141 34.7379 58.3385 34.808 58.0648C34.8653 57.8403 34.9 57.4648 35.0326 57.2743C35.1573 57.0953 35.3338 57.2012 35.5222 57.3314C35.6907 57.4477 35.8277 57.6102 35.9067 57.7988Z"
            fill="#E9E9E8"
          />
          <path
            d="M32.8344 59.0195C32.8187 59.0187 32.803 59.0175 32.7873 59.0159C32.7193 58.964 32.6453 58.9197 32.5674 58.8845C32.4841 58.847 32.4033 58.8126 32.3306 58.7978C32.2547 58.7239 32.1938 58.6356 32.1552 58.537C32.0759 58.336 32.0775 57.8251 32.3404 57.7604C32.4569 58.2142 32.5574 58.6261 32.8344 59.0195Z"
            fill="#EDEDEC"
          />
          <path
            d="M34.8203 59C34.9264 58.8123 35.0098 58.6121 35.0689 58.4048C35.108 58.2678 35.094 57.9282 35.1698 57.8216C35.2093 57.766 35.2439 57.7429 35.2736 57.7429C35.4184 57.7429 35.4527 58.2965 35.4139 58.422C35.3294 58.696 35.0983 58.9213 34.8203 59Z"
            fill="#EDEDEC"
          />
          <path
            d="M33.6495 59.8525C33.4865 59.8525 33.3503 59.7969 33.1933 59.7244C33.189 59.6903 33.1832 59.6567 33.1758 59.6234C33.185 59.6238 33.1943 59.6238 33.2039 59.6238C33.3906 59.6238 33.6269 59.5966 33.7569 59.4772C33.8687 59.5722 34.0153 59.6198 34.1618 59.6198C34.1832 59.6198 34.2046 59.6186 34.226 59.6166C34.2118 59.6511 34.1997 59.6863 34.1892 59.7224C34.0689 59.7652 33.9491 59.7981 33.8871 59.8161C33.7999 59.8413 33.722 59.8525 33.6495 59.8525Z"
            fill="#EDEDEC"
          />
          <path
            d="M33.0938 75.037L33.1302 63.5119L33.7259 60.0066L33.952 60.0445L33.3593 63.5339L33.3174 75.2559L33.0938 75.037Z"
            fill="#E3E3E2"
          />
          <path
            d="M33.3365 63.4532L33.1543 63.5918C32.972 63.3557 32.8077 63.0481 32.6178 62.6922C32.3237 62.1417 31.9905 61.5174 31.4844 60.9653L31.6542 60.8119C32.1797 61.3855 32.5199 62.0231 32.8203 62.5855C33.0057 62.9327 33.1659 63.2323 33.3365 63.4532Z"
            fill="#E3E3E2"
          />
          <path
            d="M33.475 61.9073C33.784 61.8266 34.0611 61.6313 34.2394 61.368C34.4421 61.0692 34.5123 60.7041 34.5784 60.3498C34.352 60.4169 34.1161 60.3845 33.8788 60.3522C33.6958 60.327 33.5122 60.3023 33.3312 60.323C32.9997 60.3606 32.6912 60.5611 32.5237 60.8475C32.3068 61.2182 32.2187 61.6389 32.4101 61.8082C32.5679 61.9485 33.0615 62.0156 33.475 61.9073Z"
            fill="#E9E9E8"
          />
          <path
            d="M31.9319 61.1118C31.5616 61.3443 31.0853 61.4034 30.6686 61.2688C30.2518 61.1338 30.13 60.5122 29.9688 60.108C30.3469 60.0309 31.307 60.0848 31.5241 60.1064C31.7418 60.1279 31.9622 60.2254 32.0792 60.4084C32.1962 60.5917 32.1745 60.8661 31.9974 60.9932L31.9319 61.1118Z"
            fill="#E9E9E8"
          />
          <path
            d="M30.0246 61.785C30.2794 61.479 30.9074 61.2573 31.3008 61.328C31.6941 61.3991 32.0295 61.6679 32.1705 61.9875C32.0666 62.2352 31.788 62.375 31.5181 62.3946C31.2485 62.4137 30.9826 62.3342 30.7239 62.2559C30.4652 62.1776 30.1992 62.0982 29.9297 62.1173L30.0246 61.785Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.7729 59.8038C37.7729 59.8038 38.1933 60.1769 38.2773 60.6974C38.3611 61.2179 37.4076 61.8407 37.4076 61.8407C37.4076 61.8407 36.6997 62.0656 36.2013 61.6278C35.7031 61.1895 35.7031 61.1896 35.7031 61.1896C35.7031 61.1896 37.2224 59.7858 37.7087 59.9157L37.7729 59.8038Z"
            fill="#E9E9E8"
          />
          <path
            d="M35.2999 59.0324C34.9786 59.8201 35.1675 60.995 35.8761 61.2798C36.5846 61.5646 37.5447 60.8516 37.8659 60.0638C38.1875 59.2765 37.6243 59.0184 36.9158 58.7332C36.207 58.4484 35.6214 58.245 35.2999 59.0324Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.5016 59.4463C37.5016 59.4463 36.8089 59.7163 35.7422 59.1095C35.7422 59.1095 37.1792 60.8584 37.5016 59.4463Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.0631 59.1348C37.0631 59.1348 36.4559 58.8276 36.364 59.0908C36.364 59.0908 35.8289 58.8943 35.9742 58.6914C36.1197 58.4884 37.0631 59.1348 37.0631 59.1348Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.0075 59.9971C36.4715 59.9967 35.7422 59.1095 35.7422 59.1095C36.3065 59.4306 36.7661 59.5061 37.074 59.5061C37.3479 59.5061 37.5016 59.4462 37.5016 59.4462C37.4088 59.8525 37.2238 59.9971 37.0075 59.9971Z"
            fill="#EDEDEC"
          />
          <path
            d="M37.0631 59.1348C37.0631 59.1348 36.7656 58.9842 36.5555 58.9842C36.4654 58.9842 36.3915 59.0117 36.364 59.0908C36.364 59.0908 35.9489 58.9386 35.9492 58.7633C35.9492 58.7397 35.9569 58.7157 35.9742 58.6914C35.994 58.6638 36.0284 58.6518 36.0733 58.6518C36.3585 58.6518 37.0631 59.1348 37.0631 59.1348Z"
            fill="#EDEDEC"
          />
          <path
            d="M37.0154 61.9084C36.6684 62.2104 36.1367 62.2575 35.7146 62.0722C35.2926 61.8864 34.9824 61.4946 34.8409 61.0583C34.6995 60.6225 34.7149 60.1468 34.8223 59.7013C34.8501 59.5859 34.929 59.3007 35.0928 59.3027C35.2431 59.3047 35.2687 59.5216 35.3049 59.6302C35.409 59.943 35.5289 60.2422 35.6966 60.5278C35.8587 60.8047 36.053 61.0627 36.2746 61.2948C36.3367 61.3599 36.9543 61.9615 37.0154 61.9084Z"
            fill="#E9E9E8"
          />
          <path
            d="M34.3958 59.3402C34.1563 59.6263 34.083 60.0401 34.2098 60.3901C34.293 60.6201 34.452 60.8143 34.6161 60.9965C34.7303 61.1231 34.8863 61.2577 35.0509 61.2114C35.2285 61.1614 35.282 60.9417 35.3014 60.7592C35.3309 60.4783 35.3529 60.1971 35.3674 59.9151C35.379 59.6838 35.4572 59.3147 35.3867 59.0942C35.3206 58.8865 35.1204 58.936 34.9018 59.0055C34.7064 59.0678 34.5273 59.1833 34.3958 59.3402Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.1529 61.4277C37.091 61.4277 37.029 61.4202 36.9688 61.4046C37.3502 61.1094 37.5683 60.745 37.8139 60.3452C38.046 60.4838 37.896 60.9723 37.7609 61.1417C37.6164 61.3227 37.3844 61.4277 37.1529 61.4277Z"
            fill="#EDEDEC"
          />
          <path
            d="M35.0758 60.8047C34.8335 60.6481 34.6794 60.3657 34.6797 60.0788C34.6798 59.9526 34.8618 59.4681 34.9987 59.4681C35.0336 59.4681 35.0656 59.4996 35.091 59.5763C35.1319 59.7002 35.0179 60.0205 35.0148 60.1631C35.0097 60.3785 35.0302 60.5942 35.0758 60.8047Z"
            fill="#EDEDEC"
          />
          <path
            d="M36.1677 61.9932C36.0226 61.9932 35.884 61.962 35.7244 61.8573C35.5966 61.7731 35.1792 61.515 35.1958 61.3632C35.3123 61.5258 35.5142 61.6193 35.7142 61.6193C35.7947 61.6193 35.8749 61.6041 35.9491 61.5725C36.1112 61.8486 36.701 61.9356 36.701 61.9356C36.4916 61.956 36.3257 61.9932 36.1677 61.9932Z"
            fill="#EDEDEC"
          />
          <path
            d="M32.7617 73.3164L32.9059 72.8443L33.1015 72.2079L33.3273 71.4657L35.1331 65.5652L35.3589 63.8718L35.5592 62.3694L35.6009 62.0578L35.713 62.0722L35.7146 62.0738L35.8284 62.0882L35.8253 62.115L35.7852 62.409L35.5721 64.0148L35.3974 65.3235L35.3589 65.6111L35.3446 65.6574L33.3258 72.2479L33.0981 72.9873L32.9941 73.3308L32.85 73.7998L32.7617 73.3164Z"
            fill="#E3E3E2"
          />
          <path
            d="M35.1797 65.4959L35.3126 65.6816C35.5567 65.5095 35.8047 65.2634 36.0922 64.9782C36.536 64.538 37.0395 64.0386 37.6867 63.6583L37.5699 63.4626C36.8977 63.8573 36.3835 64.3674 35.9297 64.8176C35.6498 65.0948 35.4082 65.3349 35.1797 65.4959Z"
            fill="#E3E3E2"
          />
          <path
            d="M35.5046 63.9777C35.2332 63.8103 35.0264 63.5427 34.9336 63.2391C34.8286 62.8943 34.8695 62.5244 34.9113 62.1669C35.2595 62.3974 35.7282 62.3383 36.1115 62.5052C36.4172 62.6379 36.6526 62.9195 36.7279 63.2419C36.8254 63.6593 36.7851 64.0871 36.5518 64.1938C36.3597 64.2813 35.8678 64.2014 35.5046 63.9777Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.2162 63.6664C37.5014 63.9968 37.9391 64.1925 38.3773 64.1854C38.8157 64.1782 39.116 63.6193 39.39 63.2798C39.0513 63.096 38.1178 62.8675 37.9038 62.8244C37.6895 62.7816 37.4497 62.8104 37.2836 62.9514C37.1176 63.0924 37.0571 63.3613 37.189 63.5338L37.2162 63.6664Z"
            fill="#E9E9E8"
          />
          <path
            d="M38.8374 64.8664C38.6847 64.5001 38.15 64.1042 37.7532 64.0575C37.3562 64.0107 36.9558 64.1697 36.7266 64.4342C36.7525 64.7014 36.9772 64.9163 37.2292 65.0134C37.4815 65.1105 37.7592 65.112 38.0296 65.1128C38.3002 65.1132 38.5777 65.1152 38.8298 65.2119L38.8374 64.8664Z"
            fill="#E9E9E8"
          />
          <path
            d="M29.6188 59.3427C29.6188 59.3427 29.1571 59.6647 29.0123 60.1716C28.8675 60.6785 29.7405 61.408 29.7405 61.408C29.7405 61.408 30.417 61.7144 30.9635 61.3373C31.5102 60.9602 31.5102 60.9602 31.5102 60.9602C31.5102 60.9602 30.1677 59.3891 29.6694 59.4614L29.6188 59.3427Z"
            fill="#E9E9E8"
          />
          <path
            d="M32.1726 58.8659C32.3985 59.6856 32.0716 60.8305 31.3343 61.031C30.5969 61.2312 29.7281 60.4111 29.502 59.5914C29.2761 58.7716 29.866 58.5807 30.6035 58.3806C31.3408 58.1804 31.9464 58.0462 32.1726 58.8659Z"
            fill="#E9E9E8"
          />
          <path
            d="M29.9297 59.0189C29.9297 59.0189 30.5857 59.368 31.7169 58.8899C31.7169 58.8899 30.0829 60.4586 29.9297 59.0189Z"
            fill="#E9E9E8"
          />
          <path
            d="M30.4062 58.7619C30.4062 58.7619 31.0458 58.5278 31.1057 58.7998C31.1057 58.7998 31.6601 58.6672 31.5398 58.4487C31.4195 58.2302 30.4062 58.7619 30.4062 58.7619Z"
            fill="#E9E9E8"
          />
          <path
            d="M30.4168 59.627C30.1725 59.627 29.9778 59.472 29.9297 59.019C29.9297 59.019 30.1608 59.142 30.5851 59.142C30.8756 59.142 31.257 59.0841 31.7169 58.8899C31.7169 58.8899 30.9491 59.627 30.4168 59.627Z"
            fill="#EDEDEC"
          />
          <path
            d="M31.1057 58.7998C31.0836 58.6999 30.9833 58.6684 30.8653 58.6684C30.6621 58.6684 30.4062 58.7619 30.4062 58.7619C30.4062 58.7619 31.1036 58.3959 31.4099 58.3959C31.4728 58.3959 31.5194 58.4115 31.5398 58.4487C31.5516 58.4699 31.5569 58.4906 31.5569 58.5102C31.5571 58.6919 31.1057 58.7998 31.1057 58.7998Z"
            fill="#EDEDEC"
          />
          <path
            d="M30.125 61.523C30.434 61.8634 30.9564 61.9724 31.3974 61.837C31.8385 61.702 32.1929 61.3489 32.3852 60.9326C32.5773 60.516 32.6182 60.0418 32.5641 59.5868C32.5501 59.4694 32.5058 59.1766 32.3429 59.1594C32.1935 59.1442 32.1423 59.3563 32.0935 59.4602C31.9531 59.7586 31.7984 60.0418 31.5984 60.3059C31.4043 60.5615 31.1809 60.7952 30.9333 61.0001C30.8641 61.0577 30.1794 61.5826 30.125 61.523Z"
            fill="#E9E9E8"
          />
          <path
            d="M33.0281 59.2775C33.2322 59.5891 33.256 60.0089 33.0887 60.3417C32.9788 60.5602 32.7978 60.7347 32.6133 60.8965C32.485 61.0088 32.3143 61.1246 32.1562 61.0591C31.9856 60.9888 31.9584 60.7643 31.9611 60.5809C31.9647 60.2985 31.9762 60.0165 31.9954 59.7349C32.0114 59.504 31.9775 59.1285 32.0734 58.9172C32.1638 58.7186 32.3566 58.7917 32.5655 58.886C32.7522 58.9703 32.9163 59.1061 33.0281 59.2775Z"
            fill="#E9E9E8"
          />
          <path
            d="M30.1321 61.0322C29.8714 61.0322 29.612 60.8932 29.4745 60.6723C29.3604 60.4882 29.2693 59.9856 29.5162 59.875C29.7127 60.3004 29.886 60.6879 30.2301 61.0254C30.1975 61.0298 30.1648 61.0322 30.1321 61.0322Z"
            fill="#EDEDEC"
          />
          <path
            d="M32.1797 60.6523C32.25 60.449 32.2957 60.2369 32.3163 60.0228C32.33 59.8806 32.2548 59.549 32.31 59.4308C32.3421 59.3621 32.3753 59.3337 32.4078 59.3337C32.5465 59.3337 32.6739 59.8506 32.6589 59.9776C32.6255 60.2629 32.4388 60.5253 32.1797 60.6523Z"
            fill="#EDEDEC"
          />
          <path
            d="M31.0531 61.7109C30.8621 61.7109 30.6792 61.6394 30.4297 61.5851C30.4297 61.5851 31.0258 61.5675 31.2193 61.3123C31.3115 61.365 31.4173 61.3906 31.5235 61.3906C31.6984 61.3906 31.8745 61.3215 31.9925 61.1924C31.9909 61.3446 31.5461 61.5527 31.4088 61.6211C31.2777 61.6866 31.164 61.7109 31.0531 61.7109Z"
            fill="#EDEDEC"
          />
          <path
            d="M33.3806 76.7363L31.33 65.3922L31.2812 61.8378L31.5107 61.8346L31.5592 65.3731L33.6404 76.9121L33.3806 76.7363Z"
            fill="#E3E3E2"
          />
          <path
            d="M31.5221 65.2978L31.3682 65.4668C31.1461 65.2675 30.929 64.9942 30.6774 64.6778C30.2885 64.1885 29.8476 63.634 29.25 63.1806L29.3892 62.9997C30.0101 63.4707 30.4601 64.0371 30.8576 64.5368C31.1028 64.8448 31.3144 65.1113 31.5221 65.2978Z"
            fill="#E3E3E2"
          />
          <path
            d="M31.3826 63.7533C31.6722 63.6186 31.9094 63.377 32.0372 63.0865C32.1825 62.7566 32.1856 62.3843 32.1862 62.0244C31.8133 62.2125 31.3548 62.0995 30.9544 62.2201C30.6354 62.3164 30.3681 62.5684 30.255 62.88C30.1088 63.2831 30.0981 63.7129 30.3173 63.8455C30.4978 63.955 30.9956 63.933 31.3826 63.7533Z"
            fill="#E9E9E8"
          />
          <path
            d="M29.7185 63.2451C29.3961 63.5399 28.9386 63.6829 28.5043 63.625C28.0697 63.5667 27.8374 62.9767 27.6055 62.6076C27.9637 62.4646 28.9177 62.3467 29.1354 62.3287C29.3532 62.3112 29.588 62.3679 29.7361 62.5273C29.8844 62.6863 29.9128 62.9603 29.7616 63.1169L29.7185 63.2451Z"
            fill="#E9E9E8"
          />
          <path
            d="M27.9632 64.2477C28.1583 63.9014 28.736 63.5714 29.1357 63.571C29.5356 63.5706 29.9144 63.7751 30.1109 64.0643C30.0532 64.3268 29.8047 64.5141 29.5429 64.5809C29.2809 64.648 29.0049 64.6176 28.7362 64.5868C28.4678 64.5557 28.1918 64.5249 27.9297 64.592L27.9632 64.2477Z"
            fill="#E9E9E8"
          />
          <path
            d="M34.2209 69.7767H31.8144C31.6338 69.7727 31.4727 69.8881 31.419 70.0591C31.2216 70.6787 30.8008 72.3081 30.8008 74.8747C30.8008 77.6941 31.5415 81.4375 31.7746 82.5433C31.8137 82.7294 31.9782 82.8636 32.1699 82.8652H33.8454C34.0369 82.8636 34.2014 82.7294 34.2406 82.5433C34.4736 81.4375 35.2147 77.6941 35.2147 74.8747C35.2147 72.3081 34.7937 70.6787 34.5963 70.0591C34.5442 69.8953 34.3937 69.7819 34.2209 69.7767Z"
            fill="#F4F4F4"
          />
          <path
            d="M178.544 144.102C178.544 146.6 143.601 148.625 100.497 148.625C57.3922 148.625 22.4492 146.6 22.4492 144.102C22.4492 141.604 57.3922 139.579 100.497 139.579C143.601 139.579 178.544 141.604 178.544 144.102Z"
            fill="#F8F8F9"
          />
          <path
            d="M48.4826 128.555C48.3457 128.546 48.239 128.431 48.2423 128.294C48.5401 116.553 49.1504 97.294 49.1822 97.1886C49.2228 97.0536 49.3661 96.98 49.5018 97.0168C49.6374 97.0567 49.7155 97.199 49.6757 97.334C49.668 97.3599 49.0518 116.686 48.7567 128.307C48.7535 128.447 48.6351 128.559 48.493 128.556L48.4826 128.555Z"
            fill="#1D2A30"
          />
          <path
            d="M46.8927 89.3496C46.9917 90.254 48.0826 93.389 48.9939 93.2907C49.9049 93.192 50.2913 89.898 50.1923 88.994C50.0932 88.0896 49.2741 87.4361 48.3631 87.5344C47.4518 87.6326 46.7936 88.446 46.8927 89.3496Z"
            fill="#4870C0"
          />
          <path
            d="M51.3147 99.2391C51.2157 98.3351 50.1248 95.2001 49.2139 95.2983C48.3025 95.3966 47.9161 98.691 48.0151 99.5954C48.1141 100.499 48.9333 101.153 49.8446 101.055C50.7556 100.956 51.4141 100.143 51.3147 99.2391Z"
            fill="#4870C0"
          />
          <path
            d="M44.1206 96.4892C45.032 96.391 48.1907 95.3084 48.0912 94.404C47.9922 93.5 44.6729 93.1161 43.7616 93.2148C42.8502 93.3131 42.1921 94.1256 42.2911 95.03C42.3905 95.9344 43.2093 96.5875 44.1206 96.4892Z"
            fill="#4870C0"
          />
          <path
            d="M54.0905 92.0992C53.1791 92.1975 50.0204 93.2801 50.1195 94.1845C50.2189 95.0885 53.5382 95.4719 54.4495 95.3737C55.3605 95.2754 56.019 94.4625 55.92 93.5581C55.8206 92.6541 55.0014 92.001 54.0905 92.0992Z"
            fill="#4870C0"
          />
          <path
            d="M44.0181 92.3502C44.7326 92.9202 47.7379 94.3715 48.3119 93.6625C48.8863 92.9534 46.8125 90.3529 46.098 89.7828C45.3835 89.2132 44.3389 89.3258 43.7645 90.0349C43.1904 90.7439 43.304 91.7802 44.0181 92.3502Z"
            fill="#4870C0"
          />
          <path
            d="M54.1896 96.239C53.4755 95.6694 50.4706 94.2185 49.8962 94.9272C49.3218 95.6362 51.3956 98.2364 52.1101 98.8064C52.8246 99.3764 53.8692 99.2638 54.4432 98.5547C55.0181 97.8457 54.9041 96.8091 54.1896 96.239Z"
            fill="#4870C0"
          />
          <path
            d="M47.1445 99.3426C47.7189 98.6339 49.1813 95.6515 48.4668 95.0818C47.7523 94.5118 45.1322 96.5703 44.5574 97.2789C43.9834 97.988 44.0969 99.0246 44.8114 99.5946C45.5259 100.165 46.5705 100.052 47.1445 99.3426Z"
            fill="#4870C0"
          />
          <path
            d="M51.0654 89.2472C50.4914 89.9562 49.0286 92.9382 49.7435 93.5079C50.4576 94.0779 53.0781 92.0199 53.6525 91.3108C54.2265 90.6018 54.113 89.5647 53.3985 88.9951C52.6844 88.4255 51.6394 88.5381 51.0654 89.2472Z"
            fill="#4870C0"
          />
          <path
            d="M48.9518 93.293C48.7458 93.293 48.5312 93.1336 48.3219 92.8767C48.177 92.4461 47.871 91.9248 47.5228 91.429C47.1831 90.6161 46.9376 89.7569 46.8929 89.3498C46.8864 89.2899 46.8832 89.2304 46.8828 89.1713C46.8824 88.3412 47.5128 87.6265 48.3633 87.5346C48.4241 87.5282 48.4845 87.525 48.5445 87.525C49.381 87.525 50.1003 88.1502 50.1925 88.9943C50.2025 89.0862 50.2078 89.2024 50.2078 89.3378C50.2078 89.802 50.1482 90.4883 50.0274 91.159C49.7948 91.7175 49.6092 92.2915 49.5609 92.7429C49.5178 92.8284 49.4727 92.9059 49.4252 92.9742C49.2976 93.1579 49.1539 93.2734 48.9941 93.291C48.98 93.2922 48.9659 93.293 48.9518 93.293Z"
            fill="#4164E3"
          />
          <path
            d="M49.6633 101.064C49.6267 101.064 49.5904 101.063 49.5542 101.061C49.3771 101.049 49.2064 101.01 49.0474 100.946C48.4971 100.726 48.0837 100.221 48.0153 99.5952C48.0052 99.5033 48 99.3867 48 99.2517C48 98.7871 48.0596 98.1012 48.1803 97.4305C48.413 96.872 48.599 96.2976 48.6469 95.8462C48.8059 95.5302 48.9947 95.3217 49.214 95.2981C49.2281 95.2965 49.2418 95.2957 49.2563 95.2957C49.4624 95.2957 49.677 95.4555 49.8863 95.712C50.0308 96.1426 50.3367 96.6639 50.6849 97.1601C51.0247 97.9726 51.2706 98.8318 51.3149 99.2389C51.3217 99.2992 51.3249 99.3587 51.3249 99.4178C51.3258 100.248 50.6954 100.962 49.8448 101.054C49.7836 101.061 49.7233 101.064 49.6633 101.064Z"
            fill="#4164E3"
          />
          <path
            d="M43.9389 96.499C43.7211 96.499 43.511 96.4563 43.3182 96.3788C42.7703 96.1583 42.3593 95.6537 42.2909 95.0298C42.2845 94.9699 42.2813 94.9099 42.2813 94.8512C42.2804 94.0207 42.9108 93.3065 43.7614 93.2146C43.8544 93.2046 43.9719 93.1994 44.1092 93.1994C44.5769 93.1994 45.2673 93.2585 45.9423 93.378C46.5055 93.6093 47.0847 93.7938 47.5396 93.8414C47.8576 93.9992 48.0673 94.1865 48.0911 94.4038C48.0927 94.4178 48.0935 94.4322 48.0935 94.4462C48.0935 94.6507 47.9325 94.8636 47.674 95.0713C47.2401 95.2147 46.7148 95.5183 46.2148 95.8643C45.3961 96.2014 44.5306 96.4451 44.1204 96.489C44.0592 96.4958 43.9989 96.499 43.9389 96.499Z"
            fill="#4164E3"
          />
          <path
            d="M54.1031 95.3887C53.6354 95.3887 52.9446 95.3296 52.2691 95.2101C51.706 94.9788 51.1267 94.7943 50.6715 94.7467C50.3535 94.5889 50.1434 94.4016 50.1196 94.1843C50.118 94.1699 50.1172 94.1559 50.1172 94.1415C50.1176 93.9374 50.2782 93.7245 50.5366 93.5172C50.9706 93.3738 51.4963 93.0702 51.9962 92.7238C52.815 92.3871 53.6804 92.1434 54.0906 92.0991C54.1518 92.0927 54.2122 92.0895 54.2722 92.0895C55.1082 92.0895 55.8276 92.7142 55.9201 93.5579C55.9266 93.6182 55.9298 93.6778 55.9298 93.7369C55.9306 94.567 55.3002 95.282 54.4497 95.3735C54.3571 95.3835 54.2396 95.3887 54.1031 95.3887Z"
            fill="#4164E3"
          />
          <path
            d="M47.7567 93.8535C47.6887 93.8535 47.617 93.8495 47.5417 93.8415C47.0869 93.794 46.5076 93.6094 45.9445 93.3781C45.1253 93.0418 44.3396 92.6068 44.0179 92.3503C43.6106 92.0252 43.3988 91.5486 43.3984 91.0672C43.398 90.7045 43.5176 90.3398 43.7643 90.035C44.0924 89.6299 44.5734 89.4198 45.0589 89.4198C45.424 89.4198 45.7911 89.5385 46.0978 89.7829C46.4195 90.0398 47.0164 90.7077 47.5236 91.4295C47.8718 91.9253 48.1777 92.4466 48.3227 92.8772C48.3794 93.0462 48.4112 93.2012 48.4112 93.3354C48.4112 93.4668 48.3802 93.5783 48.3118 93.6626C48.2031 93.7968 48.0075 93.8535 47.7567 93.8535Z"
            fill="#4164E3"
          />
          <path
            d="M53.1492 99.1699C53.0743 99.1699 52.9991 99.1647 52.9242 99.1547C52.6356 99.1156 52.3538 99.0005 52.1102 98.8064C51.9351 98.6666 51.6775 98.4041 51.3978 98.0778C51.1643 97.8053 50.9151 97.4882 50.6845 97.1602C50.3363 96.6641 50.0303 96.1428 49.8858 95.7121C49.8291 95.5436 49.7969 95.3886 49.7969 95.2543C49.7969 95.1229 49.8279 95.0119 49.8963 94.9272C50.005 94.793 50.201 94.7362 50.4518 94.7362C50.5194 94.7362 50.5915 94.7402 50.6664 94.7482C51.1216 94.7957 51.7009 94.9803 52.264 95.2116C53.0828 95.5475 53.8685 95.9826 54.1898 96.239C54.5975 96.5642 54.8093 97.0412 54.8097 97.5225C54.8101 97.8848 54.6905 98.2499 54.4433 98.5547C54.1157 98.9594 53.6347 99.1699 53.1492 99.1699Z"
            fill="#4164E3"
          />
          <path
            d="M45.8503 99.958C45.4852 99.9576 45.118 99.839 44.8113 99.5945C44.4039 99.2693 44.1918 98.7928 44.1914 98.3114C44.191 97.9487 44.3106 97.5836 44.5573 97.2788C44.8161 96.9596 45.4888 96.3672 46.2162 95.8643C46.7161 95.5183 47.2414 95.2147 47.6754 95.0713C47.8456 95.015 48.0018 94.983 48.1367 94.983C48.2691 94.983 48.3814 95.0138 48.4667 95.0817C48.602 95.1896 48.6592 95.3841 48.6592 95.6334C48.6592 95.7005 48.6551 95.7716 48.6471 95.8463C48.5992 96.2977 48.4132 96.8721 48.1805 97.4306C47.8416 98.2435 47.4032 99.0233 47.1444 99.3424C46.9363 99.5997 46.6662 99.7782 46.3723 99.8745C46.2037 99.9296 46.0274 99.958 45.8503 99.958Z"
            fill="#4164E3"
          />
          <path
            d="M50.0733 93.6064C49.9408 93.6064 49.8285 93.5757 49.7436 93.5078C49.6079 93.3999 49.5508 93.2054 49.5508 92.9561C49.5508 92.889 49.5552 92.8179 49.5629 92.7432C49.6112 92.2918 49.7967 91.7178 50.0294 91.1593C50.3683 90.346 50.8071 89.5662 51.0655 89.2471C51.3932 88.842 51.8746 88.6319 52.3601 88.6319C52.7248 88.6319 53.0923 88.7505 53.3986 88.995C53.8064 89.3198 54.0181 89.7967 54.0185 90.2781C54.0189 90.6408 53.8994 91.0059 53.6526 91.3107C53.3942 91.6299 52.7212 92.2223 51.9938 92.7252C51.4938 93.0716 50.9681 93.3752 50.5342 93.5186C50.3643 93.5749 50.2081 93.6064 50.0733 93.6064Z"
            fill="#4164E3"
          />
          <path
            d="M47.1484 94.5054C47.2659 95.576 48.2356 96.3501 49.3148 96.2335C50.394 96.1172 51.1737 95.1545 51.0562 94.0836C50.9391 93.0126 49.9689 92.2388 48.8897 92.3555C47.8105 92.4721 47.0312 93.4344 47.1484 94.5054Z"
            fill="#F8F8F9"
          />
          <path
            d="M47.3456 119.952C45.0773 120.001 41.1968 117.922 39.6701 115.893C38.1206 113.834 42.466 115.102 42.0152 113.482C41.5644 111.864 36.2153 113.077 35.2208 110.758C34.2262 108.44 38.0895 108.963 37.9329 107.777C37.7761 106.591 33.7759 106.844 32.4842 104.38C31.1925 101.917 34.7159 103.289 34.1605 102.268C33.605 101.247 29.1813 96.9561 31.0247 96.0541C32.8678 95.1513 37.0163 99.6213 38.4032 100.117C39.0134 100.336 39.4161 99.8586 39.8297 99.3813C40.3559 98.7737 40.9002 98.1661 41.9117 98.9926C43.7191 100.469 42.3887 106.944 44.5133 107.792C45.2926 108.103 45.5229 107.543 45.7737 106.983C46.0321 106.406 46.3119 105.828 47.2369 106.205C50.4258 107.505 48.2662 119.932 47.3456 119.952Z"
            fill="#4870C0"
          />
          <path
            d="M47.2707 119.953C44.143 108.289 36.5604 100.833 36.4669 100.743C36.4322 100.709 36.3872 100.692 36.342 100.692C36.2954 100.692 36.2489 100.71 36.2133 100.746C36.1443 100.816 36.1459 100.929 36.2168 100.998C36.3088 101.087 43.7787 108.437 46.896 119.936C45.4018 119.808 43.4036 118.942 41.795 117.831C40.9264 117.231 40.1716 116.559 39.6701 115.893C39.4341 115.579 39.3349 115.343 39.3347 115.162C39.3334 114.213 42.0478 114.778 42.0482 113.704C42.0482 113.637 42.0378 113.563 42.0152 113.483C41.6847 112.295 38.7188 112.631 36.7688 111.98C36.0789 111.75 35.5163 111.396 35.2424 110.807C35.235 110.791 35.2277 110.775 35.2208 110.758C35.1071 110.494 35.057 110.266 35.0568 110.069C35.0565 108.571 37.9401 108.816 37.9375 107.844C37.9375 107.823 37.9359 107.8 37.9329 107.777C37.7762 106.591 33.776 106.844 32.4842 104.38C32.2812 103.993 32.1971 103.701 32.1976 103.479C32.1995 102.394 34.2195 102.996 34.2205 102.458C34.2206 102.406 34.2019 102.344 34.1605 102.268C33.745 101.504 31.1657 98.9115 30.6631 97.2753C30.6085 97.098 30.5783 96.9318 30.5781 96.7804C30.5777 96.4612 30.7098 96.2083 31.0247 96.0541C31.193 95.9715 31.3802 95.9339 31.5829 95.9339C33.602 95.9339 37.1428 99.6665 38.4032 100.118C38.5079 100.155 38.6067 100.172 38.7004 100.172C39.1521 100.172 39.4873 99.7768 39.8297 99.3813C40.1724 98.9858 40.5226 98.5904 41.0041 98.5904C41.2625 98.5904 41.5587 98.7042 41.9118 98.9926C43.7192 100.469 42.3888 106.944 44.5134 107.792C44.6679 107.854 44.8008 107.881 44.9163 107.881C45.3849 107.881 45.5724 107.432 45.7737 106.983C45.9746 106.534 46.1887 106.084 46.7092 106.084C46.8577 106.084 47.0312 106.121 47.2369 106.205C48.1301 106.569 48.6039 107.807 48.8028 109.4C48.8132 110.046 48.8515 110.698 48.9179 111.342C48.9183 111.386 48.9183 111.431 48.9183 111.475C48.9183 112.871 48.7875 114.354 48.5943 115.683C48.4027 117.002 48.1495 118.169 47.9007 118.948C47.7014 119.573 47.505 119.949 47.3456 119.952C47.3206 119.953 47.2957 119.953 47.2707 119.953Z"
            fill="#4164E3"
          />
          <path
            d="M50.6019 117.096C50.6401 117.159 50.3004 117.478 51.4203 117.524C54.1776 117.637 59.0539 117.452 60.8851 114.964C63.4992 111.412 57.4696 111.738 58.0561 109.779C58.6422 107.82 65.1202 109.42 66.3845 106.623C67.6489 103.827 62.9376 104.372 63.1558 102.933C63.3744 101.495 68.3175 103.359 69.9466 100.392C71.576 97.426 67.258 99.0131 67.9576 97.7843C68.6573 96.5551 74.1394 91.4383 71.9182 90.2979C69.6974 89.1574 64.5462 94.4987 62.8474 95.0703C62.0766 95.3296 61.5746 94.392 61.0473 93.4549C60.4133 92.3268 59.7423 91.1987 58.523 92.1562C56.2901 93.909 57.7554 101.817 55.1514 102.799C54.0887 103.2 53.9256 102.53 53.602 101.861C53.3351 101.308 52.9583 100.756 51.8759 100.805C48.6246 100.953 47.5551 112.042 50.6019 117.096Z"
            fill="#4870C0"
          />
          <path
            d="M52.6049 117.549C52.5622 117.549 52.5199 117.549 52.4777 117.549C52.1013 117.547 51.7459 117.538 51.4202 117.524C51.2213 117.516 51.0684 117.499 50.9512 117.477C50.6409 117.418 50.5817 117.318 50.5817 117.235C50.5817 117.183 50.6051 117.137 50.6051 117.11C50.6051 117.105 50.6039 117.1 50.6018 117.096C49.6829 115.572 49.1382 113.499 48.9152 111.342C48.8488 110.698 48.8106 110.046 48.8001 109.4C48.7977 109.271 48.7969 109.142 48.7969 109.013C48.7973 104.793 49.9566 100.893 51.8759 100.805C51.9214 100.803 51.9652 100.802 52.0079 100.802C52.9897 100.802 53.3459 101.332 53.6019 101.861C53.858 102.391 54.0133 102.92 54.593 102.92C54.7464 102.92 54.9291 102.883 55.1513 102.799C57.7553 101.817 56.2901 93.9092 58.523 92.1563C58.8458 91.9026 59.1296 91.7956 59.3852 91.7956C60.0944 91.7956 60.5807 92.6253 61.0473 93.455C61.5138 94.2843 61.9606 95.1139 62.5918 95.1139C62.6739 95.1139 62.7588 95.1 62.8474 95.0704C64.3831 94.5535 68.7405 90.139 71.2032 90.139C71.4649 90.139 71.7052 90.1885 71.9181 90.298C72.2889 90.4885 72.4451 90.7897 72.4447 91.1656C72.4434 91.7193 72.1021 92.4347 71.6062 93.1941C70.4251 95.0037 68.3682 97.063 67.9576 97.7844C67.9045 97.8779 67.8803 97.955 67.8803 98.0193C67.8811 98.662 70.3148 97.9933 70.3169 99.2824C70.3173 99.5548 70.2094 99.9144 69.9465 100.393C69.1801 101.788 67.6798 102.115 66.2834 102.218C65.3033 102.292 64.3742 102.255 63.7857 102.402C63.4307 102.491 63.1996 102.647 63.1557 102.933C63.1509 102.965 63.1485 102.997 63.1485 103.027C63.1465 104.189 66.6043 103.975 66.6002 105.763C66.5998 106.009 66.5338 106.292 66.3845 106.623C66.3539 106.691 66.3201 106.756 66.2834 106.819C65.8153 107.62 64.8726 108.019 63.7857 108.25C62.2496 108.578 60.4249 108.571 59.2447 108.9C59.1706 108.92 59.099 108.942 59.0301 108.966C58.5282 109.136 58.1735 109.386 58.056 109.779C58.0286 109.871 58.0158 109.957 58.0158 110.04C58.0158 111.4 61.546 111.566 61.5456 113.389C61.5452 113.813 61.3548 114.326 60.885 114.964C60.429 115.584 59.7841 116.061 59.0301 116.426C58.5576 116.655 58.0423 116.839 57.5037 116.988C55.904 117.428 54.0999 117.549 52.6049 117.549Z"
            fill="#4164E3"
          />
          <path
            d="M48.5353 126.78L48.5204 126.779C48.4226 126.767 48.3526 126.679 48.3646 126.581C50.6281 108.199 61.2977 100.728 61.4052 100.654C61.4869 100.599 61.5984 100.619 61.6544 100.7C61.7107 100.781 61.6902 100.892 61.6085 100.947C61.5022 101.02 50.963 108.411 48.7205 126.624C48.7092 126.717 48.6279 126.784 48.5353 126.78Z"
            fill="#1D2A30"
          />
          <path
            d="M58.977 103.209C58.9041 103.206 58.8373 103.159 58.8135 103.086C58.783 102.992 58.8341 102.892 58.9287 102.861C58.9947 102.84 60.5839 102.341 63.1871 102.89C63.2841 102.911 63.3457 103.005 63.3256 103.101C63.305 103.197 63.2096 103.259 63.1126 103.238C60.6109 102.712 59.0547 103.195 59.0394 103.2L58.977 103.209Z"
            fill="#1D2A30"
          />
          <path
            d="M57.005 105.441C56.91 105.437 56.8339 105.36 56.8327 105.265C56.7776 99.7058 60.0208 95.3624 60.0534 95.3193C60.1126 95.2406 60.2257 95.2246 60.3046 95.2841C60.3839 95.3429 60.3996 95.4547 60.34 95.533C60.3082 95.5753 57.1378 99.8269 57.1914 105.262C57.1926 105.36 57.1133 105.441 57.0143 105.441H57.005Z"
            fill="#1D2A30"
          />
          <path
            d="M53.8285 110.146C53.783 110.144 53.7387 110.125 53.7053 110.09C53.6372 110.019 53.6405 109.906 53.7121 109.839C53.7363 109.816 56.1374 107.614 59.2808 108.732C59.3742 108.765 59.4225 108.867 59.3891 108.959C59.3557 109.052 59.253 109.1 59.16 109.067C56.2207 108.021 53.9806 110.077 53.9585 110.098C53.9218 110.132 53.8747 110.148 53.8285 110.146Z"
            fill="#1D2A30"
          />
          <path
            d="M52.1644 113.43C52.0976 113.427 52.0348 113.387 52.0067 113.322C51.9563 113.205 50.7809 110.41 51.4286 106.427C51.4443 106.331 51.5333 106.263 51.6343 106.28C51.7321 106.296 51.7985 106.388 51.7828 106.485C51.1521 110.359 52.3247 113.155 52.3367 113.182C52.3754 113.272 52.3331 113.377 52.2417 113.415L52.1644 113.43Z"
            fill="#1D2A30"
          />
          <path
            d="M48.6075 133.347C48.5146 133.344 48.4389 133.269 48.4361 133.175L48.2034 128.306C47.5167 112.118 36.3271 101.107 36.2144 100.998C36.1435 100.93 36.1419 100.817 36.2109 100.747C36.2807 100.676 36.3939 100.675 36.4645 100.744C36.5785 100.854 47.8689 111.958 48.5613 128.294L48.7943 133.164C48.7971 133.262 48.7199 133.344 48.6204 133.348L48.6075 133.347Z"
            fill="#1D2A30"
          />
          <path
            d="M40.8293 107.079L40.7996 107.075L40.7476 107.056L40.6897 107.033C39.2249 106.429 37.588 106.115 36.0818 106.148C35.981 106.153 35.9007 106.072 35.8985 105.974C35.8963 105.875 35.9747 105.794 36.0738 105.792C37.6294 105.759 39.3172 106.081 40.8273 106.704L40.8869 106.728L40.9179 106.742C40.9883 106.778 41.029 106.857 41.0121 106.938C40.994 107.024 40.9151 107.083 40.8293 107.079Z"
            fill="#1D2A30"
          />
          <path
            d="M42.4103 109.164L42.4014 109.163C42.3028 109.154 42.23 109.068 42.2388 108.97C42.6723 104.192 40.1786 100.261 40.1533 100.221C40.0999 100.139 40.1243 100.029 40.2076 99.9757C40.2913 99.923 40.402 99.9474 40.4552 100.03C40.4813 100.07 43.0407 104.099 42.5963 109.002C42.5874 109.097 42.5053 109.168 42.4103 109.164Z"
            fill="#1D2A30"
          />
          <path
            d="M44.043 111.933C43.9995 111.931 43.9561 111.913 43.9231 111.88C43.9049 111.862 42.0879 110.082 39.4287 110.785C39.3327 110.811 39.235 110.753 39.2092 110.659C39.1837 110.564 39.2408 110.467 39.3362 110.441C42.203 109.682 44.099 111.55 44.1783 111.63C44.2479 111.7 44.2471 111.812 44.1767 111.881C44.14 111.917 44.0913 111.934 44.043 111.933Z"
            fill="#1D2A30"
          />
          <path
            d="M46.1171 116.494L46.0415 116.474C45.9537 116.428 45.9199 116.321 45.9658 116.234C45.9783 116.21 47.2096 113.821 46.9287 110.376C46.9206 110.277 46.9943 110.192 47.0933 110.184C47.1923 110.172 47.2785 110.249 47.2861 110.347C47.5759 113.901 46.3365 116.298 46.2834 116.398C46.2504 116.462 46.1844 116.497 46.1171 116.494Z"
            fill="#1D2A30"
          />
          <path
            d="M58.6948 134.113C58.6948 139.792 56.1214 144.396 48.3279 144.396C40.8895 144.396 37.9609 139.792 37.9609 134.113C37.9609 131.972 38.624 129.979 39.7522 128.332H56.9036C58.0319 129.979 58.6948 131.972 58.6948 134.113Z"
            fill="#4870C0"
          />
          <path
            d="M48.3279 144.396C40.8895 144.396 37.9609 139.792 37.9609 134.113C37.9609 131.972 38.624 129.979 39.7522 128.332H56.9036C58.0319 129.979 58.6948 131.972 58.6948 134.113C58.6948 134.716 58.6659 135.306 58.6047 135.88C58.6011 135.913 58.5974 135.946 58.5938 135.98C58.0512 140.767 55.2467 144.396 48.3279 144.396Z"
            fill="#4164E3"
          />
          <path
            d="M118.251 139.377L122.261 138.796L121.248 129.488L117.238 130.069L118.251 139.377Z"
            fill="#F7B5BF"
          />
          <path
            d="M125.904 138.002C125.965 137.987 126.028 137.989 126.087 138.007C126.129 138.02 126.161 138.055 126.17 138.098C126.203 138.208 126.181 138.328 126.111 138.419C125.904 138.674 125.25 138.817 124.337 138.817C124.813 138.456 125.347 138.179 125.916 137.996L125.904 138.002ZM125.34 138.935C125.689 138.91 126.018 138.768 126.274 138.532C126.384 138.395 126.418 138.214 126.367 138.046C126.344 137.942 126.268 137.856 126.166 137.821C125.63 137.631 124.163 138.704 124 138.825C123.968 138.85 123.954 138.891 123.964 138.93C123.977 138.968 124.013 138.993 124.054 138.994C124.483 139.013 124.914 138.994 125.34 138.935Z"
            fill="#4870C0"
          />
          <path
            d="M124.75 137.233L124.804 137.208C124.981 137.2 125.001 137.266 125.007 137.288C125.101 137.552 124.57 138.331 124.127 138.691C124.086 138.232 124.193 137.773 124.433 137.379C124.519 137.291 124.635 137.237 124.758 137.229L124.75 137.233ZM124.076 138.998L124.109 138.982C124.554 138.692 125.356 137.679 125.205 137.241C125.159 137.143 125.075 137.017 124.807 137.033C124.612 137.036 124.427 137.121 124.3 137.267C123.866 137.762 123.952 138.851 123.953 138.896L123.993 138.982L124.076 138.998Z"
            fill="#4870C0"
          />
          <path
            d="M121.849 137.147L118.293 137.988C118.133 138.02 118.024 138.168 118.041 138.33L118.156 143.435C118.205 143.793 118.537 144.043 118.898 143.994L118.972 143.98C120.512 143.599 121.239 143.339 123.198 142.891C124.398 142.617 128.201 142.332 129.758 141.644C131.316 140.956 130.709 139.389 129.998 139.537C127.714 140.025 124.778 139.054 123.11 137.577C122.884 137.466 122.093 137.084 121.849 137.147Z"
            fill="#1D2A30"
          />
          <path
            d="M117.74 134.727L117.594 133.384H117.595L117.74 134.727Z"
            fill="#CECDCC"
          />
          <path
            d="M117.759 134.87L117.744 134.725L117.598 133.383L121.59 132.644L121.768 134.285L117.759 134.87Z"
            fill="#C48F94"
          />
          <path
            d="M123.386 132.311L115.968 133.686C115.968 133.686 112.365 128.581 111.686 124.957C110.978 121.184 111.734 108.336 111.686 108.166C109.587 101.136 103.886 82.9191 101.133 76.2156C99.609 72.5009 98.5391 69.9999 98.5391 69.9999L99.3099 69.8281L105.365 67.3666L109.778 68.1919C109.778 68.1919 123.188 95.1012 124.593 105.224C125.642 112.782 123.386 132.311 123.386 132.311Z"
            fill="#4870C0"
          />
          <path
            d="M115.968 133.686C115.968 133.686 112.365 128.581 111.686 124.957C111.458 123.743 111.382 121.59 111.382 119.221C111.381 114.458 111.688 108.827 111.688 108.218C111.688 108.189 111.688 108.171 111.686 108.166C110.828 105.293 109.369 100.55 107.755 95.4899C108.597 97.8592 109.351 100.111 109.938 102.078C109.939 102.079 109.939 102.08 109.939 102.08C109.981 102.08 109.647 93.0156 106.505 87.022L106.288 86.5446C106.855 81.7227 107.012 77.8015 107.012 74.9393C107.012 71.3912 106.77 69.4686 106.77 69.4686L100.227 69.4554L101.571 68.9089C104.777 68.8039 108.344 68.6493 109.772 68.4503C109.772 68.4503 109.776 68.3613 109.782 68.1995C110.032 68.7028 123.201 95.1975 124.593 105.224C124.791 106.648 124.871 108.498 124.871 110.562C124.871 113.68 124.689 117.288 124.452 120.657C124.152 124.9 123.767 128.766 123.551 130.802C123.548 130.836 123.544 130.869 123.541 130.902C123.446 131.797 123.386 132.311 123.386 132.311L121.588 132.644L117.596 133.384H117.594L115.968 133.686Z"
            fill="#4164E3"
          />
          <path
            d="M107.757 95.4893C107.143 93.7612 106.482 91.9707 105.805 90.1815C105.83 90.0138 105.854 89.8456 105.878 89.6794C106.51 91.6052 107.145 93.5702 107.757 95.4893Z"
            fill="#CECDCC"
          />
          <path
            d="M109.938 102.08C109.937 102.08 109.937 102.08 109.937 102.078C109.35 100.111 108.595 97.8597 107.753 95.4905C107.141 93.5714 106.507 91.6064 105.875 89.6806C106.032 88.5968 106.168 87.5518 106.286 86.5452L106.503 87.0225C109.645 93.0161 109.979 102.08 109.938 102.08Z"
            fill="#254B96"
          />
          <path
            d="M77.3828 137.184L80.9561 138.679L84.7698 130.558L81.1964 129.064L77.3828 137.184Z"
            fill="#F7B5BF"
          />
          <path
            d="M84.2497 139.974C84.3044 139.996 84.3523 140.033 84.3881 140.08C84.4131 140.114 84.4175 140.159 84.4002 140.197C84.3628 140.301 84.2778 140.38 84.1712 140.412C83.8672 140.493 83.2796 140.237 82.5751 139.725C83.1479 139.713 83.7183 139.798 84.2625 139.977L84.2497 139.974ZM83.2824 140.378C83.5662 140.554 83.9011 140.629 84.2332 140.591C84.3958 140.546 84.5258 140.426 84.581 140.268C84.6232 140.174 84.6131 140.065 84.5544 139.981C84.2485 139.534 82.5055 139.539 82.3102 139.541C82.2712 139.543 82.237 139.566 82.2225 139.602C82.2116 139.639 82.2249 139.679 82.2563 139.702C82.5767 139.958 82.9205 140.184 83.2824 140.378Z"
            fill="#4870C0"
          />
          <path
            d="M83.7952 138.733L83.8508 138.745C83.9916 138.838 83.9707 138.899 83.9623 138.92C83.8842 139.178 83.0304 139.481 82.4837 139.51C82.7132 139.133 83.0574 138.838 83.4667 138.669C83.5835 138.648 83.7038 138.672 83.8041 138.735L83.7952 138.733ZM82.2692 139.718L82.3034 139.725C82.8126 139.75 84.0093 139.418 84.1422 138.995C84.1623 138.894 84.1692 138.749 83.953 138.611C83.8004 138.504 83.6096 138.466 83.4281 138.508C82.811 138.646 82.2571 139.536 82.2322 139.571L82.2148 139.66L82.2692 139.718Z"
            fill="#4870C0"
          />
          <path
            d="M81.6028 137.039L78.3781 135.694C78.236 135.63 78.0677 135.683 77.9888 135.817L75.1698 139.823C75.004 140.127 75.1183 140.507 75.4246 140.671L75.4899 140.702C76.8963 141.271 77.6052 141.478 79.3727 142.231C80.4555 142.693 83.5539 144.606 85.1483 144.948C86.7432 145.29 87.167 143.74 86.5338 143.456C84.4918 142.551 82.7782 140.155 82.3322 138.079C82.2199 137.867 81.827 137.128 81.6028 137.039Z"
            fill="#1D2A30"
          />
          <path
            d="M82.8601 134.791L82.7969 134.763L83.2183 133.865L83.3009 133.909L82.8601 134.791Z"
            fill="#CECDCC"
          />
          <path
            d="M82.7946 134.763L79.3203 133.216L79.8774 132.099L83.2161 133.865L82.7946 134.763Z"
            fill="#C48F94"
          />
          <path
            d="M85.6688 135.162L78.552 131.397C78.552 131.397 77.187 126.369 78.552 123.162C81.1777 116.989 88.0104 107.914 88.0563 107.742C89.8793 100.638 93.0775 81.1809 94.1696 74.024C94.7762 70.0577 95.1324 69.2024 95.1324 69.2024L95.8836 69.4465L106.773 69.4681C106.773 69.4681 108.828 85.8331 100.954 111.171C98.9952 117.475 95.7129 122.717 90.3129 129.808C88.2624 132.501 85.6688 135.162 85.6688 135.162Z"
            fill="#4870C0"
          />
          <path
            d="M85.6688 135.162L83.2153 133.864L79.8767 132.098L78.5519 131.397C78.5519 131.397 77.9445 129.16 77.9453 126.719C77.9457 125.5 78.0975 124.23 78.5519 123.162C81.1777 116.989 88.0103 107.914 88.0562 107.742C89.8793 100.638 93.0774 81.1809 94.1695 74.024C94.7761 70.0577 95.1324 69.2024 95.1324 69.2024L95.8835 69.4465L106.773 69.4681C106.773 69.4681 107.014 71.3907 107.014 74.9388C107.014 77.801 106.858 81.7222 106.29 86.5441C106.172 87.5508 106.036 88.5958 105.879 89.6796C105.855 89.8457 105.831 90.0139 105.806 90.1817C105.267 93.8073 104.503 97.8443 103.431 102.243C102.74 105.074 101.922 108.055 100.954 111.171C100.947 111.194 100.94 111.216 100.933 111.239C100.299 113.267 99.5269 115.187 98.591 117.094C97.5154 119.286 96.2225 121.464 94.6727 123.772C93.7412 125.16 92.7172 126.595 91.5909 128.11C91.1787 128.665 90.7528 129.23 90.3128 129.808C90.0588 130.142 89.7972 130.474 89.5323 130.802C89.5057 130.835 89.4784 130.868 89.4518 130.902C87.6034 133.177 85.6688 135.162 85.6688 135.162Z"
            fill="#4164E3"
          />
          <path
            d="M116.422 56.0959C116.501 54.8823 117.312 53.3188 118.012 52.5966C118.237 52.3653 119.086 52.0142 119.567 51.7034C121.931 50.1638 126.664 48.2436 126.664 48.2436L128.124 49.5071C128.124 49.5071 125.241 52.2722 123.527 53.5984C123.189 53.8585 122.799 54.1753 122.388 54.5092C121.642 55.1268 118.131 57.4253 117.461 58.001L116.422 56.0959Z"
            fill="#F7B5BF"
          />
          <path
            d="M130.826 47.5292L128.125 49.5098L126.609 48.4024C126.609 48.4024 127.228 47.6207 127.863 47.0151C128.142 46.749 128.293 46.3823 128.296 45.9988C128.302 45.4084 128.391 44.7233 128.715 44.2208L128.734 44.1892C129.32 43.3136 130.689 43.5769 130.966 44.5895L131.356 46.0188C131.509 46.5825 131.299 47.1821 130.826 47.5292Z"
            fill="#F7B5BF"
          />
          <path
            d="M117.282 56.6323L116.57 57.2803C116.348 57.1037 115.996 56.8209 115.553 56.4558C112.083 53.5972 103.384 46.6632 106.852 44.6838C109.825 42.9877 112.981 48.1784 114.556 49.7375C114.876 50.0595 115.755 51.0645 116.463 52.3249C117.203 53.6483 117.753 55.2502 117.282 56.6323Z"
            fill="#1D2A30"
          />
          <path
            d="M116.464 51.7037C115.233 52.597 114.182 53.7338 113.391 55.0277C113.961 56.904 115.398 58.5362 117.209 59.3164C118.202 57.0303 118.664 54.5723 118.468 52.0904C117.84 51.9562 117.092 51.838 116.464 51.7037Z"
            fill="#1D2A30"
          />
          <path
            d="M97.3576 44.2798C96.1162 44.6756 94.6952 44.3585 93.8982 45.3827C93.1016 46.4069 92.8621 47.7587 92.8633 49.0526C92.8653 50.8522 93.2799 52.6231 93.6921 54.3755C94.1921 56.4999 94.692 58.6247 95.192 60.7494C95.5337 62.2015 95.1742 68.9549 95.5385 69.0684C95.5385 69.0684 106.918 68.8471 109.771 68.45C109.771 68.45 110.019 61.5076 110.248 59.1436C110.299 58.6187 111.101 56.3912 111.196 55.832C111.64 53.1943 110.769 51.3344 109.848 48.8213C109.848 48.8213 107.833 44.7951 106.85 44.6852C105.099 44.4887 100.817 43.1764 97.3576 44.2798Z"
            fill="#1D2A30"
          />
          <path
            d="M96.8834 47.6108C96.8432 47.3764 94.8237 43.3277 92.8879 46.158C90.1941 50.0967 90.0121 55.0422 90.0121 55.0422C90.0121 55.0422 88.3565 59.8509 89.5102 60.9007C90.6639 61.9509 91.9081 62.6269 92.7144 62.0316C93.5203 61.436 94.0431 60.246 94.0431 60.246C94.0431 60.246 97.5911 51.7314 96.8834 47.6108Z"
            fill="#1D2A30"
          />
          <path
            d="M96.7516 42.7779C95.9015 43.4359 96.0134 44.9602 96.9505 45.4891C96.715 46.3056 96.9903 47.2452 97.6304 47.8088C98.2704 48.3729 99.2429 48.5335 100.032 48.2047C99.691 48.8111 100.075 49.6124 100.665 49.9879C101.254 50.3634 101.981 50.4314 102.675 50.524C103.369 50.6163 104.102 50.7645 104.606 51.2471C105.322 50.2232 106.04 49.199 106.757 48.1752C107.036 47.7761 107.326 47.3487 107.348 46.8633C107.369 46.378 106.997 45.8431 106.51 45.8786C107.005 45.3653 107.016 44.4653 106.531 43.9412C106.047 43.4171 105.142 43.35 104.584 43.797C104.684 43.3863 104.442 42.9505 104.093 42.7092C103.744 42.468 103.309 42.3857 102.885 42.3445L96.7516 42.7779Z"
            fill="#1D2A30"
          />
          <path
            d="M98.0449 37.5649C98.6045 39.6034 99.2839 43.3619 97.9258 44.8476C97.9258 44.8476 101.769 46.3747 104.5 49.4395C105.772 48.2135 105.64 46.8365 105.25 45.8295C104.948 45.0493 104.3 44.4705 103.525 44.1437C102.029 43.5125 102.016 42.0513 102.265 40.6504L98.0449 37.5649Z"
            fill="#F7B5BF"
          />
          <path
            d="M99.4396 42.1592C99.2094 41.8672 99.0065 41.359 98.8789 41.0355L99.3004 41.1493C99.4167 41.2064 99.5379 41.262 99.6639 41.3167C99.9408 41.4369 100.218 41.5316 100.493 41.6023C100.168 41.7693 99.8905 41.9079 99.8905 41.9079L99.9021 41.9239L99.905 41.9271L99.9034 41.9275L99.4396 42.1592Z"
            fill="#C48F94"
          />
          <path
            d="M95.2966 35.8289C96.7928 38.9623 97.3588 40.3193 99.6621 41.3168C103.132 42.8243 106.673 40.3077 106.148 36.7936C105.677 33.6338 103.308 29.0395 99.625 29.0231C96.9933 28.9976 94.8389 31.0936 94.8127 33.7057C94.8055 34.4411 94.9709 35.1681 95.2966 35.8289Z"
            fill="#F7B5BF"
          />
          <path
            d="M96.9408 29.8451C95.8504 29.3397 94.4958 29.7516 93.5881 30.5441C92.6643 31.3511 92.102 32.4788 91.5626 33.5765C91.2695 34.1729 90.9741 34.7773 90.8384 35.4272C90.7023 36.0768 90.7418 36.7878 91.0876 37.3559C91.4269 37.9127 92.0581 38.2782 92.7106 38.3158C93.0858 38.3374 93.5249 38.6066 93.6465 38.9597C93.7592 39.2877 93.7057 39.6428 93.6525 39.9836C93.6014 40.3135 93.5527 40.6579 93.6574 40.975C93.8308 41.5023 94.3992 41.8223 94.9559 41.8759C95.5126 41.9294 96.0649 41.7696 96.6007 41.6114C96.9404 41.5111 97.2826 41.5691 97.5463 41.8039C97.6123 41.8627 97.6666 41.933 97.7073 42.0105C97.8739 42.3249 98.3566 42.2753 98.4954 41.9478C98.9825 40.7993 98.2736 38.9629 97.2178 37.5616C96.6575 36.8178 96.6876 37.0071 96.4679 36.1047C96.2847 35.3533 96.5617 34.57 96.901 33.8741C97.353 32.9461 97.9347 32.041 97.7552 30.9332C97.6791 30.4647 97.374 30.0456 96.9408 29.8451Z"
            fill="#1D2A30"
          />
          <path
            d="M95.3969 39.0343C95.8937 39.5584 96.5788 39.8656 97.3033 39.8883C98.2646 39.9091 98.5085 38.9991 98.0444 38.2229C97.6254 37.5231 96.6206 36.6718 95.7504 37.0102C94.8801 37.3481 94.7915 38.3807 95.3969 39.0343Z"
            fill="#F7B5BF"
          />
          <path
            d="M101.316 35.2719C101.427 35.5464 101.647 35.6914 101.821 35.6211C101.994 35.5504 102.037 35.2899 101.941 35.0235C101.845 34.7574 101.611 34.6068 101.436 34.6747C101.261 34.7426 101.211 35.0111 101.316 35.2719Z"
            fill="#1D2A30"
          />
          <path
            d="M104.262 34.0138C104.37 34.2891 104.592 34.4333 104.763 34.3634C104.935 34.2935 104.98 34.0322 104.884 33.7662C104.788 33.5001 104.554 33.3495 104.382 33.4166C104.21 33.4833 104.154 33.7534 104.262 34.0138Z"
            fill="#1D2A30"
          />
          <path
            d="M104.305 33.464L104.863 33.0299C104.863 33.0299 104.743 33.6475 104.305 33.464Z"
            fill="#1D2A30"
          />
          <path
            d="M103.5 34.6C104.184 35.2703 104.699 35.393 105.439 35.8531C105.418 36.5055 104.799 36.6553 104.799 36.6553L103.5 34.6Z"
            fill="#F46878"
          />
          <path
            d="M104.486 37.9348C104.613 37.8872 104.737 37.8293 104.855 37.7618C104.894 37.741 104.908 37.6935 104.887 37.6551L104.885 37.6511C104.862 37.6132 104.814 37.5984 104.774 37.6176C104.149 37.9771 103.389 38.017 102.73 37.7246C102.688 37.7027 102.637 37.7182 102.616 37.759C102.593 37.8001 102.609 37.8509 102.65 37.8724C103.229 38.1361 103.89 38.1589 104.486 37.9348Z"
            fill="#1D2A30"
          />
          <path
            d="M101.208 33.0966C101.204 33.1713 101.153 33.2348 101.08 33.2548C100.308 33.4821 99.9654 34.4548 99.9634 34.4624C99.9332 34.5527 99.8346 34.6014 99.7436 34.5711C99.6526 34.5411 99.6035 34.4432 99.6341 34.3529C99.6639 34.3162 100.037 33.2013 100.979 32.922C101.07 32.8961 101.166 32.948 101.194 33.0383L101.208 33.0966Z"
            fill="#1D2A30"
          />
          <path
            d="M104.766 32.6265C104.702 32.6656 104.62 32.66 104.562 32.6117C103.933 32.112 102.933 32.3864 102.926 32.3896C102.833 32.4164 102.737 32.3636 102.71 32.2722C102.683 32.1811 102.736 32.0852 102.828 32.0584C102.876 32.062 104.012 31.7313 104.78 32.3397C104.853 32.4 104.865 32.5078 104.806 32.5821L104.766 32.6265Z"
            fill="#1D2A30"
          />
          <path
            d="M101.367 34.7211L101.926 34.2898C101.926 34.2898 101.799 34.9066 101.367 34.7211Z"
            fill="#1D2A30"
          />
          <path
            d="M97.1793 29.3228C96.2998 29.3927 95.4653 29.8888 94.9887 30.6255C94.6687 31.1196 94.556 31.871 95.0294 32.2237C95.2508 32.3887 95.5426 32.4183 95.8184 32.4422C97.0441 32.5489 98.5544 31.6097 98.5544 31.6097C98.0818 29.6248 102.279 28.0884 104.348 31.1635C104.956 32.0671 104.792 32.7235 105.802 33.1409C106.278 33.3375 106.905 33.2831 107.21 33.6954C107.715 34.3801 106.744 35.5389 107.361 36.1265C107.783 36.5284 108.741 36.3746 108.799 36.9526C108.827 37.2243 108.648 37.617 108.911 37.6964C109.057 37.7404 109.191 37.6082 109.285 37.4895C109.513 37.2027 109.747 36.9027 109.825 36.546C109.903 36.1897 109.775 35.7598 109.441 35.6088C109.183 35.4926 108.503 35.6224 108.549 35.8988C108.605 36.232 108.317 34.5986 108.446 33.9814C108.559 33.4441 109.075 32.9783 108.919 32.4522C108.751 31.8906 108.079 31.6665 107.496 31.5802C106.912 31.4947 106.25 31.4244 105.891 30.9594C105.491 30.4397 105.673 29.6983 105.544 29.0568C105.381 28.241 104.695 27.6055 103.925 27.2747C101.592 26.2709 97.9828 26.4131 97.1793 29.3228Z"
            fill="#1D2A30"
          />
          <path
            d="M102.483 56.8527C100.688 57.5497 98.6622 56.6717 97.959 54.8909C97.2553 53.1104 98.1401 51.1019 99.935 50.4049C101.73 49.7078 103.754 50.5858 104.458 52.3662C105.161 54.1467 104.277 56.1556 102.483 56.8527ZM103.813 39.9807L95.7644 43.9934C93.1181 45.3124 91.9209 48.4143 93.0022 51.1507L96.8838 60.9752C97.965 63.7111 100.968 65.1812 103.814 64.3671L112.47 61.89C115.713 60.962 117.449 57.4686 116.217 54.35L111.729 42.9903C110.496 39.8717 106.829 38.4771 103.813 39.9807Z"
            fill="#4870C0"
          />
          <path
            d="M102.483 56.8527C100.688 57.5497 98.6622 56.6717 97.959 54.8909C97.2553 53.1104 98.1401 51.1019 99.935 50.4049C101.73 49.7078 103.754 50.5858 104.458 52.3662C105.161 54.1467 104.277 56.1556 102.483 56.8527ZM103.813 39.9807L95.7644 43.9934C93.1181 45.3124 91.9209 48.4143 93.0022 51.1507L96.8838 60.9752C97.965 63.7111 100.968 65.1812 103.814 64.3671L112.47 61.89C115.713 60.962 117.449 57.4686 116.217 54.35L111.729 42.9903C110.496 39.8717 106.829 38.4771 103.813 39.9807Z"
            fill="#4870C0"
          />
          <path
            d="M110.023 62.5898C110.023 62.5894 110.023 62.5894 110.023 62.589L112.466 61.89C112.646 61.8384 112.822 61.7789 112.993 61.7118C112.822 61.7789 112.648 61.8384 112.468 61.8904L110.023 62.5898Z"
            fill="white"
          />
          <path
            d="M102.226 64.5918C99.9203 64.5918 97.7651 63.2044 96.8828 60.9762L95.2734 56.9036C95.2738 56.9028 95.2742 56.902 95.2746 56.9008L96.8844 60.9758C97.7643 63.2028 99.9187 64.5914 102.224 64.5914C102.751 64.5914 103.286 64.5191 103.815 64.3677L110.028 62.5897C110.028 62.5901 110.028 62.5901 110.028 62.5905L103.815 64.3685C103.286 64.5195 102.752 64.5918 102.226 64.5918Z"
            fill="#304047"
          />
          <path
            d="M95.2697 56.9033L92.9974 51.1518C92.5454 50.0061 92.4922 48.7969 92.778 47.6812C92.6617 48.1354 92.6021 48.6052 92.6021 49.0801C92.6029 49.7712 92.731 50.4723 92.999 51.151L95.271 56.9005C95.2705 56.9017 95.2701 56.9025 95.2697 56.9033Z"
            fill="#304047"
          />
          <path
            d="M115.479 52.498L114.742 50.6325L114.808 50.7995L115.479 52.498Z"
            fill="#304047"
          />
          <path
            d="M116.613 56.3262C116.601 55.6686 116.473 55.0011 116.216 54.3496L115.484 52.4981L115.57 52.7138H115.57L116.217 54.3508C116.474 55.0023 116.601 55.6694 116.613 56.3262Z"
            fill="#304047"
          />
          <path
            d="M98.4414 42.6592L98.7007 42.5292C98.7007 42.5296 98.7007 42.53 98.7007 42.53L98.4422 42.6592H98.4414Z"
            fill="white"
          />
          <path
            d="M97.4766 43.1396L98.4406 42.6583H98.4414L97.4766 43.1396Z"
            fill="#304047"
          />
          <path
            d="M98.6992 42.5293C98.6992 42.5293 98.6992 42.5289 98.6992 42.5285L99.4403 42.158C99.4403 42.1584 99.4407 42.1584 99.4407 42.1588L98.6992 42.5293Z"
            fill="#F8BDC7"
          />
          <path
            d="M99.4418 42.1602C99.4418 42.1598 99.4414 42.1598 99.4414 42.1594L99.9045 41.9274L99.9061 41.927L99.9065 41.9278L99.4418 42.1602Z"
            fill="#CC9BA0"
          />
          <path
            d="M110.349 40.9473C109.282 39.9382 107.854 39.373 106.382 39.373C106.171 39.373 105.959 39.3845 105.746 39.4081L105.746 39.4077C105.959 39.3837 106.172 39.3722 106.384 39.3722C107.855 39.3722 109.282 39.9374 110.349 40.9473Z"
            fill="white"
          />
          <path
            d="M103.965 39.9082C104.544 39.6398 105.144 39.476 105.746 39.4089L105.745 39.4093C105.144 39.4764 104.544 39.6402 103.965 39.9082Z"
            fill="#F8BDC7"
          />
          <path
            d="M102.224 64.5908C99.9183 64.5908 97.764 63.2023 96.884 60.9752L95.2743 56.9003L93.0024 51.1507C92.7343 50.472 92.6063 49.771 92.6055 49.0799C92.6055 48.6049 92.665 48.1351 92.7814 47.6809C93.1135 46.3815 93.9045 45.209 95.0581 44.4117L95.5114 45.0077C94.1581 46.0251 93.384 47.6122 93.3852 49.262C93.3856 49.9104 93.5055 50.5679 93.7571 51.2046L97.3977 60.418C98.2233 62.5072 100.244 63.8095 102.406 63.8095C102.9 63.8095 103.401 63.7415 103.898 63.5997L108.623 62.2471L109.084 62.8523C109.084 62.8523 113.297 61.5804 113.388 61.5369C113.388 61.5197 113.228 61.2992 112.942 60.9173C113.284 60.7475 113.601 60.5442 113.892 60.3129L114.366 60.9361C114.793 60.6141 115.165 60.2374 115.478 59.8172C115.347 59.6426 115.177 59.4173 114.973 59.1485C115.571 58.274 115.903 57.2314 115.903 56.1544C115.903 55.5069 115.784 54.8474 115.53 54.2047L113.062 47.959L114.126 50.6086L114.21 50.6446L114.681 50.4608L114.749 50.633L116.217 54.3501C116.475 55.0016 116.603 55.6691 116.614 56.3266C116.614 56.327 116.614 56.3274 116.614 56.3278C116.614 56.3298 116.614 56.3314 116.614 56.333C116.614 56.3354 116.614 56.3374 116.614 56.3394C116.614 56.3406 116.614 56.3414 116.614 56.3422C116.633 57.6045 116.224 58.8269 115.479 59.8212C115.166 60.2414 114.794 60.6181 114.367 60.9401C113.956 61.2537 113.497 61.5149 112.996 61.7119C112.826 61.779 112.65 61.8385 112.47 61.89L110.027 62.5891L103.814 64.3671C103.285 64.5185 102.751 64.5908 102.224 64.5908ZM113.057 47.9462L112.412 46.3136L112.815 47.3198L113.356 47.1097L113.578 47.6729L113.093 47.8623L113.057 47.9462ZM111.989 45.2422L111.321 43.5504C110.483 41.4297 108.442 40.1586 106.306 40.1586C105.496 40.1586 104.673 40.3411 103.896 40.7286L101.85 41.7488C101.659 41.4656 101.531 41.2603 101.477 41.1464L103.814 39.9804C103.864 39.9552 103.915 39.9313 103.965 39.9077C104.748 39.545 105.572 39.3736 106.382 39.3736C107.853 39.3736 109.281 39.9388 110.349 40.9479C110.935 41.502 111.412 42.1898 111.728 42.992L112.534 45.0305L111.989 45.2422ZM96.3285 43.713L97.4766 43.1402L99.9071 41.9282L100.342 42.5002L99.4095 42.9652C99.1938 42.6416 99.0706 42.4323 99.0613 42.3636C98.8198 42.5142 97.4174 43.1921 96.3285 43.713Z"
            fill="#2846B1"
          />
          <path
            d="M101.961 57.0098C102.134 56.9714 102.307 56.9191 102.477 56.8528C103.926 56.2891 104.78 54.875 104.689 53.4134C104.694 53.4845 104.696 53.5552 104.696 53.6255C104.698 55.0096 103.857 56.3179 102.479 56.8528C102.308 56.9195 102.135 56.9714 101.961 57.0098Z"
            fill="#304047"
          />
          <path
            d="M98.8218 56.1582C98.4527 55.8163 98.1528 55.3892 97.9563 54.8915C97.9551 54.8887 97.9543 54.8863 97.9531 54.8835C97.9539 54.8855 97.9547 54.8879 97.9555 54.8899C98.1524 55.388 98.4523 55.8159 98.8218 56.1582Z"
            fill="#304047"
          />
          <path
            d="M98.7266 51.1895C99.0587 50.8567 99.4648 50.5863 99.9326 50.4045C100.181 50.3078 100.434 50.2415 100.687 50.2036C100.435 50.2419 100.182 50.3082 99.9342 50.4049C99.4656 50.5863 99.0591 50.8567 98.7266 51.1895Z"
            fill="#304047"
          />
          <path
            d="M97.9569 54.891C97.2533 53.1106 98.1381 51.102 99.933 50.405C101.727 49.7079 103.752 50.5859 104.456 52.3664C105.159 54.1468 104.275 56.1557 102.481 56.8528C100.686 57.5499 98.6601 56.6718 97.9569 54.891ZM103.894 40.7287L96.3452 44.4916C93.8635 45.7292 92.7409 48.6381 93.7548 51.2047L97.3954 60.418C98.4094 62.9842 101.226 64.3632 103.896 63.5998L112.013 61.2765C115.055 60.4061 116.684 57.1296 115.528 54.2047L111.318 43.5505C110.163 40.6264 106.723 39.3181 103.894 40.7287Z"
            fill="#4870C0"
          />
          <path
            d="M102.404 63.8096C100.241 63.8096 98.2209 62.5073 97.3953 60.4181L93.7548 51.2048C93.5032 50.568 93.3832 49.9105 93.3828 49.2621C93.3816 47.6123 94.1557 46.0253 95.509 45.0078L99.1576 49.8046C99.3359 49.7024 99.5219 49.6121 99.7195 49.5378C100.244 49.3336 100.784 49.237 101.315 49.237C103.064 49.237 104.717 50.2856 105.393 51.9997C105.549 52.392 105.642 52.793 105.679 53.1925C105.642 52.7938 105.549 52.3936 105.394 52.0021C104.717 50.2884 103.064 49.241 101.315 49.241C100.784 49.241 100.244 49.3376 99.7199 49.541C97.4686 50.4154 96.3588 52.9352 97.2415 55.1691C97.9186 56.8828 99.5714 57.9298 101.321 57.9298C101.852 57.9298 102.392 57.8335 102.916 57.6298C103.484 57.4093 103.979 57.0837 104.388 56.6847L108.621 62.2472L103.895 63.5998C103.399 63.7417 102.898 63.8096 102.404 63.8096Z"
            fill="#4164E3"
          />
          <path
            d="M112.939 60.918C110.769 58.0246 101.343 45.8716 99.4062 42.9659L100.339 42.5009L113.888 60.3136C113.598 60.5449 113.28 60.7482 112.939 60.918Z"
            fill="#4164E3"
          />
          <path
            d="M114.975 59.1484C112.307 55.6327 103.805 44.6449 101.852 41.7488L103.898 40.7286C104.675 40.3411 105.498 40.1585 106.308 40.1585C108.444 40.1585 110.484 41.4296 111.322 43.5504L111.991 45.2421L111.986 45.2437L112.414 46.3135L113.059 47.9461L113.064 47.9589L115.532 54.2046C115.786 54.8474 115.905 55.5069 115.905 56.1544C115.904 57.2314 115.572 58.274 114.975 59.1484Z"
            fill="#4164E3"
          />
          <path
            d="M141.403 37.1754L141.173 37.5936L141.045 37.8253L140.681 38.4856L140.833 40.1758C140.84 40.2481 140.831 40.3196 140.81 40.3855C140.761 40.5317 140.649 40.6535 140.499 40.7122L137.317 41.9482C137.166 42.0065 137.002 41.9933 136.865 41.9178C136.821 41.8939 136.781 41.8635 136.745 41.8268L134.946 40.012L134.942 40.0072L132.384 41.0007L132.754 41.9386L130.197 42.9325L130.807 44.4768L128.924 45.2087C128.769 45.2686 128.6 45.2578 128.456 45.1843C128.41 45.1611 128.366 45.13 128.326 45.0936L127.241 44.0806L124.684 45.074L125.294 46.6188L122.605 47.6634L123.218 49.2145C123.318 49.4678 123.192 49.7538 122.936 49.8529L115.571 52.7139L112.375 44.6254L139.017 34.276L139.434 34.4881L140.785 35.1764C141.521 35.5515 141.801 36.4555 141.403 37.1754Z"
            fill="#4870C0"
          />
          <path
            d="M115.571 52.7139L114.681 50.4605L124.921 46.4618L124.957 46.3779L124.367 44.8907L124.403 44.8072L127.193 43.7174L127.261 43.7298L128.545 44.9047C128.577 44.9342 128.612 44.9598 128.648 44.981L128.703 44.9842L130.461 44.2975L130.497 44.214L129.92 42.7623L129.957 42.6788L132.352 41.7433L132.388 41.6598L132.054 40.8189L132.09 40.7354L134.899 39.6389L134.969 39.6533L136.947 41.6258L137.04 41.7005L137.098 41.7053L140.557 40.3539L140.595 40.3116C140.606 40.2692 140.612 40.2257 140.612 40.181C140.612 40.165 140.611 40.1486 140.609 40.1326L140.456 38.4592L140.461 38.4269L140.736 37.8129L141.087 37.0475C141.091 37.0383 141.093 37.0291 141.093 37.0204C141.093 36.9856 141.063 36.9561 141.028 36.9561C141.02 36.9561 141.012 36.9576 141.004 36.9608L113.579 47.6726L113.356 47.1093L141.298 36.2546C141.298 36.2514 141.299 36.2486 141.299 36.2458C141.298 35.8831 141.004 35.6414 140.493 35.3817L139.142 34.6935L112.535 45.0297L112.375 44.6254L139.017 34.276L139.434 34.4881L140.785 35.1764C141.294 35.4357 141.585 35.9478 141.584 36.4771C141.584 36.7136 141.526 36.9533 141.403 37.1754L141.173 37.5936L141.045 37.8253L140.681 38.4856L140.833 40.1758C140.835 40.1917 140.835 40.2073 140.835 40.2233C140.835 40.2792 140.826 40.3339 140.81 40.3855C140.761 40.5317 140.649 40.6535 140.499 40.7122L137.317 41.9482C137.254 41.9726 137.188 41.9846 137.123 41.9846C137.033 41.9846 136.945 41.9618 136.865 41.9178C136.821 41.8939 136.781 41.8635 136.745 41.8268L134.946 40.012L134.942 40.0072L132.384 41.0007L132.754 41.9386L130.197 42.9325L130.807 44.4768L128.924 45.2087C128.857 45.2346 128.786 45.2474 128.717 45.2474C128.627 45.2474 128.537 45.2258 128.456 45.1843C128.41 45.1611 128.366 45.13 128.326 45.0936L127.241 44.0806L124.684 45.074L125.294 46.6188L122.605 47.6634L123.218 49.2145C123.241 49.274 123.252 49.3352 123.252 49.3951C123.252 49.5916 123.132 49.777 122.936 49.8529L115.571 52.7139Z"
            fill="#4164E3"
          />
          <path
            d="M141.298 36.2554L112.815 47.3203L111.984 45.2443L139.142 34.6943L140.493 35.3826C141.008 35.6443 141.303 35.8875 141.298 36.2554Z"
            fill="#4870C0"
          />
          <path
            d="M112.815 47.3203L112.412 46.3141L111.984 45.2443L139.142 34.6943L140.493 35.3826C141.004 35.6423 141.298 35.8839 141.299 36.2467C141.299 36.2495 141.298 36.2523 141.298 36.2554L113.356 47.1102L112.815 47.3203Z"
            fill="#2846B1"
          />
          <path
            d="M140.733 37.8132L140.458 38.4272L140.453 38.4596L140.607 40.1329C140.613 40.1941 140.607 40.2544 140.593 40.3119L140.554 40.3542L137.095 41.7056L137.038 41.7008L136.944 41.6261L134.966 39.6536L134.896 39.6392L132.088 40.7357L132.052 40.8192L132.386 41.6601L132.349 41.7436L129.954 42.6791L129.918 42.7626L130.494 44.2143L130.458 44.2978L128.701 44.9845L128.646 44.9813C128.609 44.9601 128.574 44.9345 128.542 44.905L127.258 43.7301L127.19 43.7178L124.401 44.8075L124.364 44.891L124.955 46.3782L124.918 46.4621L114.208 50.6445L114.123 50.6086L113.055 47.9461L113.091 47.8622L141.001 36.9611C141.055 36.94 141.109 36.9951 141.084 37.0478L140.733 37.8132Z"
            fill="#4870C0"
          />
          <path
            d="M114.208 50.6445L114.123 50.6086L113.06 47.9589L113.055 47.9461L113.091 47.8622L141.001 36.9612C141.01 36.958 141.018 36.9564 141.025 36.9564C141.061 36.9564 141.09 36.9859 141.09 37.0207C141.091 37.0295 141.089 37.0387 141.084 37.0478L140.733 37.8132L140.458 38.4272L140.453 38.4596L140.607 40.1329C140.608 40.1489 140.609 40.1653 140.609 40.1813C140.609 40.226 140.603 40.2696 140.593 40.3119L140.554 40.3542L137.095 41.7056L137.038 41.7008L136.944 41.6261L134.966 39.6536L134.896 39.6392L132.088 40.7357L132.052 40.8192L132.386 41.6601L132.349 41.7436L129.954 42.6791L129.918 42.7626L130.494 44.2143L130.458 44.2978L128.701 44.9845L128.646 44.9813C128.609 44.9601 128.574 44.9345 128.542 44.905L127.258 43.7301L127.19 43.7178L124.401 44.8075L124.364 44.891L124.955 46.3782L124.918 46.4621L114.678 50.4608L114.208 50.6445Z"
            fill="#2846B1"
          />
          <path
            d="M101.32 57.9297C99.5707 57.9297 97.9179 56.8827 97.2408 55.169C96.358 52.9351 97.4678 50.4153 99.7192 49.5409C100.243 49.3375 100.783 49.2409 101.314 49.2409C103.063 49.2409 104.716 50.2883 105.393 52.002C105.548 52.3935 105.641 52.7937 105.678 53.1924C105.798 54.4927 105.313 55.7758 104.384 56.6798L104.387 56.6845C103.978 57.0836 103.483 57.4092 102.915 57.6297C102.391 57.8334 101.851 57.9297 101.32 57.9297ZM97.7142 53.6318C97.7146 54.0508 97.7927 54.4771 97.9561 54.8909C98.4959 56.2571 99.8134 57.092 101.208 57.092C101.631 57.092 102.062 57.0149 102.48 56.8527C103.857 56.3178 104.698 55.0096 104.697 53.6254C104.696 53.2064 104.618 52.7801 104.455 52.3663C104.129 51.541 103.519 50.9094 102.779 50.5391C102.295 50.2963 101.755 50.1656 101.203 50.1656C101.139 50.1656 101.075 50.1676 101.011 50.1708C100.651 50.1908 100.287 50.2671 99.9322 50.4049C98.5543 50.9402 97.713 52.2477 97.7142 53.6318Z"
            fill="#4164E3"
          />
          <path
            d="M114.365 60.9355L113.891 60.3124C114.311 59.9772 114.675 59.5833 114.972 59.1479C115.176 59.4168 115.346 59.6421 115.477 59.8166C115.164 60.2369 114.792 60.6136 114.365 60.9355Z"
            fill="#6489CE"
          />
          <path
            d="M99.9051 41.9277L99.9023 41.9245L99.8906 41.9085C99.8906 41.9085 100.168 41.7695 100.494 41.6021C100.508 41.6057 100.522 41.6093 100.536 41.6129L99.9051 41.9277Z"
            fill="#CC9BA0"
          />
          <path
            d="M100.535 41.6133C100.521 41.6097 100.507 41.6061 100.492 41.6025C100.864 41.4115 101.298 41.1843 101.452 41.0836L101.472 41.1427C101.472 41.1435 101.473 41.1447 101.474 41.1459L101.019 41.3724L100.535 41.6133Z"
            fill="#F8BDC7"
          />
          <path
            d="M101.023 41.373L101.477 41.1462C101.477 41.1462 101.477 41.1462 101.477 41.1466H101.477L101.023 41.373Z"
            fill="#537BC6"
          />
          <path
            d="M99.9067 41.9277L99.9062 41.9269L100.537 41.6121C100.538 41.6121 100.538 41.6121 100.538 41.6121L99.9067 41.9277Z"
            fill="#D1A5A9"
          />
          <path
            d="M100.536 41.6133C100.536 41.6133 100.536 41.6133 100.535 41.6133L101.019 41.3721L100.536 41.6133Z"
            fill="#F8C5CD"
          />
          <path
            d="M100.341 42.5L99.9062 41.928L101.021 41.3723L101.475 41.1462H101.476C101.53 41.26 101.658 41.4654 101.849 41.7486L100.341 42.5Z"
            fill="#2846B1"
          />
          <path
            d="M113.893 60.3125L100.344 42.4998L101.851 41.7484C103.804 44.6446 112.307 55.6323 114.975 59.1481C114.677 59.5835 114.314 59.9773 113.893 60.3125Z"
            fill="#2846B1"
          />
          <path
            d="M109.085 62.8525L108.625 62.2473L112.017 61.2766C112.343 61.1836 112.652 61.0625 112.944 60.9175C113.23 61.2994 113.39 61.5199 113.39 61.5371C113.299 61.5806 109.085 62.8525 109.085 62.8525Z"
            fill="#6489CE"
          />
          <path
            d="M95.0597 44.4111L95.0078 44.3428C95.0078 44.3428 95.5287 44.0968 96.1985 43.7764C96.1985 43.7772 96.1981 43.778 96.1981 43.7788L95.767 43.9937C95.5182 44.1179 95.2823 44.2573 95.0597 44.4111Z"
            fill="white"
          />
          <path
            d="M96.1953 43.7793C96.1953 43.7785 96.1957 43.7777 96.1957 43.7769C96.2293 43.7609 96.2637 43.7445 96.2981 43.7277L96.1953 43.7793Z"
            fill="#304047"
          />
          <path
            d="M95.0594 44.4121L95.0586 44.4113C95.2812 44.2575 95.5171 44.1181 95.7658 43.9939L96.3004 43.7274C96.3101 43.7226 96.3197 43.7182 96.3298 43.7134L95.7679 43.9939C95.5187 44.1181 95.2824 44.2579 95.0594 44.4121Z"
            fill="#537BC6"
          />
          <path
            d="M95.5118 45.0078L95.0586 44.4118C95.2816 44.2576 95.5179 44.1178 95.7671 43.9936L96.329 43.7131C97.4178 43.1922 98.8203 42.5143 99.0618 42.3637C99.0711 42.4324 99.1942 42.6418 99.41 42.9653L96.3479 44.4917C96.0492 44.6407 95.7699 44.8141 95.5118 45.0078Z"
            fill="#2846B1"
          />
          <path
            d="M108.624 62.248L104.391 56.6855C105.319 55.7799 105.802 54.4952 105.682 53.1933C105.645 52.7938 105.551 52.3928 105.396 52.0005C104.719 50.2864 103.067 49.2378 101.317 49.2378C100.787 49.2378 100.247 49.3344 99.7222 49.5386C99.5246 49.6129 99.3386 49.7032 99.1603 49.8054L95.5117 45.0086C95.7697 44.8149 96.0491 44.6415 96.3478 44.4925L99.4099 42.9661C101.347 45.8719 110.772 58.0249 112.942 60.9182C112.651 61.0632 112.341 61.1843 112.016 61.2773L108.624 62.248Z"
            fill="#2846B1"
          />
          <path
            d="M104.39 56.6846L104.387 56.6798C105.316 55.7758 105.8 54.4927 105.681 53.1924C105.802 54.4943 105.318 55.779 104.39 56.6846Z"
            fill="#89A8DD"
          />
          <path
            d="M96.1445 31.5514C95.6744 32.1066 95.482 32.884 95.6406 33.5923C95.7992 34.3005 96.3039 34.9241 96.9673 35.2301C97.3111 35.3883 97.6891 35.4646 98.0292 35.6303C98.3693 35.7965 98.6849 36.0893 98.7208 36.4636C98.761 36.8771 98.4535 37.2634 98.4825 37.6776C98.509 38.0571 98.8081 38.3583 99.11 38.5928C99.4119 38.8273 99.7492 39.0486 99.9155 39.3913C100.082 39.7341 99.9739 40.2418 99.6039 40.3417C99.5258 40.4599 99.496 40.7431 99.5955 40.8446C99.6949 40.9461 99.8672 40.9676 99.9887 40.8933C100.557 40.5466 100.947 39.8927 100.951 39.2307C100.956 38.5688 100.537 37.9229 99.9288 37.652C99.8189 37.4315 99.9038 37.1527 99.9956 36.9242C100.18 36.4672 100.364 36.0098 100.548 35.5524C100.621 35.3727 100.557 35.0455 100.433 34.8961C100.309 34.7463 100.123 34.6652 99.9437 34.5889L98.7574 34.084C98.309 33.8935 96.9802 32.1254 98.5581 31.6093C98.352 31.1551 97.9954 31.0129 97.5019 30.9234C97.008 30.8339 96.4678 31.1703 96.1445 31.5514Z"
            fill="#1D2A30"
          />
          <path
            d="M98.2976 29.6484C98.2582 30.1134 98.2187 30.578 98.1797 31.043C98.5726 30.4022 99.3016 29.1603 99.2762 29.2086C98.967 29.3752 98.6072 29.4814 98.2976 29.6484Z"
            fill="#1D2A30"
          />
          <path
            d="M98.8281 30.4141C99.378 29.9095 99.9274 29.405 100.477 28.9009C100.053 28.7431 99.539 28.8605 99.2274 29.1865C99.2367 29.1521 98.9823 29.9275 98.8281 30.4141Z"
            fill="#1D2A30"
          />
          <path
            d="M95.4742 68.2055C93.3271 70.8492 94.0416 72.8769 91.0781 77.5575C94.8153 80.3062 98.9127 80.7616 104.006 80.3689C104.609 79.3103 104.913 78.2062 105.515 77.1476C106.378 78.2106 107.071 79.1046 107.934 80.1676C110.604 79.7529 113.774 79.0083 115.885 77.6589C114.021 75.5374 112.864 72.8877 111.67 70.5488C111.111 69.4523 111.345 68.9905 109.86 67.5524C105.131 67.7689 100.442 67.8835 95.7125 68.1001C95.8373 68.1065 95.3494 68.1987 95.4742 68.2055Z"
            fill="#1D2A30"
          />
          <path
            d="M96.0674 67.763L95.7708 68.997C95.7277 69.0941 95.8436 69.1859 96.0026 69.1772L109.038 68.6047C109.163 68.6067 109.262 68.5332 109.267 68.4581L109.337 67.2317C109.338 67.1494 109.229 67.0799 109.093 67.0891L96.2848 67.65C96.1975 67.6468 96.1145 67.6895 96.0674 67.763Z"
            fill="#4870C0"
          />
          <path
            d="M96.0674 67.763L95.7708 68.997C95.7277 69.0941 95.8436 69.1859 96.0026 69.1772L109.038 68.6047C109.163 68.6067 109.262 68.5332 109.267 68.4581L109.337 67.2317C109.338 67.1494 109.229 67.0799 109.093 67.0891L96.2848 67.65C96.1975 67.6468 96.1145 67.6895 96.0674 67.763Z"
            fill="#4164E3"
          />
          <path
            d="M98.9355 69.1799L98.5572 69.1963C98.4851 69.1951 98.4251 69.1639 98.43 69.1192L98.5318 67.5249C98.5322 67.4802 98.5974 67.4398 98.6731 67.4374L99.0515 67.4171C99.1235 67.4183 99.1835 67.4494 99.1787 67.4982L99.0772 69.088C99.0728 69.1332 99.0076 69.1771 98.9355 69.1799Z"
            fill="#1D2A30"
          />
          <path
            d="M108.35 68.7766L107.972 68.793C107.9 68.7918 107.84 68.761 107.844 68.7159L107.946 67.1256C107.947 67.0768 108.011 67.0365 108.083 67.0341L108.462 67.0177C108.534 67.0189 108.594 67.0497 108.589 67.0948L108.488 68.6851C108.487 68.7334 108.426 68.7738 108.35 68.7766Z"
            fill="#1D2A30"
          />
          <path
            d="M100.617 61.4217C100.642 61.5395 101.654 63.1378 102.448 63.0271L102.467 63.0243C102.699 62.992 102.929 63.085 103.072 63.2688C103.391 63.6807 103.583 63.9167 103.798 64.1872C104.147 64.6262 104.754 64.7672 105.265 64.5311C105.417 64.4616 105.567 64.3845 105.716 64.3062C106.207 64.0474 106.458 63.4885 106.324 62.9528C106.178 62.3648 105.95 61.7976 105.647 61.2719C105.543 61.0921 105.425 60.9107 105.245 60.8069C105.064 60.7026 103.318 60.1785 102.64 60.2001C101.934 60.2221 101.264 61.1396 100.617 61.4217Z"
            fill="#F7B5BF"
          />
          <path
            d="M102.66 60.1489C102.66 60.1489 91.9594 56.9332 89.6512 59.0744C88.2943 60.3331 88.9351 61.5215 89.6939 62.2877C90.2583 62.8573 91.4876 62.7175 92.2919 62.6804L100.721 61.8595L102.66 60.1489Z"
            fill="#F7B5BF"
          />
          <path
            d="M96.5114 58.6792C96.4531 58.1043 96.005 57.627 95.4842 57.3693C94.9633 57.1117 94.3732 57.0354 93.7959 56.9627C92.4514 56.7937 91.107 56.6247 89.7625 56.4557C89.0798 57.3122 88.5887 58.4894 88.61 59.5812C88.631 60.6733 89.0452 61.7539 89.7609 62.584C90.4042 61.3496 91.2527 60.0789 92.509 59.4657C93.7657 58.853 95.1335 58.4311 96.5114 58.6792Z"
            fill="#1D2A30"
          />
          <path
            d="M93.7539 39.2852V39.2456C93.7799 39.238 93.7967 39.2344 93.8055 39.2344C93.8247 39.2344 93.8035 39.2524 93.7539 39.2852Z"
            fill="#304047"
          />
          <path
            d="M120.34 22.0926L123.321 27.5781L135.485 17.3278C135.592 17.2375 135.468 17.0741 135.351 17.1508L123.948 24.6201L122.19 21.2174L120.34 22.0926Z"
            fill="#4164E3"
          />
          <path
            d="M139.529 22.1191H139.267C139.267 24.4692 138.026 26.6071 135.986 28.1719C133.947 29.735 131.114 30.7101 127.979 30.7097C125.572 30.7101 123.346 30.138 121.52 29.1589L121.408 29.0986L115.611 31.5993L119.257 27.5695L119.078 27.3953C117.576 25.9344 116.692 24.1061 116.691 22.1191C116.692 19.769 117.932 17.6311 119.972 16.0664C122.012 14.5033 124.845 13.5278 127.979 13.5282C131.114 13.5278 133.947 14.5033 135.986 16.0664C138.026 17.6311 139.267 19.769 139.267 22.1191H139.529H139.79C139.791 19.5805 138.446 17.2931 136.306 15.6553C134.165 14.0151 131.223 13.0093 127.979 13.0089C124.736 13.0093 121.794 14.0151 119.653 15.6553C117.513 17.2931 116.168 19.5805 116.168 22.1191C116.168 24.2631 117.127 26.2276 118.712 27.7664L118.895 27.581L118.7 27.4077L113.617 33.0254L121.5 29.6255L121.395 29.387L121.271 29.6155C123.179 30.6386 125.488 31.229 127.979 31.229C131.223 31.2286 134.165 30.2231 136.306 28.5829C138.446 26.9451 139.791 24.6577 139.79 22.1191H139.529Z"
            fill="#4164E3"
          />
        </g>
        <defs>
          <clipPath id="clip0_1926_44801">
            <rect width="200" height="150" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const LogInBtnIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 15V2M12 2L15 5.5M12 2L9 5.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 22.0002H16C18.8284 22.0002 20.2426 22.0002 21.1213 21.1215C22 20.2429 22 18.8286 22 16.0002V15.0002C22 12.1718 22 10.7576 21.1213 9.8789C20.3529 9.11051 19.175 9.01406 17 9.00195M7 9.00195C4.82497 9.01406 3.64706 9.11051 2.87868 9.87889C2 10.7576 2 12.1718 2 15.0002V16.0002C2 18.8286 2 20.2429 2.87868 21.1215C3.17848 21.4213 3.54062 21.6188 4 21.749"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarWalliconLogo = ({
  backgroundColor = "#000000",
  textColor = "#ffffff",
}) => {
  return (
    <React.Fragment>
      <svg
        width="74"
        height="74"
        viewBox="0 0 74 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="74" height="74" rx="37" fill={backgroundColor} />
        <g clipPath="url(#clip0_1054_36757)">
          <g opacity="0.5">
            <path
              d="M27.1328 35.4392L30.1976 41.0939L30.8322 39.4172L28.3349 34.8047L27.1328 35.4392Z"
              fill={textColor}
            />
          </g>
          <path
            d="M34.5552 31.4709L36.4693 30.4648L35.1228 33.4779L31.7226 41.0933H30.1953L30.9951 39.0193L34.5552 31.4712V31.4709Z"
            fill={textColor}
          />
          <g opacity="0.5">
            <path
              d="M40.3413 41.1343L41.3372 38.467L36.4719 30.4648L35.1406 33.4522L40.3413 41.1346V41.1343Z"
              fill={textColor}
            />
          </g>
          <path
            d="M40.3398 41.1355H42.8885L44.3486 38.0811L47.1345 32.2199L48.9144 28.4638L51.9849 22.0508L46.3302 25.0794L40.3401 41.1355H40.3398Z"
            fill={textColor}
          />
          <path
            d="M13.8537 47.6719L15.0403 51.9334L16.2167 47.6719H17.9709L19.1061 51.9439L20.2051 47.6719H22.181L20.1432 54.2914H18.1672L17.0838 50.1329L15.8455 54.2914H13.9105L11.8828 47.6719H13.8537Z"
            fill={textColor}
          />
          <path
            d="M27.6916 54.431C27.2893 54.2761 27.0311 54.0027 26.8661 53.6054C26.4276 54.1626 25.664 54.4205 24.9676 54.4205C23.688 54.4205 22.6562 53.7498 22.6562 52.4185C22.6562 51.3868 23.2238 50.7418 24.1268 50.4426C24.6582 50.2621 25.2877 50.2208 25.9996 50.2208H26.5672V50.1434C26.5672 49.4984 26.2319 49.1116 25.458 49.1116C24.9678 49.1116 24.5037 49.3179 24.1528 49.6792L22.9763 48.6833C23.6369 47.9197 24.5912 47.5586 25.6078 47.5586C27.3518 47.5586 28.3835 48.4358 28.3835 50.1538V51.5108C28.3835 52.8008 28.4505 53.1362 28.8893 53.4353L27.6922 54.4312L27.6916 54.431ZM26.5926 51.3868H25.9219C24.8229 51.3868 24.4361 51.712 24.4361 52.2897C24.4361 52.718 24.7353 52.9861 25.3546 52.9861C26.1027 52.9861 26.5929 52.5578 26.5929 51.877V51.3868H26.5926Z"
            fill={textColor}
          />
          <path
            d="M30.0003 45.3718V51.9913C30.0003 52.9098 30.1139 53.5545 30.5317 53.9672C30.8154 54.2509 31.2437 54.4212 31.837 54.4212H31.8627V44.5977L30 45.3715L30.0003 45.3718Z"
            fill={textColor}
          />
          <path
            d="M33.5628 45.3808V52.0003C33.5628 52.9187 33.6764 53.5635 34.0942 53.9762C34.3779 54.2599 34.8062 54.4302 35.3995 54.4302H35.4252V44.6016L33.5625 45.3808H33.5628Z"
            fill={textColor}
          />
          <path
            d="M38.0919 44.9277C38.649 44.9277 39.1135 45.3662 39.1135 45.9236C39.1135 46.481 38.649 46.9195 38.0919 46.9195C37.5348 46.9195 37.0703 46.4912 37.0703 45.9236C37.0754 45.3665 37.5243 44.9277 38.0919 44.9277ZM39.0104 47.6778V54.2973H37.1633V47.6778H39.0104Z"
            fill={textColor}
          />
          <path
            d="M45.0782 49.8443L46.951 54.2968H45.1451L43.8811 51.2786L42.5448 52.8161V54.3019H40.6875V45.3813L42.5448 44.6074V50.4376L44.8923 47.6773H46.8682L45.0779 49.8443H45.0782Z"
            fill={textColor}
          />
          <path
            d="M51.0285 47.5742C53.0406 47.5742 54.3821 48.9673 54.3821 50.995C54.3821 53.0227 53.0251 54.426 51.0387 54.426C49.0523 54.426 47.6953 53.0173 47.6953 50.995C47.6953 48.9829 49.0523 47.5742 51.0282 47.5742H51.0285ZM51.039 52.878C51.9933 52.878 52.5248 52.0268 52.5248 50.9947C52.5248 49.9627 51.9829 49.1219 51.0285 49.1219C50.0742 49.1219 49.5323 49.9731 49.5323 50.9947C49.5323 52.0265 50.0843 52.878 51.039 52.878Z"
            fill={textColor}
          />
          <path
            d="M57.3347 47.6776L57.5825 48.4515C58.0365 47.8683 58.6558 47.5742 59.4811 47.5742C60.2187 47.5742 60.7606 47.7805 61.1835 48.1831C61.7667 48.7402 61.88 49.4369 61.88 50.443V54.3022H60.0071V50.5616C60.0071 50.0559 59.9814 49.7205 59.8266 49.5038C59.6562 49.2459 59.3621 49.1272 59.001 49.1272C58.4335 49.1272 58.0052 49.4524 57.7989 49.9528C57.6958 50.2263 57.6698 50.5616 57.6698 50.8557V54.3022H55.8125V47.6776H57.3344H57.3347Z"
            fill={textColor}
          />
          <path
            d="M31.8576 49.4414V54.4358H30V49.4465L31.8576 49.4414Z"
            fill={textColor}
          />
          <path
            d="M35.4198 49.4531H33.5625V54.4422H35.4198V49.4531Z"
            fill={textColor}
          />
        </g>
        <defs>
          <clipPath id="clip0_1054_36757">
            <rect
              width="50"
              height="32.3909"
              fill="white"
              transform="translate(11.8828 22.0508)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const NavbarSearchIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.28125 10.8142C5.28128 8.1738 7.14649 5.90116 9.73613 5.38614C12.3258 4.87113 14.9187 6.25721 15.9289 8.69667C16.9392 11.1362 16.0855 13.9495 13.89 15.4162C11.6944 16.8829 8.76852 16.5944 6.90173 14.7271C5.86412 13.6893 5.28123 12.2817 5.28125 10.8142Z"
          stroke="black"
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3477 16.3477L18.7198 18.7198"
          stroke="black"
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarSearchDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.2793 10.8147C5.27933 8.17429 7.14454 5.90164 9.73418 5.38663C12.3239 4.87162 14.9167 6.2577 15.9269 8.69716C16.9372 11.1366 16.0835 13.95 13.888 15.4167C11.6925 16.8834 8.76656 16.5949 6.89978 14.7276C5.86217 13.6898 5.27928 12.2822 5.2793 10.8147Z"
          stroke="white"
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3477 16.3481L18.7198 18.7203"
          stroke="white"
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarWhatsAppIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1054_36798)">
          <path
            d="M8.00971 25.6929L8.4945 25.9353C10.5145 27.1473 12.7768 27.7128 15.0392 27.7128C22.1494 27.7128 27.9669 21.8954 27.9669 14.7851C27.9669 11.3916 26.5933 8.07888 24.1693 5.65494C21.7454 3.23099 18.5135 1.85742 15.0392 1.85742C7.92891 1.85742 2.11144 7.67489 2.19224 14.8659C2.19224 17.2899 2.91942 19.633 4.13139 21.653L4.45459 22.1378L3.16182 26.9049L8.00971 25.6929Z"
            fill="#00E676"
          />
          <path
            d="M25.5425 4.3631C22.7954 1.53517 18.9979 0 15.1195 0C6.87813 0 0.252673 6.70625 0.333471 14.8669C0.333471 17.4524 1.06066 19.9572 2.27263 22.2195L0.171875 29.8953L8.0093 27.8754C10.1909 29.0874 12.6148 29.6529 15.0387 29.6529C23.1994 29.6529 29.8248 22.9467 29.8248 14.7861C29.8248 10.827 28.2896 7.11024 25.5425 4.3631ZM15.1195 27.1482C12.938 27.1482 10.7564 26.5826 8.89808 25.4514L8.41329 25.209L3.727 26.421L4.93897 21.8155L4.61578 21.3307C1.06065 15.5941 2.75742 7.99902 8.57489 4.4439C14.3924 0.88878 21.9066 2.58554 25.4617 8.40301C29.0168 14.2205 27.3201 21.7347 21.5026 25.2898C19.6442 26.5018 17.3819 27.1482 15.1195 27.1482ZM22.2298 18.1796L21.341 17.7756C21.341 17.7756 20.0482 17.21 19.2402 16.806C19.1595 16.806 19.0787 16.7252 18.9979 16.7252C18.7555 16.7252 18.5939 16.806 18.4323 16.8868C18.4323 16.8868 18.3515 16.9676 17.2203 18.2604C17.1395 18.422 16.9779 18.5028 16.8163 18.5028H16.7355C16.6547 18.5028 16.4931 18.422 16.4123 18.3412L16.0083 18.1796C15.1195 17.7756 14.3116 17.2908 13.6652 16.6444C13.5036 16.4828 13.2612 16.3212 13.0996 16.1596C12.534 15.5941 11.9684 14.9477 11.5644 14.2205L11.4836 14.0589C11.4028 13.9781 11.4028 13.8973 11.322 13.7357C11.322 13.5741 11.322 13.4125 11.4028 13.3317C11.4028 13.3317 11.726 12.9277 11.9684 12.6853C12.13 12.5237 12.2108 12.2813 12.3724 12.1197C12.534 11.8773 12.6148 11.5541 12.534 11.3117C12.4532 10.9078 11.4836 8.72621 11.2412 8.24142C11.0796 7.99902 10.918 7.91822 10.6756 7.83742H10.4332C10.2716 7.83742 10.0293 7.83742 9.78686 7.83742C9.62526 7.83742 9.46367 7.91822 9.30207 7.91822L9.22127 7.99902C9.05968 8.07982 8.89808 8.24142 8.73648 8.32221C8.57489 8.48381 8.49409 8.64541 8.33249 8.807C7.76691 9.53419 7.44371 10.423 7.44371 11.3117C7.44371 11.9581 7.60531 12.6045 7.8477 13.1701L7.9285 13.4125C8.65569 14.9477 9.62526 16.3212 10.918 17.5332L11.2412 17.8564C11.4836 18.0988 11.726 18.2604 11.8876 18.5028C13.5844 19.9572 15.5235 21.0075 17.7051 21.5731C17.9475 21.6539 18.2707 21.6539 18.5131 21.7347C18.7555 21.7347 19.0787 21.7347 19.321 21.7347C19.725 21.7347 20.2098 21.5731 20.533 21.4115C20.7754 21.2499 20.937 21.2499 21.0986 21.0883L21.2602 20.9267C21.4218 20.7651 21.5834 20.6843 21.745 20.5227C21.9066 20.3611 22.0682 20.1995 22.149 20.038C22.3106 19.7148 22.3914 19.3108 22.4722 18.9068C22.4722 18.7452 22.4722 18.5028 22.4722 18.3412C22.4722 18.3412 22.3914 18.2604 22.2298 18.1796Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1054_36798">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const NavbarSaleOrderIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.28247 22.5H25C24.9956 23.662 24.973 24.5285 24.8582 25.2133C24.7216 26.0285 24.4717 26.4602 24.0886 26.7677C23.7054 27.0752 23.1674 27.2758 22.1514 27.3854C21.1055 27.4983 19.7192 27.5 17.7317 27.5H12.1933C10.2057 27.5 8.81957 27.4983 7.7737 27.3854C6.7577 27.2758 6.21966 27.0752 5.83645 26.7677C5.45324 26.4602 5.20339 26.0285 5.06679 25.2133C5.05652 25.152 5.04701 25.0893 5.03816 25.025C4.98806 24.661 4.96301 24.4789 5.1212 24.0496C5.27939 23.6205 5.34796 23.5531 5.48514 23.4184C5.89189 23.0189 6.44977 22.7231 7.09151 22.5851C7.4544 22.5071 7.92795 22.5 9.28247 22.5Z"
          fill="#AEB2C2"
        />
        <path
          d="M5.90897 3.91665C6.29072 3.53169 6.82669 3.2807 7.83879 3.14347C8.88065 3.00221 10.2615 3 12.2414 3H17.7586C19.7385 3 21.1194 3.00221 22.1612 3.14347C23.1734 3.2807 23.7092 3.53169 24.091 3.91665C24.4727 4.30163 24.7216 4.8421 24.8577 5.86275C24.9977 6.91341 25 8.30592 25 10.3025V23H9.28247C7.92795 23 7.4544 23.0071 7.09151 23.0851C6.44977 23.2231 5.89189 23.5189 5.48514 23.9184C5.34796 24.0531 5.27939 24.1205 5.1212 24.5496C5.03044 24.7959 5 24.9609 5 25.1254V10.3025C5 8.30592 5.0022 6.91341 5.14228 5.86275C5.27835 4.8421 5.52724 4.30163 5.90897 3.91665Z"
          fill="#646B88"
        />
        <path
          opacity="0.5"
          d="M9.0625 5.9375C9.0625 5.41974 9.48224 5 10 5H20C20.5177 5 20.9375 5.41974 20.9375 5.9375C20.9375 6.45526 20.5177 6.875 20 6.875H10C9.48224 6.875 9.0625 6.45526 9.0625 5.9375Z"
          fill="#F8F9FC"
        />
        <path
          opacity="0.5"
          d="M10 9.375C9.48224 9.375 9.0625 9.79475 9.0625 10.3125C9.0625 10.8303 9.48224 11.25 10 11.25H16.25C16.7677 11.25 17.1875 10.8303 17.1875 10.3125C17.1875 9.79475 16.7677 9.375 16.25 9.375H10Z"
          fill="#F8F9FC"
        />
        <path
          opacity="0.5"
          d="M20 12.5C17.9337 12.5 16.25 14.1837 16.25 16.25C16.25 18.3162 17.9337 20 20 20C22.0662 20 23.75 18.3162 23.75 16.25C23.75 14.1837 22.0662 12.5 20 12.5ZM21.5 16.5312H20.2812V17.75C20.2812 17.9037 20.1537 18.0312 20 18.0312C19.8463 18.0312 19.7188 17.9037 19.7188 17.75V16.5312H18.5C18.3463 16.5312 18.2188 16.4037 18.2188 16.25C18.2188 16.0963 18.3463 15.9688 18.5 15.9688H19.7188V14.75C19.7188 14.5963 19.8463 14.4688 20 14.4688C20.1537 14.4688 20.2812 14.5963 20.2812 14.75V15.9688H21.5C21.6537 15.9688 21.7812 16.0963 21.7812 16.25C21.7812 16.4037 21.6537 16.5312 21.5 16.5312Z"
          fill="#F8F9FC"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarSaleOrderDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.28247 22.5H25C24.9956 23.662 24.973 24.5285 24.8582 25.2133C24.7216 26.0285 24.4717 26.4602 24.0886 26.7677C23.7054 27.0752 23.1674 27.2758 22.1514 27.3854C21.1055 27.4983 19.7192 27.5 17.7317 27.5H12.1933C10.2057 27.5 8.81957 27.4983 7.7737 27.3854C6.7577 27.2758 6.21966 27.0752 5.83645 26.7677C5.45324 26.4602 5.20339 26.0285 5.06679 25.2133C5.05652 25.152 5.04701 25.0893 5.03816 25.025C4.98806 24.661 4.96301 24.4789 5.1212 24.0496C5.27939 23.6205 5.34796 23.5531 5.48514 23.4184C5.89189 23.0189 6.44977 22.7231 7.09151 22.5851C7.4544 22.5071 7.92795 22.5 9.28247 22.5Z"
          fill="#232529"
        />
        <path
          d="M5.90897 3.41665C6.29072 3.03169 6.82669 2.7807 7.83879 2.64347C8.88065 2.50221 10.2615 2.5 12.2414 2.5H17.7586C19.7385 2.5 21.1194 2.50221 22.1612 2.64347C23.1734 2.7807 23.7092 3.03169 24.091 3.41665C24.4727 3.80163 24.7216 4.3421 24.8577 5.36275C24.9977 6.41341 25 7.80592 25 9.80253V22.5H9.28247C7.92795 22.5 7.4544 22.5071 7.09151 22.5851C6.44977 22.7231 5.89189 23.0189 5.48514 23.4184C5.34796 23.5531 5.27939 23.6205 5.1212 24.0496C5.03044 24.2959 5 24.4609 5 24.6254V9.80253C5 7.80592 5.0022 6.41341 5.14228 5.36275C5.27835 4.3421 5.52724 3.80163 5.90897 3.41665Z"
          fill="white"
        />
        <path
          d="M9.0625 5.9375C9.0625 5.41974 9.48224 5 10 5H20C20.5177 5 20.9375 5.41974 20.9375 5.9375C20.9375 6.45526 20.5177 6.875 20 6.875H10C9.48224 6.875 9.0625 6.45526 9.0625 5.9375Z"
          fill="#2C2E33"
        />
        <path
          d="M10 9.375C9.48224 9.375 9.0625 9.79475 9.0625 10.3125C9.0625 10.8303 9.48224 11.25 10 11.25H16.25C16.7677 11.25 17.1875 10.8303 17.1875 10.3125C17.1875 9.79475 16.7677 9.375 16.25 9.375H10Z"
          fill="#2C2E33"
        />
        <path
          d="M20 12.5C17.9337 12.5 16.25 14.1837 16.25 16.25C16.25 18.3162 17.9337 20 20 20C22.0662 20 23.75 18.3162 23.75 16.25C23.75 14.1837 22.0662 12.5 20 12.5ZM21.5 16.5312H20.2812V17.75C20.2812 17.9037 20.1537 18.0312 20 18.0312C19.8463 18.0312 19.7188 17.9037 19.7188 17.75V16.5312H18.5C18.3463 16.5312 18.2188 16.4037 18.2188 16.25C18.2188 16.0963 18.3463 15.9688 18.5 15.9688H19.7188V14.75C19.7188 14.5963 19.8463 14.4688 20 14.4688C20.1537 14.4688 20.2812 14.5963 20.2812 14.75V15.9688H21.5C21.6537 15.9688 21.7812 16.0963 21.7812 16.25C21.7812 16.4037 21.6537 16.5312 21.5 16.5312Z"
          fill="#2C2E33"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarSunIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.25 15C21.25 18.4517 18.4517 21.25 15 21.25C11.5482 21.25 8.75 18.4517 8.75 15C8.75 11.5482 11.5482 8.75 15 8.75C18.4517 8.75 21.25 11.5482 21.25 15Z"
          fill="#646B88"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 1.5625C15.5177 1.5625 15.9375 1.98224 15.9375 2.5V5C15.9375 5.51776 15.5177 5.9375 15 5.9375C14.4822 5.9375 14.0625 5.51776 14.0625 5V2.5C14.0625 1.98224 14.4822 1.5625 15 1.5625ZM1.5625 15C1.5625 14.4822 1.98224 14.0625 2.5 14.0625H5C5.51776 14.0625 5.9375 14.4822 5.9375 15C5.9375 15.5177 5.51776 15.9375 5 15.9375H2.5C1.98224 15.9375 1.5625 15.5177 1.5625 15ZM24.0625 15C24.0625 14.4822 24.4822 14.0625 25 14.0625H27.5C28.0177 14.0625 28.4375 14.4822 28.4375 15C28.4375 15.5177 28.0177 15.9375 27.5 15.9375H25C24.4822 15.9375 24.0625 15.5177 24.0625 15ZM15 24.0625C15.5177 24.0625 15.9375 24.4822 15.9375 25V27.5C15.9375 28.0177 15.5177 28.4375 15 28.4375C14.4822 28.4375 14.0625 28.0177 14.0625 27.5V25C14.0625 24.4822 14.4822 24.0625 15 24.0625Z"
          fill="#646B88"
        />
        <g opacity="0.5">
          <path
            d="M4.58545 4.64499C4.93483 4.26286 5.52783 4.23633 5.90995 4.5857L8.68748 7.12517C9.0696 7.47455 9.09614 8.06755 8.74676 8.44968C8.39739 8.8318 7.80439 8.85835 7.42228 8.50898L4.64475 5.96949C4.26263 5.62011 4.23608 5.02711 4.58545 4.64499Z"
            fill="#646B88"
          />
          <path
            d="M25.4148 4.64474C25.7641 5.02687 25.7376 5.61987 25.3555 5.96924L22.5779 8.50873C22.1958 8.85811 21.6028 8.83156 21.2534 8.44943C20.904 8.06731 20.9306 7.47431 21.3128 7.12493L24.0903 4.58546C24.4724 4.23608 25.0654 4.26262 25.4148 4.64474Z"
            fill="#646B88"
          />
          <path
            d="M21.2825 21.2804C21.6486 20.9143 22.2421 20.9144 22.6082 21.2805L25.3857 24.0584C25.7518 24.4245 25.7518 25.018 25.3857 25.3841C25.0196 25.7503 24.426 25.7503 24.0598 25.384L21.2823 22.6063C20.9162 22.24 20.9163 21.6465 21.2825 21.2804Z"
            fill="#646B88"
          />
          <path
            d="M8.71804 21.2805C9.08415 21.6465 9.08415 22.2401 8.71804 22.6062L5.94026 25.384C5.57414 25.7501 4.98055 25.7501 4.61444 25.384C4.24831 25.0178 4.24831 24.4243 4.61444 24.0582L7.39221 21.2803C7.75832 20.9143 8.35192 20.9143 8.71804 21.2805Z"
            fill="#646B88"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const NavbarSunDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.25 15C21.25 18.4517 18.4517 21.25 15 21.25C11.5482 21.25 8.75 18.4517 8.75 15C8.75 11.5482 11.5482 8.75 15 8.75C18.4517 8.75 21.25 11.5482 21.25 15Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 1.5625C15.5177 1.5625 15.9375 1.98224 15.9375 2.5V5C15.9375 5.51776 15.5177 5.9375 15 5.9375C14.4822 5.9375 14.0625 5.51776 14.0625 5V2.5C14.0625 1.98224 14.4822 1.5625 15 1.5625ZM1.5625 15C1.5625 14.4822 1.98224 14.0625 2.5 14.0625H5C5.51776 14.0625 5.9375 14.4822 5.9375 15C5.9375 15.5177 5.51776 15.9375 5 15.9375H2.5C1.98224 15.9375 1.5625 15.5177 1.5625 15ZM24.0625 15C24.0625 14.4822 24.4822 14.0625 25 14.0625H27.5C28.0177 14.0625 28.4375 14.4822 28.4375 15C28.4375 15.5177 28.0177 15.9375 27.5 15.9375H25C24.4822 15.9375 24.0625 15.5177 24.0625 15ZM15 24.0625C15.5177 24.0625 15.9375 24.4822 15.9375 25V27.5C15.9375 28.0177 15.5177 28.4375 15 28.4375C14.4822 28.4375 14.0625 28.0177 14.0625 27.5V25C14.0625 24.4822 14.4822 24.0625 15 24.0625Z"
          fill="white"
        />
        <g opacity="0.5">
          <path
            d="M4.58545 4.64474C4.93483 4.26262 5.52783 4.23608 5.90995 4.58546L8.68748 7.12493C9.0696 7.47431 9.09614 8.06731 8.74676 8.44943C8.39739 8.83156 7.80439 8.85811 7.42228 8.50873L4.64475 5.96924C4.26263 5.61987 4.23608 5.02687 4.58545 4.64474Z"
            fill="white"
          />
          <path
            d="M25.4148 4.64474C25.7641 5.02687 25.7376 5.61987 25.3555 5.96924L22.5779 8.50873C22.1958 8.85811 21.6028 8.83156 21.2534 8.44943C20.904 8.06731 20.9306 7.47431 21.3128 7.12493L24.0903 4.58546C24.4724 4.23608 25.0654 4.26262 25.4148 4.64474Z"
            fill="white"
          />
          <path
            d="M21.2825 21.2814C21.6486 20.9152 22.2421 20.9154 22.6082 21.2815L25.3857 24.0594C25.7518 24.4255 25.7518 25.019 25.3857 25.3851C25.0196 25.7512 24.426 25.7512 24.0598 25.385L21.2823 22.6072C20.9162 22.241 20.9163 21.6475 21.2825 21.2814Z"
            fill="white"
          />
          <path
            d="M8.71804 21.2814C9.08415 21.6474 9.08415 22.2411 8.71804 22.6072L5.94026 25.3849C5.57414 25.7511 4.98055 25.7511 4.61444 25.3849C4.24831 25.0188 4.24831 24.4253 4.61444 24.0592L7.39221 21.2813C7.75832 20.9153 8.35192 20.9153 8.71804 21.2814Z"
            fill="white"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};
export const NavbarFullScreenIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1054_36823)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.4113 5.625H18.75C18.2325 5.625 17.8125 6.045 17.8125 6.5625C17.8125 7.08094 18.2325 7.5 18.75 7.5H21.2138L16.7156 11.9991L18.0413 13.3247L22.5206 8.84531L22.5 11.25C22.5 11.7684 22.92 12.1875 23.4375 12.1875C23.955 12.1875 24.375 11.7684 24.375 11.25V6.5625C24.375 6.285 24.2597 6.06096 24.0788 5.90721C23.9081 5.73284 23.6728 5.625 23.4113 5.625ZM28.125 26.25C28.125 27.2812 27.285 28.125 26.25 28.125H3.75C2.715 28.125 1.875 27.2812 1.875 26.25V3.75C1.875 2.715 2.715 1.875 3.75 1.875H26.25C27.285 1.875 28.125 2.715 28.125 3.75V26.25ZM26.25 0H3.75C1.67906 0 0 1.67906 0 3.75V26.25C0 28.3219 1.67906 30 3.75 30H26.25C28.3209 30 30 28.3219 30 26.25V3.75C30 1.67906 28.3209 0 26.25 0ZM11.9587 16.6781L7.47937 21.1594L7.5 18.75C7.5 18.2344 7.08 17.8125 6.5625 17.8125C6.045 17.8125 5.625 18.2344 5.625 18.75V23.4375C5.625 23.7188 5.74031 23.9438 5.92124 24.0938C6.09093 24.2625 6.32719 24.375 6.58875 24.375H11.25C11.7675 24.375 12.1875 23.9531 12.1875 23.4375C12.1875 22.9219 11.7675 22.5 11.25 22.5H8.78624L13.2844 18L11.9587 16.6781ZM23.4375 17.8125C22.92 17.8125 22.5 18.2344 22.5 18.75L22.5206 21.1594L18.0413 16.6781L16.7156 18L21.2138 22.5H18.75C18.2325 22.5 17.8125 22.9219 17.8125 23.4375C17.8125 23.9531 18.2325 24.375 18.75 24.375H23.4113C23.6728 24.375 23.9091 24.2625 24.0788 24.0938C24.2597 23.9438 24.375 23.7188 24.375 23.4375V18.75C24.375 18.2344 23.955 17.8125 23.4375 17.8125ZM11.25 7.5C11.7675 7.5 12.1875 7.08094 12.1875 6.5625C12.1875 6.045 11.7675 5.625 11.25 5.625H6.58875C6.32719 5.625 6.09187 5.73284 5.92124 5.90721C5.74031 6.06096 5.625 6.285 5.625 6.5625V11.25C5.625 11.7684 6.045 12.1875 6.5625 12.1875C7.08 12.1875 7.5 11.7684 7.5 11.25L7.47937 8.84531L11.9587 13.3247L13.2844 11.9991L8.78624 7.5H11.25Z"
            fill="#646B88"
          />
        </g>
        <defs>
          <clipPath id="clip0_1054_36823">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const NavbarFullScreenDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1054_41578)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.4113 5.625H18.75C18.2325 5.625 17.8125 6.045 17.8125 6.5625C17.8125 7.08094 18.2325 7.5 18.75 7.5H21.2138L16.7156 11.9991L18.0413 13.3247L22.5206 8.84531L22.5 11.25C22.5 11.7684 22.92 12.1875 23.4375 12.1875C23.955 12.1875 24.375 11.7684 24.375 11.25V6.5625C24.375 6.285 24.2597 6.06096 24.0788 5.90721C23.9081 5.73284 23.6728 5.625 23.4113 5.625ZM28.125 26.25C28.125 27.2812 27.285 28.125 26.25 28.125H3.75C2.715 28.125 1.875 27.2812 1.875 26.25V3.75C1.875 2.715 2.715 1.875 3.75 1.875H26.25C27.285 1.875 28.125 2.715 28.125 3.75V26.25ZM26.25 0H3.75C1.67906 0 0 1.67906 0 3.75V26.25C0 28.3219 1.67906 30 3.75 30H26.25C28.3209 30 30 28.3219 30 26.25V3.75C30 1.67906 28.3209 0 26.25 0ZM11.9587 16.6781L7.47937 21.1594L7.5 18.75C7.5 18.2344 7.08 17.8125 6.5625 17.8125C6.045 17.8125 5.625 18.2344 5.625 18.75V23.4375C5.625 23.7188 5.74031 23.9438 5.92124 24.0938C6.09093 24.2625 6.32719 24.375 6.58875 24.375H11.25C11.7675 24.375 12.1875 23.9531 12.1875 23.4375C12.1875 22.9219 11.7675 22.5 11.25 22.5H8.78624L13.2844 18L11.9587 16.6781ZM23.4375 17.8125C22.92 17.8125 22.5 18.2344 22.5 18.75L22.5206 21.1594L18.0413 16.6781L16.7156 18L21.2138 22.5H18.75C18.2325 22.5 17.8125 22.9219 17.8125 23.4375C17.8125 23.9531 18.2325 24.375 18.75 24.375H23.4113C23.6728 24.375 23.9091 24.2625 24.0788 24.0938C24.2597 23.9438 24.375 23.7188 24.375 23.4375V18.75C24.375 18.2344 23.955 17.8125 23.4375 17.8125ZM11.25 7.5C11.7675 7.5 12.1875 7.08094 12.1875 6.5625C12.1875 6.045 11.7675 5.625 11.25 5.625H6.58875C6.32719 5.625 6.09187 5.73284 5.92124 5.90721C5.74031 6.06096 5.625 6.285 5.625 6.5625V11.25C5.625 11.7684 6.045 12.1875 6.5625 12.1875C7.08 12.1875 7.5 11.7684 7.5 11.25L7.47937 8.84531L11.9587 13.3247L13.2844 11.9991L8.78624 7.5H11.25Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1054_41578">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const NavbarNotificationIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.2341 17.575L23.8216 15.225C23.5091 14.7125 23.2341 13.725 23.2341 13.125V10.7875C23.2341 6.25 19.5466 2.5625 15.0216 2.5625C10.4841 2.575 6.79659 6.25 6.79659 10.7875V13.1125C6.79659 13.7125 6.52159 14.7 6.22159 15.2125L4.80909 17.5625C4.27159 18.475 4.14659 19.5125 4.48409 20.4125C4.82159 21.325 5.58409 22.05 6.58409 22.375C7.93409 22.825 9.29659 23.15 10.6841 23.3875C10.8216 23.4125 10.9591 23.425 11.0966 23.45C11.2716 23.475 11.4591 23.5 11.6466 23.525C11.9716 23.575 12.2966 23.6125 12.6341 23.6375C13.4216 23.7125 14.2216 23.75 15.0216 23.75C15.8091 23.75 16.5966 23.7125 17.3716 23.6375C17.6591 23.6125 17.9466 23.5875 18.2216 23.55C18.4466 23.525 18.6716 23.5 18.8966 23.4625C19.0341 23.45 19.1716 23.425 19.3091 23.4C20.7091 23.175 22.0966 22.825 23.4466 22.375C24.409 22.05 25.1466 21.325 25.4966 20.4C25.8466 19.4625 25.7466 18.4375 25.2341 17.575ZM15.9341 12.5C15.9341 13.025 15.5091 13.45 14.9841 13.45C14.4591 13.45 14.0341 13.025 14.0341 12.5V8.625C14.0341 8.1 14.4591 7.675 14.9841 7.675C15.5091 7.675 15.9341 8.1 15.9341 8.625V12.5Z"
          fill="#646B88"
        />
        <path
          d="M18.5391 25.0125C18.0141 26.4625 16.6266 27.5 15.0016 27.5C14.0141 27.5 13.0391 27.1 12.3516 26.3875C11.9516 26.0125 11.6516 25.5125 11.4766 25C11.6391 25.025 11.8016 25.0375 11.9766 25.0625C12.2641 25.1 12.5641 25.1375 12.8641 25.1625C13.5766 25.225 14.3016 25.2625 15.0266 25.2625C15.7391 25.2625 16.4516 25.225 17.1516 25.1625C17.4141 25.1375 17.6766 25.125 17.9266 25.0875C18.1266 25.0625 18.3266 25.0375 18.5391 25.0125Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarNotificationDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.236 17.576L23.8235 15.226C23.511 14.7135 23.236 13.726 23.236 13.126V10.7885C23.236 6.25098 19.5485 2.56348 15.0235 2.56348C10.486 2.57598 6.79854 6.25098 6.79854 10.7885V13.1135C6.79854 13.7135 6.52354 14.701 6.22354 15.2135L4.81104 17.5635C4.27354 18.476 4.14854 19.5135 4.48604 20.4135C4.82354 21.326 5.58604 22.051 6.58604 22.376C7.93604 22.826 9.29854 23.151 10.686 23.3885C10.8235 23.4135 10.961 23.426 11.0985 23.451C11.2735 23.476 11.461 23.501 11.6485 23.526C11.9735 23.576 12.2985 23.6135 12.636 23.6385C13.4235 23.7135 14.2235 23.751 15.0235 23.751C15.811 23.751 16.5985 23.7135 17.3735 23.6385C17.661 23.6135 17.9485 23.5885 18.2235 23.551C18.4485 23.526 18.6735 23.501 18.8985 23.4635C19.036 23.451 19.1735 23.426 19.311 23.401C20.711 23.176 22.0985 22.826 23.4485 22.376C24.411 22.051 25.1485 21.326 25.4985 20.401C25.8485 19.4635 25.7485 18.4385 25.236 17.576ZM15.936 12.501C15.936 13.026 15.511 13.451 14.986 13.451C14.461 13.451 14.036 13.026 14.036 12.501V8.62598C14.036 8.10098 14.461 7.67598 14.986 7.67598C15.511 7.67598 15.936 8.10098 15.936 8.62598V12.501Z"
          fill="white"
        />
        <path
          d="M18.5371 25.0125C18.0121 26.4625 16.6246 27.5 14.9996 27.5C14.0121 27.5 13.0371 27.1 12.3496 26.3875C11.9496 26.0125 11.6496 25.5125 11.4746 25C11.6371 25.025 11.7996 25.0375 11.9746 25.0625C12.2621 25.1 12.5621 25.1375 12.8621 25.1625C13.5746 25.225 14.2996 25.2625 15.0246 25.2625C15.7371 25.2625 16.4496 25.225 17.1496 25.1625C17.4121 25.1375 17.6746 25.125 17.9246 25.0875C18.1246 25.0625 18.3246 25.0375 18.5371 25.0125Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarArrowDownIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 10L12 15L17 10"
          stroke="#646B88"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarArrowDownDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 10L12 15L17 10"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarArrowLeft = () => {
  return (
    <React.Fragment>
      <svg
        width="800px"
        height="800px"
        viewBox="-4.5 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>arrow_left [#335]</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Dribbble-Light-Preview"
            transform="translate(-345.000000, -6679.000000)"
            fill="#000000"
          >
            <g id="icons" transform="translate(56.000000, 160.000000)">
              <path
                d="M299.633777,6519.29231 L299.633777,6519.29231 C299.228878,6518.90256 298.573377,6518.90256 298.169513,6519.29231 L289.606572,6527.55587 C288.797809,6528.33636 288.797809,6529.60253 289.606572,6530.38301 L298.231646,6538.70754 C298.632403,6539.09329 299.27962,6539.09828 299.685554,6538.71753 L299.685554,6538.71753 C300.100809,6538.32879 300.104951,6537.68821 299.696945,6537.29347 L291.802968,6529.67648 C291.398069,6529.28574 291.398069,6528.65315 291.802968,6528.26241 L299.633777,6520.70538 C300.038676,6520.31563 300.038676,6519.68305 299.633777,6519.29231"
                id="arrow_left-[#335]"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const SideBarArrowRight = () => {
  return (
    <React.Fragment>
      <svg
        width="800px"
        height="800px"
        viewBox="-4.5 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>arrow_right [#336]</title>
        <desc>Created with Sketch.</desc>
        <defs></defs>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Dribbble-Light-Preview"
            transform="translate(-305.000000, -6679.000000)"
            fill="#000000"
          >
            <g id="icons" transform="translate(56.000000, 160.000000)">
              <path
                d="M249.365851,6538.70769 L249.365851,6538.70769 C249.770764,6539.09744 250.426289,6539.09744 250.830166,6538.70769 L259.393407,6530.44413 C260.202198,6529.66364 260.202198,6528.39747 259.393407,6527.61699 L250.768031,6519.29246 C250.367261,6518.90671 249.720021,6518.90172 249.314072,6519.28247 L249.314072,6519.28247 C248.899839,6519.67121 248.894661,6520.31179 249.302681,6520.70653 L257.196934,6528.32352 C257.601847,6528.71426 257.601847,6529.34685 257.196934,6529.73759 L249.365851,6537.29462 C248.960938,6537.68437 248.960938,6538.31795 249.365851,6538.70769"
                id="arrow_right-[#336]"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const SideBarDashBoardIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2021_3415)">
          <path
            d="M10 15H4C3.73478 15 3.48043 15.1054 3.29289 15.2929C3.10536 15.4804 3 15.7348 3 16V21C3 21.2652 3.10536 21.5196 3.29289 21.7071C3.48043 21.8946 3.73478 22 4 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21V16C11 15.7348 10.8946 15.4804 10.7071 15.2929C10.5196 15.1054 10.2652 15 10 15Z"
            fill={color}
          />
          <path
            d="M10 2H4C3.73478 2 3.48043 2.10536 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3V12C3 12.2652 3.10536 12.5196 3.29289 12.7071C3.48043 12.8946 3.73478 13 4 13H10C10.2652 13 10.5196 12.8946 10.7071 12.7071C10.8946 12.5196 11 12.2652 11 12V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2Z"
            fill={color}
          />
          <path
            d="M20 2H14C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V8C13 8.26522 13.1054 8.51957 13.2929 8.70711C13.4804 8.89464 13.7348 9 14 9H20C20.2652 9 20.5196 8.89464 20.7071 8.70711C20.8946 8.51957 21 8.26522 21 8V3C21 2.73478 20.8946 2.48043 20.7071 2.29289C20.5196 2.10536 20.2652 2 20 2Z"
            fill={color}
          />
          <path
            d="M20 11H14C13.7348 11 13.4804 11.1054 13.2929 11.2929C13.1054 11.4804 13 11.7348 13 12V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V12C21 11.7348 20.8946 11.4804 20.7071 11.2929C20.5196 11.1054 20.2652 11 20 11Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2021_3415">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const SideBarApplicationIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.75 3.00098H17.25V2.25098C17.25 2.05206 17.171 1.8613 17.0303 1.72065C16.8897 1.57999 16.6989 1.50098 16.5 1.50098C16.3011 1.50098 16.1103 1.57999 15.9697 1.72065C15.829 1.8613 15.75 2.05206 15.75 2.25098V3.00098H12.75V2.25098C12.75 2.05206 12.671 1.8613 12.5303 1.72065C12.3897 1.57999 12.1989 1.50098 12 1.50098C11.8011 1.50098 11.6103 1.57999 11.4697 1.72065C11.329 1.8613 11.25 2.05206 11.25 2.25098V3.00098H8.25V2.25098C8.25 2.05206 8.17098 1.8613 8.03033 1.72065C7.88968 1.57999 7.69891 1.50098 7.5 1.50098C7.30109 1.50098 7.11032 1.57999 6.96967 1.72065C6.82902 1.8613 6.75 2.05206 6.75 2.25098V3.00098H5.25C4.85231 3.00143 4.47105 3.15961 4.18984 3.44082C3.90864 3.72202 3.75045 4.10329 3.75 4.50098V18.751C3.75091 19.5463 4.06727 20.3089 4.62968 20.8713C5.1921 21.4337 5.95463 21.7501 6.75 21.751H17.25C18.0454 21.7501 18.8079 21.4337 19.3703 20.8713C19.9327 20.3089 20.2491 19.5463 20.25 18.751V4.50098C20.2495 4.10329 20.0914 3.72202 19.8102 3.44082C19.529 3.15961 19.1477 3.00143 18.75 3.00098ZM15 15.751H9C8.80109 15.751 8.61032 15.672 8.46967 15.5313C8.32902 15.3907 8.25 15.1999 8.25 15.001C8.25 14.8021 8.32902 14.6113 8.46967 14.4706C8.61032 14.33 8.80109 14.251 9 14.251H15C15.1989 14.251 15.3897 14.33 15.5303 14.4706C15.671 14.6113 15.75 14.8021 15.75 15.001C15.75 15.1999 15.671 15.3907 15.5303 15.5313C15.3897 15.672 15.1989 15.751 15 15.751ZM15 12.751H9C8.80109 12.751 8.61032 12.672 8.46967 12.5313C8.32902 12.3907 8.25 12.1999 8.25 12.001C8.25 11.8021 8.32902 11.6113 8.46967 11.4706C8.61032 11.33 8.80109 11.251 9 11.251H15C15.1989 11.251 15.3897 11.33 15.5303 11.4706C15.671 11.6113 15.75 11.8021 15.75 12.001C15.75 12.1999 15.671 12.3907 15.5303 12.5313C15.3897 12.672 15.1989 12.751 15 12.751Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarComplaintsIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.2519 6.67692V15.8677C20.2506 16.2384 20.1027 16.5937 19.8405 16.8558C19.5783 17.118 19.2231 17.2659 18.8523 17.2672H13.5799L12.2915 19.3325C12.2651 19.395 12.2209 19.4483 12.1644 19.4857C12.1079 19.5232 12.0416 19.5432 11.9738 19.5432C11.906 19.5432 11.8397 19.5232 11.7832 19.4857C11.7267 19.4483 11.6825 19.395 11.6561 19.3325L10.3677 17.2672H5.15084C4.77984 17.2662 4.4243 17.1185 4.16185 16.8563C3.89939 16.5941 3.75133 16.2387 3.75 15.8677V6.67692C3.75133 6.30614 3.89921 5.95093 4.1614 5.68874C4.42358 5.42656 4.7788 5.27868 5.14958 5.27734H18.8523C19.2231 5.27868 19.5783 5.42656 19.8405 5.68874C20.1027 5.95093 20.2506 6.30614 20.2519 6.67692ZM12.8927 14.3241C12.893 14.1476 12.8409 13.9751 12.7431 13.8283C12.6452 13.6815 12.506 13.567 12.3431 13.4993C12.1802 13.4316 12.0008 13.4137 11.8277 13.448C11.6547 13.4823 11.4957 13.5671 11.3708 13.6918C11.246 13.8164 11.1609 13.9753 11.1264 14.1484C11.0919 14.3214 11.1095 14.5008 11.1769 14.6638C11.2444 14.8268 11.3587 14.9662 11.5054 15.0642C11.652 15.1623 11.8245 15.2146 12.0009 15.2146C12.2372 15.2146 12.4639 15.1208 12.6311 14.9539C12.7983 14.7869 12.8924 14.5604 12.8927 14.3241ZM11.3012 12.0125C11.3012 12.1981 11.3749 12.3761 11.5061 12.5073C11.6372 12.6385 11.8152 12.7122 12.0009 12.7122C12.1885 12.7122 12.3666 12.6384 12.4978 12.5071C12.629 12.3757 12.7011 12.1976 12.7011 12.0125C12.7011 11.8268 12.6295 11.6489 12.4983 11.5167C12.3671 11.3845 12.1891 11.312 12.0009 11.312C11.8144 11.312 11.6367 11.384 11.5057 11.5163C11.3747 11.6486 11.3012 11.8264 11.3012 12.0125ZM12.0009 9.77284C12.2372 9.77284 12.4639 9.67903 12.6311 9.51211C12.7983 9.34516 12.8924 9.12353 12.8927 8.88526C12.8927 8.646 12.7983 8.4244 12.6311 8.25747C12.4639 8.09053 12.2372 7.99774 12.0009 7.99774C11.8144 7.99774 11.6367 8.09053 11.5057 8.25747C11.3747 8.4244 11.3012 8.646 11.3012 8.88526C11.3012 9.1238 11.3749 9.34516 11.5061 9.51216C11.6372 9.67914 11.8152 9.77284 12.0009 9.77284Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarDealersIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 10C11.2091 10 13 8.20914 13 6C13 3.79086 11.2091 2 9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10Z"
          fill={color}
        />
        <path
          d="M9 21.001C12.866 21.001 16 19.2101 16 17.001C16 14.7918 12.866 13.001 9 13.001C5.13401 13.001 2 14.7918 2 17.001C2 19.2101 5.13401 21.001 9 21.001Z"
          fill={color}
        />
        <path
          d="M21 17.001C21 18.6578 18.9645 20.0009 16.4792 20.0009C17.2114 19.2006 17.7149 18.196 17.7149 17.0023C17.7149 15.8073 17.2102 14.8018 16.4766 14.001C18.9619 14.001 21 15.3441 21 17.001Z"
          fill={color}
        />
        <path
          d="M17.9971 6.00098C17.9971 7.65784 16.6541 9.00098 14.9972 9.00098C14.6359 9.00098 14.2896 8.93712 13.9688 8.82006C14.4419 7.98797 14.7121 7.02547 14.7121 5.99987C14.7121 4.97502 14.4423 4.01319 13.9698 3.18152C14.2903 3.06471 14.6363 3.00098 14.9972 3.00098C16.6541 3.00098 17.9971 4.34413 17.9971 6.00098Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarDeliveryIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.56443 8.73049L10.0789 10.5926C10.5639 12.3481 10.8064 13.2259 11.5194 13.6252C12.2323 14.0244 13.1374 13.7892 14.9474 13.3188L16.8673 12.8199C18.6774 12.3495 19.5824 12.1143 19.9941 11.4227C20.4057 10.7312 20.1632 9.85344 19.6782 8.09788L19.1638 6.2358C18.6788 4.48023 18.4363 3.60244 17.7233 3.20319C17.0103 2.80394 16.1052 3.03915 14.2952 3.50955L12.3753 4.00849C10.5652 4.47889 9.66021 4.71409 9.24856 5.40562C8.83692 6.09714 9.07943 6.97493 9.56443 8.73049Z"
          fill={color}
        />
        <path
          d="M2.27749 5.24694C2.38823 4.84781 2.80157 4.61402 3.2007 4.72476L4.9044 5.19744C5.82129 5.45183 6.5469 6.15866 6.80003 7.07489L8.95106 14.8609L9.10935 15.4075C9.74249 15.6438 10.2863 16.0866 10.6314 16.6747L10.9414 16.579L19.8115 14.2739C20.2124 14.1697 20.6219 14.4102 20.7261 14.8111C20.8303 15.212 20.5897 15.6214 20.1888 15.7256L11.3515 18.0223L11.0228 18.1238C11.0161 19.3947 10.1392 20.5555 8.81236 20.9003C7.22189 21.3136 5.58709 20.3982 5.16092 18.8556C4.73476 17.313 5.67861 15.7274 7.26908 15.3141C7.3479 15.2936 7.42682 15.2764 7.5057 15.2623L5.35419 7.47433C5.24592 7.08242 4.92897 6.76092 4.50338 6.64284L2.79968 6.17016C2.40054 6.05942 2.16675 5.64608 2.27749 5.24694Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarDispatchIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.23737 2.28869C1.84442 2.1577 1.41968 2.37007 1.28869 2.76303C1.15771 3.15599 1.37008 3.58073 1.76303 3.71171L2.02794 3.80002C2.70435 4.02548 3.15155 4.17575 3.481 4.32901C3.79296 4.47413 3.92784 4.59093 4.01426 4.71083C4.10068 4.83073 4.16883 4.99562 4.20785 5.33746C4.24907 5.69847 4.2502 6.17024 4.2502 6.88324V9.55508C4.25018 10.9226 4.25017 12.0249 4.36673 12.8919C4.48774 13.792 4.74664 14.5499 5.34855 15.1518C5.95047 15.7537 6.70834 16.0126 7.60845 16.1336C8.47542 16.2502 9.57773 16.2502 10.9453 16.2502H18.0002C18.4144 16.2502 18.7502 15.9144 18.7502 15.5002C18.7502 15.0859 18.4144 14.7502 18.0002 14.7502H11.0002C9.56479 14.7502 8.56367 14.7486 7.80832 14.647C7.07455 14.5484 6.68598 14.3679 6.40921 14.0912C6.17403 13.856 6.00839 13.54 5.9034 13.0002H16.0222C16.9817 13.0002 17.4614 13.0002 17.8371 12.7524C18.2128 12.5047 18.4017 12.0638 18.7797 11.1819L19.2082 10.1819C20.0177 8.29314 20.4225 7.34873 19.9779 6.67446C19.5333 6.0002 18.5058 6.0002 16.4508 6.0002H5.74526C5.73936 5.69251 5.72644 5.41491 5.69817 5.16732C5.64282 4.6825 5.52222 4.23764 5.23112 3.83376C4.94002 3.42989 4.55613 3.1748 4.1137 2.96897C3.69746 2.77534 3.16814 2.59892 2.54176 2.39015L2.23737 2.28869Z"
          fill={color}
        />
        <path
          d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z"
          fill={color}
        />
        <path
          d="M16.5 18C17.3284 18 18 18.6715 18 19.5C18 20.3284 17.3284 21 16.5 21C15.6716 21 15 20.3284 15 19.5C15 18.6715 15.6716 18 16.5 18Z"
          fill={color}
        />
      </svg>{" "}
    </React.Fragment>
  );
};

export const SideBarGreetingIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6786 0.735352C6.46969 0.735352 1.42969 4.677 1.42969 9.5377C1.42969 13.9749 5.6311 17.6328 11.0876 18.2398L8.19769 23.253L16.8363 17.7104C20.9869 16.4158 23.9276 13.2478 23.9276 9.5377C23.9276 4.67559 18.8904 0.735352 12.6786 0.735352ZM12.7647 13.437H11.257V10.6939H8.51816V13.437L7.00475 13.4695V6.34147L8.51816 6.309V9.15794H11.257V6.309H12.7647V13.437ZM15.5318 13.437H14.0551V9.08876H15.5318V13.437ZM15.5756 7.82241H14.0551V6.26382H15.5756V7.82241ZM19.8109 13.4342H18.3102V11.9476H19.8109V13.4342ZM19.7897 10.6106H18.3116V6.28782H19.7897V10.6106Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarInventoryIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.6C0 3.91044 0.273928 3.24912 0.761522 2.76152C1.24912 2.27393 1.91044 2 2.6 2H21.4C22.0896 2 22.7509 2.27393 23.2385 2.76152C23.7261 3.24912 24 3.91044 24 4.6V5.4C24 6.08956 23.7261 6.75088 23.2385 7.23848C22.7509 7.72607 22.0896 8 21.4 8H21V18.6C21 19.93 19.93 21 18.6 21H5.4C4.07 21 3 19.93 3 18.6V8H2.6C1.91044 8 1.24912 7.72607 0.761522 7.23848C0.273928 6.75088 0 6.08956 0 5.4L0 4.6ZM2.6 4C2.44087 4 2.28826 4.06321 2.17574 4.17574C2.06321 4.28826 2 4.44087 2 4.6V5.4C2 5.55913 2.06321 5.71174 2.17574 5.82426C2.28826 5.93679 2.44087 6 2.6 6H21.4C21.5591 6 21.7117 5.93679 21.8243 5.82426C21.9368 5.71174 22 5.55913 22 5.4V4.6C22 4.44087 21.9368 4.28826 21.8243 4.17574C21.7117 4.06321 21.5591 4 21.4 4H2.6ZM8 10C7.73478 10 7.48043 10.1054 7.29289 10.2929C7.10536 10.4804 7 10.7348 7 11C7 11.2652 7.10536 11.5196 7.29289 11.7071C7.48043 11.8946 7.73478 12 8 12H16C16.2652 12 16.5196 11.8946 16.7071 11.7071C16.8946 11.5196 17 11.2652 17 11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10H8Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarInvoiceIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V22L7 19L9 22L12 19L15 22L17 19L20 22V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM12 16H8C7.73478 16 7.48043 15.8946 7.29289 15.7071C7.10536 15.5196 7 15.2652 7 15C7 14.7348 7.10536 14.4804 7.29289 14.2929C7.48043 14.1054 7.73478 14 8 14H12C12.2652 14 12.5196 14.1054 12.7071 14.2929C12.8946 14.4804 13 14.7348 13 15C13 15.2652 12.8946 15.5196 12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16ZM12 12H8C7.73478 12 7.48043 11.8946 7.29289 11.7071C7.10536 11.5196 7 11.2652 7 11C7 10.7348 7.10536 10.4804 7.29289 10.2929C7.48043 10.1054 7.73478 10 8 10H12C12.2652 10 12.5196 10.1054 12.7071 10.2929C12.8946 10.4804 13 10.7348 13 11C13 11.2652 12.8946 11.5196 12.7071 11.7071C12.5196 11.8946 12.2652 12 12 12ZM16 16H15C14.7348 16 14.4804 15.8946 14.2929 15.7071C14.1054 15.5196 14 15.2652 14 15C14 14.7348 14.1054 14.4804 14.2929 14.2929C14.4804 14.1054 14.7348 14 15 14H16C16.2652 14 16.5196 14.1054 16.7071 14.2929C16.8946 14.4804 17 14.7348 17 15C17 15.2652 16.8946 15.5196 16.7071 15.7071C16.5196 15.8946 16.2652 16 16 16ZM16 12H15C14.7348 12 14.4804 11.8946 14.2929 11.7071C14.1054 11.5196 14 11.2652 14 11C14 10.7348 14.1054 10.4804 14.2929 10.2929C14.4804 10.1054 14.7348 10 15 10H16C16.2652 10 16.5196 10.1054 16.7071 10.2929C16.8946 10.4804 17 10.7348 17 11C17 11.2652 16.8946 11.5196 16.7071 11.7071C16.5196 11.8946 16.2652 12 16 12ZM16 7H8C7.73478 7 7.48043 6.89464 7.29289 6.70711C7.10536 6.51957 7 6.26522 7 6C7 5.73478 7.10536 5.48043 7.29289 5.29289C7.48043 5.10536 7.73478 5 8 5H16C16.2652 5 16.5196 5.10536 16.7071 5.29289C16.8946 5.48043 17 5.73478 17 6C17 6.26522 16.8946 6.51957 16.7071 6.70711C16.5196 6.89464 16.2652 7 16 7Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarJobsIcon = ({ color = "#646B88" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.25 8.25C23.2491 7.45462 22.9328 6.69206 22.3704 6.12964C21.8079 5.56722 21.0454 5.25087 20.25 5.25H18V4.5C17.9994 3.90345 17.7621 3.33152 17.3403 2.9097C16.9185 2.48787 16.3465 2.25062 15.75 2.25H8.25C7.65345 2.25062 7.08152 2.48787 6.65969 2.9097C6.23787 3.33152 6.00062 3.90345 6 4.5V5.25H3.75C2.95462 5.25087 2.19206 5.56722 1.62964 6.12964C1.06722 6.69206 0.750869 7.45462 0.75 8.25V10.5H23.25V8.25ZM16.5 5.25H7.5V4.5C7.5 4.30109 7.57902 4.11032 7.71967 3.96967C7.86032 3.82902 8.05109 3.75 8.25 3.75H15.75C15.9489 3.75 16.1397 3.82902 16.2803 3.96967C16.421 4.11032 16.5 4.30109 16.5 4.5V5.25Z"
        fill={color}
      />
      <path
        d="M15.75 12.375C15.75 12.6734 15.6315 12.9595 15.4205 13.1705C15.2095 13.3815 14.9234 13.5 14.625 13.5H9.375C9.07663 13.5 8.79048 13.3815 8.5795 13.1705C8.36853 12.9595 8.25 12.6734 8.25 12.375V12.1875C8.25 12.1378 8.23025 12.0901 8.19508 12.0549C8.15992 12.0198 8.11223 12 8.0625 12H0.75V18.75C0.75 19.5456 1.06607 20.3087 1.62868 20.8713C2.19129 21.4339 2.95435 21.75 3.75 21.75H20.25C21.0456 21.75 21.8087 21.4339 22.3713 20.8713C22.9339 20.3087 23.25 19.5456 23.25 18.75V12H15.9375C15.8878 12 15.8401 12.0198 15.8049 12.0549C15.7698 12.0901 15.75 12.1378 15.75 12.1875V12.375Z"
        fill={color}
      />
    </svg>
  );
};

export const SideBarManagerIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.2016 16.4882C21.7056 16.3602 21.2896 16.2082 20.9536 16.0322C20.3936 15.7442 20.1136 15.4082 20.1136 15.0242C20.1136 14.9282 20.0736 14.8442 19.9936 14.7722C19.9136 14.7002 19.8176 14.6722 19.7056 14.6882C19.2416 14.7522 18.7456 14.5042 18.2176 13.9442C17.8976 13.5922 17.6016 13.1682 17.3296 12.6722C17.3136 12.6242 17.2816 12.6002 17.2336 12.6002C17.1856 12.6002 17.1536 12.6242 17.1376 12.6722C16.8656 13.1682 16.5696 13.5922 16.2496 13.9442C15.7216 14.5042 15.2256 14.7522 14.7616 14.6882C14.6496 14.6722 14.5536 14.7002 14.4736 14.7722C14.3936 14.8442 14.3536 14.9282 14.3536 15.0242C14.3696 15.4082 14.0976 15.7442 13.5376 16.0322C13.1856 16.2082 12.7696 16.3602 12.2896 16.4882C12.2416 16.4882 12.2096 16.5082 12.1936 16.5482C12.1776 16.5882 12.1856 16.6242 12.2176 16.6562C12.5696 17.0722 12.8496 17.4722 13.0576 17.8562C13.4096 18.5122 13.5216 19.0322 13.3936 19.4162C13.3616 19.4962 13.3656 19.5802 13.4056 19.6682C13.4456 19.7562 13.5056 19.8162 13.5856 19.8482C13.8736 19.9762 14.0736 20.3122 14.1856 20.8562C14.2656 21.1922 14.3056 21.5682 14.3056 21.9842C14.3056 22.0322 14.3256 22.0682 14.3656 22.0922C14.4056 22.1162 14.4416 22.1202 14.4736 22.1042C14.8896 21.8962 15.2896 21.7682 15.6736 21.7202C16.2656 21.6242 16.6976 21.7442 16.9696 22.0802C17.0336 22.1602 17.1216 22.2002 17.2336 22.2002C17.3456 22.2002 17.4336 22.1602 17.4976 22.0802C17.7696 21.7442 18.2096 21.6242 18.8176 21.7202C19.1856 21.7682 19.5776 21.8882 19.9936 22.0802C20.0416 22.1122 20.0816 22.1162 20.1136 22.0922C20.1456 22.0682 20.1616 22.0322 20.1616 21.9842C20.1616 21.5682 20.2016 21.1842 20.2816 20.8322C20.4096 20.3042 20.6096 19.9762 20.8816 19.8482C20.9616 19.8162 21.0216 19.7602 21.0616 19.6802C21.1016 19.6002 21.1056 19.5202 21.0736 19.4402C20.9456 19.0402 21.0576 18.5202 21.4096 17.8802C21.6176 17.4802 21.8976 17.0722 22.2496 16.6562C22.2816 16.6242 22.2896 16.5882 22.2736 16.5482C22.2576 16.5082 22.2336 16.4882 22.2016 16.4882ZM19.8736 17.3042L19.7536 17.4722C19.2256 18.1442 18.9696 18.9042 18.9856 19.7522V19.8482C18.9856 19.9122 18.9616 19.9642 18.9136 20.0042C18.8656 20.0442 18.8096 20.0642 18.7456 20.0642H18.6976L18.4336 19.9922C17.6336 19.7522 16.8336 19.7522 16.0336 19.9922L15.7696 20.0642H15.7216C15.6576 20.0642 15.6016 20.0442 15.5536 20.0042C15.5056 19.9642 15.4816 19.9122 15.4816 19.8482V19.7522C15.4976 18.9042 15.2416 18.1442 14.7136 17.4722L14.5936 17.3042C14.5456 17.2562 14.5336 17.1962 14.5576 17.1242C14.5816 17.0522 14.6336 17.0082 14.7136 16.9922C15.1776 16.8642 15.6096 16.6722 16.0096 16.4162C16.4096 16.1602 16.7456 15.8402 17.0176 15.4562L17.0416 15.4322C17.0896 15.3682 17.1536 15.3362 17.2336 15.3362C17.3136 15.3362 17.3776 15.3682 17.4256 15.4322L17.4496 15.4562C17.7216 15.8402 18.0536 16.1602 18.4456 16.4162C18.8376 16.6722 19.2736 16.8642 19.7536 16.9922C19.8336 17.0082 19.8856 17.0522 19.9096 17.1242C19.9336 17.1962 19.9216 17.2562 19.8736 17.3042ZM12.7936 21.2402C12.7776 21.1762 12.7376 21.1282 12.6736 21.0962C12.3376 20.9362 12.0936 20.6842 11.9416 20.3402C11.7896 19.9962 11.7696 19.6482 11.8816 19.2962C11.9456 19.0722 11.9296 18.8562 11.8336 18.6482C11.6256 18.2642 11.3776 17.9042 11.0896 17.5682C10.9296 17.3762 10.8216 17.1522 10.7656 16.8962C10.7096 16.6402 10.7176 16.3842 10.7896 16.1282C10.8616 15.8722 10.9976 15.6522 11.1976 15.4682C11.3976 15.2842 11.6376 15.1602 11.9176 15.0962C12.1976 15.0322 12.4736 14.9442 12.7456 14.8322C12.8096 14.7842 12.8496 14.7202 12.8656 14.6402C12.8656 14.5762 12.8416 14.5202 12.7936 14.4722L11.9776 13.2242C11.8816 13.0962 11.7696 12.9762 11.6416 12.8642C11.6096 12.8322 11.5976 12.8002 11.6056 12.7682C11.6136 12.7362 11.6336 12.7042 11.6656 12.6722C12.6256 12.2242 13.4096 11.5602 14.0176 10.6802C14.6416 9.75216 14.9536 8.76016 14.9536 7.70416C14.9536 6.69616 14.7056 5.76816 14.2096 4.92016C13.7136 4.07216 13.0416 3.40016 12.1936 2.90416C11.3456 2.40816 10.4216 2.16016 9.42162 2.16016C8.42162 2.16016 7.49762 2.40816 6.64962 2.90416C5.80162 3.40016 5.12962 4.07216 4.63362 4.92016C4.13762 5.76816 3.88962 6.69616 3.88962 7.70416C3.88962 8.76016 4.20162 9.75216 4.82562 10.6802C5.43362 11.5442 6.21762 12.2082 7.17762 12.6722C7.20962 12.6882 7.22562 12.7162 7.22562 12.7562C7.22562 12.7962 7.21762 12.8322 7.20162 12.8642C7.07362 12.9762 6.96162 13.0962 6.86562 13.2242C5.45762 15.3202 4.40162 16.9602 3.69762 18.1442C3.40962 18.6562 3.26562 19.0722 3.26562 19.3922C3.26562 19.8402 3.54162 20.2522 4.09362 20.6282C4.64562 21.0042 5.39362 21.3002 6.33762 21.5162C7.28162 21.7322 8.31362 21.8402 9.43362 21.8402C10.5856 21.8402 11.6576 21.7202 12.6496 21.4802C12.6976 21.4642 12.7336 21.4362 12.7576 21.3962C12.7816 21.3562 12.7936 21.3042 12.7936 21.2402Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarMarketingIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.7975 4.80047C9.22524 4.80358 7.71699 5.42374 6.59727 6.52754C5.47755 7.63133 4.83584 9.13055 4.81021 10.7026C4.78458 12.2747 5.37707 13.7941 6.46021 14.9338C7.54334 16.0735 9.03058 16.7425 10.6019 16.7969L11.3963 19.1801C9.68832 19.302 7.98385 18.8989 6.5113 18.025C5.03875 17.151 3.86847 15.8479 3.15725 14.2902C2.44604 12.7326 2.22787 10.9947 2.53197 9.30959C2.83607 7.62445 3.64792 6.0725 4.85875 4.86168C6.06957 3.65085 7.62152 2.839 9.30666 2.5349C10.9918 2.2308 12.7296 2.44897 14.2873 3.16018C15.845 3.8714 17.1481 5.04168 18.022 6.51423C18.896 7.98678 19.299 9.69125 19.1771 11.3993L16.7939 10.6049C16.7432 9.04834 16.0892 7.57253 14.9702 6.48937C13.8512 5.40621 12.3549 4.80057 10.7975 4.80047Z"
          fill={color}
        />
        <path
          d="M10.7992 9.6002C10.481 9.6002 10.1757 9.72662 9.95069 9.95167C9.72565 10.1767 9.59922 10.4819 9.59922 10.8002C9.59922 11.1185 9.72565 11.4237 9.95069 11.6487C10.1757 11.8738 10.481 12.0002 10.7992 12.0002V14.4002C10.0872 14.4002 9.39118 14.1891 8.79917 13.7935C8.20715 13.3979 7.74573 12.8357 7.47325 12.1779C7.20078 11.52 7.12949 10.7962 7.26839 10.0979C7.4073 9.39954 7.75017 8.75808 8.25364 8.25461C8.7571 7.75114 9.39856 7.40828 10.0969 7.26937C10.7952 7.13046 11.5191 7.20176 12.1769 7.47423C12.8347 7.74671 13.3969 8.20813 13.7925 8.80014C14.1881 9.39216 14.3992 10.0882 14.3992 10.8002H11.9992C11.9992 10.4819 11.8728 10.1767 11.6477 9.95167C11.4227 9.72662 11.1175 9.6002 10.7992 9.6002Z"
          fill={color}
        />
        <path
          d="M13.5796 12.0616C13.3682 11.9911 13.1413 11.9809 12.9244 12.0321C12.7075 12.0833 12.5091 12.1939 12.3515 12.3515C12.1939 12.5091 12.0833 12.7075 12.0321 12.9244C11.9809 13.1413 11.9911 13.3682 12.0616 13.5796L14.4616 20.7796C14.5411 21.0188 14.6939 21.227 14.8983 21.3744C15.1027 21.5219 15.3484 21.6013 15.6004 21.6013C15.8525 21.6013 16.0982 21.5219 16.3026 21.3744C16.507 21.227 16.6598 21.0188 16.7392 20.7796L17.7496 17.7496L20.7796 16.7392C21.0188 16.6598 21.227 16.507 21.3744 16.3026C21.5219 16.0982 21.6013 15.8525 21.6013 15.6004C21.6013 15.3484 21.5219 15.1027 21.3744 14.8983C21.227 14.6939 21.0188 14.5411 20.7796 14.4616L13.5796 12.0616Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarOrdersIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.58579 4.58579C5 5.17157 5 6.11438 5 8V17C5 18.8856 5 19.8284 5.58579 20.4142C6.17157 21 7.11438 21 9 21H15C16.8856 21 17.8284 21 18.4142 20.4142C19 19.8284 19 18.8856 19 17V8C19 6.11438 19 5.17157 18.4142 4.58579C17.8284 4 16.8856 4 15 4H9C7.11438 4 6.17157 4 5.58579 4.58579ZM9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10H15C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8H9ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H15C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12H9ZM9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18H13C13.5523 18 14 17.5523 14 17C14 16.4477 13.5523 16 13 16H9Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarOutsideInventoryIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.6C0 3.91044 0.273928 3.24912 0.761522 2.76152C1.24912 2.27393 1.91044 2 2.6 2H21.4C22.0896 2 22.7509 2.27393 23.2385 2.76152C23.7261 3.24912 24 3.91044 24 4.6V5.4C24 6.08956 23.7261 6.75088 23.2385 7.23848C22.7509 7.72607 22.0896 8 21.4 8H21V18.6C21 19.93 19.93 21 18.6 21H5.4C4.07 21 3 19.93 3 18.6V8H2.6C1.91044 8 1.24912 7.72607 0.761522 7.23848C0.273928 6.75088 0 6.08956 0 5.4L0 4.6ZM2.6 4C2.44087 4 2.28826 4.06321 2.17574 4.17574C2.06321 4.28826 2 4.44087 2 4.6V5.4C2 5.55913 2.06321 5.71174 2.17574 5.82426C2.28826 5.93679 2.44087 6 2.6 6H21.4C21.5591 6 21.7117 5.93679 21.8243 5.82426C21.9368 5.71174 22 5.55913 22 5.4V4.6C22 4.44087 21.9368 4.28826 21.8243 4.17574C21.7117 4.06321 21.5591 4 21.4 4H2.6ZM8 10C7.73478 10 7.48043 10.1054 7.29289 10.2929C7.10536 10.4804 7 10.7348 7 11C7 11.2652 7.10536 11.5196 7.29289 11.7071C7.48043 11.8946 7.73478 12 8 12H16C16.2652 12 16.5196 11.8946 16.7071 11.7071C16.8946 11.5196 17 11.2652 17 11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10H8Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarPackingOrderIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2021_7712)">
          <path
            d="M11.9638 12.9132V22.3851L19.5047 20.954V16.339C19.5047 16.1458 19.6729 15.9957 19.8649 16.0178L20.7926 16.1613C20.9558 16.1801 21.0791 16.3182 21.0791 16.4825V21.844C21.0791 21.9963 20.9727 22.128 20.8237 22.1601L12.5688 23.935C12.1699 24.0208 11.7574 24.0217 11.3581 23.9377L3.19182 22.2199C3.04523 22.1891 2.93904 22.0616 2.93515 21.9119L2.79406 16.4669C2.78966 16.2962 2.9188 16.1514 3.089 16.1364L10.0257 15.5269C10.146 15.5164 10.2504 15.4396 10.2964 15.3279L11.3414 12.7901C11.4763 12.4626 11.9638 12.559 11.9638 12.9132ZM2.71563 9.81191L0.538806 14.4649C0.432414 14.6923 0.614414 14.9488 0.864178 14.9236L9.03922 14.0975C9.15475 14.0859 9.25511 14.0132 9.30224 13.907L11.9326 7.98112L2.95006 9.63093C2.84727 9.64983 2.75994 9.71724 2.71563 9.81191ZM11.9326 7.98112L14.716 14.0923C14.7646 14.1991 14.8673 14.2712 14.9843 14.2806L23.1439 14.9368C23.3898 14.9566 23.5663 14.7048 23.464 14.4803L21.336 9.81504C21.292 9.71857 21.2034 9.64983 21.0991 9.63104L11.9326 7.98112ZM9.6455 3.1558L11.6657 6.65411C11.8213 6.92348 12.2101 6.92344 12.3656 6.65411L14.3854 3.1558C14.5409 2.88639 14.3465 2.54964 14.0355 2.54964H13.0257V0.404156C13.0257 0.180941 12.8448 0 12.6216 0H11.4093C11.1861 0 11.0052 0.180941 11.0052 0.404117V2.5496H9.99542C9.68436 2.5496 9.48993 2.88639 9.6455 3.1558Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2021_7712">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const SideBarProductIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1.61035L21 6.8065V17.1988L12 22.395L3 17.1988V6.8065L12 1.61035ZM8.99995 11.3096L9 18.3536L11 19.5084V12.4644L8.99995 11.3096ZM5 9.00035V16.0441L6.99998 17.1989V10.155L5 9.00035ZM15.9371 6.1928L10.0506 9.60699L12 10.7325L17.9 7.32612L15.9371 6.1928ZM12 3.91975L6.1 7.32612L8.05289 8.45359L13.9394 5.03945L12 3.91975Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarReceiptIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 6.25C4 5.00736 5.00736 4 6.25 4H14.75C15.9926 4 17 5.00736 17 6.25V14H20.5V17.25C20.5 19.0449 19.0449 20.5 17.25 20.5H6.25C5.00736 20.5 4 19.4926 4 18.25V6.25ZM17 19H17.25C18.2165 19 19 18.2165 19 17.25V15.5H17V19ZM7.75 8C7.33579 8 7 8.33579 7 8.75C7 9.16421 7.33579 9.5 7.75 9.5H13.25C13.6642 9.5 14 9.16421 14 8.75C14 8.33579 13.6642 8 13.25 8H7.75ZM7.75 11.5C7.33579 11.5 7 11.8358 7 12.25C7 12.6642 7.33579 13 7.75 13H13.25C13.6642 13 14 12.6642 14 12.25C14 11.8358 13.6642 11.5 13.25 11.5H7.75ZM7.75 15C7.33579 15 7 15.3358 7 15.75C7 16.1642 7.33579 16.5 7.75 16.5H10.25C10.6642 16.5 11 16.1642 11 15.75C11 15.3358 10.6642 15 10.25 15H7.75Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};
export const SideBarTemplateIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.7128 4.7998H6.28878C5.47278 4.7998 4.80078 5.4718 4.80078 6.2878V17.7118C4.80078 18.5278 5.47278 19.1998 6.28878 19.1998H17.7128C18.5288 19.1998 19.2008 18.5278 19.2008 17.7118V6.2878C19.2008 5.4718 18.5288 4.7998 17.7128 4.7998ZM10.1528 16.5838C10.1528 16.7758 9.96078 16.9198 9.76878 16.9198H7.34478H7.29678C7.10478 16.9198 6.96078 16.7278 6.96078 16.5358V11.7118C6.96078 11.5198 7.15278 11.3758 7.34478 11.3758H9.84078C10.0328 11.3758 10.1768 11.5678 10.1768 11.7598V16.5838H10.1528ZM16.9688 16.6318C16.9688 16.8238 16.7768 16.9678 16.5848 16.9678H11.9768C11.7848 16.9678 11.6408 16.7758 11.6408 16.5838V11.7118C11.6408 11.5198 11.8328 11.3758 12.0248 11.3758H16.6088H16.6568C16.8488 11.3758 16.9928 11.5678 16.9928 11.7598V16.6318H16.9688ZM17.0168 9.5758C17.0168 9.76781 16.8248 9.9118 16.6328 9.9118H7.34478H7.29678C7.10478 9.9118 6.96078 9.7198 6.96078 9.5278V7.3678C6.96078 7.1758 7.15278 7.0318 7.34478 7.0318H16.6808C16.8728 7.0318 17.0168 7.2238 17.0168 7.4158V9.5758Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarWareHousetIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.6014 7.99968C21.4795 8.00016 21.3591 7.9728 21.2494 7.91968L12.0014 3.19968L2.75338 7.88768C2.3425 8.08208 1.85178 7.90656 1.65738 7.49568C1.46298 7.0848 1.6385 6.59408 2.04938 6.39968L12.0014 1.47168L21.9534 6.39968C22.3951 6.49696 22.6747 6.93392 22.5774 7.37568C22.4801 7.81744 22.0431 8.09696 21.6014 7.99968ZM8.00138 15.9997H3.20138V20.7997H8.00138V15.9997ZM14.4014 15.9997H9.60138V20.7997H14.4014V15.9997ZM20.8014 15.9997H16.0014V20.7997H20.8014V15.9997ZM17.6014 9.59968H12.8014V14.3997H17.6014V9.59968ZM11.2014 9.59968H6.40138V14.3997H11.2014V9.59968Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarNotificationIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.1911 14.0608L19.0611 12.1808C18.8111 11.7708 18.5911 10.9808 18.5911 10.5008V8.63078C18.5911 5.00078 15.6411 2.05078 12.0211 2.05078C8.39118 2.06078 5.44118 5.00078 5.44118 8.63078V10.4908C5.44118 10.9708 5.22118 11.7608 4.98118 12.1708L3.85118 14.0508C3.42118 14.7808 3.32118 15.6108 3.59118 16.3308C3.86118 17.0608 4.47118 17.6408 5.27118 17.9008C6.35118 18.2608 7.44118 18.5208 8.55118 18.7108C8.66118 18.7308 8.77118 18.7408 8.88118 18.7608C9.02118 18.7808 9.17118 18.8008 9.32118 18.8208C9.58118 18.8608 9.84118 18.8908 10.1111 18.9108C10.7411 18.9708 11.3811 19.0008 12.0211 19.0008C12.6511 19.0008 13.2811 18.9708 13.9011 18.9108C14.1311 18.8908 14.3611 18.8708 14.5811 18.8408C14.7611 18.8208 14.9411 18.8008 15.1211 18.7708C15.2311 18.7608 15.3411 18.7408 15.4511 18.7208C16.5711 18.5408 17.6811 18.2608 18.7611 17.9008C19.5311 17.6408 20.1211 17.0608 20.4011 16.3208C20.6811 15.5708 20.6011 14.7508 20.1911 14.0608ZM12.7511 10.0008C12.7511 10.4208 12.4111 10.7608 11.9911 10.7608C11.5711 10.7608 11.2311 10.4208 11.2311 10.0008V6.90078C11.2311 6.48078 11.5711 6.14078 11.9911 6.14078C12.4111 6.14078 12.7511 6.48078 12.7511 6.90078V10.0008Z"
          fill={color}
        />
        <path
          d="M14.8297 20.01C14.4097 21.17 13.2997 22 11.9997 22C11.2097 22 10.4297 21.68 9.87969 21.11C9.55969 20.81 9.31969 20.41 9.17969 20C9.30969 20.02 9.43969 20.03 9.57969 20.05C9.80969 20.08 10.0497 20.11 10.2897 20.13C10.8597 20.18 11.4397 20.21 12.0197 20.21C12.5897 20.21 13.1597 20.18 13.7197 20.13C13.9297 20.11 14.1397 20.1 14.3397 20.07C14.4997 20.05 14.6597 20.03 14.8297 20.01Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarEditDeleteIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12V11.5C20 10.9477 20.4477 10.5 21 10.5C21.5523 10.5 22 10.9477 22 11.5V12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2H12.5C13.0523 2 13.5 2.44772 13.5 3C13.5 3.55228 13.0523 4 12.5 4H12Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2156 2.82088C17.7412 2.29528 18.4541 2 19.1974 2C19.9407 2 20.6535 2.29528 21.1791 2.82088C21.7047 3.34648 22 4.05934 22 4.80265C22 5.54596 21.7047 6.25883 21.1791 6.78443L20.396 7.56757C20.0055 7.9581 19.3723 7.9581 18.9818 7.56757L16.4324 5.01824C16.0419 4.62771 16.0419 3.99455 16.4324 3.60402L17.2156 2.82088ZM15.0182 6.43245C14.6277 6.04192 13.9945 6.04192 13.604 6.43245L9.14269 10.8938C9.01453 11.0219 8.92362 11.1825 8.87966 11.3583L8.02988 14.7575C7.94468 15.0982 8.04453 15.4587 8.29291 15.7071C8.54129 15.9555 8.90178 16.0553 9.24256 15.9701L12.6417 15.1204C12.8175 15.0764 12.9781 14.9855 13.1062 14.8573L17.5676 10.396C17.9581 10.0055 17.9581 9.37231 17.5676 8.98179L15.0182 6.43245Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarAccountIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const UpdateIcon1 = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2.5C6.49 2.5 2 6.99 2 12.5C2 18.01 6.49 22.5 12 22.5C17.51 22.5 22 18.01 22 12.5C22 6.99 17.51 2.5 12 2.5ZM16.78 10.2L11.11 15.87C10.97 16.01 10.78 16.09 10.58 16.09C10.38 16.09 10.19 16.01 10.05 15.87L7.22 13.04C6.93 12.75 6.93 12.27 7.22 11.98C7.51 11.69 7.99 11.69 8.28 11.98L10.58 14.28L15.72 9.14C16.01 8.85 16.49 8.85 16.78 9.14C17.07 9.43 17.07 9.9 16.78 10.2Z"
          fill="#34A853"
        />
      </svg>
    </React.Fragment>
  );
};

export const BlackListedIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21.5C16.9706 21.5 21 17.4706 21 12.5C21 7.52944 16.9706 3.5 12 3.5C7.02944 3.5 3 7.52944 3 12.5C3 17.4706 7.02944 21.5 12 21.5Z"
          stroke="#F93E3E"
          strokeWidth="2"
        />
        <path d="M18 18.5L6 6.5" stroke="#F93E3E" strokeWidth="2" />
      </svg>
    </React.Fragment>
  );
};

export const New = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1054_36384)">
          <path
            d="M19.3214 17.0178C18.7338 17.1935 18.1569 17.4988 17.5765 18.0764L17.5758 18.0771C16.8203 18.8383 16.5233 19.5946 16.392 20.3752C16.2628 21.1555 16.3267 21.9543 16.3403 22.7188C16.3417 22.8465 16.3425 22.9742 16.3396 23.1009L22.6009 16.8388C22.4022 16.8435 22.202 16.8406 21.9997 16.8356C21.1194 16.8093 20.2003 16.7555 19.3214 17.0178Z"
            fill="#4164E3"
          />
          <path
            d="M12.0003 0.5C5.37239 0.5 0 5.87202 0 12.4992C0 19.1272 5.37239 24.4996 12.0003 24.4996C12.9926 24.4996 13.9533 24.3712 14.876 24.1437C14.9943 24.0128 15.0697 23.8511 15.1185 23.5899C15.168 23.3162 15.1723 22.9513 15.1601 22.5302C15.14 21.6872 15.0568 20.6188 15.3897 19.4867C15.6114 18.7327 16.029 17.9578 16.7443 17.245C16.7443 17.245 16.7443 17.2446 16.745 17.2443C17.6799 16.3037 18.7238 15.885 19.6845 15.7311C20.6466 15.5751 21.5326 15.6554 22.2365 15.6641C22.705 15.6734 23.0867 15.6447 23.3342 15.5561C23.4648 15.5097 23.5588 15.4517 23.6442 15.3738C23.8716 14.4522 24 13.4912 24 12.4993C24 5.87201 18.6276 0.5 12.0003 0.5ZM9.47198 15.6141L8.68566 15.7691C8.63259 15.7791 8.59598 15.7659 8.56008 15.725L6.41414 13.2174L6.38114 13.2239L6.93572 16.0443C6.94359 16.0841 6.92208 16.1157 6.88266 16.1235L6.13575 16.2703C6.09628 16.2782 6.06473 16.2566 6.05681 16.2168L5.20017 11.8579C5.19159 11.8177 5.21311 11.7865 5.25258 11.7786L6.04537 11.6225C6.09202 11.6132 6.13505 11.6258 6.1702 11.667L8.31183 14.1821L8.34483 14.1756L7.7888 11.3485C7.78087 11.3086 7.80239 11.2775 7.84261 11.2692L8.58877 11.1225C8.62823 11.1146 8.65983 11.1354 8.6677 11.1755L9.52509 15.5349C9.53297 15.5751 9.51145 15.6066 9.47198 15.6141ZM13.3441 14.8526L10.4642 15.4193C10.4241 15.4269 10.3932 15.4057 10.3853 15.3659L9.52725 11.0069C9.52008 10.9668 9.54089 10.9352 9.58106 10.9273L12.461 10.3609C12.5004 10.3533 12.532 10.3745 12.5399 10.4143L12.6784 11.121C12.687 11.1605 12.6655 11.192 12.626 11.1999L10.6903 11.5805C10.6637 11.5855 10.653 11.6014 10.658 11.6279L10.8338 12.5197C10.8388 12.5459 10.8546 12.5566 10.8811 12.5516L12.4933 12.2345C12.5327 12.2269 12.5643 12.2485 12.5722 12.2876L12.71 12.9878C12.7178 13.0276 12.6963 13.0588 12.6569 13.0667L11.0447 13.3838C11.0189 13.3888 11.0074 13.4046 11.0124 13.4311L11.1961 14.3624C11.2011 14.389 11.2176 14.3993 11.2434 14.3939L13.1791 14.0133C13.2186 14.0054 13.2502 14.0273 13.2581 14.0667L13.3973 14.7734C13.4052 14.8135 13.3837 14.8451 13.3441 14.8526ZM18.1677 13.8352C18.1685 13.8768 18.1412 13.9098 18.0945 13.9184L17.4338 14.0483C17.3879 14.0576 17.3556 14.0361 17.3348 13.9991L16.006 11.3585L15.9931 11.3614L15.7563 14.3097C15.7513 14.3517 15.7297 14.3837 15.6839 14.3926L15.0231 14.5228C14.9836 14.5304 14.952 14.5089 14.9305 14.4719L12.9109 10.3411C12.8965 10.3027 12.9044 10.2736 12.951 10.2647L13.8026 10.0971C13.8492 10.0882 13.8808 10.109 13.8945 10.1477L15.0969 12.8407L15.1105 12.8378L15.3222 9.86717C15.3272 9.82447 15.3487 9.79325 15.3946 9.78392L15.9693 9.67095C16.0088 9.66341 16.0404 9.68422 16.0619 9.72191L17.4086 12.3859L17.4222 12.3834L17.4882 9.44141C17.4861 9.39369 17.5083 9.36823 17.5549 9.35928L18.4001 9.19316C18.446 9.18383 18.4647 9.2075 18.4654 9.24875L18.1677 13.8352Z"
            fill="#4164E3"
          />
        </g>
        <defs>
          <clipPath id="clip0_1054_36384">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const PendingIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 12.5C9.53757 12.5 12 14.9624 12 18C12 21.0376 9.53757 23.5 6.5 23.5C3.46243 23.5 1 21.0376 1 18C1 14.9624 3.46243 12.5 6.5 12.5ZM6.5 20.38C6.15509 20.38 5.87549 20.6596 5.87549 21.0045C5.87549 21.3494 6.15509 21.629 6.5 21.629C6.84491 21.629 7.12451 21.3494 7.12451 21.0045C7.12451 20.6596 6.84491 20.38 6.5 20.38ZM17.75 3.5C19.5449 3.5 21 4.95507 21 6.75V18.25C21 20.0449 19.5449 21.5 17.75 21.5L11.9774 21.5012C12.6247 20.4907 13 19.2892 13 18C13 16.4846 12.4814 15.0904 11.6108 13.9871L11.6795 13.9967L11.75 14H16.2483L16.35 13.9932C16.7161 13.9435 16.9983 13.6297 16.9983 13.25C16.9983 12.8703 16.7161 12.5565 16.35 12.5068L16.2483 12.5H12.5V7.25L12.4932 7.14823C12.4435 6.78215 12.1297 6.5 11.75 6.5C11.3703 6.5 11.0565 6.78215 11.0068 7.14823L11 7.25V13.25L11.0048 13.3142C9.83648 12.1907 8.2489 11.5 6.5 11.5C5.21084 11.5 4.00934 11.8753 2.99879 12.5226L3 6.75C3 4.95507 4.45507 3.5 6.25 3.5H17.75ZM6.50004 14.5031C5.45209 14.5031 4.63575 15.3205 4.64666 16.4574C4.64931 16.7335 4.87531 16.9552 5.15144 16.9526C5.42757 16.9499 5.64927 16.7239 5.64662 16.4478C5.64106 15.8688 6.00627 15.5031 6.50004 15.5031C6.97242 15.5031 7.35345 15.895 7.35345 16.4526C7.35345 16.6769 7.27816 16.8437 7.03552 17.13L6.9365 17.2432L6.67113 17.5333C6.18682 18.0749 6.00004 18.4255 6.00004 19.0006C6.00004 19.2767 6.2239 19.5006 6.50004 19.5006C6.77619 19.5006 7.00004 19.2767 7.00004 19.0006C7.00004 18.7684 7.07645 18.5981 7.32379 18.3063L7.42474 18.1908L7.69048 17.9003C8.16815 17.366 8.35345 17.0186 8.35345 16.4526C8.35345 15.3489 7.53109 14.5031 6.50004 14.5031Z"
          fill="#FF9900"
        />
      </svg>
    </React.Fragment>
  );
};

export const DealerInfoCardRejectedStatusIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1054_36544)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2427 15.68C16.536 15.9725 16.536 16.4525 16.2427 16.745C15.9502 17.0375 15.4748 17.0375 15.1815 16.745L12.0045 13.565L8.80499 16.7675C8.50949 17.06 8.03102 17.06 7.73552 16.7675C7.44077 16.4675 7.44077 15.9875 7.73552 15.695L10.935 12.4925L7.758 9.32001C7.46475 9.02751 7.46475 8.54747 7.758 8.25497C8.04975 7.96247 8.52525 7.96247 8.8185 8.25497L11.9955 11.435L15.219 8.21002C15.5145 7.91752 15.9922 7.91752 16.2877 8.21002C16.5825 8.51002 16.5825 8.98247 16.2877 9.28247L13.065 12.5075L16.2427 15.68ZM12 0.5C5.37225 0.5 0 5.87 0 12.5C0 19.13 5.37225 24.5 12 24.5C18.6278 24.5 24 19.13 24 12.5C24 5.87 18.6278 0.5 12 0.5Z"
            fill="#F93E3E"
          />
        </g>
        <defs>
          <clipPath id="clip0_1054_36544">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const PhoneIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#F8F9FC" />
        <path
          opacity="0.4"
          d="M25.3 7.5H14.7C11.25 7.5 10 8.75 10 12.2625V27.7375C10 31.25 11.25 32.5 14.7 32.5H25.2875C28.75 32.5 30 31.25 30 27.7375V12.2625C30 8.75 28.75 7.5 25.3 7.5Z"
          fill="#4164E3"
        />
        <path
          d="M22.5 12.8125H17.5C16.9875 12.8125 16.5625 12.3875 16.5625 11.875C16.5625 11.3625 16.9875 10.9375 17.5 10.9375H22.5C23.0125 10.9375 23.4375 11.3625 23.4375 11.875C23.4375 12.3875 23.0125 12.8125 22.5 12.8125Z"
          fill="#4164E3"
        />
        <path
          d="M20 29.125C21.2081 29.125 22.1875 28.1456 22.1875 26.9375C22.1875 25.7294 21.2081 24.75 20 24.75C18.7919 24.75 17.8125 25.7294 17.8125 26.9375C17.8125 28.1456 18.7919 29.125 20 29.125Z"
          fill="#4164E3"
        />
      </svg>
    </React.Fragment>
  );
};
export const PhoneIcon2 = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#212327" />
        <path
          opacity="0.4"
          d="M25.3 7.5H14.7C11.25 7.5 10 8.75 10 12.2625V27.7375C10 31.25 11.25 32.5 14.7 32.5H25.2875C28.75 32.5 30 31.25 30 27.7375V12.2625C30 8.75 28.75 7.5 25.3 7.5Z"
          fill="white"
        />
        <path
          d="M22.5 12.8125H17.5C16.9875 12.8125 16.5625 12.3875 16.5625 11.875C16.5625 11.3625 16.9875 10.9375 17.5 10.9375H22.5C23.0125 10.9375 23.4375 11.3625 23.4375 11.875C23.4375 12.3875 23.0125 12.8125 22.5 12.8125Z"
          fill="white"
        />
        <path
          d="M20 29.125C21.2081 29.125 22.1875 28.1456 22.1875 26.9375C22.1875 25.7294 21.2081 24.75 20 24.75C18.7919 24.75 17.8125 25.7294 17.8125 26.9375C17.8125 28.1456 18.7919 29.125 20 29.125Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const CallIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#F8F9FC" />
        <path
          opacity="0.5"
          d="M17.547 11.6452L18.3583 13.0989C19.0904 14.4107 18.7965 16.1316 17.6434 17.2847C17.6434 17.2847 16.2449 18.6835 18.7806 21.2194C21.3156 23.7544 22.7153 22.3566 22.7153 22.3566C23.8684 21.2035 25.5893 20.9096 26.9011 21.6418L28.3548 22.453C30.3358 23.5585 30.5696 26.3365 28.8285 28.0778C27.7823 29.124 26.5005 29.9381 25.0836 29.9918C22.6985 30.0823 18.6479 29.4786 14.5846 25.4154C10.5214 21.3521 9.91777 17.3015 10.0082 14.9164C10.0619 13.4995 10.876 12.2178 11.9223 11.1715C13.6635 9.43035 16.4415 9.6643 17.547 11.6452Z"
          fill="#4164E3"
        />
        <path
          d="M21.5744 7.34979C21.6571 6.83868 22.1402 6.49197 22.6514 6.5747C22.683 6.58077 22.7849 6.59979 22.8381 6.61167C22.9449 6.63543 23.0936 6.67199 23.2791 6.72603C23.6501 6.83408 24.1684 7.01209 24.7904 7.29725C26.0357 7.8682 27.693 8.86695 29.4127 10.5867C31.1325 12.3065 32.1312 13.9637 32.7021 15.2091C32.9874 15.8311 33.1654 16.3493 33.2734 16.7203C33.3274 16.9058 33.364 17.0546 33.3877 17.1613C33.3996 17.2146 33.4084 17.2574 33.4144 17.2891L33.4216 17.3281C33.5042 17.8391 33.1607 18.3424 32.6496 18.4251C32.14 18.5076 31.6599 18.1625 31.5751 17.6539C31.5725 17.6401 31.5652 17.6035 31.5576 17.5689C31.5421 17.4996 31.5155 17.3899 31.4732 17.2447C31.3886 16.9542 31.2417 16.5226 30.9977 15.9905C30.5105 14.9276 29.6342 13.4599 28.0869 11.9125C26.5396 10.3652 25.0719 9.48897 24.009 9.00168C23.4769 8.75773 23.0452 8.61082 22.7547 8.52622C22.6096 8.48393 22.4271 8.44204 22.3579 8.42663C21.8491 8.34184 21.4919 7.85944 21.5744 7.34979Z"
          fill="#4164E3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8566 11.6607C21.9989 11.1628 22.5177 10.8745 23.0156 11.0168L22.7581 11.9182C23.0156 11.0168 23.0156 11.0168 23.0156 11.0168L23.0175 11.0173L23.0194 11.0179L23.0235 11.0191L23.0332 11.022L23.058 11.0297C23.0767 11.0357 23.1004 11.0435 23.1284 11.0535C23.1845 11.0734 23.2587 11.1018 23.3497 11.1408C23.5319 11.2188 23.7806 11.3393 24.0864 11.5202C24.6981 11.8823 25.5334 12.4838 26.5146 13.465C27.4959 14.4462 28.0972 15.2815 28.4594 15.8933C28.6402 16.1989 28.7607 16.4478 28.8389 16.6299C28.8779 16.7209 28.9062 16.7951 28.9261 16.8512C28.9361 16.8793 28.9439 16.9028 28.95 16.9217L28.9576 16.9464L28.9605 16.9561L28.9617 16.9602L28.9622 16.9622C28.9622 16.9622 28.9629 16.964 28.0614 17.2215L28.9629 16.964C29.1051 17.4618 28.8167 17.9807 28.319 18.1229C27.8254 18.2639 27.311 17.9818 27.1636 17.4917L27.159 17.4782C27.1524 17.4594 27.1386 17.4225 27.1155 17.3685C27.0692 17.2605 26.9854 17.084 26.8459 16.8483C26.5671 16.3773 26.0637 15.6658 25.1887 14.7908C24.3139 13.9159 23.6022 13.4125 23.1314 13.1338C22.8956 12.9943 22.7191 12.9104 22.6111 12.8642C22.5571 12.841 22.5201 12.8272 22.5014 12.8206L22.4879 12.8159C21.9979 12.6686 21.7156 12.1543 21.8566 11.6607Z"
          fill="#4164E3"
        />
      </svg>
    </React.Fragment>
  );
};

export const DealerInfoCardCallDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M6.72831 19.6998C7.54831 18.8198 8.79828 18.8898 9.51828 19.8498L10.5283 21.1998C11.3383 22.2698 12.6483 22.2698 13.4583 21.1998L14.4683 19.8498C15.1883 18.8898 16.4384 18.8198 17.2584 19.6998C19.0384 21.5998 20.4883 20.9698 20.4883 18.3098V7.04974C20.4883 3.01974 19.5483 2.00977 15.7683 2.00977H8.20829C4.42829 2.00977 3.48828 3.01974 3.48828 7.04974V18.3098C3.49828 20.9698 4.95831 21.5898 6.72831 19.6998Z"
          fill="#E4E7EB"
        />
        <path
          d="M14.8429 9.99114L14.3429 10.5012H14.3329L11.3029 13.5312C11.1729 13.6612 10.9029 13.8012 10.7129 13.8212L9.36286 14.0212C8.87286 14.0912 8.53288 13.7412 8.60288 13.2612L8.79288 11.9012C8.82288 11.7112 8.95286 11.4512 9.08286 11.3112L12.1229 8.28115L12.6229 7.77114C12.9529 7.44114 13.3229 7.20117 13.7229 7.20117C14.0629 7.20117 14.4329 7.36114 14.8429 7.77114C15.7429 8.67114 15.4529 9.38114 14.8429 9.99114Z"
          fill="#E4E7EB"
        />
      </svg>
    </React.Fragment>
  );
};

export const WAIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#F8F9FC" />
        <path
          d="M25.685 22.2636L23.2888 20.8948C22.9925 20.7261 22.6325 20.7298 22.34 20.9061L20.5063 22.0048C19.25 21.4386 18.245 20.4336 17.6788 19.1773L18.7775 17.3436C18.9538 17.0511 18.9575 16.6911 18.7888 16.3948L17.42 13.9986C17.2775 13.7473 17.0075 13.5898 16.7188 13.5898C14.9112 13.5898 13.445 15.0486 13.4375 16.8561C13.4375 16.8636 13.4375 16.8748 13.4375 16.8823C13.445 22.0611 17.6487 26.2498 22.8275 26.2423C24.6313 26.2311 26.09 24.7648 26.0938 22.9611C26.0938 22.6761 25.9362 22.4061 25.685 22.2636Z"
          fill="#4164E3"
        />
        <path
          opacity="0.4"
          d="M25.7412 10.0086C24.005 8.97734 22.0213 8.43359 20 8.43359C13.7863 8.43359 8.75 13.4736 8.75 19.6873C8.75 21.7048 9.29375 23.6886 10.325 25.4248L9.215 29.3098C9.0725 29.8086 9.36125 30.3261 9.86 30.4686C10.0288 30.5173 10.205 30.5173 10.3738 30.4686L14.2587 29.3586C19.6025 32.5311 26.5063 30.7686 29.675 25.4248C32.8438 20.0811 31.085 13.1773 25.7412 10.0086ZM22.8238 26.2461C17.6488 26.2536 13.445 22.0611 13.4375 16.8823C13.4375 16.8748 13.4375 16.8636 13.4375 16.8561C13.445 15.0486 14.9113 13.5861 16.7188 13.5898C17.0075 13.5898 17.2775 13.7436 17.42 13.9986L18.7888 16.3948C18.9575 16.6911 18.9538 17.0511 18.7775 17.3436L17.6788 19.1773C18.245 20.4336 19.25 21.4386 20.5063 22.0048L22.34 20.9061C22.6325 20.7298 22.9925 20.7261 23.2888 20.8948L25.685 22.2636C25.9363 22.4061 26.0938 22.6761 26.0938 22.9648C26.0863 24.7686 24.6313 26.2348 22.8238 26.2461Z"
          fill="#4164E3"
        />
      </svg>
    </React.Fragment>
  );
};

export const WAIconDark = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#212327" />
        <path
          d="M25.685 22.2626L23.2888 20.8939C22.9925 20.7251 22.6325 20.7289 22.34 20.9051L20.5063 22.0039C19.25 21.4376 18.245 20.4326 17.6788 19.1764L18.7775 17.3426C18.9538 17.0501 18.9575 16.6901 18.7888 16.3939L17.42 13.9976C17.2775 13.7464 17.0075 13.5889 16.7188 13.5889C14.9112 13.5889 13.445 15.0476 13.4375 16.8551C13.4375 16.8626 13.4375 16.8739 13.4375 16.8814C13.445 22.0601 17.6487 26.2489 22.8275 26.2414C24.6313 26.2301 26.09 24.7639 26.0938 22.9601C26.0938 22.6751 25.9362 22.4051 25.685 22.2626Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M25.7412 10.0076C24.005 8.97637 22.0213 8.43262 20 8.43262C13.7863 8.43262 8.75 13.4726 8.75 19.6864C8.75 21.7039 9.29375 23.6876 10.325 25.4239L9.215 29.3089C9.0725 29.8076 9.36125 30.3251 9.86 30.4676C10.0288 30.5164 10.205 30.5164 10.3738 30.4676L14.2587 29.3576C19.6025 32.5301 26.5063 30.7676 29.675 25.4239C32.8438 20.0801 31.085 13.1764 25.7412 10.0076ZM22.8238 26.2451C17.6488 26.2526 13.445 22.0601 13.4375 16.8814C13.4375 16.8739 13.4375 16.8626 13.4375 16.8551C13.445 15.0476 14.9113 13.5851 16.7188 13.5889C17.0075 13.5889 17.2775 13.7426 17.42 13.9976L18.7888 16.3939C18.9575 16.6901 18.9538 17.0501 18.7775 17.3426L17.6788 19.1764C18.245 20.4326 19.25 21.4376 20.5063 22.0039L22.34 20.9051C22.6325 20.7289 22.9925 20.7251 23.2888 20.8939L25.685 22.2626C25.9363 22.4051 26.0938 22.6751 26.0938 22.9639C26.0863 24.7676 24.6313 26.2339 22.8238 26.2451Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const DealerStatusCardIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 10C11.2091 10 13 8.20914 13 6C13 3.79086 11.2091 2 9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10Z"
          stroke="#4164E3"
          strokeWidth="1.5"
        />
        <path
          opacity="0.5"
          d="M12.5 4.3411C13.0375 3.53275 13.9565 3 15 3C16.6569 3 18 4.34315 18 6C18 7.65685 16.6569 9 15 9C13.9565 9 13.0375 8.46725 12.5 7.6589"
          stroke="#4164E3"
          strokeWidth="1.5"
        />
        <path
          d="M9 21C12.866 21 16 19.2091 16 17C16 14.7909 12.866 13 9 13C5.13401 13 2 14.7909 2 17C2 19.2091 5.13401 21 9 21Z"
          stroke="#4164E3"
          strokeWidth="1.5"
        />
        <path
          opacity="0.5"
          d="M18 14C19.7542 14.3847 21 15.3589 21 16.5C21 17.5293 19.9863 18.4229 18.5 18.8704"
          stroke="#4164E3"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const DealerStatusCardDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M6.72831 19.6998C7.54831 18.8198 8.79828 18.8898 9.51828 19.8498L10.5283 21.1998C11.3383 22.2698 12.6483 22.2698 13.4583 21.1998L14.4683 19.8498C15.1883 18.8898 16.4384 18.8198 17.2584 19.6998C19.0384 21.5998 20.4883 20.9698 20.4883 18.3098V7.04974C20.4883 3.01974 19.5483 2.00977 15.7683 2.00977H8.20829C4.42829 2.00977 3.48828 3.01974 3.48828 7.04974V18.3098C3.49828 20.9698 4.95831 21.5898 6.72831 19.6998Z"
          fill="#E4E7EB"
        />
        <path
          d="M14.8429 9.99114L14.3429 10.5012H14.3329L11.3029 13.5312C11.1729 13.6612 10.9029 13.8012 10.7129 13.8212L9.36286 14.0212C8.87286 14.0912 8.53288 13.7412 8.60288 13.2612L8.79288 11.9012C8.82288 11.7112 8.95286 11.4512 9.08286 11.3112L12.1229 8.28115L12.6229 7.77114C12.9529 7.44114 13.3229 7.20117 13.7229 7.20117C14.0629 7.20117 14.4329 7.36114 14.8429 7.77114C15.7429 8.67114 15.4529 9.38114 14.8429 9.99114Z"
          fill="#E4E7EB"
        />
      </svg>
    </React.Fragment>
  );
};

export const TestTopDotIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="9"
        height="8"
        viewBox="0 0 9 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" width="8" height="8" rx="4" fill="#E4E7EB" />
      </svg>
    </React.Fragment>
  );
};

export const TestTopBackArrowIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 8.75L11.75 15L18 21.25"
          stroke="#4164E3"
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const TestTopAddDealerIcon = ({ color = "#ffffff" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 12H18M12 6V18"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const ManagerLogOffIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2826 9.95865C11.2826 10.3563 11.605 10.6786 12.0026 10.6786C12.4002 10.6786 12.7226 10.3563 12.7226 9.95865H11.2826ZM12.7226 4.31961C12.7226 3.92197 12.4002 3.59961 12.0026 3.59961C11.605 3.59961 11.2826 3.92197 11.2826 4.31961H12.7226ZM9.42098 6.87471C9.78288 6.70992 9.94263 6.28295 9.77789 5.92106C9.61306 5.55917 9.1861 5.3994 8.82421 5.56419L9.42098 6.87471ZM5.2826 12.1532L4.5625 12.1495L4.56264 12.1616L5.2826 12.1532ZM12.0026 18.7196L12.0109 17.9996C12.0054 17.9996 11.9998 17.9996 11.9943 17.9996L12.0026 18.7196ZM18.7226 12.1532L19.4427 12.1616L19.4426 12.1495L18.7226 12.1532ZM15.181 5.56419C14.819 5.3994 14.3921 5.55917 14.2273 5.92106C14.0626 6.28295 14.2223 6.70992 14.5842 6.87471L15.181 5.56419ZM12.7226 9.95865V4.31961H11.2826V9.95865H12.7226ZM8.82421 5.56419C6.24109 6.74045 4.57737 9.31114 4.5625 12.1495L6.00259 12.157C6.01452 9.88028 7.34896 7.81823 9.42098 6.87471L8.82421 5.56419ZM4.56264 12.1616C4.60997 16.228 7.94447 19.4863 12.0109 19.4396L11.9943 17.9996C8.72308 18.0372 6.04062 15.4161 6.00255 12.1449L4.56264 12.1616ZM11.9943 19.4396C16.0607 19.4863 19.3955 16.228 19.4427 12.1616L18.0027 12.1449C17.9646 15.4161 15.2821 18.0372 12.0109 17.9996L11.9943 19.4396ZM19.4426 12.1495C19.4277 9.31114 17.7641 6.74045 15.181 5.56419L14.5842 6.87471C16.6562 7.81823 17.9907 9.88028 18.0026 12.157L19.4426 12.1495Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const ManagerLogOutIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 12L22 12M22 12L18.5 15M22 12L18.5 9"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.9998 8L1.9998 16C1.9998 18.8284 1.9998 20.2426 2.8785 21.1213C3.7571 22 5.1714 22 7.9998 22L8.9998 22C11.8282 22 13.2424 22 14.1211 21.1213C14.8895 20.3529 14.9859 19.175 14.998 17M14.998 7C14.9859 4.82497 14.8895 3.64706 14.1211 2.87868C13.2424 2 11.8282 2 8.9998 2L7.9998 2C5.1714 2 3.7571 2 2.8785 2.87868C2.5787 3.17848 2.3812 3.54062 2.251 4"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const ManagerCameraIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.5"
          y="1.5"
          width="37"
          height="37"
          rx="18.5"
          fill="#4164E3"
          stroke="white"
          strokeWidth="3"
        />
        <g clipPath="url(#clip0_796_24173)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 19C18.8954 19 18 19.8954 18 21C18 22.1046 18.8954 23 20 23C21.1046 23 22 22.1046 22 21C22 19.8954 21.1046 19 20 19Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.0002 17.5042C30.0002 17.5377 30.0001 17.5716 30.0001 17.6058V24.066C30.0002 24.9525 30.0002 25.7163 29.918 26.328C29.8299 26.9835 29.6311 27.6118 29.1215 28.1215C28.6118 28.6312 27.9834 28.8299 27.3279 28.918C26.7163 29.0003 25.9524 29.0002 25.0659 29.0002H14.9343C14.0478 29.0002 13.284 29.0003 12.6723 28.918C12.0168 28.8299 11.3885 28.6312 10.8788 28.1215C10.3692 27.6118 10.1704 26.9835 10.0823 26.328C10 25.7163 10.0001 24.9525 10.0001 24.066V17.6058C10.0001 17.5716 10.0001 17.5377 10.0001 17.5042C9.99962 17.043 9.99924 16.6455 10.0846 16.2935C10.3492 15.2017 11.2016 14.3493 12.2934 14.0846C12.6454 13.9993 13.043 13.9997 13.5041 14.0001C13.5376 14.0002 13.5715 14.0002 13.6057 14.0002C13.952 14.0002 14.0217 13.9976 14.078 13.9892C14.3061 13.955 14.5154 13.843 14.6704 13.6721C14.7087 13.63 14.7495 13.5734 14.9416 13.2853L15.1681 12.9455C15.191 12.9112 15.2136 12.8771 15.2361 12.8433C15.5639 12.3502 15.8529 11.9154 16.2632 11.6057C16.5114 11.4184 16.7872 11.2708 17.0807 11.1682C17.5659 10.9986 18.0881 10.9993 18.6801 11.0001C18.7207 11.0002 18.7617 11.0002 18.8029 11.0002H21.1974C21.2386 11.0002 21.2796 11.0002 21.3202 11.0001C21.9122 10.9993 22.4344 10.9986 22.9196 11.1682C23.2131 11.2708 23.4889 11.4184 23.7371 11.6057C24.1473 11.9154 24.4364 12.3502 24.7642 12.8433C24.7866 12.8771 24.8093 12.9112 24.8322 12.9455L25.0587 13.2853C25.2508 13.5734 25.2916 13.63 25.3299 13.6721C25.4849 13.843 25.6942 13.955 25.9223 13.9892C25.9786 13.9976 26.0483 14.0002 26.3946 14.0002C26.4288 14.0002 26.4627 14.0002 26.4962 14.0001C26.9573 13.9997 27.3549 13.9993 27.7068 14.0846C28.7986 14.3493 29.6511 15.2017 29.9157 16.2935C30.001 16.6455 30.0006 17.043 30.0002 17.5042ZM16.0003 21.0002C16.0003 18.7911 17.7911 17.0002 20.0003 17.0002C22.2094 17.0002 24.0003 18.7911 24.0003 21.0002C24.0003 23.2093 22.2094 25.0002 20.0003 25.0002C17.7911 25.0002 16.0003 23.2093 16.0003 21.0002Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_796_24173">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(8 8)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const ManagerLockIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z"
          fill="white"
        />
        <path
          d="M12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
          fill="white"
        />
        <path
          d="M6.75 8C6.75 5.10051 9.10051 2.75 12 2.75C14.8995 2.75 17.25 5.10051 17.25 8V10.0036C17.8174 10.0089 18.3135 10.022 18.75 10.0546V8C18.75 4.27208 15.7279 1.25 12 1.25C8.27208 1.25 5.25 4.27208 5.25 8V10.0546C5.68651 10.022 6.18264 10.0089 6.75 10.0036V8Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const ImageShare = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25px"
        height="25px"
        viewBox="0 0 24 24"
        fill={mode ? "#fff" : "#000"}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 4C23 2.34315 21.6569 1 20 1H4C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4ZM21 4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4Z"
          fill={mode ? "#fff" : "#000"}
        />
        <path
          d="M4.80665 17.5211L9.1221 9.60947C9.50112 8.91461 10.4989 8.91461 10.8779 9.60947L14.0465 15.4186L15.1318 13.5194C15.5157 12.8476 16.4843 12.8476 16.8682 13.5194L19.1451 17.5039C19.526 18.1705 19.0446 19 18.2768 19H5.68454C4.92548 19 4.44317 18.1875 4.80665 17.5211Z"
          fill={mode ? "#fff" : "#000"}
        />
        <path
          d="M18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8Z"
          fill={mode ? "#fff" : "#000"}
        />
      </svg>
    </React.Fragment>
  );
};

export const VideoShare = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25px"
        height="25px"
        viewBox="0 0 24 24"
        // fill={mode ? '#fff' : "#000"}
      >
        <path
          d="M16 10L18.5768 8.45392C19.3699 7.97803 19.7665 7.74009 20.0928 7.77051C20.3773 7.79703 20.6369 7.944 20.806 8.17433C21 8.43848 21 8.90095 21 9.8259V14.1741C21 15.099 21 15.5615 20.806 15.8257C20.6369 16.056 20.3773 16.203 20.0928 16.2295C19.7665 16.2599 19.3699 16.022 18.5768 15.5461L16 14M6.2 18H12.8C13.9201 18 14.4802 18 14.908 17.782C15.2843 17.5903 15.5903 17.2843 15.782 16.908C16 16.4802 16 15.9201 16 14.8V9.2C16 8.0799 16 7.51984 15.782 7.09202C15.5903 6.71569 15.2843 6.40973 14.908 6.21799C14.4802 6 13.9201 6 12.8 6H6.2C5.0799 6 4.51984 6 4.09202 6.21799C3.71569 6.40973 3.40973 6.71569 3.21799 7.09202C3 7.51984 3 8.07989 3 9.2V14.8C3 15.9201 3 16.4802 3.21799 16.908C3.40973 17.2843 3.71569 17.5903 4.09202 17.782C4.51984 18 5.07989 18 6.2 18Z"
          stroke={mode ? "#fff" : "#000"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const DocumentShare = ({ mode, height, width }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "25px"}
        height={height ? height : "25px"}
        viewBox="0 0 24 24"
        fill={mode ? "#fff" : "#000"}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.17157 3.17157C3 4.34315 3 6.22876 3 10V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V10C21 6.22876 21 4.34315 19.8284 3.17157C18.6569 2 16.7712 2 13 2H11C7.22876 2 5.34315 2 4.17157 3.17157ZM8 9.25C7.58579 9.25 7.25 9.58579 7.25 10C7.25 10.4142 7.58579 10.75 8 10.75H16C16.4142 10.75 16.75 10.4142 16.75 10C16.75 9.58579 16.4142 9.25 16 9.25H8ZM8 13.25C7.58579 13.25 7.25 13.5858 7.25 14C7.25 14.4142 7.58579 14.75 8 14.75H13C13.4142 14.75 13.75 14.4142 13.75 14C13.75 13.5858 13.4142 13.25 13 13.25H8Z"
          fill={mode ? "#fff" : "#000"}
        />
      </svg>
    </React.Fragment>
  );
};

export const AudioShare = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25px"
        height="25px"
        viewBox="0 0 24 24"
        fill={mode ? "#fff" : "#000"}
      >
        <path
          d="M9.66984 13.9219C8.92984 13.9219 8.33984 14.5219 8.33984 15.2619C8.33984 16.0019 8.93984 16.5919 9.66984 16.5919C10.4098 16.5919 11.0098 15.9919 11.0098 15.2619C11.0098 14.5219 10.4098 13.9219 9.66984 13.9219Z"
          fill={mode ? "#fff" : "#000"}
        />
        <path
          d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM17.12 9.8C17.12 10.41 16.86 10.95 16.42 11.27C16.14 11.47 15.8 11.58 15.44 11.58C15.23 11.58 15.02 11.54 14.8 11.47L12.51 10.71C12.5 10.71 12.48 10.7 12.47 10.69V15.25C12.47 16.79 11.21 18.05 9.67 18.05C8.13 18.05 6.87 16.79 6.87 15.25C6.87 13.71 8.13 12.45 9.67 12.45C10.16 12.45 10.61 12.59 11.01 12.8V8.63V8.02C11.01 7.41 11.27 6.87 11.71 6.55C12.16 6.23 12.75 6.15 13.33 6.35L15.62 7.11C16.48 7.4 17.13 8.3 17.13 9.2V9.8H17.12Z"
          fill={mode ? "#fff" : "#000"}
        />
      </svg>
    </React.Fragment>
  );
};

export const LinkShare = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22px"
        height="22px"
        viewBox="0 0 16 16"
        fill={mode ? "#fff" : "#000"}
      >
        <path
          d="M7.05025 1.53553C8.03344 0.552348 9.36692 0 10.7574 0C13.6528 0 16 2.34721 16 5.24264C16 6.63308 15.4477 7.96656 14.4645 8.94975L12.4142 11L11 9.58579L13.0503 7.53553C13.6584 6.92742 14 6.10264 14 5.24264C14 3.45178 12.5482 2 10.7574 2C9.89736 2 9.07258 2.34163 8.46447 2.94975L6.41421 5L5 3.58579L7.05025 1.53553Z"
          fill={mode ? "#fff" : "#000"}
        />
        <path
          d="M7.53553 13.0503L9.58579 11L11 12.4142L8.94975 14.4645C7.96656 15.4477 6.63308 16 5.24264 16C2.34721 16 0 13.6528 0 10.7574C0 9.36693 0.552347 8.03344 1.53553 7.05025L3.58579 5L5 6.41421L2.94975 8.46447C2.34163 9.07258 2 9.89736 2 10.7574C2 12.5482 3.45178 14 5.24264 14C6.10264 14 6.92742 13.6584 7.53553 13.0503Z"
          fill={mode ? "#fff" : "#000"}
        />
        <path
          d="M5.70711 11.7071L11.7071 5.70711L10.2929 4.29289L4.29289 10.2929L5.70711 11.7071Z"
          fill={mode ? "#fff" : "#000"}
        />
      </svg>
    </React.Fragment>
  );
};

export const LocationShare = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.0"
        id="Layer_1"
        width="25px"
        height="25px"
        viewBox="0 0 64 64"
        enableBackground="new 0 0 64 64"
      >
        <g>
          <path
            fill={mode ? "#fff" : "#000"}
            d="M32,0C18.745,0,8,10.745,8,24c0,5.678,2.502,10.671,5.271,15l17.097,24.156C30.743,63.686,31.352,64,32,64   s1.257-0.314,1.632-0.844L50.729,39C53.375,35.438,56,29.678,56,24C56,10.745,45.255,0,32,0z M32,38c-7.732,0-14-6.268-14-14   s6.268-14,14-14s14,6.268,14,14S39.732,38,32,38z"
          />
          <path
            fill={mode ? "#fff" : "#000"}
            d="M32,12c-6.627,0-12,5.373-12,12s5.373,12,12,12s12-5.373,12-12S38.627,12,32,12z M32,34   c-5.523,0-10-4.478-10-10s4.477-10,10-10s10,4.478,10,10S37.523,34,32,34z"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const PdfShare = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill={mode ? "#fff" : "#000"}
        height="25px"
        width="25px"
        version="1.1"
        id="Capa_1"
        viewBox="0 0 490 490"
      >
        <g>
          <path d="M77.788,0v265.111H42.189v139.615h0.001l35.59,35.591L77.788,490h370.023V102.422L345.388,0H77.788z M395.793,389.413   H57.501v-108.99h338.292V389.413z M353.022,36.962l57.816,57.804h-57.816V36.962z" />
          <path d="M172.819,296.665h-3.753h-30.371v75.366h14.303v-24.344h16.845l3.312-0.06c10.303,0,17.152-1.66,20.539-4.965   c3.387-3.32,5.077-10.019,5.077-20.113c0-10.154-1.772-17.017-5.324-20.561C189.896,298.429,183.017,296.665,172.819,296.665z    M181.627,333.406c-1.75,1.495-5.862,2.243-12.337,2.243h-16.292v-26.946h17.728c6.109,0,9.892,0.763,11.342,2.288   c1.458,1.525,2.183,5.473,2.183,11.843C184.251,328.396,183.376,331.91,181.627,333.406z" />
          <path d="M244.94,296.665h-37.055v75.366h37.496c11.888,0,19.537-2.677,22.916-8.03c3.379-5.353,5.084-17.451,5.084-36.263   c0-11.514-2.123-19.574-6.325-24.18C262.84,298.953,255.467,296.665,244.94,296.665z M255.841,355.268   c-2.004,3.155-6.43,4.725-13.279,4.725h-20.374v-51.291h21.257c6.662,0,10.901,1.495,12.703,4.516   c1.802,3.021,2.707,10.094,2.707,21.204C258.854,345.174,257.853,352.128,255.841,355.268z" />
          <polygon points="283.82,372.031 298.115,372.031 298.115,341.047 331.91,341.047 331.91,329.009 298.115,329.009 298.115,308.702    333.735,308.702 333.735,296.665 283.82,296.665  " />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const StockShare = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25px"
        height="30px"
        viewBox="0 0 48 48"
        fill={mode ? "#fff" : "#000"}
      >
        <path
          d="M18.8832 4.69719C19.2737 4.30667 19.9069 4.30667 20.2974 4.69719L23.888 8.28778L27.469 4.7068C27.8595 4.31628 28.4927 4.31628 28.8832 4.7068C29.2737 5.09733 29.2737 5.73049 28.8832 6.12102L25.3022 9.702L28.7827 13.1825C29.1732 13.573 29.1732 14.2062 28.7827 14.5967C28.3922 14.9872 27.759 14.9872 27.3685 14.5967L23.888 11.1162L20.3979 14.6063C20.0074 14.9968 19.3743 14.9968 18.9837 14.6063C18.5932 14.2158 18.5932 13.5826 18.9837 13.1921L22.4738 9.702L18.8832 6.1114C18.4927 5.72088 18.4927 5.08771 18.8832 4.69719Z"
          fill={mode ? "#fff" : "#000"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.86 15.0513C24.0652 14.9829 24.2871 14.9829 24.4923 15.0513L39.2705 19.9765C39.4691 20.0336 39.6499 20.1521 39.783 20.323L43.7861 25.4612C43.9857 25.7173 44.0485 26.0544 43.9545 26.3652C43.8902 26.5779 43.7579 26.7602 43.5821 26.887L28.1827 32.0159L24.965 27.8858C24.7754 27.6424 24.4839 27.5001 24.1753 27.5004C23.8667 27.5007 23.5755 27.6434 23.3863 27.8871L20.186 32.0093L4.74236 26.8577C4.58577 26.7329 4.46805 26.5621 4.40853 26.3652C4.31456 26.0544 4.37733 25.7173 4.57688 25.4612L8.50799 20.4154C8.62826 20.2191 8.81554 20.0652 9.04466 19.9889L23.86 15.0513ZM35.8287 20.9376L24.1802 24.8197L12.5277 20.9362L24.1762 17.0541L35.8287 20.9376Z"
          fill={mode ? "#fff" : "#000"}
        />
        <path
          d="M28.1442 34.1368L39.991 30.1911L39.9905 36.7628C39.9905 38.054 39.1642 39.2003 37.9392 39.6086L25.1762 43.863V31.4111L27.0393 33.8026C27.2997 34.1368 27.7423 34.2706 28.1442 34.1368Z"
          fill={mode ? "#fff" : "#000"}
        />
        <path
          d="M23.1762 31.4191V43.863L10.4131 39.6086C9.18811 39.2003 8.36183 38.054 8.36175 36.7628L8.36132 30.1732L20.2251 34.1306C20.6277 34.2649 21.0712 34.1305 21.3314 33.7953L23.1762 31.4191Z"
          fill={mode ? "#fff" : "#000"}
        />
      </svg>
    </React.Fragment>
  );
};
export const IsEdite = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z"
          stroke="#fff"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13"
          stroke="#fff"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const Groups = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 12H22"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 12V21.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 22V12"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 12V2"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 11.999V2.53906"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const Temp = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M17.7128 4.80078H6.28878C5.47278 4.80078 4.80078 5.47278 4.80078 6.28878V17.7128C4.80078 18.5288 5.47278 19.2008 6.28878 19.2008H17.7128C18.5288 19.2008 19.2008 18.5288 19.2008 17.7128V6.28878C19.2008 5.47278 18.5288 4.80078 17.7128 4.80078ZM10.1528 16.5848C10.1528 16.7768 9.96078 16.9208 9.76878 16.9208H7.34478H7.29678C7.10478 16.9208 6.96078 16.7288 6.96078 16.5368V11.7128C6.96078 11.5208 7.15278 11.3768 7.34478 11.3768H9.84078C10.0328 11.3768 10.1768 11.5688 10.1768 11.7608V16.5848H10.1528ZM16.9688 16.6328C16.9688 16.8248 16.7768 16.9688 16.5848 16.9688H11.9768C11.7848 16.9688 11.6408 16.7768 11.6408 16.5848V11.7128C11.6408 11.5208 11.8328 11.3768 12.0248 11.3768H16.6088H16.6568C16.8488 11.3768 16.9928 11.5688 16.9928 11.7608V16.6328H16.9688ZM17.0168 9.57678C17.0168 9.76878 16.8248 9.91278 16.6328 9.91278H7.34478H7.29678C7.10478 9.91278 6.96078 9.72078 6.96078 9.52878V7.36878C6.96078 7.17678 7.15278 7.03278 7.34478 7.03278H16.6808C16.8728 7.03278 17.0168 7.22478 17.0168 7.41678V9.57678Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const AddTO = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M12.75 9.5C12.75 9.08579 12.4142 8.75 12 8.75C11.5858 8.75 11.25 9.08579 11.25 9.5V11.75H9C8.58579 11.75 8.25 12.0858 8.25 12.5C8.25 12.9142 8.58579 13.25 9 13.25H11.25V15.5C11.25 15.9142 11.5858 16.25 12 16.25C12.4142 16.25 12.75 15.9142 12.75 15.5V13.25H15C15.4142 13.25 15.75 12.9142 15.75 12.5C15.75 12.0858 15.4142 11.75 15 11.75H12.75V9.5Z"
          fill="#F8F9FC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0574 1.75H11.9426C9.63424 1.74999 7.82519 1.74998 6.41371 1.93975C4.96897 2.13399 3.82895 2.53933 2.93414 3.43414C2.03933 4.32895 1.63399 5.46897 1.43975 6.91371C1.24998 8.32519 1.24999 10.1342 1.25 12.4426V12.5574C1.24999 14.8658 1.24998 16.6748 1.43975 18.0863C1.63399 19.531 2.03933 20.6711 2.93414 21.5659C3.82895 22.4607 4.96897 22.866 6.41371 23.0603C7.82519 23.25 9.63423 23.25 11.9426 23.25H12.0574C14.3658 23.25 16.1748 23.25 17.5863 23.0603C19.031 22.866 20.1711 22.4607 21.0659 21.5659C21.9607 20.6711 22.366 19.531 22.5603 18.0863C22.75 16.6748 22.75 14.8658 22.75 12.5574V12.4426C22.75 10.1342 22.75 8.32519 22.5603 6.91371C22.366 5.46897 21.9607 4.32895 21.0659 3.43414C20.1711 2.53933 19.031 2.13399 17.5863 1.93975C16.1748 1.74998 14.3658 1.74999 12.0574 1.75ZM3.9948 4.4948C4.56445 3.92514 5.33517 3.59825 6.61358 3.42637C7.91356 3.25159 9.62177 3.25 12 3.25C14.3782 3.25 16.0864 3.25159 17.3864 3.42637C18.6648 3.59825 19.4355 3.92514 20.0052 4.4948C20.5749 5.06445 20.9018 5.83517 21.0736 7.11358C21.2484 8.41356 21.25 10.1218 21.25 12.5C21.25 14.8782 21.2484 16.5864 21.0736 17.8864C20.9018 19.1648 20.5749 19.9355 20.0052 20.5052C19.4355 21.0749 18.6648 21.4018 17.3864 21.5736C16.0864 21.7484 14.3782 21.75 12 21.75C9.62177 21.75 7.91356 21.7484 6.61358 21.5736C5.33517 21.4018 4.56445 21.0749 3.9948 20.5052C3.42514 19.9355 3.09825 19.1648 2.92637 17.8864C2.75159 16.5864 2.75 14.8782 2.75 12.5C2.75 10.1218 2.75159 8.41356 2.92637 7.11358C3.09825 5.83517 3.42514 5.06445 3.9948 4.4948Z"
          fill="#F8F9FC"
        />
      </svg>
    </React.Fragment>
  );
};
export const AddStyle = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M12.75 9.5C12.75 9.08579 12.4142 8.75 12 8.75C11.5858 8.75 11.25 9.08579 11.25 9.5V11.75H9C8.58579 11.75 8.25 12.0858 8.25 12.5C8.25 12.9142 8.58579 13.25 9 13.25H11.25V15.5C11.25 15.9142 11.5858 16.25 12 16.25C12.4142 16.25 12.75 15.9142 12.75 15.5V13.25H15C15.4142 13.25 15.75 12.9142 15.75 12.5C15.75 12.0858 15.4142 11.75 15 11.75H12.75V9.5Z"
          fill={mode ? "#fff" : "#646B88"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0574 1.75H11.9426C9.63424 1.74999 7.82519 1.74998 6.41371 1.93975C4.96897 2.13399 3.82895 2.53933 2.93414 3.43414C2.03933 4.32895 1.63399 5.46897 1.43975 6.91371C1.24998 8.32519 1.24999 10.1342 1.25 12.4426V12.5574C1.24999 14.8658 1.24998 16.6748 1.43975 18.0863C1.63399 19.531 2.03933 20.6711 2.93414 21.5659C3.82895 22.4607 4.96897 22.866 6.41371 23.0603C7.82519 23.25 9.63423 23.25 11.9426 23.25H12.0574C14.3658 23.25 16.1748 23.25 17.5863 23.0603C19.031 22.866 20.1711 22.4607 21.0659 21.5659C21.9607 20.6711 22.366 19.531 22.5603 18.0863C22.75 16.6748 22.75 14.8658 22.75 12.5574V12.4426C22.75 10.1342 22.75 8.32519 22.5603 6.91371C22.366 5.46897 21.9607 4.32895 21.0659 3.43414C20.1711 2.53933 19.031 2.13399 17.5863 1.93975C16.1748 1.74998 14.3658 1.74999 12.0574 1.75ZM3.9948 4.4948C4.56445 3.92514 5.33517 3.59825 6.61358 3.42637C7.91356 3.25159 9.62177 3.25 12 3.25C14.3782 3.25 16.0864 3.25159 17.3864 3.42637C18.6648 3.59825 19.4355 3.92514 20.0052 4.4948C20.5749 5.06445 20.9018 5.83517 21.0736 7.11358C21.2484 8.41356 21.25 10.1218 21.25 12.5C21.25 14.8782 21.2484 16.5864 21.0736 17.8864C20.9018 19.1648 20.5749 19.9355 20.0052 20.5052C19.4355 21.0749 18.6648 21.4018 17.3864 21.5736C16.0864 21.7484 14.3782 21.75 12 21.75C9.62177 21.75 7.91356 21.7484 6.61358 21.5736C5.33517 21.4018 4.56445 21.0749 3.9948 20.5052C3.42514 19.9355 3.09825 19.1648 2.92637 17.8864C2.75159 16.5864 2.75 14.8782 2.75 12.5C2.75 10.1218 2.75159 8.41356 2.92637 7.11358C3.09825 5.83517 3.42514 5.06445 3.9948 4.4948Z"
          fill={mode ? "#fff" : "#646B88"}
        />
      </svg>
    </React.Fragment>
  );
};
export const ViewTo = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
      >
        <path
          d="M25.3365 13.6679C25.8218 14.257 26.0644 14.5515 26.0644 15C26.0644 15.4485 25.8218 15.743 25.3365 16.3321C23.5614 18.4874 19.6461 22.5 15.1015 22.5C10.5568 22.5 6.64158 18.4874 4.86647 16.3321C4.38127 15.743 4.13867 15.4485 4.13867 15C4.13867 14.5515 4.38127 14.257 4.86647 13.6679C6.64158 11.5127 10.5568 7.5 15.1015 7.5C19.6461 7.5 23.5614 11.5127 25.3365 13.6679Z"
          fill="#4164E3"
          fillOpacity="0.2"
        />
        <path
          d="M15.0996 18.75C17.1707 18.75 18.8496 17.0711 18.8496 15C18.8496 12.9289 17.1707 11.25 15.0996 11.25C13.0285 11.25 11.3496 12.9289 11.3496 15C11.3496 17.0711 13.0285 18.75 15.0996 18.75Z"
          fill="#4164E3"
        />
      </svg>
    </React.Fragment>
  );
};
export const EditeTo = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          opacity="0.4"
          d="M11.3008 2H9.30078C4.30078 2 2.30078 4 2.30078 9V15C2.30078 20 4.30078 22 9.30078 22H15.3008C20.3008 22 22.3008 20 22.3008 15V13"
          stroke="#34A853"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3426 3.02123L8.46261 10.9013C8.16261 11.2013 7.86261 11.7913 7.80261 12.2213L7.37261 15.2313C7.21261 16.3213 7.98261 17.0813 9.07261 16.9313L12.0826 16.5013C12.5026 16.4413 13.0926 16.1413 13.4026 15.8413L21.2826 7.96123C22.6426 6.60123 23.2826 5.02123 21.2826 3.02123C19.2826 1.02123 17.7026 1.66123 16.3426 3.02123Z"
          stroke="#34A853"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.4"
          d="M15.2109 4.14844C15.8809 6.53844 17.7509 8.40844 20.1509 9.08844"
          stroke="#34A853"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const Crous = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
      >
        <path
          d="M9 1L1 9M1.00001 1L9 9"
          stroke={mode ? "#fff" : "#000"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const SettingTo = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="22"
        viewBox="0 0 23 22"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.295 2.00471C9.62299 0.875211 8.1523 0.454731 6.99287 1.1401L5.26788 2.12723C3.99557 2.85456 3.56417 4.48543 4.29099 5.74339L4.29151 5.74428C4.66645 6.39115 4.6076 6.80437 4.49057 7.00746C4.37347 7.21066 4.0456 7.46818 3.30039 7.46818C1.83361 7.46818 0.650391 8.66654 0.650391 10.1182V11.8782C0.650391 13.3299 1.83361 14.5282 3.30039 14.5282C4.0456 14.5282 4.37347 14.7857 4.49057 14.9889C4.6076 15.192 4.66645 15.6052 4.29151 16.2521L4.29099 16.253C3.56417 17.511 3.99597 19.1421 5.26829 19.8694L6.99296 20.8563C8.15238 21.5416 9.62299 21.1212 10.295 19.9917L10.4095 19.794C10.7845 19.1471 11.1734 18.9907 11.4091 18.9907C11.6438 18.9907 12.0297 19.1458 12.3997 19.7912L12.4013 19.794L12.5113 19.984L12.5158 19.9917C13.1878 21.1212 14.6584 21.5416 15.8178 20.8563L17.5429 19.8692C18.8161 19.1413 19.2448 17.5217 18.5216 16.2561L18.5193 16.2521C18.1443 15.6052 18.2032 15.192 18.3202 14.9889C18.4373 14.7857 18.7652 14.5282 19.5104 14.5282C20.9772 14.5282 22.1604 13.3299 22.1604 11.8782V10.1182C22.1604 8.6514 20.962 7.46818 19.5104 7.46818C18.7652 7.46818 18.4373 7.21066 18.3202 7.00746C18.2032 6.80437 18.1443 6.39115 18.5193 5.74428L18.5198 5.74339C19.2467 4.4853 18.8151 2.85421 17.5425 2.127L15.8179 1.1401C14.6585 0.454731 13.1878 0.875171 12.5158 2.00468L12.4013 2.2024C12.0263 2.84932 11.6374 3.00568 11.4016 3.00568C11.167 3.00568 10.7811 2.85064 10.4111 2.20518L10.4095 2.2024L10.2995 2.01238L10.295 2.00471ZM14.4004 10.9982C14.4004 12.6551 13.0573 13.9982 11.4004 13.9982C9.74349 13.9982 8.40039 12.6551 8.40039 10.9982C8.40039 9.34127 9.74349 7.99817 11.4004 7.99817C13.0573 7.99817 14.4004 9.34127 14.4004 10.9982Z"
          fill={mode ? "#fff" : "#232529"}
        />
      </svg>
    </React.Fragment>
  );
};
export const DeleteTo = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M10.5 12V17"
          stroke="#F93E3E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5 12V17"
          stroke="#F93E3E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 7H20.5"
          stroke="#F93E3E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 10V18C6.5 19.6569 7.84315 21 9.5 21H15.5C17.1569 21 18.5 19.6569 18.5 18V10"
          stroke="#F93E3E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 5C9.5 3.89543 10.3954 3 11.5 3H13.5C14.6046 3 15.5 3.89543 15.5 5V7H9.5V5Z"
          stroke="#F93E3E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const Back = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M14 7L9 12L14 17"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const Pluse = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M7.20047 11.2805C6.80283 11.2805 6.48047 11.6028 6.48047 12.0005C6.48047 12.3981 6.80283 12.7205 7.20047 12.7205V11.2805ZM12.0005 12.7205C12.3981 12.7205 12.7205 12.3981 12.7205 12.0005C12.7205 11.6028 12.3981 11.2805 12.0005 11.2805V12.7205ZM12.0005 11.2805C11.6028 11.2805 11.2805 11.6028 11.2805 12.0005C11.2805 12.3981 11.6028 12.7205 12.0005 12.7205V11.2805ZM16.8005 12.7205C17.1981 12.7205 17.5205 12.3981 17.5205 12.0005C17.5205 11.6028 17.1981 11.2805 16.8005 11.2805V12.7205ZM12.7205 12.0005C12.7205 11.6028 12.3981 11.2805 12.0005 11.2805C11.6028 11.2805 11.2805 11.6028 11.2805 12.0005H12.7205ZM11.2805 16.8005C11.2805 17.1981 11.6028 17.5205 12.0005 17.5205C12.3981 17.5205 12.7205 17.1981 12.7205 16.8005H11.2805ZM11.2805 12.0005C11.2805 12.3981 11.6028 12.7205 12.0005 12.7205C12.3981 12.7205 12.7205 12.3981 12.7205 12.0005H11.2805ZM12.7205 7.20047C12.7205 6.80283 12.3981 6.48047 12.0005 6.48047C11.6028 6.48047 11.2805 6.80283 11.2805 7.20047H12.7205ZM7.20047 12.7205H12.0005V11.2805H7.20047V12.7205ZM12.0005 12.7205H16.8005V11.2805H12.0005V12.7205ZM12.0005 12.0005H11.2805V12.0014C11.2805 12.0015 11.2805 12.0026 11.2805 12.0026C11.2805 12.0025 11.2805 12.0027 11.2805 12.0026C11.2805 12.0026 11.2805 12.0036 11.2805 12.0037C11.2805 12.0036 11.2805 12.0038 11.2805 12.0037C11.2805 12.0038 11.2805 12.0046 11.2805 12.0047C11.2805 12.0048 11.2805 12.0057 11.2805 12.0057C11.2805 12.0058 11.2805 12.0066 11.2805 12.0067C11.2805 12.0068 11.2805 12.0077 11.2805 12.0079C11.2805 12.008 11.2805 12.0088 11.2805 12.009C11.2805 12.0091 11.2805 12.0102 11.2805 12.0103C11.2805 12.0101 11.2805 12.0105 11.2805 12.0103C11.2805 12.0105 11.2805 12.011 11.2805 12.0112C11.2805 12.011 11.2805 12.0114 11.2805 12.0112C11.2805 12.0114 11.2805 12.0121 11.2805 12.0122C11.2805 12.012 11.2805 12.0124 11.2805 12.0122C11.2805 12.0124 11.2805 12.013 11.2805 12.0132C11.2805 12.013 11.2805 12.0134 11.2805 12.0132C11.2805 12.0134 11.2805 12.0142 11.2805 12.0144C11.2805 12.0142 11.2805 12.0146 11.2805 12.0144C11.2805 12.0146 11.2805 12.0153 11.2805 12.0155C11.2805 12.0153 11.2805 12.0157 11.2805 12.0155C11.2805 12.0157 11.2805 12.0166 11.2805 12.0168C11.2805 12.0166 11.2805 12.017 11.2805 12.0168C11.2805 12.017 11.2805 12.0178 11.2805 12.0181C11.2805 12.0178 11.2805 12.0183 11.2805 12.0181C11.2805 12.0183 11.2805 12.0193 11.2805 12.0195C11.2805 12.0193 11.2805 12.0197 11.2805 12.0195C11.2805 12.0198 11.2805 12.0206 11.2805 12.0209C11.2805 12.0206 11.2805 12.0212 11.2805 12.0209C11.2805 12.0211 11.2805 12.0222 11.2805 12.0225C11.2805 12.0222 11.2805 12.0226 11.2805 12.0225C11.2805 12.0227 11.2805 12.0237 11.2805 12.024C11.2805 12.0237 11.2805 12.0243 11.2805 12.024C11.2805 12.0243 11.2805 12.0254 11.2805 12.0257C11.2805 12.0254 11.2805 12.026 11.2805 12.0257C11.2805 12.026 11.2805 12.0272 11.2805 12.0274C11.2805 12.0272 11.2805 12.0277 11.2805 12.0274C11.2805 12.0277 11.2805 12.0289 11.2805 12.0293C11.2805 12.029 11.2805 12.0296 11.2805 12.0293C11.2805 12.0297 11.2805 12.0308 11.2805 12.0311C11.2805 12.0315 11.2805 12.0318 11.2805 12.0321C11.2805 12.0324 11.2805 12.0327 11.2805 12.0331C11.2805 12.0335 11.2805 12.0338 11.2805 12.0342C11.2805 12.0345 11.2805 12.0348 11.2805 12.0351C11.2805 12.0355 11.2805 12.0359 11.2805 12.0363C11.2805 12.0366 11.2805 12.0369 11.2805 12.0373C11.2805 12.0377 11.2805 12.038 11.2805 12.0384C11.2805 12.0388 11.2805 12.0392 11.2805 12.0395C11.2805 12.0399 11.2805 12.0403 11.2805 12.0407C11.2805 12.0411 11.2805 12.0415 11.2805 12.0418C11.2805 12.0422 11.2805 12.0427 11.2805 12.0431C11.2805 12.0435 11.2805 12.0439 11.2805 12.0442C11.2805 12.0447 11.2805 12.0451 11.2805 12.0455C11.2805 12.046 11.2805 12.0464 11.2805 12.0467C11.2805 12.0472 11.2805 12.0476 11.2805 12.0481C11.2805 12.0485 11.2805 12.0489 11.2805 12.0493C11.2805 12.0498 11.2805 12.0503 11.2805 12.0507C11.2805 12.0512 11.2805 12.0516 11.2805 12.0521C11.2805 12.0525 11.2805 12.053 11.2805 12.0535C11.2805 12.0539 11.2805 12.0544 11.2805 12.0549C11.2805 12.0553 11.2805 12.0558 11.2805 12.0562C11.2805 12.0567 11.2805 12.0573 11.2805 12.0578C11.2805 12.0583 11.2805 12.0587 11.2805 12.0592C11.2805 12.0597 11.2805 12.0602 11.2805 12.0608C11.2805 12.0612 11.2805 12.0617 11.2805 12.0623C11.2805 12.0628 11.2805 12.0633 11.2805 12.0638C11.2805 12.0643 11.2805 12.0649 11.2805 12.0654C11.2805 12.0659 11.2805 12.0665 11.2805 12.067C11.2805 12.0676 11.2805 12.0681 11.2805 12.0686C11.2805 12.0692 11.2805 12.0698 11.2805 12.0704C11.2805 12.0708 11.2805 12.0714 11.2805 12.072C11.2805 12.0726 11.2805 12.0731 11.2805 12.0737C11.2805 12.0743 11.2805 12.0749 11.2805 12.0754C11.2805 12.076 11.2805 12.0767 11.2805 12.0773C11.2805 12.0778 11.2805 12.0784 11.2805 12.079C11.2805 12.0797 11.2805 12.0802 11.2805 12.0808C11.2805 12.0815 11.2805 12.0821 11.2805 12.0827C11.2805 12.0833 11.2805 12.084 11.2805 12.0846C11.2805 12.0852 11.2805 12.0859 11.2805 12.0865C11.2805 12.0872 11.2805 12.0878 11.2805 12.0885C11.2805 12.0891 11.2805 12.0897 11.2805 12.0904C11.2805 12.0911 11.2805 12.0918 11.2805 12.0924C11.2805 12.0931 11.2805 12.0938 11.2805 12.0945C11.2805 12.0951 11.2805 12.0958 11.2805 12.0965C11.2805 12.0972 11.2805 12.0979 11.2805 12.0986C11.2805 12.0993 11.2805 12.1 11.2805 12.1007C11.2805 12.1015 11.2805 12.1021 11.2805 12.1029C11.2805 12.1036 11.2805 12.1043 11.2805 12.105C11.2805 12.1058 11.2805 12.1065 11.2805 12.1072C11.2805 12.108 11.2805 12.1088 11.2805 12.1095C11.2805 12.1103 11.2805 12.111 11.2805 12.1117C11.2805 12.1125 11.2805 12.1133 11.2805 12.114C11.2805 12.1148 11.2805 12.1157 11.2805 12.1164C11.2805 12.1172 11.2805 12.118 11.2805 12.1187C11.2805 12.1196 11.2805 12.1204 11.2805 12.1211C11.2805 12.122 11.2805 12.1228 11.2805 12.1236C11.2805 12.1244 11.2805 12.1253 11.2805 12.126C11.2805 12.1269 11.2805 12.1278 11.2805 12.1285C11.2805 12.1294 11.2805 12.1303 11.2805 12.1311C11.2805 12.1319 11.2805 12.1328 11.2805 12.1336C11.2805 12.1345 11.2805 12.1353 11.2805 12.1362C11.2805 12.1371 11.2805 12.1379 11.2805 12.1389C11.2805 12.1398 11.2805 12.1406 11.2805 12.1415C11.2805 12.1425 11.2805 12.1433 11.2805 12.1442C11.2805 12.1451 11.2805 12.146 11.2805 12.147C11.2805 12.1478 11.2805 12.1488 11.2805 12.1497C11.2805 12.1506 11.2805 12.1516 11.2805 12.1525C11.2805 12.1535 11.2805 12.1544 11.2805 12.1553C11.2805 12.1563 11.2805 12.1572 11.2805 12.1582C11.2805 12.1592 11.2805 12.1601 11.2805 12.1611C11.2805 12.1621 11.2805 12.1631 11.2805 12.1641C11.2805 12.165 11.2805 12.1661 11.2805 12.167C11.2805 12.168 11.2805 12.169 11.2805 12.17C11.2805 12.1711 11.2805 12.172 11.2805 12.1731C11.2805 12.1741 11.2805 12.1751 11.2805 12.1761C11.2805 12.1772 11.2805 12.1783 11.2805 12.1793C11.2805 12.1804 11.2805 12.1814 11.2805 12.1825C11.2805 12.1835 11.2805 12.1846 11.2805 12.1857C11.2805 12.1867 11.2805 12.1878 11.2805 12.1888C11.2805 12.19 11.2805 12.191 11.2805 12.1922C11.2805 12.1932 11.2805 12.1943 11.2805 12.1954C11.2805 12.1965 11.2805 12.1977 11.2805 12.1988C11.2805 12.1999 11.2805 12.201 11.2805 12.2022C11.2805 12.2033 11.2805 12.2045 11.2805 12.2056C11.2805 12.2068 11.2805 12.2079 11.2805 12.2091C11.2805 12.2102 11.2805 12.2114 11.2805 12.2125C11.2805 12.2137 11.2805 12.2148 11.2805 12.2161C11.2805 12.2172 11.2805 12.2185 11.2805 12.2196C11.2805 12.2209 11.2805 12.222 11.2805 12.2233C11.2805 12.2244 11.2805 12.2257 11.2805 12.2269C11.2805 12.2281 11.2805 12.2293 11.2805 12.2306C11.2805 12.2318 11.2805 12.2331 11.2805 12.2343C11.2805 12.2356 11.2805 12.2368 11.2805 12.2381C11.2805 12.2393 11.2805 12.2407 11.2805 12.2419C11.2805 12.2432 11.2805 12.2445 11.2805 12.2457C11.2805 12.2471 11.2805 12.2483 11.2805 12.2497C11.2805 12.2509 11.2805 12.2523 11.2805 12.2536C11.2805 12.2549 11.2805 12.2562 11.2805 12.2576C11.2805 12.2589 11.2805 12.2602 11.2805 12.2616C11.2805 12.2629 11.2805 12.2643 11.2805 12.2656C11.2805 12.267 11.2805 12.2684 11.2805 12.2697C11.2805 12.2711 11.2805 12.2725 11.2805 12.2739C11.2805 12.2753 11.2805 12.2767 11.2805 12.2781C11.2805 12.2794 11.2805 12.2809 11.2805 12.2823C11.2805 12.2838 11.2805 12.2851 11.2805 12.2865C11.2805 12.288 11.2805 12.2894 11.2805 12.2909C11.2805 12.2923 11.2805 12.2937 11.2805 12.2953C11.2805 12.2967 11.2805 12.2982 11.2805 12.2996C11.2805 12.3011 11.2805 12.3026 11.2805 12.3041C11.2805 12.3056 11.2805 12.3071 11.2805 12.3085C11.2805 12.3101 11.2805 12.3116 11.2805 12.3131C11.2805 12.3146 11.2805 12.3161 11.2805 12.3177C11.2805 12.3192 11.2805 12.3207 11.2805 12.3223C11.2805 12.3238 11.2805 12.3254 11.2805 12.327C11.2805 12.3285 11.2805 12.3301 11.2805 12.3317C11.2805 12.3332 11.2805 12.3348 11.2805 12.3365C11.2805 12.338 11.2805 12.3396 11.2805 12.3413C11.2805 12.3428 11.2805 12.3444 11.2805 12.3461C11.2805 12.3477 11.2805 12.3493 11.2805 12.351C11.2805 12.3526 11.2805 12.3542 11.2805 12.3559C11.2805 12.3576 11.2805 12.3592 11.2805 12.3609C11.2805 12.3626 11.2805 12.3642 11.2805 12.3659C11.2805 12.3676 11.2805 12.3693 11.2805 12.3709C11.2805 12.3727 11.2805 12.3744 11.2805 12.3761C11.2805 12.3778 11.2805 12.3796 11.2805 12.3813C11.2805 12.383 11.2805 12.3848 11.2805 12.3865C11.2805 12.3882 11.2805 12.3899 11.2805 12.3918C11.2805 12.3935 11.2805 12.3953 11.2805 12.397C11.2805 12.3989 11.2805 12.4006 11.2805 12.4024C11.2805 12.4042 11.2805 12.406 11.2805 12.4078C11.2805 12.4096 11.2805 12.4114 11.2805 12.4133C11.2805 12.4151 11.2805 12.4169 11.2805 12.4188C11.2805 12.4207 11.2805 12.4225 11.2805 12.4243C11.2805 12.4262 11.2805 12.4281 11.2805 12.43C11.2805 12.4318 11.2805 12.4337 11.2805 12.4356C11.2805 12.4375 11.2805 12.4394 11.2805 12.4413C11.2805 12.4432 11.2805 12.4451 11.2805 12.4471C11.2805 12.449 11.2805 12.4509 11.2805 12.4528C11.2805 12.4547 11.2805 12.4568 11.2805 12.4587C11.2805 12.4607 11.2805 12.4626 11.2805 12.4646C11.2805 12.4665 11.2805 12.4686 11.2805 12.4706C11.2805 12.4725 11.2805 12.4745 11.2805 12.4765C11.2805 12.4785 11.2805 12.4806 11.2805 12.4826C11.2805 12.4846 11.2805 12.4866 11.2805 12.4887C11.2805 12.4907 11.2805 12.4928 11.2805 12.4949C11.2805 12.4969 11.2805 12.499 11.2805 12.501C11.2805 12.5031 11.2805 12.5052 11.2805 12.5073C11.2805 12.5094 11.2805 12.5115 11.2805 12.5136C11.2805 12.5157 11.2805 12.5178 11.2805 12.52C11.2805 12.5221 11.2805 12.5242 11.2805 12.5264C11.2805 12.5286 11.2805 12.5307 11.2805 12.5329C11.2805 12.535 11.2805 12.5372 11.2805 12.5394C11.2805 12.5415 11.2805 12.5437 11.2805 12.5459C11.2805 12.5481 11.2805 12.5504 11.2805 12.5526C11.2805 12.5548 11.2805 12.557 11.2805 12.5593C11.2805 12.5615 11.2805 12.5637 11.2805 12.566C11.2805 12.5682 11.2805 12.5705 11.2805 12.5728C11.2805 12.575 11.2805 12.5773 11.2805 12.5796C11.2805 12.5819 11.2805 12.5842 11.2805 12.5865C11.2805 12.5889 11.2805 12.5912 11.2805 12.5935C11.2805 12.5958 11.2805 12.5982 11.2805 12.6005C11.2805 12.6028 11.2805 12.6052 11.2805 12.6076C11.2805 12.6099 11.2805 12.6123 11.2805 12.6147C11.2805 12.617 11.2805 12.6194 11.2805 12.6218C11.2805 12.6242 11.2805 12.6266 11.2805 12.6291C11.2805 12.6315 11.2805 12.6339 11.2805 12.6363C11.2805 12.6388 11.2805 12.6412 11.2805 12.6437C11.2805 12.6461 11.2805 12.6486 11.2805 12.6511C11.2805 12.6536 11.2805 12.656 11.2805 12.6585C11.2805 12.6609 11.2805 12.6634 11.2805 12.666C11.2805 12.6685 11.2805 12.671 11.2805 12.6735C11.2805 12.6761 11.2805 12.6786 11.2805 12.6812C11.2805 12.6837 11.2805 12.6863 11.2805 12.6889C11.2805 12.6915 11.2805 12.694 11.2805 12.6966C11.2805 12.6992 11.2805 12.7017 11.2805 12.7043C11.2805 12.707 11.2805 12.7096 11.2805 12.7122C11.2805 12.7149 11.2805 12.7175 11.2805 12.7202C11.2805 12.7228 11.2805 12.7255 11.2805 12.7281C11.2805 12.7307 11.2805 12.7334 11.2805 12.7361C11.2805 12.7388 11.2805 12.7415 11.2805 12.7442C11.2805 12.747 11.2805 12.7497 11.2805 12.7523C11.2805 12.7551 11.2805 12.7578 11.2805 12.7606C11.2805 12.7633 11.2805 12.7661 11.2805 12.7689C11.2805 12.7716 11.2805 12.7743 11.2805 12.7771C11.2805 12.7799 11.2805 12.7828 11.2805 12.7856C11.2805 12.7883 11.2805 12.7911 11.2805 12.794C11.2805 12.7968 11.2805 12.7997 11.2805 12.8025C11.2805 12.8053 11.2805 12.8082 11.2805 12.811C11.2805 12.8139 11.2805 12.8168 11.2805 12.8196C11.2805 12.8225 11.2805 12.8254 11.2805 12.8284C11.2805 12.8313 11.2805 12.8341 11.2805 12.8371C11.2805 12.84 11.2805 12.843 11.2805 12.8459C11.2805 12.8488 11.2805 12.8518 11.2805 12.8548C11.2805 12.8577 11.2805 12.8607 11.2805 12.8637C11.2805 12.8667 11.2805 12.8697 11.2805 12.8727C11.2805 12.8757 11.2805 12.8787 11.2805 12.8817C11.2805 12.8847 11.2805 12.8878 11.2805 12.8909C11.2805 12.8939 11.2805 12.897 11.2805 12.9001C11.2805 12.9031 11.2805 12.9062 11.2805 12.9093C11.2805 12.9124 11.2805 12.9154 11.2805 12.9186C11.2805 12.9217 11.2805 12.9249 11.2805 12.9279C11.2805 12.9311 11.2805 12.9343 11.2805 12.9374C11.2805 12.9405 11.2805 12.9437 11.2805 12.9468C11.2805 12.9501 11.2805 12.9533 11.2805 12.9564C11.2805 12.9596 11.2805 12.9629 11.2805 12.966C11.2805 12.9693 11.2805 12.9725 11.2805 12.9757C11.2805 12.979 11.2805 12.9823 11.2805 12.9855C11.2805 12.9888 11.2805 12.9921 11.2805 12.9953C11.2805 12.9986 11.2805 13.0019 11.2805 13.0052C11.2805 13.0085 11.2805 13.0118 11.2805 13.0152C11.2805 13.0185 11.2805 13.0218 11.2805 13.0252C11.2805 13.0285 11.2805 13.0319 11.2805 13.0353C11.2805 13.0386 11.2805 13.042 11.2805 13.0454C11.2805 13.0488 11.2805 13.0521 11.2805 13.0556C11.2805 13.0591 11.2805 13.0624 11.2805 13.0659C11.2805 13.0693 11.2805 13.0728 11.2805 13.0762C11.2805 13.0797 11.2805 13.0832 11.2805 13.0866C11.2805 13.0901 11.2805 13.0936 11.2805 13.0971C11.2805 13.1006 11.2805 13.1041 11.2805 13.1076C11.2805 13.1112 11.2805 13.1147 11.2805 13.1183C11.2805 13.1218 11.2805 13.1254 11.2805 13.1289C11.2805 13.1325 11.2805 13.1361 11.2805 13.1397C11.2805 13.1433 11.2805 13.1469 11.2805 13.1505C11.2805 13.1541 11.2805 13.1577 11.2805 13.1614C11.2805 13.165 11.2805 13.1687 11.2805 13.1723C11.2805 13.176 11.2805 13.1796 11.2805 13.1834C11.2805 13.187 11.2805 13.1908 11.2805 13.1944C11.2805 13.1982 11.2805 13.2019 11.2805 13.2057C11.2805 13.2093 11.2805 13.213 11.2805 13.2169C11.2805 13.2206 11.2805 13.2244 11.2805 13.2281C11.2805 13.232 11.2805 13.2357 11.2805 13.2395C11.2805 13.2433 11.2805 13.2471 11.2805 13.251C11.2805 13.2548 11.2805 13.2586 11.2805 13.2625C11.2805 13.2663 11.2805 13.2702 11.2805 13.274C11.2805 13.2779 11.2805 13.2818 11.2805 13.2857C11.2805 13.2896 11.2805 13.2935 11.2805 13.2974C11.2805 13.3013 11.2805 13.3052 11.2805 13.3091C11.2805 13.3132 11.2805 13.3171 11.2805 13.321C11.2805 13.325 11.2805 13.329 11.2805 13.3329C11.2805 13.337 11.2805 13.341 11.2805 13.3449C11.2805 13.349 11.2805 13.353 11.2805 13.357C11.2805 13.3611 11.2805 13.3651 11.2805 13.3692C11.2805 13.3733 11.2805 13.3773 11.2805 13.3814C11.2805 13.3856 11.2805 13.3896 11.2805 13.3937C11.2805 13.3978 11.2805 13.402 11.2805 13.4061C11.2805 13.4102 11.2805 13.4144 11.2805 13.4185C11.2805 13.4227 11.2805 13.4268 11.2805 13.4311C11.2805 13.4352 11.2805 13.4394 11.2805 13.4436C11.2805 13.4479 11.2805 13.4521 11.2805 13.4563C11.2805 13.4605 11.2805 13.4648 11.2805 13.469C11.2805 13.4733 11.2805 13.4775 11.2805 13.4818C11.2805 13.4861 11.2805 13.4904 11.2805 13.4947C11.2805 13.499 11.2805 13.5033 11.2805 13.5077C11.2805 13.512 11.2805 13.5163 11.2805 13.5207C11.2805 13.525 11.2805 13.5295 11.2805 13.5338C11.2805 13.5382 11.2805 13.5426 11.2805 13.5469C11.2805 13.5513 11.2805 13.5558 11.2805 13.5603C11.2805 13.5647 11.2805 13.5691 11.2805 13.5735C11.2805 13.578 11.2805 13.5825 11.2805 13.587C11.2805 13.5915 11.2805 13.596 11.2805 13.6005C11.2805 13.6049 11.2805 13.6095 11.2805 13.614C11.2805 13.6185 11.2805 13.6231 11.2805 13.6277C11.2805 13.6322 11.2805 13.6368 11.2805 13.6414C11.2805 13.6459 11.2805 13.6505 11.2805 13.6551C11.2805 13.6597 11.2805 13.6643 11.2805 13.669C11.2805 13.6737 11.2805 13.6783 11.2805 13.683C11.2805 13.6877 11.2805 13.6923 11.2805 13.697C11.2805 13.7017 11.2805 13.7064 11.2805 13.7111C11.2805 13.7158 11.2805 13.7205 11.2805 13.7253C11.2805 13.73 11.2805 13.7347 11.2805 13.7395C11.2805 13.7443 11.2805 13.749 11.2805 13.7538C11.2805 13.7586 11.2805 13.7634 11.2805 13.7682C11.2805 13.7731 11.2805 13.7779 11.2805 13.7827C11.2805 13.7876 11.2805 13.7924 11.2805 13.7973C11.2805 13.8022 11.2805 13.8071 11.2805 13.812C11.2805 13.8169 11.2805 13.8218 11.2805 13.8267C11.2805 13.8316 11.2805 13.8366 11.2805 13.8415C11.2805 13.8465 11.2805 13.8514 11.2805 13.8563C11.2805 13.8613 11.2805 13.8663 11.2805 13.8713C11.2805 13.8763 11.2805 13.8814 11.2805 13.8864C11.2805 13.8914 11.2805 13.8965 11.2805 13.9016C11.2805 13.9065 11.2805 13.9116 11.2805 13.9167C11.2805 13.9218 11.2805 13.9269 11.2805 13.932C11.2805 13.9372 11.2805 13.9423 11.2805 13.9473C11.2805 13.9525 11.2805 13.9577 11.2805 13.9628C11.2805 13.968 11.2805 13.9732 11.2805 13.9784C11.2805 13.9835 11.2805 13.9888 11.2805 13.994C11.2805 13.9992 11.2805 14.0045 11.2805 14.0097C11.2805 14.0149 11.2805 14.0202 11.2805 14.0255C11.2805 14.0308 11.2805 14.0361 11.2805 14.0413C11.2805 14.0466 11.2805 14.052 11.2805 14.0573C11.2805 14.0626 11.2805 14.0679 11.2805 14.0733C11.2805 14.0787 11.2805 14.0841 11.2805 14.0894C11.2805 14.0948 11.2805 14.1002 11.2805 14.1057C11.2805 14.111 11.2805 14.1164 11.2805 14.1219C11.2805 14.1273 11.2805 14.1328 11.2805 14.1382C11.2805 14.1437 11.2805 14.1492 11.2805 14.1547C11.2805 14.1602 11.2805 14.1657 11.2805 14.1712C11.2805 14.1767 11.2805 14.1823 11.2805 14.1878C11.2805 14.1934 11.2805 14.199 11.2805 14.2045C11.2805 14.2101 11.2805 14.2157 11.2805 14.2213C11.2805 14.2269 11.2805 14.2326 11.2805 14.2381C11.2805 14.2438 11.2805 14.2495 11.2805 14.2551C11.2805 14.2608 11.2805 14.2665 11.2805 14.2721C11.2805 14.2779 11.2805 14.2835 11.2805 14.2893C11.2805 14.295 11.2805 14.3007 11.2805 14.3065C11.2805 14.3122 11.2805 14.318 11.2805 14.3238C11.2805 14.3295 11.2805 14.3354 11.2805 14.3411C11.2805 14.347 11.2805 14.3528 11.2805 14.3586C11.2805 14.3645 11.2805 14.3703 11.2805 14.3762C11.2805 14.382 11.2805 14.388 11.2805 14.3938C11.2805 14.3997 11.2805 14.4057 11.2805 14.4116C11.2805 14.4175 11.2805 14.4234 11.2805 14.4294C11.2805 14.4353 11.2805 14.4413 11.2805 14.4473C11.2805 14.4533 11.2805 14.4592 11.2805 14.4653C11.2805 14.4713 11.2805 14.4773 11.2805 14.4833C11.2805 14.4894 11.2805 14.4954 11.2805 14.5016C11.2805 14.5076 11.2805 14.5137 11.2805 14.5198C11.2805 14.5258 11.2805 14.532 11.2805 14.5381C11.2805 14.5443 11.2805 14.5504 11.2805 14.5566C11.2805 14.5627 11.2805 14.5689 11.2805 14.5751C11.2805 14.5812 11.2805 14.5875 11.2805 14.5937C11.2805 14.5999 11.2805 14.6061 11.2805 14.6124C11.2805 14.6187 11.2805 14.6249 11.2805 14.6312C11.2805 14.6375 11.2805 14.6437 11.2805 14.6501C11.2805 14.6564 11.2805 14.6627 11.2805 14.6691C11.2805 14.6754 11.2805 14.6817 11.2805 14.6881C11.2805 14.6944 11.2805 14.7009 11.2805 14.7073C11.2805 14.7136 11.2805 14.7201 11.2805 14.7265C11.2805 14.7329 11.2805 14.7393 11.2805 14.7458C11.2805 14.7523 11.2805 14.7587 11.2805 14.7653C11.2805 14.7717 11.2805 14.7782 11.2805 14.7848C11.2805 14.7913 11.2805 14.7978 11.2805 14.8043C11.2805 14.811 11.2805 14.8175 11.2805 14.8241C11.2805 14.8306 11.2805 14.8373 11.2805 14.8439C11.2805 14.8505 11.2805 14.8571 11.2805 14.8638C11.2805 14.8704 11.2805 14.877 11.2805 14.8837C11.2805 14.8904 11.2805 14.8971 11.2805 14.9038C11.2805 14.9105 11.2805 14.9172 11.2805 14.924C11.2805 14.9307 11.2805 14.9374 11.2805 14.9442C11.2805 14.9509 11.2805 14.9577 11.2805 14.9646C11.2805 14.9714 11.2805 14.9782 11.2805 14.985C11.2805 14.9918 11.2805 14.9986 11.2805 15.0056C11.2805 15.0124 11.2805 15.0193 11.2805 15.0262C11.2805 15.033 11.2805 15.0399 11.2805 15.0469C11.2805 15.0538 11.2805 15.0608 11.2805 15.0677C11.2805 15.0747 11.2805 15.0816 11.2805 15.0886C11.2805 15.0956 11.2805 15.1026 11.2805 15.1096C11.2805 15.1166 11.2805 15.1236 11.2805 15.1307C11.2805 15.1377 11.2805 15.1449 11.2805 15.152C11.2805 15.159 11.2805 15.1661 11.2805 15.1732C11.2805 15.1804 11.2805 15.1875 11.2805 15.1946C11.2805 15.2018 11.2805 15.2089 11.2805 15.2161C11.2805 15.2233 11.2805 15.2305 11.2805 15.2377C11.2805 15.2449 11.2805 15.2521 11.2805 15.2594C11.2805 15.2666 11.2805 15.2739 11.2805 15.2812C11.2805 15.2884 11.2805 15.2957 11.2805 15.303C11.2805 15.3103 11.2805 15.3177 11.2805 15.3249C11.2805 15.3323 11.2805 15.3396 11.2805 15.347C11.2805 15.3544 11.2805 15.3618 11.2805 15.3692C11.2805 15.3766 11.2805 15.384 11.2805 15.3915C11.2805 15.3989 11.2805 15.4064 11.2805 15.4138C11.2805 15.4212 11.2805 15.4287 11.2805 15.4363C11.2805 15.4438 11.2805 15.4513 11.2805 15.4589C11.2805 15.4664 11.2805 15.4739 11.2805 15.4814C11.2805 15.489 11.2805 15.4966 11.2805 15.5042C11.2805 15.5119 11.2805 15.5194 11.2805 15.5271C11.2805 15.5347 11.2805 15.5424 11.2805 15.5501C11.2805 15.5577 11.2805 15.5653 11.2805 15.5731C11.2805 15.5808 11.2805 15.5885 11.2805 15.5962C11.2805 15.6039 11.2805 15.6117 11.2805 15.6195C11.2805 15.6273 11.2805 15.635 11.2805 15.6428C11.2805 15.6506 11.2805 15.6585 11.2805 15.6662C11.2805 15.6741 11.2805 15.682 11.2805 15.6898C11.2805 15.6977 11.2805 15.7056 11.2805 15.7135C11.2805 15.7213 11.2805 15.7293 11.2805 15.7372C11.2805 15.7451 11.2805 15.7531 11.2805 15.7611C11.2805 15.769 11.2805 15.777 11.2805 15.785C11.2805 15.793 11.2805 15.801 11.2805 15.8091C11.2805 15.8171 11.2805 15.8252 11.2805 15.8333C11.2805 15.8413 11.2805 15.8494 11.2805 15.8575C11.2805 15.8656 11.2805 15.8737 11.2805 15.8818C11.2805 15.89 11.2805 15.8982 11.2805 15.9063C11.2805 15.9145 11.2805 15.9226 11.2805 15.9309C11.2805 15.9391 11.2805 15.9473 11.2805 15.9556C11.2805 15.9638 11.2805 15.9721 11.2805 15.9803C11.2805 15.9886 11.2805 15.9969 11.2805 16.0052C11.2805 16.0135 11.2805 16.0218 11.2805 16.0302C11.2805 16.0385 11.2805 16.0469 11.2805 16.0552C11.2805 16.0637 11.2805 16.072 11.2805 16.0805C11.2805 16.0888 11.2805 16.0973 11.2805 16.1057C11.2805 16.1142 11.2805 16.1226 11.2805 16.1312C11.2805 16.1396 11.2805 16.1481 11.2805 16.1566C11.2805 16.1651 11.2805 16.1737 11.2805 16.1822C11.2805 16.1908 11.2805 16.1993 11.2805 16.208C11.2805 16.2165 11.2805 16.2251 11.2805 16.2338C11.2805 16.2423 11.2805 16.251 11.2805 16.2597C11.2805 16.2683 11.2805 16.277 11.2805 16.2857C11.2805 16.2944 11.2805 16.3031 11.2805 16.3118C11.2805 16.3206 11.2805 16.3293 11.2805 16.338C11.2805 16.3468 11.2805 16.3556 11.2805 16.3643C11.2805 16.3732 11.2805 16.382 11.2805 16.3908C11.2805 16.3997 11.2805 16.4085 11.2805 16.4174C11.2805 16.4263 11.2805 16.4352 11.2805 16.444C11.2805 16.4529 11.2805 16.4619 11.2805 16.4708C11.2805 16.4797 11.2805 16.4888 11.2805 16.4977C11.2805 16.5067 11.2805 16.5156 11.2805 16.5247C11.2805 16.5337 11.2805 16.5427 11.2805 16.5517C11.2805 16.5609 11.2805 16.5699 11.2805 16.579C11.2805 16.588 11.2805 16.5971 11.2805 16.6063C11.2805 16.6154 11.2805 16.6245 11.2805 16.6337C11.2805 16.6428 11.2805 16.6521 11.2805 16.6612C11.2805 16.6704 11.2805 16.6796 11.2805 16.6888C11.2805 16.698 11.2805 16.7073 11.2805 16.7166C11.2805 16.7259 11.2805 16.7351 11.2805 16.7444C11.2805 16.7537 11.2805 16.763 11.2805 16.7724C11.2805 16.7817 11.2805 16.7911 11.2805 16.8005H12.7205C12.7205 16.7911 12.7205 16.7817 12.7205 16.7724C12.7205 16.763 12.7205 16.7537 12.7205 16.7444C12.7205 16.7351 12.7205 16.7259 12.7205 16.7166C12.7205 16.7073 12.7205 16.698 12.7205 16.6888C12.7205 16.6796 12.7205 16.6704 12.7205 16.6612C12.7205 16.6521 12.7205 16.6428 12.7205 16.6337C12.7205 16.6245 12.7205 16.6154 12.7205 16.6063C12.7205 16.5971 12.7205 16.588 12.7205 16.579C12.7205 16.5699 12.7205 16.5609 12.7205 16.5517C12.7205 16.5427 12.7205 16.5337 12.7205 16.5247C12.7205 16.5156 12.7205 16.5067 12.7205 16.4977C12.7205 16.4888 12.7205 16.4797 12.7205 16.4708C12.7205 16.4619 12.7205 16.4529 12.7205 16.444C12.7205 16.4352 12.7205 16.4263 12.7205 16.4174C12.7205 16.4085 12.7205 16.3997 12.7205 16.3908C12.7205 16.382 12.7205 16.3732 12.7205 16.3643C12.7205 16.3556 12.7205 16.3468 12.7205 16.338C12.7205 16.3293 12.7205 16.3206 12.7205 16.3118C12.7205 16.3031 12.7205 16.2944 12.7205 16.2857C12.7205 16.277 12.7205 16.2683 12.7205 16.2597C12.7205 16.251 12.7205 16.2423 12.7205 16.2338C12.7205 16.2251 12.7205 16.2165 12.7205 16.208C12.7205 16.1993 12.7205 16.1908 12.7205 16.1822C12.7205 16.1737 12.7205 16.1651 12.7205 16.1566C12.7205 16.1481 12.7205 16.1396 12.7205 16.1312C12.7205 16.1226 12.7205 16.1142 12.7205 16.1057C12.7205 16.0973 12.7205 16.0888 12.7205 16.0805C12.7205 16.072 12.7205 16.0637 12.7205 16.0552C12.7205 16.0469 12.7205 16.0385 12.7205 16.0302C12.7205 16.0218 12.7205 16.0135 12.7205 16.0052C12.7205 15.9969 12.7205 15.9886 12.7205 15.9803C12.7205 15.9721 12.7205 15.9638 12.7205 15.9556C12.7205 15.9473 12.7205 15.9391 12.7205 15.9309C12.7205 15.9226 12.7205 15.9145 12.7205 15.9063C12.7205 15.8982 12.7205 15.89 12.7205 15.8818C12.7205 15.8737 12.7205 15.8656 12.7205 15.8575C12.7205 15.8494 12.7205 15.8413 12.7205 15.8333C12.7205 15.8252 12.7205 15.8171 12.7205 15.8091C12.7205 15.801 12.7205 15.793 12.7205 15.785C12.7205 15.777 12.7205 15.769 12.7205 15.7611C12.7205 15.7531 12.7205 15.7451 12.7205 15.7372C12.7205 15.7293 12.7205 15.7213 12.7205 15.7135C12.7205 15.7056 12.7205 15.6977 12.7205 15.6898C12.7205 15.682 12.7205 15.6741 12.7205 15.6662C12.7205 15.6585 12.7205 15.6506 12.7205 15.6428C12.7205 15.635 12.7205 15.6273 12.7205 15.6195C12.7205 15.6117 12.7205 15.6039 12.7205 15.5962C12.7205 15.5885 12.7205 15.5808 12.7205 15.5731C12.7205 15.5653 12.7205 15.5577 12.7205 15.5501C12.7205 15.5424 12.7205 15.5347 12.7205 15.5271C12.7205 15.5194 12.7205 15.5119 12.7205 15.5042C12.7205 15.4966 12.7205 15.489 12.7205 15.4814C12.7205 15.4739 12.7205 15.4664 12.7205 15.4589C12.7205 15.4513 12.7205 15.4438 12.7205 15.4363C12.7205 15.4287 12.7205 15.4212 12.7205 15.4138C12.7205 15.4064 12.7205 15.3989 12.7205 15.3915C12.7205 15.384 12.7205 15.3766 12.7205 15.3692C12.7205 15.3618 12.7205 15.3544 12.7205 15.347C12.7205 15.3396 12.7205 15.3323 12.7205 15.3249C12.7205 15.3177 12.7205 15.3103 12.7205 15.303C12.7205 15.2957 12.7205 15.2884 12.7205 15.2812C12.7205 15.2739 12.7205 15.2666 12.7205 15.2594C12.7205 15.2521 12.7205 15.2449 12.7205 15.2377C12.7205 15.2305 12.7205 15.2233 12.7205 15.2161C12.7205 15.2089 12.7205 15.2018 12.7205 15.1946C12.7205 15.1875 12.7205 15.1804 12.7205 15.1732C12.7205 15.1661 12.7205 15.159 12.7205 15.152C12.7205 15.1449 12.7205 15.1377 12.7205 15.1307C12.7205 15.1236 12.7205 15.1166 12.7205 15.1096C12.7205 15.1026 12.7205 15.0956 12.7205 15.0886C12.7205 15.0816 12.7205 15.0747 12.7205 15.0677C12.7205 15.0608 12.7205 15.0538 12.7205 15.0469C12.7205 15.0399 12.7205 15.033 12.7205 15.0262C12.7205 15.0193 12.7205 15.0124 12.7205 15.0056C12.7205 14.9986 12.7205 14.9918 12.7205 14.985C12.7205 14.9782 12.7205 14.9714 12.7205 14.9646C12.7205 14.9577 12.7205 14.9509 12.7205 14.9442C12.7205 14.9374 12.7205 14.9307 12.7205 14.924C12.7205 14.9172 12.7205 14.9105 12.7205 14.9038C12.7205 14.8971 12.7205 14.8904 12.7205 14.8837C12.7205 14.877 12.7205 14.8704 12.7205 14.8638C12.7205 14.8571 12.7205 14.8505 12.7205 14.8439C12.7205 14.8373 12.7205 14.8306 12.7205 14.8241C12.7205 14.8175 12.7205 14.811 12.7205 14.8043C12.7205 14.7978 12.7205 14.7913 12.7205 14.7848C12.7205 14.7782 12.7205 14.7717 12.7205 14.7653C12.7205 14.7587 12.7205 14.7523 12.7205 14.7458C12.7205 14.7393 12.7205 14.7329 12.7205 14.7265C12.7205 14.7201 12.7205 14.7136 12.7205 14.7073C12.7205 14.7009 12.7205 14.6944 12.7205 14.6881C12.7205 14.6817 12.7205 14.6754 12.7205 14.6691C12.7205 14.6627 12.7205 14.6564 12.7205 14.6501C12.7205 14.6437 12.7205 14.6375 12.7205 14.6312C12.7205 14.6249 12.7205 14.6187 12.7205 14.6124C12.7205 14.6061 12.7205 14.5999 12.7205 14.5937C12.7205 14.5875 12.7205 14.5812 12.7205 14.5751C12.7205 14.5689 12.7205 14.5627 12.7205 14.5566C12.7205 14.5504 12.7205 14.5443 12.7205 14.5381C12.7205 14.532 12.7205 14.5258 12.7205 14.5198C12.7205 14.5137 12.7205 14.5076 12.7205 14.5016C12.7205 14.4954 12.7205 14.4894 12.7205 14.4833C12.7205 14.4773 12.7205 14.4713 12.7205 14.4653C12.7205 14.4592 12.7205 14.4533 12.7205 14.4473C12.7205 14.4413 12.7205 14.4353 12.7205 14.4294C12.7205 14.4234 12.7205 14.4175 12.7205 14.4116C12.7205 14.4057 12.7205 14.3997 12.7205 14.3938C12.7205 14.388 12.7205 14.382 12.7205 14.3762C12.7205 14.3703 12.7205 14.3645 12.7205 14.3586C12.7205 14.3528 12.7205 14.347 12.7205 14.3411C12.7205 14.3354 12.7205 14.3295 12.7205 14.3238C12.7205 14.318 12.7205 14.3122 12.7205 14.3065C12.7205 14.3007 12.7205 14.295 12.7205 14.2893C12.7205 14.2835 12.7205 14.2779 12.7205 14.2721C12.7205 14.2665 12.7205 14.2608 12.7205 14.2551C12.7205 14.2495 12.7205 14.2438 12.7205 14.2381C12.7205 14.2326 12.7205 14.2269 12.7205 14.2213C12.7205 14.2157 12.7205 14.2101 12.7205 14.2045C12.7205 14.199 12.7205 14.1934 12.7205 14.1878C12.7205 14.1823 12.7205 14.1767 12.7205 14.1712C12.7205 14.1657 12.7205 14.1602 12.7205 14.1547C12.7205 14.1492 12.7205 14.1437 12.7205 14.1382C12.7205 14.1328 12.7205 14.1273 12.7205 14.1219C12.7205 14.1164 12.7205 14.111 12.7205 14.1057C12.7205 14.1002 12.7205 14.0948 12.7205 14.0894C12.7205 14.0841 12.7205 14.0787 12.7205 14.0733C12.7205 14.0679 12.7205 14.0626 12.7205 14.0573C12.7205 14.052 12.7205 14.0466 12.7205 14.0413C12.7205 14.0361 12.7205 14.0308 12.7205 14.0255C12.7205 14.0202 12.7205 14.0149 12.7205 14.0097C12.7205 14.0045 12.7205 13.9992 12.7205 13.994C12.7205 13.9888 12.7205 13.9835 12.7205 13.9784C12.7205 13.9732 12.7205 13.968 12.7205 13.9628C12.7205 13.9577 12.7205 13.9525 12.7205 13.9473C12.7205 13.9423 12.7205 13.9372 12.7205 13.932C12.7205 13.9269 12.7205 13.9218 12.7205 13.9167C12.7205 13.9116 12.7205 13.9065 12.7205 13.9016C12.7205 13.8965 12.7205 13.8914 12.7205 13.8864C12.7205 13.8814 12.7205 13.8763 12.7205 13.8713C12.7205 13.8663 12.7205 13.8613 12.7205 13.8563C12.7205 13.8514 12.7205 13.8465 12.7205 13.8415C12.7205 13.8366 12.7205 13.8316 12.7205 13.8267C12.7205 13.8218 12.7205 13.8169 12.7205 13.812C12.7205 13.8071 12.7205 13.8022 12.7205 13.7973C12.7205 13.7924 12.7205 13.7876 12.7205 13.7827C12.7205 13.7779 12.7205 13.7731 12.7205 13.7682C12.7205 13.7634 12.7205 13.7586 12.7205 13.7538C12.7205 13.749 12.7205 13.7443 12.7205 13.7395C12.7205 13.7347 12.7205 13.73 12.7205 13.7253C12.7205 13.7205 12.7205 13.7158 12.7205 13.7111C12.7205 13.7064 12.7205 13.7017 12.7205 13.697C12.7205 13.6923 12.7205 13.6877 12.7205 13.683C12.7205 13.6783 12.7205 13.6737 12.7205 13.669C12.7205 13.6643 12.7205 13.6597 12.7205 13.6551C12.7205 13.6505 12.7205 13.6459 12.7205 13.6414C12.7205 13.6368 12.7205 13.6322 12.7205 13.6277C12.7205 13.6231 12.7205 13.6185 12.7205 13.614C12.7205 13.6095 12.7205 13.6049 12.7205 13.6005C12.7205 13.596 12.7205 13.5915 12.7205 13.587C12.7205 13.5825 12.7205 13.578 12.7205 13.5735C12.7205 13.5691 12.7205 13.5647 12.7205 13.5603C12.7205 13.5558 12.7205 13.5513 12.7205 13.5469C12.7205 13.5426 12.7205 13.5382 12.7205 13.5338C12.7205 13.5295 12.7205 13.525 12.7205 13.5207C12.7205 13.5163 12.7205 13.512 12.7205 13.5077C12.7205 13.5033 12.7205 13.499 12.7205 13.4947C12.7205 13.4904 12.7205 13.4861 12.7205 13.4818C12.7205 13.4775 12.7205 13.4733 12.7205 13.469C12.7205 13.4648 12.7205 13.4605 12.7205 13.4563C12.7205 13.4521 12.7205 13.4479 12.7205 13.4436C12.7205 13.4394 12.7205 13.4352 12.7205 13.4311C12.7205 13.4268 12.7205 13.4227 12.7205 13.4185C12.7205 13.4144 12.7205 13.4102 12.7205 13.4061C12.7205 13.402 12.7205 13.3978 12.7205 13.3937C12.7205 13.3896 12.7205 13.3856 12.7205 13.3814C12.7205 13.3773 12.7205 13.3733 12.7205 13.3692C12.7205 13.3651 12.7205 13.3611 12.7205 13.357C12.7205 13.353 12.7205 13.349 12.7205 13.3449C12.7205 13.341 12.7205 13.337 12.7205 13.3329C12.7205 13.329 12.7205 13.325 12.7205 13.321C12.7205 13.3171 12.7205 13.3132 12.7205 13.3091C12.7205 13.3052 12.7205 13.3013 12.7205 13.2974C12.7205 13.2935 12.7205 13.2896 12.7205 13.2857C12.7205 13.2818 12.7205 13.2779 12.7205 13.274C12.7205 13.2702 12.7205 13.2663 12.7205 13.2625C12.7205 13.2586 12.7205 13.2548 12.7205 13.251C12.7205 13.2471 12.7205 13.2433 12.7205 13.2395C12.7205 13.2357 12.7205 13.232 12.7205 13.2281C12.7205 13.2244 12.7205 13.2206 12.7205 13.2169C12.7205 13.213 12.7205 13.2093 12.7205 13.2057C12.7205 13.2019 12.7205 13.1982 12.7205 13.1944C12.7205 13.1908 12.7205 13.187 12.7205 13.1834C12.7205 13.1796 12.7205 13.176 12.7205 13.1723C12.7205 13.1687 12.7205 13.165 12.7205 13.1614C12.7205 13.1577 12.7205 13.1541 12.7205 13.1505C12.7205 13.1469 12.7205 13.1433 12.7205 13.1397C12.7205 13.1361 12.7205 13.1325 12.7205 13.1289C12.7205 13.1254 12.7205 13.1218 12.7205 13.1183C12.7205 13.1147 12.7205 13.1112 12.7205 13.1076C12.7205 13.1041 12.7205 13.1006 12.7205 13.0971C12.7205 13.0936 12.7205 13.0901 12.7205 13.0866C12.7205 13.0832 12.7205 13.0797 12.7205 13.0762C12.7205 13.0728 12.7205 13.0693 12.7205 13.0659C12.7205 13.0624 12.7205 13.0591 12.7205 13.0556C12.7205 13.0521 12.7205 13.0488 12.7205 13.0454C12.7205 13.042 12.7205 13.0386 12.7205 13.0353C12.7205 13.0319 12.7205 13.0285 12.7205 13.0252C12.7205 13.0218 12.7205 13.0185 12.7205 13.0152C12.7205 13.0118 12.7205 13.0085 12.7205 13.0052C12.7205 13.0019 12.7205 12.9986 12.7205 12.9953C12.7205 12.9921 12.7205 12.9888 12.7205 12.9855C12.7205 12.9823 12.7205 12.979 12.7205 12.9757C12.7205 12.9725 12.7205 12.9693 12.7205 12.966C12.7205 12.9629 12.7205 12.9596 12.7205 12.9564C12.7205 12.9533 12.7205 12.9501 12.7205 12.9468C12.7205 12.9437 12.7205 12.9405 12.7205 12.9374C12.7205 12.9343 12.7205 12.9311 12.7205 12.9279C12.7205 12.9249 12.7205 12.9217 12.7205 12.9186C12.7205 12.9154 12.7205 12.9124 12.7205 12.9093C12.7205 12.9062 12.7205 12.9031 12.7205 12.9001C12.7205 12.897 12.7205 12.8939 12.7205 12.8909C12.7205 12.8878 12.7205 12.8847 12.7205 12.8817C12.7205 12.8787 12.7205 12.8757 12.7205 12.8727C12.7205 12.8697 12.7205 12.8667 12.7205 12.8637C12.7205 12.8607 12.7205 12.8577 12.7205 12.8548C12.7205 12.8518 12.7205 12.8488 12.7205 12.8459C12.7205 12.843 12.7205 12.84 12.7205 12.8371C12.7205 12.8341 12.7205 12.8313 12.7205 12.8284C12.7205 12.8254 12.7205 12.8225 12.7205 12.8196C12.7205 12.8168 12.7205 12.8139 12.7205 12.811C12.7205 12.8082 12.7205 12.8053 12.7205 12.8025C12.7205 12.7997 12.7205 12.7968 12.7205 12.794C12.7205 12.7911 12.7205 12.7883 12.7205 12.7856C12.7205 12.7828 12.7205 12.7799 12.7205 12.7771C12.7205 12.7743 12.7205 12.7716 12.7205 12.7689C12.7205 12.7661 12.7205 12.7633 12.7205 12.7606C12.7205 12.7578 12.7205 12.7551 12.7205 12.7523C12.7205 12.7497 12.7205 12.747 12.7205 12.7442C12.7205 12.7415 12.7205 12.7388 12.7205 12.7361C12.7205 12.7334 12.7205 12.7307 12.7205 12.7281C12.7205 12.7255 12.7205 12.7228 12.7205 12.7202C12.7205 12.7175 12.7205 12.7149 12.7205 12.7122C12.7205 12.7096 12.7205 12.707 12.7205 12.7043C12.7205 12.7017 12.7205 12.6992 12.7205 12.6966C12.7205 12.694 12.7205 12.6915 12.7205 12.6889C12.7205 12.6863 12.7205 12.6837 12.7205 12.6812C12.7205 12.6786 12.7205 12.6761 12.7205 12.6735C12.7205 12.671 12.7205 12.6685 12.7205 12.666C12.7205 12.6634 12.7205 12.6609 12.7205 12.6585C12.7205 12.656 12.7205 12.6536 12.7205 12.6511C12.7205 12.6486 12.7205 12.6461 12.7205 12.6437C12.7205 12.6412 12.7205 12.6388 12.7205 12.6363C12.7205 12.6339 12.7205 12.6315 12.7205 12.6291C12.7205 12.6266 12.7205 12.6242 12.7205 12.6218C12.7205 12.6194 12.7205 12.617 12.7205 12.6147C12.7205 12.6123 12.7205 12.6099 12.7205 12.6076C12.7205 12.6052 12.7205 12.6028 12.7205 12.6005C12.7205 12.5982 12.7205 12.5958 12.7205 12.5935C12.7205 12.5912 12.7205 12.5889 12.7205 12.5865C12.7205 12.5842 12.7205 12.5819 12.7205 12.5796C12.7205 12.5773 12.7205 12.575 12.7205 12.5728C12.7205 12.5705 12.7205 12.5682 12.7205 12.566C12.7205 12.5637 12.7205 12.5615 12.7205 12.5593C12.7205 12.557 12.7205 12.5548 12.7205 12.5526C12.7205 12.5504 12.7205 12.5481 12.7205 12.5459C12.7205 12.5437 12.7205 12.5415 12.7205 12.5394C12.7205 12.5372 12.7205 12.535 12.7205 12.5329C12.7205 12.5307 12.7205 12.5286 12.7205 12.5264C12.7205 12.5242 12.7205 12.5221 12.7205 12.52C12.7205 12.5178 12.7205 12.5157 12.7205 12.5136C12.7205 12.5115 12.7205 12.5094 12.7205 12.5073C12.7205 12.5052 12.7205 12.5031 12.7205 12.501C12.7205 12.499 12.7205 12.4969 12.7205 12.4949C12.7205 12.4928 12.7205 12.4907 12.7205 12.4887C12.7205 12.4866 12.7205 12.4846 12.7205 12.4826C12.7205 12.4806 12.7205 12.4785 12.7205 12.4765C12.7205 12.4745 12.7205 12.4725 12.7205 12.4706C12.7205 12.4686 12.7205 12.4665 12.7205 12.4646C12.7205 12.4626 12.7205 12.4607 12.7205 12.4587C12.7205 12.4568 12.7205 12.4547 12.7205 12.4528C12.7205 12.4509 12.7205 12.449 12.7205 12.4471C12.7205 12.4451 12.7205 12.4432 12.7205 12.4413C12.7205 12.4394 12.7205 12.4375 12.7205 12.4356C12.7205 12.4337 12.7205 12.4318 12.7205 12.43C12.7205 12.4281 12.7205 12.4262 12.7205 12.4243C12.7205 12.4225 12.7205 12.4207 12.7205 12.4188C12.7205 12.4169 12.7205 12.4151 12.7205 12.4133C12.7205 12.4114 12.7205 12.4096 12.7205 12.4078C12.7205 12.406 12.7205 12.4042 12.7205 12.4024C12.7205 12.4006 12.7205 12.3989 12.7205 12.397C12.7205 12.3953 12.7205 12.3935 12.7205 12.3918C12.7205 12.3899 12.7205 12.3882 12.7205 12.3865C12.7205 12.3848 12.7205 12.383 12.7205 12.3813C12.7205 12.3796 12.7205 12.3778 12.7205 12.3761C12.7205 12.3744 12.7205 12.3727 12.7205 12.3709C12.7205 12.3693 12.7205 12.3676 12.7205 12.3659C12.7205 12.3642 12.7205 12.3626 12.7205 12.3609C12.7205 12.3592 12.7205 12.3576 12.7205 12.3559C12.7205 12.3542 12.7205 12.3526 12.7205 12.351C12.7205 12.3493 12.7205 12.3477 12.7205 12.3461C12.7205 12.3444 12.7205 12.3428 12.7205 12.3413C12.7205 12.3396 12.7205 12.338 12.7205 12.3365C12.7205 12.3348 12.7205 12.3332 12.7205 12.3317C12.7205 12.3301 12.7205 12.3285 12.7205 12.327C12.7205 12.3254 12.7205 12.3238 12.7205 12.3223C12.7205 12.3207 12.7205 12.3192 12.7205 12.3177C12.7205 12.3161 12.7205 12.3146 12.7205 12.3131C12.7205 12.3116 12.7205 12.3101 12.7205 12.3085C12.7205 12.3071 12.7205 12.3056 12.7205 12.3041C12.7205 12.3026 12.7205 12.3011 12.7205 12.2996C12.7205 12.2982 12.7205 12.2967 12.7205 12.2953C12.7205 12.2937 12.7205 12.2923 12.7205 12.2909C12.7205 12.2894 12.7205 12.288 12.7205 12.2865C12.7205 12.2851 12.7205 12.2838 12.7205 12.2823C12.7205 12.2809 12.7205 12.2794 12.7205 12.2781C12.7205 12.2767 12.7205 12.2753 12.7205 12.2739C12.7205 12.2725 12.7205 12.2711 12.7205 12.2697C12.7205 12.2684 12.7205 12.267 12.7205 12.2656C12.7205 12.2643 12.7205 12.2629 12.7205 12.2616C12.7205 12.2602 12.7205 12.2589 12.7205 12.2576C12.7205 12.2562 12.7205 12.2549 12.7205 12.2536C12.7205 12.2523 12.7205 12.2509 12.7205 12.2497C12.7205 12.2483 12.7205 12.2471 12.7205 12.2457C12.7205 12.2445 12.7205 12.2432 12.7205 12.2419C12.7205 12.2407 12.7205 12.2393 12.7205 12.2381C12.7205 12.2368 12.7205 12.2356 12.7205 12.2343C12.7205 12.2331 12.7205 12.2318 12.7205 12.2306C12.7205 12.2293 12.7205 12.2281 12.7205 12.2269C12.7205 12.2257 12.7205 12.2244 12.7205 12.2233C12.7205 12.222 12.7205 12.2209 12.7205 12.2196C12.7205 12.2185 12.7205 12.2172 12.7205 12.2161C12.7205 12.2148 12.7205 12.2137 12.7205 12.2125C12.7205 12.2114 12.7205 12.2102 12.7205 12.2091C12.7205 12.2079 12.7205 12.2068 12.7205 12.2056C12.7205 12.2045 12.7205 12.2033 12.7205 12.2022C12.7205 12.201 12.7205 12.1999 12.7205 12.1988C12.7205 12.1977 12.7205 12.1965 12.7205 12.1954C12.7205 12.1943 12.7205 12.1932 12.7205 12.1922C12.7205 12.191 12.7205 12.19 12.7205 12.1888C12.7205 12.1878 12.7205 12.1867 12.7205 12.1857C12.7205 12.1846 12.7205 12.1835 12.7205 12.1825C12.7205 12.1814 12.7205 12.1804 12.7205 12.1793C12.7205 12.1783 12.7205 12.1772 12.7205 12.1761C12.7205 12.1751 12.7205 12.1741 12.7205 12.1731C12.7205 12.172 12.7205 12.1711 12.7205 12.17C12.7205 12.169 12.7205 12.168 12.7205 12.167C12.7205 12.1661 12.7205 12.165 12.7205 12.1641C12.7205 12.1631 12.7205 12.1621 12.7205 12.1611C12.7205 12.1601 12.7205 12.1592 12.7205 12.1582C12.7205 12.1572 12.7205 12.1563 12.7205 12.1553C12.7205 12.1544 12.7205 12.1535 12.7205 12.1525C12.7205 12.1516 12.7205 12.1506 12.7205 12.1497C12.7205 12.1488 12.7205 12.1478 12.7205 12.147C12.7205 12.146 12.7205 12.1451 12.7205 12.1442C12.7205 12.1433 12.7205 12.1425 12.7205 12.1415C12.7205 12.1406 12.7205 12.1398 12.7205 12.1389C12.7205 12.1379 12.7205 12.1371 12.7205 12.1362C12.7205 12.1353 12.7205 12.1345 12.7205 12.1336C12.7205 12.1328 12.7205 12.1319 12.7205 12.1311C12.7205 12.1303 12.7205 12.1294 12.7205 12.1285C12.7205 12.1278 12.7205 12.1269 12.7205 12.126C12.7205 12.1253 12.7205 12.1244 12.7205 12.1236C12.7205 12.1228 12.7205 12.122 12.7205 12.1211C12.7205 12.1204 12.7205 12.1196 12.7205 12.1187C12.7205 12.118 12.7205 12.1172 12.7205 12.1164C12.7205 12.1157 12.7205 12.1148 12.7205 12.114C12.7205 12.1133 12.7205 12.1125 12.7205 12.1117C12.7205 12.111 12.7205 12.1103 12.7205 12.1095C12.7205 12.1088 12.7205 12.108 12.7205 12.1072C12.7205 12.1065 12.7205 12.1058 12.7205 12.105C12.7205 12.1043 12.7205 12.1036 12.7205 12.1029C12.7205 12.1021 12.7205 12.1015 12.7205 12.1007C12.7205 12.1 12.7205 12.0993 12.7205 12.0986C12.7205 12.0979 12.7205 12.0972 12.7205 12.0965C12.7205 12.0958 12.7205 12.0951 12.7205 12.0945C12.7205 12.0938 12.7205 12.0931 12.7205 12.0924C12.7205 12.0918 12.7205 12.0911 12.7205 12.0904C12.7205 12.0897 12.7205 12.0891 12.7205 12.0885C12.7205 12.0878 12.7205 12.0872 12.7205 12.0865C12.7205 12.0859 12.7205 12.0852 12.7205 12.0846C12.7205 12.084 12.7205 12.0833 12.7205 12.0827C12.7205 12.0821 12.7205 12.0815 12.7205 12.0808C12.7205 12.0802 12.7205 12.0797 12.7205 12.079C12.7205 12.0784 12.7205 12.0778 12.7205 12.0773C12.7205 12.0767 12.7205 12.076 12.7205 12.0754C12.7205 12.0749 12.7205 12.0743 12.7205 12.0737C12.7205 12.0731 12.7205 12.0726 12.7205 12.072C12.7205 12.0714 12.7205 12.0708 12.7205 12.0704C12.7205 12.0698 12.7205 12.0692 12.7205 12.0686C12.7205 12.0681 12.7205 12.0676 12.7205 12.067C12.7205 12.0665 12.7205 12.0659 12.7205 12.0654C12.7205 12.0649 12.7205 12.0643 12.7205 12.0638C12.7205 12.0633 12.7205 12.0628 12.7205 12.0623C12.7205 12.0617 12.7205 12.0612 12.7205 12.0608C12.7205 12.0602 12.7205 12.0597 12.7205 12.0592C12.7205 12.0587 12.7205 12.0583 12.7205 12.0578C12.7205 12.0573 12.7205 12.0567 12.7205 12.0562C12.7205 12.0558 12.7205 12.0553 12.7205 12.0549C12.7205 12.0544 12.7205 12.0539 12.7205 12.0535C12.7205 12.053 12.7205 12.0525 12.7205 12.0521C12.7205 12.0516 12.7205 12.0512 12.7205 12.0507C12.7205 12.0503 12.7205 12.0498 12.7205 12.0493C12.7205 12.0489 12.7205 12.0485 12.7205 12.0481C12.7205 12.0476 12.7205 12.0472 12.7205 12.0467C12.7205 12.0464 12.7205 12.046 12.7205 12.0455C12.7205 12.0451 12.7205 12.0447 12.7205 12.0442C12.7205 12.0439 12.7205 12.0435 12.7205 12.0431C12.7205 12.0427 12.7205 12.0422 12.7205 12.0418C12.7205 12.0415 12.7205 12.0411 12.7205 12.0407C12.7205 12.0403 12.7205 12.0399 12.7205 12.0395C12.7205 12.0392 12.7205 12.0388 12.7205 12.0384C12.7205 12.038 12.7205 12.0377 12.7205 12.0373C12.7205 12.0369 12.7205 12.0366 12.7205 12.0363C12.7205 12.0359 12.7205 12.0355 12.7205 12.0351C12.7205 12.0348 12.7205 12.0345 12.7205 12.0342C12.7205 12.0338 12.7205 12.0335 12.7205 12.0331C12.7205 12.0327 12.7205 12.0324 12.7205 12.0321C12.7205 12.0318 12.7205 12.0315 12.7205 12.0311C12.7205 12.0308 12.7205 12.0305 12.7205 12.0301C12.7205 12.0298 12.7205 12.0304 12.7205 12.0301C12.7205 12.0297 12.7205 12.0286 12.7205 12.0283C12.7205 12.028 12.7205 12.0286 12.7205 12.0283C12.7205 12.028 12.7205 12.0269 12.7205 12.0266C12.7205 12.0263 12.7205 12.0269 12.7205 12.0266C12.7205 12.0263 12.7205 12.0251 12.7205 12.0249C12.7205 12.0246 12.7205 12.0251 12.7205 12.0249C12.7205 12.0246 12.7205 12.0235 12.7205 12.0232C12.7205 12.0229 12.7205 12.0234 12.7205 12.0232C12.7205 12.0229 12.7205 12.0219 12.7205 12.0217C12.7205 12.0214 12.7205 12.022 12.7205 12.0217C12.7205 12.0214 12.7205 12.0204 12.7205 12.0201C12.7205 12.02 12.7205 12.0203 12.7205 12.0201C12.7205 12.02 12.7205 12.019 12.7205 12.0188C12.7205 12.0185 12.7205 12.019 12.7205 12.0188C12.7205 12.0185 12.7205 12.0177 12.7205 12.0175C12.7205 12.0173 12.7205 12.0177 12.7205 12.0175C12.7205 12.0173 12.7205 12.0164 12.7205 12.0162C12.7205 12.0159 12.7205 12.0164 12.7205 12.0162C12.7205 12.016 12.7205 12.0152 12.7205 12.015C12.7205 12.0148 12.7205 12.0152 12.7205 12.015C12.7205 12.0148 12.7205 12.014 12.7205 12.0138C12.7205 12.0136 12.7205 12.014 12.7205 12.0138C12.7205 12.0136 12.7205 12.0129 12.7205 12.0128C12.7205 12.0126 12.7205 12.0129 12.7205 12.0128C12.7205 12.0127 12.7205 12.0119 12.7205 12.0117C12.7205 12.0115 12.7205 12.0105 12.7205 12.0103C12.7205 12.0102 12.7205 12.0091 12.7205 12.009C12.7205 12.0089 12.7205 12.008 12.7205 12.0079C12.7205 12.0078 12.7205 12.0069 12.7205 12.0067C12.7205 12.0066 12.7205 12.0059 12.7205 12.0057C12.7205 12.0057 12.7205 12.0048 12.7205 12.0047C12.7205 12.0046 12.7205 12.0048 12.7205 12.0047C12.7205 12.0046 12.7205 12.0038 12.7205 12.0037C12.7205 12.0036 12.7205 12.0027 12.7205 12.0026C12.7205 12.0026 12.7205 12.0017 12.7205 12.0016C12.7205 12.0015 12.7205 12.0005 12.7205 12.0005H12.0005ZM12.7205 12.0005V7.20047H11.2805V12.0005H12.7205Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const Unsaved = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M16 8.9889V20.3489C16 21.7989 14.96 22.4089 13.69 21.7089L9.76 19.5189C9.34 19.2889 8.66 19.2889 8.24 19.5189L4.31 21.7089C3.04 22.4089 2 21.7989 2 20.3489V8.9889C2 7.2789 3.4 5.87891 5.11 5.87891H12.89C14.6 5.87891 16 7.2789 16 8.9889Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58984 13.4099L10.4098 10.5898"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4098 13.4099L7.58984 10.5898"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 5.10999V16.47C22 17.92 20.96 18.53 19.69 17.83L16 15.77V8.98999C16 7.27999 14.6 5.88 12.89 5.88H8V5.10999C8 3.39999 9.4 2 11.11 2H18.89C20.6 2 22 3.39999 22 5.10999Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const Draft = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.83871 3.53846C6.12608 3.53846 5.54839 4.11246 5.54839 4.82051V19.1795C5.54839 19.8875 6.12608 20.4615 6.83871 20.4615H17.1613C17.8739 20.4615 18.4516 19.8875 18.4516 19.1795V9.14049C18.4516 8.80672 18.3206 8.48611 18.0864 8.2468L13.8594 3.92682C13.6164 3.67854 13.2827 3.53846 12.9342 3.53846H6.83871ZM4 4.82051C4 3.26279 5.27093 2 6.83871 2H12.9342C13.701 2 14.4351 2.30817 14.9696 2.85439L19.1966 7.17437C19.7118 7.70085 20 8.4062 20 9.14049V19.1795C20 20.7372 18.7291 22 17.1613 22H6.83871C5.27093 22 4 20.7372 4 19.1795V4.82051Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.12891 15.0778C8.12891 15.5027 8.47553 15.8471 8.90311 15.8471H15.0967C15.5242 15.8471 15.8709 15.5027 15.8709 15.0778C15.8709 14.653 15.5242 14.3086 15.0967 14.3086H8.90311C8.47553 14.3086 8.12891 14.653 8.12891 15.0778Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.12891 10.9763C8.12891 11.4011 8.47553 11.7455 8.90311 11.7455H11.9999C12.4275 11.7455 12.7741 11.4011 12.7741 10.9763C12.7741 10.5514 12.4275 10.207 11.9999 10.207H8.90311C8.47553 10.207 8.12891 10.5514 8.12891 10.9763Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const Support = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7137 17.7783C10.6779 17.7783 8.6097 16.5698 7.40264 14.9703C1.61158 14.9703 1.43652 23.2432 1.43652 23.2432H23.9895C23.9895 23.2432 24.4441 14.9336 17.9316 14.9336C16.7259 16.5529 14.7495 17.7783 12.7137 17.7783Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5647 7.8609C17.5647 10.2411 15.392 14.7927 12.7097 14.7927C10.0315 14.7927 7.85742 10.2397 7.85742 7.8609C7.85742 5.48208 10.0301 3.55078 12.7097 3.55078C15.392 3.55219 17.5647 5.48349 17.5647 7.8609Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7297 5.80739C19.7297 5.36127 19.1085 5.00127 18.3377 4.99845V4.07939C18.3377 3.94245 18.3899 0.736328 12.7259 0.736328C7.06472 0.736328 7.11696 3.94245 7.11696 4.07939V5.03092C7.10284 5.03092 7.09155 5.02668 7.07884 5.02668C6.31225 5.02668 5.69531 5.38103 5.69531 5.82009V9.70809C5.69531 10.1443 6.31367 10.5001 7.07884 10.5001C7.84402 10.5001 8.46519 10.1443 8.46519 9.70809V5.82009C8.46519 5.75939 8.42708 5.70433 8.40449 5.64786V4.58762C8.40449 4.49021 7.9979 2.07045 12.7259 2.07045C17.4553 2.07045 16.964 4.49021 16.964 4.58762V5.70433C16.9555 5.73962 16.9287 5.77068 16.9287 5.80739V9.78433C16.9287 10.2319 17.5541 10.5947 18.3292 10.5947C18.3461 10.5947 18.3588 10.589 18.3758 10.589V12.0417H16.9866V13.4112H19.7438L19.7297 5.80739Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

// export const Unread = ({ mode }) => {
//   return (
//     <React.Fragment>
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//          height="30px"
//         width="30px"
//         viewBox="0 0 24 24"
//         fill="none"
//       >
//         <g id="SVGRepo_bgCarrier" strokeWidth="0" />

//         <g
//           id="SVGRepo_tracerCarrier"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />

//         <g id="SVGRepo_iconCarrier">
//           <path
//             opacity="0.5"
//             d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12Z"
//             fill="#1C274C"
//           />
//           <path
//             d="M7 16.75C6.58579 16.75 6.25 17.0858 6.25 17.5C6.25 17.9142 6.58579 18.25 7 18.25H13C13.4142 18.25 13.75 17.9142 13.75 17.5C13.75 17.0858 13.4142 16.75 13 16.75H7Z"
//             fill="#1C274C"
//           />
//           <path
//             d="M7 13.25C6.58579 13.25 6.25 13.5858 6.25 14C6.25 14.4142 6.58579 14.75 7 14.75H16C16.4142 14.75 16.75 14.4142 16.75 14C16.75 13.5858 16.4142 13.25 16 13.25H7Z"
//             fill="#1C274C"
//           />
//           <path
//             d="M22 5C22 6.65685 20.6569 8 19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5Z"
//             fill="#1C274C"
//           />
//         </g>
//       </svg>
//     </React.Fragment>
//   );
// };

export const Unread1 = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M20.4002 3.59961C19.7637 3.59961 19.1532 3.85247 18.7031 4.30255C18.2531 4.75264 18.0002 5.36309 18.0002 5.99961C18.0002 6.63613 18.2531 7.24658 18.7031 7.69667C19.1532 8.14675 19.7637 8.39961 20.4002 8.39961C21.0367 8.39961 21.6472 8.14675 22.0973 7.69667C22.5473 7.24658 22.8002 6.63613 22.8002 5.99961C22.8002 5.36309 22.5473 4.75264 22.0973 4.30255C21.6472 3.85247 21.0367 3.59961 20.4002 3.59961ZM15.0002 4.79961H1.8002C1.64107 4.79961 1.48845 4.86282 1.37593 4.97535C1.26341 5.08787 1.2002 5.24048 1.2002 5.39961V6.59961C1.2002 6.75874 1.26341 6.91135 1.37593 7.02387C1.48845 7.1364 1.64107 7.19961 1.8002 7.19961H15.0002C15.1593 7.19961 15.3119 7.1364 15.4245 7.02387C15.537 6.91135 15.6002 6.75874 15.6002 6.59961V5.39961C15.6002 5.24048 15.537 5.08787 15.4245 4.97535C15.3119 4.86282 15.1593 4.79961 15.0002 4.79961ZM15.0002 10.7996H1.8002C1.64107 10.7996 1.48845 10.8628 1.37593 10.9753C1.26341 11.0879 1.2002 11.2405 1.2002 11.3996V12.5996C1.2002 12.7587 1.26341 12.9114 1.37593 13.0239C1.48845 13.1364 1.64107 13.1996 1.8002 13.1996H15.0002C15.1593 13.1996 15.3119 13.1364 15.4245 13.0239C15.537 12.9114 15.6002 12.7587 15.6002 12.5996V11.3996C15.6002 11.2405 15.537 11.0879 15.4245 10.9753C15.3119 10.8628 15.1593 10.7996 15.0002 10.7996ZM15.0002 16.7996H1.8002C1.64107 16.7996 1.48845 16.8628 1.37593 16.9753C1.26341 17.0879 1.2002 17.2405 1.2002 17.3996V18.5996C1.2002 18.7587 1.26341 18.9114 1.37593 19.0239C1.48845 19.1364 1.64107 19.1996 1.8002 19.1996H15.0002C15.1593 19.1996 15.3119 19.1364 15.4245 19.0239C15.537 18.9114 15.6002 18.7587 15.6002 18.5996V17.3996C15.6002 17.2405 15.537 17.0879 15.4245 16.9753C15.3119 16.8628 15.1593 16.7996 15.0002 16.7996Z"
          fill={mode ? "#fff" : "#000"}
        />
      </svg>
    </React.Fragment>
  );
};

// export const Unread = ({ mode,unread }) => {
//   return (
//     <React.Fragment>
//       <svg
//         stroke="currentColor"
//         fill={mode ? "#fff" : "#000"}
//         strokeWidth="0"
//         viewBox="0 0 24 24"
//         width="25px"
//         height="25px"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path fill="none" d="M0 0h24v24H0z"></path>
//         <path d="M20 16H4V4h10.1a5 5 0 0 1 0-2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V6.98c-.58.44-1.26.77-2 .92V16z"></path>
//         {unread  && <circle cx="19" cy="3" r="3"></circle>}
//         <path d="M6 12h8v2H6zM6 9h12v2H6zM6 8h12v-.1A5.013 5.013 0 0 1 15.03 6H6v2z"></path>
//       </svg>
//     </React.Fragment>
//   );
// };

// export const Unread = ({ mode, unread }) => {
//   return (
//     <React.Fragment>
//       <svg
//         stroke="currentColor"
//         fill={mode ? "#fff" : "#000"}
//         strokeWidth="0"
//         viewBox="0 0 24 24"
//         width="25px"
//         height="25px"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path fill="none" d="M0 0h24v24H0z"></path>
//         <path d="M20 16H4V4h10.1a5 5 0 0 1 0-2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V6.98c-.58.44-1.26.77-2 .92V16z"></path>
//         {unread && (
//           <circle cx="19" cy="3" r="3" fill="red" /> // Set the fill color for the unread circle
//         )}
//         <path d="M6 12h8v2H6zM6 9h12v2H6zM6 8h12v-.1A5.013 5.013 0 0 1 15.03 6H6v2z"></path>
//       </svg>
//     </React.Fragment>
//   );
// };

export const Unread = ({ mode, unread }) => {
  return (
    <React.Fragment>
      {unread ? (
        <svg
          style={{
            cursor: "pointer",
          }}
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M20 6.75C21.5188 6.75 22.75 5.51878 22.75 4C22.75 2.48122 21.5188 1.25 20 1.25C18.4812 1.25 17.25 2.48122 17.25 4C17.25 5.51878 18.4812 6.75 20 6.75Z"
            fill="#F93E3E"
          />
          <path
            d="M20 8C17.79 8 16 6.21 16 4C16 3.27 16.21 2.59 16.56 2H7C4.24 2 2 4.23 2 6.98V12.96V13.96C2 16.71 4.24 18.94 7 18.94H8.5C8.77 18.94 9.13 19.12 9.3 19.34L10.8 21.33C11.46 22.21 12.54 22.21 13.2 21.33L14.7 19.34C14.89 19.09 15.19 18.94 15.5 18.94H17C19.76 18.94 22 16.71 22 13.96V7.44C21.41 7.79 20.73 8 20 8Z"
            fill={mode ? "#fff" : "#646B88"}
          />
          <path
            d="M12 12C11.44 12 11 11.55 11 11C11 10.45 11.45 10 12 10C12.55 10 13 10.45 13 11C13 11.55 12.56 12 12 12Z"
            fill="#292D32"
          />
          <path
            d="M16 12C15.44 12 15 11.55 15 11C15 10.45 15.45 10 16 10C16.55 10 17 10.45 17 11C17 11.55 16.56 12 16 12Z"
            fill="#292D32"
          />
          <path
            d="M8 12C7.44 12 7 11.55 7 11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11C9 11.55 8.56 12 8 12Z"
            fill="#292D32"
          />
        </svg>
      ) : (
        <svg
          style={{
            cursor: "pointer",
          }}
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M2 12.97V6.99C2 4.23 4.24 2 7 2H17C19.76 2 22 4.23 22 6.99V13.97C22 16.72 19.76 18.95 17 18.95H15.5C15.19 18.95 14.89 19.1 14.7 19.35L13.2 21.34C12.54 22.22 11.46 22.22 10.8 21.34L9.3 19.35C9.14 19.13 8.78 18.95 8.5 18.95H7C4.24 18.95 2 16.72 2 13.97V12.97Z"
            fill={mode ? "#fff" : "#646B88"}
          />
          <path
            d="M12 12C11.44 12 11 11.55 11 11C11 10.45 11.45 10 12 10C12.55 10 13 10.45 13 11C13 11.55 12.56 12 12 12Z"
            fill="#292D32"
          />
          <path
            d="M16 12C15.44 12 15 11.55 15 11C15 10.45 15.45 10 16 10C16.55 10 17 10.45 17 11C17 11.55 16.56 12 16 12Z"
            fill="#292D32"
          />
          <path
            d="M8 12C7.44 12 7 11.55 7 11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11C9 11.55 8.56 12 8 12Z"
            fill="#292D32"
          />
        </svg>
      )}
    </React.Fragment>
  );
};
